/*!
 * FormCreate 可视化表单设计器
 * @form-create/designer v1.1.5
 * (c) 2021-2024 xaboy
 * Github https://github.com/xaboy/form-create-designer
 * Site https://form-create.com/
 * Released under the MIT License.
 */
(function(){"use strict";try{if(typeof document!="undefined"){var e=document.createElement("style");e.appendChild(document.createTextNode('.CodeMirror{font-family:monospace;height:300px;color:#000;direction:ltr}.CodeMirror-lines{padding:4px 0}.CodeMirror pre.CodeMirror-line,.CodeMirror pre.CodeMirror-line-like{padding:0 4px}.CodeMirror-scrollbar-filler,.CodeMirror-gutter-filler{background-color:#fff}.CodeMirror-gutters{border-right:1px solid #ddd;background-color:#f7f7f7;white-space:nowrap}.CodeMirror-linenumber{padding:0 3px 0 5px;min-width:20px;text-align:right;color:#999;white-space:nowrap}.CodeMirror-guttermarker{color:#000}.CodeMirror-guttermarker-subtle{color:#999}.CodeMirror-cursor{border-left:1px solid black;border-right:none;width:0}.CodeMirror div.CodeMirror-secondarycursor{border-left:1px solid silver}.cm-fat-cursor .CodeMirror-cursor{width:auto;border:0!important;background:#7e7}.cm-fat-cursor div.CodeMirror-cursors{z-index:1}.cm-fat-cursor-mark{background-color:#14ff1480;-webkit-animation:blink 1.06s steps(1) infinite;-moz-animation:blink 1.06s steps(1) infinite;animation:blink 1.06s steps(1) infinite}.cm-animate-fat-cursor{width:auto;border:0;-webkit-animation:blink 1.06s steps(1) infinite;-moz-animation:blink 1.06s steps(1) infinite;animation:blink 1.06s steps(1) infinite;background-color:#7e7}@-moz-keyframes blink{50%{background-color:transparent}}@-webkit-keyframes blink{50%{background-color:transparent}}@keyframes blink{50%{background-color:transparent}}.cm-tab{display:inline-block;text-decoration:inherit}.CodeMirror-rulers{position:absolute;inset:-50px 0 0;overflow:hidden}.CodeMirror-ruler{border-left:1px solid #ccc;top:0;bottom:0;position:absolute}.cm-s-default .cm-header{color:#00f}.cm-s-default .cm-quote{color:#090}.cm-negative{color:#d44}.cm-positive{color:#292}.cm-header,.cm-strong{font-weight:700}.cm-em{font-style:italic}.cm-link{text-decoration:underline}.cm-strikethrough{text-decoration:line-through}.cm-s-default .cm-keyword{color:#708}.cm-s-default .cm-atom{color:#219}.cm-s-default .cm-number{color:#164}.cm-s-default .cm-def{color:#00f}.cm-s-default .cm-variable-2{color:#05a}.cm-s-default .cm-variable-3,.cm-s-default .cm-type{color:#085}.cm-s-default .cm-comment{color:#a50}.cm-s-default .cm-string{color:#a11}.cm-s-default .cm-string-2{color:#f50}.cm-s-default .cm-meta,.cm-s-default .cm-qualifier{color:#555}.cm-s-default .cm-builtin{color:#30a}.cm-s-default .cm-bracket{color:#997}.cm-s-default .cm-tag{color:#170}.cm-s-default .cm-attribute{color:#00c}.cm-s-default .cm-hr{color:#999}.cm-s-default .cm-link{color:#00c}.cm-s-default .cm-error,.cm-invalidchar{color:red}.CodeMirror-composing{border-bottom:2px solid}div.CodeMirror span.CodeMirror-matchingbracket{color:#0b0}div.CodeMirror span.CodeMirror-nonmatchingbracket{color:#a22}.CodeMirror-matchingtag{background:#ff96004d}.CodeMirror-activeline-background{background:#e8f2ff}.CodeMirror{position:relative;overflow:hidden;background:#fff}.CodeMirror-scroll{overflow:scroll!important;margin-bottom:-50px;margin-right:-50px;padding-bottom:50px;height:100%;outline:none;position:relative}.CodeMirror-sizer{position:relative;border-right:50px solid transparent}.CodeMirror-vscrollbar,.CodeMirror-hscrollbar,.CodeMirror-scrollbar-filler,.CodeMirror-gutter-filler{position:absolute;z-index:6;display:none;outline:none}.CodeMirror-vscrollbar{right:0;top:0;overflow-x:hidden;overflow-y:scroll}.CodeMirror-hscrollbar{bottom:0;left:0;overflow-y:hidden;overflow-x:scroll}.CodeMirror-scrollbar-filler{right:0;bottom:0}.CodeMirror-gutter-filler{left:0;bottom:0}.CodeMirror-gutters{position:absolute;left:0;top:0;min-height:100%;z-index:3}.CodeMirror-gutter{white-space:normal;height:100%;display:inline-block;vertical-align:top;margin-bottom:-50px}.CodeMirror-gutter-wrapper{position:absolute;z-index:4;background:none!important;border:none!important}.CodeMirror-gutter-background{position:absolute;top:0;bottom:0;z-index:4}.CodeMirror-gutter-elt{position:absolute;cursor:default;z-index:4}.CodeMirror-gutter-wrapper ::selection{background-color:transparent}.CodeMirror-gutter-wrapper ::-moz-selection{background-color:transparent}.CodeMirror-lines{cursor:text;min-height:1px}.CodeMirror pre.CodeMirror-line,.CodeMirror pre.CodeMirror-line-like{-moz-border-radius:0;-webkit-border-radius:0;border-radius:0;border-width:0;background:transparent;font-family:inherit;font-size:inherit;margin:0;white-space:pre;word-wrap:normal;line-height:inherit;color:inherit;z-index:2;position:relative;overflow:visible;-webkit-tap-highlight-color:transparent;-webkit-font-variant-ligatures:contextual;font-variant-ligatures:contextual}.CodeMirror-wrap pre.CodeMirror-line,.CodeMirror-wrap pre.CodeMirror-line-like{word-wrap:break-word;white-space:pre-wrap;word-break:normal}.CodeMirror-linebackground{position:absolute;inset:0;z-index:0}.CodeMirror-linewidget{position:relative;z-index:2;padding:.1px}.CodeMirror-rtl pre{direction:rtl}.CodeMirror-code{outline:none}.CodeMirror-scroll,.CodeMirror-sizer,.CodeMirror-gutter,.CodeMirror-gutters,.CodeMirror-linenumber{-moz-box-sizing:content-box;box-sizing:content-box}.CodeMirror-measure{position:absolute;width:100%;height:0;overflow:hidden;visibility:hidden}.CodeMirror-cursor{position:absolute;pointer-events:none}.CodeMirror-measure pre{position:static}div.CodeMirror-cursors{visibility:hidden;position:relative;z-index:3}div.CodeMirror-dragcursors,.CodeMirror-focused div.CodeMirror-cursors{visibility:visible}.CodeMirror-selected{background:#d9d9d9}.CodeMirror-focused .CodeMirror-selected{background:#d7d4f0}.CodeMirror-crosshair{cursor:crosshair}.CodeMirror-line::selection,.CodeMirror-line>span::selection,.CodeMirror-line>span>span::selection{background:#d7d4f0}.CodeMirror-line::-moz-selection,.CodeMirror-line>span::-moz-selection,.CodeMirror-line>span>span::-moz-selection{background:#d7d4f0}.cm-searching{background-color:#ffa;background-color:#ff06}.cm-force-border{padding-right:.1px}@media print{.CodeMirror div.CodeMirror-cursors{visibility:hidden}}.cm-tab-wrap-hack:after{content:""}span.CodeMirror-selectedtext{background:none}.CodeMirror-hints{position:absolute;z-index:10;overflow:hidden;list-style:none;margin:0;padding:2px;-webkit-box-shadow:2px 3px 5px rgba(0,0,0,.2);-moz-box-shadow:2px 3px 5px rgba(0,0,0,.2);box-shadow:2px 3px 5px #0003;border-radius:3px;border:1px solid silver;background:#fff;font-size:90%;font-family:monospace;max-height:20em;overflow-y:auto}.CodeMirror-hint{margin:0;padding:0 4px;border-radius:2px;white-space:pre;color:#000;cursor:pointer}li.CodeMirror-hint-active{background:#08f;color:#fff}._fd-fn{display:flex;flex-direction:column;position:relative;width:100%;height:100%}._fd-fn .el-button{position:absolute;bottom:3px;right:5px;box-shadow:0 6px 16px #00000014,0 3px 6px -4px #0000001f,0 9px 28px 8px #0000000d}._fd-fn-editor{display:flex;flex:1;width:100%;overflow:scroll}._fd-fn-editor .CodeMirror{height:100%;width:100%}._fd-fn-tip{color:#000;font-family:monospace;direction:ltr}._fd-fn-tip .cm-keyword{color:#708;line-height:24px;white-space:nowrap;overflow-x:auto}._fd-fn-tip .cm-keyword::-webkit-scrollbar{width:0;height:0;background-color:transparent}._fd-fn-ind{background-color:#f7f7f7;width:29px;height:24px;display:inline-block;margin-right:4px;border-right:1px solid #ddd;float:left}._fd-fn-arg{text-decoration:underline;cursor:pointer}._fd-fn-arg i{font-size:12px;color:#3073ff}._fd-event .el-button{font-weight:400;width:100%;border-color:#2e73ff;color:#2e73ff}._fd-event .el-badge{width:100%}._fd-event-dialog .el-dialog__body{padding:10px 20px}._fd-event-con .el-main{padding:0}._fd-event-l,._fd-event-r{display:flex;flex-direction:column;flex:1;height:100%;border:1px solid #ececec}._fd-event-dropdown .el-dropdown-menu{max-height:500px;overflow:scroll}._fd-event-head{display:flex;padding:5px 15px;border-bottom:1px solid #eee;background:#f8f9ff;align-items:center}._fd-event-head .el-button.is-link{color:#2f73ff}._fd-event-r{border-left:0 none}._fd-event-r ._fd-event-head{justify-content:space-between}._fd-event-l>.el-main,._fd-event-r>.el-main{display:flex;flex-direction:row;flex:1;flex-basis:auto;box-sizing:border-box;min-width:0;width:100%}._fd-event-r>.el-main{flex-direction:column}._fd-event-item{display:flex;flex-direction:column;justify-content:center;max-width:250px;font-size:14px;overflow:hidden;white-space:pre-wrap}._fd-event-l .el-menu{padding:0 10px 5px;border-right:0 none;width:100%;border-top:0 none;overflow:auto}._fd-event-l .el-menu-item.is-active{background:#e4e7ed;color:#303133}._fd-event-l .el-menu-item{height:auto;line-height:1em;border:1px solid #ECECEC;border-radius:5px;padding:0;margin-top:5px}._fd-event-method{display:flex;flex-direction:column;justify-content:center;width:225px;font-size:14px;font-family:monospace;color:#9d238c;overflow:hidden;white-space:pre-wrap}._fd-event-method>span:first-child,._fd-fn-list-method>span:first-child{color:#9d238c}._fd-event-method>span:first-child>span,._fd-fn-list-method>span:first-child>span{color:#000;margin-left:10px}._fd-event-title{display:flex;align-items:center;justify-content:space-between;width:100%;padding:10px 0}._fd-event-title .fc-icon{margin-right:6px;font-size:18px;color:#282828}._fd-event-title .el-input{width:200px}._fd-event-title .el-input__wrapper{box-shadow:none}._fd-event-title .el-menu-item.is-active i{color:#282828}._fd-event-con .CodeMirror{height:100%;width:100%}._fd-event-con .CodeMirror-wrap pre.CodeMirror-line{padding-left:20px}._fd-type-select{cursor:pointer}._fd-type-select.is-disabled{cursor:default}._fd-type-select .fc-icon{font-size:14px}._fd-type-select-pop{max-height:500px;overflow:auto}._fd-type-select-pop .fc-icon{font-size:14px}._fd-drag-tool{position:relative;display:block;min-height:20px;box-sizing:border-box;padding:2px;outline:1px dashed var(--fc-tool-border-color);overflow:hidden;word-wrap:break-word;word-break:break-all;transition:outline-color .3s ease}._fd-drag-tool ._fd-drag-tool{height:calc(100% - 6px);margin:3px}._fd-drag-tool+._fd-drag-tool{margin-top:5px}._fd-drag-tool.active{outline:2px solid #2E73FF}._fd-drag-tool.active>div>._fd-drag-btn{display:flex}._fd-drag-tool._fd-drop-hover ._fd-drag-box{padding-top:15px!important;padding-bottom:15px!important}._fd-drag-tool ._fd-drag-btn{display:none}.drag-r{position:absolute;right:2px;bottom:2px;z-index:1904}._fd-drag-l{position:absolute;top:0;left:0;z-index:1904}._fd-drag-btn{height:18px;width:18px;color:#fff;background-color:#2e73ff;text-align:center;line-height:20px;padding-bottom:1px;float:left;cursor:pointer;justify-content:center}._fd-drag-btn+._fd-drag-btn{margin-left:2px}._fd-drag-danger{background-color:#ff2e2e}._fd-drag-btn i{font-size:14px}._fd-drag-mask{z-index:1900;position:absolute;inset:0}._fd-struct,._fd-struct .el-badge{width:100%}._fd-struct .el-button{font-weight:400;width:100%;border-color:#2e73ff;color:#2e73ff}._fd-struct-con .CodeMirror{height:500px}._fd-struct-con .el-dialog__body{padding:0 20px}._fd-row,._fd-html-editor{width:100%}._fd-html-editor .el-button{font-weight:400;width:100%;border-color:#2e73ff;color:#2e73ff}._fd-html-editor-con .CodeMirror{height:450px}._fd-html-editor-con .CodeMirror-line{line-height:16px!important;font-size:13px!important}._fd-html-editor-con .CodeMirror-lint-tooltip{z-index:2021!important}._fd-html-editor-con .el-dialog__body{padding:0 20px}._fd-fn-input,._fd-fn-input .el-badge{width:100%}._fd-fn-input .el-button{font-weight:400;width:100%;border-color:#2e73ff;color:#2e73ff}._fd-fn-input-dialog .CodeMirror-lint-tooltip{z-index:2021!important}._fd-fn-input-dialog .el-dialog__body{padding:0;height:500px}._fd-struct-editor{flex:1;width:100%}._fd-struct-editor>div{height:100%}._fd-gfc,._fd-gfc .el-badge{width:100%}._fd-gfc .el-button{font-weight:400;width:100%;border-color:#2e73ff;color:#2e73ff}._fd-gfc-dialog .el-tabs__header{margin-bottom:0}._fd-gfc-dialog .el-dialog__body{padding-top:0}._fd-gfc-dialog .form-create{overflow:scroll;height:410px;margin-top:15px}._fd-gfc-con .CodeMirror{height:100%;width:100%}._fd-gfc-con .CodeMirror-wrap pre.CodeMirror-line{padding-left:20px}._fd-field-input{width:100%}._fd-field-input>.fc-icon{position:absolute;right:28px;top:1px;z-index:3;color:#a8abb2;cursor:pointer;width:24px;height:24px;text-align:center}._fd-field-input>.fc-icon:hover{color:#2e73ff}._fd-field-input .el-input-group__append{width:25px;padding:0;margin:0;color:#606266;cursor:pointer;text-align:center}._fd-fn-list,._fd-fn-list .el-badge{width:100%}._fd-fn-list .el-button{font-weight:400;width:100%;border-color:#2e73ff;color:#2e73ff}._fd-fn-list-dialog .el-dialog__body{padding:10px 20px}._fd-fn-list-con .el-main{padding:0}._fd-fn-list-l,._fd-fn-list-r{display:flex;flex-direction:column;flex:1;height:100%;border:1px solid #ececec}._fd-fn-list-head{display:flex;padding:5px 15px;border-bottom:1px solid #eee;background:#f8f9ff;align-items:center}._fd-fn-list-head .el-button.is-link{color:#2f73ff}._fd-fn-list-r{border-left:0 none}._fd-fn-list-r ._fd-fn-list-head{justify-content:flex-end}._fd-fn-list-l>.el-main,._fd-fn-list-r>.el-main{display:flex;flex-direction:row;flex:1;flex-basis:auto;box-sizing:border-box;min-width:0;width:100%}._fd-fn-list-r>.el-main{flex-direction:column}._fd-fn-list-l .el-menu{padding:0 10px 5px;border-right:0 none;width:100%;border-top:0 none;overflow:auto}._fd-fn-list-l .el-menu-item.is-active{background:#e4e7ed;color:#303133}._fd-fn-list-l .el-menu-item{height:auto;line-height:1em;border:1px solid #ECECEC;border-radius:5px;padding:0;margin-top:5px}._fd-fn-list-method{display:flex;flex-direction:column;justify-content:center;padding:10px 0;font-size:14px;line-height:1em;font-family:monospace;width:100%;overflow:hidden;white-space:pre-wrap}._fd-fn-list-method-info>span:first-child,._fd-fn-list-method>span:first-child{color:#9d238c}._fd-fn-list-method-info>span:first-child>span,._fd-fn-list-method>span:first-child>span{color:#000;margin-left:10px}._fd-fn-list-con .CodeMirror{height:100%;width:100%}._fd-fn-list-con .CodeMirror-wrap pre.CodeMirror-line{padding-left:20px}._fd-table-view{overflow:auto}._fd-table-view-cell{min-height:50px;height:100%;border:1px inset rgba(0,0,0,.1);background:#fff}._fd-table-view-cell>._fd-drag-tool{height:100%;border:0px;margin:0}._fd-table-view-btn{flex-direction:column;padding:0}._fd-table-view-btn .fc-icon{width:18px;color:#fff;font-size:16px}._fd-table-view-icon{color:#fff;display:flex;justify-content:center;width:100%;height:100%;margin-top:1px}._fd-table-view>table{width:100%;height:100%;overflow:hidden;table-layout:fixed;border:1px solid #EBEEF5;border-bottom:0 none;border-right:0 none}._fd-table-view tr{min-height:50px}._fd-table-view td{padding:5px;min-height:50px;min-width:80px;position:relative;box-sizing:border-box;overflow-wrap:break-word;white-space:nowrap;border:0 none;border-right:1px solid #EBEEF5;border-bottom:1px solid #EBEEF5}._fd-tableCell-drag{height:100%}._fc-table{overflow:auto}._fc-table>table{width:100%;height:100%;overflow:hidden;table-layout:fixed;border:1px solid #EBEEF5;border-bottom:0 none;border-right:0 none}._fc-table tr{min-height:50px}._fc-table td{padding:5px;min-height:50px;min-width:80px;position:relative;box-sizing:border-box;overflow-wrap:break-word;overflow:hidden;border:0 none;border-right:1px solid #EBEEF5;border-bottom:1px solid #EBEEF5}._fd-validate{display:flex;flex-direction:column;width:100%}._fd-validate-btn{font-weight:400;width:100%;border-color:#2e73ff;color:#2e73ff}._fd-validate-pop .el-dropdown-menu__item{width:248px}._fd-validate-item{border-bottom:1px dashed #ECECEC;margin-bottom:10px}._fd-validate-item .el-col-12:first-child{padding-right:5px}._fd-validate-item .el-col-12+.el-col-12{padding-left:5px}._fd-validate-item .el-input-number{width:100%}._fd-validate-title{display:flex;flex-direction:row;justify-content:space-between;margin-bottom:10px}._fd-validate-title>div{display:flex;align-items:center}._fd-validate-title>div>span{width:16px;height:16px;background:#ececec;text-align:center;font-size:12px;line-height:16px;border-radius:15px;margin-right:5px}._fd-validate-title i{cursor:pointer}._fd-validate-title i:hover{color:#ff2e2e}._fd-validate .append-msg{cursor:pointer}._fd-validate .el-input-group__append{padding:0 10px}._fd-required{display:flex;align-items:center;width:100%}._fd-required .el-input{margin-left:15px}._fd-required .el-switch{height:28px}._td-table-opt[data-v-79b8ca47]{width:100%}._td-table-opt .el-table[data-v-79b8ca47]{z-index:1}._td-table-opt-handle[data-v-79b8ca47]{display:flex;justify-content:space-between;align-items:center;padding-right:5px}._td-table-opt-handle span[data-v-79b8ca47]{display:flex;align-items:center}._fd-tree-opt ._fd-tree-opt-btn{height:19px;width:18px;color:#fff;text-align:center;line-height:20px;padding-bottom:1px;float:left;cursor:pointer;justify-content:center;background-color:#2f73ff}._fd-tree-opt-node{display:flex;align-items:center}._fd-tree-opt-first{width:60px;margin-right:5px}._fd-tree-opt-last{width:110px}._fd-tree-opt .el-table{z-index:1}._fd-tree-opt ._fd-tree-opt-danger{background-color:#ff2d2e;border-radius:0 2px 2px 0}._fd-tree-opt .el-tree-node__content{margin-bottom:3px;height:28px}._fd-tree-opt .el-input__inner{border-right:0 none;padding:1px 7px}._fd-tree-opt .el-input-group__append{width:55px;padding-right:2px;padding-left:1px;background:#fff}._fd-size-input{display:flex;align-items:center}._fd-size-input .el-input-number{width:75px}._fd-size-input .el-input-number.is-controls-right .el-input__inner{padding-left:5px;padding-right:35px}._fd-size-input .el-button{font-size:14px;padding:6px;margin-left:3px;width:28px}._fd-color-input{width:150px}._fd-color-input .el-input .el-color-picker{margin:0;display:flex;height:26px}._fd-color-input .el-input .el-input-group__append{padding:0;width:24px}._fd-color-input .el-input .el-color-picker__trigger{border-left:0 none;border-radius:0 3px 3px 0;height:26px;width:26px}._fd-box-size-input{color:#000}._fd-box-size-input ._padding,._fd-box-size-input ._margin{width:100%;height:180px;background-color:#f2cea5;padding:30px 45px;box-sizing:border-box;position:relative}html.dark ._fd-box-size-input ._padding,._fd-box-size-input ._margin{background-color:#a9855c}._fd-box-size-input ._margin{width:100%;height:120px;background-color:#c6cf92}._fd-box-size-input ._fd-input{display:inline-block;width:30%;max-width:40px;height:20px;border:0 none;padding:0;margin:0;outline:0 none;text-align:center;font-size:12px;background-color:unset;text-decoration:underline}._fd-box-size-input ._fd-input:hover,._fd-box-size-input ._fd-input:focus{background-color:#ececec;opacity:.9;color:#262626}._fd-box-size-input ._fd-left,._fd-box-size-input ._fd-right{position:absolute;left:2px;top:50%;margin-top:-10px}._fd-box-size-input ._fd-top,._fd-box-size-input ._fd-bottom{position:absolute;left:50%;top:5px;margin-left:-20px}._fd-box-size-input ._fd-bottom{top:unset;bottom:5px}._fd-box-size-input ._fd-right{left:unset;right:2px}._fd-box-size-input ._box{width:100%;height:100%;background-color:#94b5c0;display:flex;align-items:center;justify-content:center}._fd-box-size-input ._padding-title,._fd-box-size-input ._margin-title{position:absolute;top:2px;left:4px;font-size:12px}._fd-box-size-input ._fd-help{display:flex;align-items:center;position:absolute;right:2px;top:2px;color:#aaa}._fd-box-size-input .fc-icon{cursor:pointer;color:#262626}._fd-box-size-input .fc-icon.active{color:#2e73ff}._fd-box-size-input ._fd-x{margin:0 5px}._fd-config-item{display:flex;width:100%;flex-direction:column;font-size:12px;color:#666;margin-bottom:10px}._fd-ci-head{display:flex;justify-content:space-between;align-items:center}._fd-ci-label{display:flex;align-items:center;font-size:12px;color:#262626}._fd-ci-con{display:flex;align-items:center;justify-content:flex-end;min-width:150px}._fd-ci-label.is-arrow{cursor:pointer}._fd-ci-append{display:flex;flex-direction:column;background:#f5f5f5;margin:5px 3px 3px;padding:4px}._fd-ci-label i{font-size:12px;font-weight:600}._fd-ci-label i.down{transform:rotate(-180deg)}._fd-ci-info{font-size:12px;padding-right:5px}._fd-border-input{width:100%;height:110px;display:flex;justify-content:center}._fd-border-input ._fd-bi-left{width:115px;height:115px;display:flex;flex-direction:column;justify-content:center;align-items:center}._fd-border-input ._fd-bi-right{width:140px;display:flex;flex-direction:column;justify-content:space-around;padding:5px}._fd-border-input ._fd-bi-right ._fd-color-input{width:140px}._fd-bi-opt{width:100%;display:flex;height:100%;align-items:center}._fd-bi-opt ._line{width:100%}._fd-bi-opt .solid{border:1px solid #000}._fd-bi-opt .dashed{border:1px dashed #000}._fd-bi-opt .dotted{border:1px dotted #000}._fd-bi-opt .double{border:1px double #000}._fd-border-input ._fd-bil-row{height:38px;display:flex;justify-content:center}._fd-border-input ._fd-bil-col{width:22px;height:22px;display:flex;align-items:center;justify-content:center;cursor:pointer;margin:8px;font-size:16px}._fd-border-input ._fd-bil-col.active{outline:1px dashed #2E73FF;color:#2e73ff}.line-box{width:150px;height:20px;padding:1px;box-sizing:border-box}.line-box-con{width:100%;height:100%;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAD5JREFUOE9jZGBg+M+AChjR+HjlQYqHgQFoXibNS+gBBjKMpDAZHAaQ5GQGBgYUV4+mA7QAgaYokgJ14NMBAK1TIAlUJpxYAAAAAElFTkSuQmCC);opacity:.3}._fd-radius-input{width:100%;display:flex;flex-direction:column}._fd-radius-con{display:flex;flex-wrap:wrap}._fd-radius-item{display:flex;align-items:center;justify-content:center;width:50%;padding:5px 0;box-sizing:border-box}._fd-radius-item ._fd-radius-icon{width:24px;height:24px;display:flex;justify-content:center;align-items:center}._fd-radius-item ._fd-size-input .el-input-number{width:70px}._fd-font-input{display:flex;justify-content:center;padding:0 5px}._fd-fi-box{width:150px;overflow:hidden}._fd-font-input .el-form{display:grid;grid-template-columns:repeat(2,1fr);width:100%;grid-column-gap:10px}._fd-font-input .el-form--inline .el-form-item{margin:0;padding:0}._fd-font-input .el-form--inline .el-form-item__label{font-size:12px;padding-bottom:0}._fd-font-input ._fd-size-input .el-input-number{width:100%}._fd-shadow-input ._fd-ci-con{width:150px}._fd-shadow-input :focus-visible{outline:0 none}._fd-si-input .el-input-group__append{width:24px;padding:0;text-align:center}._fd-si-input .el-input__wrapper{flex:1}._fd-si-input .el-input__inner{padding:0 10px}._fd-shadow-input ._fd-ci-con .fc-icon{cursor:pointer}._fd-style-config{width:100%;display:flex;flex-direction:column}._fd-opacity-input ._fd-ci-con{display:flex;justify-content:space-between;width:150px;align-items:center}._fd-opacity-input ._fd-ci-con>span{width:32px}._fd-opacity-input .el-slider{flex:1;margin-right:15px}._fc-designer{height:100%;min-height:500px;overflow:hidden;cursor:default;position:relative;background-color:#fff;--fc-drag-empty: "拖拽左侧列表中的组件到此处";--fc-child-empty: "点击右下角  按钮添加一列";--fc-tool-border-color: #2E73FF}._fc-designer>.el-main{position:absolute;inset:0;padding:0}._fc-m .form-create ._fc-l-item{display:flex!important;align-items:center;justify-content:center;background:#f5f5f5;color:#000;width:100%;margin:5px 0;height:30px;overflow:hidden;transition:all .3s ease;border:1px dashed #000;border-radius:4px;padding-bottom:0}._fc-m .form-create ._fc-l-item ._fc-l-icon{display:inline-block!important;padding:0 4px}._fc-m .form-create ._fc-l-item ._fc-l-name{display:inline-block!important;font-size:12px}._fc-l,._fc-m,._fc-r{border-top:1px solid #ECECEC;box-sizing:border-box}._fc-r{--el-color-primary: #2E73FF}._fc-r-tab-props{padding:0 20px}._fc-r-title{font-size:12px;color:#333;margin:15px 0 5px}._fc-r-sub ._fc-r-title{display:flex;align-items:center;justify-content:space-between}._fc-r-sub .fc-icon{cursor:pointer}._fc-r-sub ._fd-config-item+._fd-config-item{margin-top:8px}._fc-r-sub>._fd-config-item>._fd-ci-head{position:relative;padding-left:8px}._fc-r-sub>._fd-config-item>._fd-ci-head:before{content:" ";position:absolute;width:5px;height:5px;background-color:#333;border-radius:25px;left:0}._fc-r-name-input .el-input-group__append{width:25px;padding:0;margin:0;color:#606266;cursor:pointer;text-align:center}._fc-r-name-input .el-input__suffix{display:flex;align-items:center}._fc-r-name-input .icon-group{cursor:pointer}._fc-r-name-input .icon-group:hover{color:#2e73ff}._fc-r .el-main{padding-bottom:100px}._fc-l .el-main{padding:0}._fc-l .el-tree-node__label{padding:3px;font-weight:400;color:#333}._fc-l .el-tree-node__content{height:30px;margin-top:5px}._fc-l .el-tree-node__content>.el-tree-node__expand-icon{color:#333}._fc-l .el-tree-node__expand-icon.is-leaf{color:transparent}@keyframes rotating{0%{transform:rotate(0)}to{transform:rotate(360deg)}}._fc-loading{animation:rotating 2s linear infinite}._fc-tree-node{display:flex;align-items:center;justify-content:space-between;width:100%;height:26px;line-height:26px;padding-right:5px;font-size:14px}._fc-tree-node.active,._fc-tree-node.active .icon-more{color:#2e73ff}._fc-tree-label{display:flex;align-items:center}._fc-tree-label>i{margin-right:5px;font-weight:700}._fc-tree-more{display:flex;align-items:center;padding:0 15px;font-weight:700}._fc-l-tabs{display:flex;border-bottom:1px solid #ECECEC;padding:0}._fc-l-tab{height:40px;box-sizing:border-box;line-height:40px;display:inline-block;list-style:none;font-size:14px;font-weight:600;color:#303133;position:relative;flex:1;text-align:center}._fc-l ._fc-l-tab.active{color:#409eff;border-bottom:2px solid #409EFF}._fc-l-group{border:1px solid #EEEEEE;padding:0;margin:12px;user-select:none}._fc-l-group ._fc-l-list{display:grid;grid-template-columns:repeat(3,1fr);align-items:stretch}._fc-l-title{display:flex;align-items:center;justify-content:space-between;cursor:pointer;font-weight:600;font-size:14px;padding:12px;margin:0}._fc-l-title i{font-size:14px}._fc-l-title i.down{transform:rotate(90deg)}._fc-l-item{display:inline-block;background:#fff;color:#000;line-height:1;text-align:center;transition:all .2s ease;cursor:pointer;padding-bottom:10px}._fc-l-item i{font-size:21px;display:inline-block}._fc-l-item ._fc-l-name{font-size:12px}._fc-l-item ._fc-l-icon{padding:10px 5px 12px}._fc-l-item:hover{background:#2e73ff;color:#fff}._fc-m-tools{height:40px;align-items:center;display:flex;justify-content:space-between;border:1px solid #ECECEC;border-top:0 none;white-space:nowrap}._fc-m-tools-l,._fc-m-tools-r{display:flex;align-items:center}._fc-m-tools-r{overflow:auto}._fc-m-tools-l .devices .fc-icon{width:18px;cursor:pointer}._fc-m-tools-l .devices .fc-icon.active{color:#2e73ff}._fc-m-tools-l .devices .fc-icon+.fc-icon{margin-left:5px}._fc-m-tools .line{width:1px;height:24px;background:#d8d8d8;margin:0 10px}._fc-m-tools .el-button{padding:5px 10px;display:flex;align-items:center;border-radius:5px}._fc-m-tools .el-button>span{display:inline-flex;justify-content:center;align-items:center}._fc-m-tools ._fd-m-extend{color:#666;border-color:#ccc;background-color:#f1f1f1;border-radius:5px;padding:5px}._fc-m-tools ._fd-m-extend .fc-icon{margin-right:0}._fc-m-tools ._fd-input-btn{display:flex;align-items:center;justify-content:space-between;font-size:12px}._fc-m-tools ._fd-input-btn .icon-check{color:#67c23a;font-size:18px}._fc-m-tools-r .fc-icon{font-size:14px;margin-right:2px}._fc-m-tools-l .fc-icon{font-size:18px;cursor:pointer}._fc-m-tools-l .fc-icon+.fc-icon{margin-left:10px}._fc-m-tools-l .fc-icon.disabled{color:#999;cursor:not-allowed}._fc-r .el-tabs__nav-wrap:after{height:1px;background-color:#ececec}._fc-r ._fc-r-tabs{display:flex;padding:0;border-bottom:1px solid #ECECEC}._fc-r .el-table__cell .cell,._fc-r .el-button,._fc-r .el-radio-button__inner{font-weight:400}._fc-r ._fc-r-tab{height:40px;box-sizing:border-box;line-height:40px;display:inline-block;list-style:none;font-size:14px;font-weight:600;color:#303133;position:relative;flex:1;text-align:center}._fc-r ._fc-r-tab.active{color:#409eff;border-bottom:2px solid #409EFF}._fc-m-con{position:relative;background:#f5f5f5;padding:20px 20px 36px}._fc-m-drag{margin:0 auto;overflow:auto;padding:2px;box-sizing:border-box}._fc-m-input{padding:5px 5px 80px}._fc-m-input-handle{position:absolute;bottom:17px;left:0;right:0;padding:12px;background:#fff;box-shadow:0 -8px 14px #0000001a;text-align:center;margin:20px;z-index:99}._fc-m-drag.mobile{width:350px}._fc-m-drag.pad{width:770px}._fc-m-drag,.draggable-drag{background:#fff;height:100%;position:relative}._fc-m-drag>form,._fc-m-drag>form>.el-row{height:100%}._fc-m-drag .el-tree{width:100%}._fd-drag-box{width:100%;height:100%;min-height:60px;transition:padding-bottom,padding-top .3s ease}._fd-drag-box ._fd-drag-box{outline:1px dashed #ECECEC}._fd-drag-tool>._fd-drag-box{outline:none}._fd-drag-box>div[data-draggable]{margin-bottom:1px}._fc-r ._fc-group-container+._fc-group-container{margin-top:20px}._fc-r ._fc-group-container{margin:0;padding:10px}._fc-r ._fc-group-handle{right:15px}._fc-r .el-form-item{margin-bottom:10px!important}._fc-r .el-input__inner{padding:0 5px}._fc-r .el-form-item__label{color:#333}._fc-upload-preview{display:inline-block;width:120px;height:120px;border-radius:5px;overflow:hidden}._fc-tabs .el-tabs__item{font-weight:400}._fc-tabs .el-tabs__nav-scroll{padding:0 15px}._fc-tabs .el-tab-pane{margin-right:15px}._fc-tabs .el-tabs__nav-wrap:after{height:1px}.form-create .fc-none{display:none}._fd-draggable-drag.drag-holder,._fd-tableFormColumn-drag.drag-holder,._fd-elTabPane-drag.drag-holder,._fd-group-drag.drag-holder,._fd-subForm-drag.drag-holder,._fd-elCard-drag.drag-holder,._fd-elCollapseItem-drag.drag-holder{position:relative;background:#f5f5f5;background-size:0;min-height:90px}._fc-child-empty:after,._fd-draggable-drag.drag-holder:after,._fd-tableFormColumn-drag.drag-holder:after,._fd-elTabPane-drag.drag-holder:after,._fd-group-drag.drag-holder:after,._fd-subForm-drag.drag-holder:after,._fd-elCard-drag.drag-holder:after,._fd-elCollapseItem-drag.drag-holder:after{content:var(--fc-drag-empty);position:absolute;inset:0;display:flex;justify-content:center;align-items:center;color:#aaa;font-size:12px}._fc-designer ._fc-m-drag ._fd-draggable-drag{overflow:scroll;padding:2px 2px 100px}._fc-m-drag._fd-drop-hover ._fd-draggable-drag{padding-top:20px}._fd-draggable-drag.drag-holder{background-color:#fff}._fd-draggable-drag.drag-holder:after{font-size:16px}._fc-child-empty:after{font-family:fc-icon!important;content:var(--fc-child-empty)}.fc-configured{color:#999;margin-left:5px}._fc-manage-text{cursor:pointer;color:#2f73ff;margin-left:4px;font-size:12px}._fc-manage-text i{font-size:12px}._fc-message-error{top:16px;z-index:2116;min-width:auto;border-radius:8px;padding:9px 13px;background-color:#fff;border-color:#fff;box-shadow:0 6px 16px #00000014,0 3px 6px -4px #0000001f,0 9px 28px 8px #0000000d}._fc-message-error>.el-icon{font-size:18px}._fc-message-error .el-message__content{color:#000000e0;font-size:14px}._fd-preview-dialog{border-radius:6px;padding-top:0}._fd-preview-dialog .el-dialog__header{position:absolute;right:0;top:0;float:right;z-index:9}._fd-preview-code{margin-top:0;max-height:510px;overflow:scroll}._fd-preview-tabs .el-tabs__nav-wrap:after{height:1px}._fd-preview-tabs .el-tabs__item{height:46px}._fd-preview-code>code{white-space:pre-wrap}._fd-row-line{width:100%;height:1px;margin:10px 0;background:#d8d8d8}.CodeMirror-hints{z-index:999999}@font-face{font-family:fc-icon;src:url(data:font/woff;base64,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) format("woff")}.fc-icon{font-family:fc-icon!important;font-size:16px;font-style:normal;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-slot:before{content:""}.icon-link2:before{content:""}.icon-delete2:before{content:""}.icon-pad2:before{content:""}.icon-mobile2:before{content:""}.icon-pc2:before{content:""}.icon-page-max:before{content:""}.icon-page-min:before{content:""}.icon-edit2:before{content:""}.icon-variable:before{content:""}.icon-config-props:before{content:""}.icon-config-validate:before{content:""}.icon-config-event:before{content:""}.icon-config-base:before{content:""}.icon-config-advanced:before{content:""}.icon-config-style:before{content:""}.icon-drag:before{content:""}.icon-calendar:before{content:""}.icon-icon:before{content:""}.icon-add2:before{content:""}.icon-minus:before{content:""}.icon-dialog:before{content:""}.icon-down:before{content:""}.icon-page:before{content:""}.icon-yes:before{content:""}.icon-data-table:before{content:""}.icon-delete-circle:before{content:""}.icon-edit:before{content:""}.icon-save-online:before{content:""}.icon-auto:before{content:""}.icon-check:before{content:""}.icon-tooltip:before{content:""}.icon-watermark:before{content:""}.icon-table-form3:before{content:""}.icon-table-form2:before{content:""}.icon-card:before{content:""}.icon-lock:before{content:""}.icon-shadow:before{content:""}.icon-shadow-inset:before{content:""}.icon-alignitems-flexstart:before{content:"";display:inline-block;transform:rotate(180deg)}.icon-align-center:before{content:"";display:inline-block;transform:rotate(90deg)}.icon-align-flexstart:before{content:"";display:inline-block;transform:rotate(90deg)}.icon-align-spacearound:before{content:"";display:inline-block;transform:rotate(-90deg)}.icon-align-spacebetween:before{content:"";display:inline-block;transform:rotate(-90deg)}.icon-align-stretch:before{content:"";display:inline-block;transform:rotate(-90deg)}.icon-align-flexend:before{content:"";display:inline-block;transform:rotate(-90deg)}.icon-justify-flexend:before{content:"";display:inline-block;transform:rotate(180deg)}.icon-direction-rowreverse:before{content:""}.icon-direction-row:before{content:""}.icon-direction-column:before{content:""}.icon-direction-columnreverse:before{content:""}.icon-justify-spacearound:before{content:""}.icon-justify-spacebetween:before{content:""}.icon-alignitems-baseline:before{content:""}.icon-alignitems-flexend:before{content:""}.icon-alignitems-center:before{content:""}.icon-alignitems-stretch:before{content:""}.icon-flex-nowrap:before{content:""}.icon-flex-wrap:before{content:""}.icon-justify-stretch:before{content:""}.icon-justify-center:before{content:""}.icon-justify-flexstart:before{content:""}.icon-display-flex:before{content:""}.icon-display-inlineblock:before{content:""}.icon-display-block:before{content:""}.icon-display-inline:before{content:""}.icon-radius:before{content:""}.icon-arrow:before{content:""}.icon-link:before{content:""}.icon-question:before{content:""}.icon-refresh:before{content:""}.icon-setting:before{content:""}.icon-textarea:before{content:""}.icon-password:before{content:""}.icon-table-form:before{content:""}.icon-value:before{content:""}.icon-eye:before{content:""}.icon-eye-close:before{content:""}.icon-cell:before{content:""}.icon-group:before{content:""}.icon-step-form:before{content:""}.icon-add-circle:before{content:""}.icon-add-tr:before{content:""}.icon-add-td:before{content:""}.icon-more:before{content:""}.icon-flex:before{content:""}.icon-tag:before{content:""}.icon-html:before{content:""}.icon-tree-select:before{content:""}.icon-descriptions:before{content:""}.icon-table:before{content:""}.icon-collapse:before{content:""}.icon-pre-step:before{content:""}.icon-next-step:before{content:""}.icon-mobile-active:before{content:""}.icon-pc-active:before{content:""}.icon-pc:before{content:""}.icon-mobile:before{content:""}.icon-pad-active:before{content:""}.icon-pad:before{content:""}.icon-subform:before{content:""}.icon-add-child:before{content:""}.icon-switch:before{content:""}.icon-tab:before{content:""}.icon-button:before{content:""}.icon-input:before{content:""}.icon-checkbox:before{content:""}.icon-radio:before{content:""}.icon-rate:before{content:""}.icon-number:before{content:""}.icon-upload:before{content:""}.icon-cascader:before{content:""}.icon-space:before{content:""}.icon-color:before{content:""}.icon-span:before{content:""}.icon-alert:before{content:""}.icon-row:before{content:""}.icon-divider:before{content:""}.icon-select:before{content:""}.icon-transfer:before{content:""}.icon-editor:before{content:""}.icon-slider:before{content:""}.icon-tree:before{content:""}.icon-date:before{content:""}.icon-time:before{content:""}.icon-grid:before{content:""}.icon-delete:before{content:""}.icon-copy:before{content:""}.icon-import:before{content:""}.icon-add:before{content:""}.icon-preview:before{content:""}.icon-move:before{content:""}pre code.hljs{display:block;overflow-x:auto;padding:1em}code.hljs{padding:3px 5px}.hljs{color:#000;background:#fff}.hljs-subst,.hljs-title{font-weight:400;color:#000}.hljs-title.function_{color:#7a7a43}.hljs-code,.hljs-comment,.hljs-quote{color:#8c8c8c;font-style:italic}.hljs-meta{color:#9e880d}.hljs-section{color:#871094}.hljs-built_in,.hljs-keyword,.hljs-literal,.hljs-meta .hljs-keyword,.hljs-name,.hljs-selector-attr,.hljs-selector-class,.hljs-selector-id,.hljs-selector-pseudo,.hljs-selector-tag,.hljs-symbol,.hljs-template-tag,.hljs-type,.hljs-variable.language_{color:#0033b3}.hljs-attr,.hljs-property{color:#871094}.hljs-attribute{color:#174ad4}.hljs-number{color:#1750eb}.hljs-regexp{color:#264eff}.hljs-link{text-decoration:underline;color:#006dcc}.hljs-meta .hljs-string,.hljs-string{color:#067d17}.hljs-char.escape_{color:#0037a6}.hljs-doctag{text-decoration:underline}.hljs-template-variable{color:#248f8f}.hljs-addition{background:#bee6be}.hljs-deletion{background:#d6d6d6}.hljs-emphasis{font-style:italic}.hljs-strong{font-weight:700}')),document.head.appendChild(e)}}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})();
var gh = Object.defineProperty, mh = Object.defineProperties;
var yh = Object.getOwnPropertyDescriptors;
var Oc = Object.getOwnPropertySymbols;
var bh = Object.prototype.hasOwnProperty, Ah = Object.prototype.propertyIsEnumerable;
var Rc = (i, t, l) => t in i ? gh(i, t, { enumerable: !0, configurable: !0, writable: !0, value: l }) : i[t] = l, rt = (i, t) => {
  for (var l in t || (t = {}))
    bh.call(t, l) && Rc(i, l, t[l]);
  if (Oc)
    for (var l of Oc(t))
      Ah.call(t, l) && Rc(i, l, t[l]);
  return i;
}, vr = (i, t) => mh(i, yh(t));
import xh, { computed as Un, unref as Df, isRef as wh, ref as ao, defineComponent as ft, markRaw as mi, toRefs as Ic, getCurrentInstance as _h, reactive as Al, provide as Lc, toRef as Yi, watch as xl, nextTick as zn, set as Ki } from "vue";
import { Message as Ch } from "element-ui";
import Mf from "@form-create/element-ui";
const at = {
  type(i, t) {
    return Object.prototype.toString.call(i) === "[object " + t + "]";
  },
  Undef(i) {
    return i == null;
  },
  Element(i) {
    return typeof i == "object" && i !== null && i.nodeType === 1 && !at.Object(i);
  },
  trueArray(i) {
    return Array.isArray(i) && i.length > 0;
  },
  Function(i) {
    const t = this.getType(i);
    return t === "Function" || t === "AsyncFunction";
  },
  getType(i) {
    const t = Object.prototype.toString.call(i);
    return /^\[object (.*)\]$/.exec(t)[1];
  },
  empty(i) {
    return i == null || Array.isArray(i) && Array.isArray(i) && !i.length ? !0 : typeof i == "string" && !i;
  }
};
["Date", "Object", "String", "Boolean", "Array", "Number"].forEach((i) => {
  at[i] = function(t) {
    return at.type(t, i);
  };
});
function Fr(i, t) {
  return {}.hasOwnProperty.call(i, t);
}
function Xi(i, t, l) {
  xh.set(i, t, l);
}
function ba(i, t = {}, l) {
  let c = !1;
  for (let M in t)
    if (Object.prototype.hasOwnProperty.call(t, M)) {
      let T = t[M];
      if ((c = Array.isArray(T)) || at.Object(T)) {
        let F = i[M] === void 0;
        if (c)
          c = !1, F && Xi(i, M, []);
        else if (T._clone && l !== void 0)
          if (l)
            T = T.getRule(), F && Xi(i, M, {});
          else {
            Xi(i, M, T._clone());
            continue;
          }
        else
          F && Xi(i, M, {});
        i[M] = ba(i[M], T, l);
      } else
        Xi(i, M, T), at.Undef(T) || (at.Undef(T.__json) || (i[M].__json = T.__json), at.Undef(T.__origin) || (i[M].__origin = T.__origin));
    }
  return l !== void 0 && Array.isArray(i) ? i.filter((M) => !M || !M.__ctrl) : i;
}
function Nt(i) {
  return ba({}, { value: i }).value;
}
function Sh(i, t, l) {
  return `[form-create ${i}]: ${t}`;
}
function Eh(i, t) {
  console.error(Sh("err", i));
}
const Fc = "[[FORM-CREATE-PREFIX-", Bc = "-FORM-CREATE-SUFFIX]]", Pc = "$FN:", Hc = "$FNX:", qo = "function";
function jc(i) {
  return new Function("return " + i)();
}
function kh(i, t) {
  if (i && at.String(i) && i.length > 4) {
    let l = i.trim(), c = !1;
    try {
      if (l.indexOf(Bc) > 0 && l.indexOf(Fc) === 0)
        l = l.replace(Bc, "").replace(Fc, ""), c = !0;
      else if (l.indexOf(Pc) === 0)
        l = l.replace(Pc, ""), c = !0;
      else {
        if (l.indexOf(Hc) === 0)
          return l = jc("function($inject){" + l.replace(Hc, "") + "}"), l.__json = i, l.__inject = !0, l;
        !t && l.indexOf(qo) === 0 && l !== qo && (c = !0);
      }
      if (!c) return i;
      const M = jc(l.indexOf(qo) === -1 && l.indexOf("(") !== 0 ? qo + " " + l : l);
      return M.__json = i, M;
    } catch (M) {
      Eh(`解析失败:${l}

err: ${M}`);
      return;
    }
  }
  return i;
}
function Th(i) {
  const t = i.replace(/(-[a-z])/g, function(l) {
    return l.replace("-", "").toLocaleUpperCase();
  });
  return fs(t);
}
function fs(i) {
  return i.replace(i[0], i[0].toLowerCase());
}
const Nf = {
  name: "zh-cn",
  form: {
    field: "字段 ID",
    title: "字段名称",
    info: "提示信息",
    control: "联动数据",
    labelPosition: "标签的位置",
    labelStyle: "标签的样式",
    labelSuffix: "标签的后缀",
    size: "表单的尺寸",
    event: "表单事件",
    labelWidth: "标签的宽度",
    hideRequiredAsterisk: "隐藏必填字段的标签旁边的红色星号",
    showMessage: "显示校验错误信息",
    inlineMessage: "以行内形式展示校验信息",
    submitBtn: "是否显示表单提交按钮",
    resetBtn: "是否显示表单重置按钮",
    appendChild: "添加子级",
    formMode: "表单模式",
    formName: "表单名称",
    componentMode: "生成组件",
    document: "帮助文档"
  },
  computed: {
    fieldUsed: "【{label}】在计算公式中被使用，请先修改对应公式",
    fieldExist: "【{label}】字段已存在",
    fieldEmpty: "字段名称不能为空",
    fieldChar: "字段名称必须以字母开头"
  },
  validate: {
    type: "字段类型",
    typePlaceholder: "请选择",
    trigger: "触发方式",
    mode: "验证方式",
    modes: {
      required: "必填",
      pattern: "正则表达式",
      validator: "自定义验证",
      min: "最小值",
      max: "最大值",
      len: "长度"
    },
    types: {
      string: "字符串",
      array: "多选",
      number: "数字",
      integer: "整数",
      float: "小数",
      object: "合集",
      date: "日期",
      url: "URL链接",
      email: "邮箱地址"
    },
    message: "错误信息",
    auto: "自动获取",
    autoRequired: "请输入{title}",
    autoMode: "请输入正确的{title}",
    requiredPlaceholder: "请输入提示语",
    required: "是否必填",
    rule: "验证规则"
  },
  tableOptions: {
    handle: "操作",
    add: "添加",
    empty1: "点击右下角",
    empty2: "按钮添加一列",
    rmCol: "删除当前列",
    rmRow: "删除当前行",
    splitRow: "拆分成行",
    splitCol: "拆分成列",
    mergeBottom: "向下合并",
    mergeRight: "向右合并",
    addTop: "添加上列",
    addBottom: "添加下列",
    addLeft: "添加左列",
    addRight: "添加右列",
    keyValue: "键值对"
  },
  struct: {
    title: "编辑数据",
    only: "【{label}】只允许添加一个",
    errorMsg: "输入的内容语法错误",
    configured: "已配置"
  },
  event: {
    title: "设置事件",
    create: "创建事件",
    list: "事件列表",
    placeholder: "请输入事件的名称",
    saveMsg: "请先保存当前正在编辑的事件",
    type: "类型",
    info: "说明",
    label: "字段",
    inject: {
      api: "当前表单的api",
      rule: "当前表单的生成规则",
      self: "组件的生成规则",
      option: "表单的配置",
      args: "事件的原始参数"
    }
  },
  fetch: {
    title: "设置数据源",
    create: "创建数据源",
    config: "请求配置",
    action: "请求链接",
    actionRequired: "请输入正确的链接",
    placeholder: "请输入数据源的名称",
    method: "请求方式",
    data: "附带数据",
    headers: "请求头部",
    parse: "数据处理",
    response: "接口返回的数据",
    onError: "错误处理",
    remote: "远程数据",
    static: "静态数据",
    optionsType: {
      fetch: "远程数据",
      struct: "静态数据"
    }
  },
  style: {
    width: "宽度",
    height: "高度",
    color: "颜色",
    backgroundColor: "背景色",
    margin: "外边距",
    padding: "内边距",
    borderRadius: "圆角",
    border: "边框",
    solid: "实线",
    dashed: "虚线",
    dotted: "点状虚线",
    double: "双实线",
    opacity: "透明度",
    scale: "缩放",
    shadow: {
      name: "阴影",
      x: "x轴偏移量",
      y: "y轴偏移量",
      vague: "模糊半径",
      extend: "扩散半径",
      inset: "向内",
      external: "向外",
      mode: "模式",
      classic: "经典",
      flat: "扁平",
      solid: "立体"
    },
    font: {
      name: "字体",
      size: "大小",
      align: "对齐方式",
      height: "行高",
      spacing: "字间距",
      preview: "样式预览"
    },
    decoration: {
      name: "修饰",
      underline: "下划线",
      "line-through": "删除线",
      overline: "上划线"
    },
    weight: {
      name: "粗细",
      300: "细体",
      400: "常规体",
      500: "中黑体",
      700: "中粗体"
    }
  },
  designer: {
    component: "组件配置",
    id: "唯一值",
    name: "编号",
    type: "组件类型",
    form: "表单配置",
    style: "组件样式配置",
    rule: "基础配置",
    advanced: "高级配置",
    props: "属性配置",
    validate: "验证配置",
    event: "事件配置",
    clearWarn: "清空后将不能恢复，确定要清空吗？",
    childEmpty: "点击右下角 \\e789  按钮添加一列",
    dragEmpty: "拖拽左侧列表中的组件到此处",
    unload: "确定离开当前页面吗?"
  },
  menu: {
    main: "基础组件",
    aide: "辅助组件",
    layout: "布局组件",
    component: "组件",
    subform: "子表单组件",
    tree: "大纲"
  },
  props: {
    disabled: "禁用",
    time: "时间",
    email: "邮箱",
    number: "数字",
    globalData: "全局数据",
    mobile: "移动端",
    reactive: "响应式",
    pc: "电脑端",
    title: "标题",
    content: "内容",
    collection: "合集",
    group: "分组",
    custom: "自定义",
    change: "改变",
    blur: "失去焦点",
    preview: "预览",
    clear: "清空",
    cancel: "取消",
    close: "关闭",
    ok: "确定",
    save: "保存",
    refresh: "刷新",
    submit: "提交",
    reset: "重置",
    copy: "复制",
    delete: "删除",
    hide: "隐藏",
    show: "显示",
    position: "位置",
    render: "渲染",
    large: "大",
    default: "默认",
    small: "小",
    always: "常显",
    never: "不显示",
    hover: "悬浮",
    click: "点击",
    button: "按钮",
    year: "年份",
    month: "月份",
    date: "日期",
    dates: "日期多选",
    week: "一周",
    datetime: "日期时间",
    "datetime-local": "日期时间",
    datetimerange: "日期时间区间",
    daterange: "日期区间",
    monthrange: "月份区间",
    left: "左对齐",
    right: "右对齐",
    top: "顶部",
    text: "文字",
    picture: "图片",
    "picture-card": "卡片",
    center: "居中",
    vertical: "竖向",
    horizontal: "横向",
    manage: "管理",
    key: "键名",
    name: "名称",
    value: "值",
    inputData: "默认值",
    append: "插入",
    options: "选项数据",
    option: "选项",
    callback: "回调",
    _self: "当前窗口",
    _blank: "新的窗口",
    _parent: "父级窗口",
    _top: "顶级窗口"
  },
  com: {
    cascader: {
      name: "级联选择器",
      event: {
        expandChange: "当展开节点发生变化时触发",
        removeTag: "在多选模式下，移除Tag时触发"
      },
      props: {
        props: "配置选项",
        placeholder: "输入框占位文本",
        disabled: "是否禁用",
        clearable: "是否支持清空选项",
        showAllLevels: "输入框中是否显示选中值的完整路径",
        collapseTags: "多选模式下是否折叠Tag",
        collapseTagsTooltip: "当鼠标悬停于折叠标签的文本时，是否显示所有选中的标签",
        separator: "选项分隔符",
        filterable: "该选项是否可以被搜索",
        tagType: "标签类型"
      },
      propsOpt: {
        multiple: "是否多选",
        expandTrigger: "次级菜单的展开方式",
        checkStrictly: "是否严格的遵守父子节点不互相关联",
        emitPath: "在选中节点改变时，是否返回由该节点所在的各级菜单的值所组成的数组",
        value: "指定选项的值为选项对象的某个属性值",
        label: "指定选项标签为选项对象的某个属性值",
        children: "指定选项的子选项为选项对象的某个属性值",
        disabled: "指定选项的禁用为选项对象的某个属性值",
        leaf: "指定选项的叶子节点的标志位为选项对象的某个属性值"
      }
    },
    checkbox: {
      name: "多选框",
      props: {
        type: "按钮类型",
        disabled: "是否禁用",
        min: "可被勾选的最小数量",
        max: "可被勾选的最大数量",
        textColor: "当按钮为活跃状态时的字体颜色",
        fill: "当按钮为活跃状态时的边框和背景颜色"
      }
    },
    col: {
      name: "布局格子",
      props: {
        span: "栅格占据的列数",
        offset: "栅格左侧的间隔格数",
        push: "栅格向右移动格数",
        pull: "栅格向左移动格数"
      }
    },
    colorPicker: {
      name: "颜色选择器",
      event: {
        activeChange: "面板中当前显示的颜色发生改变时触发"
      },
      props: {
        disabled: "是否禁用",
        showAlpha: "是否支持透明度选择",
        colorFormat: "颜色的格式",
        predefine: "预定义颜色"
      }
    },
    datePicker: {
      name: "日期",
      props: {
        pickerOptions: "当前时间日期选择器特有的选项",
        readonly: "完全只读",
        disabled: "禁用",
        type: "显示类型",
        editable: "文本框可输入",
        clearable: "是否显示清除按钮",
        placeholder: "非范围选择时的占位内容",
        startPlaceholder: "范围选择时开始日期的占位内容",
        endPlaceholder: "范围选择时结束日期的占位内容",
        format: "显示在输入框中的格式",
        align: "对齐方式",
        rangeSeparator: "选择范围时的分隔符",
        unlinkPanels: "在范围选择器里取消两个日期面板之间的联动"
      }
    },
    dateRange: {
      name: "日期区间"
    },
    timeRange: {
      name: "时间区间"
    },
    elAlert: {
      name: "提示",
      description: "说明文字",
      props: {
        title: "标题",
        type: "主题",
        description: "辅助性文字",
        closable: "是否可关闭",
        center: "文字是否居中",
        closeText: "关闭按钮自定义文本",
        showIcon: "是否显示图标",
        effect: "选择提供的主题"
      }
    },
    elButton: {
      name: "按钮",
      props: {
        formCreateChild: "内容",
        size: "尺寸",
        type: "类型",
        plain: "是否朴素按钮",
        round: "是否圆角按钮",
        circle: "是否圆形按钮",
        loading: "是否加载中状态",
        disabled: "是否禁用状态"
      }
    },
    elCard: {
      name: "卡片",
      props: {
        header: "标题",
        shadow: "阴影显示时机"
      }
    },
    elCollapse: {
      name: "折叠面板",
      event: {
        change: "切换当前活动面板，在手风琴模式下其类型是string，在其他模式下是array"
      },
      props: {
        accordion: "是否手风琴模式"
      }
    },
    elCollapseItem: {
      name: "面板",
      props: {
        title: "面板标题",
        name: "唯一标志符",
        disabled: "是否禁用"
      }
    },
    elDivider: {
      name: "分割线",
      props: {
        formCreateChild: "设置分割线文案",
        contentPosition: "设置分割线文案的位置"
      }
    },
    elTabPane: {
      name: "选项卡",
      props: {
        label: "选项卡标题",
        disabled: "是否禁用",
        name: "选项卡的标识符",
        lazy: "标签是否延迟渲染"
      }
    },
    elTabs: {
      name: "标签页",
      event: {
        tabClick: "tab 被选中时触发",
        tabChange: "activeName 改变时触发",
        tabRemove: "点击 tab 移除按钮时触发",
        tabAdd: "点击 tab 新增按钮时触发",
        edit: "点击 tab 的新增或移除按钮后触发"
      },
      props: {
        type: "风格类型",
        closable: "标签是否可关闭",
        tabPosition: "选项卡所在位置",
        stretch: "标签的宽度是否自撑开"
      }
    },
    elTag: {
      name: "标签",
      props: {
        formCreateNative: "是否显示标题",
        formCreateTitle: "标题",
        formCreateChild: "标签内容",
        type: "标签的类型",
        size: "标签的尺寸",
        effect: "标签的主题",
        closable: "是否可关闭",
        disableTransitions: "是否禁用渐变动画",
        hit: "是否有边框描边",
        round: "是否为圆形",
        color: "背景色"
      }
    },
    elTransfer: {
      name: "穿梭框",
      event: {
        leftCheckChange: "左侧列表元素被用户选中 / 取消选中时触发",
        rightCheckChange: "右侧列表元素被用户选中 / 取消选中时触发"
      },
      props: {
        filterable: "是否可搜索",
        filterPlaceholder: "搜索框占位符",
        targetOrder: "右侧列表元素的排序策略",
        targetOrderInfo: "若为 original，则保持与数据相同的顺序；若为 push，则新加入的元素排在最后；若为 unshift，则新加入的元素排在最前",
        titles: "自定义列表标题",
        buttonTexts: "自定义按钮文案",
        props: "数据源的字段别名"
      }
    },
    fcEditor: {
      name: "富文本框",
      props: {
        disabled: "是否禁用"
      }
    },
    fcRow: {
      name: "栅格布局",
      props: {
        gutter: "栅格间隔",
        type: "flex布局模式",
        justify: "flex布局下的水平排列方式",
        align: "flex布局下的垂直排列方式"
      }
    },
    fcTable: {
      name: "表格布局",
      props: {
        border: "是否显示边框",
        borderColor: "边框颜色",
        borderWidth: "边框宽度"
      }
    },
    fcTableGrid: {
      name: "格子"
    },
    group: {
      name: "子表单",
      props: {
        disabled: "是否禁用",
        syncDisabled: "是否与子表单强制同步禁用状态",
        expand: "设置默认展开几项",
        button: "是否显示操作按钮",
        sortBtn: "是否显示排序按钮",
        min: "设置最小添加几项",
        max: "设置最多添加几项"
      }
    },
    html: {
      name: "HTML",
      props: {
        formCreateNative: "是否显示标题",
        formCreateTitle: "标题",
        formCreateChild: "内容"
      }
    },
    input: {
      name: "输入框",
      event: {
        change: "当值改变时，当组件失去焦点或用户按Enter时触发"
      },
      props: {
        type: "类型",
        maxlength: "最大输入长度",
        minlength: "最小输入长度",
        placeholder: "输入框占位文本",
        clearable: "是否显示清除按钮",
        disabled: "是否禁用",
        readonly: "是否只读"
      }
    },
    inputNumber: {
      name: "计数器",
      props: {
        precision: "数值精度",
        min: "设置计数器允许的最小值",
        max: "设置计数器允许的最大值",
        step: "计数器步长",
        stepStrictly: "是否只能输入 step 的倍数",
        disabled: "是否禁用计数器",
        controls: "是否使用控制按钮",
        controlsPosition: "控制按钮位置",
        placeholder: "输入框占位文本"
      }
    },
    password: {
      name: "密码输入框",
      event: {
        change: "当值改变时，当组件失去焦点或用户按Enter时触发"
      },
      props: {
        disabled: "是否禁用",
        readonly: "是否只读",
        maxlength: "最大输入长度",
        minlength: "最小输入长度",
        placeholder: "输入框占位文本",
        clearable: "是否显示清除按钮"
      }
    },
    radio: {
      name: "单选框",
      props: {
        disabled: "是否禁用",
        type: "按钮形式",
        textColor: "按钮形式激活时的文本颜色",
        fill: "按钮形式激活时的填充色和边框色"
      }
    },
    rate: {
      name: "评分",
      props: {
        max: "最大分值",
        disabled: "是否禁用",
        allowHalf: "是否允许半选",
        voidColor: "未选中时图标的颜色",
        disabledVoidColor: "只读时未选中时图标的颜色",
        voidIconClass: "未选中时图标的类名",
        disabledVoidIconClass: "只读时未选中时图标的类名",
        showScore: "是否显示当前分数",
        textColor: "辅助文字的颜色",
        scoreTemplate: "分数显示模板"
      }
    },
    select: {
      name: "选择器",
      event: {
        removeTag: "多选模式下移除tag时触发"
      },
      props: {
        multiple: "是否多选",
        disabled: "是否禁用",
        clearable: "是否可以清空选项",
        collapseTags: "多选时是否将选中值按文字的形式展示",
        multipleLimit: "多选时用户最多可以选择的项目数，为 0 则不限制",
        placeholder: "占位符",
        filterable: "是否可搜索",
        allowCreate: "是否允许用户创建新条目",
        noMatchText: "搜索条件无匹配时显示的文字",
        noDataText: "选项为空时显示的文字",
        reserveKeyword: "多选且可搜索时，是否在选中一个选项后保留当前的搜索关键词",
        defaultFirstOption: "在输入框按下回车，选择第一个匹配项",
        remote: "其中的选项是否从服务器远程加载",
        remoteMethod: "自定义远程搜索方法"
      }
    },
    slider: {
      name: "滑块",
      props: {
        min: "最小值",
        max: "最大值",
        disabled: "是否禁用",
        step: "步长",
        showInput: "是否显示输入框，仅在非范围选择时有效",
        showInputControls: "在显示输入框的情况下，是否显示输入框的控制按钮",
        showStops: "是否显示间断点",
        range: "是否为范围选择",
        vertical: "是否竖向模式",
        height: "Slider 高度，竖向模式时必填"
      }
    },
    space: {
      name: "间距",
      props: {
        height: "高度"
      }
    },
    subForm: {
      name: "分组",
      props: {
        disabled: "是否禁用",
        syncDisabled: "是否与子表单强制同步禁用状态"
      }
    },
    switch: {
      name: "开关",
      props: {
        disabled: "是否禁用",
        width: "宽度（px）",
        activeText: "打开时的文字描述",
        inactiveText: "关闭时的文字描述",
        activeValue: "打开时的值",
        inactiveValue: "关闭时的值",
        activeColor: "打开时的背景色",
        inactiveColor: "关闭时的背景色"
      }
    },
    tableForm: {
      name: "表格表单",
      props: {
        disabled: "是否禁用",
        max: "最多添加几行，为 0 则不限制"
      }
    },
    tableFormColumn: {
      name: "表格格子",
      label: "自定义名称",
      props: {
        label: "标题",
        width: "宽度",
        color: "颜色"
      }
    },
    text: {
      name: "文字",
      props: {
        formCreateNative: "是否显示标题",
        formCreateTitle: "标题",
        formCreateChild: "内容"
      }
    },
    textarea: {
      name: "多行输入框",
      event: {
        change: "当值改变时，当组件失去焦点或用户按Enter时触发"
      },
      props: {
        disabled: "是否禁用",
        readonly: "是否只读",
        maxlength: "最大输入长度",
        minlength: "最小输入长度",
        showWordLimit: "是否显示统计字数",
        placeholder: "输入框占位文本",
        rows: "输入框行数",
        autosize: "高度是否自适应"
      }
    },
    timePicker: {
      name: "时间",
      props: {
        pickerOptions: "当前时间日期选择器特有的选项",
        readonly: "完全只读",
        disabled: "禁用",
        editable: "文本框可输入",
        clearable: "是否显示清除按钮",
        placeholder: "非范围选择时的占位内容",
        startPlaceholder: "范围选择时开始日期的占位内容",
        endPlaceholder: "范围选择时开始日期的占位内容",
        isRange: "是否为时间范围选择",
        arrowControl: "是否使用箭头进行时间选择",
        align: "对齐方式"
      }
    },
    tree: {
      name: "树形控件",
      event: {
        nodeClick: "当节点被点击的时候触发",
        nodeContextmenu: "当某一节点被鼠标右键点击时会触发该事件",
        checkChange: "当复选框被点击的时候触发",
        check: "点击节点复选框之后触发",
        currentChange: "当前选中节点变化时触发的事件",
        nodeExpand: "节点被展开时触发的事件",
        nodeCollapse: "节点被关闭时触发的事件",
        nodeDragStart: "节点开始拖拽时触发的事件",
        nodeDragEnter: "拖拽进入其他节点时触发的事件",
        nodeDragLeave: "拖拽离开某个节点时触发的事件",
        nodeDragOver: "在拖拽节点时触发的事件（类似浏览器的 mouseover 事件）",
        nodeDragEnd: "拖拽结束时（可能未成功）触发的事件",
        nodeDrop: "拖拽成功完成时触发的事件"
      },
      props: {
        emptyText: "内容为空的时候展示的文本",
        props: "配置选项",
        renderAfterExpand: "是否在第一次展开某个树节点后才渲染其子节点",
        defaultExpandAll: "是否默认展开所有节点",
        expandOnClickNode: "是否在点击节点的时候展开或者收缩节点，如果为 false，则只有点箭头图标的时候才会展开或者收缩节点。",
        checkOnClickNode: "是否在点击节点的时候选中节点",
        autoExpandParent: "展开子节点的时候是否自动展开父节点",
        checkStrictly: "在显示复选框的情况下，是否严格的遵循父子不互相关联的做法",
        accordion: "是否每次只打开一个同级树节点展开",
        indent: "相邻级节点间的水平缩进(px)",
        nodeKey: "每个树节点用来作为唯一标识的属性，整棵树应该是唯一的"
      }
    },
    upload: {
      name: "上传",
      info: "在onSuccess方法中将接口返回的url赋值给file.url",
      event: {
        remove: "文件列表移除文件时触发"
      },
      props: {
        listType: "上传类型",
        uploadType: "上传类型",
        multiple: "是否支持多选文件",
        action: "上传的地址(必填)",
        beforeUpload: "上传文件之前的回调",
        onSuccess: "上传成功回调",
        headers: "设置上传的请求头部",
        data: "上传时附带的额外参数",
        name: "上传的文件字段名",
        withCredentials: "支持发送 cookie 凭证信息",
        accept: "接受上传的文件类型",
        autoUpload: "是否在选取文件后立即进行上传",
        disabled: "是否禁用",
        limit: "最大允许上传个数"
      }
    }
  }
}, Of = (i, t) => Ch({
  message: i,
  type: t || "info",
  customClass: "_fc-message-tip"
}), On = (i) => Of(i, "error");
function Rf(i) {
  return i == null || Array.isArray(i) && Array.isArray(i) && !i.length ? !0 : typeof i == "string" && !i;
}
function jr(i, t, l, c = []) {
  t.id || (t.id = 1), l && l--;
  for (let M = 0; M < 3; M++) {
    const T = {
      [t.label]: i + l * 10 + (M + 1),
      [t.value]: "" + t.id++
    };
    l && jr(i, t, l, T.children = []), c.push(T);
  }
  return c;
}
function Aa(i, t) {
  const l = [
    { label: i("fetch.optionsType.struct"), value: 2 },
    { label: i("fetch.optionsType.fetch"), value: 1 }
  ], c = [
    {
      value: 1,
      rule: [
        {
          type: "FetchConfig",
          field: "formCreateEffect>fetch",
          props: {
            to: t
          }
        }
      ]
    },
    {
      value: 2,
      rule: [
        {
          type: "TableOptions",
          field: "formCreate" + po(t).replace(".", ">"),
          props: {
            keyValue: "label"
          }
        }
      ]
    }
  ];
  return {
    type: "radio",
    title: i("props.options"),
    field: "_optionType",
    value: 2,
    options: l,
    props: {
      type: "button"
    },
    control: c
  };
}
function ws({ t: i, to: t, label: l, value: c }) {
  const M = [
    { label: i("fetch.optionsType.struct"), value: 2 },
    { label: i("fetch.optionsType.fetch"), value: 1 }
  ], T = [
    {
      value: 1,
      rule: [
        {
          type: "FetchConfig",
          field: "formCreateEffect>fetch",
          props: {
            to: t
          }
        }
      ]
    },
    {
      value: 2,
      rule: [
        {
          type: "TreeOptions",
          field: "formCreate" + po(t).replace(".", ">"),
          props: {
            columns: {
              label: l,
              value: c
            },
            keyValue: l
          }
        }
      ]
    }
  ];
  return {
    type: "radio",
    title: i("props.options"),
    field: "_optionType",
    value: 2,
    options: M,
    props: {
      type: "button"
    },
    control: T
  };
}
function po(i) {
  return i.replace(i[0], i[0].toLocaleUpperCase());
}
const Ar = function(i) {
  const t = /object ([a-zA-Z]*)/.exec(Object.prototype.toString.call(i));
  return t && $c[t[1].toLowerCase()] ? $c[t[1].toLowerCase()](i) : i;
}, $c = {
  object: function(i) {
    var t = [];
    for (var l in i)
      Fr(i, l) && t.push(
        Ar(l) + ": " + (i[l] != null ? Ar(i[l]) : "null")
      );
    return `{
 ` + t.join(`,
 `) + `
}`;
  },
  function: function(i) {
    i = "" + i;
    var t = /^ *([\w]+) *\(/.exec(i);
    return t && t[1] !== "function" ? "function " + i : i;
  },
  array: function(i) {
    for (var t = 0, l = []; t < i.length; t++)
      l[t] = i[t] != null ? Ar(i[t]) : "null";
    return "[" + l.join(", ") + "]";
  },
  string: function(i) {
    for (var t = i.split(""), l = 0; l < t.length; l++) {
      var c = t[l];
      c >= " " ? c === "\\" ? t[l] = "\\\\" : c === '"' && (t[l] = '\\"') : t[l] = c === `
` ? "\\n" : c === "\r" ? "\\r" : c === "	" ? "\\t" : c === "\b" ? "\\b" : c === "\f" ? "\\f" : (c = c.charCodeAt(), "\\u00" + (c > 15 ? 1 : 0) + c % 16);
    }
    return '"' + t.join("") + '"';
  }
}, If = function(i) {
  if (i && typeof i == "object") {
    for (let t in i)
      if (Object.prototype.hasOwnProperty.call(i, t)) {
        let l = i[t];
        (Array.isArray(l) || at.Object(l)) && If(l), at.String(l) && (i[t] = kh(l));
      }
  }
  return i;
};
function Dh(i, t, l) {
  t = (t || "").split(".");
  let c = 0, M = t.length;
  for (; i != null && c < M; )
    i = i[t[c++]];
  return c && c === M && i !== void 0 ? i : l;
}
const Mh = (i) => (t, l) => Nh(t, l, Df(i)), Nh = (i, t, l) => Dh(l, i, "").replace(
  /\{(\w+)\}/g,
  (c, M) => {
    var T;
    return `${(T = t == null ? void 0 : t[M]) != null ? T : `{${M}}`}`;
  }
), Oh = (i) => {
  const t = Un(() => Df(i).name), l = Un(() => po(Th(t.value || ""))), c = wh(i) ? i : ao(i);
  return {
    lang: t,
    name: l,
    locale: c,
    t: Mh(i)
  };
}, ds = (i) => Oh(Un(() => i.value || Nf)), Jt = (i, t, l) => t.map((c) => (c.label = i("props." + c.value) || c.label, c)), Ke = (i, t, l) => l.map((c) => (c.field === "formCreate$required" ? c.title = i("validate.required") || c.title : c.field && c.field !== "_optionType" && (c.title = i("com." + t + "." + c.field) || c.title), c.type === "template" && at.trueArray(c.children) && (c.children = Ke(i, t, c.children)), c)), ps = (i) => {
  const t = [];
  return i && i.forEach((l) => {
    if (l._fc_drag_tag) {
      const c = {
        id: l.__fc__.id,
        rule: l,
        children: ps(l.children)
      };
      c.children.length || delete c.children, t.push(c);
    } else
      t.push(...ps(l.children));
  }), t;
}, zc = (i) => {
  const t = (l) => {
    const c = [];
    return l && l.forEach((M) => {
      M.field ? (M.children = t(M.children || []), M.children.length || delete M.children, c.push(M)) : c.push(...t(M.children || []));
    }), c;
  };
  return t(i);
}, Uc = (i) => {
  const t = (l) => {
    const c = [];
    return l && l.forEach((M) => {
      if (typeof M == "object")
        if (M._fc_drag_tag) {
          const T = {
            _fc_id: M._fc_id,
            type: M.type,
            field: M.field,
            title: M.title,
            name: M.name,
            slot: M.slot,
            props: rt({}, M.props || {}),
            children: t(M.children || [])
          };
          M.children && typeof M.children[0] == "string" && (T.content = M.children[0]), T.children.length || delete T.children, c.push(T);
        } else
          c.push(...t(M.children));
    }), c;
  };
  return t(i);
};
function Lf(i) {
  return {
    name: "$inject",
    columns: [
      { label: "$inject.api", info: i("event.inject.api"), type: "Api" },
      { label: "$inject.rule", info: i("event.inject.rule"), type: "Rule[]" },
      { label: "$inject.self", info: i("event.inject.self"), type: "Rule" },
      { label: "$inject.option", info: i("event.inject.option"), type: "Object" },
      { label: "$inject.args", info: i("event.inject.args"), type: "Array" }
    ]
  };
}
function qn(i) {
  return ["", null, void 0].indexOf(i) !== -1;
}
function Rh(i, t) {
  return `<template>
  <form-create
    :value.sync="formData"
    v-model="fapi"
    :rule="rule"
    :option="option"
    @submit="onSubmit"
  ></form-create>
</template>

<script>
import formCreate from "@form-create/element-ui";

export default {
  components: {
    formCreate: formCreate.$form()
  },
  data () {
    const option = formCreate.parseJson('${t.replaceAll("\\", "\\\\").replaceAll("'", "\\")}');
    return {
      formData: {},
      fapi: null,
      rule: formCreate.parseJson('${i.replaceAll("\\", "\\\\").replaceAll("'", "\\")}'),
      option: option
    }
  },
  methods: {
    onSubmit (formData) {
      //todo 提交表单
    }
  }
}
<\/script>`;
}
function Ih(i, t) {
  const l = i.split("."), c = t.split("."), M = Math.min(l.length, c.length);
  for (var T = 0; T < M; T++) {
    var F = parseInt(l[T], 10) - parseInt(c[T], 10);
    if (F > 0)
      return 1;
    if (F < 0)
      return -1;
  }
  return l.length === c.length ? 0 : l.length < c.length ? -1 : 1;
}
function Ff(i) {
  const t = document.createElement("textarea");
  t.style.position = "fixed", t.style.top = 0, t.style.left = "-9999px", t.value = i, document.body.appendChild(t), t.focus(), t.select();
  try {
    document.execCommand("copy");
  } catch (l) {
    console.log("Oops, unable to copy");
  }
  Of("已复制!", "success"), document.body.removeChild(t);
}
function Wc(i) {
  return i.filter((t, l) => i.indexOf(t) === l);
}
function Qc({ t: i }) {
  return [
    {
      type: "input",
      field: ">formName",
      value: "",
      title: i("form.formName")
    },
    {
      type: "radio",
      field: "labelPosition",
      value: "left",
      title: i("form.labelPosition"),
      options: Jt(i, [
        { value: "left", label: "left" },
        { value: "right", label: "right" },
        { value: "top", label: "top" }
      ])
    },
    {
      type: "radio",
      field: "size",
      value: "small",
      title: i("form.size"),
      options: Jt(i, [
        { value: "large", label: "large" },
        { value: "default", label: "default" },
        { value: "small", label: "small" }
      ])
    },
    {
      type: "input",
      field: "labelSuffix",
      value: "",
      title: i("form.labelSuffix"),
      style: {
        width: "150px"
      }
    },
    {
      type: "SizeInput",
      field: "labelWidth",
      value: "125px",
      title: i("form.labelWidth")
    },
    {
      type: "switch",
      field: "hideRequiredAsterisk",
      value: !1,
      title: i("form.hideRequiredAsterisk")
    },
    {
      type: "switch",
      field: "showMessage",
      value: !0,
      title: i("form.showMessage")
    },
    {
      type: "switch",
      field: "inlineMessage",
      value: !1,
      title: i("form.inlineMessage")
    },
    {
      type: "switch",
      field: "_submitBtn>show",
      value: !0,
      title: i("form.submitBtn")
    },
    {
      type: "switch",
      field: "_resetBtn>show",
      value: !1,
      title: i("form.resetBtn")
    },
    {
      type: "FnConfig",
      field: ">_event",
      info: {
        native: !0,
        effect: "light",
        align: "left",
        children: [{
          type: "div",
          domProps: {
            innerHTML: i("form.document") + '：<a target="_blank" href="https://form-create.com/v3/guide/global-event">https://form-create.com/v3/guide/global-event</a>'
          }
        }]
      },
      value: {},
      col: { show: !0 },
      props: {
        eventConfig: [
          {
            name: "onSubmit",
            args: ["formData", "api"]
          },
          {
            name: "onCreated",
            args: ["api"]
          },
          {
            name: "onMounted",
            args: ["api"]
          },
          {
            name: "onChange",
            args: ["field", "value", "options"]
          },
          {
            name: "beforeFetch",
            args: ["config", "data"]
          }
        ]
      },
      title: i("form.event")
    }
  ];
}
function Ji({ t: i }) {
  return [
    {
      type: "FieldInput",
      field: "field",
      value: "",
      title: i("form.field")
    },
    {
      type: "input",
      field: "title",
      value: "",
      title: i("form.title")
    },
    {
      type: "input",
      field: "info",
      value: "",
      title: i("form.info")
    },
    {
      type: "SizeInput",
      field: "formCreateWrap>labelWidth",
      value: "",
      title: i("form.labelWidth")
    },
    {
      type: "Struct",
      field: "_control",
      value: [],
      title: i("form.control"),
      info: {
        native: !0,
        effect: "light",
        align: "left",
        children: [{
          type: "div",
          domProps: {
            innerHTML: i("form.document") + '：<a target="_blank" href="https://form-create.com/v3/guide/control">https://form-create.com/v3/guide/control</a>'
          }
        }]
      },
      props: {
        defaultValue: [],
        validate(t) {
          return Array.isArray(t) ? t.length ? !t.some(({ rule: l }) => !Array.isArray(l)) : !0 : !1;
        }
      }
    }
  ];
}
function Lh({ t: i }) {
  return [
    {
      type: "input",
      title: "ID",
      field: "id",
      wrap: {
        labelWidth: "45px"
      }
    },
    {
      type: "input",
      title: "Class",
      field: "class",
      wrap: {
        labelWidth: "45px"
      }
    },
    {
      type: "StyleConfig",
      field: "style",
      title: "",
      value: {}
    }
  ];
}
function Vc({ t: i }) {
  return [
    {
      type: "Required",
      field: "$required",
      title: i("validate.required")
    },
    {
      type: "validate",
      field: "validate",
      title: i("validate.rule"),
      value: []
    }
  ];
}
let Fh = 0;
function Je() {
  const i = 370 + ++Fh;
  return "F" + Math.random().toString(36).substr(3, 3) + (+`${Date.now()}`).toString(36) + i.toString(36) + "c";
}
const Bh = "单选框", wl = "radio", Ph = {
  menu: "main",
  icon: "icon-radio",
  label: Bh,
  name: wl,
  event: ["change"],
  validate: ["string", "number"],
  rule({ t: i }) {
    return {
      type: wl,
      field: Je(),
      title: i("com.radio.name"),
      info: "",
      effect: {
        fetch: ""
      },
      $required: !1,
      props: {},
      options: jr(i("props.option"), { label: "label", value: "value" }, 1)
    };
  },
  props(i, { t }) {
    return Ke(t, wl + ".props", [
      Aa(t, "options"),
      { type: "switch", field: "disabled" },
      {
        type: "switch",
        field: "type",
        props: { activeValue: "button", inactiveValue: "default" }
      },
      { type: "ColorPicker", field: "textColor" },
      {
        type: "ColorPicker",
        field: "fill"
      }
    ]);
  }
}, Hh = "多选框", _l = "checkbox", jh = {
  menu: "main",
  icon: "icon-checkbox",
  label: Hh,
  name: _l,
  event: ["change"],
  validate: ["array"],
  rule({ t: i }) {
    return {
      type: _l,
      field: Je(),
      title: i("com.checkbox.name"),
      info: "",
      effect: {
        fetch: ""
      },
      $required: !1,
      props: {},
      options: jr(i("props.option"), { label: "label", value: "value" }, 1)
    };
  },
  props(i, { t }) {
    return Ke(t, _l + ".props", [
      Aa(t, "options"),
      {
        type: "switch",
        field: "disabled"
      },
      {
        type: "switch",
        field: "type",
        props: { activeValue: "button", inactiveValue: "default" }
      },
      {
        field: "min",
        type: "inputNumber",
        props: {
          min: 0
        }
      },
      {
        field: "max",
        type: "inputNumber",
        props: {
          min: 0
        }
      },
      {
        type: "ColorPicker",
        field: "textColor"
      },
      {
        type: "ColorPicker",
        field: "fill"
      }
    ]);
  }
}, $h = "输入框", Cl = "input", zh = {
  menu: "main",
  icon: "icon-input",
  label: $h,
  name: Cl,
  event: ["blur", "focus", "change", "input", "clear"],
  validate: ["string", "url", "email"],
  rule({ t: i }) {
    return {
      type: Cl,
      field: Je(),
      title: i("com.input.name"),
      info: "",
      $required: !1,
      props: {}
    };
  },
  props(i, { t }) {
    return Ke(t, Cl + ".props", [
      {
        type: "switch",
        field: "disabled"
      },
      {
        type: "switch",
        field: "readonly"
      },
      {
        type: "select",
        field: "type",
        options: Jt(t, [
          { label: "text", value: "text" },
          { label: "number", value: "number" },
          { label: "time", value: "time" },
          { label: "date", value: "date" },
          { label: "month", value: "month" },
          { label: "datetime-local", value: "datetime-local" }
        ])
      },
      {
        type: "inputNumber",
        field: "maxlength",
        props: { min: 0 }
      },
      {
        type: "input",
        field: "placeholder"
      },
      {
        type: "switch",
        field: "clearable"
      }
    ]);
  }
}, Uh = "多行输入框", Gc = "textarea", Wh = {
  menu: "main",
  icon: "icon-textarea",
  label: Uh,
  name: Gc,
  event: ["blur", "focus", "change", "input"],
  validate: ["string"],
  rule({ t: i }) {
    return {
      type: "input",
      field: Je(),
      title: i("com.textarea.name"),
      info: "",
      $required: !1,
      props: {
        type: "textarea"
      }
    };
  },
  props(i, { t }) {
    return Ke(t, Gc + ".props", [
      {
        type: "switch",
        field: "disabled"
      },
      {
        type: "switch",
        field: "readonly"
      },
      {
        type: "inputNumber",
        field: "maxlength",
        props: { min: 0 }
      },
      {
        type: "switch",
        field: "showWordLimit"
      },
      {
        type: "input",
        field: "placeholder"
      },
      {
        type: "inputNumber",
        field: "rows",
        props: {
          min: 0
        }
      },
      {
        type: "switch",
        field: "autosize"
      }
    ]);
  }
}, Qh = "密码输入框", Yc = "password", Vh = {
  menu: "main",
  icon: "icon-password",
  label: Qh,
  name: Yc,
  event: ["blur", "focus", "change", "input", "clear"],
  validate: ["string"],
  rule({ t: i }) {
    return {
      type: "input",
      field: Je(),
      title: i("com.password.name"),
      info: "",
      $required: !1,
      props: {
        type: "password"
      }
    };
  },
  props(i, { t }) {
    return Ke(t, Yc + ".props", [
      {
        type: "switch",
        field: "disabled"
      },
      {
        type: "switch",
        field: "readonly"
      },
      {
        type: "inputNumber",
        field: "maxlength",
        props: { min: 0 }
      },
      {
        type: "input",
        field: "placeholder"
      },
      {
        type: "switch",
        field: "clearable"
      }
    ]);
  }
}, Gh = "计数器", Sl = "inputNumber", Yh = {
  menu: "main",
  icon: "icon-number",
  label: Gh,
  name: Sl,
  event: ["blur", "focus", "change"],
  validate: ["number", "integer", "float"],
  rule({ t: i }) {
    return {
      type: Sl,
      field: Je(),
      title: i("com.inputNumber.name"),
      info: "",
      $required: !1,
      props: {}
    };
  },
  props(i, { t }) {
    return Ke(t, Sl + ".props", [{ type: "switch", field: "disabled" }, {
      type: "inputNumber",
      field: "min"
    }, {
      type: "inputNumber",
      field: "max"
    }, {
      type: "inputNumber",
      title: "precision",
      field: "precision"
    }, { type: "inputNumber", field: "step", props: { min: 0 } }, {
      type: "switch",
      field: "stepStrictly"
    }, {
      type: "switch",
      field: "controls",
      value: !0
    }, {
      type: "select",
      field: "controlsPosition",
      options: Jt(t, [{ label: t("props.default"), value: "" }, { label: "right", value: "right" }])
    }, { type: "input", field: "placeholder" }]);
  }
}, Kh = "选择器", El = "select", Xh = {
  menu: "main",
  icon: "icon-select",
  label: Kh,
  name: El,
  event: ["change", "visibleChange", "removeTag", "clear", "blur", "focus"],
  validate: ["string", "number", "array"],
  rule({ t: i }) {
    return {
      type: El,
      field: Je(),
      title: i("com.select.name"),
      info: "",
      effect: {
        fetch: ""
      },
      $required: !1,
      props: {},
      options: jr(i("props.option"), { label: "label", value: "value" }, 1)
    };
  },
  watch: {
    multiple({ rule: i }) {
      i.key = Je();
    }
  },
  props(i, { t }) {
    return Ke(t, El + ".props", [
      Aa(t, "options"),
      { type: "switch", field: "multiple" },
      {
        type: "switch",
        field: "disabled"
      },
      { type: "switch", field: "clearable" },
      {
        type: "switch",
        field: "collapseTags"
      },
      {
        type: "inputNumber",
        field: "multipleLimit",
        props: { min: 0 }
      },
      { type: "input", field: "placeholder" },
      {
        type: "switch",
        field: "filterable"
      },
      {
        type: "switch",
        field: "remote"
      },
      {
        type: "FnInput",
        field: "remoteMethod",
        props: {
          body: !0,
          button: !0,
          fnx: !0,
          name: "remoteMethod",
          args: [Lf(t)]
        }
      },
      { type: "switch", field: "allowCreate" },
      {
        type: "input",
        field: "noMatchText"
      },
      { type: "input", field: "noDataText" },
      {
        type: "switch",
        field: "reserveKeyword"
      },
      { type: "switch", field: "defaultFirstOption" }
    ]);
  }
}, Jh = "开关", kl = "switch", qh = {
  menu: "main",
  icon: "icon-switch",
  label: Jh,
  name: kl,
  event: ["change"],
  rule({ t: i }) {
    return {
      type: kl,
      field: Je(),
      title: i("com.switch.name"),
      info: "",
      $required: !1,
      props: {}
    };
  },
  props(i, { t }) {
    return Ke(t, kl + ".props", [{
      type: "switch",
      field: "disabled"
    }, {
      type: "inputNumber",
      field: "width",
      props: { min: 0 }
    }, { type: "input", field: "activeText" }, {
      type: "input",
      field: "inactiveText"
    }, { type: "input", field: "activeValue" }, {
      type: "input",
      field: "inactiveValue"
    }, { type: "ColorPicker", field: "activeColor" }, {
      type: "ColorPicker",
      field: "inactiveColor"
    }]);
  }
}, Zh = "滑块", Tl = "slider", ev = {
  menu: "main",
  icon: "icon-slider",
  label: Zh,
  name: Tl,
  event: ["change", "input"],
  validate: ["number", "array"],
  rule({ t: i }) {
    return {
      type: Tl,
      field: Je(),
      title: i("com.slider.name"),
      info: "",
      $required: !1,
      props: {}
    };
  },
  props(i, { t }) {
    return Ke(t, Tl + ".props", [{ type: "switch", field: "disabled" }, {
      type: "switch",
      field: "range"
    }, {
      type: "inputNumber",
      field: "min",
      props: { min: 0 }
    }, {
      type: "inputNumber",
      field: "max",
      props: { min: 0 }
    }, {
      type: "inputNumber",
      field: "step",
      props: { min: 0 }
    }, { type: "switch", field: "showInput" }, {
      type: "switch",
      field: "showInputControls",
      value: !0
    }, { type: "switch", field: "showStops" }, {
      type: "switch",
      field: "vertical"
    }, {
      type: "input",
      field: "height"
    }]);
  }
}, tv = "时间", Dl = "timePicker", nv = {
  menu: "main",
  icon: "icon-time",
  label: tv,
  name: Dl,
  event: ["change", "blur", "focus"],
  rule({ t: i }) {
    return {
      type: Dl,
      field: Je(),
      title: i("com.timePicker.name"),
      info: "",
      $required: !1,
      props: {}
    };
  },
  watch: {
    isRange({ rule: i }) {
      i.key = Je();
    }
  },
  props(i, { t }) {
    return Ke(t, Dl + ".props", [{ type: "switch", field: "readonly" }, {
      type: "switch",
      field: "disabled"
    }, {
      type: "switch",
      field: "isRange"
    }, {
      type: "switch",
      field: "clearable",
      value: !0
    }, {
      type: "Struct",
      field: "pickerOptions",
      props: { defaultValue: {} }
    }, { type: "switch", field: "editable", value: !0 }, {
      type: "input",
      field: "placeholder"
    }, {
      type: "input",
      field: "startPlaceholder"
    }, { type: "input", field: "endPlaceholder" }, {
      type: "switch",
      field: "arrowControl"
    }, {
      type: "select",
      field: "align",
      options: Jt(t, [{ label: "left", value: "left" }, { label: "center", value: "center" }, {
        label: "right",
        value: "right"
      }])
    }]);
  }
}, rv = "时间区间", iv = "timeRange", ov = {
  menu: "main",
  icon: "icon-time",
  label: rv,
  name: iv,
  event: ["change", "blur", "focus"],
  rule({ t: i }) {
    return {
      type: "timePicker",
      field: Je(),
      title: i("com.timeRange.name"),
      info: "",
      $required: !1,
      props: {
        isRange: !0
      }
    };
  },
  props(i, { t }) {
    return Ke(t, "timePicker.props", [{ type: "switch", field: "readonly" }, {
      type: "switch",
      field: "disabled"
    }, {
      type: "switch",
      field: "clearable",
      value: !0
    }, {
      type: "Struct",
      field: "pickerOptions",
      props: { defaultValue: {} }
    }, { type: "switch", field: "editable", value: !0 }, {
      type: "input",
      field: "startPlaceholder"
    }, { type: "input", field: "endPlaceholder" }, {
      type: "switch",
      field: "arrowControl"
    }, {
      type: "select",
      field: "align",
      options: Jt(t, [{ label: "left", value: "left" }, { label: "center", value: "center" }, {
        label: "right",
        value: "right"
      }])
    }]);
  }
}, av = "日期", Ml = "datePicker", lv = {
  menu: "main",
  icon: "icon-date",
  label: av,
  name: Ml,
  event: ["change", "blur", "focus"],
  rule({ t: i }) {
    return {
      type: Ml,
      field: Je(),
      title: i("com.datePicker.name"),
      info: "",
      $required: !1,
      props: {}
    };
  },
  props(i, { t }) {
    return Ke(t, Ml + ".props", [{ type: "switch", field: "readonly" }, {
      type: "switch",
      field: "disabled"
    }, {
      type: "select",
      field: "type",
      options: Jt(t, [{ label: "year", value: "year" }, { label: "month", value: "month" }, {
        label: "date",
        value: "date"
      }, { label: "dates", value: "dates" }, { label: "week", value: "week" }, {
        label: "datetime",
        value: "datetime"
      }, { label: "datetimerange", value: "datetimerange" }, {
        label: "daterange",
        value: "daterange"
      }, { label: "monthrange", value: "monthrange" }])
    }, {
      type: "switch",
      field: "clearable",
      value: !0
    }, {
      type: "Struct",
      field: "pickerOptions",
      props: { defaultValue: {} }
    }, { type: "switch", field: "editable", value: !0 }, {
      type: "input",
      field: "placeholder"
    }, {
      type: "input",
      field: "startPlaceholder"
    }, { type: "input", field: "endPlaceholder" }, {
      type: "input",
      field: "format"
    }, {
      type: "select",
      field: "align",
      options: Jt(t, [{ label: "left", value: "left" }, { label: "center", value: "center" }, {
        label: "right",
        value: "right"
      }])
    }, { type: "input", field: "rangeSeparator" }, {
      type: "switch",
      field: "unlinkPanels"
    }]);
  }
}, sv = "日期区间", uv = "dateRange", cv = {
  menu: "main",
  icon: "icon-date",
  label: sv,
  name: uv,
  event: ["change", "blur", "focus"],
  rule({ t: i }) {
    return {
      type: "datePicker",
      field: Je(),
      title: i("com.dateRange.name"),
      info: "",
      $required: !1,
      props: {
        type: "datetimerange"
      }
    };
  },
  props(i, { t }) {
    return Ke(t, "datePicker.props", [{ type: "switch", field: "readonly" }, {
      type: "switch",
      field: "disabled"
    }, {
      type: "select",
      field: "type",
      options: Jt(t, [
        { label: "datetimerange", value: "datetimerange" },
        { label: "daterange", value: "daterange" },
        { label: "monthrange", value: "monthrange" }
      ])
    }, {
      type: "switch",
      field: "clearable",
      value: !0
    }, {
      type: "Struct",
      field: "pickerOptions",
      props: { defaultValue: {} }
    }, { type: "switch", field: "editable", value: !0 }, {
      type: "input",
      field: "startPlaceholder"
    }, { type: "input", field: "endPlaceholder" }, {
      type: "input",
      field: "format"
    }, {
      type: "select",
      field: "align",
      options: Jt(t, [{ label: "left", value: "left" }, { label: "center", value: "center" }, {
        label: "right",
        value: "right"
      }])
    }, { type: "input", field: "rangeSeparator" }, {
      type: "switch",
      field: "unlinkPanels"
    }]);
  }
}, fv = "评分", Nl = "rate", dv = {
  menu: "main",
  icon: "icon-rate",
  label: fv,
  name: Nl,
  event: ["change"],
  validate: ["number"],
  rule({ t: i }) {
    return {
      type: Nl,
      field: Je(),
      title: i("com.rate.name"),
      info: "",
      $required: !1,
      props: {}
    };
  },
  props(i, { t }) {
    return Ke(t, Nl + ".props", [
      { type: "inputNumber", field: "max", props: { min: 0 } },
      {
        type: "switch",
        field: "disabled"
      },
      { type: "switch", field: "allowHalf" },
      {
        type: "ColorPicker",
        field: "voidColor"
      },
      { type: "ColorPicker", field: "disabledVoidColor" },
      {
        type: "input",
        field: "voidIconClass"
      },
      { type: "input", field: "disabledVoidIconClass" },
      {
        type: "switch",
        field: "showScore"
      },
      { type: "ColorPicker", field: "textColor" },
      {
        type: "input",
        field: "scoreTemplate"
      }
    ]);
  }
}, pv = "颜色选择器", Ol = "colorPicker", hv = {
  menu: "main",
  icon: "icon-color",
  label: pv,
  name: Ol,
  event: ["change", "activeChange"],
  validate: ["string"],
  rule({ t: i }) {
    return {
      type: Ol,
      field: Je(),
      title: i("com.colorPicker.name"),
      info: "",
      $required: !1,
      props: {}
    };
  },
  props(i, { t }) {
    return Ke(t, Ol + ".props", [
      {
        type: "switch",
        field: "disabled"
      },
      {
        type: "switch",
        field: "showAlpha"
      },
      {
        type: "select",
        field: "colorFormat",
        options: [{ label: "hsl", value: "hsl" }, { label: "hsv", value: "hsv" }, {
          label: "hex",
          value: "hex"
        }, { label: "rgb", value: "rgb" }]
      },
      {
        type: "tableOptions",
        field: "predefine",
        props: {
          column: [{ label: t("props.value"), key: "value" }],
          valueType: "string"
        }
      }
    ]);
  }
}, vv = "栅格布局", Rl = "fcRow", gv = {
  menu: "layout",
  icon: "icon-row",
  label: vv,
  name: Rl,
  mask: !1,
  children: "col",
  childrenLen: 2,
  rule() {
    return {
      type: Rl,
      props: {},
      children: []
    };
  },
  props(i, { t }) {
    return Ke(t, Rl + ".props", [{
      type: "inputNumber",
      field: "gutter",
      props: { min: 0 }
    }, {
      type: "switch",
      field: "type",
      props: { activeValue: "flex", inactiveValue: "default" }
    }, {
      type: "select",
      field: "justify",
      options: [{ label: "start", value: "start" }, { label: "end", value: "end" }, {
        label: "center",
        value: "center"
      }, { label: "space-around", value: "space-around" }, { label: "space-between", value: "space-between" }]
    }, {
      type: "select",
      field: "align",
      options: [{ label: "top", value: "top" }, { label: "middle", value: "middle" }, {
        label: "bottom",
        value: "bottom"
      }]
    }]);
  }
}, Il = "col", Kc = {
  xs: "<768px",
  sm: "≥768px",
  md: "≥992px",
  lg: "≥1200px",
  xl: "≥1920px"
}, mv = {
  name: Il,
  label: "格子",
  drag: !0,
  dragBtn: !1,
  inside: !0,
  mask: !1,
  rule() {
    return {
      type: Il,
      props: { span: 12 },
      children: []
    };
  },
  props(i, { t }) {
    return Ke(t, Il + ".props", [
      { type: "slider", field: "span", value: 12, props: { min: 0, max: 24 } },
      { type: "slider", field: "offset", props: { min: 0, max: 24 } },
      { type: "slider", field: "push", props: { min: 0, max: 24 } },
      { type: "slider", field: "pull", props: { min: 0, max: 24 } },
      {
        type: "ConfigItem",
        props: {
          label: t("props.reactive")
        },
        children: [
          {
            type: "elTabs",
            style: {
              width: "100%"
            },
            slot: "append",
            children: Object.keys(Kc).map((l) => ({
              type: "elTabPane",
              props: {
                label: Kc[l]
              },
              style: "padding:0 10px;",
              children: [
                {
                  type: "slider",
                  field: l + ">span",
                  title: t("com.col.props.span"),
                  value: 12,
                  props: { min: 0, max: 24 }
                },
                {
                  type: "slider",
                  field: l + ">offset",
                  title: t("com.col.props.offset"),
                  props: { min: 0, max: 24 }
                },
                {
                  type: "slider",
                  field: l + ">push",
                  title: t("com.col.props.push"),
                  props: { min: 0, max: 24 }
                },
                {
                  type: "slider",
                  field: l + ">pull",
                  title: t("com.col.props.pull"),
                  props: { min: 0, max: 24 }
                }
              ]
            }))
          }
        ]
      }
    ]);
  }
}, yv = "分割线", Ll = "elDivider", bv = {
  menu: "aide",
  icon: "icon-divider",
  label: yv,
  name: Ll,
  rule({ t: i }) {
    return {
      type: Ll,
      props: {},
      style: {
        display: "flex"
      },
      children: [i("com.elDivider.name")]
    };
  },
  props(i, { t }) {
    return Ke(t, Ll + ".props", [{
      type: "input",
      field: "formCreateChild"
    }, {
      type: "select",
      field: "contentPosition",
      options: Jt(t, [{ label: "left", value: "left" }, { label: "right", value: "right" }, {
        label: "center",
        value: "center"
      }])
    }]);
  }
}, Av = "级联选择器", Zo = "cascader", xv = {
  menu: "main",
  icon: "icon-cascader",
  label: Av,
  name: Zo,
  event: ["change", "expandChange", "blur", "focus", "visibleChange", "removeTag"],
  validate: ["string", "number", "array"],
  rule({ t: i }) {
    return {
      type: Zo,
      field: Je(),
      title: i("com.cascader.name"),
      info: "",
      effect: {
        fetch: ""
      },
      $required: !1,
      props: {
        options: jr(i("props.option"), { label: "label", value: "value" }, 3)
      }
    };
  },
  props(i, { t }) {
    return Ke(t, Zo + ".props", [
      ws({ t, to: "props.options" }),
      {
        type: "switch",
        field: "disabled"
      },
      {
        type: "switch",
        field: "clearable"
      },
      {
        type: "input",
        field: "placeholder"
      },
      {
        type: "Object",
        field: "props",
        props: {
          rule: Ke(t, Zo + ".propsOpt", [{
            type: "switch",
            field: "multiple"
          }, {
            type: "select",
            field: "expandTrigger",
            options: Jt(t, [{ label: "click", value: "click" }, {
              label: "hover",
              value: "hover"
            }])
          }, {
            type: "switch",
            field: "checkStrictly"
          }, {
            type: "switch",
            field: "emitPath",
            value: !0
          }, {
            type: "input",
            field: "value",
            value: "value"
          }, {
            type: "input",
            field: "label",
            value: "label"
          }, {
            type: "input",
            field: "children",
            value: "children"
          }, {
            type: "input",
            field: "disabled",
            value: "disabled"
          }, { type: "input", field: "leaf" }])
        }
      },
      {
        type: "switch",
        field: "showAllLevels",
        value: !0
      },
      {
        type: "switch",
        field: "collapseTags"
      },
      {
        type: "input",
        field: "separator"
      },
      {
        type: "switch",
        field: "filterable"
      }
    ]);
  }
}, wv = "上传", Fl = "upload", _v = {
  menu: "main",
  icon: "icon-upload",
  label: wv,
  name: Fl,
  event: ["change", "remove"],
  validate: ["array"],
  rule({ t: i }) {
    return {
      type: Fl,
      field: Je(),
      title: i("com.upload.name"),
      info: "",
      $required: !1,
      props: {
        action: "/",
        uploadType: "image",
        onSuccess: new Function("res", "file", "file.url = res.data.url;")
      }
    };
  },
  props(i, { t }) {
    return Ke(t, Fl + ".props", [{
      type: "switch",
      field: "disabled"
    }, {
      type: "select",
      field: "uploadType",
      options: [{ label: t("props.image"), value: "image" }, {
        label: t("props.file"),
        value: "file"
      }]
    }, { type: "switch", field: "multiple" }, {
      type: "input",
      field: "action"
    }, {
      type: "FnInput",
      field: "beforeUpload",
      props: {
        args: ["file"],
        name: "beforeUpload"
      }
    }, {
      type: "FnInput",
      field: "onSuccess",
      info: t("com.upload.info"),
      props: {
        args: ["res", "file"],
        name: "onSuccess",
        button: !0
      }
    }, {
      type: "TableOptions",
      field: "headers",
      props: {
        column: [{ label: t("props.key"), key: "label" }, { label: t("props.value"), key: "value" }],
        valueType: "object"
      }
    }, {
      type: "TableOptions",
      field: "data",
      props: {
        column: [{ label: t("props.key"), key: "label" }, { label: t("props.value"), key: "value" }],
        valueType: "object"
      }
    }, { type: "input", field: "name" }, {
      type: "switch",
      field: "withCredentials"
    }, { type: "input", field: "accept" }, {
      type: "switch",
      field: "autoUpload",
      value: !0
    }, {
      type: "inputNumber",
      field: "limit",
      props: { min: 0 }
    }]);
  }
}, Cv = "穿梭框", Bl = "elTransfer", Sv = {
  menu: "main",
  icon: "icon-transfer",
  label: Cv,
  name: Bl,
  event: ["change", "leftCheckChange", "rightCheckChange"],
  validate: ["string", "number", "array"],
  rule({ t: i }) {
    return {
      type: Bl,
      field: Je(),
      title: i("com.elTransfer.name"),
      info: "",
      $required: !1,
      props: {
        data: jr(i("props.option"), { label: "label", value: "key" }, 1)
      }
    };
  },
  props(i, { t }) {
    return Ke(t, Bl + ".props", [
      ws({ t, to: "props.data", label: "label", value: "key" }),
      { type: "switch", field: "filterable" },
      {
        type: "input",
        field: "filterPlaceholder"
      },
      {
        type: "select",
        field: "targetOrder",
        info: t("com.elTransfer.targetOrderInfo"),
        options: [{ label: "original", value: "original" }, {
          label: "push",
          value: "push"
        }, { label: "unshift", value: "unshift" }]
      },
      {
        type: "TableOptions",
        field: "titles",
        props: {
          column: [{ label: t("props.value"), key: "value" }],
          valueType: "string",
          max: 2
        }
      },
      {
        type: "TableOptions",
        field: "buttonTexts",
        props: {
          column: [{ label: t("props.value"), key: "value" }],
          valueType: "string",
          max: 2
        }
      }
    ]);
  }
}, Ev = "树形控件", Pl = "tree", kv = {
  menu: "main",
  icon: "icon-tree",
  label: Ev,
  name: Pl,
  event: ["nodeClick", "nodeContextmenu", "checkChange", "check", "currentChange", "nodeExpand", "nodeCollapse", "nodeDragStart", "nodeDragEnter", "nodeDragLeave", "nodeDragOver", "nodeDragEnd", "nodeDrop"],
  validate: ["string", "number", "array"],
  rule({ t: i }) {
    return {
      type: Pl,
      field: Je(),
      title: i("com.tree.name"),
      info: "",
      effect: {
        fetch: ""
      },
      $required: !1,
      props: {
        props: {
          label: "label"
        },
        showCheckbox: !0,
        nodeKey: "id",
        data: jr(i("props.option"), { label: "label", value: "id" }, 3)
      }
    };
  },
  props(i, { t }) {
    return Ke(t, Pl + ".props", [
      ws({ t, to: "props.data", label: "label", value: "id" }),
      { type: "input", field: "emptyText" },
      {
        type: "TableOptions",
        field: "props",
        props: {
          column: [{ label: t("props.key"), key: "label" }, { label: t("props.value"), key: "value" }],
          valueType: "object"
        }
      },
      {
        type: "switch",
        field: "renderAfterExpand",
        value: !0
      },
      {
        type: "switch",
        field: "defaultExpandAll"
      },
      {
        type: "switch",
        field: "expandOnClickNode",
        value: !0
      },
      {
        type: "switch",
        field: "checkOnClickNode"
      },
      { type: "switch", field: "autoExpandParent", value: !0 },
      {
        type: "switch",
        field: "checkStrictly"
      },
      { type: "switch", field: "accordion" },
      {
        type: "inputNumber",
        field: "indent"
      },
      {
        type: "input",
        field: "nodeKey"
      }
    ]);
  }
}, Tv = "提示", Hl = "elAlert", Dv = {
  menu: "aide",
  icon: "icon-alert",
  label: Tv,
  name: Hl,
  event: ["close"],
  rule({ t: i }) {
    return {
      type: Hl,
      props: {
        title: i("com.elAlert.name"),
        description: i("com.elAlert.description"),
        type: "success",
        effect: "dark"
      },
      children: []
    };
  },
  props(i, { t }) {
    return Ke(t, Hl + ".props", [{ type: "input", field: "title" }, {
      type: "select",
      field: "type",
      options: [{ label: "success", value: "success" }, { label: "warning", value: "warning" }, {
        label: "info",
        value: "info"
      }, { label: "error", value: "error" }]
    }, { type: "input", field: "description" }, {
      type: "switch",
      field: "closable",
      value: !0
    }, { type: "switch", field: "center", value: !0 }, {
      type: "input",
      field: "closeText"
    }, { type: "switch", field: "showIcon" }, {
      type: "select",
      field: "effect",
      options: [{ label: "light", value: "light" }, { label: "dark", value: "dark" }]
    }]);
  }
}, Mv = "文字", Xc = "text", Nv = {
  menu: "aide",
  icon: "icon-span",
  label: Mv,
  name: Xc,
  rule({ t: i }) {
    return {
      type: "div",
      title: "",
      native: !0,
      style: {
        whiteSpace: "pre-line",
        width: "100%"
      },
      children: [i("com.text.name")]
    };
  },
  watch: {
    formCreateNative({ value: i, rule: t }) {
      i && (t.title = "");
    }
  },
  props(i, { t }) {
    return Ke(t, Xc + ".props", [
      {
        type: "switch",
        field: "formCreateNative",
        props: {
          activeValue: !1,
          inactiveValue: !0
        },
        control: [{ value: !1, rule: ["formCreateTitle"] }]
      },
      {
        type: "input",
        field: "formCreateTitle"
      },
      {
        type: "input",
        field: "formCreateChild",
        props: {
          type: "textarea"
        }
      }
    ]);
  }
}, Ov = "间距", Jc = "space", Rv = {
  menu: "layout",
  icon: "icon-space",
  label: Ov,
  name: Jc,
  rule() {
    return {
      type: "div",
      wrap: {
        show: !1
      },
      native: !0,
      style: {
        width: "100%",
        height: "20px"
      },
      children: []
    };
  },
  props(i, { t }) {
    return [
      {
        type: "object",
        field: "formCreateStyle",
        native: !0,
        props: {
          rule: Ke(t, Jc + ".props", [
            {
              type: "input",
              field: "height",
              title: "height"
            }
          ])
        }
      }
    ];
  }
}, Iv = "按钮", jl = "elButton", Lv = {
  menu: "aide",
  icon: "icon-button",
  label: Iv,
  name: jl,
  mask: !0,
  event: ["click"],
  rule({ t: i }) {
    return {
      type: jl,
      props: {},
      children: [i("com.elButton.name")]
    };
  },
  props(i, { t }) {
    return Ke(t, jl + ".props", [{
      type: "input",
      field: "formCreateChild"
    }, {
      type: "select",
      field: "size",
      options: Jt(t, [{ label: "default", value: "default" }, {
        label: "small",
        value: "small"
      }])
    }, {
      type: "select",
      field: "type",
      options: [{ label: "primary", value: "primary" }, {
        label: "success",
        value: "success"
      }, { label: "warning", value: "warning" }, { label: "danger", value: "danger" }, {
        label: "info",
        value: "info"
      }]
    }, { type: "switch", field: "plain" }, {
      type: "switch",
      field: "round"
    }, { type: "switch", field: "circle" }, {
      type: "switch",
      field: "loading"
    }, { type: "switch", field: "disabled" }]);
  }
}, Fv = "富文本框", $l = "fcEditor", Bv = {
  menu: "main",
  icon: "icon-editor",
  label: Fv,
  name: $l,
  event: ["change"],
  validate: ["string"],
  rule({ t: i }) {
    return {
      type: $l,
      field: Je(),
      title: i("com.fcEditor.name"),
      info: "",
      $required: !1,
      props: {}
    };
  },
  props(i, { t }) {
    return Ke(t, $l + ".props", [{
      type: "switch",
      field: "disabled"
    }]);
  }
}, Pv = "子表单", qc = "group", Hv = {
  menu: "subform",
  icon: "icon-subform",
  label: Pv,
  name: qc,
  inside: !1,
  drag: !0,
  dragBtn: !0,
  mask: !1,
  event: ["change"],
  subForm: "array",
  loadRule(i) {
    i.children = i.props.rule || [], i.type = "FcRow", delete i.props.rule;
  },
  parseRule(i) {
    i.props.rule = i.children, i.type = "group", delete i.children, delete i.props.mode;
  },
  rule({ t: i }) {
    return {
      type: "fcRow",
      field: Je(),
      title: i("com.group.name"),
      info: "",
      $required: !1,
      props: {},
      children: []
    };
  },
  props(i, { t }) {
    return Ke(t, qc + ".props", [
      {
        type: "switch",
        field: "disabled"
      },
      { type: "switch", field: "syncDisabled", value: !0 },
      { type: "switch", field: "button", value: !0 },
      { type: "switch", field: "sortBtn", value: !0 },
      { type: "inputNumber", field: "expand" },
      { type: "inputNumber", field: "min" },
      { type: "inputNumber", field: "max" }
    ]);
  }
}, jv = "分组", Zc = "subForm", $v = {
  menu: "subform",
  icon: "icon-group",
  label: jv,
  name: Zc,
  inside: !1,
  drag: !0,
  dragBtn: !0,
  mask: !1,
  subForm: "object",
  event: ["change"],
  loadRule(i) {
    i.children = i.props.rule || [], i.type = "FcRow", delete i.props.rule;
  },
  parseRule(i) {
    i.props.rule = i.children, i.type = "subForm", delete i.children;
  },
  rule({ t: i }) {
    return {
      type: "fcRow",
      field: Je(),
      title: i("com.subForm.name"),
      info: "",
      $required: !1,
      props: {},
      children: []
    };
  },
  props(i, { t }) {
    return Ke(t, Zc + ".props", [
      {
        type: "switch",
        field: "disabled"
      },
      { type: "switch", field: "syncDisabled", value: !0 }
    ]);
  }
}, zv = "卡片", zl = "elCard", Uv = {
  menu: "layout",
  icon: "icon-card",
  label: zv,
  name: zl,
  drag: !0,
  inside: !1,
  mask: !1,
  rule({ t: i }) {
    return {
      type: zl,
      props: {
        header: i("com.elCard.props.header")
      },
      style: {
        width: "100%"
      },
      children: []
    };
  },
  props(i, { t }) {
    return Ke(t, zl + ".props", [{
      type: "input",
      field: "header"
    }, {
      type: "select",
      field: "shadow",
      value: "always",
      options: Jt(t, [{ label: "always", value: "always" }, { label: "never", value: "never" }, {
        label: "hover",
        value: "hover"
      }])
    }]);
  }
}, Wv = "折叠面板", Ul = "elCollapse", Qv = {
  menu: "layout",
  icon: "icon-collapse",
  label: Wv,
  name: Ul,
  mask: !1,
  children: "elCollapseItem",
  event: ["change"],
  rule() {
    return {
      type: Ul,
      props: {},
      style: {
        width: "100%"
      },
      children: []
    };
  },
  props(i, { t }) {
    return Ke(t, Ul + ".props", [{
      type: "switch",
      field: "accordion"
    }]);
  }
}, Vv = "面板", Wl = "elCollapseItem", Gv = {
  icon: "icon-cell",
  label: Vv,
  name: Wl,
  drag: !0,
  dragBtn: !1,
  inside: !0,
  mask: !1,
  rule({ t: i }) {
    return {
      type: Wl,
      props: {
        title: i("com.elCollapseItem.name")
      },
      style: {},
      children: []
    };
  },
  props(i, { t }) {
    return Ke(t, Wl + ".props", [{
      type: "input",
      field: "title"
    }, {
      type: "input",
      field: "name"
    }, {
      type: "switch",
      field: "disabled"
    }]);
  }
}, Yv = "标签", Ql = "elTag", Kv = {
  menu: "aide",
  icon: "icon-tag",
  label: Yv,
  name: Ql,
  mask: !0,
  event: ["click", "close"],
  rule({ t: i }) {
    return {
      type: Ql,
      title: "",
      native: !0,
      children: [i("com.elTag.name")]
    };
  },
  watch: {
    formCreateNative({ value: i, rule: t }) {
      i && (t.title = "");
    }
  },
  props(i, { t }) {
    return Ke(t, Ql + ".props", [
      {
        type: "switch",
        field: "formCreateNative",
        props: {
          activeValue: !1,
          inactiveValue: !0
        },
        control: [{ value: !1, rule: ["formCreateTitle"] }]
      },
      {
        type: "input",
        field: "formCreateTitle"
      },
      {
        type: "input",
        field: "formCreateChild"
      },
      {
        type: "select",
        field: "type",
        options: [{ label: "primary", value: "primary" }, {
          label: "success",
          value: "success"
        }, { label: "warning", value: "warning" }, { label: "danger", value: "danger" }, {
          label: "info",
          value: "info"
        }]
      },
      {
        type: "select",
        field: "size",
        options: Jt(t, [{
          label: "default",
          value: "default"
        }, { label: "small", value: "small" }])
      },
      {
        type: "select",
        field: "effect",
        options: [{ label: "dark", value: "dark" }, {
          label: "light",
          value: "light"
        }, { label: "plain", value: "plain" }]
      },
      {
        type: "switch",
        field: "closable"
      },
      {
        type: "switch",
        field: "disableTransitions"
      },
      {
        type: "switch",
        field: "hit"
      },
      {
        type: "ColorPicker",
        field: "color"
      }
    ]);
  }
}, Xv = "HTML", Vl = "html", Jv = {
  menu: "aide",
  icon: "icon-html",
  label: Xv,
  name: Vl,
  rule() {
    return {
      type: Vl,
      title: "",
      native: !0,
      attrs: {
        innerHTML: ""
      },
      style: {
        display: "block",
        width: "100%"
      },
      children: [`<div style="color:blue;">
 html html html html html html html html html
  </div>`]
    };
  },
  watch: {
    formCreateNative({ value: i, rule: t }) {
      i && (t.title = "");
    }
  },
  props(i, { t }) {
    return Ke(t, Vl + ".props", [
      {
        type: "switch",
        field: "formCreateNative",
        props: {
          activeValue: !1,
          inactiveValue: !0
        },
        control: [{ value: !1, rule: ["formCreateTitle"] }]
      },
      {
        type: "input",
        field: "formCreateTitle"
      },
      {
        type: "HtmlEditor",
        field: "formCreateChild"
      }
    ]);
  }
}, qv = "表格布局", Gl = "fcTable", Zv = {
  menu: "layout",
  icon: "icon-table",
  label: qv,
  name: Gl,
  inside: !1,
  mask: !1,
  rule() {
    return {
      type: Gl,
      props: {
        rule: {
          row: 3,
          col: 4,
          style: {},
          class: {},
          layout: []
        }
      },
      children: []
    };
  },
  props(i, { t }) {
    return Ke(t, Gl + ".props", [
      { type: "switch", field: "border", value: !0 },
      { type: "ColorPicker", field: "borderColor" },
      { type: "input", field: "borderWidth" }
    ]);
  }
}, eg = [
  zh,
  Wh,
  Vh,
  Yh,
  Ph,
  jh,
  Xh,
  qh,
  dv,
  nv,
  ov,
  ev,
  lv,
  cv,
  hv,
  xv,
  _v,
  Sv,
  kv,
  Bv,
  Hv,
  $v,
  Dv,
  Lv,
  Nv,
  Jv,
  bv,
  Kv,
  gv,
  Zv,
  Rv,
  Uv,
  Qv,
  mv,
  Gv
];
function tg(i) {
  return {
    icon: i.field ? "icon-input" : "icon-cell",
    label: i.field || i.type,
    name: "_",
    mask: !0,
    handleBtn: ["delete"],
    rule() {
      return i;
    },
    props() {
      return [];
    }
  };
}
/**!
 * Sortable 1.10.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function sa(i) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? sa = function(t) {
    return typeof t;
  } : sa = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, sa(i);
}
function ng(i, t, l) {
  return t in i ? Object.defineProperty(i, t, {
    value: l,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : i[t] = l, i;
}
function Cn() {
  return Cn = Object.assign || function(i) {
    for (var t = 1; t < arguments.length; t++) {
      var l = arguments[t];
      for (var c in l)
        Object.prototype.hasOwnProperty.call(l, c) && (i[c] = l[c]);
    }
    return i;
  }, Cn.apply(this, arguments);
}
function xr(i) {
  for (var t = 1; t < arguments.length; t++) {
    var l = arguments[t] != null ? arguments[t] : {}, c = Object.keys(l);
    typeof Object.getOwnPropertySymbols == "function" && (c = c.concat(Object.getOwnPropertySymbols(l).filter(function(M) {
      return Object.getOwnPropertyDescriptor(l, M).enumerable;
    }))), c.forEach(function(M) {
      ng(i, M, l[M]);
    });
  }
  return i;
}
function rg(i, t) {
  if (i == null) return {};
  var l = {}, c = Object.keys(i), M, T;
  for (T = 0; T < c.length; T++)
    M = c[T], !(t.indexOf(M) >= 0) && (l[M] = i[M]);
  return l;
}
function ig(i, t) {
  if (i == null) return {};
  var l = rg(i, t), c, M;
  if (Object.getOwnPropertySymbols) {
    var T = Object.getOwnPropertySymbols(i);
    for (M = 0; M < T.length; M++)
      c = T[M], !(t.indexOf(c) >= 0) && Object.prototype.propertyIsEnumerable.call(i, c) && (l[c] = i[c]);
  }
  return l;
}
function og(i) {
  return ag(i) || lg(i) || sg();
}
function ag(i) {
  if (Array.isArray(i)) {
    for (var t = 0, l = new Array(i.length); t < i.length; t++) l[t] = i[t];
    return l;
  }
}
function lg(i) {
  if (Symbol.iterator in Object(i) || Object.prototype.toString.call(i) === "[object Arguments]") return Array.from(i);
}
function sg() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
var ug = "1.10.2";
function Zn(i) {
  if (typeof window != "undefined" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(i);
}
var er = Zn(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), vo = Zn(/Edge/i), ef = Zn(/firefox/i), hs = Zn(/safari/i) && !Zn(/chrome/i) && !Zn(/android/i), Bf = Zn(/iP(ad|od|hone)/i), cg = Zn(/chrome/i) && Zn(/android/i), Pf = {
  capture: !1,
  passive: !1
};
function Xe(i, t, l) {
  i.addEventListener(t, l, !er && Pf);
}
function Ge(i, t, l) {
  i.removeEventListener(t, l, !er && Pf);
}
function pa(i, t) {
  if (t) {
    if (t[0] === ">" && (t = t.substring(1)), i)
      try {
        if (i.matches)
          return i.matches(t);
        if (i.msMatchesSelector)
          return i.msMatchesSelector(t);
        if (i.webkitMatchesSelector)
          return i.webkitMatchesSelector(t);
      } catch (l) {
        return !1;
      }
    return !1;
  }
}
function fg(i) {
  return i.host && i !== document && i.host.nodeType ? i.host : i.parentNode;
}
function Nn(i, t, l, c) {
  if (i) {
    l = l || document;
    do {
      if (t != null && (t[0] === ">" ? i.parentNode === l && pa(i, t) : pa(i, t)) || c && i === l)
        return i;
      if (i === l) break;
    } while (i = fg(i));
  }
  return null;
}
var tf = /\s+/g;
function bt(i, t, l) {
  if (i && t)
    if (i.classList)
      i.classList[l ? "add" : "remove"](t);
    else {
      var c = (" " + i.className + " ").replace(tf, " ").replace(" " + t + " ", " ");
      i.className = (c + (l ? " " + t : "")).replace(tf, " ");
    }
}
function Me(i, t, l) {
  var c = i && i.style;
  if (c) {
    if (l === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? l = document.defaultView.getComputedStyle(i, "") : i.currentStyle && (l = i.currentStyle), t === void 0 ? l : l[t];
    !(t in c) && t.indexOf("webkit") === -1 && (t = "-webkit-" + t), c[t] = l + (typeof l == "string" ? "" : "px");
  }
}
function Hr(i, t) {
  var l = "";
  if (typeof i == "string")
    l = i;
  else
    do {
      var c = Me(i, "transform");
      c && c !== "none" && (l = c + " " + l);
    } while (!t && (i = i.parentNode));
  var M = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return M && new M(l);
}
function Hf(i, t, l) {
  if (i) {
    var c = i.getElementsByTagName(t), M = 0, T = c.length;
    if (l)
      for (; M < T; M++)
        l(c[M], M);
    return c;
  }
  return [];
}
function Wn() {
  var i = document.scrollingElement;
  return i || document.documentElement;
}
function _t(i, t, l, c, M) {
  if (!(!i.getBoundingClientRect && i !== window)) {
    var T, F, z, W, K, q, m;
    if (i !== window && i !== Wn() ? (T = i.getBoundingClientRect(), F = T.top, z = T.left, W = T.bottom, K = T.right, q = T.height, m = T.width) : (F = 0, z = 0, W = window.innerHeight, K = window.innerWidth, q = window.innerHeight, m = window.innerWidth), (t || l) && i !== window && (M = M || i.parentNode, !er))
      do
        if (M && M.getBoundingClientRect && (Me(M, "transform") !== "none" || l && Me(M, "position") !== "static")) {
          var d = M.getBoundingClientRect();
          F -= d.top + parseInt(Me(M, "border-top-width")), z -= d.left + parseInt(Me(M, "border-left-width")), W = F + T.height, K = z + T.width;
          break;
        }
      while (M = M.parentNode);
    if (c && i !== window) {
      var r = Hr(M || i), u = r && r.a, v = r && r.d;
      r && (F /= v, z /= u, m /= u, q /= v, W = F + q, K = z + m);
    }
    return {
      top: F,
      left: z,
      bottom: W,
      right: K,
      width: m,
      height: q
    };
  }
}
function nf(i, t, l) {
  for (var c = br(i, !0), M = _t(i)[t]; c; ) {
    var T = _t(c)[l], F = void 0;
    if (F = M >= T, !F) return c;
    if (c === Wn()) break;
    c = br(c, !1);
  }
  return !1;
}
function ha(i, t, l) {
  for (var c = 0, M = 0, T = i.children; M < T.length; ) {
    if (T[M].style.display !== "none" && T[M] !== Fe.ghost && T[M] !== Fe.dragged && Nn(T[M], l.draggable, i, !1)) {
      if (c === t)
        return T[M];
      c++;
    }
    M++;
  }
  return null;
}
function _s(i, t) {
  for (var l = i.lastElementChild; l && (l === Fe.ghost || Me(l, "display") === "none" || t && !pa(l, t)); )
    l = l.previousElementSibling;
  return l || null;
}
function wt(i, t) {
  var l = 0;
  if (!i || !i.parentNode)
    return -1;
  for (; i = i.previousElementSibling; )
    i.nodeName.toUpperCase() !== "TEMPLATE" && i !== Fe.clone && (!t || pa(i, t)) && l++;
  return l;
}
function rf(i) {
  var t = 0, l = 0, c = Wn();
  if (i)
    do {
      var M = Hr(i), T = M.a, F = M.d;
      t += i.scrollLeft * T, l += i.scrollTop * F;
    } while (i !== c && (i = i.parentNode));
  return [t, l];
}
function dg(i, t) {
  for (var l in i)
    if (i.hasOwnProperty(l)) {
      for (var c in t)
        if (t.hasOwnProperty(c) && t[c] === i[l][c]) return Number(l);
    }
  return -1;
}
function br(i, t) {
  if (!i || !i.getBoundingClientRect) return Wn();
  var l = i, c = !1;
  do
    if (l.clientWidth < l.scrollWidth || l.clientHeight < l.scrollHeight) {
      var M = Me(l);
      if (l.clientWidth < l.scrollWidth && (M.overflowX == "auto" || M.overflowX == "scroll") || l.clientHeight < l.scrollHeight && (M.overflowY == "auto" || M.overflowY == "scroll")) {
        if (!l.getBoundingClientRect || l === document.body) return Wn();
        if (c || t) return l;
        c = !0;
      }
    }
  while (l = l.parentNode);
  return Wn();
}
function pg(i, t) {
  if (i && t)
    for (var l in t)
      t.hasOwnProperty(l) && (i[l] = t[l]);
  return i;
}
function Yl(i, t) {
  return Math.round(i.top) === Math.round(t.top) && Math.round(i.left) === Math.round(t.left) && Math.round(i.height) === Math.round(t.height) && Math.round(i.width) === Math.round(t.width);
}
var lo;
function jf(i, t) {
  return function() {
    if (!lo) {
      var l = arguments, c = this;
      l.length === 1 ? i.call(c, l[0]) : i.apply(c, l), lo = setTimeout(function() {
        lo = void 0;
      }, t);
    }
  };
}
function hg() {
  clearTimeout(lo), lo = void 0;
}
function $f(i, t, l) {
  i.scrollLeft += t, i.scrollTop += l;
}
function Cs(i) {
  var t = window.Polymer, l = window.jQuery || window.Zepto;
  return t && t.dom ? t.dom(i).cloneNode(!0) : l ? l(i).clone(!0)[0] : i.cloneNode(!0);
}
function of(i, t) {
  Me(i, "position", "absolute"), Me(i, "top", t.top), Me(i, "left", t.left), Me(i, "width", t.width), Me(i, "height", t.height);
}
function Kl(i) {
  Me(i, "position", ""), Me(i, "top", ""), Me(i, "left", ""), Me(i, "width", ""), Me(i, "height", "");
}
var Xt = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function vg() {
  var i = [], t;
  return {
    captureAnimationState: function() {
      if (i = [], !!this.options.animation) {
        var c = [].slice.call(this.el.children);
        c.forEach(function(M) {
          if (!(Me(M, "display") === "none" || M === Fe.ghost)) {
            i.push({
              target: M,
              rect: _t(M)
            });
            var T = xr({}, i[i.length - 1].rect);
            if (M.thisAnimationDuration) {
              var F = Hr(M, !0);
              F && (T.top -= F.f, T.left -= F.e);
            }
            M.fromRect = T;
          }
        });
      }
    },
    addAnimationState: function(c) {
      i.push(c);
    },
    removeAnimationState: function(c) {
      i.splice(dg(i, {
        target: c
      }), 1);
    },
    animateAll: function(c) {
      var M = this;
      if (!this.options.animation) {
        clearTimeout(t), typeof c == "function" && c();
        return;
      }
      var T = !1, F = 0;
      i.forEach(function(z) {
        var W = 0, K = z.target, q = K.fromRect, m = _t(K), d = K.prevFromRect, r = K.prevToRect, u = z.rect, v = Hr(K, !0);
        v && (m.top -= v.f, m.left -= v.e), K.toRect = m, K.thisAnimationDuration && Yl(d, m) && !Yl(q, m) && // Make sure animatingRect is on line between toRect & fromRect
        (u.top - m.top) / (u.left - m.left) === (q.top - m.top) / (q.left - m.left) && (W = mg(u, d, r, M.options)), Yl(m, q) || (K.prevFromRect = q, K.prevToRect = m, W || (W = M.options.animation), M.animate(K, u, m, W)), W && (T = !0, F = Math.max(F, W), clearTimeout(K.animationResetTimer), K.animationResetTimer = setTimeout(function() {
          K.animationTime = 0, K.prevFromRect = null, K.fromRect = null, K.prevToRect = null, K.thisAnimationDuration = null;
        }, W), K.thisAnimationDuration = W);
      }), clearTimeout(t), T ? t = setTimeout(function() {
        typeof c == "function" && c();
      }, F) : typeof c == "function" && c(), i = [];
    },
    animate: function(c, M, T, F) {
      if (F) {
        Me(c, "transition", ""), Me(c, "transform", "");
        var z = Hr(this.el), W = z && z.a, K = z && z.d, q = (M.left - T.left) / (W || 1), m = (M.top - T.top) / (K || 1);
        c.animatingX = !!q, c.animatingY = !!m, Me(c, "transform", "translate3d(" + q + "px," + m + "px,0)"), gg(c), Me(c, "transition", "transform " + F + "ms" + (this.options.easing ? " " + this.options.easing : "")), Me(c, "transform", "translate3d(0,0,0)"), typeof c.animated == "number" && clearTimeout(c.animated), c.animated = setTimeout(function() {
          Me(c, "transition", ""), Me(c, "transform", ""), c.animated = !1, c.animatingX = !1, c.animatingY = !1;
        }, F);
      }
    }
  };
}
function gg(i) {
  return i.offsetWidth;
}
function mg(i, t, l, c) {
  return Math.sqrt(Math.pow(t.top - i.top, 2) + Math.pow(t.left - i.left, 2)) / Math.sqrt(Math.pow(t.top - l.top, 2) + Math.pow(t.left - l.left, 2)) * c.animation;
}
var qi = [], Xl = {
  initializeByDefault: !0
}, go = {
  mount: function(t) {
    for (var l in Xl)
      Xl.hasOwnProperty(l) && !(l in t) && (t[l] = Xl[l]);
    qi.push(t);
  },
  pluginEvent: function(t, l, c) {
    var M = this;
    this.eventCanceled = !1, c.cancel = function() {
      M.eventCanceled = !0;
    };
    var T = t + "Global";
    qi.forEach(function(F) {
      l[F.pluginName] && (l[F.pluginName][T] && l[F.pluginName][T](xr({
        sortable: l
      }, c)), l.options[F.pluginName] && l[F.pluginName][t] && l[F.pluginName][t](xr({
        sortable: l
      }, c)));
    });
  },
  initializePlugins: function(t, l, c, M) {
    qi.forEach(function(z) {
      var W = z.pluginName;
      if (!(!t.options[W] && !z.initializeByDefault)) {
        var K = new z(t, l, t.options);
        K.sortable = t, K.options = t.options, t[W] = K, Cn(c, K.defaults);
      }
    });
    for (var T in t.options)
      if (t.options.hasOwnProperty(T)) {
        var F = this.modifyOption(t, T, t.options[T]);
        typeof F != "undefined" && (t.options[T] = F);
      }
  },
  getEventProperties: function(t, l) {
    var c = {};
    return qi.forEach(function(M) {
      typeof M.eventProperties == "function" && Cn(c, M.eventProperties.call(l[M.pluginName], t));
    }), c;
  },
  modifyOption: function(t, l, c) {
    var M;
    return qi.forEach(function(T) {
      t[T.pluginName] && T.optionListeners && typeof T.optionListeners[l] == "function" && (M = T.optionListeners[l].call(t[T.pluginName], c));
    }), M;
  }
};
function no(i) {
  var t = i.sortable, l = i.rootEl, c = i.name, M = i.targetEl, T = i.cloneEl, F = i.toEl, z = i.fromEl, W = i.oldIndex, K = i.newIndex, q = i.oldDraggableIndex, m = i.newDraggableIndex, d = i.originalEvent, r = i.putSortable, u = i.extraEventProperties;
  if (t = t || l && l[Xt], !!t) {
    var v, C = t.options, p = "on" + c.charAt(0).toUpperCase() + c.substr(1);
    window.CustomEvent && !er && !vo ? v = new CustomEvent(c, {
      bubbles: !0,
      cancelable: !0
    }) : (v = document.createEvent("Event"), v.initEvent(c, !0, !0)), v.to = F || l, v.from = z || l, v.item = M || l, v.clone = T, v.oldIndex = W, v.newIndex = K, v.oldDraggableIndex = q, v.newDraggableIndex = m, v.originalEvent = d, v.pullMode = r ? r.lastPutMode : void 0;
    var b = xr({}, u, go.getEventProperties(c, t));
    for (var x in b)
      v[x] = b[x];
    l && l.dispatchEvent(v), C[p] && C[p].call(t, v);
  }
}
var dn = function(t, l) {
  var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, M = c.evt, T = ig(c, ["evt"]);
  go.pluginEvent.bind(Fe)(t, l, xr({
    dragEl: Ce,
    parentEl: Dt,
    ghostEl: Qe,
    rootEl: yt,
    nextEl: Br,
    lastDownEl: ua,
    cloneEl: xt,
    cloneHidden: mr,
    dragStarted: ro,
    putSortable: Qt,
    activeSortable: Fe.active,
    originalEvent: M,
    oldIndex: vi,
    oldDraggableIndex: so,
    newIndex: bn,
    newDraggableIndex: gr,
    hideGhostForTarget: Qf,
    unhideGhostForTarget: Vf,
    cloneNowHidden: function() {
      mr = !0;
    },
    cloneNowShown: function() {
      mr = !1;
    },
    dispatchSortableEvent: function(z) {
      an({
        sortable: l,
        name: z,
        originalEvent: M
      });
    }
  }, T));
};
function an(i) {
  no(xr({
    putSortable: Qt,
    cloneEl: xt,
    targetEl: Ce,
    rootEl: yt,
    oldIndex: vi,
    oldDraggableIndex: so,
    newIndex: bn,
    newDraggableIndex: gr
  }, i));
}
var Ce, Dt, Qe, yt, Br, ua, xt, mr, vi, bn, so, gr, ea, Qt, pi = !1, va = !1, ga = [], Ir, Dn, Jl, ql, af, lf, ro, ci, uo, co = !1, ta = !1, ca, Kt, Zl = [], vs = !1, ma = [], xa = typeof document != "undefined", na = Bf, sf = vo || er ? "cssFloat" : "float", yg = xa && !cg && !Bf && "draggable" in document.createElement("div"), zf = function() {
  if (xa) {
    if (er)
      return !1;
    var i = document.createElement("x");
    return i.style.cssText = "pointer-events:auto", i.style.pointerEvents === "auto";
  }
}(), Uf = function(t, l) {
  var c = Me(t), M = parseInt(c.width) - parseInt(c.paddingLeft) - parseInt(c.paddingRight) - parseInt(c.borderLeftWidth) - parseInt(c.borderRightWidth), T = ha(t, 0, l), F = ha(t, 1, l), z = T && Me(T), W = F && Me(F), K = z && parseInt(z.marginLeft) + parseInt(z.marginRight) + _t(T).width, q = W && parseInt(W.marginLeft) + parseInt(W.marginRight) + _t(F).width;
  if (c.display === "flex")
    return c.flexDirection === "column" || c.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (c.display === "grid")
    return c.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (T && z.float && z.float !== "none") {
    var m = z.float === "left" ? "left" : "right";
    return F && (W.clear === "both" || W.clear === m) ? "vertical" : "horizontal";
  }
  return T && (z.display === "block" || z.display === "flex" || z.display === "table" || z.display === "grid" || K >= M && c[sf] === "none" || F && c[sf] === "none" && K + q > M) ? "vertical" : "horizontal";
}, bg = function(t, l, c) {
  var M = c ? t.left : t.top, T = c ? t.right : t.bottom, F = c ? t.width : t.height, z = c ? l.left : l.top, W = c ? l.right : l.bottom, K = c ? l.width : l.height;
  return M === z || T === W || M + F / 2 === z + K / 2;
}, Ag = function(t, l) {
  var c;
  return ga.some(function(M) {
    if (!_s(M)) {
      var T = _t(M), F = M[Xt].options.emptyInsertThreshold, z = t >= T.left - F && t <= T.right + F, W = l >= T.top - F && l <= T.bottom + F;
      if (F && z && W)
        return c = M;
    }
  }), c;
}, Wf = function(t) {
  function l(T, F) {
    return function(z, W, K, q) {
      var m = z.options.group.name && W.options.group.name && z.options.group.name === W.options.group.name;
      if (T == null && (F || m))
        return !0;
      if (T == null || T === !1)
        return !1;
      if (F && T === "clone")
        return T;
      if (typeof T == "function")
        return l(T(z, W, K, q), F)(z, W, K, q);
      var d = (F ? z : W).options.group.name;
      return T === !0 || typeof T == "string" && T === d || T.join && T.indexOf(d) > -1;
    };
  }
  var c = {}, M = t.group;
  (!M || sa(M) != "object") && (M = {
    name: M
  }), c.name = M.name, c.checkPull = l(M.pull, !0), c.checkPut = l(M.put), c.revertClone = M.revertClone, t.group = c;
}, Qf = function() {
  !zf && Qe && Me(Qe, "display", "none");
}, Vf = function() {
  !zf && Qe && Me(Qe, "display", "");
};
xa && document.addEventListener("click", function(i) {
  if (va)
    return i.preventDefault(), i.stopPropagation && i.stopPropagation(), i.stopImmediatePropagation && i.stopImmediatePropagation(), va = !1, !1;
}, !0);
var Lr = function(t) {
  if (Ce) {
    t = t.touches ? t.touches[0] : t;
    var l = Ag(t.clientX, t.clientY);
    if (l) {
      var c = {};
      for (var M in t)
        t.hasOwnProperty(M) && (c[M] = t[M]);
      c.target = c.rootEl = l, c.preventDefault = void 0, c.stopPropagation = void 0, l[Xt]._onDragOver(c);
    }
  }
}, xg = function(t) {
  Ce && Ce.parentNode[Xt]._isOutsideThisEl(t.target);
};
function Fe(i, t) {
  if (!(i && i.nodeType && i.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(i));
  this.el = i, this.options = t = Cn({}, t), i[Xt] = this;
  var l = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(i.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: !1,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: !0,
    direction: function() {
      return Uf(i, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function(F, z) {
      F.setData("Text", z.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Fe.supportPointer !== !1 && "PointerEvent" in window,
    emptyInsertThreshold: 5
  };
  go.initializePlugins(this, i, l);
  for (var c in l)
    !(c in t) && (t[c] = l[c]);
  Wf(t);
  for (var M in this)
    M.charAt(0) === "_" && typeof this[M] == "function" && (this[M] = this[M].bind(this));
  this.nativeDraggable = t.forceFallback ? !1 : yg, this.nativeDraggable && (this.options.touchStartThreshold = 1), t.supportPointer ? Xe(i, "pointerdown", this._onTapStart) : (Xe(i, "mousedown", this._onTapStart), Xe(i, "touchstart", this._onTapStart)), this.nativeDraggable && (Xe(i, "dragover", this), Xe(i, "dragenter", this)), ga.push(this.el), t.store && t.store.get && this.sort(t.store.get(this) || []), Cn(this, vg());
}
Fe.prototype = /** @lends Sortable.prototype */
{
  constructor: Fe,
  _isOutsideThisEl: function(t) {
    !this.el.contains(t) && t !== this.el && (ci = null);
  },
  _getDirection: function(t, l) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, t, l, Ce) : this.options.direction;
  },
  _onTapStart: function(t) {
    if (t.cancelable) {
      var l = this, c = this.el, M = this.options, T = M.preventOnFilter, F = t.type, z = t.touches && t.touches[0] || t.pointerType && t.pointerType === "touch" && t, W = (z || t).target, K = t.target.shadowRoot && (t.path && t.path[0] || t.composedPath && t.composedPath()[0]) || W, q = M.filter;
      if (Tg(c), !Ce && !(/mousedown|pointerdown/.test(F) && t.button !== 0 || M.disabled) && !K.isContentEditable && (W = Nn(W, M.draggable, c, !1), !(W && W.animated) && ua !== W)) {
        if (vi = wt(W), so = wt(W, M.draggable), typeof q == "function") {
          if (q.call(this, t, W, this)) {
            an({
              sortable: l,
              rootEl: K,
              name: "filter",
              targetEl: W,
              toEl: c,
              fromEl: c
            }), dn("filter", l, {
              evt: t
            }), T && t.cancelable && t.preventDefault();
            return;
          }
        } else if (q && (q = q.split(",").some(function(m) {
          if (m = Nn(K, m.trim(), c, !1), m)
            return an({
              sortable: l,
              rootEl: m,
              name: "filter",
              targetEl: W,
              fromEl: c,
              toEl: c
            }), dn("filter", l, {
              evt: t
            }), !0;
        }), q)) {
          T && t.cancelable && t.preventDefault();
          return;
        }
        M.handle && !Nn(K, M.handle, c, !1) || this._prepareDragStart(t, z, W);
      }
    }
  },
  _prepareDragStart: function(t, l, c) {
    var M = this, T = M.el, F = M.options, z = T.ownerDocument, W;
    if (c && !Ce && c.parentNode === T) {
      var K = _t(c);
      if (yt = T, Ce = c, Dt = Ce.parentNode, Br = Ce.nextSibling, ua = c, ea = F.group, Fe.dragged = Ce, Ir = {
        target: Ce,
        clientX: (l || t).clientX,
        clientY: (l || t).clientY
      }, af = Ir.clientX - K.left, lf = Ir.clientY - K.top, this._lastX = (l || t).clientX, this._lastY = (l || t).clientY, Ce.style["will-change"] = "all", W = function() {
        if (dn("delayEnded", M, {
          evt: t
        }), Fe.eventCanceled) {
          M._onDrop();
          return;
        }
        M._disableDelayedDragEvents(), !ef && M.nativeDraggable && (Ce.draggable = !0), M._triggerDragStart(t, l), an({
          sortable: M,
          name: "choose",
          originalEvent: t
        }), bt(Ce, F.chosenClass, !0);
      }, F.ignore.split(",").forEach(function(q) {
        Hf(Ce, q.trim(), ts);
      }), Xe(z, "dragover", Lr), Xe(z, "mousemove", Lr), Xe(z, "touchmove", Lr), Xe(z, "mouseup", M._onDrop), Xe(z, "touchend", M._onDrop), Xe(z, "touchcancel", M._onDrop), ef && this.nativeDraggable && (this.options.touchStartThreshold = 4, Ce.draggable = !0), dn("delayStart", this, {
        evt: t
      }), F.delay && (!F.delayOnTouchOnly || l) && (!this.nativeDraggable || !(vo || er))) {
        if (Fe.eventCanceled) {
          this._onDrop();
          return;
        }
        Xe(z, "mouseup", M._disableDelayedDrag), Xe(z, "touchend", M._disableDelayedDrag), Xe(z, "touchcancel", M._disableDelayedDrag), Xe(z, "mousemove", M._delayedDragTouchMoveHandler), Xe(z, "touchmove", M._delayedDragTouchMoveHandler), F.supportPointer && Xe(z, "pointermove", M._delayedDragTouchMoveHandler), M._dragStartTimer = setTimeout(W, F.delay);
      } else
        W();
    }
  },
  _delayedDragTouchMoveHandler: function(t) {
    var l = t.touches ? t.touches[0] : t;
    Math.max(Math.abs(l.clientX - this._lastX), Math.abs(l.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    Ce && ts(Ce), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var t = this.el.ownerDocument;
    Ge(t, "mouseup", this._disableDelayedDrag), Ge(t, "touchend", this._disableDelayedDrag), Ge(t, "touchcancel", this._disableDelayedDrag), Ge(t, "mousemove", this._delayedDragTouchMoveHandler), Ge(t, "touchmove", this._delayedDragTouchMoveHandler), Ge(t, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(t, l) {
    l = l || t.pointerType == "touch" && t, !this.nativeDraggable || l ? this.options.supportPointer ? Xe(document, "pointermove", this._onTouchMove) : l ? Xe(document, "touchmove", this._onTouchMove) : Xe(document, "mousemove", this._onTouchMove) : (Xe(Ce, "dragend", this), Xe(yt, "dragstart", this._onDragStart));
    try {
      document.selection ? fa(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch (c) {
    }
  },
  _dragStarted: function(t, l) {
    if (pi = !1, yt && Ce) {
      dn("dragStarted", this, {
        evt: l
      }), this.nativeDraggable && Xe(document, "dragover", xg);
      var c = this.options;
      !t && bt(Ce, c.dragClass, !1), bt(Ce, c.ghostClass, !0), Fe.active = this, t && this._appendGhost(), an({
        sortable: this,
        name: "start",
        originalEvent: l
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (Dn) {
      this._lastX = Dn.clientX, this._lastY = Dn.clientY, Qf();
      for (var t = document.elementFromPoint(Dn.clientX, Dn.clientY), l = t; t && t.shadowRoot && (t = t.shadowRoot.elementFromPoint(Dn.clientX, Dn.clientY), t !== l); )
        l = t;
      if (Ce.parentNode[Xt]._isOutsideThisEl(t), l)
        do {
          if (l[Xt]) {
            var c = void 0;
            if (c = l[Xt]._onDragOver({
              clientX: Dn.clientX,
              clientY: Dn.clientY,
              target: t,
              rootEl: l
            }), c && !this.options.dragoverBubble)
              break;
          }
          t = l;
        } while (l = l.parentNode);
      Vf();
    }
  },
  _onTouchMove: function(t) {
    if (Ir) {
      var l = this.options, c = l.fallbackTolerance, M = l.fallbackOffset, T = t.touches ? t.touches[0] : t, F = Qe && Hr(Qe, !0), z = Qe && F && F.a, W = Qe && F && F.d, K = na && Kt && rf(Kt), q = (T.clientX - Ir.clientX + M.x) / (z || 1) + (K ? K[0] - Zl[0] : 0) / (z || 1), m = (T.clientY - Ir.clientY + M.y) / (W || 1) + (K ? K[1] - Zl[1] : 0) / (W || 1);
      if (!Fe.active && !pi) {
        if (c && Math.max(Math.abs(T.clientX - this._lastX), Math.abs(T.clientY - this._lastY)) < c)
          return;
        this._onDragStart(t, !0);
      }
      if (Qe) {
        F ? (F.e += q - (Jl || 0), F.f += m - (ql || 0)) : F = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: q,
          f: m
        };
        var d = "matrix(".concat(F.a, ",").concat(F.b, ",").concat(F.c, ",").concat(F.d, ",").concat(F.e, ",").concat(F.f, ")");
        Me(Qe, "webkitTransform", d), Me(Qe, "mozTransform", d), Me(Qe, "msTransform", d), Me(Qe, "transform", d), Jl = q, ql = m, Dn = T;
      }
      t.cancelable && t.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!Qe) {
      var t = this.options.fallbackOnBody ? document.body : yt, l = _t(Ce, !0, na, !0, t), c = this.options;
      if (na) {
        for (Kt = t; Me(Kt, "position") === "static" && Me(Kt, "transform") === "none" && Kt !== document; )
          Kt = Kt.parentNode;
        Kt !== document.body && Kt !== document.documentElement ? (Kt === document && (Kt = Wn()), l.top += Kt.scrollTop, l.left += Kt.scrollLeft) : Kt = Wn(), Zl = rf(Kt);
      }
      Qe = Ce.cloneNode(!0), bt(Qe, c.ghostClass, !1), bt(Qe, c.fallbackClass, !0), bt(Qe, c.dragClass, !0), Me(Qe, "transition", ""), Me(Qe, "transform", ""), Me(Qe, "box-sizing", "border-box"), Me(Qe, "margin", 0), Me(Qe, "top", l.top), Me(Qe, "left", l.left), Me(Qe, "width", l.width), Me(Qe, "height", l.height), Me(Qe, "opacity", "0.8"), Me(Qe, "position", na ? "absolute" : "fixed"), Me(Qe, "zIndex", "100000"), Me(Qe, "pointerEvents", "none"), Fe.ghost = Qe, t.appendChild(Qe), Me(Qe, "transform-origin", af / parseInt(Qe.style.width) * 100 + "% " + lf / parseInt(Qe.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(t, l) {
    var c = this, M = t.dataTransfer, T = c.options;
    if (dn("dragStart", this, {
      evt: t
    }), Fe.eventCanceled) {
      this._onDrop();
      return;
    }
    dn("setupClone", this), Fe.eventCanceled || (xt = Cs(Ce), xt.draggable = !1, xt.style["will-change"] = "", this._hideClone(), bt(xt, this.options.chosenClass, !1), Fe.clone = xt), c.cloneId = fa(function() {
      dn("clone", c), !Fe.eventCanceled && (c.options.removeCloneOnHide || yt.insertBefore(xt, Ce), c._hideClone(), an({
        sortable: c,
        name: "clone"
      }));
    }), !l && bt(Ce, T.dragClass, !0), l ? (va = !0, c._loopId = setInterval(c._emulateDragOver, 50)) : (Ge(document, "mouseup", c._onDrop), Ge(document, "touchend", c._onDrop), Ge(document, "touchcancel", c._onDrop), M && (M.effectAllowed = "move", T.setData && T.setData.call(c, M, Ce)), Xe(document, "drop", c), Me(Ce, "transform", "translateZ(0)")), pi = !0, c._dragStartId = fa(c._dragStarted.bind(c, l, t)), Xe(document, "selectstart", c), ro = !0, hs && Me(document.body, "user-select", "none");
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function(t) {
    var l = this.el, c = t.target, M, T, F, z = this.options, W = z.group, K = Fe.active, q = ea === W, m = z.sort, d = Qt || K, r, u = this, v = !1;
    if (vs) return;
    function C(I, H) {
      dn(I, u, xr({
        evt: t,
        isOwner: q,
        axis: r ? "vertical" : "horizontal",
        revert: F,
        dragRect: M,
        targetRect: T,
        canSort: m,
        fromSortable: d,
        target: c,
        completed: b,
        onMove: function(Q, U) {
          return es(yt, l, Ce, M, Q, _t(Q), t, U);
        },
        changed: x
      }, H));
    }
    function p() {
      C("dragOverAnimationCapture"), u.captureAnimationState(), u !== d && d.captureAnimationState();
    }
    function b(I) {
      return C("dragOverCompleted", {
        insertion: I
      }), I && (q ? K._hideClone() : K._showClone(u), u !== d && (bt(Ce, Qt ? Qt.options.ghostClass : K.options.ghostClass, !1), bt(Ce, z.ghostClass, !0)), Qt !== u && u !== Fe.active ? Qt = u : u === Fe.active && Qt && (Qt = null), d === u && (u._ignoreWhileAnimating = c), u.animateAll(function() {
        C("dragOverAnimationComplete"), u._ignoreWhileAnimating = null;
      }), u !== d && (d.animateAll(), d._ignoreWhileAnimating = null)), (c === Ce && !Ce.animated || c === l && !c.animated) && (ci = null), !z.dragoverBubble && !t.rootEl && c !== document && (Ce.parentNode[Xt]._isOutsideThisEl(t.target), !I && Lr(t)), !z.dragoverBubble && t.stopPropagation && t.stopPropagation(), v = !0;
    }
    function x() {
      bn = wt(Ce), gr = wt(Ce, z.draggable), an({
        sortable: u,
        name: "change",
        toEl: l,
        newIndex: bn,
        newDraggableIndex: gr,
        originalEvent: t
      });
    }
    if (t.preventDefault !== void 0 && t.cancelable && t.preventDefault(), c = Nn(c, z.draggable, l, !0), C("dragOver"), Fe.eventCanceled) return v;
    if (Ce.contains(t.target) || c.animated && c.animatingX && c.animatingY || u._ignoreWhileAnimating === c)
      return b(!1);
    if (va = !1, K && !z.disabled && (q ? m || (F = !yt.contains(Ce)) : Qt === this || (this.lastPutMode = ea.checkPull(this, K, Ce, t)) && W.checkPut(this, K, Ce, t))) {
      if (r = this._getDirection(t, c) === "vertical", M = _t(Ce), C("dragOverValid"), Fe.eventCanceled) return v;
      if (F)
        return Dt = yt, p(), this._hideClone(), C("revert"), Fe.eventCanceled || (Br ? yt.insertBefore(Ce, Br) : yt.appendChild(Ce)), b(!0);
      var g = _s(l, z.draggable);
      if (!g || Cg(t, r, this) && !g.animated) {
        if (g === Ce)
          return b(!1);
        if (g && l === t.target && (c = g), c && (T = _t(c)), es(yt, l, Ce, M, c, T, t, !!c) !== !1)
          return p(), l.appendChild(Ce), Dt = l, x(), b(!0);
      } else if (c.parentNode === l) {
        T = _t(c);
        var _ = 0, A, f = Ce.parentNode !== l, S = !bg(Ce.animated && Ce.toRect || M, c.animated && c.toRect || T, r), D = r ? "top" : "left", k = nf(c, "top", "top") || nf(Ce, "top", "top"), L = k ? k.scrollTop : void 0;
        ci !== c && (A = T[D], co = !1, ta = !S && z.invertSwap || f), _ = Sg(t, c, T, r, S ? 1 : z.swapThreshold, z.invertedSwapThreshold == null ? z.swapThreshold : z.invertedSwapThreshold, ta, ci === c);
        var h;
        if (_ !== 0) {
          var E = wt(Ce);
          do
            E -= _, h = Dt.children[E];
          while (h && (Me(h, "display") === "none" || h === Qe));
        }
        if (_ === 0 || h === c)
          return b(!1);
        ci = c, uo = _;
        var w = c.nextElementSibling, O = !1;
        O = _ === 1;
        var R = es(yt, l, Ce, M, c, T, t, O);
        if (R !== !1)
          return (R === 1 || R === -1) && (O = R === 1), vs = !0, setTimeout(_g, 30), p(), O && !w ? l.appendChild(Ce) : c.parentNode.insertBefore(Ce, O ? w : c), k && $f(k, 0, L - k.scrollTop), Dt = Ce.parentNode, A !== void 0 && !ta && (ca = Math.abs(A - _t(c)[D])), x(), b(!0);
      }
      if (l.contains(Ce))
        return b(!1);
    }
    return !1;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    Ge(document, "mousemove", this._onTouchMove), Ge(document, "touchmove", this._onTouchMove), Ge(document, "pointermove", this._onTouchMove), Ge(document, "dragover", Lr), Ge(document, "mousemove", Lr), Ge(document, "touchmove", Lr);
  },
  _offUpEvents: function() {
    var t = this.el.ownerDocument;
    Ge(t, "mouseup", this._onDrop), Ge(t, "touchend", this._onDrop), Ge(t, "pointerup", this._onDrop), Ge(t, "touchcancel", this._onDrop), Ge(document, "selectstart", this);
  },
  _onDrop: function(t) {
    var l = this.el, c = this.options;
    if (bn = wt(Ce), gr = wt(Ce, c.draggable), dn("drop", this, {
      evt: t
    }), Dt = Ce && Ce.parentNode, bn = wt(Ce), gr = wt(Ce, c.draggable), Fe.eventCanceled) {
      this._nulling();
      return;
    }
    pi = !1, ta = !1, co = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), gs(this.cloneId), gs(this._dragStartId), this.nativeDraggable && (Ge(document, "drop", this), Ge(l, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), hs && Me(document.body, "user-select", ""), Me(Ce, "transform", ""), t && (ro && (t.cancelable && t.preventDefault(), !c.dropBubble && t.stopPropagation()), Qe && Qe.parentNode && Qe.parentNode.removeChild(Qe), (yt === Dt || Qt && Qt.lastPutMode !== "clone") && xt && xt.parentNode && xt.parentNode.removeChild(xt), Ce && (this.nativeDraggable && Ge(Ce, "dragend", this), ts(Ce), Ce.style["will-change"] = "", ro && !pi && bt(Ce, Qt ? Qt.options.ghostClass : this.options.ghostClass, !1), bt(Ce, this.options.chosenClass, !1), an({
      sortable: this,
      name: "unchoose",
      toEl: Dt,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: t
    }), yt !== Dt ? (bn >= 0 && (an({
      rootEl: Dt,
      name: "add",
      toEl: Dt,
      fromEl: yt,
      originalEvent: t
    }), an({
      sortable: this,
      name: "remove",
      toEl: Dt,
      originalEvent: t
    }), an({
      rootEl: Dt,
      name: "sort",
      toEl: Dt,
      fromEl: yt,
      originalEvent: t
    }), an({
      sortable: this,
      name: "sort",
      toEl: Dt,
      originalEvent: t
    })), Qt && Qt.save()) : bn !== vi && bn >= 0 && (an({
      sortable: this,
      name: "update",
      toEl: Dt,
      originalEvent: t
    }), an({
      sortable: this,
      name: "sort",
      toEl: Dt,
      originalEvent: t
    })), Fe.active && ((bn == null || bn === -1) && (bn = vi, gr = so), an({
      sortable: this,
      name: "end",
      toEl: Dt,
      originalEvent: t
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    dn("nulling", this), yt = Ce = Dt = Qe = Br = xt = ua = mr = Ir = Dn = ro = bn = gr = vi = so = ci = uo = Qt = ea = Fe.dragged = Fe.ghost = Fe.clone = Fe.active = null, ma.forEach(function(t) {
      t.checked = !0;
    }), ma.length = Jl = ql = 0;
  },
  handleEvent: function(t) {
    switch (t.type) {
      case "drop":
      case "dragend":
        this._onDrop(t);
        break;
      case "dragenter":
      case "dragover":
        Ce && (this._onDragOver(t), wg(t));
        break;
      case "selectstart":
        t.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function() {
    for (var t = [], l, c = this.el.children, M = 0, T = c.length, F = this.options; M < T; M++)
      l = c[M], Nn(l, F.draggable, this.el, !1) && t.push(l.getAttribute(F.dataIdAttr) || kg(l));
    return t;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function(t) {
    var l = {}, c = this.el;
    this.toArray().forEach(function(M, T) {
      var F = c.children[T];
      Nn(F, this.options.draggable, c, !1) && (l[M] = F);
    }, this), t.forEach(function(M) {
      l[M] && (c.removeChild(l[M]), c.appendChild(l[M]));
    });
  },
  /**
   * Save the current sorting
   */
  save: function() {
    var t = this.options.store;
    t && t.set && t.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function(t, l) {
    return Nn(t, l || this.options.draggable, this.el, !1);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function(t, l) {
    var c = this.options;
    if (l === void 0)
      return c[t];
    var M = go.modifyOption(this, t, l);
    typeof M != "undefined" ? c[t] = M : c[t] = l, t === "group" && Wf(c);
  },
  /**
   * Destroy
   */
  destroy: function() {
    dn("destroy", this);
    var t = this.el;
    t[Xt] = null, Ge(t, "mousedown", this._onTapStart), Ge(t, "touchstart", this._onTapStart), Ge(t, "pointerdown", this._onTapStart), this.nativeDraggable && (Ge(t, "dragover", this), Ge(t, "dragenter", this)), Array.prototype.forEach.call(t.querySelectorAll("[draggable]"), function(l) {
      l.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), ga.splice(ga.indexOf(this.el), 1), this.el = t = null;
  },
  _hideClone: function() {
    if (!mr) {
      if (dn("hideClone", this), Fe.eventCanceled) return;
      Me(xt, "display", "none"), this.options.removeCloneOnHide && xt.parentNode && xt.parentNode.removeChild(xt), mr = !0;
    }
  },
  _showClone: function(t) {
    if (t.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (mr) {
      if (dn("showClone", this), Fe.eventCanceled) return;
      yt.contains(Ce) && !this.options.group.revertClone ? yt.insertBefore(xt, Ce) : Br ? yt.insertBefore(xt, Br) : yt.appendChild(xt), this.options.group.revertClone && this.animate(Ce, xt), Me(xt, "display", ""), mr = !1;
    }
  }
};
function wg(i) {
  i.dataTransfer && (i.dataTransfer.dropEffect = "move"), i.cancelable && i.preventDefault();
}
function es(i, t, l, c, M, T, F, z) {
  var W, K = i[Xt], q = K.options.onMove, m;
  return window.CustomEvent && !er && !vo ? W = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }) : (W = document.createEvent("Event"), W.initEvent("move", !0, !0)), W.to = t, W.from = i, W.dragged = l, W.draggedRect = c, W.related = M || t, W.relatedRect = T || _t(t), W.willInsertAfter = z, W.originalEvent = F, i.dispatchEvent(W), q && (m = q.call(K, W, F)), m;
}
function ts(i) {
  i.draggable = !1;
}
function _g() {
  vs = !1;
}
function Cg(i, t, l) {
  var c = _t(_s(l.el, l.options.draggable)), M = 10;
  return t ? i.clientX > c.right + M || i.clientX <= c.right && i.clientY > c.bottom && i.clientX >= c.left : i.clientX > c.right && i.clientY > c.top || i.clientX <= c.right && i.clientY > c.bottom + M;
}
function Sg(i, t, l, c, M, T, F, z) {
  var W = c ? i.clientY : i.clientX, K = c ? l.height : l.width, q = c ? l.top : l.left, m = c ? l.bottom : l.right, d = !1;
  if (!F) {
    if (z && ca < K * M) {
      if (!co && (uo === 1 ? W > q + K * T / 2 : W < m - K * T / 2) && (co = !0), co)
        d = !0;
      else if (uo === 1 ? W < q + ca : W > m - ca)
        return -uo;
    } else if (W > q + K * (1 - M) / 2 && W < m - K * (1 - M) / 2)
      return Eg(t);
  }
  return d = d || F, d && (W < q + K * T / 2 || W > m - K * T / 2) ? W > q + K / 2 ? 1 : -1 : 0;
}
function Eg(i) {
  return wt(Ce) < wt(i) ? 1 : -1;
}
function kg(i) {
  for (var t = i.tagName + i.className + i.src + i.href + i.textContent, l = t.length, c = 0; l--; )
    c += t.charCodeAt(l);
  return c.toString(36);
}
function Tg(i) {
  ma.length = 0;
  for (var t = i.getElementsByTagName("input"), l = t.length; l--; ) {
    var c = t[l];
    c.checked && ma.push(c);
  }
}
function fa(i) {
  return setTimeout(i, 0);
}
function gs(i) {
  return clearTimeout(i);
}
xa && Xe(document, "touchmove", function(i) {
  (Fe.active || pi) && i.cancelable && i.preventDefault();
});
Fe.utils = {
  on: Xe,
  off: Ge,
  css: Me,
  find: Hf,
  is: function(t, l) {
    return !!Nn(t, l, t, !1);
  },
  extend: pg,
  throttle: jf,
  closest: Nn,
  toggleClass: bt,
  clone: Cs,
  index: wt,
  nextTick: fa,
  cancelNextTick: gs,
  detectDirection: Uf,
  getChild: ha
};
Fe.get = function(i) {
  return i[Xt];
};
Fe.mount = function() {
  for (var i = arguments.length, t = new Array(i), l = 0; l < i; l++)
    t[l] = arguments[l];
  t[0].constructor === Array && (t = t[0]), t.forEach(function(c) {
    if (!c.prototype || !c.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(c));
    c.utils && (Fe.utils = xr({}, Fe.utils, c.utils)), go.mount(c);
  });
};
Fe.create = function(i, t) {
  return new Fe(i, t);
};
Fe.version = ug;
var Mt = [], io, ms, ys = !1, ns, rs, ya, oo;
function Dg() {
  function i() {
    this.defaults = {
      scroll: !0,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    };
    for (var t in this)
      t.charAt(0) === "_" && typeof this[t] == "function" && (this[t] = this[t].bind(this));
  }
  return i.prototype = {
    dragStarted: function(l) {
      var c = l.originalEvent;
      this.sortable.nativeDraggable ? Xe(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? Xe(document, "pointermove", this._handleFallbackAutoScroll) : c.touches ? Xe(document, "touchmove", this._handleFallbackAutoScroll) : Xe(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(l) {
      var c = l.originalEvent;
      !this.options.dragOverBubble && !c.rootEl && this._handleAutoScroll(c);
    },
    drop: function() {
      this.sortable.nativeDraggable ? Ge(document, "dragover", this._handleAutoScroll) : (Ge(document, "pointermove", this._handleFallbackAutoScroll), Ge(document, "touchmove", this._handleFallbackAutoScroll), Ge(document, "mousemove", this._handleFallbackAutoScroll)), uf(), da(), hg();
    },
    nulling: function() {
      ya = ms = io = ys = oo = ns = rs = null, Mt.length = 0;
    },
    _handleFallbackAutoScroll: function(l) {
      this._handleAutoScroll(l, !0);
    },
    _handleAutoScroll: function(l, c) {
      var M = this, T = (l.touches ? l.touches[0] : l).clientX, F = (l.touches ? l.touches[0] : l).clientY, z = document.elementFromPoint(T, F);
      if (ya = l, c || vo || er || hs) {
        is(l, this.options, z, c);
        var W = br(z, !0);
        ys && (!oo || T !== ns || F !== rs) && (oo && uf(), oo = setInterval(function() {
          var K = br(document.elementFromPoint(T, F), !0);
          K !== W && (W = K, da()), is(l, M.options, K, c);
        }, 10), ns = T, rs = F);
      } else {
        if (!this.options.bubbleScroll || br(z, !0) === Wn()) {
          da();
          return;
        }
        is(l, this.options, br(z, !1), !1);
      }
    }
  }, Cn(i, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}
function da() {
  Mt.forEach(function(i) {
    clearInterval(i.pid);
  }), Mt = [];
}
function uf() {
  clearInterval(oo);
}
var is = jf(function(i, t, l, c) {
  if (t.scroll) {
    var M = (i.touches ? i.touches[0] : i).clientX, T = (i.touches ? i.touches[0] : i).clientY, F = t.scrollSensitivity, z = t.scrollSpeed, W = Wn(), K = !1, q;
    ms !== l && (ms = l, da(), io = t.scroll, q = t.scrollFn, io === !0 && (io = br(l, !0)));
    var m = 0, d = io;
    do {
      var r = d, u = _t(r), v = u.top, C = u.bottom, p = u.left, b = u.right, x = u.width, g = u.height, _ = void 0, A = void 0, f = r.scrollWidth, S = r.scrollHeight, D = Me(r), k = r.scrollLeft, L = r.scrollTop;
      r === W ? (_ = x < f && (D.overflowX === "auto" || D.overflowX === "scroll" || D.overflowX === "visible"), A = g < S && (D.overflowY === "auto" || D.overflowY === "scroll" || D.overflowY === "visible")) : (_ = x < f && (D.overflowX === "auto" || D.overflowX === "scroll"), A = g < S && (D.overflowY === "auto" || D.overflowY === "scroll"));
      var h = _ && (Math.abs(b - M) <= F && k + x < f) - (Math.abs(p - M) <= F && !!k), E = A && (Math.abs(C - T) <= F && L + g < S) - (Math.abs(v - T) <= F && !!L);
      if (!Mt[m])
        for (var w = 0; w <= m; w++)
          Mt[w] || (Mt[w] = {});
      (Mt[m].vx != h || Mt[m].vy != E || Mt[m].el !== r) && (Mt[m].el = r, Mt[m].vx = h, Mt[m].vy = E, clearInterval(Mt[m].pid), (h != 0 || E != 0) && (K = !0, Mt[m].pid = setInterval(function() {
        c && this.layer === 0 && Fe.active._onTouchMove(ya);
        var O = Mt[this.layer].vy ? Mt[this.layer].vy * z : 0, R = Mt[this.layer].vx ? Mt[this.layer].vx * z : 0;
        typeof q == "function" && q.call(Fe.dragged.parentNode[Xt], R, O, i, ya, Mt[this.layer].el) !== "continue" || $f(Mt[this.layer].el, R, O);
      }.bind({
        layer: m
      }), 24))), m++;
    } while (t.bubbleScroll && d !== W && (d = br(d, !1)));
    ys = K;
  }
}, 30), Gf = function(t) {
  var l = t.originalEvent, c = t.putSortable, M = t.dragEl, T = t.activeSortable, F = t.dispatchSortableEvent, z = t.hideGhostForTarget, W = t.unhideGhostForTarget;
  if (l) {
    var K = c || T;
    z();
    var q = l.changedTouches && l.changedTouches.length ? l.changedTouches[0] : l, m = document.elementFromPoint(q.clientX, q.clientY);
    W(), K && !K.el.contains(m) && (F("spill"), this.onSpill({
      dragEl: M,
      putSortable: c
    }));
  }
};
function Ss() {
}
Ss.prototype = {
  startIndex: null,
  dragStart: function(t) {
    var l = t.oldDraggableIndex;
    this.startIndex = l;
  },
  onSpill: function(t) {
    var l = t.dragEl, c = t.putSortable;
    this.sortable.captureAnimationState(), c && c.captureAnimationState();
    var M = ha(this.sortable.el, this.startIndex, this.options);
    M ? this.sortable.el.insertBefore(l, M) : this.sortable.el.appendChild(l), this.sortable.animateAll(), c && c.animateAll();
  },
  drop: Gf
};
Cn(Ss, {
  pluginName: "revertOnSpill"
});
function Es() {
}
Es.prototype = {
  onSpill: function(t) {
    var l = t.dragEl, c = t.putSortable, M = c || this.sortable;
    M.captureAnimationState(), l.parentNode && l.parentNode.removeChild(l), M.animateAll();
  },
  drop: Gf
};
Cn(Es, {
  pluginName: "removeOnSpill"
});
var _n;
function Mg() {
  function i() {
    this.defaults = {
      swapClass: "sortable-swap-highlight"
    };
  }
  return i.prototype = {
    dragStart: function(l) {
      var c = l.dragEl;
      _n = c;
    },
    dragOverValid: function(l) {
      var c = l.completed, M = l.target, T = l.onMove, F = l.activeSortable, z = l.changed, W = l.cancel;
      if (F.options.swap) {
        var K = this.sortable.el, q = this.options;
        if (M && M !== K) {
          var m = _n;
          T(M) !== !1 ? (bt(M, q.swapClass, !0), _n = M) : _n = null, m && m !== _n && bt(m, q.swapClass, !1);
        }
        z(), c(!0), W();
      }
    },
    drop: function(l) {
      var c = l.activeSortable, M = l.putSortable, T = l.dragEl, F = M || this.sortable, z = this.options;
      _n && bt(_n, z.swapClass, !1), _n && (z.swap || M && M.options.swap) && T !== _n && (F.captureAnimationState(), F !== c && c.captureAnimationState(), Ng(T, _n), F.animateAll(), F !== c && c.animateAll());
    },
    nulling: function() {
      _n = null;
    }
  }, Cn(i, {
    pluginName: "swap",
    eventProperties: function() {
      return {
        swapItem: _n
      };
    }
  });
}
function Ng(i, t) {
  var l = i.parentNode, c = t.parentNode, M, T;
  !l || !c || l.isEqualNode(t) || c.isEqualNode(i) || (M = wt(i), T = wt(t), l.isEqualNode(c) && M < T && T++, l.insertBefore(t, l.children[M]), c.insertBefore(i, c.children[T]));
}
var Ue = [], yn = [], Zi, Mn, eo = !1, mn = !1, fi = !1, pt, to, ra;
function Og() {
  function i(t) {
    for (var l in this)
      l.charAt(0) === "_" && typeof this[l] == "function" && (this[l] = this[l].bind(this));
    t.options.supportPointer ? Xe(document, "pointerup", this._deselectMultiDrag) : (Xe(document, "mouseup", this._deselectMultiDrag), Xe(document, "touchend", this._deselectMultiDrag)), Xe(document, "keydown", this._checkKeyDown), Xe(document, "keyup", this._checkKeyUp), this.defaults = {
      selectedClass: "sortable-selected",
      multiDragKey: null,
      setData: function(M, T) {
        var F = "";
        Ue.length && Mn === t ? Ue.forEach(function(z, W) {
          F += (W ? ", " : "") + z.textContent;
        }) : F = T.textContent, M.setData("Text", F);
      }
    };
  }
  return i.prototype = {
    multiDragKeyDown: !1,
    isMultiDrag: !1,
    delayStartGlobal: function(l) {
      var c = l.dragEl;
      pt = c;
    },
    delayEnded: function() {
      this.isMultiDrag = ~Ue.indexOf(pt);
    },
    setupClone: function(l) {
      var c = l.sortable, M = l.cancel;
      if (this.isMultiDrag) {
        for (var T = 0; T < Ue.length; T++)
          yn.push(Cs(Ue[T])), yn[T].sortableIndex = Ue[T].sortableIndex, yn[T].draggable = !1, yn[T].style["will-change"] = "", bt(yn[T], this.options.selectedClass, !1), Ue[T] === pt && bt(yn[T], this.options.chosenClass, !1);
        c._hideClone(), M();
      }
    },
    clone: function(l) {
      var c = l.sortable, M = l.rootEl, T = l.dispatchSortableEvent, F = l.cancel;
      this.isMultiDrag && (this.options.removeCloneOnHide || Ue.length && Mn === c && (cf(!0, M), T("clone"), F()));
    },
    showClone: function(l) {
      var c = l.cloneNowShown, M = l.rootEl, T = l.cancel;
      this.isMultiDrag && (cf(!1, M), yn.forEach(function(F) {
        Me(F, "display", "");
      }), c(), ra = !1, T());
    },
    hideClone: function(l) {
      var c = this;
      l.sortable;
      var M = l.cloneNowHidden, T = l.cancel;
      this.isMultiDrag && (yn.forEach(function(F) {
        Me(F, "display", "none"), c.options.removeCloneOnHide && F.parentNode && F.parentNode.removeChild(F);
      }), M(), ra = !0, T());
    },
    dragStartGlobal: function(l) {
      l.sortable, !this.isMultiDrag && Mn && Mn.multiDrag._deselectMultiDrag(), Ue.forEach(function(c) {
        c.sortableIndex = wt(c);
      }), Ue = Ue.sort(function(c, M) {
        return c.sortableIndex - M.sortableIndex;
      }), fi = !0;
    },
    dragStarted: function(l) {
      var c = this, M = l.sortable;
      if (this.isMultiDrag) {
        if (this.options.sort && (M.captureAnimationState(), this.options.animation)) {
          Ue.forEach(function(F) {
            F !== pt && Me(F, "position", "absolute");
          });
          var T = _t(pt, !1, !0, !0);
          Ue.forEach(function(F) {
            F !== pt && of(F, T);
          }), mn = !0, eo = !0;
        }
        M.animateAll(function() {
          mn = !1, eo = !1, c.options.animation && Ue.forEach(function(F) {
            Kl(F);
          }), c.options.sort && ia();
        });
      }
    },
    dragOver: function(l) {
      var c = l.target, M = l.completed, T = l.cancel;
      mn && ~Ue.indexOf(c) && (M(!1), T());
    },
    revert: function(l) {
      var c = l.fromSortable, M = l.rootEl, T = l.sortable, F = l.dragRect;
      Ue.length > 1 && (Ue.forEach(function(z) {
        T.addAnimationState({
          target: z,
          rect: mn ? _t(z) : F
        }), Kl(z), z.fromRect = F, c.removeAnimationState(z);
      }), mn = !1, Rg(!this.options.removeCloneOnHide, M));
    },
    dragOverCompleted: function(l) {
      var c = l.sortable, M = l.isOwner, T = l.insertion, F = l.activeSortable, z = l.parentEl, W = l.putSortable, K = this.options;
      if (T) {
        if (M && F._hideClone(), eo = !1, K.animation && Ue.length > 1 && (mn || !M && !F.options.sort && !W)) {
          var q = _t(pt, !1, !0, !0);
          Ue.forEach(function(d) {
            d !== pt && (of(d, q), z.appendChild(d));
          }), mn = !0;
        }
        if (!M)
          if (mn || ia(), Ue.length > 1) {
            var m = ra;
            F._showClone(c), F.options.animation && !ra && m && yn.forEach(function(d) {
              F.addAnimationState({
                target: d,
                rect: to
              }), d.fromRect = to, d.thisAnimationDuration = null;
            });
          } else
            F._showClone(c);
      }
    },
    dragOverAnimationCapture: function(l) {
      var c = l.dragRect, M = l.isOwner, T = l.activeSortable;
      if (Ue.forEach(function(z) {
        z.thisAnimationDuration = null;
      }), T.options.animation && !M && T.multiDrag.isMultiDrag) {
        to = Cn({}, c);
        var F = Hr(pt, !0);
        to.top -= F.f, to.left -= F.e;
      }
    },
    dragOverAnimationComplete: function() {
      mn && (mn = !1, ia());
    },
    drop: function(l) {
      var c = l.originalEvent, M = l.rootEl, T = l.parentEl, F = l.sortable, z = l.dispatchSortableEvent, W = l.oldIndex, K = l.putSortable, q = K || this.sortable;
      if (c) {
        var m = this.options, d = T.children;
        if (!fi)
          if (m.multiDragKey && !this.multiDragKeyDown && this._deselectMultiDrag(), bt(pt, m.selectedClass, !~Ue.indexOf(pt)), ~Ue.indexOf(pt))
            Ue.splice(Ue.indexOf(pt), 1), Zi = null, no({
              sortable: F,
              rootEl: M,
              name: "deselect",
              targetEl: pt,
              originalEvt: c
            });
          else {
            if (Ue.push(pt), no({
              sortable: F,
              rootEl: M,
              name: "select",
              targetEl: pt,
              originalEvt: c
            }), c.shiftKey && Zi && F.el.contains(Zi)) {
              var r = wt(Zi), u = wt(pt);
              if (~r && ~u && r !== u) {
                var v, C;
                for (u > r ? (C = r, v = u) : (C = u, v = r + 1); C < v; C++)
                  ~Ue.indexOf(d[C]) || (bt(d[C], m.selectedClass, !0), Ue.push(d[C]), no({
                    sortable: F,
                    rootEl: M,
                    name: "select",
                    targetEl: d[C],
                    originalEvt: c
                  }));
              }
            } else
              Zi = pt;
            Mn = q;
          }
        if (fi && this.isMultiDrag) {
          if ((T[Xt].options.sort || T !== M) && Ue.length > 1) {
            var p = _t(pt), b = wt(pt, ":not(." + this.options.selectedClass + ")");
            if (!eo && m.animation && (pt.thisAnimationDuration = null), q.captureAnimationState(), !eo && (m.animation && (pt.fromRect = p, Ue.forEach(function(g) {
              if (g.thisAnimationDuration = null, g !== pt) {
                var _ = mn ? _t(g) : p;
                g.fromRect = _, q.addAnimationState({
                  target: g,
                  rect: _
                });
              }
            })), ia(), Ue.forEach(function(g) {
              d[b] ? T.insertBefore(g, d[b]) : T.appendChild(g), b++;
            }), W === wt(pt))) {
              var x = !1;
              Ue.forEach(function(g) {
                if (g.sortableIndex !== wt(g)) {
                  x = !0;
                  return;
                }
              }), x && z("update");
            }
            Ue.forEach(function(g) {
              Kl(g);
            }), q.animateAll();
          }
          Mn = q;
        }
        (M === T || K && K.lastPutMode !== "clone") && yn.forEach(function(g) {
          g.parentNode && g.parentNode.removeChild(g);
        });
      }
    },
    nullingGlobal: function() {
      this.isMultiDrag = fi = !1, yn.length = 0;
    },
    destroyGlobal: function() {
      this._deselectMultiDrag(), Ge(document, "pointerup", this._deselectMultiDrag), Ge(document, "mouseup", this._deselectMultiDrag), Ge(document, "touchend", this._deselectMultiDrag), Ge(document, "keydown", this._checkKeyDown), Ge(document, "keyup", this._checkKeyUp);
    },
    _deselectMultiDrag: function(l) {
      if (!(typeof fi != "undefined" && fi) && Mn === this.sortable && !(l && Nn(l.target, this.options.draggable, this.sortable.el, !1)) && !(l && l.button !== 0))
        for (; Ue.length; ) {
          var c = Ue[0];
          bt(c, this.options.selectedClass, !1), Ue.shift(), no({
            sortable: this.sortable,
            rootEl: this.sortable.el,
            name: "deselect",
            targetEl: c,
            originalEvt: l
          });
        }
    },
    _checkKeyDown: function(l) {
      l.key === this.options.multiDragKey && (this.multiDragKeyDown = !0);
    },
    _checkKeyUp: function(l) {
      l.key === this.options.multiDragKey && (this.multiDragKeyDown = !1);
    }
  }, Cn(i, {
    // Static methods & properties
    pluginName: "multiDrag",
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function(l) {
        var c = l.parentNode[Xt];
        !c || !c.options.multiDrag || ~Ue.indexOf(l) || (Mn && Mn !== c && (Mn.multiDrag._deselectMultiDrag(), Mn = c), bt(l, c.options.selectedClass, !0), Ue.push(l));
      },
      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function(l) {
        var c = l.parentNode[Xt], M = Ue.indexOf(l);
        !c || !c.options.multiDrag || !~M || (bt(l, c.options.selectedClass, !1), Ue.splice(M, 1));
      }
    },
    eventProperties: function() {
      var l = this, c = [], M = [];
      return Ue.forEach(function(T) {
        c.push({
          multiDragElement: T,
          index: T.sortableIndex
        });
        var F;
        mn && T !== pt ? F = -1 : mn ? F = wt(T, ":not(." + l.options.selectedClass + ")") : F = wt(T), M.push({
          multiDragElement: T,
          index: F
        });
      }), {
        items: og(Ue),
        clones: [].concat(yn),
        oldIndicies: c,
        newIndicies: M
      };
    },
    optionListeners: {
      multiDragKey: function(l) {
        return l = l.toLowerCase(), l === "ctrl" ? l = "Control" : l.length > 1 && (l = l.charAt(0).toUpperCase() + l.substr(1)), l;
      }
    }
  });
}
function Rg(i, t) {
  Ue.forEach(function(l, c) {
    var M = t.children[l.sortableIndex + (i ? Number(c) : 0)];
    M ? t.insertBefore(l, M) : t.appendChild(l);
  });
}
function cf(i, t) {
  yn.forEach(function(l, c) {
    var M = t.children[l.sortableIndex + (i ? Number(c) : 0)];
    M ? t.insertBefore(l, M) : t.appendChild(l);
  });
}
function ia() {
  Ue.forEach(function(i) {
    i !== pt && i.parentNode && i.parentNode.removeChild(i);
  });
}
Fe.mount(new Dg());
Fe.mount(Es, Ss);
const Ig = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MultiDrag: Og,
  Sortable: Fe,
  Swap: Mg,
  default: Fe
}, Symbol.toStringTag, { value: "Module" }));
function Lg() {
  return typeof window != "undefined" ? window.console : global.console;
}
const os = Lg();
function Fg(i) {
  const t = /* @__PURE__ */ Object.create(null);
  return function(c) {
    return t[c] || (t[c] = i(c));
  };
}
const Bg = /-(\w)/g, ff = Fg(
  (i) => i.replace(Bg, (t, l) => l ? l.toUpperCase() : "")
);
function as(i) {
  i.parentElement !== null && i.parentElement.removeChild(i);
}
function df(i, t, l) {
  const c = l === 0 ? i.children[0] : i.children[l - 1].nextSibling;
  i.insertBefore(t, c);
}
function Pg(i, t, l) {
  return l === void 0 || (i = i || {}, i[t] = l), i;
}
function Hg(i, t) {
  return i.map((l) => l.elm).indexOf(t);
}
function jg(i, t, l, c) {
  if (!i)
    return [];
  const M = i.map((z) => z.elm), T = t.length - c, F = [...t].map(
    (z, W) => W >= T ? M.length : M.indexOf(z)
  );
  return l ? F.filter((z) => z !== -1) : F;
}
function Yf(i, t) {
  this.$nextTick(() => this.$emit(i.toLowerCase(), t));
}
function $g(i) {
  return (t) => {
    this.realList !== null && this["onDrag" + i](t), Yf.call(this, i, t);
  };
}
function Kf(i) {
  return ["transition-group", "TransitionGroup"].includes(i);
}
function zg(i) {
  if (!i || i.length !== 1)
    return !1;
  const [{ componentOptions: t }] = i;
  return t ? Kf(t.tag) : !1;
}
function pf(i, t, l) {
  return i[l] || (t[l] ? t[l]() : void 0);
}
function Ug(i, t, l) {
  let c = 0, M = 0;
  const T = pf(t, l, "header");
  T && (c = T.length, i = i ? [...T, ...i] : [...T]);
  const F = pf(t, l, "footer");
  return F && (M = F.length, i = i ? [...i, ...F] : [...F]), { children: i, headerOffset: c, footerOffset: M };
}
function Wg(i, t) {
  let l = null;
  const c = (W, K) => {
    l = Pg(l, W, K);
  }, M = Object.keys(i).filter((W) => W === "id" || W.startsWith("data-")).reduce((W, K) => (W[K] = i[K], W), {});
  if (c("attrs", M), !t)
    return l;
  const { on: T, props: F, attrs: z } = t;
  return c("on", T), c("props", F), Object.assign(l.attrs, z), l;
}
const Xf = ["Start", "Add", "Remove", "Update", "End"], Jf = ["Choose", "Unchoose", "Sort", "Filter", "Clone"], Qg = ["Move", ...Xf, ...Jf].map(
  (i) => "on" + i
);
var ls = null;
const Vg = {
  options: Object,
  list: {
    type: Array,
    required: !1,
    default: null
  },
  value: {
    type: Array,
    required: !1,
    default: null
  },
  noTransitionOnDrag: {
    type: Boolean,
    default: !1
  },
  clone: {
    type: Function,
    default: (i) => i
  },
  element: {
    type: String,
    default: "div"
  },
  tag: {
    type: String,
    default: null
  },
  move: {
    type: Function,
    default: null
  },
  componentData: {
    type: Object,
    required: !1,
    default: null
  }
}, qf = {
  name: "draggable",
  inheritAttrs: !1,
  props: Vg,
  data() {
    return {
      transitionMode: !1,
      noneFunctionalComponentMode: !1
    };
  },
  render(i) {
    const t = this.$slots.default;
    this.transitionMode = zg(t);
    const { children: l, headerOffset: c, footerOffset: M } = Ug(
      t,
      this.$slots,
      this.$scopedSlots
    );
    this.headerOffset = c, this.footerOffset = M;
    const T = Wg(this.$attrs, this.componentData);
    return i(this.getTag(), T, l);
  },
  created() {
    this.list !== null && this.value !== null && os.error(
      "Value and list props are mutually exclusive! Please set one or another."
    ), this.element !== "div" && os.warn(
      "Element props is deprecated please use tag props instead. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#element-props"
    ), this.options !== void 0 && os.warn(
      "Options props is deprecated, add sortable options directly as vue.draggable item, or use v-bind. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#options-props"
    );
  },
  mounted() {
    if (this.noneFunctionalComponentMode = this.getTag().toLowerCase() !== this.$el.nodeName.toLowerCase() && !this.getIsFunctional(), this.noneFunctionalComponentMode && this.transitionMode)
      throw new Error(
        `Transition-group inside component is not supported. Please alter tag value or remove transition-group. Current tag value: ${this.getTag()}`
      );
    const i = {};
    Xf.forEach((c) => {
      i["on" + c] = $g.call(this, c);
    }), Jf.forEach((c) => {
      i["on" + c] = Yf.bind(this, c);
    });
    const t = Object.keys(this.$attrs).reduce((c, M) => (c[ff(M)] = this.$attrs[M], c), {}), l = Object.assign({}, this.options, t, i, {
      onMove: (c, M) => this.onDragMove(c, M)
    });
    !("draggable" in l) && (l.draggable = ">*"), this._sortable = new Fe(this.rootContainer, l), this.computeIndexes();
  },
  beforeDestroy() {
    this._sortable !== void 0 && this._sortable.destroy();
  },
  computed: {
    rootContainer() {
      return this.transitionMode ? this.$el.children[0] : this.$el;
    },
    realList() {
      return this.list ? this.list : this.value;
    }
  },
  watch: {
    options: {
      handler(i) {
        this.updateOptions(i);
      },
      deep: !0
    },
    $attrs: {
      handler(i) {
        this.updateOptions(i);
      },
      deep: !0
    },
    realList() {
      this.computeIndexes();
    }
  },
  methods: {
    getIsFunctional() {
      const { fnOptions: i } = this._vnode;
      return i && i.functional;
    },
    getTag() {
      return this.tag || this.element;
    },
    updateOptions(i) {
      for (var t in i) {
        const l = ff(t);
        Qg.indexOf(l) === -1 && this._sortable.option(l, i[t]);
      }
    },
    getChildrenNodes() {
      if (this.noneFunctionalComponentMode)
        return this.$children[0].$slots.default;
      const i = this.$slots.default;
      return this.transitionMode ? i[0].child.$slots.default : i;
    },
    computeIndexes() {
      this.$nextTick(() => {
        this.visibleIndexes = jg(
          this.getChildrenNodes(),
          this.rootContainer.children,
          this.transitionMode,
          this.footerOffset
        );
      });
    },
    getUnderlyingVm(i) {
      const t = Hg(this.getChildrenNodes() || [], i);
      if (t === -1)
        return null;
      const l = this.realList[t];
      return { index: t, element: l };
    },
    getUnderlyingPotencialDraggableComponent({ __vue__: i }) {
      return !i || !i.$options || !Kf(i.$options._componentTag) ? !("realList" in i) && i.$children.length === 1 && "realList" in i.$children[0] ? i.$children[0] : i : i.$parent;
    },
    emitChanges(i) {
      this.$nextTick(() => {
        this.$emit("change", i);
      });
    },
    alterList(i) {
      if (this.list) {
        i(this.list);
        return;
      }
      const t = [...this.value];
      i(t), this.$emit("input", t);
    },
    spliceList() {
      const i = (t) => t.splice(...arguments);
      this.alterList(i);
    },
    updatePosition(i, t) {
      const l = (c) => c.splice(t, 0, c.splice(i, 1)[0]);
      this.alterList(l);
    },
    getRelatedContextFromMoveEvent({ to: i, related: t }) {
      const l = this.getUnderlyingPotencialDraggableComponent(i);
      if (!l)
        return { component: l };
      const c = l.realList, M = { list: c, component: l };
      if (i !== t && c && l.getUnderlyingVm) {
        const T = l.getUnderlyingVm(t);
        if (T)
          return Object.assign(T, M);
      }
      return M;
    },
    getVmIndex(i) {
      const t = this.visibleIndexes, l = t.length;
      return i > l - 1 ? l : t[i];
    },
    getComponent() {
      return this.$slots.default[0].componentInstance;
    },
    resetTransitionData(i) {
      if (!this.noTransitionOnDrag || !this.transitionMode)
        return;
      var t = this.getChildrenNodes();
      t[i].data = null;
      const l = this.getComponent();
      l.children = [], l.kept = void 0;
    },
    onDragStart(i) {
      this.context = this.getUnderlyingVm(i.item), i.item._underlying_vm_ = this.clone(this.context.element), ls = i.item;
    },
    onDragAdd(i) {
      const t = i.item._underlying_vm_;
      if (t === void 0)
        return;
      as(i.item);
      const l = this.getVmIndex(i.newIndex);
      this.spliceList(l, 0, t), this.computeIndexes();
      const c = { element: t, newIndex: l };
      this.emitChanges({ added: c });
    },
    onDragRemove(i) {
      if (df(this.rootContainer, i.item, i.oldIndex), i.pullMode === "clone") {
        as(i.clone);
        return;
      }
      const t = this.context.index;
      this.spliceList(t, 1);
      const l = { element: this.context.element, oldIndex: t };
      this.resetTransitionData(t), this.emitChanges({ removed: l });
    },
    onDragUpdate(i) {
      as(i.item), df(i.from, i.item, i.oldIndex);
      const t = this.context.index, l = this.getVmIndex(i.newIndex);
      this.updatePosition(t, l);
      const c = { element: this.context.element, oldIndex: t, newIndex: l };
      this.emitChanges({ moved: c });
    },
    updateProperty(i, t) {
      i.hasOwnProperty(t) && (i[t] += this.headerOffset);
    },
    computeFutureIndex(i, t) {
      if (!i.element)
        return 0;
      const l = [...t.to.children].filter(
        (F) => F.style.display !== "none"
      ), c = l.indexOf(t.related), M = i.component.getVmIndex(c);
      return l.indexOf(ls) !== -1 || !t.willInsertAfter ? M : M + 1;
    },
    onDragMove(i, t) {
      const l = this.move;
      if (!l || !this.realList)
        return !0;
      const c = this.getRelatedContextFromMoveEvent(i), M = this.context, T = this.computeFutureIndex(c, i);
      Object.assign(M, { futureIndex: T });
      const F = Object.assign({}, i, {
        relatedContext: c,
        draggedContext: M
      });
      return l(F, t);
    },
    onDragEnd() {
      this.computeIndexes(), ls = null;
    }
  }
};
typeof window != "undefined" && "Vue" in window && window.Vue.component("draggable", qf);
function Gg() {
  return [
    {
      name: "main",
      title: "基础组件",
      list: []
    },
    {
      name: "subform",
      title: "子表单组件",
      list: []
    },
    {
      name: "aide",
      title: "辅助组件",
      list: []
    },
    {
      name: "layout",
      title: "布局组件",
      list: []
    }
  ];
}
const wa = Mf, qe = Mf.factory();
let Zf = null, hf = ao(null);
function bs(...i) {
  return Zf(...i);
}
const ed = (i) => {
  hf.value = i || Nf;
  const t = ds(hf);
  return Zf = t.t, t;
};
ed();
var ks = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Ts(i) {
  return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
}
function Yg(i) {
  if (i.__esModule) return i;
  var t = i.default;
  if (typeof t == "function") {
    var l = function c() {
      return this instanceof c ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    l.prototype = t.prototype;
  } else l = {};
  return Object.defineProperty(l, "__esModule", { value: !0 }), Object.keys(i).forEach(function(c) {
    var M = Object.getOwnPropertyDescriptor(i, c);
    Object.defineProperty(l, c, M.get ? M : {
      enumerable: !0,
      get: function() {
        return i[c];
      }
    });
  }), l;
}
var ss = { exports: {} }, vf;
function _a() {
  return vf || (vf = 1, function(i, t) {
    (function(l, c) {
      i.exports = c();
    })(ks, function() {
      var l = navigator.userAgent, c = navigator.platform, M = /gecko\/\d/i.test(l), T = /MSIE \d/.test(l), F = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(l), z = /Edge\/(\d+)/.exec(l), W = T || F || z, K = W && (T ? document.documentMode || 6 : +(z || F)[1]), q = !z && /WebKit\//.test(l), m = q && /Qt\/\d+\.\d+/.test(l), d = !z && /Chrome\//.test(l), r = /Opera\//.test(l), u = /Apple Computer/.test(navigator.vendor), v = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(l), C = /PhantomJS/.test(l), p = u && (/Mobile\/\w+/.test(l) || navigator.maxTouchPoints > 2), b = /Android/.test(l), x = p || b || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(l), g = p || /Mac/.test(c), _ = /\bCrOS\b/.test(l), A = /win/i.test(c), f = r && l.match(/Version\/(\d*\.\d*)/);
      f && (f = Number(f[1])), f && f >= 15 && (r = !1, q = !0);
      var S = g && (m || r && (f == null || f < 12.11)), D = M || W && K >= 9;
      function k(e) {
        return new RegExp("(^|\\s)" + e + "(?:$|\\s)\\s*");
      }
      var L = function(e, n) {
        var a = e.className, o = k(n).exec(a);
        if (o) {
          var s = a.slice(o.index + o[0].length);
          e.className = a.slice(0, o.index) + (s ? o[1] + s : "");
        }
      };
      function h(e) {
        for (var n = e.childNodes.length; n > 0; --n)
          e.removeChild(e.firstChild);
        return e;
      }
      function E(e, n) {
        return h(e).appendChild(n);
      }
      function w(e, n, a, o) {
        var s = document.createElement(e);
        if (a && (s.className = a), o && (s.style.cssText = o), typeof n == "string")
          s.appendChild(document.createTextNode(n));
        else if (n)
          for (var y = 0; y < n.length; ++y)
            s.appendChild(n[y]);
        return s;
      }
      function O(e, n, a, o) {
        var s = w(e, n, a, o);
        return s.setAttribute("role", "presentation"), s;
      }
      var R;
      document.createRange ? R = function(e, n, a, o) {
        var s = document.createRange();
        return s.setEnd(o || e, a), s.setStart(e, n), s;
      } : R = function(e, n, a) {
        var o = document.body.createTextRange();
        try {
          o.moveToElementText(e.parentNode);
        } catch (s) {
          return o;
        }
        return o.collapse(!0), o.moveEnd("character", a), o.moveStart("character", n), o;
      };
      function I(e, n) {
        if (n.nodeType == 3 && (n = n.parentNode), e.contains)
          return e.contains(n);
        do
          if (n.nodeType == 11 && (n = n.host), n == e)
            return !0;
        while (n = n.parentNode);
      }
      function H() {
        var e;
        try {
          e = document.activeElement;
        } catch (n) {
          e = document.body || null;
        }
        for (; e && e.shadowRoot && e.shadowRoot.activeElement; )
          e = e.shadowRoot.activeElement;
        return e;
      }
      function $(e, n) {
        var a = e.className;
        k(n).test(a) || (e.className += (a ? " " : "") + n);
      }
      function Q(e, n) {
        for (var a = e.split(" "), o = 0; o < a.length; o++)
          a[o] && !k(a[o]).test(n) && (n += " " + a[o]);
        return n;
      }
      var U = function(e) {
        e.select();
      };
      p ? U = function(e) {
        e.selectionStart = 0, e.selectionEnd = e.value.length;
      } : W && (U = function(e) {
        try {
          e.select();
        } catch (n) {
        }
      });
      function Y(e) {
        var n = Array.prototype.slice.call(arguments, 1);
        return function() {
          return e.apply(null, n);
        };
      }
      function X(e, n, a) {
        n || (n = {});
        for (var o in e)
          e.hasOwnProperty(o) && (a !== !1 || !n.hasOwnProperty(o)) && (n[o] = e[o]);
        return n;
      }
      function G(e, n, a, o, s) {
        n == null && (n = e.search(/[^\s\u00a0]/), n == -1 && (n = e.length));
        for (var y = o || 0, N = s || 0; ; ) {
          var B = e.indexOf("	", y);
          if (B < 0 || B >= n)
            return N + (n - y);
          N += B - y, N += a - N % a, y = B + 1;
        }
      }
      var J = function() {
        this.id = null, this.f = null, this.time = 0, this.handler = Y(this.onTimeout, this);
      };
      J.prototype.onTimeout = function(e) {
        e.id = 0, e.time <= +/* @__PURE__ */ new Date() ? e.f() : setTimeout(e.handler, e.time - +/* @__PURE__ */ new Date());
      }, J.prototype.set = function(e, n) {
        this.f = n;
        var a = +/* @__PURE__ */ new Date() + e;
        (!this.id || a < this.time) && (clearTimeout(this.id), this.id = setTimeout(this.handler, e), this.time = a);
      };
      function ee(e, n) {
        for (var a = 0; a < e.length; ++a)
          if (e[a] == n)
            return a;
        return -1;
      }
      var re = 50, oe = { toString: function() {
        return "CodeMirror.Pass";
      } }, ae = { scroll: !1 }, se = { origin: "*mouse" }, ve = { origin: "+move" };
      function Ae(e, n, a) {
        for (var o = 0, s = 0; ; ) {
          var y = e.indexOf("	", o);
          y == -1 && (y = e.length);
          var N = y - o;
          if (y == e.length || s + N >= n)
            return o + Math.min(N, n - s);
          if (s += y - o, s += a - s % a, o = y + 1, s >= n)
            return o;
        }
      }
      var ye = [""];
      function ce(e) {
        for (; ye.length <= e; )
          ye.push(he(ye) + " ");
        return ye[e];
      }
      function he(e) {
        return e[e.length - 1];
      }
      function ke(e, n) {
        for (var a = [], o = 0; o < e.length; o++)
          a[o] = n(e[o], o);
        return a;
      }
      function je(e, n, a) {
        for (var o = 0, s = a(n); o < e.length && a(e[o]) <= s; )
          o++;
        e.splice(o, 0, n);
      }
      function He() {
      }
      function Ve(e, n) {
        var a;
        return Object.create ? a = Object.create(e) : (He.prototype = e, a = new He()), n && X(n, a), a;
      }
      var qt = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
      function ln(e) {
        return /\w/.test(e) || e > "" && (e.toUpperCase() != e.toLowerCase() || qt.test(e));
      }
      function Ft(e, n) {
        return n ? n.source.indexOf("\\w") > -1 && ln(e) ? !0 : n.test(e) : ln(e);
      }
      function pn(e) {
        for (var n in e)
          if (e.hasOwnProperty(n) && e[n])
            return !1;
        return !0;
      }
      var _r = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
      function Bt(e) {
        return e.charCodeAt(0) >= 768 && _r.test(e);
      }
      function jt(e, n, a) {
        for (; (a < 0 ? n > 0 : n < e.length) && Bt(e.charAt(n)); )
          n += a;
        return n;
      }
      function sn(e, n, a) {
        for (var o = n > a ? -1 : 1; ; ) {
          if (n == a)
            return n;
          var s = (n + a) / 2, y = o < 0 ? Math.ceil(s) : Math.floor(s);
          if (y == n)
            return e(y) ? n : a;
          e(y) ? a = y : n = y + o;
        }
      }
      function Zt(e, n, a, o) {
        if (!e)
          return o(n, a, "ltr", 0);
        for (var s = !1, y = 0; y < e.length; ++y) {
          var N = e[y];
          (N.from < a && N.to > n || n == a && N.to == n) && (o(Math.max(N.from, n), Math.min(N.to, a), N.level == 1 ? "rtl" : "ltr", y), s = !0);
        }
        s || o(n, a, "ltr");
      }
      var st = null;
      function $t(e, n, a) {
        var o;
        st = null;
        for (var s = 0; s < e.length; ++s) {
          var y = e[s];
          if (y.from < n && y.to > n)
            return s;
          y.to == n && (y.from != y.to && a == "before" ? o = s : st = s), y.from == n && (y.from != y.to && a != "before" ? o = s : st = s);
        }
        return o != null ? o : st;
      }
      var zt = /* @__PURE__ */ function() {
        var e = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN", n = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
        function a(j) {
          return j <= 247 ? e.charAt(j) : 1424 <= j && j <= 1524 ? "R" : 1536 <= j && j <= 1785 ? n.charAt(j - 1536) : 1774 <= j && j <= 2220 ? "r" : 8192 <= j && j <= 8203 ? "w" : j == 8204 ? "b" : "L";
        }
        var o = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/, s = /[stwN]/, y = /[LRr]/, N = /[Lb1n]/, B = /[1n]/;
        function P(j, Z, te) {
          this.level = j, this.from = Z, this.to = te;
        }
        return function(j, Z) {
          var te = Z == "ltr" ? "L" : "R";
          if (j.length == 0 || Z == "ltr" && !o.test(j))
            return !1;
          for (var ue = j.length, le = [], pe = 0; pe < ue; ++pe)
            le.push(a(j.charCodeAt(pe)));
          for (var ge = 0, me = te; ge < ue; ++ge) {
            var xe = le[ge];
            xe == "m" ? le[ge] = me : me = xe;
          }
          for (var Se = 0, we = te; Se < ue; ++Se) {
            var Ee = le[Se];
            Ee == "1" && we == "r" ? le[Se] = "n" : y.test(Ee) && (we = Ee, Ee == "r" && (le[Se] = "R"));
          }
          for (var Le = 1, Re = le[0]; Le < ue - 1; ++Le) {
            var We = le[Le];
            We == "+" && Re == "1" && le[Le + 1] == "1" ? le[Le] = "1" : We == "," && Re == le[Le + 1] && (Re == "1" || Re == "n") && (le[Le] = Re), Re = We;
          }
          for (var ut = 0; ut < ue; ++ut) {
            var It = le[ut];
            if (It == ",")
              le[ut] = "N";
            else if (It == "%") {
              var vt = void 0;
              for (vt = ut + 1; vt < ue && le[vt] == "%"; ++vt)
                ;
              for (var fn = ut && le[ut - 1] == "!" || vt < ue && le[vt] == "1" ? "1" : "N", nn = ut; nn < vt; ++nn)
                le[nn] = fn;
              ut = vt - 1;
            }
          }
          for (var St = 0, rn = te; St < ue; ++St) {
            var Ht = le[St];
            rn == "L" && Ht == "1" ? le[St] = "L" : y.test(Ht) && (rn = Ht);
          }
          for (var Tt = 0; Tt < ue; ++Tt)
            if (s.test(le[Tt])) {
              var Et = void 0;
              for (Et = Tt + 1; Et < ue && s.test(le[Et]); ++Et)
                ;
              for (var mt = (Tt ? le[Tt - 1] : te) == "L", on = (Et < ue ? le[Et] : te) == "L", si = mt == on ? mt ? "L" : "R" : te, hr = Tt; hr < Et; ++hr)
                le[hr] = si;
              Tt = Et - 1;
            }
          for (var Wt = [], $n, Lt = 0; Lt < ue; )
            if (N.test(le[Lt])) {
              var yl = Lt;
              for (++Lt; Lt < ue && N.test(le[Lt]); ++Lt)
                ;
              Wt.push(new P(0, yl, Lt));
            } else {
              var Jn = Lt, Or = Wt.length, Rr = Z == "rtl" ? 1 : 0;
              for (++Lt; Lt < ue && le[Lt] != "L"; ++Lt)
                ;
              for (var Yt = Jn; Yt < Lt; )
                if (B.test(le[Yt])) {
                  Jn < Yt && (Wt.splice(Or, 0, new P(1, Jn, Yt)), Or += Rr);
                  var ui = Yt;
                  for (++Yt; Yt < Lt && B.test(le[Yt]); ++Yt)
                    ;
                  Wt.splice(Or, 0, new P(2, ui, Yt)), Or += Rr, Jn = Yt;
                } else
                  ++Yt;
              Jn < Lt && Wt.splice(Or, 0, new P(1, Jn, Lt));
            }
          return Z == "ltr" && (Wt[0].level == 1 && ($n = j.match(/^\s+/)) && (Wt[0].from = $n[0].length, Wt.unshift(new P(0, 0, $n[0].length))), he(Wt).level == 1 && ($n = j.match(/\s+$/)) && (he(Wt).to -= $n[0].length, Wt.push(new P(0, ue - $n[0].length, ue)))), Z == "rtl" ? Wt.reverse() : Wt;
        };
      }();
      function ct(e, n) {
        var a = e.order;
        return a == null && (a = e.order = zt(e.text, n)), a;
      }
      var An = [], fe = function(e, n, a) {
        if (e.addEventListener)
          e.addEventListener(n, a, !1);
        else if (e.attachEvent)
          e.attachEvent("on" + n, a);
        else {
          var o = e._handlers || (e._handlers = {});
          o[n] = (o[n] || An).concat(a);
        }
      };
      function Ne(e, n) {
        return e._handlers && e._handlers[n] || An;
      }
      function _e(e, n, a) {
        if (e.removeEventListener)
          e.removeEventListener(n, a, !1);
        else if (e.detachEvent)
          e.detachEvent("on" + n, a);
        else {
          var o = e._handlers, s = o && o[n];
          if (s) {
            var y = ee(s, a);
            y > -1 && (o[n] = s.slice(0, y).concat(s.slice(y + 1)));
          }
        }
      }
      function Oe(e, n) {
        var a = Ne(e, n);
        if (a.length)
          for (var o = Array.prototype.slice.call(arguments, 2), s = 0; s < a.length; ++s)
            a[s].apply(null, o);
      }
      function $e(e, n, a) {
        return typeof n == "string" && (n = { type: n, preventDefault: function() {
          this.defaultPrevented = !0;
        } }), Oe(e, a || n.type, e, n), ze(n) || n.codemirrorIgnore;
      }
      function Ct(e) {
        var n = e._handlers && e._handlers.cursorActivity;
        if (n)
          for (var a = e.curOp.cursorActivityHandlers || (e.curOp.cursorActivityHandlers = []), o = 0; o < n.length; ++o)
            ee(a, n[o]) == -1 && a.push(n[o]);
      }
      function nt(e, n) {
        return Ne(e, n).length > 0;
      }
      function be(e) {
        e.prototype.on = function(n, a) {
          fe(this, n, a);
        }, e.prototype.off = function(n, a) {
          _e(this, n, a);
        };
      }
      function Te(e) {
        e.preventDefault ? e.preventDefault() : e.returnValue = !1;
      }
      function Ie(e) {
        e.stopPropagation ? e.stopPropagation() : e.cancelBubble = !0;
      }
      function ze(e) {
        return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == !1;
      }
      function it(e) {
        Te(e), Ie(e);
      }
      function dt(e) {
        return e.target || e.srcElement;
      }
      function Vt(e) {
        var n = e.which;
        return n == null && (e.button & 1 ? n = 1 : e.button & 2 ? n = 3 : e.button & 4 && (n = 2)), g && e.ctrlKey && n == 1 && (n = 3), n;
      }
      var Rn = function() {
        if (W && K < 9)
          return !1;
        var e = w("div");
        return "draggable" in e || "dragDrop" in e;
      }(), xn;
      function ka(e) {
        if (xn == null) {
          var n = w("span", "​");
          E(e, w("span", [n, document.createTextNode("x")])), e.firstChild.offsetHeight != 0 && (xn = n.offsetWidth <= 1 && n.offsetHeight > 2 && !(W && K < 8));
        }
        var a = xn ? w("span", "​") : w("span", " ", null, "display: inline-block; width: 1px; margin-right: -1px");
        return a.setAttribute("cm-text", ""), a;
      }
      var zr;
      function bo(e) {
        if (zr != null)
          return zr;
        var n = E(e, document.createTextNode("AخA")), a = R(n, 0, 1).getBoundingClientRect(), o = R(n, 1, 2).getBoundingClientRect();
        return h(e), !a || a.left == a.right ? !1 : zr = o.right - a.right < 3;
      }
      var bi = `

b`.split(/\n/).length != 3 ? function(e) {
        for (var n = 0, a = [], o = e.length; n <= o; ) {
          var s = e.indexOf(`
`, n);
          s == -1 && (s = e.length);
          var y = e.slice(n, e.charAt(s - 1) == "\r" ? s - 1 : s), N = y.indexOf("\r");
          N != -1 ? (a.push(y.slice(0, N)), n += N + 1) : (a.push(y), n = s + 1);
        }
        return a;
      } : function(e) {
        return e.split(/\r\n?|\n/);
      }, tr = window.getSelection ? function(e) {
        try {
          return e.selectionStart != e.selectionEnd;
        } catch (n) {
          return !1;
        }
      } : function(e) {
        var n;
        try {
          n = e.ownerDocument.selection.createRange();
        } catch (a) {
        }
        return !n || n.parentElement() != e ? !1 : n.compareEndPoints("StartToEnd", n) != 0;
      }, In = function() {
        var e = w("div");
        return "oncopy" in e ? !0 : (e.setAttribute("oncopy", "return;"), typeof e.oncopy == "function");
      }(), Ln = null;
      function Ao(e) {
        if (Ln != null)
          return Ln;
        var n = E(e, w("span", "x")), a = n.getBoundingClientRect(), o = R(n, 0, 1).getBoundingClientRect();
        return Ln = Math.abs(a.left - o.left) > 1;
      }
      var Sn = {}, nr = {};
      function xo(e, n) {
        arguments.length > 2 && (n.dependencies = Array.prototype.slice.call(arguments, 2)), Sn[e] = n;
      }
      function Ur(e, n) {
        nr[e] = n;
      }
      function un(e) {
        if (typeof e == "string" && nr.hasOwnProperty(e))
          e = nr[e];
        else if (e && typeof e.name == "string" && nr.hasOwnProperty(e.name)) {
          var n = nr[e.name];
          typeof n == "string" && (n = { name: n }), e = Ve(n, e), e.name = n.name;
        } else {
          if (typeof e == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(e))
            return un("application/xml");
          if (typeof e == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(e))
            return un("application/json");
        }
        return typeof e == "string" ? { name: e } : e || { name: "null" };
      }
      function rr(e, n) {
        n = un(n);
        var a = Sn[n.name];
        if (!a)
          return rr(e, "text/plain");
        var o = a(e, n);
        if (ir.hasOwnProperty(n.name)) {
          var s = ir[n.name];
          for (var y in s)
            s.hasOwnProperty(y) && (o.hasOwnProperty(y) && (o["_" + y] = o[y]), o[y] = s[y]);
        }
        if (o.name = n.name, n.helperType && (o.helperType = n.helperType), n.modeProps)
          for (var N in n.modeProps)
            o[N] = n.modeProps[N];
        return o;
      }
      var ir = {};
      function wo(e, n) {
        var a = ir.hasOwnProperty(e) ? ir[e] : ir[e] = {};
        X(n, a);
      }
      function Qn(e, n) {
        if (n === !0)
          return n;
        if (e.copyState)
          return e.copyState(n);
        var a = {};
        for (var o in n) {
          var s = n[o];
          s instanceof Array && (s = s.concat([])), a[o] = s;
        }
        return a;
      }
      function or(e, n) {
        for (var a; e.innerMode && (a = e.innerMode(n), !(!a || a.mode == e)); )
          n = a.state, e = a.mode;
        return a || { mode: e, state: n };
      }
      function Ai(e, n, a) {
        return e.startState ? e.startState(n, a) : !0;
      }
      var gt = function(e, n, a) {
        this.pos = this.start = 0, this.string = e, this.tabSize = n || 8, this.lastColumnPos = this.lastColumnValue = 0, this.lineStart = 0, this.lineOracle = a;
      };
      gt.prototype.eol = function() {
        return this.pos >= this.string.length;
      }, gt.prototype.sol = function() {
        return this.pos == this.lineStart;
      }, gt.prototype.peek = function() {
        return this.string.charAt(this.pos) || void 0;
      }, gt.prototype.next = function() {
        if (this.pos < this.string.length)
          return this.string.charAt(this.pos++);
      }, gt.prototype.eat = function(e) {
        var n = this.string.charAt(this.pos), a;
        if (typeof e == "string" ? a = n == e : a = n && (e.test ? e.test(n) : e(n)), a)
          return ++this.pos, n;
      }, gt.prototype.eatWhile = function(e) {
        for (var n = this.pos; this.eat(e); )
          ;
        return this.pos > n;
      }, gt.prototype.eatSpace = function() {
        for (var e = this.pos; /[\s\u00a0]/.test(this.string.charAt(this.pos)); )
          ++this.pos;
        return this.pos > e;
      }, gt.prototype.skipToEnd = function() {
        this.pos = this.string.length;
      }, gt.prototype.skipTo = function(e) {
        var n = this.string.indexOf(e, this.pos);
        if (n > -1)
          return this.pos = n, !0;
      }, gt.prototype.backUp = function(e) {
        this.pos -= e;
      }, gt.prototype.column = function() {
        return this.lastColumnPos < this.start && (this.lastColumnValue = G(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue), this.lastColumnPos = this.start), this.lastColumnValue - (this.lineStart ? G(this.string, this.lineStart, this.tabSize) : 0);
      }, gt.prototype.indentation = function() {
        return G(this.string, null, this.tabSize) - (this.lineStart ? G(this.string, this.lineStart, this.tabSize) : 0);
      }, gt.prototype.match = function(e, n, a) {
        if (typeof e == "string") {
          var o = function(N) {
            return a ? N.toLowerCase() : N;
          }, s = this.string.substr(this.pos, e.length);
          if (o(s) == o(e))
            return n !== !1 && (this.pos += e.length), !0;
        } else {
          var y = this.string.slice(this.pos).match(e);
          return y && y.index > 0 ? null : (y && n !== !1 && (this.pos += y[0].length), y);
        }
      }, gt.prototype.current = function() {
        return this.string.slice(this.start, this.pos);
      }, gt.prototype.hideFirstChars = function(e, n) {
        this.lineStart += e;
        try {
          return n();
        } finally {
          this.lineStart -= e;
        }
      }, gt.prototype.lookAhead = function(e) {
        var n = this.lineOracle;
        return n && n.lookAhead(e);
      }, gt.prototype.baseToken = function() {
        var e = this.lineOracle;
        return e && e.baseToken(this.pos);
      };
      function De(e, n) {
        if (n -= e.first, n < 0 || n >= e.size)
          throw new Error("There is no line " + (n + e.first) + " in the document.");
        for (var a = e; !a.lines; )
          for (var o = 0; ; ++o) {
            var s = a.children[o], y = s.chunkSize();
            if (n < y) {
              a = s;
              break;
            }
            n -= y;
          }
        return a.lines[n];
      }
      function Vn(e, n, a) {
        var o = [], s = n.line;
        return e.iter(n.line, a.line + 1, function(y) {
          var N = y.text;
          s == a.line && (N = N.slice(0, a.ch)), s == n.line && (N = N.slice(n.ch)), o.push(N), ++s;
        }), o;
      }
      function Wr(e, n, a) {
        var o = [];
        return e.iter(n, a, function(s) {
          o.push(s.text);
        }), o;
      }
      function wn(e, n) {
        var a = n - e.height;
        if (a)
          for (var o = e; o; o = o.parent)
            o.height += a;
      }
      function Ze(e) {
        if (e.parent == null)
          return null;
        for (var n = e.parent, a = ee(n.lines, e), o = n.parent; o; n = o, o = o.parent)
          for (var s = 0; o.children[s] != n; ++s)
            a += o.children[s].chunkSize();
        return a + n.first;
      }
      function Fn(e, n) {
        var a = e.first;
        e: do {
          for (var o = 0; o < e.children.length; ++o) {
            var s = e.children[o], y = s.height;
            if (n < y) {
              e = s;
              continue e;
            }
            n -= y, a += s.chunkSize();
          }
          return a;
        } while (!e.lines);
        for (var N = 0; N < e.lines.length; ++N) {
          var B = e.lines[N], P = B.height;
          if (n < P)
            break;
          n -= P;
        }
        return a + N;
      }
      function V(e, n) {
        return n >= e.first && n < e.first + e.size;
      }
      function ne(e, n) {
        return String(e.lineNumberFormatter(n + e.firstLineNumber));
      }
      function ie(e, n, a) {
        if (a === void 0 && (a = null), !(this instanceof ie))
          return new ie(e, n, a);
        this.line = e, this.ch = n, this.sticky = a;
      }
      function de(e, n) {
        return e.line - n.line || e.ch - n.ch;
      }
      function Be(e, n) {
        return e.sticky == n.sticky && de(e, n) == 0;
      }
      function Ye(e) {
        return ie(e.line, e.ch);
      }
      function et(e, n) {
        return de(e, n) < 0 ? n : e;
      }
      function kt(e, n) {
        return de(e, n) < 0 ? e : n;
      }
      function hn(e, n) {
        return Math.max(e.first, Math.min(n, e.first + e.size - 1));
      }
      function Pe(e, n) {
        if (n.line < e.first)
          return ie(e.first, 0);
        var a = e.first + e.size - 1;
        return n.line > a ? ie(a, De(e, a).text.length) : md(n, De(e, n.line).text.length);
      }
      function md(e, n) {
        var a = e.ch;
        return a == null || a > n ? ie(e.line, n) : a < 0 ? ie(e.line, 0) : e;
      }
      function Os(e, n) {
        for (var a = [], o = 0; o < n.length; o++)
          a[o] = Pe(e, n[o]);
        return a;
      }
      var _o = function(e, n) {
        this.state = e, this.lookAhead = n;
      }, Bn = function(e, n, a, o) {
        this.state = n, this.doc = e, this.line = a, this.maxLookAhead = o || 0, this.baseTokens = null, this.baseTokenPos = 1;
      };
      Bn.prototype.lookAhead = function(e) {
        var n = this.doc.getLine(this.line + e);
        return n != null && e > this.maxLookAhead && (this.maxLookAhead = e), n;
      }, Bn.prototype.baseToken = function(e) {
        if (!this.baseTokens)
          return null;
        for (; this.baseTokens[this.baseTokenPos] <= e; )
          this.baseTokenPos += 2;
        var n = this.baseTokens[this.baseTokenPos + 1];
        return {
          type: n && n.replace(/( |^)overlay .*/, ""),
          size: this.baseTokens[this.baseTokenPos] - e
        };
      }, Bn.prototype.nextLine = function() {
        this.line++, this.maxLookAhead > 0 && this.maxLookAhead--;
      }, Bn.fromSaved = function(e, n, a) {
        return n instanceof _o ? new Bn(e, Qn(e.mode, n.state), a, n.lookAhead) : new Bn(e, Qn(e.mode, n), a);
      }, Bn.prototype.save = function(e) {
        var n = e !== !1 ? Qn(this.doc.mode, this.state) : this.state;
        return this.maxLookAhead > 0 ? new _o(n, this.maxLookAhead) : n;
      };
      function Rs(e, n, a, o) {
        var s = [e.state.modeGen], y = {};
        Hs(
          e,
          n.text,
          e.doc.mode,
          a,
          function(j, Z) {
            return s.push(j, Z);
          },
          y,
          o
        );
        for (var N = a.state, B = function(j) {
          a.baseTokens = s;
          var Z = e.state.overlays[j], te = 1, ue = 0;
          a.state = !0, Hs(e, n.text, Z.mode, a, function(le, pe) {
            for (var ge = te; ue < le; ) {
              var me = s[te];
              me > le && s.splice(te, 1, le, s[te + 1], me), te += 2, ue = Math.min(le, me);
            }
            if (pe)
              if (Z.opaque)
                s.splice(ge, te - ge, le, "overlay " + pe), te = ge + 2;
              else
                for (; ge < te; ge += 2) {
                  var xe = s[ge + 1];
                  s[ge + 1] = (xe ? xe + " " : "") + "overlay " + pe;
                }
          }, y), a.state = N, a.baseTokens = null, a.baseTokenPos = 1;
        }, P = 0; P < e.state.overlays.length; ++P) B(P);
        return { styles: s, classes: y.bgClass || y.textClass ? y : null };
      }
      function Is(e, n, a) {
        if (!n.styles || n.styles[0] != e.state.modeGen) {
          var o = xi(e, Ze(n)), s = n.text.length > e.options.maxHighlightLength && Qn(e.doc.mode, o.state), y = Rs(e, n, o);
          s && (o.state = s), n.stateAfter = o.save(!s), n.styles = y.styles, y.classes ? n.styleClasses = y.classes : n.styleClasses && (n.styleClasses = null), a === e.doc.highlightFrontier && (e.doc.modeFrontier = Math.max(e.doc.modeFrontier, ++e.doc.highlightFrontier));
        }
        return n.styles;
      }
      function xi(e, n, a) {
        var o = e.doc, s = e.display;
        if (!o.mode.startState)
          return new Bn(o, !0, n);
        var y = yd(e, n, a), N = y > o.first && De(o, y - 1).stateAfter, B = N ? Bn.fromSaved(o, N, y) : new Bn(o, Ai(o.mode), y);
        return o.iter(y, n, function(P) {
          Ta(e, P.text, B);
          var j = B.line;
          P.stateAfter = j == n - 1 || j % 5 == 0 || j >= s.viewFrom && j < s.viewTo ? B.save() : null, B.nextLine();
        }), a && (o.modeFrontier = B.line), B;
      }
      function Ta(e, n, a, o) {
        var s = e.doc.mode, y = new gt(n, e.options.tabSize, a);
        for (y.start = y.pos = o || 0, n == "" && Ls(s, a.state); !y.eol(); )
          Da(s, y, a.state), y.start = y.pos;
      }
      function Ls(e, n) {
        if (e.blankLine)
          return e.blankLine(n);
        if (e.innerMode) {
          var a = or(e, n);
          if (a.mode.blankLine)
            return a.mode.blankLine(a.state);
        }
      }
      function Da(e, n, a, o) {
        for (var s = 0; s < 10; s++) {
          o && (o[0] = or(e, a).mode);
          var y = e.token(n, a);
          if (n.pos > n.start)
            return y;
        }
        throw new Error("Mode " + e.name + " failed to advance stream.");
      }
      var Fs = function(e, n, a) {
        this.start = e.start, this.end = e.pos, this.string = e.current(), this.type = n || null, this.state = a;
      };
      function Bs(e, n, a, o) {
        var s = e.doc, y = s.mode, N;
        n = Pe(s, n);
        var B = De(s, n.line), P = xi(e, n.line, a), j = new gt(B.text, e.options.tabSize, P), Z;
        for (o && (Z = []); (o || j.pos < n.ch) && !j.eol(); )
          j.start = j.pos, N = Da(y, j, P.state), o && Z.push(new Fs(j, N, Qn(s.mode, P.state)));
        return o ? Z : new Fs(j, N, P.state);
      }
      function Ps(e, n) {
        if (e)
          for (; ; ) {
            var a = e.match(/(?:^|\s+)line-(background-)?(\S+)/);
            if (!a)
              break;
            e = e.slice(0, a.index) + e.slice(a.index + a[0].length);
            var o = a[1] ? "bgClass" : "textClass";
            n[o] == null ? n[o] = a[2] : new RegExp("(?:^|\\s)" + a[2] + "(?:$|\\s)").test(n[o]) || (n[o] += " " + a[2]);
          }
        return e;
      }
      function Hs(e, n, a, o, s, y, N) {
        var B = a.flattenSpans;
        B == null && (B = e.options.flattenSpans);
        var P = 0, j = null, Z = new gt(n, e.options.tabSize, o), te, ue = e.options.addModeClass && [null];
        for (n == "" && Ps(Ls(a, o.state), y); !Z.eol(); ) {
          if (Z.pos > e.options.maxHighlightLength ? (B = !1, N && Ta(e, n, o, Z.pos), Z.pos = n.length, te = null) : te = Ps(Da(a, Z, o.state, ue), y), ue) {
            var le = ue[0].name;
            le && (te = "m-" + (te ? le + " " + te : le));
          }
          if (!B || j != te) {
            for (; P < Z.start; )
              P = Math.min(Z.start, P + 5e3), s(P, j);
            j = te;
          }
          Z.start = Z.pos;
        }
        for (; P < Z.pos; ) {
          var pe = Math.min(Z.pos, P + 5e3);
          s(pe, j), P = pe;
        }
      }
      function yd(e, n, a) {
        for (var o, s, y = e.doc, N = a ? -1 : n - (e.doc.mode.innerMode ? 1e3 : 100), B = n; B > N; --B) {
          if (B <= y.first)
            return y.first;
          var P = De(y, B - 1), j = P.stateAfter;
          if (j && (!a || B + (j instanceof _o ? j.lookAhead : 0) <= y.modeFrontier))
            return B;
          var Z = G(P.text, null, e.options.tabSize);
          (s == null || o > Z) && (s = B - 1, o = Z);
        }
        return s;
      }
      function bd(e, n) {
        if (e.modeFrontier = Math.min(e.modeFrontier, n), !(e.highlightFrontier < n - 10)) {
          for (var a = e.first, o = n - 1; o > a; o--) {
            var s = De(e, o).stateAfter;
            if (s && (!(s instanceof _o) || o + s.lookAhead < n)) {
              a = o + 1;
              break;
            }
          }
          e.highlightFrontier = Math.min(e.highlightFrontier, a);
        }
      }
      var js = !1, Gn = !1;
      function Ad() {
        js = !0;
      }
      function xd() {
        Gn = !0;
      }
      function Co(e, n, a) {
        this.marker = e, this.from = n, this.to = a;
      }
      function wi(e, n) {
        if (e)
          for (var a = 0; a < e.length; ++a) {
            var o = e[a];
            if (o.marker == n)
              return o;
          }
      }
      function wd(e, n) {
        for (var a, o = 0; o < e.length; ++o)
          e[o] != n && (a || (a = [])).push(e[o]);
        return a;
      }
      function _d(e, n) {
        e.markedSpans = e.markedSpans ? e.markedSpans.concat([n]) : [n], n.marker.attachLine(e);
      }
      function Cd(e, n, a) {
        var o;
        if (e)
          for (var s = 0; s < e.length; ++s) {
            var y = e[s], N = y.marker, B = y.from == null || (N.inclusiveLeft ? y.from <= n : y.from < n);
            if (B || y.from == n && N.type == "bookmark" && (!a || !y.marker.insertLeft)) {
              var P = y.to == null || (N.inclusiveRight ? y.to >= n : y.to > n);
              (o || (o = [])).push(new Co(N, y.from, P ? null : y.to));
            }
          }
        return o;
      }
      function Sd(e, n, a) {
        var o;
        if (e)
          for (var s = 0; s < e.length; ++s) {
            var y = e[s], N = y.marker, B = y.to == null || (N.inclusiveRight ? y.to >= n : y.to > n);
            if (B || y.from == n && N.type == "bookmark" && (!a || y.marker.insertLeft)) {
              var P = y.from == null || (N.inclusiveLeft ? y.from <= n : y.from < n);
              (o || (o = [])).push(new Co(
                N,
                P ? null : y.from - n,
                y.to == null ? null : y.to - n
              ));
            }
          }
        return o;
      }
      function Ma(e, n) {
        if (n.full)
          return null;
        var a = V(e, n.from.line) && De(e, n.from.line).markedSpans, o = V(e, n.to.line) && De(e, n.to.line).markedSpans;
        if (!a && !o)
          return null;
        var s = n.from.ch, y = n.to.ch, N = de(n.from, n.to) == 0, B = Cd(a, s, N), P = Sd(o, y, N), j = n.text.length == 1, Z = he(n.text).length + (j ? s : 0);
        if (B)
          for (var te = 0; te < B.length; ++te) {
            var ue = B[te];
            if (ue.to == null) {
              var le = wi(P, ue.marker);
              le ? j && (ue.to = le.to == null ? null : le.to + Z) : ue.to = s;
            }
          }
        if (P)
          for (var pe = 0; pe < P.length; ++pe) {
            var ge = P[pe];
            if (ge.to != null && (ge.to += Z), ge.from == null) {
              var me = wi(B, ge.marker);
              me || (ge.from = Z, j && (B || (B = [])).push(ge));
            } else
              ge.from += Z, j && (B || (B = [])).push(ge);
          }
        B && (B = $s(B)), P && P != B && (P = $s(P));
        var xe = [B];
        if (!j) {
          var Se = n.text.length - 2, we;
          if (Se > 0 && B)
            for (var Ee = 0; Ee < B.length; ++Ee)
              B[Ee].to == null && (we || (we = [])).push(new Co(B[Ee].marker, null, null));
          for (var Le = 0; Le < Se; ++Le)
            xe.push(we);
          xe.push(P);
        }
        return xe;
      }
      function $s(e) {
        for (var n = 0; n < e.length; ++n) {
          var a = e[n];
          a.from != null && a.from == a.to && a.marker.clearWhenEmpty !== !1 && e.splice(n--, 1);
        }
        return e.length ? e : null;
      }
      function Ed(e, n, a) {
        var o = null;
        if (e.iter(n.line, a.line + 1, function(le) {
          if (le.markedSpans)
            for (var pe = 0; pe < le.markedSpans.length; ++pe) {
              var ge = le.markedSpans[pe].marker;
              ge.readOnly && (!o || ee(o, ge) == -1) && (o || (o = [])).push(ge);
            }
        }), !o)
          return null;
        for (var s = [{ from: n, to: a }], y = 0; y < o.length; ++y)
          for (var N = o[y], B = N.find(0), P = 0; P < s.length; ++P) {
            var j = s[P];
            if (!(de(j.to, B.from) < 0 || de(j.from, B.to) > 0)) {
              var Z = [P, 1], te = de(j.from, B.from), ue = de(j.to, B.to);
              (te < 0 || !N.inclusiveLeft && !te) && Z.push({ from: j.from, to: B.from }), (ue > 0 || !N.inclusiveRight && !ue) && Z.push({ from: B.to, to: j.to }), s.splice.apply(s, Z), P += Z.length - 3;
            }
          }
        return s;
      }
      function zs(e) {
        var n = e.markedSpans;
        if (n) {
          for (var a = 0; a < n.length; ++a)
            n[a].marker.detachLine(e);
          e.markedSpans = null;
        }
      }
      function Us(e, n) {
        if (n) {
          for (var a = 0; a < n.length; ++a)
            n[a].marker.attachLine(e);
          e.markedSpans = n;
        }
      }
      function So(e) {
        return e.inclusiveLeft ? -1 : 0;
      }
      function Eo(e) {
        return e.inclusiveRight ? 1 : 0;
      }
      function Na(e, n) {
        var a = e.lines.length - n.lines.length;
        if (a != 0)
          return a;
        var o = e.find(), s = n.find(), y = de(o.from, s.from) || So(e) - So(n);
        if (y)
          return -y;
        var N = de(o.to, s.to) || Eo(e) - Eo(n);
        return N || n.id - e.id;
      }
      function Ws(e, n) {
        var a = Gn && e.markedSpans, o;
        if (a)
          for (var s = void 0, y = 0; y < a.length; ++y)
            s = a[y], s.marker.collapsed && (n ? s.from : s.to) == null && (!o || Na(o, s.marker) < 0) && (o = s.marker);
        return o;
      }
      function Qs(e) {
        return Ws(e, !0);
      }
      function ko(e) {
        return Ws(e, !1);
      }
      function kd(e, n) {
        var a = Gn && e.markedSpans, o;
        if (a)
          for (var s = 0; s < a.length; ++s) {
            var y = a[s];
            y.marker.collapsed && (y.from == null || y.from < n) && (y.to == null || y.to > n) && (!o || Na(o, y.marker) < 0) && (o = y.marker);
          }
        return o;
      }
      function Vs(e, n, a, o, s) {
        var y = De(e, n), N = Gn && y.markedSpans;
        if (N)
          for (var B = 0; B < N.length; ++B) {
            var P = N[B];
            if (P.marker.collapsed) {
              var j = P.marker.find(0), Z = de(j.from, a) || So(P.marker) - So(s), te = de(j.to, o) || Eo(P.marker) - Eo(s);
              if (!(Z >= 0 && te <= 0 || Z <= 0 && te >= 0) && (Z <= 0 && (P.marker.inclusiveRight && s.inclusiveLeft ? de(j.to, a) >= 0 : de(j.to, a) > 0) || Z >= 0 && (P.marker.inclusiveRight && s.inclusiveLeft ? de(j.from, o) <= 0 : de(j.from, o) < 0)))
                return !0;
            }
          }
      }
      function Pn(e) {
        for (var n; n = Qs(e); )
          e = n.find(-1, !0).line;
        return e;
      }
      function Td(e) {
        for (var n; n = ko(e); )
          e = n.find(1, !0).line;
        return e;
      }
      function Dd(e) {
        for (var n, a; n = ko(e); )
          e = n.find(1, !0).line, (a || (a = [])).push(e);
        return a;
      }
      function Oa(e, n) {
        var a = De(e, n), o = Pn(a);
        return a == o ? n : Ze(o);
      }
      function Gs(e, n) {
        if (n > e.lastLine())
          return n;
        var a = De(e, n), o;
        if (!ar(e, a))
          return n;
        for (; o = ko(a); )
          a = o.find(1, !0).line;
        return Ze(a) + 1;
      }
      function ar(e, n) {
        var a = Gn && n.markedSpans;
        if (a) {
          for (var o = void 0, s = 0; s < a.length; ++s)
            if (o = a[s], !!o.marker.collapsed) {
              if (o.from == null)
                return !0;
              if (!o.marker.widgetNode && o.from == 0 && o.marker.inclusiveLeft && Ra(e, n, o))
                return !0;
            }
        }
      }
      function Ra(e, n, a) {
        if (a.to == null) {
          var o = a.marker.find(1, !0);
          return Ra(e, o.line, wi(o.line.markedSpans, a.marker));
        }
        if (a.marker.inclusiveRight && a.to == n.text.length)
          return !0;
        for (var s = void 0, y = 0; y < n.markedSpans.length; ++y)
          if (s = n.markedSpans[y], s.marker.collapsed && !s.marker.widgetNode && s.from == a.to && (s.to == null || s.to != a.from) && (s.marker.inclusiveLeft || a.marker.inclusiveRight) && Ra(e, n, s))
            return !0;
      }
      function Yn(e) {
        e = Pn(e);
        for (var n = 0, a = e.parent, o = 0; o < a.lines.length; ++o) {
          var s = a.lines[o];
          if (s == e)
            break;
          n += s.height;
        }
        for (var y = a.parent; y; a = y, y = a.parent)
          for (var N = 0; N < y.children.length; ++N) {
            var B = y.children[N];
            if (B == a)
              break;
            n += B.height;
          }
        return n;
      }
      function To(e) {
        if (e.height == 0)
          return 0;
        for (var n = e.text.length, a, o = e; a = Qs(o); ) {
          var s = a.find(0, !0);
          o = s.from.line, n += s.from.ch - s.to.ch;
        }
        for (o = e; a = ko(o); ) {
          var y = a.find(0, !0);
          n -= o.text.length - y.from.ch, o = y.to.line, n += o.text.length - y.to.ch;
        }
        return n;
      }
      function Ia(e) {
        var n = e.display, a = e.doc;
        n.maxLine = De(a, a.first), n.maxLineLength = To(n.maxLine), n.maxLineChanged = !0, a.iter(function(o) {
          var s = To(o);
          s > n.maxLineLength && (n.maxLineLength = s, n.maxLine = o);
        });
      }
      var Qr = function(e, n, a) {
        this.text = e, Us(this, n), this.height = a ? a(this) : 1;
      };
      Qr.prototype.lineNo = function() {
        return Ze(this);
      }, be(Qr);
      function Md(e, n, a, o) {
        e.text = n, e.stateAfter && (e.stateAfter = null), e.styles && (e.styles = null), e.order != null && (e.order = null), zs(e), Us(e, a);
        var s = o ? o(e) : 1;
        s != e.height && wn(e, s);
      }
      function Nd(e) {
        e.parent = null, zs(e);
      }
      var Od = {}, Rd = {};
      function Ys(e, n) {
        if (!e || /^\s*$/.test(e))
          return null;
        var a = n.addModeClass ? Rd : Od;
        return a[e] || (a[e] = e.replace(/\S+/g, "cm-$&"));
      }
      function Ks(e, n) {
        var a = O("span", null, null, q ? "padding-right: .1px" : null), o = {
          pre: O("pre", [a], "CodeMirror-line"),
          content: a,
          col: 0,
          pos: 0,
          cm: e,
          trailingSpace: !1,
          splitSpaces: e.getOption("lineWrapping")
        };
        n.measure = {};
        for (var s = 0; s <= (n.rest ? n.rest.length : 0); s++) {
          var y = s ? n.rest[s - 1] : n.line, N = void 0;
          o.pos = 0, o.addToken = Ld, bo(e.display.measure) && (N = ct(y, e.doc.direction)) && (o.addToken = Bd(o.addToken, N)), o.map = [];
          var B = n != e.display.externalMeasured && Ze(y);
          Pd(y, o, Is(e, y, B)), y.styleClasses && (y.styleClasses.bgClass && (o.bgClass = Q(y.styleClasses.bgClass, o.bgClass || "")), y.styleClasses.textClass && (o.textClass = Q(y.styleClasses.textClass, o.textClass || ""))), o.map.length == 0 && o.map.push(0, 0, o.content.appendChild(ka(e.display.measure))), s == 0 ? (n.measure.map = o.map, n.measure.cache = {}) : ((n.measure.maps || (n.measure.maps = [])).push(o.map), (n.measure.caches || (n.measure.caches = [])).push({}));
        }
        if (q) {
          var P = o.content.lastChild;
          (/\bcm-tab\b/.test(P.className) || P.querySelector && P.querySelector(".cm-tab")) && (o.content.className = "cm-tab-wrap-hack");
        }
        return Oe(e, "renderLine", e, n.line, o.pre), o.pre.className && (o.textClass = Q(o.pre.className, o.textClass || "")), o;
      }
      function Id(e) {
        var n = w("span", "•", "cm-invalidchar");
        return n.title = "\\u" + e.charCodeAt(0).toString(16), n.setAttribute("aria-label", n.title), n;
      }
      function Ld(e, n, a, o, s, y, N) {
        if (n) {
          var B = e.splitSpaces ? Fd(n, e.trailingSpace) : n, P = e.cm.state.specialChars, j = !1, Z;
          if (!P.test(n))
            e.col += n.length, Z = document.createTextNode(B), e.map.push(e.pos, e.pos + n.length, Z), W && K < 9 && (j = !0), e.pos += n.length;
          else {
            Z = document.createDocumentFragment();
            for (var te = 0; ; ) {
              P.lastIndex = te;
              var ue = P.exec(n), le = ue ? ue.index - te : n.length - te;
              if (le) {
                var pe = document.createTextNode(B.slice(te, te + le));
                W && K < 9 ? Z.appendChild(w("span", [pe])) : Z.appendChild(pe), e.map.push(e.pos, e.pos + le, pe), e.col += le, e.pos += le;
              }
              if (!ue)
                break;
              te += le + 1;
              var ge = void 0;
              if (ue[0] == "	") {
                var me = e.cm.options.tabSize, xe = me - e.col % me;
                ge = Z.appendChild(w("span", ce(xe), "cm-tab")), ge.setAttribute("role", "presentation"), ge.setAttribute("cm-text", "	"), e.col += xe;
              } else ue[0] == "\r" || ue[0] == `
` ? (ge = Z.appendChild(w("span", ue[0] == "\r" ? "␍" : "␤", "cm-invalidchar")), ge.setAttribute("cm-text", ue[0]), e.col += 1) : (ge = e.cm.options.specialCharPlaceholder(ue[0]), ge.setAttribute("cm-text", ue[0]), W && K < 9 ? Z.appendChild(w("span", [ge])) : Z.appendChild(ge), e.col += 1);
              e.map.push(e.pos, e.pos + 1, ge), e.pos++;
            }
          }
          if (e.trailingSpace = B.charCodeAt(n.length - 1) == 32, a || o || s || j || y || N) {
            var Se = a || "";
            o && (Se += o), s && (Se += s);
            var we = w("span", [Z], Se, y);
            if (N)
              for (var Ee in N)
                N.hasOwnProperty(Ee) && Ee != "style" && Ee != "class" && we.setAttribute(Ee, N[Ee]);
            return e.content.appendChild(we);
          }
          e.content.appendChild(Z);
        }
      }
      function Fd(e, n) {
        if (e.length > 1 && !/  /.test(e))
          return e;
        for (var a = n, o = "", s = 0; s < e.length; s++) {
          var y = e.charAt(s);
          y == " " && a && (s == e.length - 1 || e.charCodeAt(s + 1) == 32) && (y = " "), o += y, a = y == " ";
        }
        return o;
      }
      function Bd(e, n) {
        return function(a, o, s, y, N, B, P) {
          s = s ? s + " cm-force-border" : "cm-force-border";
          for (var j = a.pos, Z = j + o.length; ; ) {
            for (var te = void 0, ue = 0; ue < n.length && (te = n[ue], !(te.to > j && te.from <= j)); ue++)
              ;
            if (te.to >= Z)
              return e(a, o, s, y, N, B, P);
            e(a, o.slice(0, te.to - j), s, y, null, B, P), y = null, o = o.slice(te.to - j), j = te.to;
          }
        };
      }
      function Xs(e, n, a, o) {
        var s = !o && a.widgetNode;
        s && e.map.push(e.pos, e.pos + n, s), !o && e.cm.display.input.needsContentAttribute && (s || (s = e.content.appendChild(document.createElement("span"))), s.setAttribute("cm-marker", a.id)), s && (e.cm.display.input.setUneditable(s), e.content.appendChild(s)), e.pos += n, e.trailingSpace = !1;
      }
      function Pd(e, n, a) {
        var o = e.markedSpans, s = e.text, y = 0;
        if (!o) {
          for (var N = 1; N < a.length; N += 2)
            n.addToken(n, s.slice(y, y = a[N]), Ys(a[N + 1], n.cm.options));
          return;
        }
        for (var B = s.length, P = 0, j = 1, Z = "", te, ue, le = 0, pe, ge, me, xe, Se; ; ) {
          if (le == P) {
            pe = ge = me = ue = "", Se = null, xe = null, le = 1 / 0;
            for (var we = [], Ee = void 0, Le = 0; Le < o.length; ++Le) {
              var Re = o[Le], We = Re.marker;
              if (We.type == "bookmark" && Re.from == P && We.widgetNode)
                we.push(We);
              else if (Re.from <= P && (Re.to == null || Re.to > P || We.collapsed && Re.to == P && Re.from == P)) {
                if (Re.to != null && Re.to != P && le > Re.to && (le = Re.to, ge = ""), We.className && (pe += " " + We.className), We.css && (ue = (ue ? ue + ";" : "") + We.css), We.startStyle && Re.from == P && (me += " " + We.startStyle), We.endStyle && Re.to == le && (Ee || (Ee = [])).push(We.endStyle, Re.to), We.title && ((Se || (Se = {})).title = We.title), We.attributes)
                  for (var ut in We.attributes)
                    (Se || (Se = {}))[ut] = We.attributes[ut];
                We.collapsed && (!xe || Na(xe.marker, We) < 0) && (xe = Re);
              } else Re.from > P && le > Re.from && (le = Re.from);
            }
            if (Ee)
              for (var It = 0; It < Ee.length; It += 2)
                Ee[It + 1] == le && (ge += " " + Ee[It]);
            if (!xe || xe.from == P)
              for (var vt = 0; vt < we.length; ++vt)
                Xs(n, 0, we[vt]);
            if (xe && (xe.from || 0) == P) {
              if (Xs(
                n,
                (xe.to == null ? B + 1 : xe.to) - P,
                xe.marker,
                xe.from == null
              ), xe.to == null)
                return;
              xe.to == P && (xe = !1);
            }
          }
          if (P >= B)
            break;
          for (var fn = Math.min(B, le); ; ) {
            if (Z) {
              var nn = P + Z.length;
              if (!xe) {
                var St = nn > fn ? Z.slice(0, fn - P) : Z;
                n.addToken(
                  n,
                  St,
                  te ? te + pe : pe,
                  me,
                  P + St.length == le ? ge : "",
                  ue,
                  Se
                );
              }
              if (nn >= fn) {
                Z = Z.slice(fn - P), P = fn;
                break;
              }
              P = nn, me = "";
            }
            Z = s.slice(y, y = a[j++]), te = Ys(a[j++], n.cm.options);
          }
        }
      }
      function Js(e, n, a) {
        this.line = n, this.rest = Dd(n), this.size = this.rest ? Ze(he(this.rest)) - a + 1 : 1, this.node = this.text = null, this.hidden = ar(e, n);
      }
      function Do(e, n, a) {
        for (var o = [], s, y = n; y < a; y = s) {
          var N = new Js(e.doc, De(e.doc, y), y);
          s = y + N.size, o.push(N);
        }
        return o;
      }
      var Vr = null;
      function Hd(e) {
        Vr ? Vr.ops.push(e) : e.ownsGroup = Vr = {
          ops: [e],
          delayedCallbacks: []
        };
      }
      function jd(e) {
        var n = e.delayedCallbacks, a = 0;
        do {
          for (; a < n.length; a++)
            n[a].call(null);
          for (var o = 0; o < e.ops.length; o++) {
            var s = e.ops[o];
            if (s.cursorActivityHandlers)
              for (; s.cursorActivityCalled < s.cursorActivityHandlers.length; )
                s.cursorActivityHandlers[s.cursorActivityCalled++].call(null, s.cm);
          }
        } while (a < n.length);
      }
      function $d(e, n) {
        var a = e.ownsGroup;
        if (a)
          try {
            jd(a);
          } finally {
            Vr = null, n(a);
          }
      }
      var _i = null;
      function Pt(e, n) {
        var a = Ne(e, n);
        if (a.length) {
          var o = Array.prototype.slice.call(arguments, 2), s;
          Vr ? s = Vr.delayedCallbacks : _i ? s = _i : (s = _i = [], setTimeout(zd, 0));
          for (var y = function(B) {
            s.push(function() {
              return a[B].apply(null, o);
            });
          }, N = 0; N < a.length; ++N)
            y(N);
        }
      }
      function zd() {
        var e = _i;
        _i = null;
        for (var n = 0; n < e.length; ++n)
          e[n]();
      }
      function qs(e, n, a, o) {
        for (var s = 0; s < n.changes.length; s++) {
          var y = n.changes[s];
          y == "text" ? Wd(e, n) : y == "gutter" ? eu(e, n, a, o) : y == "class" ? La(e, n) : y == "widget" && Qd(e, n, o);
        }
        n.changes = null;
      }
      function Ci(e) {
        return e.node == e.text && (e.node = w("div", null, null, "position: relative"), e.text.parentNode && e.text.parentNode.replaceChild(e.node, e.text), e.node.appendChild(e.text), W && K < 8 && (e.node.style.zIndex = 2)), e.node;
      }
      function Ud(e, n) {
        var a = n.bgClass ? n.bgClass + " " + (n.line.bgClass || "") : n.line.bgClass;
        if (a && (a += " CodeMirror-linebackground"), n.background)
          a ? n.background.className = a : (n.background.parentNode.removeChild(n.background), n.background = null);
        else if (a) {
          var o = Ci(n);
          n.background = o.insertBefore(w("div", null, a), o.firstChild), e.display.input.setUneditable(n.background);
        }
      }
      function Zs(e, n) {
        var a = e.display.externalMeasured;
        return a && a.line == n.line ? (e.display.externalMeasured = null, n.measure = a.measure, a.built) : Ks(e, n);
      }
      function Wd(e, n) {
        var a = n.text.className, o = Zs(e, n);
        n.text == n.node && (n.node = o.pre), n.text.parentNode.replaceChild(o.pre, n.text), n.text = o.pre, o.bgClass != n.bgClass || o.textClass != n.textClass ? (n.bgClass = o.bgClass, n.textClass = o.textClass, La(e, n)) : a && (n.text.className = a);
      }
      function La(e, n) {
        Ud(e, n), n.line.wrapClass ? Ci(n).className = n.line.wrapClass : n.node != n.text && (n.node.className = "");
        var a = n.textClass ? n.textClass + " " + (n.line.textClass || "") : n.line.textClass;
        n.text.className = a || "";
      }
      function eu(e, n, a, o) {
        if (n.gutter && (n.node.removeChild(n.gutter), n.gutter = null), n.gutterBackground && (n.node.removeChild(n.gutterBackground), n.gutterBackground = null), n.line.gutterClass) {
          var s = Ci(n);
          n.gutterBackground = w(
            "div",
            null,
            "CodeMirror-gutter-background " + n.line.gutterClass,
            "left: " + (e.options.fixedGutter ? o.fixedPos : -o.gutterTotalWidth) + "px; width: " + o.gutterTotalWidth + "px"
          ), e.display.input.setUneditable(n.gutterBackground), s.insertBefore(n.gutterBackground, n.text);
        }
        var y = n.line.gutterMarkers;
        if (e.options.lineNumbers || y) {
          var N = Ci(n), B = n.gutter = w("div", null, "CodeMirror-gutter-wrapper", "left: " + (e.options.fixedGutter ? o.fixedPos : -o.gutterTotalWidth) + "px");
          if (e.display.input.setUneditable(B), N.insertBefore(B, n.text), n.line.gutterClass && (B.className += " " + n.line.gutterClass), e.options.lineNumbers && (!y || !y["CodeMirror-linenumbers"]) && (n.lineNumber = B.appendChild(
            w(
              "div",
              ne(e.options, a),
              "CodeMirror-linenumber CodeMirror-gutter-elt",
              "left: " + o.gutterLeft["CodeMirror-linenumbers"] + "px; width: " + e.display.lineNumInnerWidth + "px"
            )
          )), y)
            for (var P = 0; P < e.display.gutterSpecs.length; ++P) {
              var j = e.display.gutterSpecs[P].className, Z = y.hasOwnProperty(j) && y[j];
              Z && B.appendChild(w(
                "div",
                [Z],
                "CodeMirror-gutter-elt",
                "left: " + o.gutterLeft[j] + "px; width: " + o.gutterWidth[j] + "px"
              ));
            }
        }
      }
      function Qd(e, n, a) {
        n.alignable && (n.alignable = null);
        for (var o = k("CodeMirror-linewidget"), s = n.node.firstChild, y = void 0; s; s = y)
          y = s.nextSibling, o.test(s.className) && n.node.removeChild(s);
        tu(e, n, a);
      }
      function Vd(e, n, a, o) {
        var s = Zs(e, n);
        return n.text = n.node = s.pre, s.bgClass && (n.bgClass = s.bgClass), s.textClass && (n.textClass = s.textClass), La(e, n), eu(e, n, a, o), tu(e, n, o), n.node;
      }
      function tu(e, n, a) {
        if (nu(e, n.line, n, a, !0), n.rest)
          for (var o = 0; o < n.rest.length; o++)
            nu(e, n.rest[o], n, a, !1);
      }
      function nu(e, n, a, o, s) {
        if (n.widgets)
          for (var y = Ci(a), N = 0, B = n.widgets; N < B.length; ++N) {
            var P = B[N], j = w("div", [P.node], "CodeMirror-linewidget" + (P.className ? " " + P.className : ""));
            P.handleMouseEvents || j.setAttribute("cm-ignore-events", "true"), Gd(P, j, a, o), e.display.input.setUneditable(j), s && P.above ? y.insertBefore(j, a.gutter || a.text) : y.appendChild(j), Pt(P, "redraw");
          }
      }
      function Gd(e, n, a, o) {
        if (e.noHScroll) {
          (a.alignable || (a.alignable = [])).push(n);
          var s = o.wrapperWidth;
          n.style.left = o.fixedPos + "px", e.coverGutter || (s -= o.gutterTotalWidth, n.style.paddingLeft = o.gutterTotalWidth + "px"), n.style.width = s + "px";
        }
        e.coverGutter && (n.style.zIndex = 5, n.style.position = "relative", e.noHScroll || (n.style.marginLeft = -o.gutterTotalWidth + "px"));
      }
      function Si(e) {
        if (e.height != null)
          return e.height;
        var n = e.doc.cm;
        if (!n)
          return 0;
        if (!I(document.body, e.node)) {
          var a = "position: relative;";
          e.coverGutter && (a += "margin-left: -" + n.display.gutters.offsetWidth + "px;"), e.noHScroll && (a += "width: " + n.display.wrapper.clientWidth + "px;"), E(n.display.measure, w("div", [e.node], null, a));
        }
        return e.height = e.node.parentNode.offsetHeight;
      }
      function Kn(e, n) {
        for (var a = dt(n); a != e.wrapper; a = a.parentNode)
          if (!a || a.nodeType == 1 && a.getAttribute("cm-ignore-events") == "true" || a.parentNode == e.sizer && a != e.mover)
            return !0;
      }
      function Mo(e) {
        return e.lineSpace.offsetTop;
      }
      function Fa(e) {
        return e.mover.offsetHeight - e.lineSpace.offsetHeight;
      }
      function ru(e) {
        if (e.cachedPaddingH)
          return e.cachedPaddingH;
        var n = E(e.measure, w("pre", "x", "CodeMirror-line-like")), a = window.getComputedStyle ? window.getComputedStyle(n) : n.currentStyle, o = { left: parseInt(a.paddingLeft), right: parseInt(a.paddingRight) };
        return !isNaN(o.left) && !isNaN(o.right) && (e.cachedPaddingH = o), o;
      }
      function Hn(e) {
        return re - e.display.nativeBarWidth;
      }
      function Cr(e) {
        return e.display.scroller.clientWidth - Hn(e) - e.display.barWidth;
      }
      function Ba(e) {
        return e.display.scroller.clientHeight - Hn(e) - e.display.barHeight;
      }
      function Yd(e, n, a) {
        var o = e.options.lineWrapping, s = o && Cr(e);
        if (!n.measure.heights || o && n.measure.width != s) {
          var y = n.measure.heights = [];
          if (o) {
            n.measure.width = s;
            for (var N = n.text.firstChild.getClientRects(), B = 0; B < N.length - 1; B++) {
              var P = N[B], j = N[B + 1];
              Math.abs(P.bottom - j.bottom) > 2 && y.push((P.bottom + j.top) / 2 - a.top);
            }
          }
          y.push(a.bottom - a.top);
        }
      }
      function iu(e, n, a) {
        if (e.line == n)
          return { map: e.measure.map, cache: e.measure.cache };
        for (var o = 0; o < e.rest.length; o++)
          if (e.rest[o] == n)
            return { map: e.measure.maps[o], cache: e.measure.caches[o] };
        for (var s = 0; s < e.rest.length; s++)
          if (Ze(e.rest[s]) > a)
            return { map: e.measure.maps[s], cache: e.measure.caches[s], before: !0 };
      }
      function Kd(e, n) {
        n = Pn(n);
        var a = Ze(n), o = e.display.externalMeasured = new Js(e.doc, n, a);
        o.lineN = a;
        var s = o.built = Ks(e, o);
        return o.text = s.pre, E(e.display.lineMeasure, s.pre), o;
      }
      function ou(e, n, a, o) {
        return jn(e, Gr(e, n), a, o);
      }
      function Pa(e, n) {
        if (n >= e.display.viewFrom && n < e.display.viewTo)
          return e.display.view[kr(e, n)];
        var a = e.display.externalMeasured;
        if (a && n >= a.lineN && n < a.lineN + a.size)
          return a;
      }
      function Gr(e, n) {
        var a = Ze(n), o = Pa(e, a);
        o && !o.text ? o = null : o && o.changes && (qs(e, o, a, Wa(e)), e.curOp.forceUpdate = !0), o || (o = Kd(e, n));
        var s = iu(o, n, a);
        return {
          line: n,
          view: o,
          rect: null,
          map: s.map,
          cache: s.cache,
          before: s.before,
          hasHeights: !1
        };
      }
      function jn(e, n, a, o, s) {
        n.before && (a = -1);
        var y = a + (o || ""), N;
        return n.cache.hasOwnProperty(y) ? N = n.cache[y] : (n.rect || (n.rect = n.view.text.getBoundingClientRect()), n.hasHeights || (Yd(e, n.view, n.rect), n.hasHeights = !0), N = Jd(e, n, a, o), N.bogus || (n.cache[y] = N)), {
          left: N.left,
          right: N.right,
          top: s ? N.rtop : N.top,
          bottom: s ? N.rbottom : N.bottom
        };
      }
      var au = { left: 0, right: 0, top: 0, bottom: 0 };
      function lu(e, n, a) {
        for (var o, s, y, N, B, P, j = 0; j < e.length; j += 3)
          if (B = e[j], P = e[j + 1], n < B ? (s = 0, y = 1, N = "left") : n < P ? (s = n - B, y = s + 1) : (j == e.length - 3 || n == P && e[j + 3] > n) && (y = P - B, s = y - 1, n >= P && (N = "right")), s != null) {
            if (o = e[j + 2], B == P && a == (o.insertLeft ? "left" : "right") && (N = a), a == "left" && s == 0)
              for (; j && e[j - 2] == e[j - 3] && e[j - 1].insertLeft; )
                o = e[(j -= 3) + 2], N = "left";
            if (a == "right" && s == P - B)
              for (; j < e.length - 3 && e[j + 3] == e[j + 4] && !e[j + 5].insertLeft; )
                o = e[(j += 3) + 2], N = "right";
            break;
          }
        return { node: o, start: s, end: y, collapse: N, coverStart: B, coverEnd: P };
      }
      function Xd(e, n) {
        var a = au;
        if (n == "left")
          for (var o = 0; o < e.length && (a = e[o]).left == a.right; o++)
            ;
        else
          for (var s = e.length - 1; s >= 0 && (a = e[s]).left == a.right; s--)
            ;
        return a;
      }
      function Jd(e, n, a, o) {
        var s = lu(n.map, a, o), y = s.node, N = s.start, B = s.end, P = s.collapse, j;
        if (y.nodeType == 3) {
          for (var Z = 0; Z < 4; Z++) {
            for (; N && Bt(n.line.text.charAt(s.coverStart + N)); )
              --N;
            for (; s.coverStart + B < s.coverEnd && Bt(n.line.text.charAt(s.coverStart + B)); )
              ++B;
            if (W && K < 9 && N == 0 && B == s.coverEnd - s.coverStart ? j = y.parentNode.getBoundingClientRect() : j = Xd(R(y, N, B).getClientRects(), o), j.left || j.right || N == 0)
              break;
            B = N, N = N - 1, P = "right";
          }
          W && K < 11 && (j = qd(e.display.measure, j));
        } else {
          N > 0 && (P = o = "right");
          var te;
          e.options.lineWrapping && (te = y.getClientRects()).length > 1 ? j = te[o == "right" ? te.length - 1 : 0] : j = y.getBoundingClientRect();
        }
        if (W && K < 9 && !N && (!j || !j.left && !j.right)) {
          var ue = y.parentNode.getClientRects()[0];
          ue ? j = { left: ue.left, right: ue.left + Kr(e.display), top: ue.top, bottom: ue.bottom } : j = au;
        }
        for (var le = j.top - n.rect.top, pe = j.bottom - n.rect.top, ge = (le + pe) / 2, me = n.view.measure.heights, xe = 0; xe < me.length - 1 && !(ge < me[xe]); xe++)
          ;
        var Se = xe ? me[xe - 1] : 0, we = me[xe], Ee = {
          left: (P == "right" ? j.right : j.left) - n.rect.left,
          right: (P == "left" ? j.left : j.right) - n.rect.left,
          top: Se,
          bottom: we
        };
        return !j.left && !j.right && (Ee.bogus = !0), e.options.singleCursorHeightPerLine || (Ee.rtop = le, Ee.rbottom = pe), Ee;
      }
      function qd(e, n) {
        if (!window.screen || screen.logicalXDPI == null || screen.logicalXDPI == screen.deviceXDPI || !Ao(e))
          return n;
        var a = screen.logicalXDPI / screen.deviceXDPI, o = screen.logicalYDPI / screen.deviceYDPI;
        return {
          left: n.left * a,
          right: n.right * a,
          top: n.top * o,
          bottom: n.bottom * o
        };
      }
      function su(e) {
        if (e.measure && (e.measure.cache = {}, e.measure.heights = null, e.rest))
          for (var n = 0; n < e.rest.length; n++)
            e.measure.caches[n] = {};
      }
      function uu(e) {
        e.display.externalMeasure = null, h(e.display.lineMeasure);
        for (var n = 0; n < e.display.view.length; n++)
          su(e.display.view[n]);
      }
      function Ei(e) {
        uu(e), e.display.cachedCharWidth = e.display.cachedTextHeight = e.display.cachedPaddingH = null, e.options.lineWrapping || (e.display.maxLineChanged = !0), e.display.lineNumChars = null;
      }
      function cu() {
        return d && b ? -(document.body.getBoundingClientRect().left - parseInt(getComputedStyle(document.body).marginLeft)) : window.pageXOffset || (document.documentElement || document.body).scrollLeft;
      }
      function fu() {
        return d && b ? -(document.body.getBoundingClientRect().top - parseInt(getComputedStyle(document.body).marginTop)) : window.pageYOffset || (document.documentElement || document.body).scrollTop;
      }
      function Ha(e) {
        var n = 0;
        if (e.widgets)
          for (var a = 0; a < e.widgets.length; ++a)
            e.widgets[a].above && (n += Si(e.widgets[a]));
        return n;
      }
      function No(e, n, a, o, s) {
        if (!s) {
          var y = Ha(n);
          a.top += y, a.bottom += y;
        }
        if (o == "line")
          return a;
        o || (o = "local");
        var N = Yn(n);
        if (o == "local" ? N += Mo(e.display) : N -= e.display.viewOffset, o == "page" || o == "window") {
          var B = e.display.lineSpace.getBoundingClientRect();
          N += B.top + (o == "window" ? 0 : fu());
          var P = B.left + (o == "window" ? 0 : cu());
          a.left += P, a.right += P;
        }
        return a.top += N, a.bottom += N, a;
      }
      function du(e, n, a) {
        if (a == "div")
          return n;
        var o = n.left, s = n.top;
        if (a == "page")
          o -= cu(), s -= fu();
        else if (a == "local" || !a) {
          var y = e.display.sizer.getBoundingClientRect();
          o += y.left, s += y.top;
        }
        var N = e.display.lineSpace.getBoundingClientRect();
        return { left: o - N.left, top: s - N.top };
      }
      function ja(e, n, a, o, s) {
        return o || (o = De(e.doc, n.line)), No(e, o, ou(e, o, n.ch, s), a);
      }
      function En(e, n, a, o, s, y) {
        o = o || De(e.doc, n.line), s || (s = Gr(e, o));
        function N(pe, ge) {
          var me = jn(e, s, pe, ge ? "right" : "left", y);
          return ge ? me.left = me.right : me.right = me.left, No(e, o, me, a);
        }
        var B = ct(o, e.doc.direction), P = n.ch, j = n.sticky;
        if (P >= o.text.length ? (P = o.text.length, j = "before") : P <= 0 && (P = 0, j = "after"), !B)
          return N(j == "before" ? P - 1 : P, j == "before");
        function Z(pe, ge, me) {
          var xe = B[ge], Se = xe.level == 1;
          return N(me ? pe - 1 : pe, Se != me);
        }
        var te = $t(B, P, j), ue = st, le = Z(P, te, j == "before");
        return ue != null && (le.other = Z(P, ue, j != "before")), le;
      }
      function pu(e, n) {
        var a = 0;
        n = Pe(e.doc, n), e.options.lineWrapping || (a = Kr(e.display) * n.ch);
        var o = De(e.doc, n.line), s = Yn(o) + Mo(e.display);
        return { left: a, right: a, top: s, bottom: s + o.height };
      }
      function $a(e, n, a, o, s) {
        var y = ie(e, n, a);
        return y.xRel = s, o && (y.outside = o), y;
      }
      function za(e, n, a) {
        var o = e.doc;
        if (a += e.display.viewOffset, a < 0)
          return $a(o.first, 0, null, -1, -1);
        var s = Fn(o, a), y = o.first + o.size - 1;
        if (s > y)
          return $a(o.first + o.size - 1, De(o, y).text.length, null, 1, 1);
        n < 0 && (n = 0);
        for (var N = De(o, s); ; ) {
          var B = Zd(e, N, s, n, a), P = kd(N, B.ch + (B.xRel > 0 || B.outside > 0 ? 1 : 0));
          if (!P)
            return B;
          var j = P.find(1);
          if (j.line == s)
            return j;
          N = De(o, s = j.line);
        }
      }
      function hu(e, n, a, o) {
        o -= Ha(n);
        var s = n.text.length, y = sn(function(N) {
          return jn(e, a, N - 1).bottom <= o;
        }, s, 0);
        return s = sn(function(N) {
          return jn(e, a, N).top > o;
        }, y, s), { begin: y, end: s };
      }
      function vu(e, n, a, o) {
        a || (a = Gr(e, n));
        var s = No(e, n, jn(e, a, o), "line").top;
        return hu(e, n, a, s);
      }
      function Ua(e, n, a, o) {
        return e.bottom <= a ? !1 : e.top > a ? !0 : (o ? e.left : e.right) > n;
      }
      function Zd(e, n, a, o, s) {
        s -= Yn(n);
        var y = Gr(e, n), N = Ha(n), B = 0, P = n.text.length, j = !0, Z = ct(n, e.doc.direction);
        if (Z) {
          var te = (e.options.lineWrapping ? tp : ep)(e, n, a, y, Z, o, s);
          j = te.level != 1, B = j ? te.from : te.to - 1, P = j ? te.to : te.from - 1;
        }
        var ue = null, le = null, pe = sn(function(Le) {
          var Re = jn(e, y, Le);
          return Re.top += N, Re.bottom += N, Ua(Re, o, s, !1) ? (Re.top <= s && Re.left <= o && (ue = Le, le = Re), !0) : !1;
        }, B, P), ge, me, xe = !1;
        if (le) {
          var Se = o - le.left < le.right - o, we = Se == j;
          pe = ue + (we ? 0 : 1), me = we ? "after" : "before", ge = Se ? le.left : le.right;
        } else {
          !j && (pe == P || pe == B) && pe++, me = pe == 0 ? "after" : pe == n.text.length ? "before" : jn(e, y, pe - (j ? 1 : 0)).bottom + N <= s == j ? "after" : "before";
          var Ee = En(e, ie(a, pe, me), "line", n, y);
          ge = Ee.left, xe = s < Ee.top ? -1 : s >= Ee.bottom ? 1 : 0;
        }
        return pe = jt(n.text, pe, 1), $a(a, pe, me, xe, o - ge);
      }
      function ep(e, n, a, o, s, y, N) {
        var B = sn(function(te) {
          var ue = s[te], le = ue.level != 1;
          return Ua(En(
            e,
            ie(a, le ? ue.to : ue.from, le ? "before" : "after"),
            "line",
            n,
            o
          ), y, N, !0);
        }, 0, s.length - 1), P = s[B];
        if (B > 0) {
          var j = P.level != 1, Z = En(
            e,
            ie(a, j ? P.from : P.to, j ? "after" : "before"),
            "line",
            n,
            o
          );
          Ua(Z, y, N, !0) && Z.top > N && (P = s[B - 1]);
        }
        return P;
      }
      function tp(e, n, a, o, s, y, N) {
        var B = hu(e, n, o, N), P = B.begin, j = B.end;
        /\s/.test(n.text.charAt(j - 1)) && j--;
        for (var Z = null, te = null, ue = 0; ue < s.length; ue++) {
          var le = s[ue];
          if (!(le.from >= j || le.to <= P)) {
            var pe = le.level != 1, ge = jn(e, o, pe ? Math.min(j, le.to) - 1 : Math.max(P, le.from)).right, me = ge < y ? y - ge + 1e9 : ge - y;
            (!Z || te > me) && (Z = le, te = me);
          }
        }
        return Z || (Z = s[s.length - 1]), Z.from < P && (Z = { from: P, to: Z.to, level: Z.level }), Z.to > j && (Z = { from: Z.from, to: j, level: Z.level }), Z;
      }
      var Sr;
      function Yr(e) {
        if (e.cachedTextHeight != null)
          return e.cachedTextHeight;
        if (Sr == null) {
          Sr = w("pre", null, "CodeMirror-line-like");
          for (var n = 0; n < 49; ++n)
            Sr.appendChild(document.createTextNode("x")), Sr.appendChild(w("br"));
          Sr.appendChild(document.createTextNode("x"));
        }
        E(e.measure, Sr);
        var a = Sr.offsetHeight / 50;
        return a > 3 && (e.cachedTextHeight = a), h(e.measure), a || 1;
      }
      function Kr(e) {
        if (e.cachedCharWidth != null)
          return e.cachedCharWidth;
        var n = w("span", "xxxxxxxxxx"), a = w("pre", [n], "CodeMirror-line-like");
        E(e.measure, a);
        var o = n.getBoundingClientRect(), s = (o.right - o.left) / 10;
        return s > 2 && (e.cachedCharWidth = s), s || 10;
      }
      function Wa(e) {
        for (var n = e.display, a = {}, o = {}, s = n.gutters.clientLeft, y = n.gutters.firstChild, N = 0; y; y = y.nextSibling, ++N) {
          var B = e.display.gutterSpecs[N].className;
          a[B] = y.offsetLeft + y.clientLeft + s, o[B] = y.clientWidth;
        }
        return {
          fixedPos: Qa(n),
          gutterTotalWidth: n.gutters.offsetWidth,
          gutterLeft: a,
          gutterWidth: o,
          wrapperWidth: n.wrapper.clientWidth
        };
      }
      function Qa(e) {
        return e.scroller.getBoundingClientRect().left - e.sizer.getBoundingClientRect().left;
      }
      function gu(e) {
        var n = Yr(e.display), a = e.options.lineWrapping, o = a && Math.max(5, e.display.scroller.clientWidth / Kr(e.display) - 3);
        return function(s) {
          if (ar(e.doc, s))
            return 0;
          var y = 0;
          if (s.widgets)
            for (var N = 0; N < s.widgets.length; N++)
              s.widgets[N].height && (y += s.widgets[N].height);
          return a ? y + (Math.ceil(s.text.length / o) || 1) * n : y + n;
        };
      }
      function Va(e) {
        var n = e.doc, a = gu(e);
        n.iter(function(o) {
          var s = a(o);
          s != o.height && wn(o, s);
        });
      }
      function Er(e, n, a, o) {
        var s = e.display;
        if (!a && dt(n).getAttribute("cm-not-content") == "true")
          return null;
        var y, N, B = s.lineSpace.getBoundingClientRect();
        try {
          y = n.clientX - B.left, N = n.clientY - B.top;
        } catch (te) {
          return null;
        }
        var P = za(e, y, N), j;
        if (o && P.xRel > 0 && (j = De(e.doc, P.line).text).length == P.ch) {
          var Z = G(j, j.length, e.options.tabSize) - j.length;
          P = ie(P.line, Math.max(0, Math.round((y - ru(e.display).left) / Kr(e.display)) - Z));
        }
        return P;
      }
      function kr(e, n) {
        if (n >= e.display.viewTo || (n -= e.display.viewFrom, n < 0))
          return null;
        for (var a = e.display.view, o = 0; o < a.length; o++)
          if (n -= a[o].size, n < 0)
            return o;
      }
      function en(e, n, a, o) {
        n == null && (n = e.doc.first), a == null && (a = e.doc.first + e.doc.size), o || (o = 0);
        var s = e.display;
        if (o && a < s.viewTo && (s.updateLineNumbers == null || s.updateLineNumbers > n) && (s.updateLineNumbers = n), e.curOp.viewChanged = !0, n >= s.viewTo)
          Gn && Oa(e.doc, n) < s.viewTo && sr(e);
        else if (a <= s.viewFrom)
          Gn && Gs(e.doc, a + o) > s.viewFrom ? sr(e) : (s.viewFrom += o, s.viewTo += o);
        else if (n <= s.viewFrom && a >= s.viewTo)
          sr(e);
        else if (n <= s.viewFrom) {
          var y = Oo(e, a, a + o, 1);
          y ? (s.view = s.view.slice(y.index), s.viewFrom = y.lineN, s.viewTo += o) : sr(e);
        } else if (a >= s.viewTo) {
          var N = Oo(e, n, n, -1);
          N ? (s.view = s.view.slice(0, N.index), s.viewTo = N.lineN) : sr(e);
        } else {
          var B = Oo(e, n, n, -1), P = Oo(e, a, a + o, 1);
          B && P ? (s.view = s.view.slice(0, B.index).concat(Do(e, B.lineN, P.lineN)).concat(s.view.slice(P.index)), s.viewTo += o) : sr(e);
        }
        var j = s.externalMeasured;
        j && (a < j.lineN ? j.lineN += o : n < j.lineN + j.size && (s.externalMeasured = null));
      }
      function lr(e, n, a) {
        e.curOp.viewChanged = !0;
        var o = e.display, s = e.display.externalMeasured;
        if (s && n >= s.lineN && n < s.lineN + s.size && (o.externalMeasured = null), !(n < o.viewFrom || n >= o.viewTo)) {
          var y = o.view[kr(e, n)];
          if (y.node != null) {
            var N = y.changes || (y.changes = []);
            ee(N, a) == -1 && N.push(a);
          }
        }
      }
      function sr(e) {
        e.display.viewFrom = e.display.viewTo = e.doc.first, e.display.view = [], e.display.viewOffset = 0;
      }
      function Oo(e, n, a, o) {
        var s = kr(e, n), y, N = e.display.view;
        if (!Gn || a == e.doc.first + e.doc.size)
          return { index: s, lineN: a };
        for (var B = e.display.viewFrom, P = 0; P < s; P++)
          B += N[P].size;
        if (B != n) {
          if (o > 0) {
            if (s == N.length - 1)
              return null;
            y = B + N[s].size - n, s++;
          } else
            y = B - n;
          n += y, a += y;
        }
        for (; Oa(e.doc, a) != a; ) {
          if (s == (o < 0 ? 0 : N.length - 1))
            return null;
          a += o * N[s - (o < 0 ? 1 : 0)].size, s += o;
        }
        return { index: s, lineN: a };
      }
      function np(e, n, a) {
        var o = e.display, s = o.view;
        s.length == 0 || n >= o.viewTo || a <= o.viewFrom ? (o.view = Do(e, n, a), o.viewFrom = n) : (o.viewFrom > n ? o.view = Do(e, n, o.viewFrom).concat(o.view) : o.viewFrom < n && (o.view = o.view.slice(kr(e, n))), o.viewFrom = n, o.viewTo < a ? o.view = o.view.concat(Do(e, o.viewTo, a)) : o.viewTo > a && (o.view = o.view.slice(0, kr(e, a)))), o.viewTo = a;
      }
      function mu(e) {
        for (var n = e.display.view, a = 0, o = 0; o < n.length; o++) {
          var s = n[o];
          !s.hidden && (!s.node || s.changes) && ++a;
        }
        return a;
      }
      function ki(e) {
        e.display.input.showSelection(e.display.input.prepareSelection());
      }
      function yu(e, n) {
        n === void 0 && (n = !0);
        for (var a = e.doc, o = {}, s = o.cursors = document.createDocumentFragment(), y = o.selection = document.createDocumentFragment(), N = 0; N < a.sel.ranges.length; N++)
          if (!(!n && N == a.sel.primIndex)) {
            var B = a.sel.ranges[N];
            if (!(B.from().line >= e.display.viewTo || B.to().line < e.display.viewFrom)) {
              var P = B.empty();
              (P || e.options.showCursorWhenSelecting) && bu(e, B.head, s), P || rp(e, B, y);
            }
          }
        return o;
      }
      function bu(e, n, a) {
        var o = En(e, n, "div", null, null, !e.options.singleCursorHeightPerLine), s = a.appendChild(w("div", " ", "CodeMirror-cursor"));
        if (s.style.left = o.left + "px", s.style.top = o.top + "px", s.style.height = Math.max(0, o.bottom - o.top) * e.options.cursorHeight + "px", o.other) {
          var y = a.appendChild(w("div", " ", "CodeMirror-cursor CodeMirror-secondarycursor"));
          y.style.display = "", y.style.left = o.other.left + "px", y.style.top = o.other.top + "px", y.style.height = (o.other.bottom - o.other.top) * 0.85 + "px";
        }
      }
      function Ro(e, n) {
        return e.top - n.top || e.left - n.left;
      }
      function rp(e, n, a) {
        var o = e.display, s = e.doc, y = document.createDocumentFragment(), N = ru(e.display), B = N.left, P = Math.max(o.sizerWidth, Cr(e) - o.sizer.offsetLeft) - N.right, j = s.direction == "ltr";
        function Z(we, Ee, Le, Re) {
          Ee < 0 && (Ee = 0), Ee = Math.round(Ee), Re = Math.round(Re), y.appendChild(w("div", null, "CodeMirror-selected", "position: absolute; left: " + we + `px;
                             top: ` + Ee + "px; width: " + (Le == null ? P - we : Le) + `px;
                             height: ` + (Re - Ee) + "px"));
        }
        function te(we, Ee, Le) {
          var Re = De(s, we), We = Re.text.length, ut, It;
          function vt(St, rn) {
            return ja(e, ie(we, St), "div", Re, rn);
          }
          function fn(St, rn, Ht) {
            var Tt = vu(e, Re, null, St), Et = rn == "ltr" == (Ht == "after") ? "left" : "right", mt = Ht == "after" ? Tt.begin : Tt.end - (/\s/.test(Re.text.charAt(Tt.end - 1)) ? 2 : 1);
            return vt(mt, Et)[Et];
          }
          var nn = ct(Re, s.direction);
          return Zt(nn, Ee || 0, Le == null ? We : Le, function(St, rn, Ht, Tt) {
            var Et = Ht == "ltr", mt = vt(St, Et ? "left" : "right"), on = vt(rn - 1, Et ? "right" : "left"), si = Ee == null && St == 0, hr = Le == null && rn == We, Wt = Tt == 0, $n = !nn || Tt == nn.length - 1;
            if (on.top - mt.top <= 3) {
              var Lt = (j ? si : hr) && Wt, yl = (j ? hr : si) && $n, Jn = Lt ? B : (Et ? mt : on).left, Or = yl ? P : (Et ? on : mt).right;
              Z(Jn, mt.top, Or - Jn, mt.bottom);
            } else {
              var Rr, Yt, ui, bl;
              Et ? (Rr = j && si && Wt ? B : mt.left, Yt = j ? P : fn(St, Ht, "before"), ui = j ? B : fn(rn, Ht, "after"), bl = j && hr && $n ? P : on.right) : (Rr = j ? fn(St, Ht, "before") : B, Yt = !j && si && Wt ? P : mt.right, ui = !j && hr && $n ? B : on.left, bl = j ? fn(rn, Ht, "after") : P), Z(Rr, mt.top, Yt - Rr, mt.bottom), mt.bottom < on.top && Z(B, mt.bottom, null, on.top), Z(ui, on.top, bl - ui, on.bottom);
            }
            (!ut || Ro(mt, ut) < 0) && (ut = mt), Ro(on, ut) < 0 && (ut = on), (!It || Ro(mt, It) < 0) && (It = mt), Ro(on, It) < 0 && (It = on);
          }), { start: ut, end: It };
        }
        var ue = n.from(), le = n.to();
        if (ue.line == le.line)
          te(ue.line, ue.ch, le.ch);
        else {
          var pe = De(s, ue.line), ge = De(s, le.line), me = Pn(pe) == Pn(ge), xe = te(ue.line, ue.ch, me ? pe.text.length + 1 : null).end, Se = te(le.line, me ? 0 : null, le.ch).start;
          me && (xe.top < Se.top - 2 ? (Z(xe.right, xe.top, null, xe.bottom), Z(B, Se.top, Se.left, Se.bottom)) : Z(xe.right, xe.top, Se.left - xe.right, xe.bottom)), xe.bottom < Se.top && Z(B, xe.bottom, null, Se.top);
        }
        a.appendChild(y);
      }
      function Ga(e) {
        if (e.state.focused) {
          var n = e.display;
          clearInterval(n.blinker);
          var a = !0;
          n.cursorDiv.style.visibility = "", e.options.cursorBlinkRate > 0 ? n.blinker = setInterval(function() {
            e.hasFocus() || Xr(e), n.cursorDiv.style.visibility = (a = !a) ? "" : "hidden";
          }, e.options.cursorBlinkRate) : e.options.cursorBlinkRate < 0 && (n.cursorDiv.style.visibility = "hidden");
        }
      }
      function Au(e) {
        e.hasFocus() || (e.display.input.focus(), e.state.focused || Ka(e));
      }
      function Ya(e) {
        e.state.delayingBlurEvent = !0, setTimeout(function() {
          e.state.delayingBlurEvent && (e.state.delayingBlurEvent = !1, e.state.focused && Xr(e));
        }, 100);
      }
      function Ka(e, n) {
        e.state.delayingBlurEvent && !e.state.draggingText && (e.state.delayingBlurEvent = !1), e.options.readOnly != "nocursor" && (e.state.focused || (Oe(e, "focus", e, n), e.state.focused = !0, $(e.display.wrapper, "CodeMirror-focused"), !e.curOp && e.display.selForContextMenu != e.doc.sel && (e.display.input.reset(), q && setTimeout(function() {
          return e.display.input.reset(!0);
        }, 20)), e.display.input.receivedFocus()), Ga(e));
      }
      function Xr(e, n) {
        e.state.delayingBlurEvent || (e.state.focused && (Oe(e, "blur", e, n), e.state.focused = !1, L(e.display.wrapper, "CodeMirror-focused")), clearInterval(e.display.blinker), setTimeout(function() {
          e.state.focused || (e.display.shift = !1);
        }, 150));
      }
      function Io(e) {
        for (var n = e.display, a = n.lineDiv.offsetTop, o = 0; o < n.view.length; o++) {
          var s = n.view[o], y = e.options.lineWrapping, N = void 0, B = 0;
          if (!s.hidden) {
            if (W && K < 8) {
              var P = s.node.offsetTop + s.node.offsetHeight;
              N = P - a, a = P;
            } else {
              var j = s.node.getBoundingClientRect();
              N = j.bottom - j.top, !y && s.text.firstChild && (B = s.text.firstChild.getBoundingClientRect().right - j.left - 1);
            }
            var Z = s.line.height - N;
            if ((Z > 5e-3 || Z < -5e-3) && (wn(s.line, N), xu(s.line), s.rest))
              for (var te = 0; te < s.rest.length; te++)
                xu(s.rest[te]);
            if (B > e.display.sizerWidth) {
              var ue = Math.ceil(B / Kr(e.display));
              ue > e.display.maxLineLength && (e.display.maxLineLength = ue, e.display.maxLine = s.line, e.display.maxLineChanged = !0);
            }
          }
        }
      }
      function xu(e) {
        if (e.widgets)
          for (var n = 0; n < e.widgets.length; ++n) {
            var a = e.widgets[n], o = a.node.parentNode;
            o && (a.height = o.offsetHeight);
          }
      }
      function Lo(e, n, a) {
        var o = a && a.top != null ? Math.max(0, a.top) : e.scroller.scrollTop;
        o = Math.floor(o - Mo(e));
        var s = a && a.bottom != null ? a.bottom : o + e.wrapper.clientHeight, y = Fn(n, o), N = Fn(n, s);
        if (a && a.ensure) {
          var B = a.ensure.from.line, P = a.ensure.to.line;
          B < y ? (y = B, N = Fn(n, Yn(De(n, B)) + e.wrapper.clientHeight)) : Math.min(P, n.lastLine()) >= N && (y = Fn(n, Yn(De(n, P)) - e.wrapper.clientHeight), N = P);
        }
        return { from: y, to: Math.max(N, y + 1) };
      }
      function ip(e, n) {
        if (!$e(e, "scrollCursorIntoView")) {
          var a = e.display, o = a.sizer.getBoundingClientRect(), s = null;
          if (n.top + o.top < 0 ? s = !0 : n.bottom + o.top > (window.innerHeight || document.documentElement.clientHeight) && (s = !1), s != null && !C) {
            var y = w("div", "​", null, `position: absolute;
                         top: ` + (n.top - a.viewOffset - Mo(e.display)) + `px;
                         height: ` + (n.bottom - n.top + Hn(e) + a.barHeight) + `px;
                         left: ` + n.left + "px; width: " + Math.max(2, n.right - n.left) + "px;");
            e.display.lineSpace.appendChild(y), y.scrollIntoView(s), e.display.lineSpace.removeChild(y);
          }
        }
      }
      function op(e, n, a, o) {
        o == null && (o = 0);
        var s;
        !e.options.lineWrapping && n == a && (n = n.ch ? ie(n.line, n.sticky == "before" ? n.ch - 1 : n.ch, "after") : n, a = n.sticky == "before" ? ie(n.line, n.ch + 1, "before") : n);
        for (var y = 0; y < 5; y++) {
          var N = !1, B = En(e, n), P = !a || a == n ? B : En(e, a);
          s = {
            left: Math.min(B.left, P.left),
            top: Math.min(B.top, P.top) - o,
            right: Math.max(B.left, P.left),
            bottom: Math.max(B.bottom, P.bottom) + o
          };
          var j = Xa(e, s), Z = e.doc.scrollTop, te = e.doc.scrollLeft;
          if (j.scrollTop != null && (Di(e, j.scrollTop), Math.abs(e.doc.scrollTop - Z) > 1 && (N = !0)), j.scrollLeft != null && (Tr(e, j.scrollLeft), Math.abs(e.doc.scrollLeft - te) > 1 && (N = !0)), !N)
            break;
        }
        return s;
      }
      function ap(e, n) {
        var a = Xa(e, n);
        a.scrollTop != null && Di(e, a.scrollTop), a.scrollLeft != null && Tr(e, a.scrollLeft);
      }
      function Xa(e, n) {
        var a = e.display, o = Yr(e.display);
        n.top < 0 && (n.top = 0);
        var s = e.curOp && e.curOp.scrollTop != null ? e.curOp.scrollTop : a.scroller.scrollTop, y = Ba(e), N = {};
        n.bottom - n.top > y && (n.bottom = n.top + y);
        var B = e.doc.height + Fa(a), P = n.top < o, j = n.bottom > B - o;
        if (n.top < s)
          N.scrollTop = P ? 0 : n.top;
        else if (n.bottom > s + y) {
          var Z = Math.min(n.top, (j ? B : n.bottom) - y);
          Z != s && (N.scrollTop = Z);
        }
        var te = e.options.fixedGutter ? 0 : a.gutters.offsetWidth, ue = e.curOp && e.curOp.scrollLeft != null ? e.curOp.scrollLeft : a.scroller.scrollLeft - te, le = Cr(e) - a.gutters.offsetWidth, pe = n.right - n.left > le;
        return pe && (n.right = n.left + le), n.left < 10 ? N.scrollLeft = 0 : n.left < ue ? N.scrollLeft = Math.max(0, n.left + te - (pe ? 0 : 10)) : n.right > le + ue - 3 && (N.scrollLeft = n.right + (pe ? 0 : 10) - le), N;
      }
      function Ja(e, n) {
        n != null && (Fo(e), e.curOp.scrollTop = (e.curOp.scrollTop == null ? e.doc.scrollTop : e.curOp.scrollTop) + n);
      }
      function Jr(e) {
        Fo(e);
        var n = e.getCursor();
        e.curOp.scrollToPos = { from: n, to: n, margin: e.options.cursorScrollMargin };
      }
      function Ti(e, n, a) {
        (n != null || a != null) && Fo(e), n != null && (e.curOp.scrollLeft = n), a != null && (e.curOp.scrollTop = a);
      }
      function lp(e, n) {
        Fo(e), e.curOp.scrollToPos = n;
      }
      function Fo(e) {
        var n = e.curOp.scrollToPos;
        if (n) {
          e.curOp.scrollToPos = null;
          var a = pu(e, n.from), o = pu(e, n.to);
          wu(e, a, o, n.margin);
        }
      }
      function wu(e, n, a, o) {
        var s = Xa(e, {
          left: Math.min(n.left, a.left),
          top: Math.min(n.top, a.top) - o,
          right: Math.max(n.right, a.right),
          bottom: Math.max(n.bottom, a.bottom) + o
        });
        Ti(e, s.scrollLeft, s.scrollTop);
      }
      function Di(e, n) {
        Math.abs(e.doc.scrollTop - n) < 2 || (M || Za(e, { top: n }), _u(e, n, !0), M && Za(e), Oi(e, 100));
      }
      function _u(e, n, a) {
        n = Math.max(0, Math.min(e.display.scroller.scrollHeight - e.display.scroller.clientHeight, n)), !(e.display.scroller.scrollTop == n && !a) && (e.doc.scrollTop = n, e.display.scrollbars.setScrollTop(n), e.display.scroller.scrollTop != n && (e.display.scroller.scrollTop = n));
      }
      function Tr(e, n, a, o) {
        n = Math.max(0, Math.min(n, e.display.scroller.scrollWidth - e.display.scroller.clientWidth)), !((a ? n == e.doc.scrollLeft : Math.abs(e.doc.scrollLeft - n) < 2) && !o) && (e.doc.scrollLeft = n, Tu(e), e.display.scroller.scrollLeft != n && (e.display.scroller.scrollLeft = n), e.display.scrollbars.setScrollLeft(n));
      }
      function Mi(e) {
        var n = e.display, a = n.gutters.offsetWidth, o = Math.round(e.doc.height + Fa(e.display));
        return {
          clientHeight: n.scroller.clientHeight,
          viewHeight: n.wrapper.clientHeight,
          scrollWidth: n.scroller.scrollWidth,
          clientWidth: n.scroller.clientWidth,
          viewWidth: n.wrapper.clientWidth,
          barLeft: e.options.fixedGutter ? a : 0,
          docHeight: o,
          scrollHeight: o + Hn(e) + n.barHeight,
          nativeBarWidth: n.nativeBarWidth,
          gutterWidth: a
        };
      }
      var Dr = function(e, n, a) {
        this.cm = a;
        var o = this.vert = w("div", [w("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar"), s = this.horiz = w("div", [w("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
        o.tabIndex = s.tabIndex = -1, e(o), e(s), fe(o, "scroll", function() {
          o.clientHeight && n(o.scrollTop, "vertical");
        }), fe(s, "scroll", function() {
          s.clientWidth && n(s.scrollLeft, "horizontal");
        }), this.checkedZeroWidth = !1, W && K < 8 && (this.horiz.style.minHeight = this.vert.style.minWidth = "18px");
      };
      Dr.prototype.update = function(e) {
        var n = e.scrollWidth > e.clientWidth + 1, a = e.scrollHeight > e.clientHeight + 1, o = e.nativeBarWidth;
        if (a) {
          this.vert.style.display = "block", this.vert.style.bottom = n ? o + "px" : "0";
          var s = e.viewHeight - (n ? o : 0);
          this.vert.firstChild.style.height = Math.max(0, e.scrollHeight - e.clientHeight + s) + "px";
        } else
          this.vert.style.display = "", this.vert.firstChild.style.height = "0";
        if (n) {
          this.horiz.style.display = "block", this.horiz.style.right = a ? o + "px" : "0", this.horiz.style.left = e.barLeft + "px";
          var y = e.viewWidth - e.barLeft - (a ? o : 0);
          this.horiz.firstChild.style.width = Math.max(0, e.scrollWidth - e.clientWidth + y) + "px";
        } else
          this.horiz.style.display = "", this.horiz.firstChild.style.width = "0";
        return !this.checkedZeroWidth && e.clientHeight > 0 && (o == 0 && this.zeroWidthHack(), this.checkedZeroWidth = !0), { right: a ? o : 0, bottom: n ? o : 0 };
      }, Dr.prototype.setScrollLeft = function(e) {
        this.horiz.scrollLeft != e && (this.horiz.scrollLeft = e), this.disableHoriz && this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz");
      }, Dr.prototype.setScrollTop = function(e) {
        this.vert.scrollTop != e && (this.vert.scrollTop = e), this.disableVert && this.enableZeroWidthBar(this.vert, this.disableVert, "vert");
      }, Dr.prototype.zeroWidthHack = function() {
        var e = g && !v ? "12px" : "18px";
        this.horiz.style.height = this.vert.style.width = e, this.horiz.style.pointerEvents = this.vert.style.pointerEvents = "none", this.disableHoriz = new J(), this.disableVert = new J();
      }, Dr.prototype.enableZeroWidthBar = function(e, n, a) {
        e.style.pointerEvents = "auto";
        function o() {
          var s = e.getBoundingClientRect(), y = a == "vert" ? document.elementFromPoint(s.right - 1, (s.top + s.bottom) / 2) : document.elementFromPoint((s.right + s.left) / 2, s.bottom - 1);
          y != e ? e.style.pointerEvents = "none" : n.set(1e3, o);
        }
        n.set(1e3, o);
      }, Dr.prototype.clear = function() {
        var e = this.horiz.parentNode;
        e.removeChild(this.horiz), e.removeChild(this.vert);
      };
      var Ni = function() {
      };
      Ni.prototype.update = function() {
        return { bottom: 0, right: 0 };
      }, Ni.prototype.setScrollLeft = function() {
      }, Ni.prototype.setScrollTop = function() {
      }, Ni.prototype.clear = function() {
      };
      function qr(e, n) {
        n || (n = Mi(e));
        var a = e.display.barWidth, o = e.display.barHeight;
        Cu(e, n);
        for (var s = 0; s < 4 && a != e.display.barWidth || o != e.display.barHeight; s++)
          a != e.display.barWidth && e.options.lineWrapping && Io(e), Cu(e, Mi(e)), a = e.display.barWidth, o = e.display.barHeight;
      }
      function Cu(e, n) {
        var a = e.display, o = a.scrollbars.update(n);
        a.sizer.style.paddingRight = (a.barWidth = o.right) + "px", a.sizer.style.paddingBottom = (a.barHeight = o.bottom) + "px", a.heightForcer.style.borderBottom = o.bottom + "px solid transparent", o.right && o.bottom ? (a.scrollbarFiller.style.display = "block", a.scrollbarFiller.style.height = o.bottom + "px", a.scrollbarFiller.style.width = o.right + "px") : a.scrollbarFiller.style.display = "", o.bottom && e.options.coverGutterNextToScrollbar && e.options.fixedGutter ? (a.gutterFiller.style.display = "block", a.gutterFiller.style.height = o.bottom + "px", a.gutterFiller.style.width = n.gutterWidth + "px") : a.gutterFiller.style.display = "";
      }
      var Su = { native: Dr, null: Ni };
      function Eu(e) {
        e.display.scrollbars && (e.display.scrollbars.clear(), e.display.scrollbars.addClass && L(e.display.wrapper, e.display.scrollbars.addClass)), e.display.scrollbars = new Su[e.options.scrollbarStyle](function(n) {
          e.display.wrapper.insertBefore(n, e.display.scrollbarFiller), fe(n, "mousedown", function() {
            e.state.focused && setTimeout(function() {
              return e.display.input.focus();
            }, 0);
          }), n.setAttribute("cm-not-content", "true");
        }, function(n, a) {
          a == "horizontal" ? Tr(e, n) : Di(e, n);
        }, e), e.display.scrollbars.addClass && $(e.display.wrapper, e.display.scrollbars.addClass);
      }
      var sp = 0;
      function Mr(e) {
        e.curOp = {
          cm: e,
          viewChanged: !1,
          // Flag that indicates that lines might need to be redrawn
          startHeight: e.doc.height,
          // Used to detect need to update scrollbar
          forceUpdate: !1,
          // Used to force a redraw
          updateInput: 0,
          // Whether to reset the input textarea
          typing: !1,
          // Whether this reset should be careful to leave existing text (for compositing)
          changeObjs: null,
          // Accumulated changes, for firing change events
          cursorActivityHandlers: null,
          // Set of handlers to fire cursorActivity on
          cursorActivityCalled: 0,
          // Tracks which cursorActivity handlers have been called already
          selectionChanged: !1,
          // Whether the selection needs to be redrawn
          updateMaxLine: !1,
          // Set when the widest line needs to be determined anew
          scrollLeft: null,
          scrollTop: null,
          // Intermediate scroll position, not pushed to DOM yet
          scrollToPos: null,
          // Used to scroll to a specific position
          focus: !1,
          id: ++sp
          // Unique ID
        }, Hd(e.curOp);
      }
      function Nr(e) {
        var n = e.curOp;
        n && $d(n, function(a) {
          for (var o = 0; o < a.ops.length; o++)
            a.ops[o].cm.curOp = null;
          up(a);
        });
      }
      function up(e) {
        for (var n = e.ops, a = 0; a < n.length; a++)
          cp(n[a]);
        for (var o = 0; o < n.length; o++)
          fp(n[o]);
        for (var s = 0; s < n.length; s++)
          dp(n[s]);
        for (var y = 0; y < n.length; y++)
          pp(n[y]);
        for (var N = 0; N < n.length; N++)
          hp(n[N]);
      }
      function cp(e) {
        var n = e.cm, a = n.display;
        gp(n), e.updateMaxLine && Ia(n), e.mustUpdate = e.viewChanged || e.forceUpdate || e.scrollTop != null || e.scrollToPos && (e.scrollToPos.from.line < a.viewFrom || e.scrollToPos.to.line >= a.viewTo) || a.maxLineChanged && n.options.lineWrapping, e.update = e.mustUpdate && new Bo(n, e.mustUpdate && { top: e.scrollTop, ensure: e.scrollToPos }, e.forceUpdate);
      }
      function fp(e) {
        e.updatedDisplay = e.mustUpdate && qa(e.cm, e.update);
      }
      function dp(e) {
        var n = e.cm, a = n.display;
        e.updatedDisplay && Io(n), e.barMeasure = Mi(n), a.maxLineChanged && !n.options.lineWrapping && (e.adjustWidthTo = ou(n, a.maxLine, a.maxLine.text.length).left + 3, n.display.sizerWidth = e.adjustWidthTo, e.barMeasure.scrollWidth = Math.max(a.scroller.clientWidth, a.sizer.offsetLeft + e.adjustWidthTo + Hn(n) + n.display.barWidth), e.maxScrollLeft = Math.max(0, a.sizer.offsetLeft + e.adjustWidthTo - Cr(n))), (e.updatedDisplay || e.selectionChanged) && (e.preparedSelection = a.input.prepareSelection());
      }
      function pp(e) {
        var n = e.cm;
        e.adjustWidthTo != null && (n.display.sizer.style.minWidth = e.adjustWidthTo + "px", e.maxScrollLeft < n.doc.scrollLeft && Tr(n, Math.min(n.display.scroller.scrollLeft, e.maxScrollLeft), !0), n.display.maxLineChanged = !1);
        var a = e.focus && e.focus == H();
        e.preparedSelection && n.display.input.showSelection(e.preparedSelection, a), (e.updatedDisplay || e.startHeight != n.doc.height) && qr(n, e.barMeasure), e.updatedDisplay && tl(n, e.barMeasure), e.selectionChanged && Ga(n), n.state.focused && e.updateInput && n.display.input.reset(e.typing), a && Au(e.cm);
      }
      function hp(e) {
        var n = e.cm, a = n.display, o = n.doc;
        if (e.updatedDisplay && ku(n, e.update), a.wheelStartX != null && (e.scrollTop != null || e.scrollLeft != null || e.scrollToPos) && (a.wheelStartX = a.wheelStartY = null), e.scrollTop != null && _u(n, e.scrollTop, e.forceScroll), e.scrollLeft != null && Tr(n, e.scrollLeft, !0, !0), e.scrollToPos) {
          var s = op(
            n,
            Pe(o, e.scrollToPos.from),
            Pe(o, e.scrollToPos.to),
            e.scrollToPos.margin
          );
          ip(n, s);
        }
        var y = e.maybeHiddenMarkers, N = e.maybeUnhiddenMarkers;
        if (y)
          for (var B = 0; B < y.length; ++B)
            y[B].lines.length || Oe(y[B], "hide");
        if (N)
          for (var P = 0; P < N.length; ++P)
            N[P].lines.length && Oe(N[P], "unhide");
        a.wrapper.offsetHeight && (o.scrollTop = n.display.scroller.scrollTop), e.changeObjs && Oe(n, "changes", n, e.changeObjs), e.update && e.update.finish();
      }
      function cn(e, n) {
        if (e.curOp)
          return n();
        Mr(e);
        try {
          return n();
        } finally {
          Nr(e);
        }
      }
      function Ot(e, n) {
        return function() {
          if (e.curOp)
            return n.apply(e, arguments);
          Mr(e);
          try {
            return n.apply(e, arguments);
          } finally {
            Nr(e);
          }
        };
      }
      function Gt(e) {
        return function() {
          if (this.curOp)
            return e.apply(this, arguments);
          Mr(this);
          try {
            return e.apply(this, arguments);
          } finally {
            Nr(this);
          }
        };
      }
      function Rt(e) {
        return function() {
          var n = this.cm;
          if (!n || n.curOp)
            return e.apply(this, arguments);
          Mr(n);
          try {
            return e.apply(this, arguments);
          } finally {
            Nr(n);
          }
        };
      }
      function Oi(e, n) {
        e.doc.highlightFrontier < e.display.viewTo && e.state.highlight.set(n, Y(vp, e));
      }
      function vp(e) {
        var n = e.doc;
        if (!(n.highlightFrontier >= e.display.viewTo)) {
          var a = +/* @__PURE__ */ new Date() + e.options.workTime, o = xi(e, n.highlightFrontier), s = [];
          n.iter(o.line, Math.min(n.first + n.size, e.display.viewTo + 500), function(y) {
            if (o.line >= e.display.viewFrom) {
              var N = y.styles, B = y.text.length > e.options.maxHighlightLength ? Qn(n.mode, o.state) : null, P = Rs(e, y, o, !0);
              B && (o.state = B), y.styles = P.styles;
              var j = y.styleClasses, Z = P.classes;
              Z ? y.styleClasses = Z : j && (y.styleClasses = null);
              for (var te = !N || N.length != y.styles.length || j != Z && (!j || !Z || j.bgClass != Z.bgClass || j.textClass != Z.textClass), ue = 0; !te && ue < N.length; ++ue)
                te = N[ue] != y.styles[ue];
              te && s.push(o.line), y.stateAfter = o.save(), o.nextLine();
            } else
              y.text.length <= e.options.maxHighlightLength && Ta(e, y.text, o), y.stateAfter = o.line % 5 == 0 ? o.save() : null, o.nextLine();
            if (+/* @__PURE__ */ new Date() > a)
              return Oi(e, e.options.workDelay), !0;
          }), n.highlightFrontier = o.line, n.modeFrontier = Math.max(n.modeFrontier, o.line), s.length && cn(e, function() {
            for (var y = 0; y < s.length; y++)
              lr(e, s[y], "text");
          });
        }
      }
      var Bo = function(e, n, a) {
        var o = e.display;
        this.viewport = n, this.visible = Lo(o, e.doc, n), this.editorIsHidden = !o.wrapper.offsetWidth, this.wrapperHeight = o.wrapper.clientHeight, this.wrapperWidth = o.wrapper.clientWidth, this.oldDisplayWidth = Cr(e), this.force = a, this.dims = Wa(e), this.events = [];
      };
      Bo.prototype.signal = function(e, n) {
        nt(e, n) && this.events.push(arguments);
      }, Bo.prototype.finish = function() {
        for (var e = 0; e < this.events.length; e++)
          Oe.apply(null, this.events[e]);
      };
      function gp(e) {
        var n = e.display;
        !n.scrollbarsClipped && n.scroller.offsetWidth && (n.nativeBarWidth = n.scroller.offsetWidth - n.scroller.clientWidth, n.heightForcer.style.height = Hn(e) + "px", n.sizer.style.marginBottom = -n.nativeBarWidth + "px", n.sizer.style.borderRightWidth = Hn(e) + "px", n.scrollbarsClipped = !0);
      }
      function mp(e) {
        if (e.hasFocus())
          return null;
        var n = H();
        if (!n || !I(e.display.lineDiv, n))
          return null;
        var a = { activeElt: n };
        if (window.getSelection) {
          var o = window.getSelection();
          o.anchorNode && o.extend && I(e.display.lineDiv, o.anchorNode) && (a.anchorNode = o.anchorNode, a.anchorOffset = o.anchorOffset, a.focusNode = o.focusNode, a.focusOffset = o.focusOffset);
        }
        return a;
      }
      function yp(e) {
        if (!(!e || !e.activeElt || e.activeElt == H()) && (e.activeElt.focus(), !/^(INPUT|TEXTAREA)$/.test(e.activeElt.nodeName) && e.anchorNode && I(document.body, e.anchorNode) && I(document.body, e.focusNode))) {
          var n = window.getSelection(), a = document.createRange();
          a.setEnd(e.anchorNode, e.anchorOffset), a.collapse(!1), n.removeAllRanges(), n.addRange(a), n.extend(e.focusNode, e.focusOffset);
        }
      }
      function qa(e, n) {
        var a = e.display, o = e.doc;
        if (n.editorIsHidden)
          return sr(e), !1;
        if (!n.force && n.visible.from >= a.viewFrom && n.visible.to <= a.viewTo && (a.updateLineNumbers == null || a.updateLineNumbers >= a.viewTo) && a.renderedView == a.view && mu(e) == 0)
          return !1;
        Du(e) && (sr(e), n.dims = Wa(e));
        var s = o.first + o.size, y = Math.max(n.visible.from - e.options.viewportMargin, o.first), N = Math.min(s, n.visible.to + e.options.viewportMargin);
        a.viewFrom < y && y - a.viewFrom < 20 && (y = Math.max(o.first, a.viewFrom)), a.viewTo > N && a.viewTo - N < 20 && (N = Math.min(s, a.viewTo)), Gn && (y = Oa(e.doc, y), N = Gs(e.doc, N));
        var B = y != a.viewFrom || N != a.viewTo || a.lastWrapHeight != n.wrapperHeight || a.lastWrapWidth != n.wrapperWidth;
        np(e, y, N), a.viewOffset = Yn(De(e.doc, a.viewFrom)), e.display.mover.style.top = a.viewOffset + "px";
        var P = mu(e);
        if (!B && P == 0 && !n.force && a.renderedView == a.view && (a.updateLineNumbers == null || a.updateLineNumbers >= a.viewTo))
          return !1;
        var j = mp(e);
        return P > 4 && (a.lineDiv.style.display = "none"), bp(e, a.updateLineNumbers, n.dims), P > 4 && (a.lineDiv.style.display = ""), a.renderedView = a.view, yp(j), h(a.cursorDiv), h(a.selectionDiv), a.gutters.style.height = a.sizer.style.minHeight = 0, B && (a.lastWrapHeight = n.wrapperHeight, a.lastWrapWidth = n.wrapperWidth, Oi(e, 400)), a.updateLineNumbers = null, !0;
      }
      function ku(e, n) {
        for (var a = n.viewport, o = !0; ; o = !1) {
          if (!o || !e.options.lineWrapping || n.oldDisplayWidth == Cr(e)) {
            if (a && a.top != null && (a = { top: Math.min(e.doc.height + Fa(e.display) - Ba(e), a.top) }), n.visible = Lo(e.display, e.doc, a), n.visible.from >= e.display.viewFrom && n.visible.to <= e.display.viewTo)
              break;
          } else o && (n.visible = Lo(e.display, e.doc, a));
          if (!qa(e, n))
            break;
          Io(e);
          var s = Mi(e);
          ki(e), qr(e, s), tl(e, s), n.force = !1;
        }
        n.signal(e, "update", e), (e.display.viewFrom != e.display.reportedViewFrom || e.display.viewTo != e.display.reportedViewTo) && (n.signal(e, "viewportChange", e, e.display.viewFrom, e.display.viewTo), e.display.reportedViewFrom = e.display.viewFrom, e.display.reportedViewTo = e.display.viewTo);
      }
      function Za(e, n) {
        var a = new Bo(e, n);
        if (qa(e, a)) {
          Io(e), ku(e, a);
          var o = Mi(e);
          ki(e), qr(e, o), tl(e, o), a.finish();
        }
      }
      function bp(e, n, a) {
        var o = e.display, s = e.options.lineNumbers, y = o.lineDiv, N = y.firstChild;
        function B(pe) {
          var ge = pe.nextSibling;
          return q && g && e.display.currentWheelTarget == pe ? pe.style.display = "none" : pe.parentNode.removeChild(pe), ge;
        }
        for (var P = o.view, j = o.viewFrom, Z = 0; Z < P.length; Z++) {
          var te = P[Z];
          if (!te.hidden) if (!te.node || te.node.parentNode != y) {
            var ue = Vd(e, te, j, a);
            y.insertBefore(ue, N);
          } else {
            for (; N != te.node; )
              N = B(N);
            var le = s && n != null && n <= j && te.lineNumber;
            te.changes && (ee(te.changes, "gutter") > -1 && (le = !1), qs(e, te, j, a)), le && (h(te.lineNumber), te.lineNumber.appendChild(document.createTextNode(ne(e.options, j)))), N = te.node.nextSibling;
          }
          j += te.size;
        }
        for (; N; )
          N = B(N);
      }
      function el(e) {
        var n = e.gutters.offsetWidth;
        e.sizer.style.marginLeft = n + "px";
      }
      function tl(e, n) {
        e.display.sizer.style.minHeight = n.docHeight + "px", e.display.heightForcer.style.top = n.docHeight + "px", e.display.gutters.style.height = n.docHeight + e.display.barHeight + Hn(e) + "px";
      }
      function Tu(e) {
        var n = e.display, a = n.view;
        if (!(!n.alignWidgets && (!n.gutters.firstChild || !e.options.fixedGutter))) {
          for (var o = Qa(n) - n.scroller.scrollLeft + e.doc.scrollLeft, s = n.gutters.offsetWidth, y = o + "px", N = 0; N < a.length; N++)
            if (!a[N].hidden) {
              e.options.fixedGutter && (a[N].gutter && (a[N].gutter.style.left = y), a[N].gutterBackground && (a[N].gutterBackground.style.left = y));
              var B = a[N].alignable;
              if (B)
                for (var P = 0; P < B.length; P++)
                  B[P].style.left = y;
            }
          e.options.fixedGutter && (n.gutters.style.left = o + s + "px");
        }
      }
      function Du(e) {
        if (!e.options.lineNumbers)
          return !1;
        var n = e.doc, a = ne(e.options, n.first + n.size - 1), o = e.display;
        if (a.length != o.lineNumChars) {
          var s = o.measure.appendChild(w(
            "div",
            [w("div", a)],
            "CodeMirror-linenumber CodeMirror-gutter-elt"
          )), y = s.firstChild.offsetWidth, N = s.offsetWidth - y;
          return o.lineGutter.style.width = "", o.lineNumInnerWidth = Math.max(y, o.lineGutter.offsetWidth - N) + 1, o.lineNumWidth = o.lineNumInnerWidth + N, o.lineNumChars = o.lineNumInnerWidth ? a.length : -1, o.lineGutter.style.width = o.lineNumWidth + "px", el(e.display), !0;
        }
        return !1;
      }
      function nl(e, n) {
        for (var a = [], o = !1, s = 0; s < e.length; s++) {
          var y = e[s], N = null;
          if (typeof y != "string" && (N = y.style, y = y.className), y == "CodeMirror-linenumbers")
            if (n)
              o = !0;
            else
              continue;
          a.push({ className: y, style: N });
        }
        return n && !o && a.push({ className: "CodeMirror-linenumbers", style: null }), a;
      }
      function Mu(e) {
        var n = e.gutters, a = e.gutterSpecs;
        h(n), e.lineGutter = null;
        for (var o = 0; o < a.length; ++o) {
          var s = a[o], y = s.className, N = s.style, B = n.appendChild(w("div", null, "CodeMirror-gutter " + y));
          N && (B.style.cssText = N), y == "CodeMirror-linenumbers" && (e.lineGutter = B, B.style.width = (e.lineNumWidth || 1) + "px");
        }
        n.style.display = a.length ? "" : "none", el(e);
      }
      function Ri(e) {
        Mu(e.display), en(e), Tu(e);
      }
      function Ap(e, n, a, o) {
        var s = this;
        this.input = a, s.scrollbarFiller = w("div", null, "CodeMirror-scrollbar-filler"), s.scrollbarFiller.setAttribute("cm-not-content", "true"), s.gutterFiller = w("div", null, "CodeMirror-gutter-filler"), s.gutterFiller.setAttribute("cm-not-content", "true"), s.lineDiv = O("div", null, "CodeMirror-code"), s.selectionDiv = w("div", null, null, "position: relative; z-index: 1"), s.cursorDiv = w("div", null, "CodeMirror-cursors"), s.measure = w("div", null, "CodeMirror-measure"), s.lineMeasure = w("div", null, "CodeMirror-measure"), s.lineSpace = O(
          "div",
          [s.measure, s.lineMeasure, s.selectionDiv, s.cursorDiv, s.lineDiv],
          null,
          "position: relative; outline: none"
        );
        var y = O("div", [s.lineSpace], "CodeMirror-lines");
        s.mover = w("div", [y], null, "position: relative"), s.sizer = w("div", [s.mover], "CodeMirror-sizer"), s.sizerWidth = null, s.heightForcer = w("div", null, null, "position: absolute; height: " + re + "px; width: 1px;"), s.gutters = w("div", null, "CodeMirror-gutters"), s.lineGutter = null, s.scroller = w("div", [s.sizer, s.heightForcer, s.gutters], "CodeMirror-scroll"), s.scroller.setAttribute("tabIndex", "-1"), s.wrapper = w("div", [s.scrollbarFiller, s.gutterFiller, s.scroller], "CodeMirror"), W && K < 8 && (s.gutters.style.zIndex = -1, s.scroller.style.paddingRight = 0), !q && !(M && x) && (s.scroller.draggable = !0), e && (e.appendChild ? e.appendChild(s.wrapper) : e(s.wrapper)), s.viewFrom = s.viewTo = n.first, s.reportedViewFrom = s.reportedViewTo = n.first, s.view = [], s.renderedView = null, s.externalMeasured = null, s.viewOffset = 0, s.lastWrapHeight = s.lastWrapWidth = 0, s.updateLineNumbers = null, s.nativeBarWidth = s.barHeight = s.barWidth = 0, s.scrollbarsClipped = !1, s.lineNumWidth = s.lineNumInnerWidth = s.lineNumChars = null, s.alignWidgets = !1, s.cachedCharWidth = s.cachedTextHeight = s.cachedPaddingH = null, s.maxLine = null, s.maxLineLength = 0, s.maxLineChanged = !1, s.wheelDX = s.wheelDY = s.wheelStartX = s.wheelStartY = null, s.shift = !1, s.selForContextMenu = null, s.activeTouch = null, s.gutterSpecs = nl(o.gutters, o.lineNumbers), Mu(s), a.init(s);
      }
      var Po = 0, vn = null;
      W ? vn = -0.53 : M ? vn = 15 : d ? vn = -0.7 : u && (vn = -1 / 3);
      function Nu(e) {
        var n = e.wheelDeltaX, a = e.wheelDeltaY;
        return n == null && e.detail && e.axis == e.HORIZONTAL_AXIS && (n = e.detail), a == null && e.detail && e.axis == e.VERTICAL_AXIS ? a = e.detail : a == null && (a = e.wheelDelta), { x: n, y: a };
      }
      function xp(e) {
        var n = Nu(e);
        return n.x *= vn, n.y *= vn, n;
      }
      function Ou(e, n) {
        var a = Nu(n), o = a.x, s = a.y, y = e.display, N = y.scroller, B = N.scrollWidth > N.clientWidth, P = N.scrollHeight > N.clientHeight;
        if (o && B || s && P) {
          if (s && g && q) {
            e: for (var j = n.target, Z = y.view; j != N; j = j.parentNode)
              for (var te = 0; te < Z.length; te++)
                if (Z[te].node == j) {
                  e.display.currentWheelTarget = j;
                  break e;
                }
          }
          if (o && !M && !r && vn != null) {
            s && P && Di(e, Math.max(0, N.scrollTop + s * vn)), Tr(e, Math.max(0, N.scrollLeft + o * vn)), (!s || s && P) && Te(n), y.wheelStartX = null;
            return;
          }
          if (s && vn != null) {
            var ue = s * vn, le = e.doc.scrollTop, pe = le + y.wrapper.clientHeight;
            ue < 0 ? le = Math.max(0, le + ue - 50) : pe = Math.min(e.doc.height, pe + ue + 50), Za(e, { top: le, bottom: pe });
          }
          Po < 20 && (y.wheelStartX == null ? (y.wheelStartX = N.scrollLeft, y.wheelStartY = N.scrollTop, y.wheelDX = o, y.wheelDY = s, setTimeout(function() {
            if (y.wheelStartX != null) {
              var ge = N.scrollLeft - y.wheelStartX, me = N.scrollTop - y.wheelStartY, xe = me && y.wheelDY && me / y.wheelDY || ge && y.wheelDX && ge / y.wheelDX;
              y.wheelStartX = y.wheelStartY = null, xe && (vn = (vn * Po + xe) / (Po + 1), ++Po);
            }
          }, 200)) : (y.wheelDX += o, y.wheelDY += s));
        }
      }
      var gn = function(e, n) {
        this.ranges = e, this.primIndex = n;
      };
      gn.prototype.primary = function() {
        return this.ranges[this.primIndex];
      }, gn.prototype.equals = function(e) {
        if (e == this)
          return !0;
        if (e.primIndex != this.primIndex || e.ranges.length != this.ranges.length)
          return !1;
        for (var n = 0; n < this.ranges.length; n++) {
          var a = this.ranges[n], o = e.ranges[n];
          if (!Be(a.anchor, o.anchor) || !Be(a.head, o.head))
            return !1;
        }
        return !0;
      }, gn.prototype.deepCopy = function() {
        for (var e = [], n = 0; n < this.ranges.length; n++)
          e[n] = new tt(Ye(this.ranges[n].anchor), Ye(this.ranges[n].head));
        return new gn(e, this.primIndex);
      }, gn.prototype.somethingSelected = function() {
        for (var e = 0; e < this.ranges.length; e++)
          if (!this.ranges[e].empty())
            return !0;
        return !1;
      }, gn.prototype.contains = function(e, n) {
        n || (n = e);
        for (var a = 0; a < this.ranges.length; a++) {
          var o = this.ranges[a];
          if (de(n, o.from()) >= 0 && de(e, o.to()) <= 0)
            return a;
        }
        return -1;
      };
      var tt = function(e, n) {
        this.anchor = e, this.head = n;
      };
      tt.prototype.from = function() {
        return kt(this.anchor, this.head);
      }, tt.prototype.to = function() {
        return et(this.anchor, this.head);
      }, tt.prototype.empty = function() {
        return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch;
      };
      function kn(e, n, a) {
        var o = e && e.options.selectionsMayTouch, s = n[a];
        n.sort(function(ue, le) {
          return de(ue.from(), le.from());
        }), a = ee(n, s);
        for (var y = 1; y < n.length; y++) {
          var N = n[y], B = n[y - 1], P = de(B.to(), N.from());
          if (o && !N.empty() ? P > 0 : P >= 0) {
            var j = kt(B.from(), N.from()), Z = et(B.to(), N.to()), te = B.empty() ? N.from() == N.head : B.from() == B.head;
            y <= a && --a, n.splice(--y, 2, new tt(te ? Z : j, te ? j : Z));
          }
        }
        return new gn(n, a);
      }
      function ur(e, n) {
        return new gn([new tt(e, n || e)], 0);
      }
      function cr(e) {
        return e.text ? ie(
          e.from.line + e.text.length - 1,
          he(e.text).length + (e.text.length == 1 ? e.from.ch : 0)
        ) : e.to;
      }
      function Ru(e, n) {
        if (de(e, n.from) < 0)
          return e;
        if (de(e, n.to) <= 0)
          return cr(n);
        var a = e.line + n.text.length - (n.to.line - n.from.line) - 1, o = e.ch;
        return e.line == n.to.line && (o += cr(n).ch - n.to.ch), ie(a, o);
      }
      function rl(e, n) {
        for (var a = [], o = 0; o < e.sel.ranges.length; o++) {
          var s = e.sel.ranges[o];
          a.push(new tt(
            Ru(s.anchor, n),
            Ru(s.head, n)
          ));
        }
        return kn(e.cm, a, e.sel.primIndex);
      }
      function Iu(e, n, a) {
        return e.line == n.line ? ie(a.line, e.ch - n.ch + a.ch) : ie(a.line + (e.line - n.line), e.ch);
      }
      function wp(e, n, a) {
        for (var o = [], s = ie(e.first, 0), y = s, N = 0; N < n.length; N++) {
          var B = n[N], P = Iu(B.from, s, y), j = Iu(cr(B), s, y);
          if (s = B.to, y = j, a == "around") {
            var Z = e.sel.ranges[N], te = de(Z.head, Z.anchor) < 0;
            o[N] = new tt(te ? j : P, te ? P : j);
          } else
            o[N] = new tt(P, P);
        }
        return new gn(o, e.sel.primIndex);
      }
      function il(e) {
        e.doc.mode = rr(e.options, e.doc.modeOption), Ii(e);
      }
      function Ii(e) {
        e.doc.iter(function(n) {
          n.stateAfter && (n.stateAfter = null), n.styles && (n.styles = null);
        }), e.doc.modeFrontier = e.doc.highlightFrontier = e.doc.first, Oi(e, 100), e.state.modeGen++, e.curOp && en(e);
      }
      function Lu(e, n) {
        return n.from.ch == 0 && n.to.ch == 0 && he(n.text) == "" && (!e.cm || e.cm.options.wholeLineUpdateBefore);
      }
      function ol(e, n, a, o) {
        function s(Se) {
          return a ? a[Se] : null;
        }
        function y(Se, we, Ee) {
          Md(Se, we, Ee, o), Pt(Se, "change", Se, n);
        }
        function N(Se, we) {
          for (var Ee = [], Le = Se; Le < we; ++Le)
            Ee.push(new Qr(j[Le], s(Le), o));
          return Ee;
        }
        var B = n.from, P = n.to, j = n.text, Z = De(e, B.line), te = De(e, P.line), ue = he(j), le = s(j.length - 1), pe = P.line - B.line;
        if (n.full)
          e.insert(0, N(0, j.length)), e.remove(j.length, e.size - j.length);
        else if (Lu(e, n)) {
          var ge = N(0, j.length - 1);
          y(te, te.text, le), pe && e.remove(B.line, pe), ge.length && e.insert(B.line, ge);
        } else if (Z == te)
          if (j.length == 1)
            y(Z, Z.text.slice(0, B.ch) + ue + Z.text.slice(P.ch), le);
          else {
            var me = N(1, j.length - 1);
            me.push(new Qr(ue + Z.text.slice(P.ch), le, o)), y(Z, Z.text.slice(0, B.ch) + j[0], s(0)), e.insert(B.line + 1, me);
          }
        else if (j.length == 1)
          y(Z, Z.text.slice(0, B.ch) + j[0] + te.text.slice(P.ch), s(0)), e.remove(B.line + 1, pe);
        else {
          y(Z, Z.text.slice(0, B.ch) + j[0], s(0)), y(te, ue + te.text.slice(P.ch), le);
          var xe = N(1, j.length - 1);
          pe > 1 && e.remove(B.line + 1, pe - 1), e.insert(B.line + 1, xe);
        }
        Pt(e, "change", e, n);
      }
      function fr(e, n, a) {
        function o(s, y, N) {
          if (s.linked)
            for (var B = 0; B < s.linked.length; ++B) {
              var P = s.linked[B];
              if (P.doc != y) {
                var j = N && P.sharedHist;
                a && !j || (n(P.doc, j), o(P.doc, s, j));
              }
            }
        }
        o(e, null, !0);
      }
      function Fu(e, n) {
        if (n.cm)
          throw new Error("This document is already in use.");
        e.doc = n, n.cm = e, Va(e), il(e), Bu(e), e.options.lineWrapping || Ia(e), e.options.mode = n.modeOption, en(e);
      }
      function Bu(e) {
        (e.doc.direction == "rtl" ? $ : L)(e.display.lineDiv, "CodeMirror-rtl");
      }
      function _p(e) {
        cn(e, function() {
          Bu(e), en(e);
        });
      }
      function Ho(e) {
        this.done = [], this.undone = [], this.undoDepth = e ? e.undoDepth : 1 / 0, this.lastModTime = this.lastSelTime = 0, this.lastOp = this.lastSelOp = null, this.lastOrigin = this.lastSelOrigin = null, this.generation = this.maxGeneration = e ? e.maxGeneration : 1;
      }
      function al(e, n) {
        var a = { from: Ye(n.from), to: cr(n), text: Vn(e, n.from, n.to) };
        return ju(e, a, n.from.line, n.to.line + 1), fr(e, function(o) {
          return ju(o, a, n.from.line, n.to.line + 1);
        }, !0), a;
      }
      function Pu(e) {
        for (; e.length; ) {
          var n = he(e);
          if (n.ranges)
            e.pop();
          else
            break;
        }
      }
      function Cp(e, n) {
        if (n)
          return Pu(e.done), he(e.done);
        if (e.done.length && !he(e.done).ranges)
          return he(e.done);
        if (e.done.length > 1 && !e.done[e.done.length - 2].ranges)
          return e.done.pop(), he(e.done);
      }
      function Hu(e, n, a, o) {
        var s = e.history;
        s.undone.length = 0;
        var y = +/* @__PURE__ */ new Date(), N, B;
        if ((s.lastOp == o || s.lastOrigin == n.origin && n.origin && (n.origin.charAt(0) == "+" && s.lastModTime > y - (e.cm ? e.cm.options.historyEventDelay : 500) || n.origin.charAt(0) == "*")) && (N = Cp(s, s.lastOp == o)))
          B = he(N.changes), de(n.from, n.to) == 0 && de(n.from, B.to) == 0 ? B.to = cr(n) : N.changes.push(al(e, n));
        else {
          var P = he(s.done);
          for ((!P || !P.ranges) && jo(e.sel, s.done), N = {
            changes: [al(e, n)],
            generation: s.generation
          }, s.done.push(N); s.done.length > s.undoDepth; )
            s.done.shift(), s.done[0].ranges || s.done.shift();
        }
        s.done.push(a), s.generation = ++s.maxGeneration, s.lastModTime = s.lastSelTime = y, s.lastOp = s.lastSelOp = o, s.lastOrigin = s.lastSelOrigin = n.origin, B || Oe(e, "historyAdded");
      }
      function Sp(e, n, a, o) {
        var s = n.charAt(0);
        return s == "*" || s == "+" && a.ranges.length == o.ranges.length && a.somethingSelected() == o.somethingSelected() && /* @__PURE__ */ new Date() - e.history.lastSelTime <= (e.cm ? e.cm.options.historyEventDelay : 500);
      }
      function Ep(e, n, a, o) {
        var s = e.history, y = o && o.origin;
        a == s.lastSelOp || y && s.lastSelOrigin == y && (s.lastModTime == s.lastSelTime && s.lastOrigin == y || Sp(e, y, he(s.done), n)) ? s.done[s.done.length - 1] = n : jo(n, s.done), s.lastSelTime = +/* @__PURE__ */ new Date(), s.lastSelOrigin = y, s.lastSelOp = a, o && o.clearRedo !== !1 && Pu(s.undone);
      }
      function jo(e, n) {
        var a = he(n);
        a && a.ranges && a.equals(e) || n.push(e);
      }
      function ju(e, n, a, o) {
        var s = n["spans_" + e.id], y = 0;
        e.iter(Math.max(e.first, a), Math.min(e.first + e.size, o), function(N) {
          N.markedSpans && ((s || (s = n["spans_" + e.id] = {}))[y] = N.markedSpans), ++y;
        });
      }
      function kp(e) {
        if (!e)
          return null;
        for (var n, a = 0; a < e.length; ++a)
          e[a].marker.explicitlyCleared ? n || (n = e.slice(0, a)) : n && n.push(e[a]);
        return n ? n.length ? n : null : e;
      }
      function Tp(e, n) {
        var a = n["spans_" + e.id];
        if (!a)
          return null;
        for (var o = [], s = 0; s < n.text.length; ++s)
          o.push(kp(a[s]));
        return o;
      }
      function $u(e, n) {
        var a = Tp(e, n), o = Ma(e, n);
        if (!a)
          return o;
        if (!o)
          return a;
        for (var s = 0; s < a.length; ++s) {
          var y = a[s], N = o[s];
          if (y && N)
            e: for (var B = 0; B < N.length; ++B) {
              for (var P = N[B], j = 0; j < y.length; ++j)
                if (y[j].marker == P.marker)
                  continue e;
              y.push(P);
            }
          else N && (a[s] = N);
        }
        return a;
      }
      function Zr(e, n, a) {
        for (var o = [], s = 0; s < e.length; ++s) {
          var y = e[s];
          if (y.ranges) {
            o.push(a ? gn.prototype.deepCopy.call(y) : y);
            continue;
          }
          var N = y.changes, B = [];
          o.push({ changes: B });
          for (var P = 0; P < N.length; ++P) {
            var j = N[P], Z = void 0;
            if (B.push({ from: j.from, to: j.to, text: j.text }), n)
              for (var te in j)
                (Z = te.match(/^spans_(\d+)$/)) && ee(n, Number(Z[1])) > -1 && (he(B)[te] = j[te], delete j[te]);
          }
        }
        return o;
      }
      function ll(e, n, a, o) {
        if (o) {
          var s = e.anchor;
          if (a) {
            var y = de(n, s) < 0;
            y != de(a, s) < 0 ? (s = n, n = a) : y != de(n, a) < 0 && (n = a);
          }
          return new tt(s, n);
        } else
          return new tt(a || n, n);
      }
      function $o(e, n, a, o, s) {
        s == null && (s = e.cm && (e.cm.display.shift || e.extend)), Ut(e, new gn([ll(e.sel.primary(), n, a, s)], 0), o);
      }
      function zu(e, n, a) {
        for (var o = [], s = e.cm && (e.cm.display.shift || e.extend), y = 0; y < e.sel.ranges.length; y++)
          o[y] = ll(e.sel.ranges[y], n[y], null, s);
        var N = kn(e.cm, o, e.sel.primIndex);
        Ut(e, N, a);
      }
      function sl(e, n, a, o) {
        var s = e.sel.ranges.slice(0);
        s[n] = a, Ut(e, kn(e.cm, s, e.sel.primIndex), o);
      }
      function Uu(e, n, a, o) {
        Ut(e, ur(n, a), o);
      }
      function Dp(e, n, a) {
        var o = {
          ranges: n.ranges,
          update: function(s) {
            this.ranges = [];
            for (var y = 0; y < s.length; y++)
              this.ranges[y] = new tt(
                Pe(e, s[y].anchor),
                Pe(e, s[y].head)
              );
          },
          origin: a && a.origin
        };
        return Oe(e, "beforeSelectionChange", e, o), e.cm && Oe(e.cm, "beforeSelectionChange", e.cm, o), o.ranges != n.ranges ? kn(e.cm, o.ranges, o.ranges.length - 1) : n;
      }
      function Wu(e, n, a) {
        var o = e.history.done, s = he(o);
        s && s.ranges ? (o[o.length - 1] = n, zo(e, n, a)) : Ut(e, n, a);
      }
      function Ut(e, n, a) {
        zo(e, n, a), Ep(e, e.sel, e.cm ? e.cm.curOp.id : NaN, a);
      }
      function zo(e, n, a) {
        (nt(e, "beforeSelectionChange") || e.cm && nt(e.cm, "beforeSelectionChange")) && (n = Dp(e, n, a));
        var o = a && a.bias || (de(n.primary().head, e.sel.primary().head) < 0 ? -1 : 1);
        Qu(e, Gu(e, n, o, !0)), !(a && a.scroll === !1) && e.cm && e.cm.getOption("readOnly") != "nocursor" && Jr(e.cm);
      }
      function Qu(e, n) {
        n.equals(e.sel) || (e.sel = n, e.cm && (e.cm.curOp.updateInput = 1, e.cm.curOp.selectionChanged = !0, Ct(e.cm)), Pt(e, "cursorActivity", e));
      }
      function Vu(e) {
        Qu(e, Gu(e, e.sel, null, !1));
      }
      function Gu(e, n, a, o) {
        for (var s, y = 0; y < n.ranges.length; y++) {
          var N = n.ranges[y], B = n.ranges.length == e.sel.ranges.length && e.sel.ranges[y], P = Uo(e, N.anchor, B && B.anchor, a, o), j = Uo(e, N.head, B && B.head, a, o);
          (s || P != N.anchor || j != N.head) && (s || (s = n.ranges.slice(0, y)), s[y] = new tt(P, j));
        }
        return s ? kn(e.cm, s, n.primIndex) : n;
      }
      function ei(e, n, a, o, s) {
        var y = De(e, n.line);
        if (y.markedSpans)
          for (var N = 0; N < y.markedSpans.length; ++N) {
            var B = y.markedSpans[N], P = B.marker, j = "selectLeft" in P ? !P.selectLeft : P.inclusiveLeft, Z = "selectRight" in P ? !P.selectRight : P.inclusiveRight;
            if ((B.from == null || (j ? B.from <= n.ch : B.from < n.ch)) && (B.to == null || (Z ? B.to >= n.ch : B.to > n.ch))) {
              if (s && (Oe(P, "beforeCursorEnter"), P.explicitlyCleared))
                if (y.markedSpans) {
                  --N;
                  continue;
                } else
                  break;
              if (!P.atomic)
                continue;
              if (a) {
                var te = P.find(o < 0 ? 1 : -1), ue = void 0;
                if ((o < 0 ? Z : j) && (te = Yu(e, te, -o, te && te.line == n.line ? y : null)), te && te.line == n.line && (ue = de(te, a)) && (o < 0 ? ue < 0 : ue > 0))
                  return ei(e, te, n, o, s);
              }
              var le = P.find(o < 0 ? -1 : 1);
              return (o < 0 ? j : Z) && (le = Yu(e, le, o, le.line == n.line ? y : null)), le ? ei(e, le, n, o, s) : null;
            }
          }
        return n;
      }
      function Uo(e, n, a, o, s) {
        var y = o || 1, N = ei(e, n, a, y, s) || !s && ei(e, n, a, y, !0) || ei(e, n, a, -y, s) || !s && ei(e, n, a, -y, !0);
        return N || (e.cantEdit = !0, ie(e.first, 0));
      }
      function Yu(e, n, a, o) {
        return a < 0 && n.ch == 0 ? n.line > e.first ? Pe(e, ie(n.line - 1)) : null : a > 0 && n.ch == (o || De(e, n.line)).text.length ? n.line < e.first + e.size - 1 ? ie(n.line + 1, 0) : null : new ie(n.line, n.ch + a);
      }
      function Ku(e) {
        e.setSelection(ie(e.firstLine(), 0), ie(e.lastLine()), ae);
      }
      function Xu(e, n, a) {
        var o = {
          canceled: !1,
          from: n.from,
          to: n.to,
          text: n.text,
          origin: n.origin,
          cancel: function() {
            return o.canceled = !0;
          }
        };
        return a && (o.update = function(s, y, N, B) {
          s && (o.from = Pe(e, s)), y && (o.to = Pe(e, y)), N && (o.text = N), B !== void 0 && (o.origin = B);
        }), Oe(e, "beforeChange", e, o), e.cm && Oe(e.cm, "beforeChange", e.cm, o), o.canceled ? (e.cm && (e.cm.curOp.updateInput = 2), null) : { from: o.from, to: o.to, text: o.text, origin: o.origin };
      }
      function ti(e, n, a) {
        if (e.cm) {
          if (!e.cm.curOp)
            return Ot(e.cm, ti)(e, n, a);
          if (e.cm.state.suppressEdits)
            return;
        }
        if (!((nt(e, "beforeChange") || e.cm && nt(e.cm, "beforeChange")) && (n = Xu(e, n, !0), !n))) {
          var o = js && !a && Ed(e, n.from, n.to);
          if (o)
            for (var s = o.length - 1; s >= 0; --s)
              Ju(e, { from: o[s].from, to: o[s].to, text: s ? [""] : n.text, origin: n.origin });
          else
            Ju(e, n);
        }
      }
      function Ju(e, n) {
        if (!(n.text.length == 1 && n.text[0] == "" && de(n.from, n.to) == 0)) {
          var a = rl(e, n);
          Hu(e, n, a, e.cm ? e.cm.curOp.id : NaN), Li(e, n, a, Ma(e, n));
          var o = [];
          fr(e, function(s, y) {
            !y && ee(o, s.history) == -1 && (tc(s.history, n), o.push(s.history)), Li(s, n, null, Ma(s, n));
          });
        }
      }
      function Wo(e, n, a) {
        var o = e.cm && e.cm.state.suppressEdits;
        if (!(o && !a)) {
          for (var s = e.history, y, N = e.sel, B = n == "undo" ? s.done : s.undone, P = n == "undo" ? s.undone : s.done, j = 0; j < B.length && (y = B[j], !(a ? y.ranges && !y.equals(e.sel) : !y.ranges)); j++)
            ;
          if (j != B.length) {
            for (s.lastOrigin = s.lastSelOrigin = null; ; )
              if (y = B.pop(), y.ranges) {
                if (jo(y, P), a && !y.equals(e.sel)) {
                  Ut(e, y, { clearRedo: !1 });
                  return;
                }
                N = y;
              } else if (o) {
                B.push(y);
                return;
              } else
                break;
            var Z = [];
            jo(N, P), P.push({ changes: Z, generation: s.generation }), s.generation = y.generation || ++s.maxGeneration;
            for (var te = nt(e, "beforeChange") || e.cm && nt(e.cm, "beforeChange"), ue = function(ge) {
              var me = y.changes[ge];
              if (me.origin = n, te && !Xu(e, me, !1))
                return B.length = 0, {};
              Z.push(al(e, me));
              var xe = ge ? rl(e, me) : he(B);
              Li(e, me, xe, $u(e, me)), !ge && e.cm && e.cm.scrollIntoView({ from: me.from, to: cr(me) });
              var Se = [];
              fr(e, function(we, Ee) {
                !Ee && ee(Se, we.history) == -1 && (tc(we.history, me), Se.push(we.history)), Li(we, me, null, $u(we, me));
              });
            }, le = y.changes.length - 1; le >= 0; --le) {
              var pe = ue(le);
              if (pe) return pe.v;
            }
          }
        }
      }
      function qu(e, n) {
        if (n != 0 && (e.first += n, e.sel = new gn(ke(e.sel.ranges, function(s) {
          return new tt(
            ie(s.anchor.line + n, s.anchor.ch),
            ie(s.head.line + n, s.head.ch)
          );
        }), e.sel.primIndex), e.cm)) {
          en(e.cm, e.first, e.first - n, n);
          for (var a = e.cm.display, o = a.viewFrom; o < a.viewTo; o++)
            lr(e.cm, o, "gutter");
        }
      }
      function Li(e, n, a, o) {
        if (e.cm && !e.cm.curOp)
          return Ot(e.cm, Li)(e, n, a, o);
        if (n.to.line < e.first) {
          qu(e, n.text.length - 1 - (n.to.line - n.from.line));
          return;
        }
        if (!(n.from.line > e.lastLine())) {
          if (n.from.line < e.first) {
            var s = n.text.length - 1 - (e.first - n.from.line);
            qu(e, s), n = {
              from: ie(e.first, 0),
              to: ie(n.to.line + s, n.to.ch),
              text: [he(n.text)],
              origin: n.origin
            };
          }
          var y = e.lastLine();
          n.to.line > y && (n = {
            from: n.from,
            to: ie(y, De(e, y).text.length),
            text: [n.text[0]],
            origin: n.origin
          }), n.removed = Vn(e, n.from, n.to), a || (a = rl(e, n)), e.cm ? Mp(e.cm, n, o) : ol(e, n, o), zo(e, a, ae), e.cantEdit && Uo(e, ie(e.firstLine(), 0)) && (e.cantEdit = !1);
        }
      }
      function Mp(e, n, a) {
        var o = e.doc, s = e.display, y = n.from, N = n.to, B = !1, P = y.line;
        e.options.lineWrapping || (P = Ze(Pn(De(o, y.line))), o.iter(P, N.line + 1, function(le) {
          if (le == s.maxLine)
            return B = !0, !0;
        })), o.sel.contains(n.from, n.to) > -1 && Ct(e), ol(o, n, a, gu(e)), e.options.lineWrapping || (o.iter(P, y.line + n.text.length, function(le) {
          var pe = To(le);
          pe > s.maxLineLength && (s.maxLine = le, s.maxLineLength = pe, s.maxLineChanged = !0, B = !1);
        }), B && (e.curOp.updateMaxLine = !0)), bd(o, y.line), Oi(e, 400);
        var j = n.text.length - (N.line - y.line) - 1;
        n.full ? en(e) : y.line == N.line && n.text.length == 1 && !Lu(e.doc, n) ? lr(e, y.line, "text") : en(e, y.line, N.line + 1, j);
        var Z = nt(e, "changes"), te = nt(e, "change");
        if (te || Z) {
          var ue = {
            from: y,
            to: N,
            text: n.text,
            removed: n.removed,
            origin: n.origin
          };
          te && Pt(e, "change", e, ue), Z && (e.curOp.changeObjs || (e.curOp.changeObjs = [])).push(ue);
        }
        e.display.selForContextMenu = null;
      }
      function ni(e, n, a, o, s) {
        var y;
        o || (o = a), de(o, a) < 0 && (y = [o, a], a = y[0], o = y[1]), typeof n == "string" && (n = e.splitLines(n)), ti(e, { from: a, to: o, text: n, origin: s });
      }
      function Zu(e, n, a, o) {
        a < e.line ? e.line += o : n < e.line && (e.line = n, e.ch = 0);
      }
      function ec(e, n, a, o) {
        for (var s = 0; s < e.length; ++s) {
          var y = e[s], N = !0;
          if (y.ranges) {
            y.copied || (y = e[s] = y.deepCopy(), y.copied = !0);
            for (var B = 0; B < y.ranges.length; B++)
              Zu(y.ranges[B].anchor, n, a, o), Zu(y.ranges[B].head, n, a, o);
            continue;
          }
          for (var P = 0; P < y.changes.length; ++P) {
            var j = y.changes[P];
            if (a < j.from.line)
              j.from = ie(j.from.line + o, j.from.ch), j.to = ie(j.to.line + o, j.to.ch);
            else if (n <= j.to.line) {
              N = !1;
              break;
            }
          }
          N || (e.splice(0, s + 1), s = 0);
        }
      }
      function tc(e, n) {
        var a = n.from.line, o = n.to.line, s = n.text.length - (o - a) - 1;
        ec(e.done, a, o, s), ec(e.undone, a, o, s);
      }
      function Fi(e, n, a, o) {
        var s = n, y = n;
        return typeof n == "number" ? y = De(e, hn(e, n)) : s = Ze(n), s == null ? null : (o(y, s) && e.cm && lr(e.cm, s, a), y);
      }
      function Bi(e) {
        this.lines = e, this.parent = null;
        for (var n = 0, a = 0; a < e.length; ++a)
          e[a].parent = this, n += e[a].height;
        this.height = n;
      }
      Bi.prototype = {
        chunkSize: function() {
          return this.lines.length;
        },
        // Remove the n lines at offset 'at'.
        removeInner: function(e, n) {
          for (var a = e, o = e + n; a < o; ++a) {
            var s = this.lines[a];
            this.height -= s.height, Nd(s), Pt(s, "delete");
          }
          this.lines.splice(e, n);
        },
        // Helper used to collapse a small branch into a single leaf.
        collapse: function(e) {
          e.push.apply(e, this.lines);
        },
        // Insert the given array of lines at offset 'at', count them as
        // having the given height.
        insertInner: function(e, n, a) {
          this.height += a, this.lines = this.lines.slice(0, e).concat(n).concat(this.lines.slice(e));
          for (var o = 0; o < n.length; ++o)
            n[o].parent = this;
        },
        // Used to iterate over a part of the tree.
        iterN: function(e, n, a) {
          for (var o = e + n; e < o; ++e)
            if (a(this.lines[e]))
              return !0;
        }
      };
      function Pi(e) {
        this.children = e;
        for (var n = 0, a = 0, o = 0; o < e.length; ++o) {
          var s = e[o];
          n += s.chunkSize(), a += s.height, s.parent = this;
        }
        this.size = n, this.height = a, this.parent = null;
      }
      Pi.prototype = {
        chunkSize: function() {
          return this.size;
        },
        removeInner: function(e, n) {
          this.size -= n;
          for (var a = 0; a < this.children.length; ++a) {
            var o = this.children[a], s = o.chunkSize();
            if (e < s) {
              var y = Math.min(n, s - e), N = o.height;
              if (o.removeInner(e, y), this.height -= N - o.height, s == y && (this.children.splice(a--, 1), o.parent = null), (n -= y) == 0)
                break;
              e = 0;
            } else
              e -= s;
          }
          if (this.size - n < 25 && (this.children.length > 1 || !(this.children[0] instanceof Bi))) {
            var B = [];
            this.collapse(B), this.children = [new Bi(B)], this.children[0].parent = this;
          }
        },
        collapse: function(e) {
          for (var n = 0; n < this.children.length; ++n)
            this.children[n].collapse(e);
        },
        insertInner: function(e, n, a) {
          this.size += n.length, this.height += a;
          for (var o = 0; o < this.children.length; ++o) {
            var s = this.children[o], y = s.chunkSize();
            if (e <= y) {
              if (s.insertInner(e, n, a), s.lines && s.lines.length > 50) {
                for (var N = s.lines.length % 25 + 25, B = N; B < s.lines.length; ) {
                  var P = new Bi(s.lines.slice(B, B += 25));
                  s.height -= P.height, this.children.splice(++o, 0, P), P.parent = this;
                }
                s.lines = s.lines.slice(0, N), this.maybeSpill();
              }
              break;
            }
            e -= y;
          }
        },
        // When a node has grown, check whether it should be split.
        maybeSpill: function() {
          if (!(this.children.length <= 10)) {
            var e = this;
            do {
              var n = e.children.splice(e.children.length - 5, 5), a = new Pi(n);
              if (e.parent) {
                e.size -= a.size, e.height -= a.height;
                var s = ee(e.parent.children, e);
                e.parent.children.splice(s + 1, 0, a);
              } else {
                var o = new Pi(e.children);
                o.parent = e, e.children = [o, a], e = o;
              }
              a.parent = e.parent;
            } while (e.children.length > 10);
            e.parent.maybeSpill();
          }
        },
        iterN: function(e, n, a) {
          for (var o = 0; o < this.children.length; ++o) {
            var s = this.children[o], y = s.chunkSize();
            if (e < y) {
              var N = Math.min(n, y - e);
              if (s.iterN(e, N, a))
                return !0;
              if ((n -= N) == 0)
                break;
              e = 0;
            } else
              e -= y;
          }
        }
      };
      var Hi = function(e, n, a) {
        if (a)
          for (var o in a)
            a.hasOwnProperty(o) && (this[o] = a[o]);
        this.doc = e, this.node = n;
      };
      Hi.prototype.clear = function() {
        var e = this.doc.cm, n = this.line.widgets, a = this.line, o = Ze(a);
        if (!(o == null || !n)) {
          for (var s = 0; s < n.length; ++s)
            n[s] == this && n.splice(s--, 1);
          n.length || (a.widgets = null);
          var y = Si(this);
          wn(a, Math.max(0, a.height - y)), e && (cn(e, function() {
            nc(e, a, -y), lr(e, o, "widget");
          }), Pt(e, "lineWidgetCleared", e, this, o));
        }
      }, Hi.prototype.changed = function() {
        var e = this, n = this.height, a = this.doc.cm, o = this.line;
        this.height = null;
        var s = Si(this) - n;
        s && (ar(this.doc, o) || wn(o, o.height + s), a && cn(a, function() {
          a.curOp.forceUpdate = !0, nc(a, o, s), Pt(a, "lineWidgetChanged", a, e, Ze(o));
        }));
      }, be(Hi);
      function nc(e, n, a) {
        Yn(n) < (e.curOp && e.curOp.scrollTop || e.doc.scrollTop) && Ja(e, a);
      }
      function Np(e, n, a, o) {
        var s = new Hi(e, a, o), y = e.cm;
        return y && s.noHScroll && (y.display.alignWidgets = !0), Fi(e, n, "widget", function(N) {
          var B = N.widgets || (N.widgets = []);
          if (s.insertAt == null ? B.push(s) : B.splice(Math.min(B.length, Math.max(0, s.insertAt)), 0, s), s.line = N, y && !ar(e, N)) {
            var P = Yn(N) < e.scrollTop;
            wn(N, N.height + Si(s)), P && Ja(y, s.height), y.curOp.forceUpdate = !0;
          }
          return !0;
        }), y && Pt(y, "lineWidgetAdded", y, s, typeof n == "number" ? n : Ze(n)), s;
      }
      var rc = 0, dr = function(e, n) {
        this.lines = [], this.type = n, this.doc = e, this.id = ++rc;
      };
      dr.prototype.clear = function() {
        if (!this.explicitlyCleared) {
          var e = this.doc.cm, n = e && !e.curOp;
          if (n && Mr(e), nt(this, "clear")) {
            var a = this.find();
            a && Pt(this, "clear", a.from, a.to);
          }
          for (var o = null, s = null, y = 0; y < this.lines.length; ++y) {
            var N = this.lines[y], B = wi(N.markedSpans, this);
            e && !this.collapsed ? lr(e, Ze(N), "text") : e && (B.to != null && (s = Ze(N)), B.from != null && (o = Ze(N))), N.markedSpans = wd(N.markedSpans, B), B.from == null && this.collapsed && !ar(this.doc, N) && e && wn(N, Yr(e.display));
          }
          if (e && this.collapsed && !e.options.lineWrapping)
            for (var P = 0; P < this.lines.length; ++P) {
              var j = Pn(this.lines[P]), Z = To(j);
              Z > e.display.maxLineLength && (e.display.maxLine = j, e.display.maxLineLength = Z, e.display.maxLineChanged = !0);
            }
          o != null && e && this.collapsed && en(e, o, s + 1), this.lines.length = 0, this.explicitlyCleared = !0, this.atomic && this.doc.cantEdit && (this.doc.cantEdit = !1, e && Vu(e.doc)), e && Pt(e, "markerCleared", e, this, o, s), n && Nr(e), this.parent && this.parent.clear();
        }
      }, dr.prototype.find = function(e, n) {
        e == null && this.type == "bookmark" && (e = 1);
        for (var a, o, s = 0; s < this.lines.length; ++s) {
          var y = this.lines[s], N = wi(y.markedSpans, this);
          if (N.from != null && (a = ie(n ? y : Ze(y), N.from), e == -1))
            return a;
          if (N.to != null && (o = ie(n ? y : Ze(y), N.to), e == 1))
            return o;
        }
        return a && { from: a, to: o };
      }, dr.prototype.changed = function() {
        var e = this, n = this.find(-1, !0), a = this, o = this.doc.cm;
        !n || !o || cn(o, function() {
          var s = n.line, y = Ze(n.line), N = Pa(o, y);
          if (N && (su(N), o.curOp.selectionChanged = o.curOp.forceUpdate = !0), o.curOp.updateMaxLine = !0, !ar(a.doc, s) && a.height != null) {
            var B = a.height;
            a.height = null;
            var P = Si(a) - B;
            P && wn(s, s.height + P);
          }
          Pt(o, "markerChanged", o, e);
        });
      }, dr.prototype.attachLine = function(e) {
        if (!this.lines.length && this.doc.cm) {
          var n = this.doc.cm.curOp;
          (!n.maybeHiddenMarkers || ee(n.maybeHiddenMarkers, this) == -1) && (n.maybeUnhiddenMarkers || (n.maybeUnhiddenMarkers = [])).push(this);
        }
        this.lines.push(e);
      }, dr.prototype.detachLine = function(e) {
        if (this.lines.splice(ee(this.lines, e), 1), !this.lines.length && this.doc.cm) {
          var n = this.doc.cm.curOp;
          (n.maybeHiddenMarkers || (n.maybeHiddenMarkers = [])).push(this);
        }
      }, be(dr);
      function ri(e, n, a, o, s) {
        if (o && o.shared)
          return Op(e, n, a, o, s);
        if (e.cm && !e.cm.curOp)
          return Ot(e.cm, ri)(e, n, a, o, s);
        var y = new dr(e, s), N = de(n, a);
        if (o && X(o, y, !1), N > 0 || N == 0 && y.clearWhenEmpty !== !1)
          return y;
        if (y.replacedWith && (y.collapsed = !0, y.widgetNode = O("span", [y.replacedWith], "CodeMirror-widget"), o.handleMouseEvents || y.widgetNode.setAttribute("cm-ignore-events", "true"), o.insertLeft && (y.widgetNode.insertLeft = !0)), y.collapsed) {
          if (Vs(e, n.line, n, a, y) || n.line != a.line && Vs(e, a.line, n, a, y))
            throw new Error("Inserting collapsed marker partially overlapping an existing one");
          xd();
        }
        y.addToHistory && Hu(e, { from: n, to: a, origin: "markText" }, e.sel, NaN);
        var B = n.line, P = e.cm, j;
        if (e.iter(B, a.line + 1, function(te) {
          P && y.collapsed && !P.options.lineWrapping && Pn(te) == P.display.maxLine && (j = !0), y.collapsed && B != n.line && wn(te, 0), _d(te, new Co(
            y,
            B == n.line ? n.ch : null,
            B == a.line ? a.ch : null
          )), ++B;
        }), y.collapsed && e.iter(n.line, a.line + 1, function(te) {
          ar(e, te) && wn(te, 0);
        }), y.clearOnEnter && fe(y, "beforeCursorEnter", function() {
          return y.clear();
        }), y.readOnly && (Ad(), (e.history.done.length || e.history.undone.length) && e.clearHistory()), y.collapsed && (y.id = ++rc, y.atomic = !0), P) {
          if (j && (P.curOp.updateMaxLine = !0), y.collapsed)
            en(P, n.line, a.line + 1);
          else if (y.className || y.startStyle || y.endStyle || y.css || y.attributes || y.title)
            for (var Z = n.line; Z <= a.line; Z++)
              lr(P, Z, "text");
          y.atomic && Vu(P.doc), Pt(P, "markerAdded", P, y);
        }
        return y;
      }
      var ji = function(e, n) {
        this.markers = e, this.primary = n;
        for (var a = 0; a < e.length; ++a)
          e[a].parent = this;
      };
      ji.prototype.clear = function() {
        if (!this.explicitlyCleared) {
          this.explicitlyCleared = !0;
          for (var e = 0; e < this.markers.length; ++e)
            this.markers[e].clear();
          Pt(this, "clear");
        }
      }, ji.prototype.find = function(e, n) {
        return this.primary.find(e, n);
      }, be(ji);
      function Op(e, n, a, o, s) {
        o = X(o), o.shared = !1;
        var y = [ri(e, n, a, o, s)], N = y[0], B = o.widgetNode;
        return fr(e, function(P) {
          B && (o.widgetNode = B.cloneNode(!0)), y.push(ri(P, Pe(P, n), Pe(P, a), o, s));
          for (var j = 0; j < P.linked.length; ++j)
            if (P.linked[j].isParent)
              return;
          N = he(y);
        }), new ji(y, N);
      }
      function ic(e) {
        return e.findMarks(ie(e.first, 0), e.clipPos(ie(e.lastLine())), function(n) {
          return n.parent;
        });
      }
      function Rp(e, n) {
        for (var a = 0; a < n.length; a++) {
          var o = n[a], s = o.find(), y = e.clipPos(s.from), N = e.clipPos(s.to);
          if (de(y, N)) {
            var B = ri(e, y, N, o.primary, o.primary.type);
            o.markers.push(B), B.parent = o;
          }
        }
      }
      function Ip(e) {
        for (var n = function(o) {
          var s = e[o], y = [s.primary.doc];
          fr(s.primary.doc, function(P) {
            return y.push(P);
          });
          for (var N = 0; N < s.markers.length; N++) {
            var B = s.markers[N];
            ee(y, B.doc) == -1 && (B.parent = null, s.markers.splice(N--, 1));
          }
        }, a = 0; a < e.length; a++) n(a);
      }
      var Lp = 0, tn = function(e, n, a, o, s) {
        if (!(this instanceof tn))
          return new tn(e, n, a, o, s);
        a == null && (a = 0), Pi.call(this, [new Bi([new Qr("", null)])]), this.first = a, this.scrollTop = this.scrollLeft = 0, this.cantEdit = !1, this.cleanGeneration = 1, this.modeFrontier = this.highlightFrontier = a;
        var y = ie(a, 0);
        this.sel = ur(y), this.history = new Ho(null), this.id = ++Lp, this.modeOption = n, this.lineSep = o, this.direction = s == "rtl" ? "rtl" : "ltr", this.extend = !1, typeof e == "string" && (e = this.splitLines(e)), ol(this, { from: y, to: y, text: e }), Ut(this, ur(y), ae);
      };
      tn.prototype = Ve(Pi.prototype, {
        constructor: tn,
        // Iterate over the document. Supports two forms -- with only one
        // argument, it calls that for each line in the document. With
        // three, it iterates over the range given by the first two (with
        // the second being non-inclusive).
        iter: function(e, n, a) {
          a ? this.iterN(e - this.first, n - e, a) : this.iterN(this.first, this.first + this.size, e);
        },
        // Non-public interface for adding and removing lines.
        insert: function(e, n) {
          for (var a = 0, o = 0; o < n.length; ++o)
            a += n[o].height;
          this.insertInner(e - this.first, n, a);
        },
        remove: function(e, n) {
          this.removeInner(e - this.first, n);
        },
        // From here, the methods are part of the public interface. Most
        // are also available from CodeMirror (editor) instances.
        getValue: function(e) {
          var n = Wr(this, this.first, this.first + this.size);
          return e === !1 ? n : n.join(e || this.lineSeparator());
        },
        setValue: Rt(function(e) {
          var n = ie(this.first, 0), a = this.first + this.size - 1;
          ti(this, {
            from: n,
            to: ie(a, De(this, a).text.length),
            text: this.splitLines(e),
            origin: "setValue",
            full: !0
          }, !0), this.cm && Ti(this.cm, 0, 0), Ut(this, ur(n), ae);
        }),
        replaceRange: function(e, n, a, o) {
          n = Pe(this, n), a = a ? Pe(this, a) : n, ni(this, e, n, a, o);
        },
        getRange: function(e, n, a) {
          var o = Vn(this, Pe(this, e), Pe(this, n));
          return a === !1 ? o : o.join(a || this.lineSeparator());
        },
        getLine: function(e) {
          var n = this.getLineHandle(e);
          return n && n.text;
        },
        getLineHandle: function(e) {
          if (V(this, e))
            return De(this, e);
        },
        getLineNumber: function(e) {
          return Ze(e);
        },
        getLineHandleVisualStart: function(e) {
          return typeof e == "number" && (e = De(this, e)), Pn(e);
        },
        lineCount: function() {
          return this.size;
        },
        firstLine: function() {
          return this.first;
        },
        lastLine: function() {
          return this.first + this.size - 1;
        },
        clipPos: function(e) {
          return Pe(this, e);
        },
        getCursor: function(e) {
          var n = this.sel.primary(), a;
          return e == null || e == "head" ? a = n.head : e == "anchor" ? a = n.anchor : e == "end" || e == "to" || e === !1 ? a = n.to() : a = n.from(), a;
        },
        listSelections: function() {
          return this.sel.ranges;
        },
        somethingSelected: function() {
          return this.sel.somethingSelected();
        },
        setCursor: Rt(function(e, n, a) {
          Uu(this, Pe(this, typeof e == "number" ? ie(e, n || 0) : e), null, a);
        }),
        setSelection: Rt(function(e, n, a) {
          Uu(this, Pe(this, e), Pe(this, n || e), a);
        }),
        extendSelection: Rt(function(e, n, a) {
          $o(this, Pe(this, e), n && Pe(this, n), a);
        }),
        extendSelections: Rt(function(e, n) {
          zu(this, Os(this, e), n);
        }),
        extendSelectionsBy: Rt(function(e, n) {
          var a = ke(this.sel.ranges, e);
          zu(this, Os(this, a), n);
        }),
        setSelections: Rt(function(e, n, a) {
          if (e.length) {
            for (var o = [], s = 0; s < e.length; s++)
              o[s] = new tt(
                Pe(this, e[s].anchor),
                Pe(this, e[s].head || e[s].anchor)
              );
            n == null && (n = Math.min(e.length - 1, this.sel.primIndex)), Ut(this, kn(this.cm, o, n), a);
          }
        }),
        addSelection: Rt(function(e, n, a) {
          var o = this.sel.ranges.slice(0);
          o.push(new tt(Pe(this, e), Pe(this, n || e))), Ut(this, kn(this.cm, o, o.length - 1), a);
        }),
        getSelection: function(e) {
          for (var n = this.sel.ranges, a, o = 0; o < n.length; o++) {
            var s = Vn(this, n[o].from(), n[o].to());
            a = a ? a.concat(s) : s;
          }
          return e === !1 ? a : a.join(e || this.lineSeparator());
        },
        getSelections: function(e) {
          for (var n = [], a = this.sel.ranges, o = 0; o < a.length; o++) {
            var s = Vn(this, a[o].from(), a[o].to());
            e !== !1 && (s = s.join(e || this.lineSeparator())), n[o] = s;
          }
          return n;
        },
        replaceSelection: function(e, n, a) {
          for (var o = [], s = 0; s < this.sel.ranges.length; s++)
            o[s] = e;
          this.replaceSelections(o, n, a || "+input");
        },
        replaceSelections: Rt(function(e, n, a) {
          for (var o = [], s = this.sel, y = 0; y < s.ranges.length; y++) {
            var N = s.ranges[y];
            o[y] = { from: N.from(), to: N.to(), text: this.splitLines(e[y]), origin: a };
          }
          for (var B = n && n != "end" && wp(this, o, n), P = o.length - 1; P >= 0; P--)
            ti(this, o[P]);
          B ? Wu(this, B) : this.cm && Jr(this.cm);
        }),
        undo: Rt(function() {
          Wo(this, "undo");
        }),
        redo: Rt(function() {
          Wo(this, "redo");
        }),
        undoSelection: Rt(function() {
          Wo(this, "undo", !0);
        }),
        redoSelection: Rt(function() {
          Wo(this, "redo", !0);
        }),
        setExtending: function(e) {
          this.extend = e;
        },
        getExtending: function() {
          return this.extend;
        },
        historySize: function() {
          for (var e = this.history, n = 0, a = 0, o = 0; o < e.done.length; o++)
            e.done[o].ranges || ++n;
          for (var s = 0; s < e.undone.length; s++)
            e.undone[s].ranges || ++a;
          return { undo: n, redo: a };
        },
        clearHistory: function() {
          var e = this;
          this.history = new Ho(this.history), fr(this, function(n) {
            return n.history = e.history;
          }, !0);
        },
        markClean: function() {
          this.cleanGeneration = this.changeGeneration(!0);
        },
        changeGeneration: function(e) {
          return e && (this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null), this.history.generation;
        },
        isClean: function(e) {
          return this.history.generation == (e || this.cleanGeneration);
        },
        getHistory: function() {
          return {
            done: Zr(this.history.done),
            undone: Zr(this.history.undone)
          };
        },
        setHistory: function(e) {
          var n = this.history = new Ho(this.history);
          n.done = Zr(e.done.slice(0), null, !0), n.undone = Zr(e.undone.slice(0), null, !0);
        },
        setGutterMarker: Rt(function(e, n, a) {
          return Fi(this, e, "gutter", function(o) {
            var s = o.gutterMarkers || (o.gutterMarkers = {});
            return s[n] = a, !a && pn(s) && (o.gutterMarkers = null), !0;
          });
        }),
        clearGutter: Rt(function(e) {
          var n = this;
          this.iter(function(a) {
            a.gutterMarkers && a.gutterMarkers[e] && Fi(n, a, "gutter", function() {
              return a.gutterMarkers[e] = null, pn(a.gutterMarkers) && (a.gutterMarkers = null), !0;
            });
          });
        }),
        lineInfo: function(e) {
          var n;
          if (typeof e == "number") {
            if (!V(this, e) || (n = e, e = De(this, e), !e))
              return null;
          } else if (n = Ze(e), n == null)
            return null;
          return {
            line: n,
            handle: e,
            text: e.text,
            gutterMarkers: e.gutterMarkers,
            textClass: e.textClass,
            bgClass: e.bgClass,
            wrapClass: e.wrapClass,
            widgets: e.widgets
          };
        },
        addLineClass: Rt(function(e, n, a) {
          return Fi(this, e, n == "gutter" ? "gutter" : "class", function(o) {
            var s = n == "text" ? "textClass" : n == "background" ? "bgClass" : n == "gutter" ? "gutterClass" : "wrapClass";
            if (!o[s])
              o[s] = a;
            else {
              if (k(a).test(o[s]))
                return !1;
              o[s] += " " + a;
            }
            return !0;
          });
        }),
        removeLineClass: Rt(function(e, n, a) {
          return Fi(this, e, n == "gutter" ? "gutter" : "class", function(o) {
            var s = n == "text" ? "textClass" : n == "background" ? "bgClass" : n == "gutter" ? "gutterClass" : "wrapClass", y = o[s];
            if (y)
              if (a == null)
                o[s] = null;
              else {
                var N = y.match(k(a));
                if (!N)
                  return !1;
                var B = N.index + N[0].length;
                o[s] = y.slice(0, N.index) + (!N.index || B == y.length ? "" : " ") + y.slice(B) || null;
              }
            else return !1;
            return !0;
          });
        }),
        addLineWidget: Rt(function(e, n, a) {
          return Np(this, e, n, a);
        }),
        removeLineWidget: function(e) {
          e.clear();
        },
        markText: function(e, n, a) {
          return ri(this, Pe(this, e), Pe(this, n), a, a && a.type || "range");
        },
        setBookmark: function(e, n) {
          var a = {
            replacedWith: n && (n.nodeType == null ? n.widget : n),
            insertLeft: n && n.insertLeft,
            clearWhenEmpty: !1,
            shared: n && n.shared,
            handleMouseEvents: n && n.handleMouseEvents
          };
          return e = Pe(this, e), ri(this, e, e, a, "bookmark");
        },
        findMarksAt: function(e) {
          e = Pe(this, e);
          var n = [], a = De(this, e.line).markedSpans;
          if (a)
            for (var o = 0; o < a.length; ++o) {
              var s = a[o];
              (s.from == null || s.from <= e.ch) && (s.to == null || s.to >= e.ch) && n.push(s.marker.parent || s.marker);
            }
          return n;
        },
        findMarks: function(e, n, a) {
          e = Pe(this, e), n = Pe(this, n);
          var o = [], s = e.line;
          return this.iter(e.line, n.line + 1, function(y) {
            var N = y.markedSpans;
            if (N)
              for (var B = 0; B < N.length; B++) {
                var P = N[B];
                !(P.to != null && s == e.line && e.ch >= P.to || P.from == null && s != e.line || P.from != null && s == n.line && P.from >= n.ch) && (!a || a(P.marker)) && o.push(P.marker.parent || P.marker);
              }
            ++s;
          }), o;
        },
        getAllMarks: function() {
          var e = [];
          return this.iter(function(n) {
            var a = n.markedSpans;
            if (a)
              for (var o = 0; o < a.length; ++o)
                a[o].from != null && e.push(a[o].marker);
          }), e;
        },
        posFromIndex: function(e) {
          var n, a = this.first, o = this.lineSeparator().length;
          return this.iter(function(s) {
            var y = s.text.length + o;
            if (y > e)
              return n = e, !0;
            e -= y, ++a;
          }), Pe(this, ie(a, n));
        },
        indexFromPos: function(e) {
          e = Pe(this, e);
          var n = e.ch;
          if (e.line < this.first || e.ch < 0)
            return 0;
          var a = this.lineSeparator().length;
          return this.iter(this.first, e.line, function(o) {
            n += o.text.length + a;
          }), n;
        },
        copy: function(e) {
          var n = new tn(
            Wr(this, this.first, this.first + this.size),
            this.modeOption,
            this.first,
            this.lineSep,
            this.direction
          );
          return n.scrollTop = this.scrollTop, n.scrollLeft = this.scrollLeft, n.sel = this.sel, n.extend = !1, e && (n.history.undoDepth = this.history.undoDepth, n.setHistory(this.getHistory())), n;
        },
        linkedDoc: function(e) {
          e || (e = {});
          var n = this.first, a = this.first + this.size;
          e.from != null && e.from > n && (n = e.from), e.to != null && e.to < a && (a = e.to);
          var o = new tn(Wr(this, n, a), e.mode || this.modeOption, n, this.lineSep, this.direction);
          return e.sharedHist && (o.history = this.history), (this.linked || (this.linked = [])).push({ doc: o, sharedHist: e.sharedHist }), o.linked = [{ doc: this, isParent: !0, sharedHist: e.sharedHist }], Rp(o, ic(this)), o;
        },
        unlinkDoc: function(e) {
          if (e instanceof ht && (e = e.doc), this.linked)
            for (var n = 0; n < this.linked.length; ++n) {
              var a = this.linked[n];
              if (a.doc == e) {
                this.linked.splice(n, 1), e.unlinkDoc(this), Ip(ic(this));
                break;
              }
            }
          if (e.history == this.history) {
            var o = [e.id];
            fr(e, function(s) {
              return o.push(s.id);
            }, !0), e.history = new Ho(null), e.history.done = Zr(this.history.done, o), e.history.undone = Zr(this.history.undone, o);
          }
        },
        iterLinkedDocs: function(e) {
          fr(this, e);
        },
        getMode: function() {
          return this.mode;
        },
        getEditor: function() {
          return this.cm;
        },
        splitLines: function(e) {
          return this.lineSep ? e.split(this.lineSep) : bi(e);
        },
        lineSeparator: function() {
          return this.lineSep || `
`;
        },
        setDirection: Rt(function(e) {
          e != "rtl" && (e = "ltr"), e != this.direction && (this.direction = e, this.iter(function(n) {
            return n.order = null;
          }), this.cm && _p(this.cm));
        })
      }), tn.prototype.eachLine = tn.prototype.iter;
      var oc = 0;
      function Fp(e) {
        var n = this;
        if (ac(n), !($e(n, e) || Kn(n.display, e))) {
          Te(e), W && (oc = +/* @__PURE__ */ new Date());
          var a = Er(n, e, !0), o = e.dataTransfer.files;
          if (!(!a || n.isReadOnly()))
            if (o && o.length && window.FileReader && window.File)
              for (var s = o.length, y = Array(s), N = 0, B = function() {
                ++N == s && Ot(n, function() {
                  a = Pe(n.doc, a);
                  var le = {
                    from: a,
                    to: a,
                    text: n.doc.splitLines(
                      y.filter(function(pe) {
                        return pe != null;
                      }).join(n.doc.lineSeparator())
                    ),
                    origin: "paste"
                  };
                  ti(n.doc, le), Wu(n.doc, ur(Pe(n.doc, a), Pe(n.doc, cr(le))));
                })();
              }, P = function(le, pe) {
                if (n.options.allowDropFileTypes && ee(n.options.allowDropFileTypes, le.type) == -1) {
                  B();
                  return;
                }
                var ge = new FileReader();
                ge.onerror = function() {
                  return B();
                }, ge.onload = function() {
                  var me = ge.result;
                  if (/[\x00-\x08\x0e-\x1f]{2}/.test(me)) {
                    B();
                    return;
                  }
                  y[pe] = me, B();
                }, ge.readAsText(le);
              }, j = 0; j < o.length; j++)
                P(o[j], j);
            else {
              if (n.state.draggingText && n.doc.sel.contains(a) > -1) {
                n.state.draggingText(e), setTimeout(function() {
                  return n.display.input.focus();
                }, 20);
                return;
              }
              try {
                var Z = e.dataTransfer.getData("Text");
                if (Z) {
                  var te;
                  if (n.state.draggingText && !n.state.draggingText.copy && (te = n.listSelections()), zo(n.doc, ur(a, a)), te)
                    for (var ue = 0; ue < te.length; ++ue)
                      ni(n.doc, "", te[ue].anchor, te[ue].head, "drag");
                  n.replaceSelection(Z, "around", "paste"), n.display.input.focus();
                }
              } catch (le) {
              }
            }
        }
      }
      function Bp(e, n) {
        if (W && (!e.state.draggingText || +/* @__PURE__ */ new Date() - oc < 100)) {
          it(n);
          return;
        }
        if (!($e(e, n) || Kn(e.display, n)) && (n.dataTransfer.setData("Text", e.getSelection()), n.dataTransfer.effectAllowed = "copyMove", n.dataTransfer.setDragImage && !u)) {
          var a = w("img", null, null, "position: fixed; left: 0; top: 0;");
          a.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", r && (a.width = a.height = 1, e.display.wrapper.appendChild(a), a._top = a.offsetTop), n.dataTransfer.setDragImage(a, 0, 0), r && a.parentNode.removeChild(a);
        }
      }
      function Pp(e, n) {
        var a = Er(e, n);
        if (a) {
          var o = document.createDocumentFragment();
          bu(e, a, o), e.display.dragCursor || (e.display.dragCursor = w("div", null, "CodeMirror-cursors CodeMirror-dragcursors"), e.display.lineSpace.insertBefore(e.display.dragCursor, e.display.cursorDiv)), E(e.display.dragCursor, o);
        }
      }
      function ac(e) {
        e.display.dragCursor && (e.display.lineSpace.removeChild(e.display.dragCursor), e.display.dragCursor = null);
      }
      function lc(e) {
        if (document.getElementsByClassName) {
          for (var n = document.getElementsByClassName("CodeMirror"), a = [], o = 0; o < n.length; o++) {
            var s = n[o].CodeMirror;
            s && a.push(s);
          }
          a.length && a[0].operation(function() {
            for (var y = 0; y < a.length; y++)
              e(a[y]);
          });
        }
      }
      var sc = !1;
      function Hp() {
        sc || (jp(), sc = !0);
      }
      function jp() {
        var e;
        fe(window, "resize", function() {
          e == null && (e = setTimeout(function() {
            e = null, lc($p);
          }, 100));
        }), fe(window, "blur", function() {
          return lc(Xr);
        });
      }
      function $p(e) {
        var n = e.display;
        n.cachedCharWidth = n.cachedTextHeight = n.cachedPaddingH = null, n.scrollbarsClipped = !1, e.setSize();
      }
      for (var pr = {
        3: "Pause",
        8: "Backspace",
        9: "Tab",
        13: "Enter",
        16: "Shift",
        17: "Ctrl",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Esc",
        32: "Space",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "Left",
        38: "Up",
        39: "Right",
        40: "Down",
        44: "PrintScrn",
        45: "Insert",
        46: "Delete",
        59: ";",
        61: "=",
        91: "Mod",
        92: "Mod",
        93: "Mod",
        106: "*",
        107: "=",
        109: "-",
        110: ".",
        111: "/",
        145: "ScrollLock",
        173: "-",
        186: ";",
        187: "=",
        188: ",",
        189: "-",
        190: ".",
        191: "/",
        192: "`",
        219: "[",
        220: "\\",
        221: "]",
        222: "'",
        224: "Mod",
        63232: "Up",
        63233: "Down",
        63234: "Left",
        63235: "Right",
        63272: "Delete",
        63273: "Home",
        63275: "End",
        63276: "PageUp",
        63277: "PageDown",
        63302: "Insert"
      }, $i = 0; $i < 10; $i++)
        pr[$i + 48] = pr[$i + 96] = String($i);
      for (var Qo = 65; Qo <= 90; Qo++)
        pr[Qo] = String.fromCharCode(Qo);
      for (var zi = 1; zi <= 12; zi++)
        pr[zi + 111] = pr[zi + 63235] = "F" + zi;
      var Xn = {};
      Xn.basic = {
        Left: "goCharLeft",
        Right: "goCharRight",
        Up: "goLineUp",
        Down: "goLineDown",
        End: "goLineEnd",
        Home: "goLineStartSmart",
        PageUp: "goPageUp",
        PageDown: "goPageDown",
        Delete: "delCharAfter",
        Backspace: "delCharBefore",
        "Shift-Backspace": "delCharBefore",
        Tab: "defaultTab",
        "Shift-Tab": "indentAuto",
        Enter: "newlineAndIndent",
        Insert: "toggleOverwrite",
        Esc: "singleSelection"
      }, Xn.pcDefault = {
        "Ctrl-A": "selectAll",
        "Ctrl-D": "deleteLine",
        "Ctrl-Z": "undo",
        "Shift-Ctrl-Z": "redo",
        "Ctrl-Y": "redo",
        "Ctrl-Home": "goDocStart",
        "Ctrl-End": "goDocEnd",
        "Ctrl-Up": "goLineUp",
        "Ctrl-Down": "goLineDown",
        "Ctrl-Left": "goGroupLeft",
        "Ctrl-Right": "goGroupRight",
        "Alt-Left": "goLineStart",
        "Alt-Right": "goLineEnd",
        "Ctrl-Backspace": "delGroupBefore",
        "Ctrl-Delete": "delGroupAfter",
        "Ctrl-S": "save",
        "Ctrl-F": "find",
        "Ctrl-G": "findNext",
        "Shift-Ctrl-G": "findPrev",
        "Shift-Ctrl-F": "replace",
        "Shift-Ctrl-R": "replaceAll",
        "Ctrl-[": "indentLess",
        "Ctrl-]": "indentMore",
        "Ctrl-U": "undoSelection",
        "Shift-Ctrl-U": "redoSelection",
        "Alt-U": "redoSelection",
        fallthrough: "basic"
      }, Xn.emacsy = {
        "Ctrl-F": "goCharRight",
        "Ctrl-B": "goCharLeft",
        "Ctrl-P": "goLineUp",
        "Ctrl-N": "goLineDown",
        "Alt-F": "goWordRight",
        "Alt-B": "goWordLeft",
        "Ctrl-A": "goLineStart",
        "Ctrl-E": "goLineEnd",
        "Ctrl-V": "goPageDown",
        "Shift-Ctrl-V": "goPageUp",
        "Ctrl-D": "delCharAfter",
        "Ctrl-H": "delCharBefore",
        "Alt-D": "delWordAfter",
        "Alt-Backspace": "delWordBefore",
        "Ctrl-K": "killLine",
        "Ctrl-T": "transposeChars",
        "Ctrl-O": "openLine"
      }, Xn.macDefault = {
        "Cmd-A": "selectAll",
        "Cmd-D": "deleteLine",
        "Cmd-Z": "undo",
        "Shift-Cmd-Z": "redo",
        "Cmd-Y": "redo",
        "Cmd-Home": "goDocStart",
        "Cmd-Up": "goDocStart",
        "Cmd-End": "goDocEnd",
        "Cmd-Down": "goDocEnd",
        "Alt-Left": "goGroupLeft",
        "Alt-Right": "goGroupRight",
        "Cmd-Left": "goLineLeft",
        "Cmd-Right": "goLineRight",
        "Alt-Backspace": "delGroupBefore",
        "Ctrl-Alt-Backspace": "delGroupAfter",
        "Alt-Delete": "delGroupAfter",
        "Cmd-S": "save",
        "Cmd-F": "find",
        "Cmd-G": "findNext",
        "Shift-Cmd-G": "findPrev",
        "Cmd-Alt-F": "replace",
        "Shift-Cmd-Alt-F": "replaceAll",
        "Cmd-[": "indentLess",
        "Cmd-]": "indentMore",
        "Cmd-Backspace": "delWrappedLineLeft",
        "Cmd-Delete": "delWrappedLineRight",
        "Cmd-U": "undoSelection",
        "Shift-Cmd-U": "redoSelection",
        "Ctrl-Up": "goDocStart",
        "Ctrl-Down": "goDocEnd",
        fallthrough: ["basic", "emacsy"]
      }, Xn.default = g ? Xn.macDefault : Xn.pcDefault;
      function zp(e) {
        var n = e.split(/-(?!$)/);
        e = n[n.length - 1];
        for (var a, o, s, y, N = 0; N < n.length - 1; N++) {
          var B = n[N];
          if (/^(cmd|meta|m)$/i.test(B))
            y = !0;
          else if (/^a(lt)?$/i.test(B))
            a = !0;
          else if (/^(c|ctrl|control)$/i.test(B))
            o = !0;
          else if (/^s(hift)?$/i.test(B))
            s = !0;
          else
            throw new Error("Unrecognized modifier name: " + B);
        }
        return a && (e = "Alt-" + e), o && (e = "Ctrl-" + e), y && (e = "Cmd-" + e), s && (e = "Shift-" + e), e;
      }
      function Up(e) {
        var n = {};
        for (var a in e)
          if (e.hasOwnProperty(a)) {
            var o = e[a];
            if (/^(name|fallthrough|(de|at)tach)$/.test(a))
              continue;
            if (o == "...") {
              delete e[a];
              continue;
            }
            for (var s = ke(a.split(" "), zp), y = 0; y < s.length; y++) {
              var N = void 0, B = void 0;
              y == s.length - 1 ? (B = s.join(" "), N = o) : (B = s.slice(0, y + 1).join(" "), N = "...");
              var P = n[B];
              if (!P)
                n[B] = N;
              else if (P != N)
                throw new Error("Inconsistent bindings for " + B);
            }
            delete e[a];
          }
        for (var j in n)
          e[j] = n[j];
        return e;
      }
      function ii(e, n, a, o) {
        n = Vo(n);
        var s = n.call ? n.call(e, o) : n[e];
        if (s === !1)
          return "nothing";
        if (s === "...")
          return "multi";
        if (s != null && a(s))
          return "handled";
        if (n.fallthrough) {
          if (Object.prototype.toString.call(n.fallthrough) != "[object Array]")
            return ii(e, n.fallthrough, a, o);
          for (var y = 0; y < n.fallthrough.length; y++) {
            var N = ii(e, n.fallthrough[y], a, o);
            if (N)
              return N;
          }
        }
      }
      function uc(e) {
        var n = typeof e == "string" ? e : pr[e.keyCode];
        return n == "Ctrl" || n == "Alt" || n == "Shift" || n == "Mod";
      }
      function cc(e, n, a) {
        var o = e;
        return n.altKey && o != "Alt" && (e = "Alt-" + e), (S ? n.metaKey : n.ctrlKey) && o != "Ctrl" && (e = "Ctrl-" + e), (S ? n.ctrlKey : n.metaKey) && o != "Mod" && (e = "Cmd-" + e), !a && n.shiftKey && o != "Shift" && (e = "Shift-" + e), e;
      }
      function fc(e, n) {
        if (r && e.keyCode == 34 && e.char)
          return !1;
        var a = pr[e.keyCode];
        return a == null || e.altGraphKey ? !1 : (e.keyCode == 3 && e.code && (a = e.code), cc(a, e, n));
      }
      function Vo(e) {
        return typeof e == "string" ? Xn[e] : e;
      }
      function oi(e, n) {
        for (var a = e.doc.sel.ranges, o = [], s = 0; s < a.length; s++) {
          for (var y = n(a[s]); o.length && de(y.from, he(o).to) <= 0; ) {
            var N = o.pop();
            if (de(N.from, y.from) < 0) {
              y.from = N.from;
              break;
            }
          }
          o.push(y);
        }
        cn(e, function() {
          for (var B = o.length - 1; B >= 0; B--)
            ni(e.doc, "", o[B].from, o[B].to, "+delete");
          Jr(e);
        });
      }
      function ul(e, n, a) {
        var o = jt(e.text, n + a, a);
        return o < 0 || o > e.text.length ? null : o;
      }
      function cl(e, n, a) {
        var o = ul(e, n.ch, a);
        return o == null ? null : new ie(n.line, o, a < 0 ? "after" : "before");
      }
      function fl(e, n, a, o, s) {
        if (e) {
          n.doc.direction == "rtl" && (s = -s);
          var y = ct(a, n.doc.direction);
          if (y) {
            var N = s < 0 ? he(y) : y[0], B = s < 0 == (N.level == 1), P = B ? "after" : "before", j;
            if (N.level > 0 || n.doc.direction == "rtl") {
              var Z = Gr(n, a);
              j = s < 0 ? a.text.length - 1 : 0;
              var te = jn(n, Z, j).top;
              j = sn(function(ue) {
                return jn(n, Z, ue).top == te;
              }, s < 0 == (N.level == 1) ? N.from : N.to - 1, j), P == "before" && (j = ul(a, j, 1));
            } else
              j = s < 0 ? N.to : N.from;
            return new ie(o, j, P);
          }
        }
        return new ie(o, s < 0 ? a.text.length : 0, s < 0 ? "before" : "after");
      }
      function Wp(e, n, a, o) {
        var s = ct(n, e.doc.direction);
        if (!s)
          return cl(n, a, o);
        a.ch >= n.text.length ? (a.ch = n.text.length, a.sticky = "before") : a.ch <= 0 && (a.ch = 0, a.sticky = "after");
        var y = $t(s, a.ch, a.sticky), N = s[y];
        if (e.doc.direction == "ltr" && N.level % 2 == 0 && (o > 0 ? N.to > a.ch : N.from < a.ch))
          return cl(n, a, o);
        var B = function(xe, Se) {
          return ul(n, xe instanceof ie ? xe.ch : xe, Se);
        }, P, j = function(xe) {
          return e.options.lineWrapping ? (P = P || Gr(e, n), vu(e, n, P, xe)) : { begin: 0, end: n.text.length };
        }, Z = j(a.sticky == "before" ? B(a, -1) : a.ch);
        if (e.doc.direction == "rtl" || N.level == 1) {
          var te = N.level == 1 == o < 0, ue = B(a, te ? 1 : -1);
          if (ue != null && (te ? ue <= N.to && ue <= Z.end : ue >= N.from && ue >= Z.begin)) {
            var le = te ? "before" : "after";
            return new ie(a.line, ue, le);
          }
        }
        var pe = function(xe, Se, we) {
          for (var Ee = function(ut, It) {
            return It ? new ie(a.line, B(ut, 1), "before") : new ie(a.line, ut, "after");
          }; xe >= 0 && xe < s.length; xe += Se) {
            var Le = s[xe], Re = Se > 0 == (Le.level != 1), We = Re ? we.begin : B(we.end, -1);
            if (Le.from <= We && We < Le.to || (We = Re ? Le.from : B(Le.to, -1), we.begin <= We && We < we.end))
              return Ee(We, Re);
          }
        }, ge = pe(y + o, o, Z);
        if (ge)
          return ge;
        var me = o > 0 ? Z.end : B(Z.begin, -1);
        return me != null && !(o > 0 && me == n.text.length) && (ge = pe(o > 0 ? 0 : s.length - 1, o, j(me)), ge) ? ge : null;
      }
      var Ui = {
        selectAll: Ku,
        singleSelection: function(e) {
          return e.setSelection(e.getCursor("anchor"), e.getCursor("head"), ae);
        },
        killLine: function(e) {
          return oi(e, function(n) {
            if (n.empty()) {
              var a = De(e.doc, n.head.line).text.length;
              return n.head.ch == a && n.head.line < e.lastLine() ? { from: n.head, to: ie(n.head.line + 1, 0) } : { from: n.head, to: ie(n.head.line, a) };
            } else
              return { from: n.from(), to: n.to() };
          });
        },
        deleteLine: function(e) {
          return oi(e, function(n) {
            return {
              from: ie(n.from().line, 0),
              to: Pe(e.doc, ie(n.to().line + 1, 0))
            };
          });
        },
        delLineLeft: function(e) {
          return oi(e, function(n) {
            return {
              from: ie(n.from().line, 0),
              to: n.from()
            };
          });
        },
        delWrappedLineLeft: function(e) {
          return oi(e, function(n) {
            var a = e.charCoords(n.head, "div").top + 5, o = e.coordsChar({ left: 0, top: a }, "div");
            return { from: o, to: n.from() };
          });
        },
        delWrappedLineRight: function(e) {
          return oi(e, function(n) {
            var a = e.charCoords(n.head, "div").top + 5, o = e.coordsChar({ left: e.display.lineDiv.offsetWidth + 100, top: a }, "div");
            return { from: n.from(), to: o };
          });
        },
        undo: function(e) {
          return e.undo();
        },
        redo: function(e) {
          return e.redo();
        },
        undoSelection: function(e) {
          return e.undoSelection();
        },
        redoSelection: function(e) {
          return e.redoSelection();
        },
        goDocStart: function(e) {
          return e.extendSelection(ie(e.firstLine(), 0));
        },
        goDocEnd: function(e) {
          return e.extendSelection(ie(e.lastLine()));
        },
        goLineStart: function(e) {
          return e.extendSelectionsBy(
            function(n) {
              return dc(e, n.head.line);
            },
            { origin: "+move", bias: 1 }
          );
        },
        goLineStartSmart: function(e) {
          return e.extendSelectionsBy(
            function(n) {
              return pc(e, n.head);
            },
            { origin: "+move", bias: 1 }
          );
        },
        goLineEnd: function(e) {
          return e.extendSelectionsBy(
            function(n) {
              return Qp(e, n.head.line);
            },
            { origin: "+move", bias: -1 }
          );
        },
        goLineRight: function(e) {
          return e.extendSelectionsBy(function(n) {
            var a = e.cursorCoords(n.head, "div").top + 5;
            return e.coordsChar({ left: e.display.lineDiv.offsetWidth + 100, top: a }, "div");
          }, ve);
        },
        goLineLeft: function(e) {
          return e.extendSelectionsBy(function(n) {
            var a = e.cursorCoords(n.head, "div").top + 5;
            return e.coordsChar({ left: 0, top: a }, "div");
          }, ve);
        },
        goLineLeftSmart: function(e) {
          return e.extendSelectionsBy(function(n) {
            var a = e.cursorCoords(n.head, "div").top + 5, o = e.coordsChar({ left: 0, top: a }, "div");
            return o.ch < e.getLine(o.line).search(/\S/) ? pc(e, n.head) : o;
          }, ve);
        },
        goLineUp: function(e) {
          return e.moveV(-1, "line");
        },
        goLineDown: function(e) {
          return e.moveV(1, "line");
        },
        goPageUp: function(e) {
          return e.moveV(-1, "page");
        },
        goPageDown: function(e) {
          return e.moveV(1, "page");
        },
        goCharLeft: function(e) {
          return e.moveH(-1, "char");
        },
        goCharRight: function(e) {
          return e.moveH(1, "char");
        },
        goColumnLeft: function(e) {
          return e.moveH(-1, "column");
        },
        goColumnRight: function(e) {
          return e.moveH(1, "column");
        },
        goWordLeft: function(e) {
          return e.moveH(-1, "word");
        },
        goGroupRight: function(e) {
          return e.moveH(1, "group");
        },
        goGroupLeft: function(e) {
          return e.moveH(-1, "group");
        },
        goWordRight: function(e) {
          return e.moveH(1, "word");
        },
        delCharBefore: function(e) {
          return e.deleteH(-1, "codepoint");
        },
        delCharAfter: function(e) {
          return e.deleteH(1, "char");
        },
        delWordBefore: function(e) {
          return e.deleteH(-1, "word");
        },
        delWordAfter: function(e) {
          return e.deleteH(1, "word");
        },
        delGroupBefore: function(e) {
          return e.deleteH(-1, "group");
        },
        delGroupAfter: function(e) {
          return e.deleteH(1, "group");
        },
        indentAuto: function(e) {
          return e.indentSelection("smart");
        },
        indentMore: function(e) {
          return e.indentSelection("add");
        },
        indentLess: function(e) {
          return e.indentSelection("subtract");
        },
        insertTab: function(e) {
          return e.replaceSelection("	");
        },
        insertSoftTab: function(e) {
          for (var n = [], a = e.listSelections(), o = e.options.tabSize, s = 0; s < a.length; s++) {
            var y = a[s].from(), N = G(e.getLine(y.line), y.ch, o);
            n.push(ce(o - N % o));
          }
          e.replaceSelections(n);
        },
        defaultTab: function(e) {
          e.somethingSelected() ? e.indentSelection("add") : e.execCommand("insertTab");
        },
        // Swap the two chars left and right of each selection's head.
        // Move cursor behind the two swapped characters afterwards.
        //
        // Doesn't consider line feeds a character.
        // Doesn't scan more than one line above to find a character.
        // Doesn't do anything on an empty line.
        // Doesn't do anything with non-empty selections.
        transposeChars: function(e) {
          return cn(e, function() {
            for (var n = e.listSelections(), a = [], o = 0; o < n.length; o++)
              if (n[o].empty()) {
                var s = n[o].head, y = De(e.doc, s.line).text;
                if (y) {
                  if (s.ch == y.length && (s = new ie(s.line, s.ch - 1)), s.ch > 0)
                    s = new ie(s.line, s.ch + 1), e.replaceRange(
                      y.charAt(s.ch - 1) + y.charAt(s.ch - 2),
                      ie(s.line, s.ch - 2),
                      s,
                      "+transpose"
                    );
                  else if (s.line > e.doc.first) {
                    var N = De(e.doc, s.line - 1).text;
                    N && (s = new ie(s.line, 1), e.replaceRange(
                      y.charAt(0) + e.doc.lineSeparator() + N.charAt(N.length - 1),
                      ie(s.line - 1, N.length - 1),
                      s,
                      "+transpose"
                    ));
                  }
                }
                a.push(new tt(s, s));
              }
            e.setSelections(a);
          });
        },
        newlineAndIndent: function(e) {
          return cn(e, function() {
            for (var n = e.listSelections(), a = n.length - 1; a >= 0; a--)
              e.replaceRange(e.doc.lineSeparator(), n[a].anchor, n[a].head, "+input");
            n = e.listSelections();
            for (var o = 0; o < n.length; o++)
              e.indentLine(n[o].from().line, null, !0);
            Jr(e);
          });
        },
        openLine: function(e) {
          return e.replaceSelection(`
`, "start");
        },
        toggleOverwrite: function(e) {
          return e.toggleOverwrite();
        }
      };
      function dc(e, n) {
        var a = De(e.doc, n), o = Pn(a);
        return o != a && (n = Ze(o)), fl(!0, e, o, n, 1);
      }
      function Qp(e, n) {
        var a = De(e.doc, n), o = Td(a);
        return o != a && (n = Ze(o)), fl(!0, e, a, n, -1);
      }
      function pc(e, n) {
        var a = dc(e, n.line), o = De(e.doc, a.line), s = ct(o, e.doc.direction);
        if (!s || s[0].level == 0) {
          var y = Math.max(a.ch, o.text.search(/\S/)), N = n.line == a.line && n.ch <= y && n.ch;
          return ie(a.line, N ? 0 : y, a.sticky);
        }
        return a;
      }
      function Go(e, n, a) {
        if (typeof n == "string" && (n = Ui[n], !n))
          return !1;
        e.display.input.ensurePolled();
        var o = e.display.shift, s = !1;
        try {
          e.isReadOnly() && (e.state.suppressEdits = !0), a && (e.display.shift = !1), s = n(e) != oe;
        } finally {
          e.display.shift = o, e.state.suppressEdits = !1;
        }
        return s;
      }
      function Vp(e, n, a) {
        for (var o = 0; o < e.state.keyMaps.length; o++) {
          var s = ii(n, e.state.keyMaps[o], a, e);
          if (s)
            return s;
        }
        return e.options.extraKeys && ii(n, e.options.extraKeys, a, e) || ii(n, e.options.keyMap, a, e);
      }
      var Gp = new J();
      function Wi(e, n, a, o) {
        var s = e.state.keySeq;
        if (s) {
          if (uc(n))
            return "handled";
          if (/\'$/.test(n) ? e.state.keySeq = null : Gp.set(50, function() {
            e.state.keySeq == s && (e.state.keySeq = null, e.display.input.reset());
          }), hc(e, s + " " + n, a, o))
            return !0;
        }
        return hc(e, n, a, o);
      }
      function hc(e, n, a, o) {
        var s = Vp(e, n, o);
        return s == "multi" && (e.state.keySeq = n), s == "handled" && Pt(e, "keyHandled", e, n, a), (s == "handled" || s == "multi") && (Te(a), Ga(e)), !!s;
      }
      function vc(e, n) {
        var a = fc(n, !0);
        return a ? n.shiftKey && !e.state.keySeq ? Wi(e, "Shift-" + a, n, function(o) {
          return Go(e, o, !0);
        }) || Wi(e, a, n, function(o) {
          if (typeof o == "string" ? /^go[A-Z]/.test(o) : o.motion)
            return Go(e, o);
        }) : Wi(e, a, n, function(o) {
          return Go(e, o);
        }) : !1;
      }
      function Yp(e, n, a) {
        return Wi(e, "'" + a + "'", n, function(o) {
          return Go(e, o, !0);
        });
      }
      var dl = null;
      function gc(e) {
        var n = this;
        if (!(e.target && e.target != n.display.input.getField()) && (n.curOp.focus = H(), !$e(n, e))) {
          W && K < 11 && e.keyCode == 27 && (e.returnValue = !1);
          var a = e.keyCode;
          n.display.shift = a == 16 || e.shiftKey;
          var o = vc(n, e);
          r && (dl = o ? a : null, !o && a == 88 && !In && (g ? e.metaKey : e.ctrlKey) && n.replaceSelection("", null, "cut")), M && !g && !o && a == 46 && e.shiftKey && !e.ctrlKey && document.execCommand && document.execCommand("cut"), a == 18 && !/\bCodeMirror-crosshair\b/.test(n.display.lineDiv.className) && Kp(n);
        }
      }
      function Kp(e) {
        var n = e.display.lineDiv;
        $(n, "CodeMirror-crosshair");
        function a(o) {
          (o.keyCode == 18 || !o.altKey) && (L(n, "CodeMirror-crosshair"), _e(document, "keyup", a), _e(document, "mouseover", a));
        }
        fe(document, "keyup", a), fe(document, "mouseover", a);
      }
      function mc(e) {
        e.keyCode == 16 && (this.doc.sel.shift = !1), $e(this, e);
      }
      function yc(e) {
        var n = this;
        if (!(e.target && e.target != n.display.input.getField()) && !(Kn(n.display, e) || $e(n, e) || e.ctrlKey && !e.altKey || g && e.metaKey)) {
          var a = e.keyCode, o = e.charCode;
          if (r && a == dl) {
            dl = null, Te(e);
            return;
          }
          if (!(r && (!e.which || e.which < 10) && vc(n, e))) {
            var s = String.fromCharCode(o == null ? a : o);
            s != "\b" && (Yp(n, e, s) || n.display.input.onKeyPress(e));
          }
        }
      }
      var Xp = 400, pl = function(e, n, a) {
        this.time = e, this.pos = n, this.button = a;
      };
      pl.prototype.compare = function(e, n, a) {
        return this.time + Xp > e && de(n, this.pos) == 0 && a == this.button;
      };
      var Qi, Vi;
      function Jp(e, n) {
        var a = +/* @__PURE__ */ new Date();
        return Vi && Vi.compare(a, e, n) ? (Qi = Vi = null, "triple") : Qi && Qi.compare(a, e, n) ? (Vi = new pl(a, e, n), Qi = null, "double") : (Qi = new pl(a, e, n), Vi = null, "single");
      }
      function bc(e) {
        var n = this, a = n.display;
        if (!($e(n, e) || a.activeTouch && a.input.supportsTouch())) {
          if (a.input.ensurePolled(), a.shift = e.shiftKey, Kn(a, e)) {
            q || (a.scroller.draggable = !1, setTimeout(function() {
              return a.scroller.draggable = !0;
            }, 100));
            return;
          }
          if (!hl(n, e)) {
            var o = Er(n, e), s = Vt(e), y = o ? Jp(o, s) : "single";
            window.focus(), s == 1 && n.state.selectingText && n.state.selectingText(e), !(o && qp(n, s, o, y, e)) && (s == 1 ? o ? eh(n, o, y, e) : dt(e) == a.scroller && Te(e) : s == 2 ? (o && $o(n.doc, o), setTimeout(function() {
              return a.input.focus();
            }, 20)) : s == 3 && (D ? n.display.input.onContextMenu(e) : Ya(n)));
          }
        }
      }
      function qp(e, n, a, o, s) {
        var y = "Click";
        return o == "double" ? y = "Double" + y : o == "triple" && (y = "Triple" + y), y = (n == 1 ? "Left" : n == 2 ? "Middle" : "Right") + y, Wi(e, cc(y, s), s, function(N) {
          if (typeof N == "string" && (N = Ui[N]), !N)
            return !1;
          var B = !1;
          try {
            e.isReadOnly() && (e.state.suppressEdits = !0), B = N(e, a) != oe;
          } finally {
            e.state.suppressEdits = !1;
          }
          return B;
        });
      }
      function Zp(e, n, a) {
        var o = e.getOption("configureMouse"), s = o ? o(e, n, a) : {};
        if (s.unit == null) {
          var y = _ ? a.shiftKey && a.metaKey : a.altKey;
          s.unit = y ? "rectangle" : n == "single" ? "char" : n == "double" ? "word" : "line";
        }
        return (s.extend == null || e.doc.extend) && (s.extend = e.doc.extend || a.shiftKey), s.addNew == null && (s.addNew = g ? a.metaKey : a.ctrlKey), s.moveOnDrag == null && (s.moveOnDrag = !(g ? a.altKey : a.ctrlKey)), s;
      }
      function eh(e, n, a, o) {
        W ? setTimeout(Y(Au, e), 0) : e.curOp.focus = H();
        var s = Zp(e, a, o), y = e.doc.sel, N;
        e.options.dragDrop && Rn && !e.isReadOnly() && a == "single" && (N = y.contains(n)) > -1 && (de((N = y.ranges[N]).from(), n) < 0 || n.xRel > 0) && (de(N.to(), n) > 0 || n.xRel < 0) ? th(e, o, n, s) : nh(e, o, n, s);
      }
      function th(e, n, a, o) {
        var s = e.display, y = !1, N = Ot(e, function(j) {
          q && (s.scroller.draggable = !1), e.state.draggingText = !1, e.state.delayingBlurEvent && (e.hasFocus() ? e.state.delayingBlurEvent = !1 : Ya(e)), _e(s.wrapper.ownerDocument, "mouseup", N), _e(s.wrapper.ownerDocument, "mousemove", B), _e(s.scroller, "dragstart", P), _e(s.scroller, "drop", N), y || (Te(j), o.addNew || $o(e.doc, a, null, null, o.extend), q && !u || W && K == 9 ? setTimeout(function() {
            s.wrapper.ownerDocument.body.focus({ preventScroll: !0 }), s.input.focus();
          }, 20) : s.input.focus());
        }), B = function(j) {
          y = y || Math.abs(n.clientX - j.clientX) + Math.abs(n.clientY - j.clientY) >= 10;
        }, P = function() {
          return y = !0;
        };
        q && (s.scroller.draggable = !0), e.state.draggingText = N, N.copy = !o.moveOnDrag, fe(s.wrapper.ownerDocument, "mouseup", N), fe(s.wrapper.ownerDocument, "mousemove", B), fe(s.scroller, "dragstart", P), fe(s.scroller, "drop", N), e.state.delayingBlurEvent = !0, setTimeout(function() {
          return s.input.focus();
        }, 20), s.scroller.dragDrop && s.scroller.dragDrop();
      }
      function Ac(e, n, a) {
        if (a == "char")
          return new tt(n, n);
        if (a == "word")
          return e.findWordAt(n);
        if (a == "line")
          return new tt(ie(n.line, 0), Pe(e.doc, ie(n.line + 1, 0)));
        var o = a(e, n);
        return new tt(o.from, o.to);
      }
      function nh(e, n, a, o) {
        W && Ya(e);
        var s = e.display, y = e.doc;
        Te(n);
        var N, B, P = y.sel, j = P.ranges;
        if (o.addNew && !o.extend ? (B = y.sel.contains(a), B > -1 ? N = j[B] : N = new tt(a, a)) : (N = y.sel.primary(), B = y.sel.primIndex), o.unit == "rectangle")
          o.addNew || (N = new tt(a, a)), a = Er(e, n, !0, !0), B = -1;
        else {
          var Z = Ac(e, a, o.unit);
          o.extend ? N = ll(N, Z.anchor, Z.head, o.extend) : N = Z;
        }
        o.addNew ? B == -1 ? (B = j.length, Ut(
          y,
          kn(e, j.concat([N]), B),
          { scroll: !1, origin: "*mouse" }
        )) : j.length > 1 && j[B].empty() && o.unit == "char" && !o.extend ? (Ut(
          y,
          kn(e, j.slice(0, B).concat(j.slice(B + 1)), 0),
          { scroll: !1, origin: "*mouse" }
        ), P = y.sel) : sl(y, B, N, se) : (B = 0, Ut(y, new gn([N], 0), se), P = y.sel);
        var te = a;
        function ue(we) {
          if (de(te, we) != 0)
            if (te = we, o.unit == "rectangle") {
              for (var Ee = [], Le = e.options.tabSize, Re = G(De(y, a.line).text, a.ch, Le), We = G(De(y, we.line).text, we.ch, Le), ut = Math.min(Re, We), It = Math.max(Re, We), vt = Math.min(a.line, we.line), fn = Math.min(e.lastLine(), Math.max(a.line, we.line)); vt <= fn; vt++) {
                var nn = De(y, vt).text, St = Ae(nn, ut, Le);
                ut == It ? Ee.push(new tt(ie(vt, St), ie(vt, St))) : nn.length > St && Ee.push(new tt(ie(vt, St), ie(vt, Ae(nn, It, Le))));
              }
              Ee.length || Ee.push(new tt(a, a)), Ut(
                y,
                kn(e, P.ranges.slice(0, B).concat(Ee), B),
                { origin: "*mouse", scroll: !1 }
              ), e.scrollIntoView(we);
            } else {
              var rn = N, Ht = Ac(e, we, o.unit), Tt = rn.anchor, Et;
              de(Ht.anchor, Tt) > 0 ? (Et = Ht.head, Tt = kt(rn.from(), Ht.anchor)) : (Et = Ht.anchor, Tt = et(rn.to(), Ht.head));
              var mt = P.ranges.slice(0);
              mt[B] = rh(e, new tt(Pe(y, Tt), Et)), Ut(y, kn(e, mt, B), se);
            }
        }
        var le = s.wrapper.getBoundingClientRect(), pe = 0;
        function ge(we) {
          var Ee = ++pe, Le = Er(e, we, !0, o.unit == "rectangle");
          if (Le)
            if (de(Le, te) != 0) {
              e.curOp.focus = H(), ue(Le);
              var Re = Lo(s, y);
              (Le.line >= Re.to || Le.line < Re.from) && setTimeout(Ot(e, function() {
                pe == Ee && ge(we);
              }), 150);
            } else {
              var We = we.clientY < le.top ? -20 : we.clientY > le.bottom ? 20 : 0;
              We && setTimeout(Ot(e, function() {
                pe == Ee && (s.scroller.scrollTop += We, ge(we));
              }), 50);
            }
        }
        function me(we) {
          e.state.selectingText = !1, pe = 1 / 0, we && (Te(we), s.input.focus()), _e(s.wrapper.ownerDocument, "mousemove", xe), _e(s.wrapper.ownerDocument, "mouseup", Se), y.history.lastSelOrigin = null;
        }
        var xe = Ot(e, function(we) {
          we.buttons === 0 || !Vt(we) ? me(we) : ge(we);
        }), Se = Ot(e, me);
        e.state.selectingText = Se, fe(s.wrapper.ownerDocument, "mousemove", xe), fe(s.wrapper.ownerDocument, "mouseup", Se);
      }
      function rh(e, n) {
        var a = n.anchor, o = n.head, s = De(e.doc, a.line);
        if (de(a, o) == 0 && a.sticky == o.sticky)
          return n;
        var y = ct(s);
        if (!y)
          return n;
        var N = $t(y, a.ch, a.sticky), B = y[N];
        if (B.from != a.ch && B.to != a.ch)
          return n;
        var P = N + (B.from == a.ch == (B.level != 1) ? 0 : 1);
        if (P == 0 || P == y.length)
          return n;
        var j;
        if (o.line != a.line)
          j = (o.line - a.line) * (e.doc.direction == "ltr" ? 1 : -1) > 0;
        else {
          var Z = $t(y, o.ch, o.sticky), te = Z - N || (o.ch - a.ch) * (B.level == 1 ? -1 : 1);
          Z == P - 1 || Z == P ? j = te < 0 : j = te > 0;
        }
        var ue = y[P + (j ? -1 : 0)], le = j == (ue.level == 1), pe = le ? ue.from : ue.to, ge = le ? "after" : "before";
        return a.ch == pe && a.sticky == ge ? n : new tt(new ie(a.line, pe, ge), o);
      }
      function xc(e, n, a, o) {
        var s, y;
        if (n.touches)
          s = n.touches[0].clientX, y = n.touches[0].clientY;
        else
          try {
            s = n.clientX, y = n.clientY;
          } catch (ue) {
            return !1;
          }
        if (s >= Math.floor(e.display.gutters.getBoundingClientRect().right))
          return !1;
        o && Te(n);
        var N = e.display, B = N.lineDiv.getBoundingClientRect();
        if (y > B.bottom || !nt(e, a))
          return ze(n);
        y -= B.top - N.viewOffset;
        for (var P = 0; P < e.display.gutterSpecs.length; ++P) {
          var j = N.gutters.childNodes[P];
          if (j && j.getBoundingClientRect().right >= s) {
            var Z = Fn(e.doc, y), te = e.display.gutterSpecs[P];
            return Oe(e, a, e, Z, te.className, n), ze(n);
          }
        }
      }
      function hl(e, n) {
        return xc(e, n, "gutterClick", !0);
      }
      function wc(e, n) {
        Kn(e.display, n) || ih(e, n) || $e(e, n, "contextmenu") || D || e.display.input.onContextMenu(n);
      }
      function ih(e, n) {
        return nt(e, "gutterContextMenu") ? xc(e, n, "gutterContextMenu", !1) : !1;
      }
      function _c(e) {
        e.display.wrapper.className = e.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") + e.options.theme.replace(/(^|\s)\s*/g, " cm-s-"), Ei(e);
      }
      var ai = { toString: function() {
        return "CodeMirror.Init";
      } }, Cc = {}, Yo = {};
      function oh(e) {
        var n = e.optionHandlers;
        function a(o, s, y, N) {
          e.defaults[o] = s, y && (n[o] = N ? function(B, P, j) {
            j != ai && y(B, P, j);
          } : y);
        }
        e.defineOption = a, e.Init = ai, a("value", "", function(o, s) {
          return o.setValue(s);
        }, !0), a("mode", null, function(o, s) {
          o.doc.modeOption = s, il(o);
        }, !0), a("indentUnit", 2, il, !0), a("indentWithTabs", !1), a("smartIndent", !0), a("tabSize", 4, function(o) {
          Ii(o), Ei(o), en(o);
        }, !0), a("lineSeparator", null, function(o, s) {
          if (o.doc.lineSep = s, !!s) {
            var y = [], N = o.doc.first;
            o.doc.iter(function(P) {
              for (var j = 0; ; ) {
                var Z = P.text.indexOf(s, j);
                if (Z == -1)
                  break;
                j = Z + s.length, y.push(ie(N, Z));
              }
              N++;
            });
            for (var B = y.length - 1; B >= 0; B--)
              ni(o.doc, s, y[B], ie(y[B].line, y[B].ch + s.length));
          }
        }), a("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\ufeff\ufff9-\ufffc]/g, function(o, s, y) {
          o.state.specialChars = new RegExp(s.source + (s.test("	") ? "" : "|	"), "g"), y != ai && o.refresh();
        }), a("specialCharPlaceholder", Id, function(o) {
          return o.refresh();
        }, !0), a("electricChars", !0), a("inputStyle", x ? "contenteditable" : "textarea", function() {
          throw new Error("inputStyle can not (yet) be changed in a running editor");
        }, !0), a("spellcheck", !1, function(o, s) {
          return o.getInputField().spellcheck = s;
        }, !0), a("autocorrect", !1, function(o, s) {
          return o.getInputField().autocorrect = s;
        }, !0), a("autocapitalize", !1, function(o, s) {
          return o.getInputField().autocapitalize = s;
        }, !0), a("rtlMoveVisually", !A), a("wholeLineUpdateBefore", !0), a("theme", "default", function(o) {
          _c(o), Ri(o);
        }, !0), a("keyMap", "default", function(o, s, y) {
          var N = Vo(s), B = y != ai && Vo(y);
          B && B.detach && B.detach(o, N), N.attach && N.attach(o, B || null);
        }), a("extraKeys", null), a("configureMouse", null), a("lineWrapping", !1, lh, !0), a("gutters", [], function(o, s) {
          o.display.gutterSpecs = nl(s, o.options.lineNumbers), Ri(o);
        }, !0), a("fixedGutter", !0, function(o, s) {
          o.display.gutters.style.left = s ? Qa(o.display) + "px" : "0", o.refresh();
        }, !0), a("coverGutterNextToScrollbar", !1, function(o) {
          return qr(o);
        }, !0), a("scrollbarStyle", "native", function(o) {
          Eu(o), qr(o), o.display.scrollbars.setScrollTop(o.doc.scrollTop), o.display.scrollbars.setScrollLeft(o.doc.scrollLeft);
        }, !0), a("lineNumbers", !1, function(o, s) {
          o.display.gutterSpecs = nl(o.options.gutters, s), Ri(o);
        }, !0), a("firstLineNumber", 1, Ri, !0), a("lineNumberFormatter", function(o) {
          return o;
        }, Ri, !0), a("showCursorWhenSelecting", !1, ki, !0), a("resetSelectionOnContextMenu", !0), a("lineWiseCopyCut", !0), a("pasteLinesPerSelection", !0), a("selectionsMayTouch", !1), a("readOnly", !1, function(o, s) {
          s == "nocursor" && (Xr(o), o.display.input.blur()), o.display.input.readOnlyChanged(s);
        }), a("screenReaderLabel", null, function(o, s) {
          s = s === "" ? null : s, o.display.input.screenReaderLabelChanged(s);
        }), a("disableInput", !1, function(o, s) {
          s || o.display.input.reset();
        }, !0), a("dragDrop", !0, ah), a("allowDropFileTypes", null), a("cursorBlinkRate", 530), a("cursorScrollMargin", 0), a("cursorHeight", 1, ki, !0), a("singleCursorHeightPerLine", !0, ki, !0), a("workTime", 100), a("workDelay", 100), a("flattenSpans", !0, Ii, !0), a("addModeClass", !1, Ii, !0), a("pollInterval", 100), a("undoDepth", 200, function(o, s) {
          return o.doc.history.undoDepth = s;
        }), a("historyEventDelay", 1250), a("viewportMargin", 10, function(o) {
          return o.refresh();
        }, !0), a("maxHighlightLength", 1e4, Ii, !0), a("moveInputWithCursor", !0, function(o, s) {
          s || o.display.input.resetPosition();
        }), a("tabindex", null, function(o, s) {
          return o.display.input.getField().tabIndex = s || "";
        }), a("autofocus", null), a("direction", "ltr", function(o, s) {
          return o.doc.setDirection(s);
        }, !0), a("phrases", null);
      }
      function ah(e, n, a) {
        var o = a && a != ai;
        if (!n != !o) {
          var s = e.display.dragFunctions, y = n ? fe : _e;
          y(e.display.scroller, "dragstart", s.start), y(e.display.scroller, "dragenter", s.enter), y(e.display.scroller, "dragover", s.over), y(e.display.scroller, "dragleave", s.leave), y(e.display.scroller, "drop", s.drop);
        }
      }
      function lh(e) {
        e.options.lineWrapping ? ($(e.display.wrapper, "CodeMirror-wrap"), e.display.sizer.style.minWidth = "", e.display.sizerWidth = null) : (L(e.display.wrapper, "CodeMirror-wrap"), Ia(e)), Va(e), en(e), Ei(e), setTimeout(function() {
          return qr(e);
        }, 100);
      }
      function ht(e, n) {
        var a = this;
        if (!(this instanceof ht))
          return new ht(e, n);
        this.options = n = n ? X(n) : {}, X(Cc, n, !1);
        var o = n.value;
        typeof o == "string" ? o = new tn(o, n.mode, null, n.lineSeparator, n.direction) : n.mode && (o.modeOption = n.mode), this.doc = o;
        var s = new ht.inputStyles[n.inputStyle](this), y = this.display = new Ap(e, o, s, n);
        y.wrapper.CodeMirror = this, _c(this), n.lineWrapping && (this.display.wrapper.className += " CodeMirror-wrap"), Eu(this), this.state = {
          keyMaps: [],
          // stores maps added by addKeyMap
          overlays: [],
          // highlighting overlays, as added by addOverlay
          modeGen: 0,
          // bumped when mode/overlay changes, used to invalidate highlighting info
          overwrite: !1,
          delayingBlurEvent: !1,
          focused: !1,
          suppressEdits: !1,
          // used to disable editing during key handlers when in readOnly mode
          pasteIncoming: -1,
          cutIncoming: -1,
          // help recognize paste/cut edits in input.poll
          selectingText: !1,
          draggingText: !1,
          highlight: new J(),
          // stores highlight worker timeout
          keySeq: null,
          // Unfinished key sequence
          specialChars: null
        }, n.autofocus && !x && y.input.focus(), W && K < 11 && setTimeout(function() {
          return a.display.input.reset(!0);
        }, 20), sh(this), Hp(), Mr(this), this.curOp.forceUpdate = !0, Fu(this, o), n.autofocus && !x || this.hasFocus() ? setTimeout(function() {
          a.hasFocus() && !a.state.focused && Ka(a);
        }, 20) : Xr(this);
        for (var N in Yo)
          Yo.hasOwnProperty(N) && Yo[N](this, n[N], ai);
        Du(this), n.finishInit && n.finishInit(this);
        for (var B = 0; B < vl.length; ++B)
          vl[B](this);
        Nr(this), q && n.lineWrapping && getComputedStyle(y.lineDiv).textRendering == "optimizelegibility" && (y.lineDiv.style.textRendering = "auto");
      }
      ht.defaults = Cc, ht.optionHandlers = Yo;
      function sh(e) {
        var n = e.display;
        fe(n.scroller, "mousedown", Ot(e, bc)), W && K < 11 ? fe(n.scroller, "dblclick", Ot(e, function(P) {
          if (!$e(e, P)) {
            var j = Er(e, P);
            if (!(!j || hl(e, P) || Kn(e.display, P))) {
              Te(P);
              var Z = e.findWordAt(j);
              $o(e.doc, Z.anchor, Z.head);
            }
          }
        })) : fe(n.scroller, "dblclick", function(P) {
          return $e(e, P) || Te(P);
        }), fe(n.scroller, "contextmenu", function(P) {
          return wc(e, P);
        }), fe(n.input.getField(), "contextmenu", function(P) {
          n.scroller.contains(P.target) || wc(e, P);
        });
        var a, o = { end: 0 };
        function s() {
          n.activeTouch && (a = setTimeout(function() {
            return n.activeTouch = null;
          }, 1e3), o = n.activeTouch, o.end = +/* @__PURE__ */ new Date());
        }
        function y(P) {
          if (P.touches.length != 1)
            return !1;
          var j = P.touches[0];
          return j.radiusX <= 1 && j.radiusY <= 1;
        }
        function N(P, j) {
          if (j.left == null)
            return !0;
          var Z = j.left - P.left, te = j.top - P.top;
          return Z * Z + te * te > 20 * 20;
        }
        fe(n.scroller, "touchstart", function(P) {
          if (!$e(e, P) && !y(P) && !hl(e, P)) {
            n.input.ensurePolled(), clearTimeout(a);
            var j = +/* @__PURE__ */ new Date();
            n.activeTouch = {
              start: j,
              moved: !1,
              prev: j - o.end <= 300 ? o : null
            }, P.touches.length == 1 && (n.activeTouch.left = P.touches[0].pageX, n.activeTouch.top = P.touches[0].pageY);
          }
        }), fe(n.scroller, "touchmove", function() {
          n.activeTouch && (n.activeTouch.moved = !0);
        }), fe(n.scroller, "touchend", function(P) {
          var j = n.activeTouch;
          if (j && !Kn(n, P) && j.left != null && !j.moved && /* @__PURE__ */ new Date() - j.start < 300) {
            var Z = e.coordsChar(n.activeTouch, "page"), te;
            !j.prev || N(j, j.prev) ? te = new tt(Z, Z) : !j.prev.prev || N(j, j.prev.prev) ? te = e.findWordAt(Z) : te = new tt(ie(Z.line, 0), Pe(e.doc, ie(Z.line + 1, 0))), e.setSelection(te.anchor, te.head), e.focus(), Te(P);
          }
          s();
        }), fe(n.scroller, "touchcancel", s), fe(n.scroller, "scroll", function() {
          n.scroller.clientHeight && (Di(e, n.scroller.scrollTop), Tr(e, n.scroller.scrollLeft, !0), Oe(e, "scroll", e));
        }), fe(n.scroller, "mousewheel", function(P) {
          return Ou(e, P);
        }), fe(n.scroller, "DOMMouseScroll", function(P) {
          return Ou(e, P);
        }), fe(n.wrapper, "scroll", function() {
          return n.wrapper.scrollTop = n.wrapper.scrollLeft = 0;
        }), n.dragFunctions = {
          enter: function(P) {
            $e(e, P) || it(P);
          },
          over: function(P) {
            $e(e, P) || (Pp(e, P), it(P));
          },
          start: function(P) {
            return Bp(e, P);
          },
          drop: Ot(e, Fp),
          leave: function(P) {
            $e(e, P) || ac(e);
          }
        };
        var B = n.input.getField();
        fe(B, "keyup", function(P) {
          return mc.call(e, P);
        }), fe(B, "keydown", Ot(e, gc)), fe(B, "keypress", Ot(e, yc)), fe(B, "focus", function(P) {
          return Ka(e, P);
        }), fe(B, "blur", function(P) {
          return Xr(e, P);
        });
      }
      var vl = [];
      ht.defineInitHook = function(e) {
        return vl.push(e);
      };
      function Gi(e, n, a, o) {
        var s = e.doc, y;
        a == null && (a = "add"), a == "smart" && (s.mode.indent ? y = xi(e, n).state : a = "prev");
        var N = e.options.tabSize, B = De(s, n), P = G(B.text, null, N);
        B.stateAfter && (B.stateAfter = null);
        var j = B.text.match(/^\s*/)[0], Z;
        if (!o && !/\S/.test(B.text))
          Z = 0, a = "not";
        else if (a == "smart" && (Z = s.mode.indent(y, B.text.slice(j.length), B.text), Z == oe || Z > 150)) {
          if (!o)
            return;
          a = "prev";
        }
        a == "prev" ? n > s.first ? Z = G(De(s, n - 1).text, null, N) : Z = 0 : a == "add" ? Z = P + e.options.indentUnit : a == "subtract" ? Z = P - e.options.indentUnit : typeof a == "number" && (Z = P + a), Z = Math.max(0, Z);
        var te = "", ue = 0;
        if (e.options.indentWithTabs)
          for (var le = Math.floor(Z / N); le; --le)
            ue += N, te += "	";
        if (ue < Z && (te += ce(Z - ue)), te != j)
          return ni(s, te, ie(n, 0), ie(n, j.length), "+input"), B.stateAfter = null, !0;
        for (var pe = 0; pe < s.sel.ranges.length; pe++) {
          var ge = s.sel.ranges[pe];
          if (ge.head.line == n && ge.head.ch < j.length) {
            var me = ie(n, j.length);
            sl(s, pe, new tt(me, me));
            break;
          }
        }
      }
      var Tn = null;
      function Ko(e) {
        Tn = e;
      }
      function gl(e, n, a, o, s) {
        var y = e.doc;
        e.display.shift = !1, o || (o = y.sel);
        var N = +/* @__PURE__ */ new Date() - 200, B = s == "paste" || e.state.pasteIncoming > N, P = bi(n), j = null;
        if (B && o.ranges.length > 1)
          if (Tn && Tn.text.join(`
`) == n) {
            if (o.ranges.length % Tn.text.length == 0) {
              j = [];
              for (var Z = 0; Z < Tn.text.length; Z++)
                j.push(y.splitLines(Tn.text[Z]));
            }
          } else P.length == o.ranges.length && e.options.pasteLinesPerSelection && (j = ke(P, function(xe) {
            return [xe];
          }));
        for (var te = e.curOp.updateInput, ue = o.ranges.length - 1; ue >= 0; ue--) {
          var le = o.ranges[ue], pe = le.from(), ge = le.to();
          le.empty() && (a && a > 0 ? pe = ie(pe.line, pe.ch - a) : e.state.overwrite && !B ? ge = ie(ge.line, Math.min(De(y, ge.line).text.length, ge.ch + he(P).length)) : B && Tn && Tn.lineWise && Tn.text.join(`
`) == P.join(`
`) && (pe = ge = ie(pe.line, 0)));
          var me = {
            from: pe,
            to: ge,
            text: j ? j[ue % j.length] : P,
            origin: s || (B ? "paste" : e.state.cutIncoming > N ? "cut" : "+input")
          };
          ti(e.doc, me), Pt(e, "inputRead", e, me);
        }
        n && !B && Ec(e, n), Jr(e), e.curOp.updateInput < 2 && (e.curOp.updateInput = te), e.curOp.typing = !0, e.state.pasteIncoming = e.state.cutIncoming = -1;
      }
      function Sc(e, n) {
        var a = e.clipboardData && e.clipboardData.getData("Text");
        if (a)
          return e.preventDefault(), !n.isReadOnly() && !n.options.disableInput && cn(n, function() {
            return gl(n, a, 0, null, "paste");
          }), !0;
      }
      function Ec(e, n) {
        if (!(!e.options.electricChars || !e.options.smartIndent))
          for (var a = e.doc.sel, o = a.ranges.length - 1; o >= 0; o--) {
            var s = a.ranges[o];
            if (!(s.head.ch > 100 || o && a.ranges[o - 1].head.line == s.head.line)) {
              var y = e.getModeAt(s.head), N = !1;
              if (y.electricChars) {
                for (var B = 0; B < y.electricChars.length; B++)
                  if (n.indexOf(y.electricChars.charAt(B)) > -1) {
                    N = Gi(e, s.head.line, "smart");
                    break;
                  }
              } else y.electricInput && y.electricInput.test(De(e.doc, s.head.line).text.slice(0, s.head.ch)) && (N = Gi(e, s.head.line, "smart"));
              N && Pt(e, "electricInput", e, s.head.line);
            }
          }
      }
      function kc(e) {
        for (var n = [], a = [], o = 0; o < e.doc.sel.ranges.length; o++) {
          var s = e.doc.sel.ranges[o].head.line, y = { anchor: ie(s, 0), head: ie(s + 1, 0) };
          a.push(y), n.push(e.getRange(y.anchor, y.head));
        }
        return { text: n, ranges: a };
      }
      function Tc(e, n, a, o) {
        e.setAttribute("autocorrect", a ? "" : "off"), e.setAttribute("autocapitalize", o ? "" : "off"), e.setAttribute("spellcheck", !!n);
      }
      function Dc() {
        var e = w("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; outline: none"), n = w("div", [e], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
        return q ? e.style.width = "1000px" : e.setAttribute("wrap", "off"), p && (e.style.border = "1px solid black"), Tc(e), n;
      }
      function uh(e) {
        var n = e.optionHandlers, a = e.helpers = {};
        e.prototype = {
          constructor: e,
          focus: function() {
            window.focus(), this.display.input.focus();
          },
          setOption: function(o, s) {
            var y = this.options, N = y[o];
            y[o] == s && o != "mode" || (y[o] = s, n.hasOwnProperty(o) && Ot(this, n[o])(this, s, N), Oe(this, "optionChange", this, o));
          },
          getOption: function(o) {
            return this.options[o];
          },
          getDoc: function() {
            return this.doc;
          },
          addKeyMap: function(o, s) {
            this.state.keyMaps[s ? "push" : "unshift"](Vo(o));
          },
          removeKeyMap: function(o) {
            for (var s = this.state.keyMaps, y = 0; y < s.length; ++y)
              if (s[y] == o || s[y].name == o)
                return s.splice(y, 1), !0;
          },
          addOverlay: Gt(function(o, s) {
            var y = o.token ? o : e.getMode(this.options, o);
            if (y.startState)
              throw new Error("Overlays may not be stateful.");
            je(
              this.state.overlays,
              {
                mode: y,
                modeSpec: o,
                opaque: s && s.opaque,
                priority: s && s.priority || 0
              },
              function(N) {
                return N.priority;
              }
            ), this.state.modeGen++, en(this);
          }),
          removeOverlay: Gt(function(o) {
            for (var s = this.state.overlays, y = 0; y < s.length; ++y) {
              var N = s[y].modeSpec;
              if (N == o || typeof o == "string" && N.name == o) {
                s.splice(y, 1), this.state.modeGen++, en(this);
                return;
              }
            }
          }),
          indentLine: Gt(function(o, s, y) {
            typeof s != "string" && typeof s != "number" && (s == null ? s = this.options.smartIndent ? "smart" : "prev" : s = s ? "add" : "subtract"), V(this.doc, o) && Gi(this, o, s, y);
          }),
          indentSelection: Gt(function(o) {
            for (var s = this.doc.sel.ranges, y = -1, N = 0; N < s.length; N++) {
              var B = s[N];
              if (B.empty())
                B.head.line > y && (Gi(this, B.head.line, o, !0), y = B.head.line, N == this.doc.sel.primIndex && Jr(this));
              else {
                var P = B.from(), j = B.to(), Z = Math.max(y, P.line);
                y = Math.min(this.lastLine(), j.line - (j.ch ? 0 : 1)) + 1;
                for (var te = Z; te < y; ++te)
                  Gi(this, te, o);
                var ue = this.doc.sel.ranges;
                P.ch == 0 && s.length == ue.length && ue[N].from().ch > 0 && sl(this.doc, N, new tt(P, ue[N].to()), ae);
              }
            }
          }),
          // Fetch the parser token for a given character. Useful for hacks
          // that want to inspect the mode state (say, for completion).
          getTokenAt: function(o, s) {
            return Bs(this, o, s);
          },
          getLineTokens: function(o, s) {
            return Bs(this, ie(o), s, !0);
          },
          getTokenTypeAt: function(o) {
            o = Pe(this.doc, o);
            var s = Is(this, De(this.doc, o.line)), y = 0, N = (s.length - 1) / 2, B = o.ch, P;
            if (B == 0)
              P = s[2];
            else
              for (; ; ) {
                var j = y + N >> 1;
                if ((j ? s[j * 2 - 1] : 0) >= B)
                  N = j;
                else if (s[j * 2 + 1] < B)
                  y = j + 1;
                else {
                  P = s[j * 2 + 2];
                  break;
                }
              }
            var Z = P ? P.indexOf("overlay ") : -1;
            return Z < 0 ? P : Z == 0 ? null : P.slice(0, Z - 1);
          },
          getModeAt: function(o) {
            var s = this.doc.mode;
            return s.innerMode ? e.innerMode(s, this.getTokenAt(o).state).mode : s;
          },
          getHelper: function(o, s) {
            return this.getHelpers(o, s)[0];
          },
          getHelpers: function(o, s) {
            var y = [];
            if (!a.hasOwnProperty(s))
              return y;
            var N = a[s], B = this.getModeAt(o);
            if (typeof B[s] == "string")
              N[B[s]] && y.push(N[B[s]]);
            else if (B[s])
              for (var P = 0; P < B[s].length; P++) {
                var j = N[B[s][P]];
                j && y.push(j);
              }
            else B.helperType && N[B.helperType] ? y.push(N[B.helperType]) : N[B.name] && y.push(N[B.name]);
            for (var Z = 0; Z < N._global.length; Z++) {
              var te = N._global[Z];
              te.pred(B, this) && ee(y, te.val) == -1 && y.push(te.val);
            }
            return y;
          },
          getStateAfter: function(o, s) {
            var y = this.doc;
            return o = hn(y, o == null ? y.first + y.size - 1 : o), xi(this, o + 1, s).state;
          },
          cursorCoords: function(o, s) {
            var y, N = this.doc.sel.primary();
            return o == null ? y = N.head : typeof o == "object" ? y = Pe(this.doc, o) : y = o ? N.from() : N.to(), En(this, y, s || "page");
          },
          charCoords: function(o, s) {
            return ja(this, Pe(this.doc, o), s || "page");
          },
          coordsChar: function(o, s) {
            return o = du(this, o, s || "page"), za(this, o.left, o.top);
          },
          lineAtHeight: function(o, s) {
            return o = du(this, { top: o, left: 0 }, s || "page").top, Fn(this.doc, o + this.display.viewOffset);
          },
          heightAtLine: function(o, s, y) {
            var N = !1, B;
            if (typeof o == "number") {
              var P = this.doc.first + this.doc.size - 1;
              o < this.doc.first ? o = this.doc.first : o > P && (o = P, N = !0), B = De(this.doc, o);
            } else
              B = o;
            return No(this, B, { top: 0, left: 0 }, s || "page", y || N).top + (N ? this.doc.height - Yn(B) : 0);
          },
          defaultTextHeight: function() {
            return Yr(this.display);
          },
          defaultCharWidth: function() {
            return Kr(this.display);
          },
          getViewport: function() {
            return { from: this.display.viewFrom, to: this.display.viewTo };
          },
          addWidget: function(o, s, y, N, B) {
            var P = this.display;
            o = En(this, Pe(this.doc, o));
            var j = o.bottom, Z = o.left;
            if (s.style.position = "absolute", s.setAttribute("cm-ignore-events", "true"), this.display.input.setUneditable(s), P.sizer.appendChild(s), N == "over")
              j = o.top;
            else if (N == "above" || N == "near") {
              var te = Math.max(P.wrapper.clientHeight, this.doc.height), ue = Math.max(P.sizer.clientWidth, P.lineSpace.clientWidth);
              (N == "above" || o.bottom + s.offsetHeight > te) && o.top > s.offsetHeight ? j = o.top - s.offsetHeight : o.bottom + s.offsetHeight <= te && (j = o.bottom), Z + s.offsetWidth > ue && (Z = ue - s.offsetWidth);
            }
            s.style.top = j + "px", s.style.left = s.style.right = "", B == "right" ? (Z = P.sizer.clientWidth - s.offsetWidth, s.style.right = "0px") : (B == "left" ? Z = 0 : B == "middle" && (Z = (P.sizer.clientWidth - s.offsetWidth) / 2), s.style.left = Z + "px"), y && ap(this, { left: Z, top: j, right: Z + s.offsetWidth, bottom: j + s.offsetHeight });
          },
          triggerOnKeyDown: Gt(gc),
          triggerOnKeyPress: Gt(yc),
          triggerOnKeyUp: mc,
          triggerOnMouseDown: Gt(bc),
          execCommand: function(o) {
            if (Ui.hasOwnProperty(o))
              return Ui[o].call(null, this);
          },
          triggerElectric: Gt(function(o) {
            Ec(this, o);
          }),
          findPosH: function(o, s, y, N) {
            var B = 1;
            s < 0 && (B = -1, s = -s);
            for (var P = Pe(this.doc, o), j = 0; j < s && (P = ml(this.doc, P, B, y, N), !P.hitSide); ++j)
              ;
            return P;
          },
          moveH: Gt(function(o, s) {
            var y = this;
            this.extendSelectionsBy(function(N) {
              return y.display.shift || y.doc.extend || N.empty() ? ml(y.doc, N.head, o, s, y.options.rtlMoveVisually) : o < 0 ? N.from() : N.to();
            }, ve);
          }),
          deleteH: Gt(function(o, s) {
            var y = this.doc.sel, N = this.doc;
            y.somethingSelected() ? N.replaceSelection("", null, "+delete") : oi(this, function(B) {
              var P = ml(N, B.head, o, s, !1);
              return o < 0 ? { from: P, to: B.head } : { from: B.head, to: P };
            });
          }),
          findPosV: function(o, s, y, N) {
            var B = 1, P = N;
            s < 0 && (B = -1, s = -s);
            for (var j = Pe(this.doc, o), Z = 0; Z < s; ++Z) {
              var te = En(this, j, "div");
              if (P == null ? P = te.left : te.left = P, j = Mc(this, te, B, y), j.hitSide)
                break;
            }
            return j;
          },
          moveV: Gt(function(o, s) {
            var y = this, N = this.doc, B = [], P = !this.display.shift && !N.extend && N.sel.somethingSelected();
            if (N.extendSelectionsBy(function(Z) {
              if (P)
                return o < 0 ? Z.from() : Z.to();
              var te = En(y, Z.head, "div");
              Z.goalColumn != null && (te.left = Z.goalColumn), B.push(te.left);
              var ue = Mc(y, te, o, s);
              return s == "page" && Z == N.sel.primary() && Ja(y, ja(y, ue, "div").top - te.top), ue;
            }, ve), B.length)
              for (var j = 0; j < N.sel.ranges.length; j++)
                N.sel.ranges[j].goalColumn = B[j];
          }),
          // Find the word at the given position (as returned by coordsChar).
          findWordAt: function(o) {
            var s = this.doc, y = De(s, o.line).text, N = o.ch, B = o.ch;
            if (y) {
              var P = this.getHelper(o, "wordChars");
              (o.sticky == "before" || B == y.length) && N ? --N : ++B;
              for (var j = y.charAt(N), Z = Ft(j, P) ? function(te) {
                return Ft(te, P);
              } : /\s/.test(j) ? function(te) {
                return /\s/.test(te);
              } : function(te) {
                return !/\s/.test(te) && !Ft(te);
              }; N > 0 && Z(y.charAt(N - 1)); )
                --N;
              for (; B < y.length && Z(y.charAt(B)); )
                ++B;
            }
            return new tt(ie(o.line, N), ie(o.line, B));
          },
          toggleOverwrite: function(o) {
            o != null && o == this.state.overwrite || ((this.state.overwrite = !this.state.overwrite) ? $(this.display.cursorDiv, "CodeMirror-overwrite") : L(this.display.cursorDiv, "CodeMirror-overwrite"), Oe(this, "overwriteToggle", this, this.state.overwrite));
          },
          hasFocus: function() {
            return this.display.input.getField() == H();
          },
          isReadOnly: function() {
            return !!(this.options.readOnly || this.doc.cantEdit);
          },
          scrollTo: Gt(function(o, s) {
            Ti(this, o, s);
          }),
          getScrollInfo: function() {
            var o = this.display.scroller;
            return {
              left: o.scrollLeft,
              top: o.scrollTop,
              height: o.scrollHeight - Hn(this) - this.display.barHeight,
              width: o.scrollWidth - Hn(this) - this.display.barWidth,
              clientHeight: Ba(this),
              clientWidth: Cr(this)
            };
          },
          scrollIntoView: Gt(function(o, s) {
            o == null ? (o = { from: this.doc.sel.primary().head, to: null }, s == null && (s = this.options.cursorScrollMargin)) : typeof o == "number" ? o = { from: ie(o, 0), to: null } : o.from == null && (o = { from: o, to: null }), o.to || (o.to = o.from), o.margin = s || 0, o.from.line != null ? lp(this, o) : wu(this, o.from, o.to, o.margin);
          }),
          setSize: Gt(function(o, s) {
            var y = this, N = function(P) {
              return typeof P == "number" || /^\d+$/.test(String(P)) ? P + "px" : P;
            };
            o != null && (this.display.wrapper.style.width = N(o)), s != null && (this.display.wrapper.style.height = N(s)), this.options.lineWrapping && uu(this);
            var B = this.display.viewFrom;
            this.doc.iter(B, this.display.viewTo, function(P) {
              if (P.widgets) {
                for (var j = 0; j < P.widgets.length; j++)
                  if (P.widgets[j].noHScroll) {
                    lr(y, B, "widget");
                    break;
                  }
              }
              ++B;
            }), this.curOp.forceUpdate = !0, Oe(this, "refresh", this);
          }),
          operation: function(o) {
            return cn(this, o);
          },
          startOperation: function() {
            return Mr(this);
          },
          endOperation: function() {
            return Nr(this);
          },
          refresh: Gt(function() {
            var o = this.display.cachedTextHeight;
            en(this), this.curOp.forceUpdate = !0, Ei(this), Ti(this, this.doc.scrollLeft, this.doc.scrollTop), el(this.display), (o == null || Math.abs(o - Yr(this.display)) > 0.5 || this.options.lineWrapping) && Va(this), Oe(this, "refresh", this);
          }),
          swapDoc: Gt(function(o) {
            var s = this.doc;
            return s.cm = null, this.state.selectingText && this.state.selectingText(), Fu(this, o), Ei(this), this.display.input.reset(), Ti(this, o.scrollLeft, o.scrollTop), this.curOp.forceScroll = !0, Pt(this, "swapDoc", this, s), s;
          }),
          phrase: function(o) {
            var s = this.options.phrases;
            return s && Object.prototype.hasOwnProperty.call(s, o) ? s[o] : o;
          },
          getInputField: function() {
            return this.display.input.getField();
          },
          getWrapperElement: function() {
            return this.display.wrapper;
          },
          getScrollerElement: function() {
            return this.display.scroller;
          },
          getGutterElement: function() {
            return this.display.gutters;
          }
        }, be(e), e.registerHelper = function(o, s, y) {
          a.hasOwnProperty(o) || (a[o] = e[o] = { _global: [] }), a[o][s] = y;
        }, e.registerGlobalHelper = function(o, s, y, N) {
          e.registerHelper(o, s, N), a[o]._global.push({ pred: y, val: N });
        };
      }
      function ml(e, n, a, o, s) {
        var y = n, N = a, B = De(e, n.line), P = s && e.direction == "rtl" ? -a : a;
        function j() {
          var Se = n.line + P;
          return Se < e.first || Se >= e.first + e.size ? !1 : (n = new ie(Se, n.ch, n.sticky), B = De(e, Se));
        }
        function Z(Se) {
          var we;
          if (o == "codepoint") {
            var Ee = B.text.charCodeAt(n.ch + (a > 0 ? 0 : -1));
            if (isNaN(Ee))
              we = null;
            else {
              var Le = a > 0 ? Ee >= 55296 && Ee < 56320 : Ee >= 56320 && Ee < 57343;
              we = new ie(n.line, Math.max(0, Math.min(B.text.length, n.ch + a * (Le ? 2 : 1))), -a);
            }
          } else s ? we = Wp(e.cm, B, n, a) : we = cl(B, n, a);
          if (we == null)
            if (!Se && j())
              n = fl(s, e.cm, B, n.line, P);
            else
              return !1;
          else
            n = we;
          return !0;
        }
        if (o == "char" || o == "codepoint")
          Z();
        else if (o == "column")
          Z(!0);
        else if (o == "word" || o == "group")
          for (var te = null, ue = o == "group", le = e.cm && e.cm.getHelper(n, "wordChars"), pe = !0; !(a < 0 && !Z(!pe)); pe = !1) {
            var ge = B.text.charAt(n.ch) || `
`, me = Ft(ge, le) ? "w" : ue && ge == `
` ? "n" : !ue || /\s/.test(ge) ? null : "p";
            if (ue && !pe && !me && (me = "s"), te && te != me) {
              a < 0 && (a = 1, Z(), n.sticky = "after");
              break;
            }
            if (me && (te = me), a > 0 && !Z(!pe))
              break;
          }
        var xe = Uo(e, n, y, N, !0);
        return Be(y, xe) && (xe.hitSide = !0), xe;
      }
      function Mc(e, n, a, o) {
        var s = e.doc, y = n.left, N;
        if (o == "page") {
          var B = Math.min(e.display.wrapper.clientHeight, window.innerHeight || document.documentElement.clientHeight), P = Math.max(B - 0.5 * Yr(e.display), 3);
          N = (a > 0 ? n.bottom : n.top) + a * P;
        } else o == "line" && (N = a > 0 ? n.bottom + 3 : n.top - 3);
        for (var j; j = za(e, y, N), !!j.outside; ) {
          if (a < 0 ? N <= 0 : N >= s.height) {
            j.hitSide = !0;
            break;
          }
          N += a * 5;
        }
        return j;
      }
      var ot = function(e) {
        this.cm = e, this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null, this.polling = new J(), this.composing = null, this.gracePeriod = !1, this.readDOMTimeout = null;
      };
      ot.prototype.init = function(e) {
        var n = this, a = this, o = a.cm, s = a.div = e.lineDiv;
        s.contentEditable = !0, Tc(s, o.options.spellcheck, o.options.autocorrect, o.options.autocapitalize);
        function y(B) {
          for (var P = B.target; P; P = P.parentNode) {
            if (P == s)
              return !0;
            if (/\bCodeMirror-(?:line)?widget\b/.test(P.className))
              break;
          }
          return !1;
        }
        fe(s, "paste", function(B) {
          !y(B) || $e(o, B) || Sc(B, o) || K <= 11 && setTimeout(Ot(o, function() {
            return n.updateFromDOM();
          }), 20);
        }), fe(s, "compositionstart", function(B) {
          n.composing = { data: B.data, done: !1 };
        }), fe(s, "compositionupdate", function(B) {
          n.composing || (n.composing = { data: B.data, done: !1 });
        }), fe(s, "compositionend", function(B) {
          n.composing && (B.data != n.composing.data && n.readFromDOMSoon(), n.composing.done = !0);
        }), fe(s, "touchstart", function() {
          return a.forceCompositionEnd();
        }), fe(s, "input", function() {
          n.composing || n.readFromDOMSoon();
        });
        function N(B) {
          if (!(!y(B) || $e(o, B))) {
            if (o.somethingSelected())
              Ko({ lineWise: !1, text: o.getSelections() }), B.type == "cut" && o.replaceSelection("", null, "cut");
            else if (o.options.lineWiseCopyCut) {
              var P = kc(o);
              Ko({ lineWise: !0, text: P.text }), B.type == "cut" && o.operation(function() {
                o.setSelections(P.ranges, 0, ae), o.replaceSelection("", null, "cut");
              });
            } else
              return;
            if (B.clipboardData) {
              B.clipboardData.clearData();
              var j = Tn.text.join(`
`);
              if (B.clipboardData.setData("Text", j), B.clipboardData.getData("Text") == j) {
                B.preventDefault();
                return;
              }
            }
            var Z = Dc(), te = Z.firstChild;
            o.display.lineSpace.insertBefore(Z, o.display.lineSpace.firstChild), te.value = Tn.text.join(`
`);
            var ue = document.activeElement;
            U(te), setTimeout(function() {
              o.display.lineSpace.removeChild(Z), ue.focus(), ue == s && a.showPrimarySelection();
            }, 50);
          }
        }
        fe(s, "copy", N), fe(s, "cut", N);
      }, ot.prototype.screenReaderLabelChanged = function(e) {
        e ? this.div.setAttribute("aria-label", e) : this.div.removeAttribute("aria-label");
      }, ot.prototype.prepareSelection = function() {
        var e = yu(this.cm, !1);
        return e.focus = document.activeElement == this.div, e;
      }, ot.prototype.showSelection = function(e, n) {
        !e || !this.cm.display.view.length || ((e.focus || n) && this.showPrimarySelection(), this.showMultipleSelections(e));
      }, ot.prototype.getSelection = function() {
        return this.cm.display.wrapper.ownerDocument.getSelection();
      }, ot.prototype.showPrimarySelection = function() {
        var e = this.getSelection(), n = this.cm, a = n.doc.sel.primary(), o = a.from(), s = a.to();
        if (n.display.viewTo == n.display.viewFrom || o.line >= n.display.viewTo || s.line < n.display.viewFrom) {
          e.removeAllRanges();
          return;
        }
        var y = Xo(n, e.anchorNode, e.anchorOffset), N = Xo(n, e.focusNode, e.focusOffset);
        if (!(y && !y.bad && N && !N.bad && de(kt(y, N), o) == 0 && de(et(y, N), s) == 0)) {
          var B = n.display.view, P = o.line >= n.display.viewFrom && Nc(n, o) || { node: B[0].measure.map[2], offset: 0 }, j = s.line < n.display.viewTo && Nc(n, s);
          if (!j) {
            var Z = B[B.length - 1].measure, te = Z.maps ? Z.maps[Z.maps.length - 1] : Z.map;
            j = { node: te[te.length - 1], offset: te[te.length - 2] - te[te.length - 3] };
          }
          if (!P || !j) {
            e.removeAllRanges();
            return;
          }
          var ue = e.rangeCount && e.getRangeAt(0), le;
          try {
            le = R(P.node, P.offset, j.offset, j.node);
          } catch (pe) {
          }
          le && (!M && n.state.focused ? (e.collapse(P.node, P.offset), le.collapsed || (e.removeAllRanges(), e.addRange(le))) : (e.removeAllRanges(), e.addRange(le)), ue && e.anchorNode == null ? e.addRange(ue) : M && this.startGracePeriod()), this.rememberSelection();
        }
      }, ot.prototype.startGracePeriod = function() {
        var e = this;
        clearTimeout(this.gracePeriod), this.gracePeriod = setTimeout(function() {
          e.gracePeriod = !1, e.selectionChanged() && e.cm.operation(function() {
            return e.cm.curOp.selectionChanged = !0;
          });
        }, 20);
      }, ot.prototype.showMultipleSelections = function(e) {
        E(this.cm.display.cursorDiv, e.cursors), E(this.cm.display.selectionDiv, e.selection);
      }, ot.prototype.rememberSelection = function() {
        var e = this.getSelection();
        this.lastAnchorNode = e.anchorNode, this.lastAnchorOffset = e.anchorOffset, this.lastFocusNode = e.focusNode, this.lastFocusOffset = e.focusOffset;
      }, ot.prototype.selectionInEditor = function() {
        var e = this.getSelection();
        if (!e.rangeCount)
          return !1;
        var n = e.getRangeAt(0).commonAncestorContainer;
        return I(this.div, n);
      }, ot.prototype.focus = function() {
        this.cm.options.readOnly != "nocursor" && ((!this.selectionInEditor() || document.activeElement != this.div) && this.showSelection(this.prepareSelection(), !0), this.div.focus());
      }, ot.prototype.blur = function() {
        this.div.blur();
      }, ot.prototype.getField = function() {
        return this.div;
      }, ot.prototype.supportsTouch = function() {
        return !0;
      }, ot.prototype.receivedFocus = function() {
        var e = this;
        this.selectionInEditor() ? this.pollSelection() : cn(this.cm, function() {
          return e.cm.curOp.selectionChanged = !0;
        });
        function n() {
          e.cm.state.focused && (e.pollSelection(), e.polling.set(e.cm.options.pollInterval, n));
        }
        this.polling.set(this.cm.options.pollInterval, n);
      }, ot.prototype.selectionChanged = function() {
        var e = this.getSelection();
        return e.anchorNode != this.lastAnchorNode || e.anchorOffset != this.lastAnchorOffset || e.focusNode != this.lastFocusNode || e.focusOffset != this.lastFocusOffset;
      }, ot.prototype.pollSelection = function() {
        if (!(this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged())) {
          var e = this.getSelection(), n = this.cm;
          if (b && d && this.cm.display.gutterSpecs.length && ch(e.anchorNode)) {
            this.cm.triggerOnKeyDown({ type: "keydown", keyCode: 8, preventDefault: Math.abs }), this.blur(), this.focus();
            return;
          }
          if (!this.composing) {
            this.rememberSelection();
            var a = Xo(n, e.anchorNode, e.anchorOffset), o = Xo(n, e.focusNode, e.focusOffset);
            a && o && cn(n, function() {
              Ut(n.doc, ur(a, o), ae), (a.bad || o.bad) && (n.curOp.selectionChanged = !0);
            });
          }
        }
      }, ot.prototype.pollContent = function() {
        this.readDOMTimeout != null && (clearTimeout(this.readDOMTimeout), this.readDOMTimeout = null);
        var e = this.cm, n = e.display, a = e.doc.sel.primary(), o = a.from(), s = a.to();
        if (o.ch == 0 && o.line > e.firstLine() && (o = ie(o.line - 1, De(e.doc, o.line - 1).length)), s.ch == De(e.doc, s.line).text.length && s.line < e.lastLine() && (s = ie(s.line + 1, 0)), o.line < n.viewFrom || s.line > n.viewTo - 1)
          return !1;
        var y, N, B;
        o.line == n.viewFrom || (y = kr(e, o.line)) == 0 ? (N = Ze(n.view[0].line), B = n.view[0].node) : (N = Ze(n.view[y].line), B = n.view[y - 1].node.nextSibling);
        var P = kr(e, s.line), j, Z;
        if (P == n.view.length - 1 ? (j = n.viewTo - 1, Z = n.lineDiv.lastChild) : (j = Ze(n.view[P + 1].line) - 1, Z = n.view[P + 1].node.previousSibling), !B)
          return !1;
        for (var te = e.doc.splitLines(fh(e, B, Z, N, j)), ue = Vn(e.doc, ie(N, 0), ie(j, De(e.doc, j).text.length)); te.length > 1 && ue.length > 1; )
          if (he(te) == he(ue))
            te.pop(), ue.pop(), j--;
          else if (te[0] == ue[0])
            te.shift(), ue.shift(), N++;
          else
            break;
        for (var le = 0, pe = 0, ge = te[0], me = ue[0], xe = Math.min(ge.length, me.length); le < xe && ge.charCodeAt(le) == me.charCodeAt(le); )
          ++le;
        for (var Se = he(te), we = he(ue), Ee = Math.min(
          Se.length - (te.length == 1 ? le : 0),
          we.length - (ue.length == 1 ? le : 0)
        ); pe < Ee && Se.charCodeAt(Se.length - pe - 1) == we.charCodeAt(we.length - pe - 1); )
          ++pe;
        if (te.length == 1 && ue.length == 1 && N == o.line)
          for (; le && le > o.ch && Se.charCodeAt(Se.length - pe - 1) == we.charCodeAt(we.length - pe - 1); )
            le--, pe++;
        te[te.length - 1] = Se.slice(0, Se.length - pe).replace(/^\u200b+/, ""), te[0] = te[0].slice(le).replace(/\u200b+$/, "");
        var Le = ie(N, le), Re = ie(j, ue.length ? he(ue).length - pe : 0);
        if (te.length > 1 || te[0] || de(Le, Re))
          return ni(e.doc, te, Le, Re, "+input"), !0;
      }, ot.prototype.ensurePolled = function() {
        this.forceCompositionEnd();
      }, ot.prototype.reset = function() {
        this.forceCompositionEnd();
      }, ot.prototype.forceCompositionEnd = function() {
        this.composing && (clearTimeout(this.readDOMTimeout), this.composing = null, this.updateFromDOM(), this.div.blur(), this.div.focus());
      }, ot.prototype.readFromDOMSoon = function() {
        var e = this;
        this.readDOMTimeout == null && (this.readDOMTimeout = setTimeout(function() {
          if (e.readDOMTimeout = null, e.composing)
            if (e.composing.done)
              e.composing = null;
            else
              return;
          e.updateFromDOM();
        }, 80));
      }, ot.prototype.updateFromDOM = function() {
        var e = this;
        (this.cm.isReadOnly() || !this.pollContent()) && cn(this.cm, function() {
          return en(e.cm);
        });
      }, ot.prototype.setUneditable = function(e) {
        e.contentEditable = "false";
      }, ot.prototype.onKeyPress = function(e) {
        e.charCode == 0 || this.composing || (e.preventDefault(), this.cm.isReadOnly() || Ot(this.cm, gl)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0));
      }, ot.prototype.readOnlyChanged = function(e) {
        this.div.contentEditable = String(e != "nocursor");
      }, ot.prototype.onContextMenu = function() {
      }, ot.prototype.resetPosition = function() {
      }, ot.prototype.needsContentAttribute = !0;
      function Nc(e, n) {
        var a = Pa(e, n.line);
        if (!a || a.hidden)
          return null;
        var o = De(e.doc, n.line), s = iu(a, o, n.line), y = ct(o, e.doc.direction), N = "left";
        if (y) {
          var B = $t(y, n.ch);
          N = B % 2 ? "right" : "left";
        }
        var P = lu(s.map, n.ch, N);
        return P.offset = P.collapse == "right" ? P.end : P.start, P;
      }
      function ch(e) {
        for (var n = e; n; n = n.parentNode)
          if (/CodeMirror-gutter-wrapper/.test(n.className))
            return !0;
        return !1;
      }
      function li(e, n) {
        return n && (e.bad = !0), e;
      }
      function fh(e, n, a, o, s) {
        var y = "", N = !1, B = e.doc.lineSeparator(), P = !1;
        function j(le) {
          return function(pe) {
            return pe.id == le;
          };
        }
        function Z() {
          N && (y += B, P && (y += B), N = P = !1);
        }
        function te(le) {
          le && (Z(), y += le);
        }
        function ue(le) {
          if (le.nodeType == 1) {
            var pe = le.getAttribute("cm-text");
            if (pe) {
              te(pe);
              return;
            }
            var ge = le.getAttribute("cm-marker"), me;
            if (ge) {
              var xe = e.findMarks(ie(o, 0), ie(s + 1, 0), j(+ge));
              xe.length && (me = xe[0].find(0)) && te(Vn(e.doc, me.from, me.to).join(B));
              return;
            }
            if (le.getAttribute("contenteditable") == "false")
              return;
            var Se = /^(pre|div|p|li|table|br)$/i.test(le.nodeName);
            if (!/^br$/i.test(le.nodeName) && le.textContent.length == 0)
              return;
            Se && Z();
            for (var we = 0; we < le.childNodes.length; we++)
              ue(le.childNodes[we]);
            /^(pre|p)$/i.test(le.nodeName) && (P = !0), Se && (N = !0);
          } else le.nodeType == 3 && te(le.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
        }
        for (; ue(n), n != a; )
          n = n.nextSibling, P = !1;
        return y;
      }
      function Xo(e, n, a) {
        var o;
        if (n == e.display.lineDiv) {
          if (o = e.display.lineDiv.childNodes[a], !o)
            return li(e.clipPos(ie(e.display.viewTo - 1)), !0);
          n = null, a = 0;
        } else
          for (o = n; ; o = o.parentNode) {
            if (!o || o == e.display.lineDiv)
              return null;
            if (o.parentNode && o.parentNode == e.display.lineDiv)
              break;
          }
        for (var s = 0; s < e.display.view.length; s++) {
          var y = e.display.view[s];
          if (y.node == o)
            return dh(y, n, a);
        }
      }
      function dh(e, n, a) {
        var o = e.text.firstChild, s = !1;
        if (!n || !I(o, n))
          return li(ie(Ze(e.line), 0), !0);
        if (n == o && (s = !0, n = o.childNodes[a], a = 0, !n)) {
          var y = e.rest ? he(e.rest) : e.line;
          return li(ie(Ze(y), y.text.length), s);
        }
        var N = n.nodeType == 3 ? n : null, B = n;
        for (!N && n.childNodes.length == 1 && n.firstChild.nodeType == 3 && (N = n.firstChild, a && (a = N.nodeValue.length)); B.parentNode != o; )
          B = B.parentNode;
        var P = e.measure, j = P.maps;
        function Z(me, xe, Se) {
          for (var we = -1; we < (j ? j.length : 0); we++)
            for (var Ee = we < 0 ? P.map : j[we], Le = 0; Le < Ee.length; Le += 3) {
              var Re = Ee[Le + 2];
              if (Re == me || Re == xe) {
                var We = Ze(we < 0 ? e.line : e.rest[we]), ut = Ee[Le] + Se;
                return (Se < 0 || Re != me) && (ut = Ee[Le + (Se ? 1 : 0)]), ie(We, ut);
              }
            }
        }
        var te = Z(N, B, a);
        if (te)
          return li(te, s);
        for (var ue = B.nextSibling, le = N ? N.nodeValue.length - a : 0; ue; ue = ue.nextSibling) {
          if (te = Z(ue, ue.firstChild, 0), te)
            return li(ie(te.line, te.ch - le), s);
          le += ue.textContent.length;
        }
        for (var pe = B.previousSibling, ge = a; pe; pe = pe.previousSibling) {
          if (te = Z(pe, pe.firstChild, -1), te)
            return li(ie(te.line, te.ch + ge), s);
          ge += pe.textContent.length;
        }
      }
      var At = function(e) {
        this.cm = e, this.prevInput = "", this.pollingFast = !1, this.polling = new J(), this.hasSelection = !1, this.composing = null;
      };
      At.prototype.init = function(e) {
        var n = this, a = this, o = this.cm;
        this.createField(e);
        var s = this.textarea;
        e.wrapper.insertBefore(this.wrapper, e.wrapper.firstChild), p && (s.style.width = "0px"), fe(s, "input", function() {
          W && K >= 9 && n.hasSelection && (n.hasSelection = null), a.poll();
        }), fe(s, "paste", function(N) {
          $e(o, N) || Sc(N, o) || (o.state.pasteIncoming = +/* @__PURE__ */ new Date(), a.fastPoll());
        });
        function y(N) {
          if (!$e(o, N)) {
            if (o.somethingSelected())
              Ko({ lineWise: !1, text: o.getSelections() });
            else if (o.options.lineWiseCopyCut) {
              var B = kc(o);
              Ko({ lineWise: !0, text: B.text }), N.type == "cut" ? o.setSelections(B.ranges, null, ae) : (a.prevInput = "", s.value = B.text.join(`
`), U(s));
            } else
              return;
            N.type == "cut" && (o.state.cutIncoming = +/* @__PURE__ */ new Date());
          }
        }
        fe(s, "cut", y), fe(s, "copy", y), fe(e.scroller, "paste", function(N) {
          if (!(Kn(e, N) || $e(o, N))) {
            if (!s.dispatchEvent) {
              o.state.pasteIncoming = +/* @__PURE__ */ new Date(), a.focus();
              return;
            }
            var B = new Event("paste");
            B.clipboardData = N.clipboardData, s.dispatchEvent(B);
          }
        }), fe(e.lineSpace, "selectstart", function(N) {
          Kn(e, N) || Te(N);
        }), fe(s, "compositionstart", function() {
          var N = o.getCursor("from");
          a.composing && a.composing.range.clear(), a.composing = {
            start: N,
            range: o.markText(N, o.getCursor("to"), { className: "CodeMirror-composing" })
          };
        }), fe(s, "compositionend", function() {
          a.composing && (a.poll(), a.composing.range.clear(), a.composing = null);
        });
      }, At.prototype.createField = function(e) {
        this.wrapper = Dc(), this.textarea = this.wrapper.firstChild;
      }, At.prototype.screenReaderLabelChanged = function(e) {
        e ? this.textarea.setAttribute("aria-label", e) : this.textarea.removeAttribute("aria-label");
      }, At.prototype.prepareSelection = function() {
        var e = this.cm, n = e.display, a = e.doc, o = yu(e);
        if (e.options.moveInputWithCursor) {
          var s = En(e, a.sel.primary().head, "div"), y = n.wrapper.getBoundingClientRect(), N = n.lineDiv.getBoundingClientRect();
          o.teTop = Math.max(0, Math.min(
            n.wrapper.clientHeight - 10,
            s.top + N.top - y.top
          )), o.teLeft = Math.max(0, Math.min(
            n.wrapper.clientWidth - 10,
            s.left + N.left - y.left
          ));
        }
        return o;
      }, At.prototype.showSelection = function(e) {
        var n = this.cm, a = n.display;
        E(a.cursorDiv, e.cursors), E(a.selectionDiv, e.selection), e.teTop != null && (this.wrapper.style.top = e.teTop + "px", this.wrapper.style.left = e.teLeft + "px");
      }, At.prototype.reset = function(e) {
        if (!(this.contextMenuPending || this.composing)) {
          var n = this.cm;
          if (n.somethingSelected()) {
            this.prevInput = "";
            var a = n.getSelection();
            this.textarea.value = a, n.state.focused && U(this.textarea), W && K >= 9 && (this.hasSelection = a);
          } else e || (this.prevInput = this.textarea.value = "", W && K >= 9 && (this.hasSelection = null));
        }
      }, At.prototype.getField = function() {
        return this.textarea;
      }, At.prototype.supportsTouch = function() {
        return !1;
      }, At.prototype.focus = function() {
        if (this.cm.options.readOnly != "nocursor" && (!x || H() != this.textarea))
          try {
            this.textarea.focus();
          } catch (e) {
          }
      }, At.prototype.blur = function() {
        this.textarea.blur();
      }, At.prototype.resetPosition = function() {
        this.wrapper.style.top = this.wrapper.style.left = 0;
      }, At.prototype.receivedFocus = function() {
        this.slowPoll();
      }, At.prototype.slowPoll = function() {
        var e = this;
        this.pollingFast || this.polling.set(this.cm.options.pollInterval, function() {
          e.poll(), e.cm.state.focused && e.slowPoll();
        });
      }, At.prototype.fastPoll = function() {
        var e = !1, n = this;
        n.pollingFast = !0;
        function a() {
          var o = n.poll();
          !o && !e ? (e = !0, n.polling.set(60, a)) : (n.pollingFast = !1, n.slowPoll());
        }
        n.polling.set(20, a);
      }, At.prototype.poll = function() {
        var e = this, n = this.cm, a = this.textarea, o = this.prevInput;
        if (this.contextMenuPending || !n.state.focused || tr(a) && !o && !this.composing || n.isReadOnly() || n.options.disableInput || n.state.keySeq)
          return !1;
        var s = a.value;
        if (s == o && !n.somethingSelected())
          return !1;
        if (W && K >= 9 && this.hasSelection === s || g && /[\uf700-\uf7ff]/.test(s))
          return n.display.input.reset(), !1;
        if (n.doc.sel == n.display.selForContextMenu) {
          var y = s.charCodeAt(0);
          if (y == 8203 && !o && (o = "​"), y == 8666)
            return this.reset(), this.cm.execCommand("undo");
        }
        for (var N = 0, B = Math.min(o.length, s.length); N < B && o.charCodeAt(N) == s.charCodeAt(N); )
          ++N;
        return cn(n, function() {
          gl(
            n,
            s.slice(N),
            o.length - N,
            null,
            e.composing ? "*compose" : null
          ), s.length > 1e3 || s.indexOf(`
`) > -1 ? a.value = e.prevInput = "" : e.prevInput = s, e.composing && (e.composing.range.clear(), e.composing.range = n.markText(
            e.composing.start,
            n.getCursor("to"),
            { className: "CodeMirror-composing" }
          ));
        }), !0;
      }, At.prototype.ensurePolled = function() {
        this.pollingFast && this.poll() && (this.pollingFast = !1);
      }, At.prototype.onKeyPress = function() {
        W && K >= 9 && (this.hasSelection = null), this.fastPoll();
      }, At.prototype.onContextMenu = function(e) {
        var n = this, a = n.cm, o = a.display, s = n.textarea;
        n.contextMenuPending && n.contextMenuPending();
        var y = Er(a, e), N = o.scroller.scrollTop;
        if (!y || r)
          return;
        var B = a.options.resetSelectionOnContextMenu;
        B && a.doc.sel.contains(y) == -1 && Ot(a, Ut)(a.doc, ur(y), ae);
        var P = s.style.cssText, j = n.wrapper.style.cssText, Z = n.wrapper.offsetParent.getBoundingClientRect();
        n.wrapper.style.cssText = "position: static", s.style.cssText = `position: absolute; width: 30px; height: 30px;
      top: ` + (e.clientY - Z.top - 5) + "px; left: " + (e.clientX - Z.left - 5) + `px;
      z-index: 1000; background: ` + (W ? "rgba(255, 255, 255, .05)" : "transparent") + `;
      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);`;
        var te;
        q && (te = window.scrollY), o.input.focus(), q && window.scrollTo(null, te), o.input.reset(), a.somethingSelected() || (s.value = n.prevInput = " "), n.contextMenuPending = le, o.selForContextMenu = a.doc.sel, clearTimeout(o.detectingSelectAll);
        function ue() {
          if (s.selectionStart != null) {
            var ge = a.somethingSelected(), me = "​" + (ge ? s.value : "");
            s.value = "⇚", s.value = me, n.prevInput = ge ? "" : "​", s.selectionStart = 1, s.selectionEnd = me.length, o.selForContextMenu = a.doc.sel;
          }
        }
        function le() {
          if (n.contextMenuPending == le && (n.contextMenuPending = !1, n.wrapper.style.cssText = j, s.style.cssText = P, W && K < 9 && o.scrollbars.setScrollTop(o.scroller.scrollTop = N), s.selectionStart != null)) {
            (!W || W && K < 9) && ue();
            var ge = 0, me = function() {
              o.selForContextMenu == a.doc.sel && s.selectionStart == 0 && s.selectionEnd > 0 && n.prevInput == "​" ? Ot(a, Ku)(a) : ge++ < 10 ? o.detectingSelectAll = setTimeout(me, 500) : (o.selForContextMenu = null, o.input.reset());
            };
            o.detectingSelectAll = setTimeout(me, 200);
          }
        }
        if (W && K >= 9 && ue(), D) {
          it(e);
          var pe = function() {
            _e(window, "mouseup", pe), setTimeout(le, 20);
          };
          fe(window, "mouseup", pe);
        } else
          setTimeout(le, 50);
      }, At.prototype.readOnlyChanged = function(e) {
        e || this.reset(), this.textarea.disabled = e == "nocursor", this.textarea.readOnly = !!e;
      }, At.prototype.setUneditable = function() {
      }, At.prototype.needsContentAttribute = !1;
      function ph(e, n) {
        if (n = n ? X(n) : {}, n.value = e.value, !n.tabindex && e.tabIndex && (n.tabindex = e.tabIndex), !n.placeholder && e.placeholder && (n.placeholder = e.placeholder), n.autofocus == null) {
          var a = H();
          n.autofocus = a == e || e.getAttribute("autofocus") != null && a == document.body;
        }
        function o() {
          e.value = B.getValue();
        }
        var s;
        if (e.form && (fe(e.form, "submit", o), !n.leaveSubmitMethodAlone)) {
          var y = e.form;
          s = y.submit;
          try {
            var N = y.submit = function() {
              o(), y.submit = s, y.submit(), y.submit = N;
            };
          } catch (P) {
          }
        }
        n.finishInit = function(P) {
          P.save = o, P.getTextArea = function() {
            return e;
          }, P.toTextArea = function() {
            P.toTextArea = isNaN, o(), e.parentNode.removeChild(P.getWrapperElement()), e.style.display = "", e.form && (_e(e.form, "submit", o), !n.leaveSubmitMethodAlone && typeof e.form.submit == "function" && (e.form.submit = s));
          };
        }, e.style.display = "none";
        var B = ht(
          function(P) {
            return e.parentNode.insertBefore(P, e.nextSibling);
          },
          n
        );
        return B;
      }
      function hh(e) {
        e.off = _e, e.on = fe, e.wheelEventPixels = xp, e.Doc = tn, e.splitLines = bi, e.countColumn = G, e.findColumn = Ae, e.isWordChar = ln, e.Pass = oe, e.signal = Oe, e.Line = Qr, e.changeEnd = cr, e.scrollbarModel = Su, e.Pos = ie, e.cmpPos = de, e.modes = Sn, e.mimeModes = nr, e.resolveMode = un, e.getMode = rr, e.modeExtensions = ir, e.extendMode = wo, e.copyState = Qn, e.startState = Ai, e.innerMode = or, e.commands = Ui, e.keyMap = Xn, e.keyName = fc, e.isModifierKey = uc, e.lookupKey = ii, e.normalizeKeyMap = Up, e.StringStream = gt, e.SharedTextMarker = ji, e.TextMarker = dr, e.LineWidget = Hi, e.e_preventDefault = Te, e.e_stopPropagation = Ie, e.e_stop = it, e.addClass = $, e.contains = I, e.rmClass = L, e.keyNames = pr;
      }
      oh(ht), uh(ht);
      var vh = "iter insert remove copy getEditor constructor".split(" ");
      for (var Jo in tn.prototype)
        tn.prototype.hasOwnProperty(Jo) && ee(vh, Jo) < 0 && (ht.prototype[Jo] = /* @__PURE__ */ function(e) {
          return function() {
            return e.apply(this.doc, arguments);
          };
        }(tn.prototype[Jo]));
      return be(tn), ht.inputStyles = { textarea: At, contenteditable: ot }, ht.defineMode = function(e) {
        !ht.defaults.mode && e != "null" && (ht.defaults.mode = e), xo.apply(this, arguments);
      }, ht.defineMIME = Ur, ht.defineMode("null", function() {
        return { token: function(e) {
          return e.skipToEnd();
        } };
      }), ht.defineMIME("text/plain", "null"), ht.defineExtension = function(e, n) {
        ht.prototype[e] = n;
      }, ht.defineDocExtension = function(e, n) {
        tn.prototype[e] = n;
      }, ht.fromTextArea = ph, hh(ht), ht.version = "5.60.0", ht;
    });
  }(ss)), ss.exports;
}
var Kg = _a();
const gi = /* @__PURE__ */ Ts(Kg);
(function(i, t) {
  (function(l) {
    l(_a());
  })(function(l) {
    l.defineMode("javascript", function(c, M) {
      var T = c.indentUnit, F = M.statementIndent, z = M.jsonld, W = M.json || z, K = M.typescript, q = M.wordCharacters || /[\w$\xa1-\uffff]/, m = function() {
        function V(kt) {
          return { type: kt, style: "keyword" };
        }
        var ne = V("keyword a"), ie = V("keyword b"), de = V("keyword c"), Be = V("keyword d"), Ye = V("operator"), et = { type: "atom", style: "atom" };
        return {
          if: V("if"),
          while: ne,
          with: ne,
          else: ie,
          do: ie,
          try: ie,
          finally: ie,
          return: Be,
          break: Be,
          continue: Be,
          new: V("new"),
          delete: de,
          void: de,
          throw: de,
          debugger: V("debugger"),
          var: V("var"),
          const: V("var"),
          let: V("var"),
          function: V("function"),
          catch: V("catch"),
          for: V("for"),
          switch: V("switch"),
          case: V("case"),
          default: V("default"),
          in: Ye,
          typeof: Ye,
          instanceof: Ye,
          true: et,
          false: et,
          null: et,
          undefined: et,
          NaN: et,
          Infinity: et,
          this: V("this"),
          class: V("class"),
          super: V("atom"),
          yield: de,
          export: V("export"),
          import: V("import"),
          extends: de,
          await: de
        };
      }(), d = /[+\-*&%=<>!?|~^@]/, r = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;
      function u(V) {
        for (var ne = !1, ie, de = !1; (ie = V.next()) != null; ) {
          if (!ne) {
            if (ie == "/" && !de) return;
            ie == "[" ? de = !0 : de && ie == "]" && (de = !1);
          }
          ne = !ne && ie == "\\";
        }
      }
      var v, C;
      function p(V, ne, ie) {
        return v = V, C = ie, ne;
      }
      function b(V, ne) {
        var ie = V.next();
        if (ie == '"' || ie == "'")
          return ne.tokenize = x(ie), ne.tokenize(V, ne);
        if (ie == "." && V.match(/^\d[\d_]*(?:[eE][+\-]?[\d_]+)?/))
          return p("number", "number");
        if (ie == "." && V.match(".."))
          return p("spread", "meta");
        if (/[\[\]{}\(\),;\:\.]/.test(ie))
          return p(ie);
        if (ie == "=" && V.eat(">"))
          return p("=>", "operator");
        if (ie == "0" && V.match(/^(?:x[\dA-Fa-f_]+|o[0-7_]+|b[01_]+)n?/))
          return p("number", "number");
        if (/\d/.test(ie))
          return V.match(/^[\d_]*(?:n|(?:\.[\d_]*)?(?:[eE][+\-]?[\d_]+)?)?/), p("number", "number");
        if (ie == "/")
          return V.eat("*") ? (ne.tokenize = g, g(V, ne)) : V.eat("/") ? (V.skipToEnd(), p("comment", "comment")) : Fn(V, ne, 1) ? (u(V), V.match(/^\b(([gimyus])(?![gimyus]*\2))+\b/), p("regexp", "string-2")) : (V.eat("="), p("operator", "operator", V.current()));
        if (ie == "`")
          return ne.tokenize = _, _(V, ne);
        if (ie == "#" && V.peek() == "!")
          return V.skipToEnd(), p("meta", "meta");
        if (ie == "#" && V.eatWhile(q))
          return p("variable", "property");
        if (ie == "<" && V.match("!--") || ie == "-" && V.match("->") && !/\S/.test(V.string.slice(0, V.start)))
          return V.skipToEnd(), p("comment", "comment");
        if (d.test(ie))
          return (ie != ">" || !ne.lexical || ne.lexical.type != ">") && (V.eat("=") ? (ie == "!" || ie == "=") && V.eat("=") : /[<>*+\-|&?]/.test(ie) && (V.eat(ie), ie == ">" && V.eat(ie))), ie == "?" && V.eat(".") ? p(".") : p("operator", "operator", V.current());
        if (q.test(ie)) {
          V.eatWhile(q);
          var de = V.current();
          if (ne.lastType != ".") {
            if (m.propertyIsEnumerable(de)) {
              var Be = m[de];
              return p(Be.type, Be.style, de);
            }
            if (de == "async" && V.match(/^(\s|\/\*([^*]|\*(?!\/))*?\*\/)*[\[\(\w]/, !1))
              return p("async", "keyword", de);
          }
          return p("variable", "variable", de);
        }
      }
      function x(V) {
        return function(ne, ie) {
          var de = !1, Be;
          if (z && ne.peek() == "@" && ne.match(r))
            return ie.tokenize = b, p("jsonld-keyword", "meta");
          for (; (Be = ne.next()) != null && !(Be == V && !de); )
            de = !de && Be == "\\";
          return de || (ie.tokenize = b), p("string", "string");
        };
      }
      function g(V, ne) {
        for (var ie = !1, de; de = V.next(); ) {
          if (de == "/" && ie) {
            ne.tokenize = b;
            break;
          }
          ie = de == "*";
        }
        return p("comment", "comment");
      }
      function _(V, ne) {
        for (var ie = !1, de; (de = V.next()) != null; ) {
          if (!ie && (de == "`" || de == "$" && V.eat("{"))) {
            ne.tokenize = b;
            break;
          }
          ie = !ie && de == "\\";
        }
        return p("quasi", "string-2", V.current());
      }
      var A = "([{}])";
      function f(V, ne) {
        ne.fatArrowAt && (ne.fatArrowAt = null);
        var ie = V.string.indexOf("=>", V.start);
        if (!(ie < 0)) {
          if (K) {
            var de = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(V.string.slice(V.start, ie));
            de && (ie = de.index);
          }
          for (var Be = 0, Ye = !1, et = ie - 1; et >= 0; --et) {
            var kt = V.string.charAt(et), hn = A.indexOf(kt);
            if (hn >= 0 && hn < 3) {
              if (!Be) {
                ++et;
                break;
              }
              if (--Be == 0) {
                kt == "(" && (Ye = !0);
                break;
              }
            } else if (hn >= 3 && hn < 6)
              ++Be;
            else if (q.test(kt))
              Ye = !0;
            else if (/["'\/`]/.test(kt))
              for (; ; --et) {
                if (et == 0) return;
                var Pe = V.string.charAt(et - 1);
                if (Pe == kt && V.string.charAt(et - 2) != "\\") {
                  et--;
                  break;
                }
              }
            else if (Ye && !Be) {
              ++et;
              break;
            }
          }
          Ye && !Be && (ne.fatArrowAt = et);
        }
      }
      var S = {
        atom: !0,
        number: !0,
        variable: !0,
        string: !0,
        regexp: !0,
        this: !0,
        import: !0,
        "jsonld-keyword": !0
      };
      function D(V, ne, ie, de, Be, Ye) {
        this.indented = V, this.column = ne, this.type = ie, this.prev = Be, this.info = Ye, de != null && (this.align = de);
      }
      function k(V, ne) {
        for (var ie = V.localVars; ie; ie = ie.next)
          if (ie.name == ne) return !0;
        for (var de = V.context; de; de = de.prev)
          for (var ie = de.vars; ie; ie = ie.next)
            if (ie.name == ne) return !0;
      }
      function L(V, ne, ie, de, Be) {
        var Ye = V.cc;
        for (h.state = V, h.stream = Be, h.marked = null, h.cc = Ye, h.style = ne, V.lexical.hasOwnProperty("align") || (V.lexical.align = !0); ; ) {
          var et = Ye.length ? Ye.pop() : W ? se : oe;
          if (et(ie, de)) {
            for (; Ye.length && Ye[Ye.length - 1].lex; )
              Ye.pop()();
            return h.marked ? h.marked : ie == "variable" && k(V, de) ? "variable-2" : ne;
          }
        }
      }
      var h = { state: null, column: null, marked: null, cc: null };
      function E() {
        for (var V = arguments.length - 1; V >= 0; V--) h.cc.push(arguments[V]);
      }
      function w() {
        return E.apply(null, arguments), !0;
      }
      function O(V, ne) {
        for (var ie = ne; ie; ie = ie.next) if (ie.name == V) return !0;
        return !1;
      }
      function R(V) {
        var ne = h.state;
        if (h.marked = "def", ne.context) {
          if (ne.lexical.info == "var" && ne.context && ne.context.block) {
            var ie = I(V, ne.context);
            if (ie != null) {
              ne.context = ie;
              return;
            }
          } else if (!O(V, ne.localVars)) {
            ne.localVars = new Q(V, ne.localVars);
            return;
          }
        }
        M.globalVars && !O(V, ne.globalVars) && (ne.globalVars = new Q(V, ne.globalVars));
      }
      function I(V, ne) {
        if (ne)
          if (ne.block) {
            var ie = I(V, ne.prev);
            return ie ? ie == ne.prev ? ne : new $(ie, ne.vars, !0) : null;
          } else return O(V, ne.vars) ? ne : new $(ne.prev, new Q(V, ne.vars), !1);
        else return null;
      }
      function H(V) {
        return V == "public" || V == "private" || V == "protected" || V == "abstract" || V == "readonly";
      }
      function $(V, ne, ie) {
        this.prev = V, this.vars = ne, this.block = ie;
      }
      function Q(V, ne) {
        this.name = V, this.next = ne;
      }
      var U = new Q("this", new Q("arguments", null));
      function Y() {
        h.state.context = new $(h.state.context, h.state.localVars, !1), h.state.localVars = U;
      }
      function X() {
        h.state.context = new $(h.state.context, h.state.localVars, !0), h.state.localVars = null;
      }
      function G() {
        h.state.localVars = h.state.context.vars, h.state.context = h.state.context.prev;
      }
      G.lex = !0;
      function J(V, ne) {
        var ie = function() {
          var de = h.state, Be = de.indented;
          if (de.lexical.type == "stat") Be = de.lexical.indented;
          else for (var Ye = de.lexical; Ye && Ye.type == ")" && Ye.align; Ye = Ye.prev)
            Be = Ye.indented;
          de.lexical = new D(Be, h.stream.column(), V, null, de.lexical, ne);
        };
        return ie.lex = !0, ie;
      }
      function ee() {
        var V = h.state;
        V.lexical.prev && (V.lexical.type == ")" && (V.indented = V.lexical.indented), V.lexical = V.lexical.prev);
      }
      ee.lex = !0;
      function re(V) {
        function ne(ie) {
          return ie == V ? w() : V == ";" || ie == "}" || ie == ")" || ie == "]" ? E() : w(ne);
        }
        return ne;
      }
      function oe(V, ne) {
        return V == "var" ? w(J("vardef", ne), it, re(";"), ee) : V == "keyword a" ? w(J("form"), Ae, oe, ee) : V == "keyword b" ? w(J("form"), oe, ee) : V == "keyword d" ? h.stream.match(/^\s*$/, !1) ? w() : w(J("stat"), ce, re(";"), ee) : V == "debugger" ? w(re(";")) : V == "{" ? w(J("}"), X, zt, ee, G) : V == ";" ? w() : V == "if" ? (h.state.lexical.info == "else" && h.state.cc[h.state.cc.length - 1] == ee && h.state.cc.pop()(), w(J("form"), Ae, oe, ee, zr)) : V == "function" ? w(In) : V == "for" ? w(J("form"), bo, oe, ee) : V == "class" || K && ne == "interface" ? (h.marked = "keyword", w(J("form", V == "class" ? V : ne), xo, ee)) : V == "variable" ? K && ne == "declare" ? (h.marked = "keyword", w(oe)) : K && (ne == "module" || ne == "enum" || ne == "type") && h.stream.match(/^\s*\w/, !1) ? (h.marked = "keyword", ne == "enum" ? w(Wr) : ne == "type" ? w(Ao, re("operator"), _e, re(";")) : w(J("form"), dt, re("{"), J("}"), zt, ee, ee)) : K && ne == "namespace" ? (h.marked = "keyword", w(J("form"), se, oe, ee)) : K && ne == "abstract" ? (h.marked = "keyword", w(oe)) : w(J("stat"), _r) : V == "switch" ? w(
          J("form"),
          Ae,
          re("{"),
          J("}", "switch"),
          X,
          zt,
          ee,
          ee,
          G
        ) : V == "case" ? w(se, re(":")) : V == "default" ? w(re(":")) : V == "catch" ? w(J("form"), Y, ae, oe, ee, G) : V == "export" ? w(J("stat"), ir, ee) : V == "import" ? w(J("stat"), Qn, ee) : V == "async" ? w(oe) : ne == "@" ? w(se, oe) : E(J("stat"), se, re(";"), ee);
      }
      function ae(V) {
        if (V == "(") return w(Sn, re(")"));
      }
      function se(V, ne) {
        return ye(V, ne, !1);
      }
      function ve(V, ne) {
        return ye(V, ne, !0);
      }
      function Ae(V) {
        return V != "(" ? E() : w(J(")"), ce, re(")"), ee);
      }
      function ye(V, ne, ie) {
        if (h.state.fatArrowAt == h.stream.start) {
          var de = ie ? qt : Ve;
          if (V == "(") return w(Y, J(")"), st(Sn, ")"), ee, re("=>"), de, G);
          if (V == "variable") return E(Y, dt, re("=>"), de, G);
        }
        var Be = ie ? ke : he;
        return S.hasOwnProperty(V) ? w(Be) : V == "function" ? w(In, Be) : V == "class" || K && ne == "interface" ? (h.marked = "keyword", w(J("form"), nr, ee)) : V == "keyword c" || V == "async" ? w(ie ? ve : se) : V == "(" ? w(J(")"), ce, re(")"), ee, Be) : V == "operator" || V == "spread" ? w(ie ? ve : se) : V == "[" ? w(J("]"), Vn, ee, Be) : V == "{" ? $t(jt, "}", null, Be) : V == "quasi" ? E(je, Be) : V == "new" ? w(ln(ie)) : w();
      }
      function ce(V) {
        return V.match(/[;\}\)\],]/) ? E() : E(se);
      }
      function he(V, ne) {
        return V == "," ? w(ce) : ke(V, ne, !1);
      }
      function ke(V, ne, ie) {
        var de = ie == !1 ? he : ke, Be = ie == !1 ? se : ve;
        if (V == "=>") return w(Y, ie ? qt : Ve, G);
        if (V == "operator")
          return /\+\+|--/.test(ne) || K && ne == "!" ? w(de) : K && ne == "<" && h.stream.match(/^([^<>]|<[^<>]*>)*>\s*\(/, !1) ? w(J(">"), st(_e, ">"), ee, de) : ne == "?" ? w(se, re(":"), Be) : w(Be);
        if (V == "quasi")
          return E(je, de);
        if (V != ";") {
          if (V == "(") return $t(ve, ")", "call", de);
          if (V == ".") return w(Bt, de);
          if (V == "[") return w(J("]"), ce, re("]"), ee, de);
          if (K && ne == "as")
            return h.marked = "keyword", w(_e, de);
          if (V == "regexp")
            return h.state.lastType = h.marked = "operator", h.stream.backUp(h.stream.pos - h.stream.start - 1), w(Be);
        }
      }
      function je(V, ne) {
        return V != "quasi" ? E() : ne.slice(ne.length - 2) != "${" ? w(je) : w(se, He);
      }
      function He(V) {
        if (V == "}")
          return h.marked = "string-2", h.state.tokenize = _, w(je);
      }
      function Ve(V) {
        return f(h.stream, h.state), E(V == "{" ? oe : se);
      }
      function qt(V) {
        return f(h.stream, h.state), E(V == "{" ? oe : ve);
      }
      function ln(V) {
        return function(ne) {
          return ne == "." ? w(V ? pn : Ft) : ne == "variable" && K ? w(Te, V ? ke : he) : E(V ? ve : se);
        };
      }
      function Ft(V, ne) {
        if (ne == "target")
          return h.marked = "keyword", w(he);
      }
      function pn(V, ne) {
        if (ne == "target")
          return h.marked = "keyword", w(ke);
      }
      function _r(V) {
        return V == ":" ? w(ee, oe) : E(he, re(";"), ee);
      }
      function Bt(V) {
        if (V == "variable")
          return h.marked = "property", w();
      }
      function jt(V, ne) {
        if (V == "async")
          return h.marked = "property", w(jt);
        if (V == "variable" || h.style == "keyword") {
          if (h.marked = "property", ne == "get" || ne == "set") return w(sn);
          var ie;
          return K && h.state.fatArrowAt == h.stream.start && (ie = h.stream.match(/^\s*:\s*/, !1)) && (h.state.fatArrowAt = h.stream.pos + ie[0].length), w(Zt);
        } else {
          if (V == "number" || V == "string")
            return h.marked = z ? "property" : h.style + " property", w(Zt);
          if (V == "jsonld-keyword")
            return w(Zt);
          if (K && H(ne))
            return h.marked = "keyword", w(jt);
          if (V == "[")
            return w(se, ct, re("]"), Zt);
          if (V == "spread")
            return w(ve, Zt);
          if (ne == "*")
            return h.marked = "keyword", w(jt);
          if (V == ":")
            return E(Zt);
        }
      }
      function sn(V) {
        return V != "variable" ? E(Zt) : (h.marked = "property", w(In));
      }
      function Zt(V) {
        if (V == ":") return w(ve);
        if (V == "(") return E(In);
      }
      function st(V, ne, ie) {
        function de(Be, Ye) {
          if (ie ? ie.indexOf(Be) > -1 : Be == ",") {
            var et = h.state.lexical;
            return et.info == "call" && (et.pos = (et.pos || 0) + 1), w(function(kt, hn) {
              return kt == ne || hn == ne ? E() : E(V);
            }, de);
          }
          return Be == ne || Ye == ne ? w() : ie && ie.indexOf(";") > -1 ? E(V) : w(re(ne));
        }
        return function(Be, Ye) {
          return Be == ne || Ye == ne ? w() : E(V, de);
        };
      }
      function $t(V, ne, ie) {
        for (var de = 3; de < arguments.length; de++)
          h.cc.push(arguments[de]);
        return w(J(ne, ie), st(V, ne), ee);
      }
      function zt(V) {
        return V == "}" ? w() : E(oe, zt);
      }
      function ct(V, ne) {
        if (K) {
          if (V == ":") return w(_e);
          if (ne == "?") return w(ct);
        }
      }
      function An(V, ne) {
        if (K && (V == ":" || ne == "in")) return w(_e);
      }
      function fe(V) {
        if (K && V == ":")
          return h.stream.match(/^\s*\w+\s+is\b/, !1) ? w(se, Ne, _e) : w(_e);
      }
      function Ne(V, ne) {
        if (ne == "is")
          return h.marked = "keyword", w();
      }
      function _e(V, ne) {
        if (ne == "keyof" || ne == "typeof" || ne == "infer" || ne == "readonly")
          return h.marked = "keyword", w(ne == "typeof" ? ve : _e);
        if (V == "variable" || ne == "void")
          return h.marked = "type", w(be);
        if (ne == "|" || ne == "&") return w(_e);
        if (V == "string" || V == "number" || V == "atom") return w(be);
        if (V == "[") return w(J("]"), st(_e, "]", ","), ee, be);
        if (V == "{") return w(J("}"), $e, ee, be);
        if (V == "(") return w(st(nt, ")"), Oe, be);
        if (V == "<") return w(st(_e, ">"), _e);
      }
      function Oe(V) {
        if (V == "=>") return w(_e);
      }
      function $e(V) {
        return V.match(/[\}\)\]]/) ? w() : V == "," || V == ";" ? w($e) : E(Ct, $e);
      }
      function Ct(V, ne) {
        if (V == "variable" || h.style == "keyword")
          return h.marked = "property", w(Ct);
        if (ne == "?" || V == "number" || V == "string")
          return w(Ct);
        if (V == ":")
          return w(_e);
        if (V == "[")
          return w(re("variable"), An, re("]"), Ct);
        if (V == "(")
          return E(Ln, Ct);
        if (!V.match(/[;\}\)\],]/))
          return w();
      }
      function nt(V, ne) {
        return V == "variable" && h.stream.match(/^\s*[?:]/, !1) || ne == "?" ? w(nt) : V == ":" ? w(_e) : V == "spread" ? w(nt) : E(_e);
      }
      function be(V, ne) {
        if (ne == "<") return w(J(">"), st(_e, ">"), ee, be);
        if (ne == "|" || V == "." || ne == "&") return w(_e);
        if (V == "[") return w(_e, re("]"), be);
        if (ne == "extends" || ne == "implements")
          return h.marked = "keyword", w(_e);
        if (ne == "?") return w(_e, re(":"), _e);
      }
      function Te(V, ne) {
        if (ne == "<") return w(J(">"), st(_e, ">"), ee, be);
      }
      function Ie() {
        return E(_e, ze);
      }
      function ze(V, ne) {
        if (ne == "=") return w(_e);
      }
      function it(V, ne) {
        return ne == "enum" ? (h.marked = "keyword", w(Wr)) : E(dt, ct, xn, ka);
      }
      function dt(V, ne) {
        if (K && H(ne))
          return h.marked = "keyword", w(dt);
        if (V == "variable")
          return R(ne), w();
        if (V == "spread") return w(dt);
        if (V == "[") return $t(Rn, "]");
        if (V == "{") return $t(Vt, "}");
      }
      function Vt(V, ne) {
        return V == "variable" && !h.stream.match(/^\s*:/, !1) ? (R(ne), w(xn)) : (V == "variable" && (h.marked = "property"), V == "spread" ? w(dt) : V == "}" ? E() : V == "[" ? w(se, re("]"), re(":"), Vt) : w(re(":"), dt, xn));
      }
      function Rn() {
        return E(dt, xn);
      }
      function xn(V, ne) {
        if (ne == "=") return w(ve);
      }
      function ka(V) {
        if (V == ",") return w(it);
      }
      function zr(V, ne) {
        if (V == "keyword b" && ne == "else") return w(J("form", "else"), oe, ee);
      }
      function bo(V, ne) {
        if (ne == "await") return w(bo);
        if (V == "(") return w(J(")"), bi, ee);
      }
      function bi(V) {
        return V == "var" ? w(it, tr) : V == "variable" ? w(tr) : E(tr);
      }
      function tr(V, ne) {
        return V == ")" ? w() : V == ";" ? w(tr) : ne == "in" || ne == "of" ? (h.marked = "keyword", w(se, tr)) : E(se, tr);
      }
      function In(V, ne) {
        if (ne == "*")
          return h.marked = "keyword", w(In);
        if (V == "variable")
          return R(ne), w(In);
        if (V == "(") return w(Y, J(")"), st(Sn, ")"), ee, fe, oe, G);
        if (K && ne == "<") return w(J(">"), st(Ie, ">"), ee, In);
      }
      function Ln(V, ne) {
        if (ne == "*")
          return h.marked = "keyword", w(Ln);
        if (V == "variable")
          return R(ne), w(Ln);
        if (V == "(") return w(Y, J(")"), st(Sn, ")"), ee, fe, G);
        if (K && ne == "<") return w(J(">"), st(Ie, ">"), ee, Ln);
      }
      function Ao(V, ne) {
        if (V == "keyword" || V == "variable")
          return h.marked = "type", w(Ao);
        if (ne == "<")
          return w(J(">"), st(Ie, ">"), ee);
      }
      function Sn(V, ne) {
        return ne == "@" && w(se, Sn), V == "spread" ? w(Sn) : K && H(ne) ? (h.marked = "keyword", w(Sn)) : K && V == "this" ? w(ct, xn) : E(dt, ct, xn);
      }
      function nr(V, ne) {
        return V == "variable" ? xo(V, ne) : Ur(V, ne);
      }
      function xo(V, ne) {
        if (V == "variable")
          return R(ne), w(Ur);
      }
      function Ur(V, ne) {
        if (ne == "<") return w(J(">"), st(Ie, ">"), ee, Ur);
        if (ne == "extends" || ne == "implements" || K && V == ",")
          return ne == "implements" && (h.marked = "keyword"), w(K ? _e : se, Ur);
        if (V == "{") return w(J("}"), un, ee);
      }
      function un(V, ne) {
        if (V == "async" || V == "variable" && (ne == "static" || ne == "get" || ne == "set" || K && H(ne)) && h.stream.match(/^\s+[\w$\xa1-\uffff]/, !1))
          return h.marked = "keyword", w(un);
        if (V == "variable" || h.style == "keyword")
          return h.marked = "property", w(rr, un);
        if (V == "number" || V == "string") return w(rr, un);
        if (V == "[")
          return w(se, ct, re("]"), rr, un);
        if (ne == "*")
          return h.marked = "keyword", w(un);
        if (K && V == "(") return E(Ln, un);
        if (V == ";" || V == ",") return w(un);
        if (V == "}") return w();
        if (ne == "@") return w(se, un);
      }
      function rr(V, ne) {
        if (ne == "?") return w(rr);
        if (V == ":") return w(_e, xn);
        if (ne == "=") return w(ve);
        var ie = h.state.lexical.prev, de = ie && ie.info == "interface";
        return E(de ? Ln : In);
      }
      function ir(V, ne) {
        return ne == "*" ? (h.marked = "keyword", w(De, re(";"))) : ne == "default" ? (h.marked = "keyword", w(se, re(";"))) : V == "{" ? w(st(wo, "}"), De, re(";")) : E(oe);
      }
      function wo(V, ne) {
        if (ne == "as")
          return h.marked = "keyword", w(re("variable"));
        if (V == "variable") return E(ve, wo);
      }
      function Qn(V) {
        return V == "string" ? w() : V == "(" ? E(se) : V == "." ? E(he) : E(or, Ai, De);
      }
      function or(V, ne) {
        return V == "{" ? $t(or, "}") : (V == "variable" && R(ne), ne == "*" && (h.marked = "keyword"), w(gt));
      }
      function Ai(V) {
        if (V == ",") return w(or, Ai);
      }
      function gt(V, ne) {
        if (ne == "as")
          return h.marked = "keyword", w(or);
      }
      function De(V, ne) {
        if (ne == "from")
          return h.marked = "keyword", w(se);
      }
      function Vn(V) {
        return V == "]" ? w() : E(st(ve, "]"));
      }
      function Wr() {
        return E(J("form"), dt, re("{"), J("}"), st(wn, "}"), ee, ee);
      }
      function wn() {
        return E(dt, xn);
      }
      function Ze(V, ne) {
        return V.lastType == "operator" || V.lastType == "," || d.test(ne.charAt(0)) || /[,.]/.test(ne.charAt(0));
      }
      function Fn(V, ne, ie) {
        return ne.tokenize == b && /^(?:operator|sof|keyword [bcd]|case|new|export|default|spread|[\[{}\(,;:]|=>)$/.test(ne.lastType) || ne.lastType == "quasi" && /\{\s*$/.test(V.string.slice(0, V.pos - (ie || 0)));
      }
      return {
        startState: function(V) {
          var ne = {
            tokenize: b,
            lastType: "sof",
            cc: [],
            lexical: new D((V || 0) - T, 0, "block", !1),
            localVars: M.localVars,
            context: M.localVars && new $(null, null, !1),
            indented: V || 0
          };
          return M.globalVars && typeof M.globalVars == "object" && (ne.globalVars = M.globalVars), ne;
        },
        token: function(V, ne) {
          if (V.sol() && (ne.lexical.hasOwnProperty("align") || (ne.lexical.align = !1), ne.indented = V.indentation(), f(V, ne)), ne.tokenize != g && V.eatSpace()) return null;
          var ie = ne.tokenize(V, ne);
          return v == "comment" ? ie : (ne.lastType = v == "operator" && (C == "++" || C == "--") ? "incdec" : v, L(ne, ie, v, C, V));
        },
        indent: function(V, ne) {
          if (V.tokenize == g || V.tokenize == _) return l.Pass;
          if (V.tokenize != b) return 0;
          var ie = ne && ne.charAt(0), de = V.lexical, Be;
          if (!/^\s*else\b/.test(ne)) for (var Ye = V.cc.length - 1; Ye >= 0; --Ye) {
            var et = V.cc[Ye];
            if (et == ee) de = de.prev;
            else if (et != zr) break;
          }
          for (; (de.type == "stat" || de.type == "form") && (ie == "}" || (Be = V.cc[V.cc.length - 1]) && (Be == he || Be == ke) && !/^[,\.=+\-*:?[\(]/.test(ne)); )
            de = de.prev;
          F && de.type == ")" && de.prev.type == "stat" && (de = de.prev);
          var kt = de.type, hn = ie == kt;
          return kt == "vardef" ? de.indented + (V.lastType == "operator" || V.lastType == "," ? de.info.length + 1 : 0) : kt == "form" && ie == "{" ? de.indented : kt == "form" ? de.indented + T : kt == "stat" ? de.indented + (Ze(V, ne) ? F || T : 0) : de.info == "switch" && !hn && M.doubleIndentSwitch != !1 ? de.indented + (/^(?:case|default)\b/.test(ne) ? T : 2 * T) : de.align ? de.column + (hn ? 0 : 1) : de.indented + (hn ? 0 : T);
        },
        electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
        blockCommentStart: W ? null : "/*",
        blockCommentEnd: W ? null : "*/",
        blockCommentContinue: W ? null : " * ",
        lineComment: W ? null : "//",
        fold: "brace",
        closeBrackets: "()[]{}''\"\"``",
        helperType: W ? "json" : "javascript",
        jsonldMode: z,
        jsonMode: W,
        expressionAllowed: Fn,
        skipExpression: function(V) {
          var ne = V.cc[V.cc.length - 1];
          (ne == se || ne == ve) && V.cc.pop();
        }
      };
    }), l.registerHelper("wordChars", "javascript", /[\w$]/), l.defineMIME("text/javascript", "javascript"), l.defineMIME("text/ecmascript", "javascript"), l.defineMIME("application/javascript", "javascript"), l.defineMIME("application/x-javascript", "javascript"), l.defineMIME("application/ecmascript", "javascript"), l.defineMIME("application/json", { name: "javascript", json: !0 }), l.defineMIME("application/x-json", { name: "javascript", json: !0 }), l.defineMIME("application/manifest+json", { name: "javascript", json: !0 }), l.defineMIME("application/ld+json", { name: "javascript", jsonld: !0 }), l.defineMIME("text/typescript", { name: "javascript", typescript: !0 }), l.defineMIME("application/typescript", { name: "javascript", typescript: !0 });
  });
})();
(function(i, t) {
  (function(l) {
    l(_a());
  })(function(l) {
    var c = "CodeMirror-hint", M = "CodeMirror-hint-active";
    l.showHint = function(p, b, x) {
      if (!b) return p.showHint(x);
      x && x.async && (b.async = !0);
      var g = { hint: b };
      if (x) for (var _ in x) g[_] = x[_];
      return p.showHint(g);
    }, l.defineExtension("showHint", function(p) {
      p = W(this, this.getCursor("start"), p);
      var b = this.listSelections();
      if (!(b.length > 1)) {
        if (this.somethingSelected()) {
          if (!p.hint.supportsSelection) return;
          for (var x = 0; x < b.length; x++)
            if (b[x].head.line != b[x].anchor.line) return;
        }
        this.state.completionActive && this.state.completionActive.close();
        var g = this.state.completionActive = new T(this, p);
        g.options.hint && (l.signal(this, "startCompletion", this), g.update(!0));
      }
    }), l.defineExtension("closeHint", function() {
      this.state.completionActive && this.state.completionActive.close();
    });
    function T(p, b) {
      if (this.cm = p, this.options = b, this.widget = null, this.debounce = 0, this.tick = 0, this.startPos = this.cm.getCursor("start"), this.startLen = this.cm.getLine(this.startPos.line).length - this.cm.getSelection().length, this.options.updateOnCursorActivity) {
        var x = this;
        p.on("cursorActivity", this.activityFunc = function() {
          x.cursorActivity();
        });
      }
    }
    var F = window.requestAnimationFrame || function(p) {
      return setTimeout(p, 1e3 / 60);
    }, z = window.cancelAnimationFrame || clearTimeout;
    T.prototype = {
      close: function() {
        this.active() && (this.cm.state.completionActive = null, this.tick = null, this.options.updateOnCursorActivity && this.cm.off("cursorActivity", this.activityFunc), this.widget && this.data && l.signal(this.data, "close"), this.widget && this.widget.close(), l.signal(this.cm, "endCompletion", this.cm));
      },
      active: function() {
        return this.cm.state.completionActive == this;
      },
      pick: function(p, b) {
        var x = p.list[b], g = this;
        this.cm.operation(function() {
          x.hint ? x.hint(g.cm, p, x) : g.cm.replaceRange(
            K(x),
            x.from || p.from,
            x.to || p.to,
            "complete"
          ), l.signal(p, "pick", x), g.cm.scrollIntoView();
        }), this.options.closeOnPick && this.close();
      },
      cursorActivity: function() {
        this.debounce && (z(this.debounce), this.debounce = 0);
        var p = this.startPos;
        this.data && (p = this.data.from);
        var b = this.cm.getCursor(), x = this.cm.getLine(b.line);
        if (b.line != this.startPos.line || x.length - b.ch != this.startLen - this.startPos.ch || b.ch < p.ch || this.cm.somethingSelected() || !b.ch || this.options.closeCharacters.test(x.charAt(b.ch - 1)))
          this.close();
        else {
          var g = this;
          this.debounce = F(function() {
            g.update();
          }), this.widget && this.widget.disable();
        }
      },
      update: function(p) {
        if (this.tick != null) {
          var b = this, x = ++this.tick;
          u(this.options.hint, this.cm, this.options, function(g) {
            b.tick == x && b.finishUpdate(g, p);
          });
        }
      },
      finishUpdate: function(p, b) {
        this.data && l.signal(this.data, "update");
        var x = this.widget && this.widget.picked || b && this.options.completeSingle;
        this.widget && this.widget.close(), this.data = p, p && p.list.length && (x && p.list.length == 1 ? this.pick(p, 0) : (this.widget = new d(this, p), l.signal(p, "shown")));
      }
    };
    function W(p, b, x) {
      var g = p.options.hintOptions, _ = {};
      for (var A in C) _[A] = C[A];
      if (g) for (var A in g)
        g[A] !== void 0 && (_[A] = g[A]);
      if (x) for (var A in x)
        x[A] !== void 0 && (_[A] = x[A]);
      return _.hint.resolve && (_.hint = _.hint.resolve(p, b)), _;
    }
    function K(p) {
      return typeof p == "string" ? p : p.text;
    }
    function q(p, b) {
      var x = {
        Up: function() {
          b.moveFocus(-1);
        },
        Down: function() {
          b.moveFocus(1);
        },
        PageUp: function() {
          b.moveFocus(-b.menuSize() + 1, !0);
        },
        PageDown: function() {
          b.moveFocus(b.menuSize() - 1, !0);
        },
        Home: function() {
          b.setFocus(0);
        },
        End: function() {
          b.setFocus(b.length - 1);
        },
        Enter: b.pick,
        Tab: b.pick,
        Esc: b.close
      }, g = /Mac/.test(navigator.platform);
      g && (x["Ctrl-P"] = function() {
        b.moveFocus(-1);
      }, x["Ctrl-N"] = function() {
        b.moveFocus(1);
      });
      var _ = p.options.customKeys, A = _ ? {} : x;
      function f(k, L) {
        var h;
        typeof L != "string" ? h = function(E) {
          return L(E, b);
        } : x.hasOwnProperty(L) ? h = x[L] : h = L, A[k] = h;
      }
      if (_)
        for (var S in _) _.hasOwnProperty(S) && f(S, _[S]);
      var D = p.options.extraKeys;
      if (D)
        for (var S in D) D.hasOwnProperty(S) && f(S, D[S]);
      return A;
    }
    function m(p, b) {
      for (; b && b != p; ) {
        if (b.nodeName.toUpperCase() === "LI" && b.parentNode == p) return b;
        b = b.parentNode;
      }
    }
    function d(p, b) {
      this.completion = p, this.data = b, this.picked = !1;
      var x = this, g = p.cm, _ = g.getInputField().ownerDocument, A = _.defaultView || _.parentWindow, f = this.hints = _.createElement("ul"), S = p.cm.options.theme;
      f.className = "CodeMirror-hints " + S, this.selectedHint = b.selectedHint || 0;
      for (var D = b.list, k = 0; k < D.length; ++k) {
        var L = f.appendChild(_.createElement("li")), h = D[k], E = c + (k != this.selectedHint ? "" : " " + M);
        h.className != null && (E = h.className + " " + E), L.className = E, h.render ? h.render(L, b, h) : L.appendChild(_.createTextNode(h.displayText || K(h))), L.hintId = k;
      }
      var w = p.options.container || _.body, O = g.cursorCoords(p.options.alignWithWord ? b.from : null), R = O.left, I = O.bottom, H = !0, $ = 0, Q = 0;
      if (w !== _.body) {
        var U = ["absolute", "relative", "fixed"].indexOf(A.getComputedStyle(w).position) !== -1, Y = U ? w : w.offsetParent, X = Y.getBoundingClientRect(), G = _.body.getBoundingClientRect();
        $ = X.left - G.left - Y.scrollLeft, Q = X.top - G.top - Y.scrollTop;
      }
      f.style.left = R - $ + "px", f.style.top = I - Q + "px";
      var J = A.innerWidth || Math.max(_.body.offsetWidth, _.documentElement.offsetWidth), ee = A.innerHeight || Math.max(_.body.offsetHeight, _.documentElement.offsetHeight);
      w.appendChild(f);
      var re = p.options.moveOnOverlap ? f.getBoundingClientRect() : new DOMRect(), oe = p.options.paddingForScrollbar ? f.scrollHeight > f.clientHeight + 1 : !1, ae;
      setTimeout(function() {
        ae = g.getScrollInfo();
      });
      var se = re.bottom - ee;
      if (se > 0) {
        var ve = re.bottom - re.top, Ae = O.top - (O.bottom - re.top);
        if (Ae - ve > 0)
          f.style.top = (I = O.top - ve - Q) + "px", H = !1;
        else if (ve > ee) {
          f.style.height = ee - 5 + "px", f.style.top = (I = O.bottom - re.top - Q) + "px";
          var ye = g.getCursor();
          b.from.ch != ye.ch && (O = g.cursorCoords(ye), f.style.left = (R = O.left - $) + "px", re = f.getBoundingClientRect());
        }
      }
      var ce = re.right - J;
      if (ce > 0 && (re.right - re.left > J && (f.style.width = J - 5 + "px", ce -= re.right - re.left - J), f.style.left = (R = O.left - ce - $) + "px"), oe) for (var he = f.firstChild; he; he = he.nextSibling)
        he.style.paddingRight = g.display.nativeBarWidth + "px";
      if (g.addKeyMap(this.keyMap = q(p, {
        moveFocus: function(He, Ve) {
          x.changeActive(x.selectedHint + He, Ve);
        },
        setFocus: function(He) {
          x.changeActive(He);
        },
        menuSize: function() {
          return x.screenAmount();
        },
        length: D.length,
        close: function() {
          p.close();
        },
        pick: function() {
          x.pick();
        },
        data: b
      })), p.options.closeOnUnfocus) {
        var ke;
        g.on("blur", this.onBlur = function() {
          ke = setTimeout(function() {
            p.close();
          }, 100);
        }), g.on("focus", this.onFocus = function() {
          clearTimeout(ke);
        });
      }
      g.on("scroll", this.onScroll = function() {
        var He = g.getScrollInfo(), Ve = g.getWrapperElement().getBoundingClientRect(), qt = I + ae.top - He.top, ln = qt - (A.pageYOffset || (_.documentElement || _.body).scrollTop);
        if (H || (ln += f.offsetHeight), ln <= Ve.top || ln >= Ve.bottom) return p.close();
        f.style.top = qt + "px", f.style.left = R + ae.left - He.left + "px";
      }), l.on(f, "dblclick", function(He) {
        var Ve = m(f, He.target || He.srcElement);
        Ve && Ve.hintId != null && (x.changeActive(Ve.hintId), x.pick());
      }), l.on(f, "click", function(He) {
        var Ve = m(f, He.target || He.srcElement);
        Ve && Ve.hintId != null && (x.changeActive(Ve.hintId), p.options.completeOnSingleClick && x.pick());
      }), l.on(f, "mousedown", function() {
        setTimeout(function() {
          g.focus();
        }, 20);
      });
      var je = this.getSelectedHintRange();
      return (je.from !== 0 || je.to !== 0) && this.scrollToActive(), l.signal(b, "select", D[this.selectedHint], f.childNodes[this.selectedHint]), !0;
    }
    d.prototype = {
      close: function() {
        if (this.completion.widget == this) {
          this.completion.widget = null, this.hints.parentNode && this.hints.parentNode.removeChild(this.hints), this.completion.cm.removeKeyMap(this.keyMap);
          var p = this.completion.cm;
          this.completion.options.closeOnUnfocus && (p.off("blur", this.onBlur), p.off("focus", this.onFocus)), p.off("scroll", this.onScroll);
        }
      },
      disable: function() {
        this.completion.cm.removeKeyMap(this.keyMap);
        var p = this;
        this.keyMap = { Enter: function() {
          p.picked = !0;
        } }, this.completion.cm.addKeyMap(this.keyMap);
      },
      pick: function() {
        this.completion.pick(this.data, this.selectedHint);
      },
      changeActive: function(p, b) {
        if (p >= this.data.list.length ? p = b ? this.data.list.length - 1 : 0 : p < 0 && (p = b ? 0 : this.data.list.length - 1), this.selectedHint != p) {
          var x = this.hints.childNodes[this.selectedHint];
          x && (x.className = x.className.replace(" " + M, "")), x = this.hints.childNodes[this.selectedHint = p], x.className += " " + M, this.scrollToActive(), l.signal(this.data, "select", this.data.list[this.selectedHint], x);
        }
      },
      scrollToActive: function() {
        var p = this.getSelectedHintRange(), b = this.hints.childNodes[p.from], x = this.hints.childNodes[p.to], g = this.hints.firstChild;
        b.offsetTop < this.hints.scrollTop ? this.hints.scrollTop = b.offsetTop - g.offsetTop : x.offsetTop + x.offsetHeight > this.hints.scrollTop + this.hints.clientHeight && (this.hints.scrollTop = x.offsetTop + x.offsetHeight - this.hints.clientHeight + g.offsetTop);
      },
      screenAmount: function() {
        return Math.floor(this.hints.clientHeight / this.hints.firstChild.offsetHeight) || 1;
      },
      getSelectedHintRange: function() {
        var p = this.completion.options.scrollMargin || 0;
        return {
          from: Math.max(0, this.selectedHint - p),
          to: Math.min(this.data.list.length - 1, this.selectedHint + p)
        };
      }
    };
    function r(p, b) {
      if (!p.somethingSelected()) return b;
      for (var x = [], g = 0; g < b.length; g++)
        b[g].supportsSelection && x.push(b[g]);
      return x;
    }
    function u(p, b, x, g) {
      if (p.async)
        p(b, g, x);
      else {
        var _ = p(b, x);
        _ && _.then ? _.then(g) : g(_);
      }
    }
    function v(p, b) {
      var x = p.getHelpers(b, "hint"), g;
      if (x.length) {
        var _ = function(A, f, S) {
          var D = r(A, x);
          function k(L) {
            if (L == D.length) return f(null);
            u(D[L], A, S, function(h) {
              h && h.list.length > 0 ? f(h) : k(L + 1);
            });
          }
          k(0);
        };
        return _.async = !0, _.supportsSelection = !0, _;
      } else return (g = p.getHelper(p.getCursor(), "hintWords")) ? function(A) {
        return l.hint.fromList(A, { words: g });
      } : l.hint.anyword ? function(A, f) {
        return l.hint.anyword(A, f);
      } : function() {
      };
    }
    l.registerHelper("hint", "auto", {
      resolve: v
    }), l.registerHelper("hint", "fromList", function(p, b) {
      var x = p.getCursor(), g = p.getTokenAt(x), _, A = l.Pos(x.line, g.start), f = x;
      g.start < x.ch && /\w/.test(g.string.charAt(x.ch - g.start - 1)) ? _ = g.string.substr(0, x.ch - g.start) : (_ = "", A = x);
      for (var S = [], D = 0; D < b.words.length; D++) {
        var k = b.words[D];
        k.slice(0, _.length) == _ && S.push(k);
      }
      if (S.length) return { list: S, from: A, to: f };
    }), l.commands.autocomplete = l.showHint;
    var C = {
      hint: l.hint.auto,
      completeSingle: !0,
      alignWithWord: !0,
      closeCharacters: /[\s()\[\]{};:>,]/,
      closeOnPick: !0,
      closeOnUnfocus: !0,
      updateOnCursorActivity: !0,
      completeOnSingleClick: !0,
      container: null,
      customKeys: null,
      extraKeys: null,
      paddingForScrollbar: !0,
      moveOnOverlap: !0
    };
    l.defineOption("hintOptions", null);
  });
})();
(function(i, t) {
  (function(l) {
    l(_a());
  })(function(l) {
    var c = l.Pos;
    function M(p, b) {
      for (var x = 0, g = p.length; x < g; ++x) b(p[x]);
    }
    function T(p, b) {
      if (!Array.prototype.indexOf) {
        for (var x = p.length; x--; )
          if (p[x] === b)
            return !0;
        return !1;
      }
      return p.indexOf(b) != -1;
    }
    function F(p, b, x, g) {
      var _ = p.getCursor(), A = x(p, _);
      if (!/\b(?:string|comment)\b/.test(A.type)) {
        var f = l.innerMode(p.getMode(), A.state);
        if (f.mode.helperType !== "json") {
          A.state = f.state, /^[\w$_]*$/.test(A.string) ? A.end > _.ch && (A.end = _.ch, A.string = A.string.slice(0, _.ch - A.start)) : A = {
            start: _.ch,
            end: _.ch,
            string: "",
            state: A.state,
            type: A.string == "." ? "property" : null
          };
          for (var S = A; S.type == "property"; ) {
            if (S = x(p, c(_.line, S.start)), S.string != ".") return;
            if (S = x(p, c(_.line, S.start)), !D) var D = [];
            D.push(S);
          }
          return {
            list: C(A, D, b, g),
            from: c(_.line, A.start),
            to: c(_.line, A.end)
          };
        }
      }
    }
    function z(p, b) {
      return F(
        p,
        r,
        function(x, g) {
          return x.getTokenAt(g);
        },
        b
      );
    }
    l.registerHelper("hint", "javascript", z);
    function W(p, b) {
      var x = p.getTokenAt(b);
      return b.ch == x.start + 1 && x.string.charAt(0) == "." ? (x.end = x.start, x.string = ".", x.type = "property") : /^\.[\w$_]*$/.test(x.string) && (x.type = "property", x.start++, x.string = x.string.replace(/\./, "")), x;
    }
    function K(p, b) {
      return F(p, u, W, b);
    }
    l.registerHelper("hint", "coffeescript", K);
    var q = "charAt charCodeAt indexOf lastIndexOf substring substr slice trim trimLeft trimRight toUpperCase toLowerCase split concat match replace search".split(" "), m = "length concat join splice push pop shift unshift slice reverse sort indexOf lastIndexOf every some filter forEach map reduce reduceRight ".split(" "), d = "prototype apply call bind".split(" "), r = "break case catch class const continue debugger default delete do else export extends false finally for function if in import instanceof new null return super switch this throw true try typeof var void while with yield".split(" "), u = "and break catch class continue delete do else extends false finally for if in instanceof isnt new no not null of off on or return switch then throw true try typeof until void while with yes".split(" ");
    function v(p, b) {
      if (!Object.getOwnPropertyNames || !Object.getPrototypeOf)
        for (var x in p) b(x);
      else
        for (var g = p; g; g = Object.getPrototypeOf(g))
          Object.getOwnPropertyNames(g).forEach(b);
    }
    function C(p, b, x, g) {
      var _ = [], A = p.string, f = g && g.globalScope || window;
      function S(O) {
        O.lastIndexOf(A, 0) == 0 && !T(_, O) && _.push(O);
      }
      function D(O) {
        typeof O == "string" ? M(q, S) : O instanceof Array ? M(m, S) : O instanceof Function && M(d, S), v(O, S);
      }
      if (b && b.length) {
        var k = b.pop(), L;
        for (k.type && k.type.indexOf("variable") === 0 ? (g && g.additionalContext && (L = g.additionalContext[k.string]), (!g || g.useGlobalScope !== !1) && (L = L || f[k.string])) : k.type == "string" ? L = "" : k.type == "atom" ? L = 1 : k.type == "function" && (f.jQuery != null && (k.string == "$" || k.string == "jQuery") && typeof f.jQuery == "function" ? L = f.jQuery() : f._ != null && k.string == "_" && typeof f._ == "function" && (L = f._())); L != null && b.length; )
          L = L[b.pop().string];
        L != null && D(L);
      } else {
        for (var h = p.state.localVars; h; h = h.next) S(h.name);
        for (var E = p.state.context; E; E = E.prev)
          for (var h = E.vars; h; h = h.next) S(h.name);
        for (var h = p.state.globalVars; h; h = h.next) S(h.name);
        if (g && g.additionalContext != null)
          for (var w in g.additionalContext)
            S(w);
        (!g || g.useGlobalScope !== !1) && D(f), M(x, S);
      }
      return _;
    }
  });
})();
function lt(i, t, l, c, M, T, F, z) {
  var W = typeof i == "function" ? i.options : i;
  return t && (W.render = t, W.staticRenderFns = l, W._compiled = !0), T && (W._scopeId = "data-v-" + T), {
    exports: i,
    options: W
  };
}
const Xg = "[[FORM-CREATE-PREFIX-", Jg = "-FORM-CREATE-SUFFIX]]", qg = ft({
  name: "FnEditor",
  emits: ["input", "change"],
  props: {
    value: [String, Function],
    name: String,
    args: Array,
    body: Boolean,
    button: Boolean,
    fnx: Boolean
  },
  inject: ["designer"],
  data() {
    return {
      editor: null,
      fn: "",
      visible: !1,
      formValue: ""
    };
  },
  watch: {
    value(i) {
      i != this.formValue && (!i || !i.__json || i.__json && i.__json != this.formValue) && this.editor && this.editor.setValue(this.tidyValue());
    }
  },
  computed: {
    t() {
      return this.designer.t;
    },
    argStr() {
      return (this.args || []).map((i) => typeof i == "string" ? i : i.name).join(", ");
    },
    argList() {
      return this.args.map((i) => typeof i == "string" ? {
        name: i,
        type: "string"
      } : i);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.load();
    });
  },
  methods: {
    save() {
      const i = this.editor.getValue() || "";
      if (i.trim() === "")
        this.fn = "";
      else {
        let t;
        try {
          t = new Function("return function " + this.name + "(" + this.argStr + "){" + i + "}")();
        } catch (l) {
          return console.error(l), On(this.t("struct.errorMsg")), !1;
        }
        this.body ? this.fn = (this.fnx ? "$FNX:" : "") + i : this.fn = Xg + t + Jg;
      }
      return this.submit(), !0;
    },
    submit() {
      this.$emit("input", this.fn), this.$emit("change", this.fn), this.formValue = this.fn, this.visible = !1;
    },
    trimString(i) {
      const t = i.indexOf("{"), l = i.lastIndexOf("}");
      return t === -1 || l === -1 || t >= l ? i : i.slice(t + 1, l).replace(/^\n+|\n+$/g, "");
    },
    tidyValue() {
      let i = this.value || "";
      return i.__json && (i = i.__json), this.fnx && i.indexOf("$FNX:") === 0 && (i = i.slice(5)), typeof i == "function" ? i = this.trimString(Ar(i)).trim() : this.body || (i = this.trimString(i).trim()), this.formValue = i, i;
    },
    load() {
      this.$nextTick(() => {
        let i = this.tidyValue();
        this.editor = mi(gi(this.$refs.editor, {
          lineNumbers: !0,
          mode: { name: "javascript", globalVars: !0 },
          extraKeys: { "Ctrl-Space": "autocomplete" },
          line: !0,
          tabSize: 2,
          lineWrapping: !0,
          value: i
        })), this.editor.on("inputRead", (t, l) => {
          l.keyCode === 32 && l.ctrlKey && gi.showHint(t, gi.hint.javascript);
        }), this.editor.on("change", () => {
          this.visible = !0;
        }), this.editor;
      });
    }
  }
});
var Zg = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_fd-fn" }, [l("div", { staticClass: "_fd-fn-tip" }, [l("div", { staticClass: "_fd-fn-ind" }), l("div", { staticClass: "cm-keyword" }, [l("span", [t._v("function " + t._s(t.name) + "("), t._l(t.argList, function(c, M) {
    return [t._v(t._s(M > 0 ? ", " : "")), c.type === "string" ? [l("span", [t._v(t._s(c.name))])] : [l("el-popover", { attrs: { placement: "top-start", width: 400, trigger: "click", title: c.name, content: c.info || "" }, scopedSlots: t._u([{ key: "reference", fn: function() {
      return [l("span", { staticClass: "_fd-fn-arg" }, [t._v(t._s(c.name)), l("i", { staticClass: "fc-icon icon-question" })])];
    }, proxy: !0 }], null, !0) }, [c.columns ? [l("el-table", { attrs: { data: c.columns, border: "" } }, [l("el-table-column", { attrs: { width: "120", property: "label", label: t.t("event.label") } }), l("el-table-column", { attrs: { property: "info", label: t.t("event.info") } }), l("el-table-column", { attrs: { width: "80", property: "type", label: t.t("event.type") } })], 1)] : t._e()], 2)]];
  }), t._v(") {")], 2)])]), l("div", { ref: "editor", staticClass: "_fd-fn-editor" }), t._m(0), t.visible && t.button ? l("el-button", { attrs: { type: "primary", size: "mini" }, on: { click: t.save } }, [t._v(t._s(t.t("props.save")))]) : t._e()], 1);
}, em = [function() {
  var i = this, t = i._self._c;
  return i._self._setupProxy, t("div", { staticClass: "_fd-fn-tip" }, [t("div", { staticClass: "_fd-fn-ind" }), t("div", { staticClass: "cm-keyword" }, [i._v("}")])]);
}], tm = /* @__PURE__ */ lt(
  qg,
  Zg,
  em,
  !1,
  null,
  null
);
const mo = tm.exports, hi = "$FNX:", oa = (i) => at.String(i) && i.indexOf(hi) === 0, nm = ft({
  name: "EventConfig",
  emits: ["input"],
  props: {
    value: [Object, void 0, null],
    componentName: "",
    eventName: {
      type: Array,
      default: () => []
    }
  },
  inject: ["designer"],
  components: {
    FnEditor: mo
  },
  data() {
    return {
      visible: !1,
      activeData: null,
      val: null,
      defActive: "no",
      event: {},
      cus: !1,
      cusValue: "",
      eventStr: ""
    };
  },
  computed: {
    t() {
      return this.designer.t;
    },
    eventNum() {
      let i = 0;
      return Object.keys(this.value || {}).forEach((t) => {
        i += Array.isArray(this.value[t]) ? this.value[t].length : 1;
      }), i;
    },
    fnArgs() {
      return [Lf(this.t)];
    }
  },
  watch: {
    visible(i) {
      this.event = i ? this.loadFN(ba({}, this.value || {})) : {}, i || (this.destroy(), this.closeCus());
    }
  },
  methods: {
    addCus() {
      const i = this.cusValue && this.cusValue.trim();
      i && (this.closeCus(), this.add(i));
    },
    closeCus() {
      this.cus = !1, this.cusValue = "";
    },
    cusEvent() {
      this.cus = !0;
    },
    loadFN(i) {
      const t = {};
      return Object.keys(i).forEach((l) => {
        if (Array.isArray(i[l])) {
          const c = [];
          i[l].forEach((M) => {
            oa(M) ? c.push(M.replace(hi, "")) : at.Function(M) && oa(M.__json) ? c.push(M.__json.replace(hi, "")) : M && M.indexOf("$GLOBAL:") === 0 && c.push(M);
          }), t[l] = c;
        } else oa(i[l]) ? t[l] = [i[l].replace(hi, "")] : at.Function(i[l]) && oa(i[l].__json) ? t[l] = [i[l].__json.replace(hi, "")] : i[l] && i[l].indexOf("$GLOBAL:") === 0 && (t[l] = [i[l]]);
      }), t;
    },
    parseFN(i) {
      const t = {};
      return Object.keys(i).forEach((l) => {
        const c = [];
        i[l].forEach((M, T) => {
          c[T] = M.indexOf("$GLOBAL:") !== 0 ? hi + M : M;
        }), c.length > 0 && (t[l] = c.length === 1 ? c[0] : c);
      }), t;
    },
    add(i) {
      if (!i)
        return this.cusEvent();
      let t = {};
      if (Array.isArray(this.event[i]))
        this.event[i].push(""), t = {
          name: i,
          item: this.event[i],
          index: this.event[i].length - 1
        };
      else if (this.event[i]) {
        const l = [this.event[i], ""];
        this.$set(this.event, i, l), t = {
          name: i,
          item: l,
          index: 1
        };
      } else {
        const l = [""];
        this.$set(this.event, i, l), t = {
          name: i,
          item: l,
          index: 0
        };
      }
      this.activeData || this.edit(t);
    },
    edit(i) {
      i.key = Je(), i.item ? this.val = i.item[i.index] : this.val = this.event[i.name], this.activeData = i, this.eventStr = this.val, this.defActive = i.name + (i.index || 0);
    },
    save() {
      if (!this.$refs.fn.save())
        return;
      const i = this.eventStr;
      this.activeData.item ? this.activeData.item[this.activeData.index] = i : this.event[this.activeData.name] = i, this.destroy();
    },
    rm(i) {
      i.index !== void 0 ? i.item.splice(i.index, 1) : this.$delete(this.event, i.name), this.defActive === i.name + (i.index || 0) && this.destroy();
    },
    destroy() {
      this.activeData = null, this.val = null, this.defActive = "no";
    },
    close() {
      this.destroy();
    },
    submit() {
      if (this.activeData)
        return On(this.t("event.saveMsg"));
      this.$emit("input", this.parseFN(this.event)), this.visible = !1, this.destroy(), this.closeCus();
    }
  },
  beforeCreate() {
    window.$inject = {
      $f: {},
      rule: [],
      self: {},
      option: {},
      inject: {},
      args: []
    };
  }
});
var rm = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_fd-event" }, [l("el-badge", { attrs: { value: t.eventNum, type: "warning", hidden: t.eventNum < 1 } }, [l("el-button", { attrs: { size: "mini" }, on: { click: function(c) {
    t.visible = !0;
  } } }, [t._v(t._s(t.t("event.title")))])], 1), l("el-dialog", { staticClass: "_fd-event-dialog", attrs: { title: t.t("event.title"), visible: t.visible, "close-on-click-modal": !1, "append-to-body": "", width: "980px" }, on: { "update:visible": function(c) {
    t.visible = c;
  } }, scopedSlots: t._u([{ key: "footer", fn: function() {
    return [l("div", [l("el-button", { attrs: { size: "small" }, on: { click: function(c) {
      t.visible = !1;
    } } }, [t._v(t._s(t.t("props.cancel")))]), l("el-button", { attrs: { type: "primary", size: "small", color: "#2f73ff" }, on: { click: t.submit } }, [t._v(t._s(t.t("props.ok")) + " ")])], 1)];
  }, proxy: !0 }]) }, [l("el-container", { staticClass: "_fd-event-con", staticStyle: { height: "600px" } }, [l("el-aside", { staticStyle: { width: "300px" } }, [l("el-container", { staticClass: "_fd-event-l" }, [l("el-header", { staticClass: "_fd-event-head", attrs: { height: "40px" } }, [l("el-dropdown", { attrs: { "popper-class": "_fd-event-dropdown", trigger: "click", size: "default", placement: "bottom-start" }, on: { command: t.add }, scopedSlots: t._u([{ key: "dropdown", fn: function() {
    return [l("el-dropdown-menu", [t._l(t.eventName, function(c) {
      return l("el-dropdown-item", { key: c, attrs: { command: c } }, [l("div", { staticClass: "_fd-event-item" }, [l("span", [t._v(t._s(c))])])]);
    }), l("el-dropdown-item", { attrs: { command: "", divided: t.eventName.length > 0 } }, [l("div", [t._v(t._s(t.t("props.custom")))])])], 2)];
  }, proxy: !0 }]) }, [l("el-button", { attrs: { type: "text", size: "default" } }, [t._v(" " + t._s(t.t("event.create"))), l("i", { staticClass: "el-icon-arrow-down el-icon--right" })])], 1)], 1), l("el-main", [l("el-menu", { attrs: { "default-active": t.defActive }, model: { value: t.activeData, callback: function(c) {
    t.activeData = c;
  }, expression: "activeData" } }, [t._l(t.event, function(c, M) {
    return [Array.isArray(c) ? [t._l(c, function(T, F) {
      return [l("el-menu-item", { key: M + F, attrs: { index: M + F } }, [l("div", { staticClass: "_fd-event-title", on: { click: function(z) {
        return z.stopPropagation(), t.edit({ name: M, item: c, index: F });
      } } }, [l("div", { staticClass: "_fd-event-method" }, [l("span", [t._v("function"), l("span", [t._v(t._s(M))])])]), l("i", { staticClass: "fc-icon icon-delete", on: { click: function(z) {
        return z.stopPropagation(), t.rm({ name: M, item: c, index: F });
      } } })])])];
    })] : l("el-menu-item", { key: M, attrs: { index: M + 0 } }, [l("div", { staticClass: "_fd-event-title", on: { click: function(T) {
      return T.stopPropagation(), t.edit({ name: M });
    } } }, [l("div", { staticClass: "_fd-event-method" }, [l("span", [t._v("function"), l("span", [t._v(t._s(M))])])]), l("i", { staticClass: "fc-icon icon-delete", on: { click: function(T) {
      return T.stopPropagation(), t.rm({ name: M });
    } } })])])];
  }), t.cus ? l("el-menu-item", { staticStyle: { "padding-left": "10px" }, attrs: { index: "custom" } }, [l("div", { staticClass: "_fd-event-title", on: { click: function(c) {
    c.stopPropagation();
  } } }, [l("el-input", { attrs: { type: "text", size: "default", placeholder: t.t("event.placeholder") }, on: { keydown: function(c) {
    return !c.type.indexOf("key") && t._k(c.keyCode, "enter", 13, c.key, "Enter") ? null : t.addCus.apply(null, arguments);
  } }, model: { value: t.cusValue, callback: function(c) {
    t.cusValue = c;
  }, expression: "cusValue" } }), l("div", [l("i", { staticClass: "fc-icon icon-add", on: { click: function(c) {
    return c.stopPropagation(), t.addCus.apply(null, arguments);
  } } }), l("i", { staticClass: "fc-icon icon-delete", on: { click: function(c) {
    return c.stopPropagation(), t.closeCus.apply(null, arguments);
  } } })])], 1)]) : t._e()], 2)], 1)], 1)], 1), l("el-main", [l("el-container", { staticClass: "_fd-event-r" }, [t.activeData ? l("el-header", { staticClass: "_fd-event-head", attrs: { height: "40px" } }, [l("div", [l("a", { attrs: { target: "_blank", href: "https://form-create.com/v3/instance/" } }, [t._v(t._s(t.t("form.document")))])]), l("div", [l("el-button", { attrs: { size: "mini" }, on: { click: t.close } }, [t._v(t._s(t.t("props.cancel")))]), l("el-button", { attrs: { size: "mini", type: "primary", color: "#2f73ff" }, on: { click: t.save } }, [t._v(t._s(t.t("props.save")) + " ")])], 1)]) : t._e(), t.activeData ? l("el-main", [l("FnEditor", { ref: "fn", staticStyle: { height: "519px" }, attrs: { body: "", name: t.activeData.name, args: t.fnArgs }, model: { value: t.eventStr, callback: function(c) {
    t.eventStr = c;
  }, expression: "eventStr" } })], 1) : t._e()], 1)], 1)], 1)], 1)], 1);
}, im = [], om = /* @__PURE__ */ lt(
  nm,
  rm,
  im,
  !1,
  null,
  null
);
const td = om.exports;
function am(i, t) {
  var l = null;
  return function(...c) {
    l !== null && clearTimeout(l), l = setTimeout(() => i.call(this, ...c), t);
  };
}
/*!
  Highlight.js v11.9.0 (git: b7ec4bfafc)
  (c) 2006-2024 undefined and other contributors
  License: BSD-3-Clause
 */
function nd(i) {
  return i instanceof Map ? i.clear = i.delete = i.set = () => {
    throw Error("map is read-only");
  } : i instanceof Set && (i.add = i.clear = i.delete = () => {
    throw Error("set is read-only");
  }), Object.freeze(i), Object.getOwnPropertyNames(i).forEach((t) => {
    const l = i[t], c = typeof l;
    c !== "object" && c !== "function" || Object.isFrozen(l) || nd(l);
  }), i;
}
class gf {
  constructor(t) {
    t.data === void 0 && (t.data = {}), this.data = t.data, this.isMatchIgnored = !1;
  }
  ignoreMatch() {
    this.isMatchIgnored = !0;
  }
}
function rd(i) {
  return i.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
}
function yr(i, ...t) {
  const l = /* @__PURE__ */ Object.create(null);
  for (const c in i) l[c] = i[c];
  return t.forEach((c) => {
    for (const M in c) l[M] = c[M];
  }), l;
}
const mf = (i) => !!i.scope;
class lm {
  constructor(t, l) {
    this.buffer = "", this.classPrefix = l.classPrefix, t.walk(this);
  }
  addText(t) {
    this.buffer += rd(t);
  }
  openNode(t) {
    if (!mf(t)) return;
    const l = ((c, { prefix: M }) => {
      if (c.startsWith("language:")) return c.replace("language:", "language-");
      if (c.includes(".")) {
        const T = c.split(".");
        return [`${M}${T.shift()}`, ...T.map((F, z) => `${F}${"_".repeat(z + 1)}`)].join(" ");
      }
      return `${M}${c}`;
    })(t.scope, { prefix: this.classPrefix });
    this.span(l);
  }
  closeNode(t) {
    mf(t) && (this.buffer += "</span>");
  }
  value() {
    return this.buffer;
  }
  span(t) {
    this.buffer += `<span class="${t}">`;
  }
}
const yf = (i = {}) => {
  const t = { children: [] };
  return Object.assign(t, i), t;
};
class Ds {
  constructor() {
    this.rootNode = yf(), this.stack = [this.rootNode];
  }
  get top() {
    return this.stack[this.stack.length - 1];
  }
  get root() {
    return this.rootNode;
  }
  add(t) {
    this.top.children.push(t);
  }
  openNode(t) {
    const l = yf({ scope: t });
    this.add(l), this.stack.push(l);
  }
  closeNode() {
    if (this.stack.length > 1) return this.stack.pop();
  }
  closeAllNodes() {
    for (; this.closeNode(); ) ;
  }
  toJSON() {
    return JSON.stringify(this.rootNode, null, 4);
  }
  walk(t) {
    return this.constructor._walk(t, this.rootNode);
  }
  static _walk(t, l) {
    return typeof l == "string" ? t.addText(l) : l.children && (t.openNode(l), l.children.forEach((c) => this._walk(t, c)), t.closeNode(l)), t;
  }
  static _collapse(t) {
    typeof t != "string" && t.children && (t.children.every((l) => typeof l == "string") ? t.children = [t.children.join("")] : t.children.forEach((l) => {
      Ds._collapse(l);
    }));
  }
}
class sm extends Ds {
  constructor(t) {
    super(), this.options = t;
  }
  addText(t) {
    t !== "" && this.add(t);
  }
  startScope(t) {
    this.openNode(t);
  }
  endScope() {
    this.closeNode();
  }
  __addSublanguage(t, l) {
    const c = t.root;
    l && (c.scope = "language:" + l), this.add(c);
  }
  toHTML() {
    return new lm(this, this.options).value();
  }
  finalize() {
    return this.closeAllNodes(), !0;
  }
}
function ho(i) {
  return i ? typeof i == "string" ? i : i.source : null;
}
function id(i) {
  return $r("(?=", i, ")");
}
function um(i) {
  return $r("(?:", i, ")*");
}
function cm(i) {
  return $r("(?:", i, ")?");
}
function $r(...i) {
  return i.map((t) => ho(t)).join("");
}
function Ms(...i) {
  return "(" + (((l) => {
    const c = l[l.length - 1];
    return typeof c == "object" && c.constructor === Object ? (l.splice(l.length - 1, 1), c) : {};
  })(i).capture ? "" : "?:") + i.map((l) => ho(l)).join("|") + ")";
}
function od(i) {
  return RegExp(i.toString() + "|").exec("").length - 1;
}
const fm = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
function As(i, { joinWith: t }) {
  let l = 0;
  return i.map((c) => {
    l += 1;
    const M = l;
    let T = ho(c), F = "";
    for (; T.length > 0; ) {
      const z = fm.exec(T);
      if (!z) {
        F += T;
        break;
      }
      F += T.substring(0, z.index), T = T.substring(z.index + z[0].length), z[0][0] === "\\" && z[1] ? F += "\\" + (Number(z[1]) + M) : (F += z[0], z[0] === "(" && l++);
    }
    return F;
  }).map((c) => `(${c})`).join(t);
}
const bf = "[a-zA-Z]\\w*", us = "[a-zA-Z_]\\w*", Af = "\\b\\d+(\\.\\d+)?", xf = "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)", wf = "\\b(0b[01]+)", fo = {
  begin: "\\\\[\\s\\S]",
  relevance: 0
}, dm = {
  scope: "string",
  begin: "'",
  end: "'",
  illegal: "\\n",
  contains: [fo]
}, pm = {
  scope: "string",
  begin: '"',
  end: '"',
  illegal: "\\n",
  contains: [fo]
}, Ca = (i, t, l = {}) => {
  const c = yr({
    scope: "comment",
    begin: i,
    end: t,
    contains: []
  }, l);
  c.contains.push({
    scope: "doctag",
    begin: "[ ]*(?=(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):)",
    end: /(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):/,
    excludeBegin: !0,
    relevance: 0
  });
  const M = Ms("I", "a", "is", "so", "us", "to", "at", "if", "in", "it", "on", /[A-Za-z]+['](d|ve|re|ll|t|s|n)/, /[A-Za-z]+[-][a-z]+/, /[A-Za-z][a-z]{2,}/);
  return c.contains.push({ begin: $r(/[ ]+/, "(", M, /[.]?[:]?([.][ ]|[ ])/, "){3}") }), c;
}, hm = Ca("//", "$"), vm = Ca("/\\*", "\\*/"), gm = Ca("#", "$");
var aa = Object.freeze({
  __proto__: null,
  APOS_STRING_MODE: dm,
  BACKSLASH_ESCAPE: fo,
  BINARY_NUMBER_MODE: {
    scope: "number",
    begin: wf,
    relevance: 0
  },
  BINARY_NUMBER_RE: wf,
  COMMENT: Ca,
  C_BLOCK_COMMENT_MODE: vm,
  C_LINE_COMMENT_MODE: hm,
  C_NUMBER_MODE: {
    scope: "number",
    begin: xf,
    relevance: 0
  },
  C_NUMBER_RE: xf,
  END_SAME_AS_BEGIN: (i) => Object.assign(i, {
    "on:begin": (t, l) => {
      l.data._beginMatch = t[1];
    },
    "on:end": (t, l) => {
      l.data._beginMatch !== t[1] && l.ignoreMatch();
    }
  }),
  HASH_COMMENT_MODE: gm,
  IDENT_RE: bf,
  MATCH_NOTHING_RE: /\b\B/,
  METHOD_GUARD: { begin: "\\.\\s*" + us, relevance: 0 },
  NUMBER_MODE: { scope: "number", begin: Af, relevance: 0 },
  NUMBER_RE: Af,
  PHRASAL_WORDS_MODE: {
    begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
  },
  QUOTE_STRING_MODE: pm,
  REGEXP_MODE: {
    scope: "regexp",
    begin: /\/(?=[^/\n]*\/)/,
    end: /\/[gimuy]*/,
    contains: [fo, { begin: /\[/, end: /\]/, relevance: 0, contains: [fo] }]
  },
  RE_STARTERS_RE: "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~",
  SHEBANG: (i = {}) => {
    const t = /^#![ ]*\//;
    return i.binary && (i.begin = $r(t, /.*\b/, i.binary, /\b.*/)), yr({
      scope: "meta",
      begin: t,
      end: /$/,
      relevance: 0,
      "on:begin": (l, c) => {
        l.index !== 0 && c.ignoreMatch();
      }
    }, i);
  },
  TITLE_MODE: { scope: "title", begin: bf, relevance: 0 },
  UNDERSCORE_IDENT_RE: us,
  UNDERSCORE_TITLE_MODE: { scope: "title", begin: us, relevance: 0 }
});
function mm(i, t) {
  i.input[i.index - 1] === "." && t.ignoreMatch();
}
function ym(i, t) {
  i.className !== void 0 && (i.scope = i.className, delete i.className);
}
function bm(i, t) {
  t && i.beginKeywords && (i.begin = "\\b(" + i.beginKeywords.split(" ").join("|") + ")(?!\\.)(?=\\b|\\s)", i.__beforeBegin = mm, i.keywords = i.keywords || i.beginKeywords, delete i.beginKeywords, i.relevance === void 0 && (i.relevance = 0));
}
function Am(i, t) {
  Array.isArray(i.illegal) && (i.illegal = Ms(...i.illegal));
}
function xm(i, t) {
  if (i.match) {
    if (i.begin || i.end) throw Error("begin & end are not supported with match");
    i.begin = i.match, delete i.match;
  }
}
function wm(i, t) {
  i.relevance === void 0 && (i.relevance = 1);
}
const _m = (i, t) => {
  if (!i.beforeMatch) return;
  if (i.starts) throw Error("beforeMatch cannot be used with starts");
  const l = Object.assign({}, i);
  Object.keys(i).forEach((c) => {
    delete i[c];
  }), i.keywords = l.keywords, i.begin = $r(l.beforeMatch, id(l.begin)), i.starts = {
    relevance: 0,
    contains: [Object.assign(l, { endsParent: !0 })]
  }, i.relevance = 0, delete l.beforeMatch;
}, Cm = ["of", "and", "for", "in", "not", "or", "if", "then", "parent", "list", "value"], Sm = "keyword";
function ad(i, t, l = Sm) {
  const c = /* @__PURE__ */ Object.create(null);
  return typeof i == "string" ? M(l, i.split(" ")) : Array.isArray(i) ? M(l, i) : Object.keys(i).forEach((T) => {
    Object.assign(c, ad(i[T], t, T));
  }), c;
  function M(T, F) {
    t && (F = F.map((z) => z.toLowerCase())), F.forEach((z) => {
      const W = z.split("|");
      c[W[0]] = [T, Em(W[0], W[1])];
    });
  }
}
function Em(i, t) {
  return t ? Number(t) : ((l) => Cm.includes(l.toLowerCase()))(i) ? 0 : 1;
}
const _f = {}, Pr = (i) => {
  console.error(i);
}, Cf = (i, ...t) => {
  console.log("WARN: " + i, ...t);
}, di = (i, t) => {
  _f[`${i}/${t}`] || (console.log(`Deprecated as of ${i}. ${t}`), _f[`${i}/${t}`] = !0);
}, la = Error();
function Sf(i, t, { key: l }) {
  let c = 0;
  const M = i[l], T = {}, F = {};
  for (let z = 1; z <= t.length; z++) F[z + c] = M[z], T[z + c] = !0, c += od(t[z - 1]);
  i[l] = F, i[l]._emit = T, i[l]._multi = !0;
}
function km(i) {
  ((t) => {
    t.scope && typeof t.scope == "object" && t.scope !== null && (t.beginScope = t.scope, delete t.scope);
  })(i), typeof i.beginScope == "string" && (i.beginScope = {
    _wrap: i.beginScope
  }), typeof i.endScope == "string" && (i.endScope = {
    _wrap: i.endScope
  }), ((t) => {
    if (Array.isArray(t.begin)) {
      if (t.skip || t.excludeBegin || t.returnBegin) throw Pr("skip, excludeBegin, returnBegin not compatible with beginScope: {}"), la;
      if (typeof t.beginScope != "object" || t.beginScope === null) throw Pr("beginScope must be object"), la;
      Sf(t, t.begin, { key: "beginScope" }), t.begin = As(t.begin, { joinWith: "" });
    }
  })(i), ((t) => {
    if (Array.isArray(t.end)) {
      if (t.skip || t.excludeEnd || t.returnEnd) throw Pr("skip, excludeEnd, returnEnd not compatible with endScope: {}"), la;
      if (typeof t.endScope != "object" || t.endScope === null) throw Pr("endScope must be object"), la;
      Sf(t, t.end, { key: "endScope" }), t.end = As(t.end, { joinWith: "" });
    }
  })(i);
}
function Tm(i) {
  function t(M, T) {
    return RegExp(ho(M), "m" + (i.case_insensitive ? "i" : "") + (i.unicodeRegex ? "u" : "") + (T ? "g" : ""));
  }
  class l {
    constructor() {
      this.matchIndexes = {}, this.regexes = [], this.matchAt = 1, this.position = 0;
    }
    addRule(T, F) {
      F.position = this.position++, this.matchIndexes[this.matchAt] = F, this.regexes.push([F, T]), this.matchAt += od(T) + 1;
    }
    compile() {
      this.regexes.length === 0 && (this.exec = () => null);
      const T = this.regexes.map((F) => F[1]);
      this.matcherRe = t(As(T, {
        joinWith: "|"
      }), !0), this.lastIndex = 0;
    }
    exec(T) {
      this.matcherRe.lastIndex = this.lastIndex;
      const F = this.matcherRe.exec(T);
      if (!F) return null;
      const z = F.findIndex((K, q) => q > 0 && K !== void 0), W = this.matchIndexes[z];
      return F.splice(0, z), Object.assign(F, W);
    }
  }
  class c {
    constructor() {
      this.rules = [], this.multiRegexes = [], this.count = 0, this.lastIndex = 0, this.regexIndex = 0;
    }
    getMatcher(T) {
      if (this.multiRegexes[T]) return this.multiRegexes[T];
      const F = new l();
      return this.rules.slice(T).forEach(([z, W]) => F.addRule(z, W)), F.compile(), this.multiRegexes[T] = F, F;
    }
    resumingScanAtSamePosition() {
      return this.regexIndex !== 0;
    }
    considerAll() {
      this.regexIndex = 0;
    }
    addRule(T, F) {
      this.rules.push([T, F]), F.type === "begin" && this.count++;
    }
    exec(T) {
      const F = this.getMatcher(this.regexIndex);
      F.lastIndex = this.lastIndex;
      let z = F.exec(T);
      if (this.resumingScanAtSamePosition() && !(z && z.index === this.lastIndex)) {
        const W = this.getMatcher(0);
        W.lastIndex = this.lastIndex + 1, z = W.exec(T);
      }
      return z && (this.regexIndex += z.position + 1, this.regexIndex === this.count && this.considerAll()), z;
    }
  }
  if (i.compilerExtensions || (i.compilerExtensions = []), i.contains && i.contains.includes("self")) throw Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
  return i.classNameAliases = yr(i.classNameAliases || {}), function M(T, F) {
    const z = T;
    if (T.isCompiled) return z;
    [ym, xm, km, _m].forEach((K) => K(T, F)), i.compilerExtensions.forEach((K) => K(T, F)), T.__beforeBegin = null, [bm, Am, wm].forEach((K) => K(T, F)), T.isCompiled = !0;
    let W = null;
    return typeof T.keywords == "object" && T.keywords.$pattern && (T.keywords = Object.assign({}, T.keywords), W = T.keywords.$pattern, delete T.keywords.$pattern), W = W || /\w+/, T.keywords && (T.keywords = ad(T.keywords, i.case_insensitive)), z.keywordPatternRe = t(W, !0), F && (T.begin || (T.begin = /\B|\b/), z.beginRe = t(z.begin), T.end || T.endsWithParent || (T.end = /\B|\b/), T.end && (z.endRe = t(z.end)), z.terminatorEnd = ho(z.end) || "", T.endsWithParent && F.terminatorEnd && (z.terminatorEnd += (T.end ? "|" : "") + F.terminatorEnd)), T.illegal && (z.illegalRe = t(T.illegal)), T.contains || (T.contains = []), T.contains = [].concat(...T.contains.map((K) => ((q) => (q.variants && !q.cachedVariants && (q.cachedVariants = q.variants.map((m) => yr(q, {
      variants: null
    }, m))), q.cachedVariants ? q.cachedVariants : ld(q) ? yr(q, {
      starts: q.starts ? yr(q.starts) : null
    }) : Object.isFrozen(q) ? yr(q) : q))(K === "self" ? T : K))), T.contains.forEach((K) => {
      M(K, z);
    }), T.starts && M(T.starts, F), z.matcher = ((K) => {
      const q = new c();
      return K.contains.forEach((m) => q.addRule(m.begin, {
        rule: m,
        type: "begin"
      })), K.terminatorEnd && q.addRule(K.terminatorEnd, {
        type: "end"
      }), K.illegal && q.addRule(K.illegal, { type: "illegal" }), q;
    })(z), z;
  }(i);
}
function ld(i) {
  return !!i && (i.endsWithParent || ld(i.starts));
}
class Dm extends Error {
  constructor(t, l) {
    super(t), this.name = "HTMLInjectionError", this.html = l;
  }
}
const cs = rd, Ef = yr, kf = Symbol("nomatch"), sd = (i) => {
  const t = /* @__PURE__ */ Object.create(null), l = /* @__PURE__ */ Object.create(null), c = [];
  let M = !0;
  const T = "Could not find the language '{}', did you forget to load/include a language module?", F = {
    disableAutodetect: !0,
    name: "Plain text",
    contains: []
  };
  let z = {
    ignoreUnescapedHTML: !1,
    throwUnescapedHTML: !1,
    noHighlightRe: /^(no-?highlight)$/i,
    languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
    classPrefix: "hljs-",
    cssSelector: "pre code",
    languages: null,
    __emitter: sm
  };
  function W(x) {
    return z.noHighlightRe.test(x);
  }
  function K(x, g, _) {
    let A = "", f = "";
    typeof g == "object" ? (A = x, _ = g.ignoreIllegals, f = g.language) : (di("10.7.0", "highlight(lang, code, ...args) has been deprecated."), di("10.7.0", `Please use highlight(code, options) instead.
https://github.com/highlightjs/highlight.js/issues/2277`), f = x, A = g), _ === void 0 && (_ = !0);
    const S = { code: A, language: f };
    b("before:highlight", S);
    const D = S.result ? S.result : q(S.language, S.code, _);
    return D.code = S.code, b("after:highlight", D), D;
  }
  function q(x, g, _, A) {
    const f = /* @__PURE__ */ Object.create(null);
    function S() {
      if (!U.keywords) return X.addText(G);
      let ae = 0;
      U.keywordPatternRe.lastIndex = 0;
      let se = U.keywordPatternRe.exec(G), ve = "";
      for (; se; ) {
        ve += G.substring(ae, se.index);
        const ye = H.case_insensitive ? se[0].toLowerCase() : se[0], ce = (Ae = ye, U.keywords[Ae]);
        if (ce) {
          const [he, ke] = ce;
          if (X.addText(ve), ve = "", f[ye] = (f[ye] || 0) + 1, f[ye] <= 7 && (J += ke), he.startsWith("_")) ve += se[0];
          else {
            const je = H.classNameAliases[he] || he;
            k(se[0], je);
          }
        } else ve += se[0];
        ae = U.keywordPatternRe.lastIndex, se = U.keywordPatternRe.exec(G);
      }
      var Ae;
      ve += G.substring(ae), X.addText(ve);
    }
    function D() {
      U.subLanguage != null ? (() => {
        if (G === "") return;
        let ae = null;
        if (typeof U.subLanguage == "string") {
          if (!t[U.subLanguage]) return X.addText(G);
          ae = q(U.subLanguage, G, !0, Y[U.subLanguage]), Y[U.subLanguage] = ae._top;
        } else ae = m(G, U.subLanguage.length ? U.subLanguage : null);
        U.relevance > 0 && (J += ae.relevance), X.__addSublanguage(ae._emitter, ae.language);
      })() : S(), G = "";
    }
    function k(ae, se) {
      ae !== "" && (X.startScope(se), X.addText(ae), X.endScope());
    }
    function L(ae, se) {
      let ve = 1;
      const Ae = se.length - 1;
      for (; ve <= Ae; ) {
        if (!ae._emit[ve]) {
          ve++;
          continue;
        }
        const ye = H.classNameAliases[ae[ve]] || ae[ve], ce = se[ve];
        ye ? k(ce, ye) : (G = ce, S(), G = ""), ve++;
      }
    }
    function h(ae, se) {
      return ae.scope && typeof ae.scope == "string" && X.openNode(H.classNameAliases[ae.scope] || ae.scope), ae.beginScope && (ae.beginScope._wrap ? (k(G, H.classNameAliases[ae.beginScope._wrap] || ae.beginScope._wrap), G = "") : ae.beginScope._multi && (L(ae.beginScope, se), G = "")), U = Object.create(ae, { parent: {
        value: U
      } }), U;
    }
    function E(ae, se, ve) {
      let Ae = ((ye, ce) => {
        const he = ye && ye.exec(ce);
        return he && he.index === 0;
      })(ae.endRe, ve);
      if (Ae) {
        if (ae["on:end"]) {
          const ye = new gf(ae);
          ae["on:end"](se, ye), ye.isMatchIgnored && (Ae = !1);
        }
        if (Ae) {
          for (; ae.endsParent && ae.parent; ) ae = ae.parent;
          return ae;
        }
      }
      if (ae.endsWithParent) return E(ae.parent, se, ve);
    }
    function w(ae) {
      return U.matcher.regexIndex === 0 ? (G += ae[0], 1) : (oe = !0, 0);
    }
    function O(ae) {
      const se = ae[0], ve = g.substring(ae.index), Ae = E(U, ae, ve);
      if (!Ae) return kf;
      const ye = U;
      U.endScope && U.endScope._wrap ? (D(), k(se, U.endScope._wrap)) : U.endScope && U.endScope._multi ? (D(), L(U.endScope, ae)) : ye.skip ? G += se : (ye.returnEnd || ye.excludeEnd || (G += se), D(), ye.excludeEnd && (G = se));
      do
        U.scope && X.closeNode(), U.skip || U.subLanguage || (J += U.relevance), U = U.parent;
      while (U !== Ae.parent);
      return Ae.starts && h(Ae.starts, ae), ye.returnEnd ? 0 : se.length;
    }
    let R = {};
    function I(ae, se) {
      const ve = se && se[0];
      if (G += ae, ve == null) return D(), 0;
      if (R.type === "begin" && se.type === "end" && R.index === se.index && ve === "") {
        if (G += g.slice(se.index, se.index + 1), !M) {
          const Ae = Error(`0 width match regex (${x})`);
          throw Ae.languageName = x, Ae.badRule = R.rule, Ae;
        }
        return 1;
      }
      if (R = se, se.type === "begin") return ((Ae) => {
        const ye = Ae[0], ce = Ae.rule, he = new gf(ce), ke = [ce.__beforeBegin, ce["on:begin"]];
        for (const je of ke) if (je && (je(Ae, he), he.isMatchIgnored)) return w(ye);
        return ce.skip ? G += ye : (ce.excludeBegin && (G += ye), D(), ce.returnBegin || ce.excludeBegin || (G = ye)), h(ce, Ae), ce.returnBegin ? 0 : ye.length;
      })(se);
      if (se.type === "illegal" && !_) {
        const Ae = Error('Illegal lexeme "' + ve + '" for mode "' + (U.scope || "<unnamed>") + '"');
        throw Ae.mode = U, Ae;
      }
      if (se.type === "end") {
        const Ae = O(se);
        if (Ae !== kf) return Ae;
      }
      if (se.type === "illegal" && ve === "") return 1;
      if (re > 1e5 && re > 3 * se.index) throw Error("potential infinite loop, way more iterations than matches");
      return G += ve, ve.length;
    }
    const H = v(x);
    if (!H) throw Pr(T.replace("{}", x)), Error('Unknown language: "' + x + '"');
    const $ = Tm(H);
    let Q = "", U = A || $;
    const Y = {}, X = new z.__emitter(z);
    (() => {
      const ae = [];
      for (let se = U; se !== H; se = se.parent) se.scope && ae.unshift(se.scope);
      ae.forEach((se) => X.openNode(se));
    })();
    let G = "", J = 0, ee = 0, re = 0, oe = !1;
    try {
      if (H.__emitTokens) H.__emitTokens(g, X);
      else {
        for (U.matcher.considerAll(); ; ) {
          re++, oe ? oe = !1 : U.matcher.considerAll(), U.matcher.lastIndex = ee;
          const ae = U.matcher.exec(g);
          if (!ae) break;
          const se = I(g.substring(ee, ae.index), ae);
          ee = ae.index + se;
        }
        I(g.substring(ee));
      }
      return X.finalize(), Q = X.toHTML(), {
        language: x,
        value: Q,
        relevance: J,
        illegal: !1,
        _emitter: X,
        _top: U
      };
    } catch (ae) {
      if (ae.message && ae.message.includes("Illegal")) return {
        language: x,
        value: cs(g),
        illegal: !0,
        relevance: 0,
        _illegalBy: {
          message: ae.message,
          index: ee,
          context: g.slice(ee - 100, ee + 100),
          mode: ae.mode,
          resultSoFar: Q
        },
        _emitter: X
      };
      if (M) return {
        language: x,
        value: cs(g),
        illegal: !1,
        relevance: 0,
        errorRaised: ae,
        _emitter: X,
        _top: U
      };
      throw ae;
    }
  }
  function m(x, g) {
    g = g || z.languages || Object.keys(t);
    const _ = ((L) => {
      const h = { value: cs(L), illegal: !1, relevance: 0, _top: F, _emitter: new z.__emitter(z) };
      return h._emitter.addText(L), h;
    })(x), A = g.filter(v).filter(p).map((L) => q(L, x, !1));
    A.unshift(_);
    const f = A.sort((L, h) => {
      if (L.relevance !== h.relevance) return h.relevance - L.relevance;
      if (L.language && h.language) {
        if (v(L.language).supersetOf === h.language) return 1;
        if (v(h.language).supersetOf === L.language) return -1;
      }
      return 0;
    }), [S, D] = f, k = S;
    return k.secondBest = D, k;
  }
  function d(x) {
    let g = null;
    const _ = ((S) => {
      let D = S.className + " ";
      D += S.parentNode ? S.parentNode.className : "";
      const k = z.languageDetectRe.exec(D);
      if (k) {
        const L = v(k[1]);
        return L || (Cf(T.replace("{}", k[1])), Cf("Falling back to no-highlight mode for this block.", S)), L ? k[1] : "no-highlight";
      }
      return D.split(/\s+/).find((L) => W(L) || v(L));
    })(x);
    if (W(_)) return;
    if (b("before:highlightElement", {
      el: x,
      language: _
    }), x.dataset.highlighted) return console.log("Element previously highlighted. To highlight again, first unset `dataset.highlighted`.", x);
    if (x.children.length > 0 && (z.ignoreUnescapedHTML || (console.warn("One of your code blocks includes unescaped HTML. This is a potentially serious security risk."), console.warn("https://github.com/highlightjs/highlight.js/wiki/security"), console.warn("The element with unescaped HTML:"), console.warn(x)), z.throwUnescapedHTML)) throw new Dm("One of your code blocks includes unescaped HTML.", x.innerHTML);
    g = x;
    const A = g.textContent, f = _ ? K(A, { language: _, ignoreIllegals: !0 }) : m(A);
    x.innerHTML = f.value, x.dataset.highlighted = "yes", ((S, D, k) => {
      const L = D && l[D] || k;
      S.classList.add("hljs"), S.classList.add("language-" + L);
    })(x, _, f.language), x.result = {
      language: f.language,
      re: f.relevance,
      relevance: f.relevance
    }, f.secondBest && (x.secondBest = {
      language: f.secondBest.language,
      relevance: f.secondBest.relevance
    }), b("after:highlightElement", { el: x, result: f, text: A });
  }
  let r = !1;
  function u() {
    document.readyState !== "loading" ? document.querySelectorAll(z.cssSelector).forEach(d) : r = !0;
  }
  function v(x) {
    return x = (x || "").toLowerCase(), t[x] || t[l[x]];
  }
  function C(x, { languageName: g }) {
    typeof x == "string" && (x = [x]), x.forEach((_) => {
      l[_.toLowerCase()] = g;
    });
  }
  function p(x) {
    const g = v(x);
    return g && !g.disableAutodetect;
  }
  function b(x, g) {
    const _ = x;
    c.forEach((A) => {
      A[_] && A[_](g);
    });
  }
  typeof window != "undefined" && window.addEventListener && window.addEventListener("DOMContentLoaded", () => {
    r && u();
  }, !1), Object.assign(i, {
    highlight: K,
    highlightAuto: m,
    highlightAll: u,
    highlightElement: d,
    highlightBlock: (x) => (di("10.7.0", "highlightBlock will be removed entirely in v12.0"), di("10.7.0", "Please use highlightElement now."), d(x)),
    configure: (x) => {
      z = Ef(z, x);
    },
    initHighlighting: () => {
      u(), di("10.6.0", "initHighlighting() deprecated.  Use highlightAll() now.");
    },
    initHighlightingOnLoad: () => {
      u(), di("10.6.0", "initHighlightingOnLoad() deprecated.  Use highlightAll() now.");
    },
    registerLanguage: (x, g) => {
      let _ = null;
      try {
        _ = g(i);
      } catch (A) {
        if (Pr("Language definition for '{}' could not be registered.".replace("{}", x)), !M) throw A;
        Pr(A), _ = F;
      }
      _.name || (_.name = x), t[x] = _, _.rawDefinition = g.bind(null, i), _.aliases && C(_.aliases, {
        languageName: x
      });
    },
    unregisterLanguage: (x) => {
      delete t[x];
      for (const g of Object.keys(l)) l[g] === x && delete l[g];
    },
    listLanguages: () => Object.keys(t),
    getLanguage: v,
    registerAliases: C,
    autoDetection: p,
    inherit: Ef,
    addPlugin: (x) => {
      ((g) => {
        g["before:highlightBlock"] && !g["before:highlightElement"] && (g["before:highlightElement"] = (_) => {
          g["before:highlightBlock"](Object.assign({ block: _.el }, _));
        }), g["after:highlightBlock"] && !g["after:highlightElement"] && (g["after:highlightElement"] = (_) => {
          g["after:highlightBlock"](Object.assign({ block: _.el }, _));
        });
      })(x), c.push(x);
    },
    removePlugin: (x) => {
      const g = c.indexOf(x);
      g !== -1 && c.splice(g, 1);
    }
  }), i.debugMode = () => {
    M = !1;
  }, i.safeMode = () => {
    M = !0;
  }, i.versionString = "11.9.0", i.regex = {
    concat: $r,
    lookahead: id,
    either: Ms,
    optional: cm,
    anyNumberOfTimes: um
  };
  for (const x in aa) typeof aa[x] == "object" && nd(aa[x]);
  return Object.assign(i, aa), i;
}, Sa = sd({});
Sa.newInstance = () => sd({});
/*! `xml` grammar compiled for Highlight.js 11.9.0 */
var Mm = (i) => {
  const t = i.regex, l = t.concat(/[\p{L}_]/u, t.optional(/[\p{L}0-9_.-]*:/u), /[\p{L}0-9_.-]*/u), c = {
    className: "symbol",
    begin: /&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/
  }, M = {
    begin: /\s/,
    contains: [{ className: "keyword", begin: /#?[a-z_][a-z1-9_-]+/, illegal: /\n/ }]
  }, T = i.inherit(M, { begin: /\(/, end: /\)/ }), F = i.inherit(i.APOS_STRING_MODE, {
    className: "string"
  }), z = i.inherit(i.QUOTE_STRING_MODE, { className: "string" }), W = {
    endsWithParent: !0,
    illegal: /</,
    relevance: 0,
    contains: [{
      className: "attr",
      begin: /[\p{L}0-9._:-]+/u,
      relevance: 0
    }, { begin: /=\s*/, relevance: 0, contains: [{
      className: "string",
      endsParent: !0,
      variants: [{ begin: /"/, end: /"/, contains: [c] }, {
        begin: /'/,
        end: /'/,
        contains: [c]
      }, { begin: /[^\s"'=<>`]+/ }]
    }] }]
  };
  return {
    name: "HTML, XML",
    aliases: ["html", "xhtml", "rss", "atom", "xjb", "xsd", "xsl", "plist", "wsf", "svg"],
    case_insensitive: !0,
    unicodeRegex: !0,
    contains: [{
      className: "meta",
      begin: /<![a-z]/,
      end: />/,
      relevance: 10,
      contains: [M, z, F, T, { begin: /\[/, end: /\]/, contains: [{
        className: "meta",
        begin: /<![a-z]/,
        end: />/,
        contains: [M, T, z, F]
      }] }]
    }, i.COMMENT(/<!--/, /-->/, { relevance: 10 }), {
      begin: /<!\[CDATA\[/,
      end: /\]\]>/,
      relevance: 10
    }, c, { className: "meta", end: /\?>/, variants: [{
      begin: /<\?xml/,
      relevance: 10,
      contains: [z]
    }, { begin: /<\?[a-z][a-z0-9]+/ }] }, {
      className: "tag",
      begin: /<style(?=\s|>)/,
      end: />/,
      keywords: { name: "style" },
      contains: [W],
      starts: {
        end: /<\/style>/,
        returnEnd: !0,
        subLanguage: ["css", "xml"]
      }
    }, {
      className: "tag",
      begin: /<script(?=\s|>)/,
      end: />/,
      keywords: { name: "script" },
      contains: [W],
      starts: {
        end: /<\/script>/,
        returnEnd: !0,
        subLanguage: ["javascript", "handlebars", "xml"]
      }
    }, {
      className: "tag",
      begin: /<>|<\/>/
    }, {
      className: "tag",
      begin: t.concat(/</, t.lookahead(t.concat(l, t.either(/\/>/, />/, /\s/)))),
      end: /\/?>/,
      contains: [{ className: "name", begin: l, relevance: 0, starts: W }]
    }, {
      className: "tag",
      begin: t.concat(/<\//, t.lookahead(t.concat(l, />/))),
      contains: [{
        className: "name",
        begin: l,
        relevance: 0
      }, { begin: />/, relevance: 0, endsParent: !0 }]
    }]
  };
};
/*! `javascript` grammar compiled for Highlight.js 11.9.0 */
var Nm = (() => {
  const i = "[A-Za-z$_][0-9A-Za-z$_]*", t = ["as", "in", "of", "if", "for", "while", "finally", "var", "new", "function", "do", "return", "void", "else", "break", "catch", "instanceof", "with", "throw", "case", "default", "try", "switch", "continue", "typeof", "delete", "let", "yield", "const", "class", "debugger", "async", "await", "static", "import", "from", "export", "extends"], l = ["true", "false", "null", "undefined", "NaN", "Infinity"], c = ["Object", "Function", "Boolean", "Symbol", "Math", "Date", "Number", "BigInt", "String", "RegExp", "Array", "Float32Array", "Float64Array", "Int8Array", "Uint8Array", "Uint8ClampedArray", "Int16Array", "Int32Array", "Uint16Array", "Uint32Array", "BigInt64Array", "BigUint64Array", "Set", "Map", "WeakSet", "WeakMap", "ArrayBuffer", "SharedArrayBuffer", "Atomics", "DataView", "JSON", "Promise", "Generator", "GeneratorFunction", "AsyncFunction", "Reflect", "Proxy", "Intl", "WebAssembly"], M = ["Error", "EvalError", "InternalError", "RangeError", "ReferenceError", "SyntaxError", "TypeError", "URIError"], T = ["setInterval", "setTimeout", "clearInterval", "clearTimeout", "require", "exports", "eval", "isFinite", "isNaN", "parseFloat", "parseInt", "decodeURI", "decodeURIComponent", "encodeURI", "encodeURIComponent", "escape", "unescape"], F = ["arguments", "this", "super", "console", "window", "document", "localStorage", "sessionStorage", "module", "global"], z = [].concat(T, c, M);
  return (W) => {
    const K = W.regex, q = i, m = {
      begin: /<[A-Za-z0-9\\._:-]+/,
      end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
      isTrulyOpeningTag: (Q, U) => {
        const Y = Q[0].length + Q.index, X = Q.input[Y];
        if (X === "<" || X === ",") return void U.ignoreMatch();
        let G;
        X === ">" && (((ee, { after: re }) => {
          const oe = "</" + ee[0].slice(1);
          return ee.input.indexOf(oe, re) !== -1;
        })(Q, { after: Y }) || U.ignoreMatch());
        const J = Q.input.substring(Y);
        ((G = J.match(/^\s*=/)) || (G = J.match(/^\s+extends\s+/)) && G.index === 0) && U.ignoreMatch();
      }
    }, d = {
      $pattern: i,
      keyword: t,
      literal: l,
      built_in: z,
      "variable.language": F
    }, r = "[0-9](_?[0-9])*", u = `\\.(${r})`, v = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*", C = {
      className: "number",
      variants: [{
        begin: `(\\b(${v})((${u})|\\.)?|(${u}))[eE][+-]?(${r})\\b`
      }, {
        begin: `\\b(${v})\\b((${u})\\b|\\.)?|(${u})\\b`
      }, {
        begin: "\\b(0|[1-9](_?[0-9])*)n\\b"
      }, {
        begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b"
      }, {
        begin: "\\b0[bB][0-1](_?[0-1])*n?\\b"
      }, { begin: "\\b0[oO][0-7](_?[0-7])*n?\\b" }, {
        begin: "\\b0[0-7]+n?\\b"
      }],
      relevance: 0
    }, p = {
      className: "subst",
      begin: "\\$\\{",
      end: "\\}",
      keywords: d,
      contains: []
    }, b = { begin: "html`", end: "", starts: {
      end: "`",
      returnEnd: !1,
      contains: [W.BACKSLASH_ESCAPE, p],
      subLanguage: "xml"
    } }, x = {
      begin: "css`",
      end: "",
      starts: {
        end: "`",
        returnEnd: !1,
        contains: [W.BACKSLASH_ESCAPE, p],
        subLanguage: "css"
      }
    }, g = {
      begin: "gql`",
      end: "",
      starts: {
        end: "`",
        returnEnd: !1,
        contains: [W.BACKSLASH_ESCAPE, p],
        subLanguage: "graphql"
      }
    }, _ = {
      className: "string",
      begin: "`",
      end: "`",
      contains: [W.BACKSLASH_ESCAPE, p]
    }, A = {
      className: "comment",
      variants: [W.COMMENT(/\/\*\*(?!\/)/, "\\*/", {
        relevance: 0,
        contains: [{
          begin: "(?=@[A-Za-z]+)",
          relevance: 0,
          contains: [{
            className: "doctag",
            begin: "@[A-Za-z]+"
          }, {
            className: "type",
            begin: "\\{",
            end: "\\}",
            excludeEnd: !0,
            excludeBegin: !0,
            relevance: 0
          }, {
            className: "variable",
            begin: q + "(?=\\s*(-)|$)",
            endsParent: !0,
            relevance: 0
          }, { begin: /(?=[^\n])\s/, relevance: 0 }]
        }]
      }), W.C_BLOCK_COMMENT_MODE, W.C_LINE_COMMENT_MODE]
    }, f = [W.APOS_STRING_MODE, W.QUOTE_STRING_MODE, b, x, g, _, { match: /\$\d+/ }, C];
    p.contains = f.concat({
      begin: /\{/,
      end: /\}/,
      keywords: d,
      contains: ["self"].concat(f)
    });
    const S = [].concat(A, p.contains), D = S.concat([{
      begin: /\(/,
      end: /\)/,
      keywords: d,
      contains: ["self"].concat(S)
    }]), k = {
      className: "params",
      begin: /\(/,
      end: /\)/,
      excludeBegin: !0,
      excludeEnd: !0,
      keywords: d,
      contains: D
    }, L = { variants: [{
      match: [/class/, /\s+/, q, /\s+/, /extends/, /\s+/, K.concat(q, "(", K.concat(/\./, q), ")*")],
      scope: { 1: "keyword", 3: "title.class", 5: "keyword", 7: "title.class.inherited" }
    }, {
      match: [/class/, /\s+/, q],
      scope: { 1: "keyword", 3: "title.class" }
    }] }, h = {
      relevance: 0,
      match: K.either(/\bJSON/, /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/, /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/, /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/),
      className: "title.class",
      keywords: { _: [...c, ...M] }
    }, E = {
      variants: [{
        match: [/function/, /\s+/, q, /(?=\s*\()/]
      }, { match: [/function/, /\s*(?=\()/] }],
      className: { 1: "keyword", 3: "title.function" },
      label: "func.def",
      contains: [k],
      illegal: /%/
    }, w = {
      match: K.concat(/\b/, (O = [...T, "super", "import"], K.concat("(?!", O.join("|"), ")")), q, K.lookahead(/\(/)),
      className: "title.function",
      relevance: 0
    };
    var O;
    const R = {
      begin: K.concat(/\./, K.lookahead(K.concat(q, /(?![0-9A-Za-z$_(])/))),
      end: q,
      excludeBegin: !0,
      keywords: "prototype",
      className: "property",
      relevance: 0
    }, I = {
      match: [/get|set/, /\s+/, q, /(?=\()/],
      className: { 1: "keyword", 3: "title.function" },
      contains: [{ begin: /\(\)/ }, k]
    }, H = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + W.UNDERSCORE_IDENT_RE + ")\\s*=>", $ = {
      match: [/const|var|let/, /\s+/, q, /\s*/, /=\s*/, /(async\s*)?/, K.lookahead(H)],
      keywords: "async",
      className: { 1: "keyword", 3: "title.function" },
      contains: [k]
    };
    return {
      name: "JavaScript",
      aliases: ["js", "jsx", "mjs", "cjs"],
      keywords: d,
      exports: {
        PARAMS_CONTAINS: D,
        CLASS_REFERENCE: h
      },
      illegal: /#(?![$_A-z])/,
      contains: [W.SHEBANG({ label: "shebang", binary: "node", relevance: 5 }), {
        label: "use_strict",
        className: "meta",
        relevance: 10,
        begin: /^\s*['"]use (strict|asm)['"]/
      }, W.APOS_STRING_MODE, W.QUOTE_STRING_MODE, b, x, g, _, A, { match: /\$\d+/ }, C, h, {
        className: "attr",
        begin: q + K.lookahead(":"),
        relevance: 0
      }, $, {
        begin: "(" + W.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
        keywords: "return throw case",
        relevance: 0,
        contains: [A, W.REGEXP_MODE, {
          className: "function",
          begin: H,
          returnBegin: !0,
          end: "\\s*=>",
          contains: [{
            className: "params",
            variants: [{ begin: W.UNDERSCORE_IDENT_RE, relevance: 0 }, {
              className: null,
              begin: /\(\s*\)/,
              skip: !0
            }, {
              begin: /\(/,
              end: /\)/,
              excludeBegin: !0,
              excludeEnd: !0,
              keywords: d,
              contains: D
            }]
          }]
        }, { begin: /,/, relevance: 0 }, {
          match: /\s+/,
          relevance: 0
        }, { variants: [{ begin: "<>", end: "</>" }, {
          match: /<[A-Za-z0-9\\._:-]+\s*\/>/
        }, {
          begin: m.begin,
          "on:begin": m.isTrulyOpeningTag,
          end: m.end
        }], subLanguage: "xml", contains: [{
          begin: m.begin,
          end: m.end,
          skip: !0,
          contains: ["self"]
        }] }]
      }, E, {
        beginKeywords: "while if switch catch for"
      }, {
        begin: "\\b(?!function)" + W.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
        returnBegin: !0,
        label: "func.def",
        contains: [k, W.inherit(W.TITLE_MODE, {
          begin: q,
          className: "title.function"
        })]
      }, { match: /\.\.\./, relevance: 0 }, R, {
        match: "\\$" + q,
        relevance: 0
      }, {
        match: [/\bconstructor(?=\s*\()/],
        className: { 1: "title.function" },
        contains: [k]
      }, w, {
        relevance: 0,
        match: /\b[A-Z][A-Z_0-9]+\b/,
        className: "variable.constant"
      }, L, I, { match: /\$[(.]/ }]
    };
  };
})();
const Om = ft({
  name: "TypeSelect",
  inject: ["designer"],
  computed: {
    t() {
      return this.designer.t;
    },
    activeRule() {
      return this.designer.activeRule;
    },
    customForm() {
      return this.designer.customForm;
    },
    menus() {
      let i = [];
      const t = this.designer;
      if (this.activeRule) {
        const l = this.activeRule._menu.name, c = t.getConfig("switchType", []);
        if (c === !1)
          return i;
        let M = [];
        c.forEach((T) => {
          T.indexOf(l) > -1 && M.push(...T);
        }), M = M.filter((T, F) => T !== l && M.indexOf(T) === F), M.length ? t.menuList.forEach((T) => {
          T.list.forEach((F) => {
            M.indexOf(F.name) > -1 && i.push(F);
          });
        }) : t.menuList.forEach((T) => {
          T.name === this.activeRule._menu.menu && T.list.forEach((F) => {
            F.name !== l && i.push(F);
          });
        });
      }
      return i;
    }
  },
  methods: {
    handleCommand(i) {
      var F;
      let t = this.activeRule, l = this.activeRule;
      l._menu.inside || (l = l.__fc__.parent.rule);
      const c = l.__fc__.parent.rule.children, M = this.designer.makeRule(i);
      let T = M;
      M.type === "DragTool" && (T = M.children[0]), T.field && t.field ? ["title", "info", "field", "validate", "control", "$required"].forEach((z) => {
        T[z] = t[z];
      }) : (F = t == null ? void 0 : t.computed) != null && F.hidden && (T.computed = { hidden: t.computed.hidden }), t.name && (T.name = t.name), ["name", "id", "on"].forEach((z) => {
        t[z] && (T[z] = t[z]);
      }), c.splice(c.indexOf(l), 1, M), this.$nextTick(() => {
        this.designer.triggerActive(T);
      });
    }
  }
});
var Rm = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("el-dropdown", { staticClass: "_fd-type-select", attrs: { trigger: "click", size: "small", disabled: !t.menus.length }, on: { command: t.handleCommand }, scopedSlots: t._u([{ key: "dropdown", fn: function() {
    return [l("el-dropdown-menu", t._l(t.menus, function(c) {
      return l("el-dropdown-item", { key: c.name, attrs: { command: c } }, [l("div", [l("i", { staticClass: "fc-icon", class: c.icon || "icon-input" }), t._v(t._s(t.t("com." + c.name + ".name") || c.label))])]);
    }), 1)];
  }, proxy: !0 }]) }, [l("el-tag", { attrs: { type: "success", effect: "plain", size: "small", "disable-transitions": "" } }, [t.activeRule ? [t._v(" " + t._s(t.t("com." + t.activeRule._menu.name + ".name") || t.activeRule._menu.label) + " "), t.menus.length ? l("i", { staticClass: "fc-icon icon-down" }) : t._e()] : [t._v(" " + t._s(t.t("com." + t.customForm.config.name + ".name") || t.customForm.config.label || t.customForm.config.name) + " ")]], 2)], 1);
}, Im = [], Lm = /* @__PURE__ */ lt(
  Om,
  Rm,
  Im,
  !1,
  null,
  null
);
const Fm = Lm.exports;
Sa.registerLanguage("javascript", Nm);
Sa.registerLanguage("xml", Mm);
const Bm = ft({
  name: "FcDesigner",
  components: {
    TypeSelect: Fm,
    fcDraggable: qf,
    DragForm: qe.$form(),
    ViewForm: wa.$form(),
    EventConfig: td
  },
  props: {
    menu: Array,
    height: [String, Number],
    config: {
      type: Object,
      default: () => ({})
    },
    mask: {
      type: Boolean,
      default: void 0
    },
    locale: Object,
    handle: Array
  },
  provide() {
    return {
      designer: this
    };
  },
  emits: ["active", "create", "copy", "delete", "drag", "inputData", "save", "clear"],
  setup(i, { emit: t }) {
    const { menu: l, height: c, mask: M, locale: T, handle: F } = Ic(i), z = _h(), W = Al({ active: null });
    Lc("fcx", W), Lc("designer", z);
    const K = Yi(i, "config", {}), q = Yi(K.value, "baseRule", null), m = Yi(K.value, "componentRule", {}), d = Yi(K.value, "validateRule", null), r = Yi(K.value, "formRule", null), u = Un(() => {
      const h = c.value;
      return h ? at.Number(h) ? `${h}px` : h : "100%";
    }), v = Un(() => K.value.fieldReadonly !== !1), C = Un(() => K.value.hiddenMenu || []), p = Un(() => K.value.hiddenItem || []), b = Un(() => K.value.hiddenDragMenu === !0), x = Un(() => K.value.hiddenDragBtn === !0);
    let g = bs;
    T.value && (g = ds(T).t);
    const _ = (...h) => g(...h), A = (h, E, ...w) => {
      if (E) {
        if (at.Function(E))
          return E(...w);
        if (E.rule) {
          let O = E.rule(...w);
          return E.prepend ? O = [...O, ...h(...w)] : E.append && (O = [...h(...w), ...O]), O;
        }
      }
      return h(...w);
    }, f = Al({
      cacheProps: {},
      operation: {
        idx: -1,
        list: []
      },
      moveRule: null,
      addRule: null,
      added: null,
      device: "pc",
      activeTab: "form",
      activeMenuTab: "menu",
      activeRule: null,
      children: ao([]),
      treeInfo: [],
      menuList: l.value || Gg(),
      dragRuleList: {},
      eventShow: !1,
      unloadStatus: !1,
      previewStatus: "form",
      t: _,
      preview: {
        state: !1,
        rule: [],
        option: {},
        api: {}
      },
      inputForm: {
        state: !1,
        rule: [],
        option: {},
        api: {},
        data: {},
        key: ""
      },
      dragForm: ao({
        rule: [],
        api: {}
      }),
      formOptions: {},
      oldOptionsKeys: [],
      form: {
        rule: A(Qc, r.value, { t: _ }),
        api: {},
        option: {
          form: {
            labelPosition: "top",
            size: "mini"
          },
          submitBtn: !1
        },
        value: {
          form: {},
          submitBtn: !1
        }
      },
      baseForm: {
        isShow: !1,
        rule: A(Ji, q.value, { t: _ }),
        api: {},
        value: {},
        options: {
          global: {
            input: {
              modelEmit: "blur"
            }
          },
          form: {
            labelPosition: "top",
            size: "mini"
          },
          submitBtn: !1,
          mounted: (h) => {
            h.activeRule = f.activeRule, h.setValue(h.options.formData || {});
          }
        }
      },
      styleForm: {
        isShow: !1,
        rule: Lh({ t: _ }),
        api: {},
        value: {},
        options: {
          form: {
            labelPosition: "left",
            size: "mini"
          },
          submitBtn: !1,
          mounted: (h) => {
            h.activeRule = f.activeRule, h.setValue(h.options.formData || {});
          }
        }
      },
      validateForm: {
        isShow: !1,
        rule: A(Vc, d.value, { t: _ }),
        api: {},
        value: [],
        options: {
          global: {
            input: {
              modelEmit: "blur"
            }
          },
          form: {
            labelPosition: "top",
            size: "mini"
          },
          submitBtn: !1,
          mounted: (h) => {
            h.activeRule = f.activeRule, h.setValue(h.options.formData || {});
          }
        }
      },
      propsForm: {
        isShow: !1,
        rule: [],
        api: {},
        value: {},
        options: {
          global: {
            input: {
              modelEmit: "blur"
            },
            inputNumber: {
              props: {
                controlsPosition: "right"
              }
            }
          },
          form: {
            labelPosition: "top",
            size: "mini"
          },
          submitBtn: !1,
          mounted: (h) => {
            h.activeRule = f.activeRule, h.setValue(h.options.formData || {});
          }
        }
      },
      customForm: {
        isShow: !1,
        config: null,
        key: "",
        rule: [],
        api: {},
        options: {
          global: {
            input: {
              modelEmit: "blur"
            }
          },
          form: {
            labelPosition: "top",
            size: "mini"
          },
          submitBtn: !1
        }
      }
    });
    xl(() => f.preview.state, function(h) {
      h || zn(() => {
        f.previewStatus = "form", f.preview.rule = f.preview.option = null;
      });
    });
    let S = null;
    const D = (h, E) => {
      if (h[10] !== ">") {
        if (h = h.replace("formCreate", ""), !h) return;
        h = fs(h);
      } else
        h = h.replace("formCreate>", "");
      const w = h.split(">"), O = w.pop();
      let R = f.activeRule;
      w.forEach((I, H) => {
        H || (I = fs(I)), R[I] || Ki(R, I, {}), R = R[I];
      }), E({ source: R, field: O });
    };
    xl(() => T.value, (h) => {
      g = h ? ds(T).t : bs;
      const E = f.form.api.formData && f.form.api.formData(), w = f.baseForm.api.formData && f.baseForm.api.formData(), O = f.validateForm.api.formData && f.validateForm.api.formData();
      f.validateForm.rule = A(Vc, d.value, { t: _ }), f.baseForm.rule = A(Ji, q.value, { t: _ }), f.form.rule = A(Qc, r.value, { t: _ }), f.cacheProps = {};
      const R = f.activeRule;
      let I = null;
      R && (I = f.propsForm.api.formData && f.propsForm.api.formData(), f.propsForm.rule = f.cacheProps[R._fc_id] = k.getPropsRule(R)), zn(() => {
        E && f.form.api.setValue(E), w && f.baseForm.api.setValue(w), O && f.validateForm.api.setValue(O), I && f.propsForm.api.setValue(I);
      });
    });
    const k = {
      unWatchActiveRule() {
        S && S(), S = null;
      },
      watchActiveRule() {
        k.unWatchActiveRule(), S = xl(() => f.activeRule, function(h) {
          h && k.updateRuleFormData();
        }, { deep: !0, flush: "post" });
      },
      makeChildren(h) {
        return Al({ children: h }).children;
      },
      addMenu(h) {
        if (!h.name || !h.list) return;
        let E = !0;
        f.menuList.forEach((w, O) => {
          w.name === h.name && (f.menuList[O] = h, E = !1);
        }), E && f.menuList.push(h);
      },
      removeMenu(h) {
        [...f.menuList].forEach((E, w) => {
          E.name === h && f.menuList.splice(w, 1);
        });
      },
      setMenuItem(h, E) {
        f.menuList.forEach((w) => {
          w.name === h && (w.list = E);
        });
      },
      appendMenuItem(h, E) {
        f.menuList.forEach((w) => {
          w.name === h && w.list.push(...Array.isArray(E) ? E : [E]);
        });
      },
      removeMenuItem(h) {
        f.menuList.forEach((E) => {
          let w;
          at.String(h) ? [...E.list].forEach((O, R) => {
            O.name === h && E.list.splice(R, 1);
          }) : (w = E.list.indexOf(h)) > -1 && E.list.splice(w, 1);
        });
      },
      addComponent(h) {
        Array.isArray(h) ? h.forEach((E) => {
          f.dragRuleList[E.name] = E, E.menu && k.appendMenuItem(E.menu, E);
        }) : (f.dragRuleList[h.name] = h, h.menu && k.appendMenuItem(h.menu, h));
      },
      openInputData(h) {
        f.inputForm.state = h === void 0 ? !f.inputForm.state : !!h, f.inputForm.state && (f.inputForm.rule = qe.parseJson(k.getJson()), f.inputForm.option = qe.parseJson(k.getOptionsJson()), f.inputForm.option.formData = Nt(f.inputForm.data), f.inputForm.option.submitBtn.show = !1, f.inputForm.option.resetBtn.show = !1, k.clearActiveRule());
      },
      inputSave() {
        const h = f.inputForm.api.formData();
        Object.keys(h).forEach((w) => {
          qn(h[w]) && delete h[w];
        });
        const E = JSON.stringify(f.inputForm.data) !== JSON.stringify(h);
        f.inputForm.data = h, f.inputForm.state = !1, t("inputData", h), E && k.addOperationRecord();
      },
      inputClear() {
        k.inputReset({});
      },
      inputReset(h) {
        f.inputForm.rule = qe.parseJson(k.getJson()), f.inputForm.option.formData = h || Nt(f.inputForm.data), f.inputForm.key = Je();
      },
      setFormData(h) {
        f.inputForm.data = h || {};
      },
      getFormData() {
        return f.inputForm.data;
      },
      getParent(h) {
        let E = h.__fc__.parent.rule;
        const w = E._menu;
        return w && w.inside && (h = E, E = E.__fc__.parent.rule), { root: E, parent: h };
      },
      copyName() {
        Ff(f.activeRule.name);
      },
      updateName() {
        f.activeRule.name = "ref_" + Je();
      },
      makeDrag(h, E, w, O, R) {
        return {
          type: "DragBox",
          wrap: {
            show: !1
          },
          col: {
            show: !1
          },
          inject: !0,
          props: {
            rule: {
              props: {
                tag: "el-col"
              },
              attrs: {
                group: h === !0 ? "default" : h,
                ghostClass: "ghost",
                animation: 150,
                handle: "._fd-drag-btn",
                emptyInsertThreshold: 0,
                direction: "vertical"
              }
            },
            tag: E
          },
          children: w,
          on: O,
          slot: R
        };
      },
      clearDragRule() {
        k.setRule([]), k.addOperationRecord(), f.unloadStatus = !1, t("clear");
      },
      makeDragRule(h) {
        return k.makeChildren([k.makeDrag(!0, "draggable", h, {
          add: (E, w) => k.dragAdd(h, w),
          end: (E, w) => k.dragEnd(h, w),
          start: (E, w) => k.dragStart(h, w),
          unchoose: (E, w) => k.dragUnchoose(h, w)
        })]);
      },
      handleSave() {
        t("save", {
          rule: k.getJson(),
          options: k.getOptionsJson()
        });
      },
      openPreview() {
        f.preview.state = !0;
        const h = k.getJson(), E = k.getOptionsJson();
        f.preview.rule = qe.parseJson(h), f.preview.option = qe.parseJson(E), f.preview.html = Sa.highlight(
          Rh(h, E),
          { language: "xml" }
        ).value;
      },
      getRule() {
        return k.parseRule(Nt(f.dragForm.rule[0].children));
      },
      getJson() {
        return qe.toJson(k.getRule());
      },
      getOption() {
        const h = Nt(f.formOptions);
        Object.keys(h._event || {}).forEach((w) => {
          h._event[w] && (h[w] = h._event[w]);
        }), delete h._event, h.submitBtn = h._submitBtn, h.resetBtn = h._resetBtn, h.resetBtn.innerText = _("props.reset"), h.submitBtn.innerText = _("props.submit");
        const E = Nt(f.inputForm.data);
        return Object.keys(E).length > 0 && (h.formData = E), delete h._submitBtn, delete h._resetBtn, h;
      },
      getOptions() {
        k.getOption();
      },
      getOptionsJson() {
        return qe.toJson([k.getOption()]).slice(1).slice(0, -1);
      },
      setRule(h) {
        h || (h = []), f.children = ao(k.loadRule(at.String(h) ? qe.parseJson(h) : Nt(h))), k.clearActiveRule(), f.dragForm.rule = k.makeDragRule(k.makeChildren(f.children)), k.updateTree();
      },
      setBaseRuleConfig(h, E) {
        q.value = { rule: h, append: E }, f.baseForm.rule = A(Ji, q.value, { t: _ });
      },
      setComponentRuleConfig(h, E, w) {
        m.value[h] = { rule: E, append: w }, f.cacheProps = {};
        const O = f.activeRule;
        if (O) {
          const R = f.propsForm.api.formData && f.propsForm.api.formData();
          f.propsForm.rule = f.cacheProps[O._fc_id] = k.getPropsRule(O), zn(() => {
            R && f.propsForm.api.setValue(R);
          });
        }
      },
      setValidateRuleConfig(h, E) {
        d.value = { rule: h, append: E }, f.validateForm.rule = A(Ji, d.value, { t: _ });
      },
      setFormRuleConfig(h, E) {
        r.value = { rule: h, append: E }, f.form.rule = A(Ji, r.value, { t: _ });
      },
      clearActiveRule() {
        f.activeRule = null, f.customForm.config = null, f.activeTab = "form", W.active = "";
      },
      setOption(h) {
        const E = Nt(k.getConfig("formOptions", {})), w = E.form || {};
        delete E.form;
        let O = rt(rt({}, E), at.String(h) ? JSON.parse(h) : Nt(h || {}));
        O.form = rt(rt({
          inline: !1,
          hideRequiredAsterisk: !1,
          labelPosition: "right",
          size: "default",
          labelWidth: "125px"
        }, w), O.form || {}), O._event = {
          onSubmit: O.onSubmit || "",
          onCreated: O.onCreated || "",
          onMounted: O.onMounted || "",
          onChange: O.onChange || "",
          beforeFetch: O.beforeFetch || ""
        }, O._resetBtn = typeof O.resetBtn == "object" ? O.resetBtn : { show: O.resetBtn === !0 }, O._submitBtn = typeof O.submitBtn == "object" ? O.submitBtn : { show: O.submitBtn !== !1 }, O.submitBtn = O.resetBtn = !1, f.inputForm.data = O.formData || {}, f.oldOptionsKeys = Object.keys(f.form.value), delete O.formData, f.formOptions = O, k.updateOptionsValue();
      },
      setOptions(h) {
        k.setOption(h);
      },
      updateOptionsValue() {
        const h = {};
        f.oldOptionsKeys.forEach((w) => {
          h[w] = void 0;
        });
        const E = rt(rt({}, h), f.formOptions.form);
        Object.keys(f.formOptions).forEach((w) => {
          const O = f.formOptions[w];
          E[">" + w] = O, typeof O == "object" && Object.keys(O).forEach((R) => {
            E[w + ">" + R] = O[R];
          });
        }), f.form.value = E;
      },
      loadRule(h, E, w) {
        const O = [];
        return h.forEach((R) => {
          if (at.String(R))
            return O.push(R);
          let I = f.dragRuleList[R._fc_drag_tag] || f.dragRuleList[R.type];
          if (I || (I = tg(R), R._fc_drag_tag = "_"), w && (R._fc_template = w), I && I.loadRule && I.loadRule(R), R.children = k.loadRule(R.children || [], I, w), R.control && (R._control = R.control, delete R.control), R.computed && (R._computed = R.computed, delete R.computed), R.on && (R._on = R.on, delete R.on), I) {
            const H = R.slot;
            let $;
            E && E.slot && H && H !== "default" && ($ = k.getSlotConfig(E, H, I)), delete R.slot, R = k.makeRule($ || I, R), H && (R.slot = H);
          }
          O.push(R);
        }), O;
      },
      parseRule(h, E) {
        return [...h].reduce((w, O) => {
          let R = E;
          if (at.String(O))
            return w.push(O), w;
          if (O.type === "DragBox")
            return w.push(...k.parseRule(O.children, R || O.slot)), w;
          if (O.type === "DragTool") {
            if (R = O.slot || E, O = O.children[0], at.String(O))
              return w.push(O), w;
            if (O.type === "DragBox")
              return w.push(...k.parseRule(O.children, R || O.slot)), w;
          }
          return O && (O = rt({}, O), R && R !== "default" && (O.slot = R), O.children && O.children.length && (O.children = k.parseRule(O.children)), delete O.key, delete O.component, O._menu && (O._menu.parseRule && O._menu.parseRule(O), delete O._menu), O._fc_drag_tag === "_" && delete O._fc_drag_tag, O._control && (O.control = O._control, delete O._control), O._computed && (O.computed = O._computed, delete O._computed), O.slot || delete O.slot, O.class || delete O.class, (!O.style || !Object.keys(O.style).length) && delete O.style, O._on && (O.on = O._on, delete O._on), O.props && Object.keys(O.props).forEach((I) => {
            const H = O.props[I];
            qn(H) && delete O.props[I];
          }), Object.keys(O).filter((I) => I.indexOf("__") === 0 || Array.isArray(O[I]) && O[I].length === 0 || at.Object(O[I]) && Object.keys(O[I]).length === 0).forEach((I) => {
            delete O[I];
          }), w.push(O)), w;
        }, []);
      },
      fields() {
        return f.dragForm.api.all().map((h) => h.field).filter((h) => !!h);
      },
      baseChange(h, E, w, O) {
        k.handleChange("", h, E, w, O);
      },
      formOptChange(h, E) {
        f.form.value[h] = E, h.indexOf(">") === -1 && (h = "form>" + h);
        let w = f.formOptions;
        const O = h.split(">"), R = O.pop();
        O.forEach((I) => {
          I && (w[I] || (w[I] = {}), w = w[I]);
        }), Ki(w, R, E);
      },
      propRemoveField(h, E, w) {
        var O, R, I;
        if (f.activeRule && w[f.activeRule._fc_id] === f.activeRule) {
          k.unWatchActiveRule();
          const H = h;
          f.dragForm.api.sync(f.activeRule), h.indexOf("__") !== 0 && (h === "formCreateChild" ? delete f.activeRule.children[0] : h.indexOf("formCreate") === 0 || h.indexOf(">") > 0 ? (h.indexOf("formCreate") < 0 && (h = "props>" + h), D(h, ({ source: $, field: Q }) => {
            delete $[Q];
          })) : delete f.activeRule.props[h]), k.watchActiveRule(), (I = (R = (O = f.activeRule._menu) == null ? void 0 : O.watch) == null ? void 0 : R[H]) == null || I.call(R, {
            field: H,
            value: void 0,
            api: w,
            rule: f.activeRule,
            ctx: z
          });
        }
      },
      propChange(h, E, w, O) {
        k.handleChange("props", h, E, w, O);
      },
      styleChange(h, E, w, O) {
        if (f.customForm.config)
          return f.customForm.config.style.change(h, E);
        k.handleChange("", h, E, w, O);
      },
      handleChange(h, E, w, O, R) {
        var I, H, $;
        if (f.activeRule && R[f.activeRule._fc_id] === f.activeRule) {
          k.unWatchActiveRule();
          const Q = E;
          E.indexOf("__") !== 0 && (E === "formCreateChild" ? f.activeRule.children[0] = w : E.indexOf("formCreate") === 0 || E.indexOf(">") > 0 ? (E.indexOf("formCreate") < 0 && (E = (h ? h + ">" : "") + E), D(E, ({ source: U, field: Y }) => {
            qn(w) ? (delete U[Y], f.dragForm.api.sync(f.activeRule)) : Ki(U, Y, w);
          })) : h && qn(w) ? (delete f.activeRule[h][E], f.dragForm.api.sync(f.activeRule)) : Ki(h ? f.activeRule[h] : f.activeRule, E, w)), k.watchActiveRule(), ($ = (H = (I = f.activeRule._menu) == null ? void 0 : I.watch) == null ? void 0 : H[Q]) == null || $.call(H, {
            field: Q,
            value: w,
            api: R,
            rule: f.activeRule,
            ctx: z
          });
        }
      },
      validateChange(h, E, w, O) {
        !f.activeRule || f.validateForm.api[f.activeRule._fc_id] !== f.activeRule || (k.handleChange("", h, E, w, O), f.dragForm.api.refreshValidate(), f.dragForm.api.nextTick(() => {
          f.dragForm.api.clearValidateState(f.activeRule.__fc__.id);
        }));
      },
      triggerActive(h) {
        let E;
        if (at.String(h) && (h = k.findRule(h)), !!h && (h._menu.inside ? E = h.children[0] : E = h.__fc__.parent.rule, E && E.type === "DragTool")) {
          const w = f.dragForm.api.el(E.__fc__.id);
          w && (W.active = w.id, t("active", h), k.toolActive(h));
        }
      },
      customFormChange(h, E) {
        f.customForm.config && f.customForm.config.change(h, E);
      },
      customActive(h) {
        f.baseForm.isShow = !1, f.propsForm.isShow = !1, f.eventShow = !1, f.validateForm.isShow = !1, f.styleForm.isShow = !!h.style && k.getConfig("showStyleForm") !== !1, f.activeRule = null, f.customForm.config = h, f.customForm.isShow = !0, f.customForm.propsShow = h.props && k.getConfig("showPropsForm") !== !1, f.customForm.key = Je(), f.customForm.rule = f.customForm.propsShow ? h.props({ t: _ }) : [], f.customForm.options.formData = h.formData, h.style && (f.styleForm.value = h.style.formData || {}), zn(() => {
          f.activeTab = "props";
        });
      },
      getPropsRule(h) {
        let E = A(h._menu.props, m.value && m.value[h._menu.name], h, {
          t: _,
          api: f.dragForm.api
        });
        if (m.value && m.value.default) {
          const w = m.value.default;
          E = A(() => E, at.Function(w) ? {
            rule: w,
            append: !0
          } : w, h, {
            t: _,
            api: f.dragForm.api
          });
        }
        return E;
      },
      findRule(h) {
        let E;
        const w = (O) => {
          O.forEach((R) => {
            [R.rule.field, R.rule.name, R.rule._fc_id].indexOf(h) > -1 ? E = R.rule : R.children && w(R.children);
          });
        };
        return w(f.treeInfo), E;
      },
      toolActive(h) {
        k.unWatchActiveRule(), f.customForm.isShow = !1, f.customForm.config = null, f.activeRule && (delete f.propsForm.api[f.activeRule._fc_id], delete f.baseForm.api[f.activeRule._fc_id], delete f.validateForm.api[f.activeRule._fc_id], delete f.styleForm.api[f.activeRule._fc_id], delete f.dragForm.api.activeRule), f.activeRule = h, f.dragForm.api.activeRule = h, zn(() => {
          f.activeTab = "props", zn(() => {
            f.propsForm.api[f.activeRule._fc_id] = f.activeRule, f.baseForm.api[f.activeRule._fc_id] = f.activeRule, f.validateForm.api[f.activeRule._fc_id] = f.activeRule, f.styleForm.api[f.activeRule._fc_id] = f.activeRule;
          });
        }), f.cacheProps[h._fc_id] || (f.cacheProps[h._fc_id] = k.getPropsRule(h));
        const E = k.getConfig("hiddenItemConfig", {}), w = k.getConfig("disabledItemConfig", {}), O = Wc([...(E == null ? void 0 : E.default) || [], ...(E == null ? void 0 : E[h._menu.name]) || [], ...h._menu.hiddenBaseField || []]), R = Wc([...(w == null ? void 0 : w.default) || [], ...(w == null ? void 0 : w[h._menu.name]) || []]);
        f.baseForm.api.hidden(!1), f.baseForm.api.disabled(!1), O.length && (f.baseForm.api.hidden(!0, O), zn(() => {
          f.propsForm.api.hidden(!0, O);
        })), R.length && (f.baseForm.api.disabled(!0, R), zn(() => {
          f.propsForm.api.disabled(!0, R);
        })), k.getConfig("showControl", !0) || f.baseForm.api.hidden(!0, "_control");
        const I = Fr(h, "field");
        f.baseForm.isShow = I && h.input !== !1 && k.getConfig("showBaseForm") !== !1, f.propsForm.isShow = f.cacheProps[h._fc_id].length > 0 && k.getConfig("showPropsForm") !== !1, f.eventShow = h._menu.event && h._menu.event.length > 0 && k.getConfig("showEventForm") !== !1, f.styleForm.isShow = h._menu.style !== !1 && k.getConfig("showStyleForm") !== !1, f.validateForm.isShow = f.baseForm.isShow && h._menu.validate !== !1 && k.getConfig("showValidateForm") !== !1, f.propsForm.rule = f.cacheProps[h._fc_id], k.updateRuleFormData(), k.watchActiveRule();
      },
      getConfig(h, E) {
        return K.value && Fr(K.value, h) ? K.value[h] : E;
      },
      updateRuleFormData() {
        const h = f.activeRule;
        let E = {
          formCreateChild: "" + h.children[0],
          "formCreateWrap>labelWidth": ""
        };
        const w = K.value.appendConfigData;
        at.Function(w) ? E = rt(rt({}, E), w(h)) : Array.isArray(w) && w.forEach((R) => {
          E[R] = void 0;
        }), Object.keys(h).forEach((R) => {
          ["effect", "config", "payload", "id", "type", "_menu"].indexOf(R) < 0 && (E["formCreate" + po(R)] = Nt(h[R]));
        }), Object.keys(h.props).forEach((R) => {
          const I = h.props[R];
          E[R] = Nt(I), at.Object(I) && Object.keys(I).forEach((H) => {
            E[R + ">" + H] = Nt(I[H]);
          });
        }), ["props", "effect", "attrs", "style", "wrap"].forEach((R) => {
          h[R] && typeof h[R] == "object" && Object.keys(h[R]).forEach((I) => {
            E["formCreate" + po(R) + ">" + I] = Nt(h[R][I]);
          });
        });
        const O = h._menu.attrs || {};
        Object.keys(O).forEach((R) => {
          E["__" + R] = O[R]({ rule: h });
        }), f.propsForm.value = E, f.styleForm.value = {
          style: h.style,
          class: h.class,
          id: h.id
        }, f.baseForm.isShow && (f.baseForm.value = rt({
          field: h.field,
          title: h.title || "",
          info: h.info,
          _control: h._control
        }, E), f.validateForm.value = {
          validate: h.validate ? [...h.validate] : [],
          $required: E.formCreate$required
        }, f.dragForm.api.refreshValidate(), f.dragForm.api.nextTick(() => {
          f.dragForm.api.clearValidateState(h.__fc__.id);
        }));
      },
      dragStart(h) {
        f.moveRule = h, f.added = !1;
      },
      dragUnchoose(h, E) {
        f.addRule = {
          children: h,
          oldIndex: E.oldIndex
        };
      },
      clickMenu(h) {
        k.dragMenu({ menu: h, children: f.children, index: f.children.length });
      },
      checkOnly(h) {
        let E = !1;
        return f.dragForm.api.all().forEach((w) => {
          E = E || w._fc_template === h.name || w._menu && w._menu.name === h.name;
        }), E && On(f.t("struct.only", { label: _("com." + h.name + ".name") || h.label })), E;
      },
      dragMenu({ menu: h, children: E, index: w, slot: O }) {
        if (f.inputForm.state || h.only && k.checkOnly(h))
          return;
        k.handleAddBefore();
        const R = f.dragRuleList[h.name];
        t("drag", {
          item: h,
          dragRule: R
        });
        const I = k.makeRule(f.dragRuleList[R.name]);
        O && (I.slot = O), E.splice(w, 0, I);
        const H = I.type === "DragTool" ? I.children[0] : I;
        k.handleAddAfter({ rule: I }), H && k.getConfig("autoActive", !0) && zn(() => {
          k.triggerActive(H);
        });
      },
      replaceField(h) {
        const E = ["array", "object"].indexOf(h._menu.subForm) > -1;
        let w = k.parseRule(Nt([h]))[0];
        return E && (w.field = Je()), w = qe.toJson([w]), E ? w = k.batchReplaceUni(w) : w = k.batchReplaceField(w), k.loadRule(qe.parseJson(w))[0];
      },
      batchReplaceField(h) {
        const E = /"field"\s*:\s*"(\w[\w\d]+)"/g;
        return h = h.replace(E, (w, O) => `"field":"${Je()}"`), k.batchReplaceUni(h);
      },
      batchReplaceUni(h) {
        const E = /"_fc_id"\s*:\s*"(\w[\w\d]+)"/g;
        return h = h.replace(E, () => `"_fc_id":"id_${Je()}"`), h;
      },
      dragAdd(h, E, w) {
        const O = E.newIndex, R = E.item._underlying_vm_ || E.item.__rule__;
        if (R && R.__fc__) {
          if (f.addRule) {
            k.handleSortBefore();
            const I = f.addRule.children.splice(f.addRule.children.indexOf(R), 1)[0];
            w ? I.slot = w : delete I.slot, h.splice(O, 0, I), k.handleSortAfter({ rule: I });
          }
        } else
          k.dragMenu({ menu: R, children: h, index: O, slot: w });
        f.added = !0;
      },
      dragEnd(h, { newIndex: E, oldIndex: w }, O) {
        if (!f.added && !(f.moveRule === h && E === w)) {
          k.handleSortBefore();
          const R = f.moveRule.splice(w, 1);
          O && (R.slot = O), h.splice(E, 0, R[0]), k.handleSortAfter({ rule: R[0] });
        }
        f.moveRule = null, f.addRule = null, f.added = !1;
      },
      getSlotConfig(h, E, w) {
        let O = {};
        return (h.slot || []).forEach((R) => {
          R.name === E && (O = R.config || {});
        }), rt(vr(rt({}, w), { dragBtn: !1, handleBtn: w.children ? ["addChild"] : !1 }), O);
      },
      makeRule(h, E) {
        const w = E || h.rule({ t: _ });
        w._menu = mi(h), w._fc_id || (w._fc_id = "id_" + Je()), w.name || (w.name = "ref_" + Je()), h.component && (w.component = mi(h.component)), w._computed || (w._computed = {}), w.wrap || (w.wrap = {}), w.style || (w.style = {}), w.class || (w.class = ""), w.effect || (w.effect = {}), Fr(w, "field") && !Fr(w, "$required") && (w.$required = !1), Fr(w, "display") || (w.display = !0), Fr(w, "hidden") || (w.hidden = !1), w._fc_drag_tag = h.name;
        let O = h.only === !0, R;
        const I = w.children || [];
        if (h.drag && (w.children = [R = k.makeDrag(h.drag, w._menu ? w._menu.name : w.type, I, {
          end: ($, Q) => k.dragEnd($.self.children, Q),
          add: ($, Q) => k.dragAdd($.self.children, Q),
          start: ($, Q) => k.dragStart($.self.children, Q),
          unchoose: ($, Q) => k.dragUnchoose($.self.children, Q)
        })]), h.children && !E && !I.length)
          for (let $ = 0; $ < (h.childrenLen || 1); $++) {
            const Q = k.makeRule(f.dragRuleList[h.children]);
            (R || w).children.push(Q);
          }
        const H = M.value !== void 0 ? M.value !== !1 : h.mask !== !1;
        return h.tool === !1 ? w : h.inside ? (w.children = k.makeChildren([{
          type: "DragTool",
          props: {
            dragBtn: h.dragBtn !== !1,
            children: h.children,
            mask: H,
            handleBtn: h.handleBtn,
            only: O
          },
          inject: !0,
          on: {
            delete: ({ self: $ }) => {
              const Q = k.getParent($).parent;
              k.handleRemoveBefore({ parent: Q, rule: Q }) !== !1 && (Q.__fc__.rm(), t("delete", Q), f.activeRule === Q && k.clearActiveRule(), k.handleRemoveAfter({ rule: Q }));
            },
            create: ({ self: $ }) => {
              k.handleAddBefore();
              const Q = k.getParent($);
              t("create", Q.parent);
              const U = k.makeRule(Q.parent._menu);
              Q.parent.slot && (U.slot = Q.parent.slot), Q.root.children.splice(Q.root.children.indexOf(Q.parent) + 1, 0, U), k.handleAddAfter({ rule: Q.parent });
            },
            addChild: ({ self: $ }) => {
              k.handleAddBefore();
              const Q = k.getParent($), U = Q.parent._menu, Y = f.dragRuleList[U.children];
              if (!Y) return;
              const X = k.makeRule(Y);
              (U.drag ? Q.parent.children[0] : Q.parent).children[0].children.push(X), k.handleAddAfter({ rule: X });
            },
            copy: ({ self: $ }) => {
              k.handleCopyBefore();
              const Q = k.getParent($);
              t("copy", Q.parent);
              const U = k.replaceField(Q.parent);
              Q.root.children.splice(Q.root.children.indexOf(Q.parent) + 1, 0, U), k.handleCopyAfter({ rule: Q.parent });
            },
            active: ({ self: $ }) => {
              const Q = k.getParent($);
              t("active", Q.parent), setTimeout(() => {
                k.toolActive(Q.parent);
              }, 10);
            }
          },
          children: w.children
        }]), w) : {
          type: "DragTool",
          props: {
            dragBtn: h.dragBtn !== !1,
            children: h.children,
            mask: H,
            handleBtn: h.handleBtn,
            only: O
          },
          inject: !0,
          display: !!w.display,
          on: {
            delete: ({ self: $ }) => {
              k.handleRemoveBefore({ parent: $, rule: $.children[0] }) !== !1 && (t("delete", $.children[0]), $.__fc__.rm(), f.activeRule === $.children[0] && k.clearActiveRule(), k.handleRemoveAfter({ rule: $.children[0] }));
            },
            create: ({ self: $ }) => {
              k.handleAddBefore(), t("create", $.children[0]);
              const Q = k.getParent($), U = k.makeRule($.children[0]._menu);
              Q.parent.slot && (U.slot = Q.parent.slot), Q.root.children.splice(Q.root.children.indexOf(Q.parent) + 1, 0, U), k.handleAddAfter({ rule: U });
            },
            addChild: ({ self: $ }) => {
              k.handleAddBefore();
              const Q = $.children[0]._menu, U = f.dragRuleList[Q.children];
              if (!U) return;
              const Y = k.makeRule(U);
              (Q.drag ? $.children[0] : $).children[0].children.push(Y), k.handleAddAfter({ rule: Y });
            },
            copy: ({ self: $ }) => {
              k.handleCopyBefore(), t("copy", $.children[0]);
              const Q = k.getParent($), U = k.replaceField($.children[0]);
              $.slot && (U.slot = $.slot), Q.root.children.splice(Q.root.children.indexOf(Q.parent) + 1, 0, U), k.handleCopyAfter({ rule: $.children[0] });
            },
            active: ({ self: $ }) => {
              t("active", $.children[0]), setTimeout(() => {
                k.toolActive($.children[0]);
              }, 10);
            }
          },
          children: k.makeChildren([w])
        };
      },
      toolHandle(h, E) {
        if (!h._fc_drag_tag || h._menu.tool === !1) {
          h.__fc__.rm();
          return;
        }
        let w;
        h._menu.inside ? w = h.children[0].__fc__.exportEl : w = h.__fc__.parent.exportEl, w.$emit(E);
      },
      handleAddBefore() {
      },
      handleRemoveBefore() {
      },
      handleCopyBefore() {
      },
      handleSortBefore() {
      },
      addOperationRecord() {
        const h = k.getJson(), E = Nt(f.inputForm.data), w = f.operation.list.slice(0, f.operation.idx + 1);
        w.push({ rule: h, formData: E }), f.operation.list = w, f.operation.idx = w.length - 1, f.unloadStatus = w.length !== 1;
      },
      prevOperationRecord() {
        if (!f.operation.list[f.operation.idx - 1])
          return;
        const h = f.operation.list[--f.operation.idx];
        k.useOperationRecord(h), k.clearActiveRule();
      },
      nextOperationRecord() {
        if (!f.operation.list[f.operation.idx + 1])
          return;
        const h = f.operation.list[++f.operation.idx];
        k.useOperationRecord(h), k.clearActiveRule();
      },
      useOperationRecord(h) {
        f.inputForm.data = h.formData, k.setRule(h.rule);
      },
      handleAddAfter() {
        k.addOperationRecord(), k.updateTree();
      },
      handleRemoveAfter() {
        k.addOperationRecord(), k.updateTree();
      },
      handleCopyAfter() {
        k.addOperationRecord(), k.updateTree();
      },
      handleSortAfter() {
        k.addOperationRecord(), k.updateTree();
      },
      treeChange(h) {
        k.triggerActive(h.rule);
      },
      getFormDescription() {
        return zc(k.getDescription());
      },
      getDescription() {
        return Uc(f.dragForm.rule[0].children);
      },
      getSubFormDescription(h) {
        let E = h.__fc__ && h.__fc__.parent;
        for (; E; ) {
          if (E.rule._menu && ["array", "object"].indexOf(E.rule._menu.subForm) > -1)
            return zc(Uc(E.rule.children));
          E = E.parent;
        }
        return null;
      },
      getSubFormChildren(h) {
        let E = h.__fc__ && h.__fc__.parent;
        for (; E; ) {
          if (E.rule._menu && ["array", "object"].indexOf(E.rule._menu.subForm) > -1)
            return E.rule.children || [];
          E = E.parent;
        }
        return null;
      },
      updateTree: am(function() {
        zn(() => {
          f.treeInfo = ps(f.dragForm.rule[0].children);
        });
      }, 300),
      findTree(h) {
        let E;
        const w = (O) => {
          O.forEach((R) => {
            R.rule.field === h ? E = R.children : R.children && w(R.children);
          });
        };
        return w(f.treeInfo), E || [];
      },
      handleDragenter(h) {
        f.bus.$emit("dragenter", h);
      },
      handleDragleave(h) {
        f.bus.$emit("dragleave", h);
      },
      handleDrop(h) {
        f.bus.$emit("drop", h);
      },
      changeEvent(h) {
        Ki(f.activeRule, "_on", h);
      },
      triggerHandle(h) {
        h.handle();
      }
    };
    f.dragForm.rule = k.makeDragRule(k.makeChildren(f.children)), k.setOption({}), l.value || k.addComponent(eg);
    const L = Un(() => Object.keys(f.inputForm.data).length > 0);
    return vr(rt(rt({}, Ic(f)), k), {
      dragHeight: u,
      t: _,
      handle: F,
      inputCheckStatus: L,
      fieldReadonly: v,
      hiddenMenu: C,
      hiddenItem: p,
      hiddenDragMenu: b,
      hiddenDragBtn: x
    });
  },
  created() {
    document.body.ondrop = (i) => {
      i.preventDefault(), i.stopPropagation();
    }, window.onbeforeunload = (i) => {
      this.unloadStatus && (i.returnValue = this.t("designer.unload"));
    };
  }
});
var Pm = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("el-container", { staticClass: "_fc-designer", style: t.height ? `height:${t.dragHeight};flex:0;` : "", on: { dragenter: t.handleDragenter, dragleave: t.handleDragleave, drop: t.handleDrop } }, [l("el-main", [l("el-container", { key: t.locale && t.locale.name, staticStyle: { height: "100%" } }, [l("el-aside", { staticClass: "_fc-l", attrs: { width: "266px" } }, [l("el-container", { staticStyle: { height: "100%" } }, [l("el-header", { staticClass: "_fc-l-tabs", attrs: { height: "40px" } }, [l("div", { staticClass: "_fc-l-tab", class: { active: t.activeMenuTab === "menu" }, on: { click: function(c) {
    t.activeMenuTab = "menu";
  } } }, [t._v(" " + t._s(t.t("menu.component")) + " ")]), l("div", { staticClass: "_fc-l-tab", class: { active: t.activeMenuTab === "tree" }, on: { click: function(c) {
    t.activeMenuTab = "tree";
  } } }, [t._v(" " + t._s(t.t("menu.tree")) + " ")])]), l("el-main", { directives: [{ name: "show", rawName: "v-show", value: t.activeMenuTab === "menu", expression: "activeMenuTab === 'menu'" }] }, [t._l(t.menuList, function(c, M) {
    return [t.hiddenMenu.indexOf(c.name) === -1 ? l("div", { key: M, staticClass: "_fc-l-group" }, [l("h4", { staticClass: "_fc-l-title", on: { click: function(T) {
      return t.$set(c, "hidden", !c.hidden);
    } } }, [t._v(" " + t._s(t.t("menu." + c.name) || c.title) + " "), l("i", { staticClass: "fc-icon icon-arrow", class: { down: !c.hidden } })]), l("fcDraggable", { directives: [{ name: "show", rawName: "v-show", value: !c.hidden, expression: "!item.hidden" }], staticClass: "_fc-l-list", attrs: { group: { name: "default", pull: "clone", put: !1 }, sort: !1, itemKey: "name", list: c.list } }, [t._l(c.list, function(T, F) {
      return [t.hiddenItem.indexOf(T.name) === -1 ? l("div", { key: F, staticClass: "_fc-l-item", on: { click: function(z) {
        return t.clickMenu(T);
      } } }, [l("div", { staticClass: "_fc-l-icon" }, [l("i", { staticClass: "fc-icon", class: T.icon || "icon-input" })]), l("span", { staticClass: "_fc-l-name" }, [t._v(t._s(t.t("com." + T.name + ".name") || T.label))])]) : t._e()];
    })], 2)], 1) : t._e()];
  })], 2), t.activeMenuTab === "tree" ? l("el-main", [l("el-tree", { ref: "treeRef", attrs: { data: t.treeInfo, "default-expand-all": "", "expand-on-click-node": !1 }, scopedSlots: t._u([{ key: "default", fn: function({ node: c, data: M }) {
    return [l("div", { staticClass: "_fc-tree-node", class: { active: t.activeRule === M.rule }, on: { click: function(T) {
      return t.treeChange(M);
    } } }, [l("div", { staticClass: "_fc-tree-label" }, [l("i", { staticClass: "fc-icon", class: M.rule._menu && M.rule._menu.icon || "icon-cell" }), l("span", [t._v(t._s((M.rule.title || "").trim() || M.rule.props && M.rule.props.label || t.t("com." + (M.rule._menu && M.rule._menu.name) + ".name") || M.rule.type))])]), M.slot ? t._e() : l("div", { staticClass: "_fc-tree-more", on: { click: function(T) {
      T.stopPropagation();
    } } }, [l("el-dropdown", { attrs: { trigger: "click", size: "default" }, on: { command: (T) => t.toolHandle(M.rule, T) }, scopedSlots: t._u([{ key: "dropdown", fn: function() {
      return [l("el-dropdown-menu", [M.rule._fc_drag_tag !== "_" ? l("el-dropdown-item", { key: "1", attrs: { command: "copy" } }, [t._v(" " + t._s(t.t("props.copy")) + " ")]) : t._e(), M.rule._menu && M.rule._menu.children && M.rule._fc_drag_tag !== "_" ? l("el-dropdown-item", { key: "2", attrs: { command: "addChild" } }, [t._v(" " + t._s(t.t("form.appendChild")) + " ")]) : t._e(), l("el-dropdown-item", { key: "3", attrs: { command: "delete" } }, [t._v(" " + t._s(t.t("props.delete")) + " ")])], 1)];
    }, proxy: !0 }], null, !0) }, [l("i", { staticClass: "fc-icon icon-more" })])], 1)])];
  } }], null, !1, 3096078697) })], 1) : t._e()], 1)], 1), l("el-container", { staticClass: "_fc-m" }, [l("el-header", { staticClass: "_fc-m-tools", attrs: { height: "45" } }, [l("div", { staticClass: "_fc-m-tools-l" }, [t.inputForm.state ? t._e() : [t.getConfig("showDevice") !== !1 ? [l("div", { staticClass: "devices" }, [l("i", { staticClass: "fc-icon icon-pc2", class: { active: t.device === "pc" }, on: { click: function(c) {
    t.device = "pc";
  } } }), l("i", { staticClass: "fc-icon icon-pad2", class: { active: t.device === "pad" }, on: { click: function(c) {
    t.device = "pad";
  } } }), l("i", { staticClass: "fc-icon icon-mobile2", class: { active: t.device === "mobile" }, on: { click: function(c) {
    t.device = "mobile";
  } } })]), l("div", { staticClass: "line" })] : t._e(), l("div", [l("i", { staticClass: "fc-icon icon-pre-step", class: { disabled: !t.operation.list[t.operation.idx - 1] }, on: { click: t.prevOperationRecord } }), l("i", { staticClass: "fc-icon icon-next-step", class: { disabled: !t.operation.list[t.operation.idx + 1] }, on: { click: t.nextOperationRecord } })])]], 2), l("div", { staticClass: "_fc-m-tools-r" }, [t.inputForm.state ? t._e() : [t._t("handle"), t.getConfig("showSaveBtn", !1) ? l("el-button", { attrs: { type: "success", plain: "", size: "mini" }, on: { click: t.handleSave } }, [l("i", { staticClass: "fc-icon icon-save-online" }), t._v(" " + t._s(t.t("props.save")) + " ")]) : t._e(), l("el-button", { attrs: { type: "primary", plain: "", size: "mini" }, on: { click: t.openPreview } }, [l("i", { staticClass: "fc-icon icon-preview" }), t._v(" " + t._s(t.t("props.preview")) + " ")]), l("el-popconfirm", { staticStyle: { display: "block", margin: "10px" }, attrs: { title: t.t("designer.clearWarn"), "confirm-button-text": t.t("props.clear"), "cancel-button-text": t.t("props.cancel") }, on: { confirm: t.clearDragRule }, scopedSlots: t._u([{ key: "reference", fn: function() {
    return [l("el-button", { attrs: { type: "danger", plain: "", size: "mini" } }, [l("i", { staticClass: "fc-icon icon-delete" }), t._v(t._s(t.t("props.clear")) + " ")])];
  }, proxy: !0 }], null, !1, 2674624104) }), t.handle && t.handle.length ? l("el-dropdown", { attrs: { trigger: "click", size: "default" }, on: { command: t.triggerHandle }, scopedSlots: t._u([{ key: "dropdown", fn: function() {
    return [l("el-dropdown-menu", t._l(t.handle, function(c) {
      return l("el-dropdown-item", { attrs: { command: c } }, [l("div", [t._v(t._s(c.label))])]);
    }), 1)];
  }, proxy: !0 }], null, !1, 3665106710) }, [l("el-button", { staticClass: "_fd-m-extend", attrs: { plain: "", size: "mini" } }, [l("i", { staticClass: "fc-icon icon-more" })])], 1) : t._e()], t.getConfig("showInputData", !0) ? [l("div", { staticClass: "line" }), l("div", { staticClass: "_fd-input-btn" }, [t.inputCheckStatus ? l("i", { staticClass: "fc-icon icon-check" }) : t._e(), l("span", [t._v(t._s(t.t("props.inputData")) + "：")]), l("el-switch", { attrs: { size: "mini", value: t.inputForm.state, "inline-prompt": "" }, on: { input: t.openInputData } })], 1)] : t._e()], 2)]), l("el-main", { staticClass: "_fc-m-con" }, [l("a", { key: t.activeRule ? t.activeRule._fc_id : "", staticStyle: { "background-image": "url(data:image/png;base64,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) !important", "background-repeat": "no-repeat !important", "background-size": "cover !important", "background-position": "center !important", position: "absolute !important", overflow: "hidden !important", left: "50% !important", width: "160px!important", right: "0 !important", top: "auto !important", bottom: "9px !important", display: "block !important", height: "17px !important", "text-align": "center !important", opacity: "1 !important", visibility: "visible !important", margin: "0 0 0 -80px !important", padding: "0 !important" }, attrs: { target: "_blank", href: "https://form-create.com/" } }), l("div", { ref: "dragCon", staticClass: "_fc-m-drag", class: t.device, style: { "--fc-drag-empty": `'${t.t("designer.dragEmpty")}'`, "--fc-child-empty": `'${t.t("designer.childEmpty")}'` } }, [t.inputForm.state ? l("div", { staticClass: "_fc-m-input" }, [l("ViewForm", { key: t.inputForm.key, attrs: { rule: t.inputForm.rule, option: t.inputForm.option, disabled: !1 }, model: { value: t.inputForm.api, callback: function(c) {
    t.$set(t.inputForm, "api", c);
  }, expression: "inputForm.api" } })], 1) : l("DragForm", { attrs: { rule: t.dragForm.rule, option: t.formOptions }, model: { value: t.dragForm.api, callback: function(c) {
    t.$set(t.dragForm, "api", c);
  }, expression: "dragForm.api" } })], 1), t.inputForm.state ? l("div", { staticClass: "_fc-m-input-handle" }, [l("el-button", { attrs: { plain: "" }, on: { click: function(c) {
    return t.inputClear();
  } } }, [t._v(t._s(t.t("props.clear")))]), l("el-button", { attrs: { plain: "" }, on: { click: function(c) {
    return t.inputReset();
  } } }, [t._v(t._s(t.t("props.reset")))]), l("el-button", { attrs: { type: "primary", plain: "" }, on: { click: function(c) {
    return t.inputSave();
  } } }, [t._v(t._s(t.t("props.save")))])], 1) : t._e()])], 1), !t.config || t.config.showConfig !== !1 ? l("el-aside", { staticClass: "_fc-r", attrs: { width: "320px" } }, [l("el-container", { staticStyle: { height: "100%" } }, [l("el-header", { staticClass: "_fc-r-tabs", attrs: { height: "40px" } }, [t.activeRule || t.customForm.isShow || t.config && t.config.showFormConfig === !1 ? l("div", { staticClass: "_fc-r-tab", class: { active: t.activeTab === "props" }, on: { click: function(c) {
    t.activeTab = "props";
  } } }, [t._v(" " + t._s(t.t("designer.component")) + " ")]) : t._e(), !t.config || t.config.showFormConfig !== !1 ? l("div", { staticClass: "_fc-r-tab", class: { active: t.activeTab === "form" && (!!t.activeRule || t.customForm.isShow) }, on: { click: function(c) {
    t.activeTab = "form";
  } } }, [t._v(t._s(t.t("designer.form")) + " ")]) : t._e()]), !t.config || t.config.showFormConfig !== !1 ? l("el-main", { directives: [{ name: "show", rawName: "v-show", value: t.activeTab === "form", expression: "activeTab==='form'" }], staticClass: "_fc-r-tab-form" }, [l("DragForm", { attrs: { rule: t.form.rule, option: t.form.option, value: t.form.value }, on: { change: t.formOptChange }, model: { value: t.form.api, callback: function(c) {
    t.$set(t.form, "api", c);
  }, expression: "form.api" } })], 1) : t._e(), l("el-main", { directives: [{ name: "show", rawName: "v-show", value: t.activeTab === "props", expression: "activeTab==='props'" }], key: t.activeRule ? t.activeRule._fc_id : t.customForm.config ? t.customForm.key : "", staticClass: "_fc-r-tab-props" }, [t.activeRule || t.customForm.config && (t.customForm.config.name || t.customForm.config.label) ? [l("p", { staticClass: "_fc-r-title" }, [t._v(t._s(t.t("designer.type")))]), l("TypeSelect"), t.activeRule && t.activeRule.name ? [l("p", { staticClass: "_fc-r-title" }, [t._v(t._s(t.t("designer.name")))]), l("el-input", { staticClass: "_fc-r-name-input", attrs: { size: "mini", value: t.activeRule.name, readonly: "" }, scopedSlots: t._u([{ key: "suffix", fn: function() {
    return [l("i", { staticClass: "fc-icon icon-group", on: { click: t.copyName } })];
  }, proxy: !0 }, { key: "append", fn: function() {
    return [l("i", { staticClass: "fc-icon icon-auto", on: { click: t.updateName } })];
  }, proxy: !0 }], null, !1, 2892183956) })] : t._e()] : t._e(), t.baseForm.isShow ? l("el-divider", [t._v(t._s(t.t("designer.rule")))]) : t._e(), l("DragForm", { directives: [{ name: "show", rawName: "v-show", value: t.baseForm.isShow, expression: "baseForm.isShow" }], attrs: { rule: t.baseForm.rule, option: t.baseForm.options, value: t.baseForm.value }, on: { change: t.baseChange }, model: { value: t.baseForm.api, callback: function(c) {
    t.$set(t.baseForm, "api", c);
  }, expression: "baseForm.api" } }), t.propsForm.isShow ? l("el-divider", [t._v(t._s(t.t("designer.props")))]) : t._e(), l("DragForm", { directives: [{ name: "show", rawName: "v-show", value: t.propsForm.isShow, expression: "propsForm.isShow" }], attrs: { rule: t.propsForm.rule, option: t.propsForm.options, value: t.propsForm.value }, on: { change: t.propChange, removeField: t.propRemoveField }, model: { value: t.propsForm.api, callback: function(c) {
    t.$set(t.propsForm, "api", c);
  }, expression: "propsForm.api" } }), t.customForm.isShow && t.customForm.propsShow ? l("el-divider", [t._v(" " + t._s(t.t("designer.props")) + " ")]) : t._e(), t.customForm.isShow && t.customForm.propsShow ? l("DragForm", { key: t.customForm.key, attrs: { rule: t.customForm.rule, option: t.customForm.options }, on: { change: t.customFormChange }, model: { value: t.customForm.api, callback: function(c) {
    t.$set(t.customForm, "api", c);
  }, expression: "customForm.api" } }) : t._e(), t.styleForm.isShow ? l("el-divider", [t._v(t._s(t.t("designer.style")) + " ")]) : t._e(), l("DragForm", { directives: [{ name: "show", rawName: "v-show", value: t.styleForm.isShow, expression: "styleForm.isShow" }], attrs: { rule: t.styleForm.rule, option: t.styleForm.options, value: t.styleForm.value }, on: { change: t.styleChange }, model: { value: t.styleForm.api, callback: function(c) {
    t.$set(t.styleForm, "api", c);
  }, expression: "styleForm.api" } }), t.eventShow ? l("el-divider", [t._v(" " + t._s(t.t("designer.event")) + " ")]) : t._e(), t.eventShow ? l("EventConfig", { attrs: { "event-name": t.activeRule && t.activeRule._menu.event || [], "component-name": t.activeRule && t.activeRule._menu.name || "", value: t.activeRule && t.activeRule._on || {} }, on: { input: t.changeEvent } }) : t._e(), t.activeRule ? [t.validateForm.isShow ? l("el-divider", [t._v(t._s(t.t("designer.validate")) + " ")]) : t._e(), t.validateForm.isShow ? l("DragForm", { key: t.activeRule._fc_id, attrs: { rule: t.validateForm.rule, option: t.validateForm.options, value: t.validateForm.value }, on: { change: t.validateChange }, model: { value: t.validateForm.api, callback: function(c) {
    t.$set(t.validateForm, "api", c);
  }, expression: "validateForm.api" } }) : t._e()] : t._e()], 2)], 1)], 1) : t._e(), l("el-dialog", { staticClass: "_fd-preview-dialog", attrs: { visible: t.preview.state, width: "800px", "append-to-body": "" }, on: { "update:visible": function(c) {
    return t.$set(t.preview, "state", c);
  } } }, [l("el-tabs", { staticClass: "_fd-preview-tabs", model: { value: t.previewStatus, callback: function(c) {
    t.previewStatus = c;
  }, expression: "previewStatus" } }, [l("el-tab-pane", { attrs: { label: t.t("form.formMode"), name: "form" } }), l("el-tab-pane", { attrs: { label: t.t("form.componentMode"), name: "component" } })], 1), t.previewStatus === "form" ? [t.preview.state ? l("ViewForm", { attrs: { rule: t.preview.rule, option: t.preview.option }, model: { value: t.preview.api, callback: function(c) {
    t.$set(t.preview, "api", c);
  }, expression: "preview.api" } }) : t._e()] : l("pre", { staticClass: "_fd-preview-code" }, [l("code", { domProps: { innerHTML: t._s(t.preview.html) } })])], 2)], 1)], 1)], 1);
}, Hm = [], jm = /* @__PURE__ */ lt(
  Bm,
  Pm,
  Hm,
  !1,
  null,
  null
);
const wr = jm.exports, $m = ft({
  name: "DragTool",
  emits: ["create", "copy", "addChild", "delete", "active", "fc.el"],
  props: {
    dragBtn: Boolean,
    children: String,
    mask: Boolean,
    handleBtn: [Boolean, Array],
    formCreateInject: Object,
    unique: String,
    only: Boolean
  },
  inject: {
    fcx: {
      default: null
    },
    designer: {
      default: null
    },
    dragTool: {
      default: null
    }
  },
  provide() {
    return {
      dragTool: this
    };
  },
  computed: {
    isCreate() {
      return this.dragTool ? !!this.dragTool.children : !1;
    },
    btns() {
      return Array.isArray(this.handleBtn) ? this.handleBtn.length ? this.handleBtn : !1 : this.handleBtn !== !1;
    },
    id() {
      return this.unique || this.formCreateInject.rule.__fc__.id;
    },
    hiddenMenu() {
      return this.designer.hiddenDragMenu;
    },
    hiddenBtn() {
      return this.designer.hiddenDragBtn;
    }
  },
  methods: {
    active() {
      this.fcx.active !== this.id && (this.fcx.active = this.id, this.$emit("active"));
    }
  },
  mounted() {
    this.$emit("fc.el", this);
  }
});
var zm = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_fd-drag-tool", class: { active: t.fcx.active === t.id }, on: { click: function(c) {
    return c.stopPropagation(), t.active.apply(null, arguments);
  } } }, [t.mask ? l("div", { staticClass: "_fd-drag-mask" }) : t._e(), t.hiddenBtn ? t._e() : l("div", { staticClass: "_fd-drag-l" }, [t.fcx.active === t.id && t.dragBtn !== !1 ? l("div", { staticClass: "_fd-drag-btn", staticStyle: { cursor: "move" } }, [l("i", { staticClass: "fc-icon icon-move" })]) : t._e()]), t.btns !== !1 && !t.hiddenMenu ? l("div", { staticClass: "drag-r" }, [t._t("handle", function() {
    return [t.isCreate && (t.btns === !0 || t.btns.indexOf("create") > -1) ? l("div", { staticClass: "_fd-drag-btn", on: { click: function(c) {
      return t.$emit("create");
    } } }, [l("i", { staticClass: "fc-icon icon-add" })]) : t._e(), !t.only && (t.btns === !0 || t.btns.indexOf("copy") > -1) ? l("div", { staticClass: "_fd-drag-btn", on: { click: function(c) {
      return t.$emit("copy");
    } } }, [l("i", { staticClass: "fc-icon icon-copy" })]) : t._e(), t.children && (t.btns === !0 || t.btns.indexOf("addChild") > -1) ? l("div", { staticClass: "_fd-drag-btn", on: { click: function(c) {
      return t.$emit("addChild");
    } } }, [l("i", { staticClass: "fc-icon icon-add-child" })]) : t._e(), t.btns === !0 || t.btns.indexOf("delete") > -1 ? l("div", { staticClass: "_fd-drag-btn _fd-drag-danger", on: { click: function(c) {
      return t.$emit("delete");
    } } }, [l("i", { staticClass: "fc-icon icon-delete" })]) : t._e()];
  })], 2) : t._e(), t._t("default")], 2);
}, Um = [], Wm = /* @__PURE__ */ lt(
  $m,
  zm,
  Um,
  !1,
  null,
  null
);
const ud = Wm.exports, Qm = ft({
  name: "Struct",
  emits: ["input"],
  props: {
    value: [Object, Array, Function],
    title: String,
    defaultValue: {
      require: !1
    },
    validate: Function
  },
  inject: ["designer"],
  computed: {
    t() {
      return this.designer.t;
    },
    configured() {
      return !Rf(this.value);
    }
  },
  data() {
    return {
      editor: null,
      visible: !1,
      oldVal: null
    };
  },
  watch: {
    value() {
      this.load();
    },
    visible(i) {
      i && this.load();
    }
  },
  methods: {
    load() {
      const i = Ar(If(this.value ? Nt(this.value) : this.defaultValue));
      this.oldVal = i, this.$nextTick(() => {
        this.editor = mi(gi(this.$refs.editor, {
          lineNumbers: !0,
          mode: "javascript",
          lint: !0,
          line: !0,
          tabSize: 2,
          lineWrapping: !0,
          value: i || ""
        }));
      });
    },
    onOk() {
      const i = this.editor.getValue();
      let t;
      try {
        t = new Function("return " + i)();
      } catch (l) {
        return console.error(l), On(this.t("struct.errorMsg")), !1;
      }
      return this.validate && this.validate(t) === !1 ? (On(this.t("struct.errorMsg")), !1) : (this.visible = !1, Ar(t) !== this.oldVal && this.$emit("input", t), !0);
    }
  }
});
var Vm = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_fd-struct" }, [l("el-badge", { attrs: { type: "warning", "is-dot": "", hidden: !t.configured } }, [l("el-button", { attrs: { size: "mini" }, on: { click: function(c) {
    t.visible = !0;
  } } }, [t._v(t._s(t.title || t.t("struct.title")))])], 1), l("el-dialog", { staticClass: "_fd-struct-con", attrs: { title: t.title || t.t("struct.title"), visible: t.visible, "destroy-on-close": "", "close-on-click-modal": !1, "append-to-body": "", width: "800px" }, on: { "update:visible": function(c) {
    t.visible = c;
  } }, scopedSlots: t._u([{ key: "footer", fn: function() {
    return [l("div", [l("el-button", { attrs: { size: "small" }, on: { click: function(c) {
      t.visible = !1;
    } } }, [t._v(t._s(t.t("props.cancel")))]), l("el-button", { attrs: { type: "primary", size: "small", color: "#2f73ff" }, on: { click: t.onOk } }, [t._v(t._s(t.t("props.ok")))])], 1)];
  }, proxy: !0 }]) }, [t.visible ? l("div", { ref: "editor" }) : t._e()])], 1);
}, Gm = [], Ym = /* @__PURE__ */ lt(
  Qm,
  Vm,
  Gm,
  !1,
  null,
  null
);
const Km = Ym.exports, Xm = ft({
  name: "fcRow",
  mounted() {
  }
});
var Jm = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("el-col", { attrs: { span: 24 } }, [l("div", t._b({ staticClass: "_fd-row el-row", class: { "_fc-child-empty": !t.$slots.default } }, "div", t.$attrs, !1), [t._t("default")], 2)]);
}, qm = [], Zm = /* @__PURE__ */ lt(
  Xm,
  Jm,
  qm,
  !1,
  null,
  null
);
const ey = Zm.exports, ty = ft({
  name: "HtmlEditor",
  emits: ["input"],
  props: {
    value: String,
    title: String,
    defaultValue: {
      require: !1
    }
  },
  inject: ["designer"],
  computed: {
    t() {
      return this.designer.t;
    }
  },
  data() {
    return {
      editor: null,
      visible: !1,
      oldVal: null
    };
  },
  watch: {
    value() {
      this.load();
    },
    visible(i) {
      i && this.load();
    }
  },
  methods: {
    validateXML(i) {
      var M;
      const c = new DOMParser().parseFromString(i, "application/xml").getElementsByTagName("parsererror");
      return c.length > 0 && (M = c[0].innerText.split(`
`)[0]) != null ? M : "";
    },
    load() {
      this.oldVal = this.value, this.$nextTick(() => {
        this.editor = mi(gi(this.$refs.editor, {
          lineNumbers: !0,
          mode: "xml",
          lint: !0,
          line: !0,
          tabSize: 2,
          lineWrapping: !0,
          value: this.value || ""
        }));
      });
    },
    onOk() {
      const i = this.editor.getValue();
      return this.validateXML(i) ? (On(this.t("struct.errorMsg")), !1) : (this.visible = !1, i !== this.oldVal && this.$emit("input", i), !0);
    }
  }
});
var ny = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_fd-html-editor" }, [l("el-button", { staticStyle: { width: "100%" }, on: { click: function(c) {
    t.visible = !0;
  } } }, [t._v(t._s(t.title || t.t("struct.title")))]), l("el-dialog", { staticClass: "_fd-html-editor-con", attrs: { title: t.title || t.t("struct.title"), visible: t.visible, "close-on-click-modal": !1, "append-to-body": "" }, on: { "update:visible": function(c) {
    t.visible = c;
  } }, scopedSlots: t._u([{ key: "footer", fn: function() {
    return [l("div", [l("el-button", { attrs: { size: "small" }, on: { click: function(c) {
      t.visible = !1;
    } } }, [t._v(t._s(t.t("props.cancel")))]), l("el-button", { attrs: { type: "primary", size: "small" }, on: { click: t.onOk } }, [t._v(t._s(t.t("props.ok")))])], 1)];
  }, proxy: !0 }]) }, [t.visible ? l("div", { ref: "editor" }) : t._e()])], 1);
}, ry = [], iy = /* @__PURE__ */ lt(
  ty,
  ny,
  ry,
  !1,
  null,
  null
);
const oy = iy.exports, ay = ft({
  name: "FnInput",
  components: { FnEditor: mo },
  emits: ["input", "change"],
  props: {
    value: [String, Function],
    name: String,
    args: Array,
    title: String,
    body: Boolean,
    fnx: Boolean,
    defaultValue: {
      require: !1
    },
    validate: Function
  },
  inject: ["designer"],
  computed: {
    t() {
      return this.designer.t;
    },
    configured() {
      return !!this.value;
    }
  },
  data() {
    return {
      visible: !1,
      fn: this.value
    };
  },
  watch: {
    value(i) {
      this.fn = i;
    }
  },
  methods: {
    onOk() {
      this.$refs.editor.save() && (this.$emit("input", this.fn), this.$emit("change", this.fn), this.visible = !1);
    }
  }
});
var ly = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_fd-fn-input" }, [l("el-badge", { attrs: { type: "warning", "is-dot": "", hidden: !t.configured } }, [l("el-button", { attrs: { size: "mini" }, on: { click: function(c) {
    t.visible = !0;
  } } }, [t._t("default", function() {
    return [t._v(" " + t._s(t.t("event.title")) + " ")];
  })], 2)], 1), l("el-dialog", { staticClass: "_fd-fn-input-dialog _fd-config-dialog", attrs: { title: t.title || t.t("struct.title"), visible: t.visible, "destroy-on-close": "", "close-on-click-modal": !1, "append-to-body": "", width: "800px" }, on: { "update:visible": function(c) {
    t.visible = c;
  } }, scopedSlots: t._u([{ key: "footer", fn: function() {
    return [l("div", [l("el-button", { attrs: { size: "small" }, on: { click: function(c) {
      t.visible = !1;
    } } }, [t._v(t._s(t.t("props.cancel")))]), l("el-button", { attrs: { type: "primary", size: "small" }, on: { click: t.onOk } }, [t._v(t._s(t.t("props.ok")))])], 1)];
  }, proxy: !0 }]) }, [l("FnEditor", { ref: "editor", attrs: { name: t.name, args: t.args, body: t.body, fnx: t.fnx }, model: { value: t.fn, callback: function(c) {
    t.fn = c;
  }, expression: "fn" } })], 1)], 1);
}, sy = [], uy = /* @__PURE__ */ lt(
  ay,
  ly,
  sy,
  !1,
  null,
  null
);
const cd = uy.exports, cy = ft({
  name: "StructEditor",
  props: {
    value: [Object, Array, Function],
    defaultValue: {
      require: !1
    }
  },
  inject: ["designer"],
  data() {
    return {
      editor: null,
      visible: !1,
      err: !1,
      oldVal: null
    };
  },
  computed: {
    t() {
      return this.designer.t;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.load();
    });
  },
  methods: {
    load() {
      const i = this.value ? Ar(this.value) : "";
      this.oldVal = i, this.$nextTick(() => {
        this.editor = mi(gi(this.$refs.editor, {
          lineNumbers: !0,
          mode: "javascript",
          lint: !0,
          line: !0,
          tabSize: 2,
          lineWrapping: !0,
          value: i || ""
        }));
      });
    },
    save() {
      const i = this.editor.getValue();
      let t;
      try {
        t = new Function("return " + i)();
      } catch (l) {
        return console.error(l), On(this.t("struct.errorMsg")), !1;
      }
      return this.validate && this.validate(t) === !1 ? (this.err = !0, !1) : (this.visible = !1, Ar(t) !== this.oldVal && this.$emit("input", t), !0);
    }
  }
});
var fy = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_fd-struct-editor" }, [l("div", { ref: "editor" })]);
}, dy = [], py = /* @__PURE__ */ lt(
  cy,
  fy,
  dy,
  !1,
  null,
  null
);
const hy = py.exports, vy = (i) => [
  {
    type: "input",
    field: "action",
    title: i("fetch.action"),
    value: "",
    props: { size: "default" },
    validate: [{ required: !0, message: i("fetch.actionRequired"), trigger: "blur" }]
  },
  {
    type: "radio",
    field: "method",
    title: i("fetch.method"),
    value: "GET",
    props: {
      size: "default"
    },
    options: [
      { label: "GET", value: "GET" },
      { label: "POST", value: "POST" }
    ],
    $required: !0
  },
  {
    type: "TableOptions",
    field: "headers",
    title: i("fetch.headers"),
    value: {},
    props: {
      column: [{ label: i("props.key"), key: "label" }, { label: i("props.value"), key: "value" }],
      valueType: "object",
      size: "default"
    }
  },
  {
    type: "TableOptions",
    field: "data",
    title: i("fetch.data"),
    value: {},
    props: {
      column: [{ label: i("props.key"), key: "label" }, { label: i("props.value"), key: "value" }],
      valueType: "object",
      size: "default"
    }
  }
], gy = ft({
  name: "FetchConfig",
  emits: ["input"],
  props: {
    value: [Object, String],
    to: String
  },
  components: {
    DragForm: qe.$form(),
    FnEditor: mo,
    StructEditor: hy
  },
  inject: ["designer"],
  data() {
    return {
      visible: !1,
      formValue: Nt(this.value || {}),
      form: {
        api: {},
        formData: {},
        rule: [],
        options: {
          form: {
            labelWidth: "90px",
            size: "default"
          },
          submitBtn: !1,
          resetBtn: !1
        }
      }
    };
  },
  computed: {
    t() {
      return this.designer.t;
    },
    configured() {
      return !Rf(this.value);
    }
  },
  watch: {
    visible(i) {
      i && (this.formValue = Nt(this.value || {}));
    }
  },
  methods: {
    open() {
      this.visible = !0;
    },
    active() {
      const i = this.formValue;
      this.form.rule = i.type === "static" ? [] : vy(this.t), this.form.formData = rt({}, i), this.form.label = i.label, this.form.type = i.type, this.form.data = i.data, this.form.parse = i.parse || "", this.form.onError = i.onError || "";
    },
    save() {
      this.form.api.validate().then(() => {
        const i = rt({}, this.form.formData);
        this.$refs.parse && !this.$refs.parse.save() || this.$refs.error && !this.$refs.error.save() || (i.parse = this.form.parse, i.onError = this.form.onError, i.label = this.form.label, i.type = this.form.type, i.to = this.to || "options", this.$emit("input", i), this.visible = !1);
      }).catch((i) => {
      });
    }
  },
  created() {
    this.active();
  }
});
var my = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_fd-gfc" }, [l("el-badge", { attrs: { type: "warning", "is-dot": "", hidden: !t.configured } }, [l("el-button", { attrs: { size: "mini" }, on: { click: function(c) {
    t.visible = !0;
  } } }, [t._v(t._s(t.t("struct.title")))])], 1), l("el-dialog", { staticClass: "_fd-gfc-dialog", attrs: { title: t.t("fetch.optionsType.fetch"), visible: t.visible, "close-on-click-modal": !1, "append-to-body": "", width: "980px" }, on: { "update:visible": function(c) {
    t.visible = c;
  } }, scopedSlots: t._u([{ key: "footer", fn: function() {
    return [l("div", [l("el-button", { attrs: { size: "small" }, on: { click: function(c) {
      t.visible = !1;
    } } }, [t._v(t._s(t.t("props.cancel")))]), l("el-button", { attrs: { type: "primary", size: "small", color: "#2f73ff" }, on: { click: t.save } }, [t._v(t._s(t.t("props.ok")) + " ")])], 1)];
  }, proxy: !0 }]) }, [l("el-container", { staticClass: "_fd-gfc-con", staticStyle: { height: "450px" } }, [l("el-tabs", { staticClass: "_fc-tabs", staticStyle: { width: "100%" }, attrs: { value: "first" } }, [l("el-tab-pane", { attrs: { label: t.t("fetch.config"), name: "first" } }, [l("DragForm", { attrs: { value: t.form.formData, rule: t.form.rule, option: t.form.options }, on: { "update:value": function(c) {
    return t.$set(t.form, "formData", c);
  } }, model: { value: t.form.api, callback: function(c) {
    t.$set(t.form, "api", c);
  }, expression: "form.api" } })], 1), l("el-tab-pane", { attrs: { lazy: "", label: t.t("fetch.parse"), name: "second" } }, [l("FnEditor", { ref: "parse", staticStyle: { height: "415px" }, attrs: { name: "parse", args: [{ name: "res", info: t.t("fetch.response") }] }, model: { value: t.form.parse, callback: function(c) {
    t.$set(t.form, "parse", c);
  }, expression: "form.parse" } })], 1), l("el-tab-pane", { attrs: { lazy: "", label: t.t("fetch.onError"), name: "third" } }, [l("FnEditor", { ref: "error", staticStyle: { height: "415px" }, attrs: { name: "onError", args: ["e"] }, model: { value: t.form.onError, callback: function(c) {
    t.$set(t.form, "onError", c);
  }, expression: "form.onError" } })], 1)], 1)], 1)], 1)], 1);
}, yy = [], by = /* @__PURE__ */ lt(
  gy,
  my,
  yy,
  !1,
  null,
  null
);
const Ay = by.exports, xy = ft({
  name: "FieldInput",
  inject: ["designer"],
  emits: ["input"],
  props: {
    value: String,
    disabled: Boolean
  },
  computed: {
    fieldReadonly() {
      return this.designer.fieldReadonly;
    },
    activeRule() {
      return this.designer.activeRule;
    },
    t() {
      return this.designer.t;
    }
  },
  data() {
    return {
      formValue: this.value || "",
      oldValue: ""
    };
  },
  watch: {
    value(i) {
      this.formValue = i;
    }
  },
  methods: {
    copy() {
      Ff(this.value);
    },
    getSubChildren() {
      let i = this.designer.getSubFormChildren(this.activeRule) || [];
      return i = at.trueArray(i) ? i : this.designer.children, i;
    },
    getSubFieldChildren() {
      const i = this.getSubChildren(), t = [], l = (c) => (c && c.forEach((M) => {
        M && M._fc_drag_tag && M.field ? t.push(vr(rt({}, M), { children: [] })) : M && M.children && l(M.children);
      }), t);
      return l(i);
    },
    checkValue() {
      const i = this.oldValue;
      let t = (this.formValue || "").replace(/[\s\　]/g, "");
      if (t)
        if (/^[a-zA-Z]/.test(t)) {
          if (i !== t) {
            const l = t.indexOf(".") > -1;
            if (l && (t = t.replaceAll(".", "_")), this.getSubFieldChildren().filter((c) => c.field === t).length > 0)
              return On(this.t("computed.fieldExist", { label: t })), i;
            if (l)
              return t;
          }
        } else return On(this.t("computed.fieldChar")), i;
      else return On(this.t("computed.fieldEmpty")), i;
      return this.oldValue = "", t;
    },
    onFocus() {
      this.oldValue = this.formValue;
    },
    makeField() {
      this.oldValue = this.formValue, this.formValue = Je(), this.onInput();
    },
    onInput() {
      this.formValue !== this.value && (this.formValue = this.checkValue(), this.formValue !== this.value && this.$emit("input", this.formValue));
    }
  }
});
var wy = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_fd-field-input" }, [l("i", { staticClass: "fc-icon icon-group", on: { click: function(c) {
    return c.stopPropagation(), t.copy.apply(null, arguments);
  } } }), l("el-input", { attrs: { readonly: t.fieldReadonly || t.disabled, disabled: t.fieldReadonly || t.disabled }, on: { focus: t.onFocus, blur: t.onInput }, scopedSlots: t._u([t.fieldReadonly ? null : { key: "append", fn: function() {
    return [l("i", { staticClass: "fc-icon icon-auto", on: { click: t.makeField } })];
  }, proxy: !0 }], null, !0), model: { value: t.formValue, callback: function(c) {
    t.formValue = c;
  }, expression: "formValue" } })], 1);
}, _y = [], Cy = /* @__PURE__ */ lt(
  xy,
  wy,
  _y,
  !1,
  null,
  null
);
const Sy = Cy.exports, Ey = "[[FORM-CREATE-PREFIX-", ky = "-FORM-CREATE-SUFFIX]]", Ty = ft({
  name: "FnConfig",
  emits: ["input"],
  props: {
    value: [Object, void 0, null],
    eventConfig: {
      type: Array,
      default: () => []
    }
  },
  inject: ["designer"],
  components: {
    FnEditor: mo
  },
  data() {
    return {
      visible: !1,
      activeData: null,
      defActive: "no",
      event: {},
      cus: !1,
      eventStr: ""
    };
  },
  computed: {
    t() {
      return this.designer.t;
    },
    eventNum() {
      let i = 0;
      return Object.keys(this.value || {}).forEach((t) => {
        this.value[t] && i++;
      }), i;
    }
  },
  watch: {
    visible(i) {
      this.event = i ? this.loadFN(ba({}, this.value || {})) : {}, i || this.destroy();
    }
  },
  methods: {
    getArgs(i) {
      return i.args.join(", ");
    },
    loadFN(i) {
      const t = {};
      return this.eventConfig.forEach((l) => {
        const c = l.name, M = i[c] || "";
        t[c] = {
          item: l,
          fn: M
        };
      }), t;
    },
    parseFN(i) {
      const t = {};
      return Object.keys(i).forEach((l) => {
        i[l].fn && (t[l] = i[l].fn);
      }), t;
    },
    edit(i) {
      i.key = Je(), this.activeData = i, this.eventStr = i.fn || Ey + `function ${i.item.name}(${this.getArgs(i.item)}){}` + ky, this.defActive = i.item.name;
    },
    save() {
      this.$refs.fn.save() && (this.activeData.fn = this.eventStr, this.destroy());
    },
    destroy() {
      this.activeData = null, this.defActive = "no";
    },
    close() {
      this.destroy();
    },
    submit() {
      if (this.activeData)
        return On(this.t("event.saveMsg"));
      this.$emit("input", this.parseFN(this.event)), this.visible = !1, this.destroy();
    }
  }
});
var Dy = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_fd-fn-list" }, [l("el-badge", { attrs: { value: t.eventNum, type: "warning", hidden: t.eventNum < 1 } }, [l("el-button", { attrs: { size: "mini" }, on: { click: function(c) {
    t.visible = !0;
  } } }, [t._v(t._s(t.t("event.title")))])], 1), l("el-dialog", { staticClass: "_fd-fn-list-dialog", attrs: { title: t.t("event.title"), visible: t.visible, "destroy-on-close": "", "close-on-click-modal": !1, "append-to-body": "", width: "980px" }, on: { "update:visible": function(c) {
    t.visible = c;
  } }, scopedSlots: t._u([{ key: "footer", fn: function() {
    return [l("div", [l("el-button", { attrs: { size: "small" }, on: { click: function(c) {
      t.visible = !1;
    } } }, [t._v(t._s(t.t("props.cancel")))]), l("el-button", { attrs: { type: "primary", size: "small", color: "#2f73ff" }, on: { click: t.submit } }, [t._v(t._s(t.t("props.ok")) + " ")])], 1)];
  }, proxy: !0 }]) }, [l("el-container", { staticClass: "_fd-fn-list-con", staticStyle: { height: "600px" } }, [l("el-aside", { staticStyle: { width: "300px" } }, [l("el-container", { staticClass: "_fd-fn-list-l" }, [l("el-header", { staticClass: "_fd-fn-list-head", attrs: { height: "40px" } }, [l("el-button", { attrs: { type: "text", size: "small" } }, [t._v(" " + t._s(t.t("event.list")) + " ")])], 1), l("el-main", [l("el-menu", { attrs: { "default-active": t.defActive }, model: { value: t.activeData, callback: function(c) {
    t.activeData = c;
  }, expression: "activeData" } }, [t._l(t.event, function(c, M) {
    return [l("el-menu-item", { key: M, attrs: { index: M } }, [l("div", { staticClass: "_fd-fn-list-method", on: { click: function(T) {
      return T.stopPropagation(), t.edit(c);
    } } }, [l("span", [t._v("function"), l("span", [t._v(t._s(M))])])])])];
  })], 2)], 1)], 1)], 1), l("el-main", [l("el-container", { staticClass: "_fd-fn-list-r" }, [t.activeData ? l("el-header", { staticClass: "_fd-fn-list-head", attrs: { height: "40px" } }, [l("el-button", { attrs: { size: "mini" }, on: { click: t.close } }, [t._v(t._s(t.t("props.cancel")))]), l("el-button", { attrs: { size: "mini", type: "primary", color: "#2f73ff" }, on: { click: t.save } }, [t._v(t._s(t.t("props.save")) + " ")])], 1) : t._e(), t.activeData ? l("el-main", [l("FnEditor", { ref: "fn", attrs: { name: t.activeData.item.name, args: t.activeData.item.args }, model: { value: t.eventStr, callback: function(c) {
    t.eventStr = c;
  }, expression: "eventStr" } })], 1) : t._e()], 1)], 1)], 1)], 1)], 1);
}, My = [], Ny = /* @__PURE__ */ lt(
  Ty,
  Dy,
  My,
  !1,
  null,
  null
);
const Oy = Ny.exports;
var fd = { exports: {} };
const Ry = /* @__PURE__ */ Yg(Ig);
(function(i, t) {
  (function(c, M) {
    i.exports = M(Ry);
  })(typeof self != "undefined" ? self : ks, function(l) {
    return (
      /******/
      function(c) {
        var M = {};
        function T(F) {
          if (M[F])
            return M[F].exports;
          var z = M[F] = {
            /******/
            i: F,
            /******/
            l: !1,
            /******/
            exports: {}
            /******/
          };
          return c[F].call(z.exports, z, z.exports, T), z.l = !0, z.exports;
        }
        return T.m = c, T.c = M, T.d = function(F, z, W) {
          T.o(F, z) || Object.defineProperty(F, z, { enumerable: !0, get: W });
        }, T.r = function(F) {
          typeof Symbol != "undefined" && Symbol.toStringTag && Object.defineProperty(F, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(F, "__esModule", { value: !0 });
        }, T.t = function(F, z) {
          if (z & 1 && (F = T(F)), z & 8 || z & 4 && typeof F == "object" && F && F.__esModule) return F;
          var W = /* @__PURE__ */ Object.create(null);
          if (T.r(W), Object.defineProperty(W, "default", { enumerable: !0, value: F }), z & 2 && typeof F != "string") for (var K in F) T.d(W, K, function(q) {
            return F[q];
          }.bind(null, K));
          return W;
        }, T.n = function(F) {
          var z = F && F.__esModule ? (
            /******/
            function() {
              return F.default;
            }
          ) : (
            /******/
            function() {
              return F;
            }
          );
          return T.d(z, "a", z), z;
        }, T.o = function(F, z) {
          return Object.prototype.hasOwnProperty.call(F, z);
        }, T.p = "", T(T.s = "fb15");
      }({
        /***/
        "01f9": (
          /***/
          function(c, M, T) {
            var F = T("2d00"), z = T("5ca1"), W = T("2aba"), K = T("32e9"), q = T("84f2"), m = T("41a0"), d = T("7f20"), r = T("38fd"), u = T("2b4c")("iterator"), v = !([].keys && "next" in [].keys()), C = "@@iterator", p = "keys", b = "values", x = function() {
              return this;
            };
            c.exports = function(g, _, A, f, S, D, k) {
              m(A, _, f);
              var L = function(X) {
                if (!v && X in O) return O[X];
                switch (X) {
                  case p:
                    return function() {
                      return new A(this, X);
                    };
                  case b:
                    return function() {
                      return new A(this, X);
                    };
                }
                return function() {
                  return new A(this, X);
                };
              }, h = _ + " Iterator", E = S == b, w = !1, O = g.prototype, R = O[u] || O[C] || S && O[S], I = R || L(S), H = S ? E ? L("entries") : I : void 0, $ = _ == "Array" && O.entries || R, Q, U, Y;
              if ($ && (Y = r($.call(new g())), Y !== Object.prototype && Y.next && (d(Y, h, !0), !F && typeof Y[u] != "function" && K(Y, u, x))), E && R && R.name !== b && (w = !0, I = function() {
                return R.call(this);
              }), (!F || k) && (v || w || !O[u]) && K(O, u, I), q[_] = I, q[h] = x, S)
                if (Q = {
                  values: E ? I : L(b),
                  keys: D ? I : L(p),
                  entries: H
                }, k) for (U in Q)
                  U in O || W(O, U, Q[U]);
                else z(z.P + z.F * (v || w), _, Q);
              return Q;
            };
          }
        ),
        /***/
        "02f4": (
          /***/
          function(c, M, T) {
            var F = T("4588"), z = T("be13");
            c.exports = function(W) {
              return function(K, q) {
                var m = String(z(K)), d = F(q), r = m.length, u, v;
                return d < 0 || d >= r ? W ? "" : void 0 : (u = m.charCodeAt(d), u < 55296 || u > 56319 || d + 1 === r || (v = m.charCodeAt(d + 1)) < 56320 || v > 57343 ? W ? m.charAt(d) : u : W ? m.slice(d, d + 2) : (u - 55296 << 10) + (v - 56320) + 65536);
              };
            };
          }
        ),
        /***/
        "0390": (
          /***/
          function(c, M, T) {
            var F = T("02f4")(!0);
            c.exports = function(z, W, K) {
              return W + (K ? F(z, W).length : 1);
            };
          }
        ),
        /***/
        "0bfb": (
          /***/
          function(c, M, T) {
            var F = T("cb7c");
            c.exports = function() {
              var z = F(this), W = "";
              return z.global && (W += "g"), z.ignoreCase && (W += "i"), z.multiline && (W += "m"), z.unicode && (W += "u"), z.sticky && (W += "y"), W;
            };
          }
        ),
        /***/
        "0d58": (
          /***/
          function(c, M, T) {
            var F = T("ce10"), z = T("e11e");
            c.exports = Object.keys || function(K) {
              return F(K, z);
            };
          }
        ),
        /***/
        1495: (
          /***/
          function(c, M, T) {
            var F = T("86cc"), z = T("cb7c"), W = T("0d58");
            c.exports = T("9e1e") ? Object.defineProperties : function(q, m) {
              z(q);
              for (var d = W(m), r = d.length, u = 0, v; r > u; ) F.f(q, v = d[u++], m[v]);
              return q;
            };
          }
        ),
        /***/
        "214f": (
          /***/
          function(c, M, T) {
            T("b0c5");
            var F = T("2aba"), z = T("32e9"), W = T("79e5"), K = T("be13"), q = T("2b4c"), m = T("520a"), d = q("species"), r = !W(function() {
              var v = /./;
              return v.exec = function() {
                var C = [];
                return C.groups = { a: "7" }, C;
              }, "".replace(v, "$<a>") !== "7";
            }), u = function() {
              var v = /(?:)/, C = v.exec;
              v.exec = function() {
                return C.apply(this, arguments);
              };
              var p = "ab".split(v);
              return p.length === 2 && p[0] === "a" && p[1] === "b";
            }();
            c.exports = function(v, C, p) {
              var b = q(v), x = !W(function() {
                var D = {};
                return D[b] = function() {
                  return 7;
                }, ""[v](D) != 7;
              }), g = x ? !W(function() {
                var D = !1, k = /a/;
                return k.exec = function() {
                  return D = !0, null;
                }, v === "split" && (k.constructor = {}, k.constructor[d] = function() {
                  return k;
                }), k[b](""), !D;
              }) : void 0;
              if (!x || !g || v === "replace" && !r || v === "split" && !u) {
                var _ = /./[b], A = p(
                  K,
                  b,
                  ""[v],
                  function(k, L, h, E, w) {
                    return L.exec === m ? x && !w ? { done: !0, value: _.call(L, h, E) } : { done: !0, value: k.call(h, L, E) } : { done: !1 };
                  }
                ), f = A[0], S = A[1];
                F(String.prototype, v, f), z(
                  RegExp.prototype,
                  b,
                  C == 2 ? function(D, k) {
                    return S.call(D, this, k);
                  } : function(D) {
                    return S.call(D, this);
                  }
                );
              }
            };
          }
        ),
        /***/
        "230e": (
          /***/
          function(c, M, T) {
            var F = T("d3f4"), z = T("7726").document, W = F(z) && F(z.createElement);
            c.exports = function(K) {
              return W ? z.createElement(K) : {};
            };
          }
        ),
        /***/
        "23c6": (
          /***/
          function(c, M, T) {
            var F = T("2d95"), z = T("2b4c")("toStringTag"), W = F(/* @__PURE__ */ function() {
              return arguments;
            }()) == "Arguments", K = function(q, m) {
              try {
                return q[m];
              } catch (d) {
              }
            };
            c.exports = function(q) {
              var m, d, r;
              return q === void 0 ? "Undefined" : q === null ? "Null" : typeof (d = K(m = Object(q), z)) == "string" ? d : W ? F(m) : (r = F(m)) == "Object" && typeof m.callee == "function" ? "Arguments" : r;
            };
          }
        ),
        /***/
        2621: (
          /***/
          function(c, M) {
            M.f = Object.getOwnPropertySymbols;
          }
        ),
        /***/
        "2aba": (
          /***/
          function(c, M, T) {
            var F = T("7726"), z = T("32e9"), W = T("69a8"), K = T("ca5a")("src"), q = T("fa5b"), m = "toString", d = ("" + q).split(m);
            T("8378").inspectSource = function(r) {
              return q.call(r);
            }, (c.exports = function(r, u, v, C) {
              var p = typeof v == "function";
              p && (W(v, "name") || z(v, "name", u)), r[u] !== v && (p && (W(v, K) || z(v, K, r[u] ? "" + r[u] : d.join(String(u)))), r === F ? r[u] = v : C ? r[u] ? r[u] = v : z(r, u, v) : (delete r[u], z(r, u, v)));
            })(Function.prototype, m, function() {
              return typeof this == "function" && this[K] || q.call(this);
            });
          }
        ),
        /***/
        "2aeb": (
          /***/
          function(c, M, T) {
            var F = T("cb7c"), z = T("1495"), W = T("e11e"), K = T("613b")("IE_PROTO"), q = function() {
            }, m = "prototype", d = function() {
              var r = T("230e")("iframe"), u = W.length, v = "<", C = ">", p;
              for (r.style.display = "none", T("fab2").appendChild(r), r.src = "javascript:", p = r.contentWindow.document, p.open(), p.write(v + "script" + C + "document.F=Object" + v + "/script" + C), p.close(), d = p.F; u--; ) delete d[m][W[u]];
              return d();
            };
            c.exports = Object.create || function(u, v) {
              var C;
              return u !== null ? (q[m] = F(u), C = new q(), q[m] = null, C[K] = u) : C = d(), v === void 0 ? C : z(C, v);
            };
          }
        ),
        /***/
        "2b4c": (
          /***/
          function(c, M, T) {
            var F = T("5537")("wks"), z = T("ca5a"), W = T("7726").Symbol, K = typeof W == "function", q = c.exports = function(m) {
              return F[m] || (F[m] = K && W[m] || (K ? W : z)("Symbol." + m));
            };
            q.store = F;
          }
        ),
        /***/
        "2d00": (
          /***/
          function(c, M) {
            c.exports = !1;
          }
        ),
        /***/
        "2d95": (
          /***/
          function(c, M) {
            var T = {}.toString;
            c.exports = function(F) {
              return T.call(F).slice(8, -1);
            };
          }
        ),
        /***/
        "2fdb": (
          /***/
          function(c, M, T) {
            var F = T("5ca1"), z = T("d2c8"), W = "includes";
            F(F.P + F.F * T("5147")(W), "String", {
              includes: function(q) {
                return !!~z(this, q, W).indexOf(q, arguments.length > 1 ? arguments[1] : void 0);
              }
            });
          }
        ),
        /***/
        "32e9": (
          /***/
          function(c, M, T) {
            var F = T("86cc"), z = T("4630");
            c.exports = T("9e1e") ? function(W, K, q) {
              return F.f(W, K, z(1, q));
            } : function(W, K, q) {
              return W[K] = q, W;
            };
          }
        ),
        /***/
        "38fd": (
          /***/
          function(c, M, T) {
            var F = T("69a8"), z = T("4bf8"), W = T("613b")("IE_PROTO"), K = Object.prototype;
            c.exports = Object.getPrototypeOf || function(q) {
              return q = z(q), F(q, W) ? q[W] : typeof q.constructor == "function" && q instanceof q.constructor ? q.constructor.prototype : q instanceof Object ? K : null;
            };
          }
        ),
        /***/
        "41a0": (
          /***/
          function(c, M, T) {
            var F = T("2aeb"), z = T("4630"), W = T("7f20"), K = {};
            T("32e9")(K, T("2b4c")("iterator"), function() {
              return this;
            }), c.exports = function(q, m, d) {
              q.prototype = F(K, { next: z(1, d) }), W(q, m + " Iterator");
            };
          }
        ),
        /***/
        "456d": (
          /***/
          function(c, M, T) {
            var F = T("4bf8"), z = T("0d58");
            T("5eda")("keys", function() {
              return function(K) {
                return z(F(K));
              };
            });
          }
        ),
        /***/
        4588: (
          /***/
          function(c, M) {
            var T = Math.ceil, F = Math.floor;
            c.exports = function(z) {
              return isNaN(z = +z) ? 0 : (z > 0 ? F : T)(z);
            };
          }
        ),
        /***/
        4630: (
          /***/
          function(c, M) {
            c.exports = function(T, F) {
              return {
                enumerable: !(T & 1),
                configurable: !(T & 2),
                writable: !(T & 4),
                value: F
              };
            };
          }
        ),
        /***/
        "4bf8": (
          /***/
          function(c, M, T) {
            var F = T("be13");
            c.exports = function(z) {
              return Object(F(z));
            };
          }
        ),
        /***/
        5147: (
          /***/
          function(c, M, T) {
            var F = T("2b4c")("match");
            c.exports = function(z) {
              var W = /./;
              try {
                "/./"[z](W);
              } catch (K) {
                try {
                  return W[F] = !1, !"/./"[z](W);
                } catch (q) {
                }
              }
              return !0;
            };
          }
        ),
        /***/
        "520a": (
          /***/
          function(c, M, T) {
            var F = T("0bfb"), z = RegExp.prototype.exec, W = String.prototype.replace, K = z, q = "lastIndex", m = function() {
              var u = /a/, v = /b*/g;
              return z.call(u, "a"), z.call(v, "a"), u[q] !== 0 || v[q] !== 0;
            }(), d = /()??/.exec("")[1] !== void 0, r = m || d;
            r && (K = function(v) {
              var C = this, p, b, x, g;
              return d && (b = new RegExp("^" + C.source + "$(?!\\s)", F.call(C))), m && (p = C[q]), x = z.call(C, v), m && x && (C[q] = C.global ? x.index + x[0].length : p), d && x && x.length > 1 && W.call(x[0], b, function() {
                for (g = 1; g < arguments.length - 2; g++)
                  arguments[g] === void 0 && (x[g] = void 0);
              }), x;
            }), c.exports = K;
          }
        ),
        /***/
        "52a7": (
          /***/
          function(c, M) {
            M.f = {}.propertyIsEnumerable;
          }
        ),
        /***/
        5537: (
          /***/
          function(c, M, T) {
            var F = T("8378"), z = T("7726"), W = "__core-js_shared__", K = z[W] || (z[W] = {});
            (c.exports = function(q, m) {
              return K[q] || (K[q] = m !== void 0 ? m : {});
            })("versions", []).push({
              version: F.version,
              mode: T("2d00") ? "pure" : "global",
              copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
            });
          }
        ),
        /***/
        "5ca1": (
          /***/
          function(c, M, T) {
            var F = T("7726"), z = T("8378"), W = T("32e9"), K = T("2aba"), q = T("9b43"), m = "prototype", d = function(r, u, v) {
              var C = r & d.F, p = r & d.G, b = r & d.S, x = r & d.P, g = r & d.B, _ = p ? F : b ? F[u] || (F[u] = {}) : (F[u] || {})[m], A = p ? z : z[u] || (z[u] = {}), f = A[m] || (A[m] = {}), S, D, k, L;
              p && (v = u);
              for (S in v)
                D = !C && _ && _[S] !== void 0, k = (D ? _ : v)[S], L = g && D ? q(k, F) : x && typeof k == "function" ? q(Function.call, k) : k, _ && K(_, S, k, r & d.U), A[S] != k && W(A, S, L), x && f[S] != k && (f[S] = k);
            };
            F.core = z, d.F = 1, d.G = 2, d.S = 4, d.P = 8, d.B = 16, d.W = 32, d.U = 64, d.R = 128, c.exports = d;
          }
        ),
        /***/
        "5eda": (
          /***/
          function(c, M, T) {
            var F = T("5ca1"), z = T("8378"), W = T("79e5");
            c.exports = function(K, q) {
              var m = (z.Object || {})[K] || Object[K], d = {};
              d[K] = q(m), F(F.S + F.F * W(function() {
                m(1);
              }), "Object", d);
            };
          }
        ),
        /***/
        "5f1b": (
          /***/
          function(c, M, T) {
            var F = T("23c6"), z = RegExp.prototype.exec;
            c.exports = function(W, K) {
              var q = W.exec;
              if (typeof q == "function") {
                var m = q.call(W, K);
                if (typeof m != "object")
                  throw new TypeError("RegExp exec method returned something other than an Object or null");
                return m;
              }
              if (F(W) !== "RegExp")
                throw new TypeError("RegExp#exec called on incompatible receiver");
              return z.call(W, K);
            };
          }
        ),
        /***/
        "613b": (
          /***/
          function(c, M, T) {
            var F = T("5537")("keys"), z = T("ca5a");
            c.exports = function(W) {
              return F[W] || (F[W] = z(W));
            };
          }
        ),
        /***/
        "626a": (
          /***/
          function(c, M, T) {
            var F = T("2d95");
            c.exports = Object("z").propertyIsEnumerable(0) ? Object : function(z) {
              return F(z) == "String" ? z.split("") : Object(z);
            };
          }
        ),
        /***/
        6762: (
          /***/
          function(c, M, T) {
            var F = T("5ca1"), z = T("c366")(!0);
            F(F.P, "Array", {
              includes: function(K) {
                return z(this, K, arguments.length > 1 ? arguments[1] : void 0);
              }
            }), T("9c6c")("includes");
          }
        ),
        /***/
        6821: (
          /***/
          function(c, M, T) {
            var F = T("626a"), z = T("be13");
            c.exports = function(W) {
              return F(z(W));
            };
          }
        ),
        /***/
        "69a8": (
          /***/
          function(c, M) {
            var T = {}.hasOwnProperty;
            c.exports = function(F, z) {
              return T.call(F, z);
            };
          }
        ),
        /***/
        "6a99": (
          /***/
          function(c, M, T) {
            var F = T("d3f4");
            c.exports = function(z, W) {
              if (!F(z)) return z;
              var K, q;
              if (W && typeof (K = z.toString) == "function" && !F(q = K.call(z)) || typeof (K = z.valueOf) == "function" && !F(q = K.call(z)) || !W && typeof (K = z.toString) == "function" && !F(q = K.call(z))) return q;
              throw TypeError("Can't convert object to primitive value");
            };
          }
        ),
        /***/
        7333: (
          /***/
          function(c, M, T) {
            var F = T("0d58"), z = T("2621"), W = T("52a7"), K = T("4bf8"), q = T("626a"), m = Object.assign;
            c.exports = !m || T("79e5")(function() {
              var d = {}, r = {}, u = Symbol(), v = "abcdefghijklmnopqrst";
              return d[u] = 7, v.split("").forEach(function(C) {
                r[C] = C;
              }), m({}, d)[u] != 7 || Object.keys(m({}, r)).join("") != v;
            }) ? function(r, u) {
              for (var v = K(r), C = arguments.length, p = 1, b = z.f, x = W.f; C > p; )
                for (var g = q(arguments[p++]), _ = b ? F(g).concat(b(g)) : F(g), A = _.length, f = 0, S; A > f; ) x.call(g, S = _[f++]) && (v[S] = g[S]);
              return v;
            } : m;
          }
        ),
        /***/
        7726: (
          /***/
          function(c, M) {
            var T = c.exports = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();
            typeof __g == "number" && (__g = T);
          }
        ),
        /***/
        "77f1": (
          /***/
          function(c, M, T) {
            var F = T("4588"), z = Math.max, W = Math.min;
            c.exports = function(K, q) {
              return K = F(K), K < 0 ? z(K + q, 0) : W(K, q);
            };
          }
        ),
        /***/
        "79e5": (
          /***/
          function(c, M) {
            c.exports = function(T) {
              try {
                return !!T();
              } catch (F) {
                return !0;
              }
            };
          }
        ),
        /***/
        "7f20": (
          /***/
          function(c, M, T) {
            var F = T("86cc").f, z = T("69a8"), W = T("2b4c")("toStringTag");
            c.exports = function(K, q, m) {
              K && !z(K = m ? K : K.prototype, W) && F(K, W, { configurable: !0, value: q });
            };
          }
        ),
        /***/
        8378: (
          /***/
          function(c, M) {
            var T = c.exports = { version: "2.6.5" };
            typeof __e == "number" && (__e = T);
          }
        ),
        /***/
        "84f2": (
          /***/
          function(c, M) {
            c.exports = {};
          }
        ),
        /***/
        "86cc": (
          /***/
          function(c, M, T) {
            var F = T("cb7c"), z = T("c69a"), W = T("6a99"), K = Object.defineProperty;
            M.f = T("9e1e") ? Object.defineProperty : function(m, d, r) {
              if (F(m), d = W(d, !0), F(r), z) try {
                return K(m, d, r);
              } catch (u) {
              }
              if ("get" in r || "set" in r) throw TypeError("Accessors not supported!");
              return "value" in r && (m[d] = r.value), m;
            };
          }
        ),
        /***/
        "9b43": (
          /***/
          function(c, M, T) {
            var F = T("d8e8");
            c.exports = function(z, W, K) {
              if (F(z), W === void 0) return z;
              switch (K) {
                case 1:
                  return function(q) {
                    return z.call(W, q);
                  };
                case 2:
                  return function(q, m) {
                    return z.call(W, q, m);
                  };
                case 3:
                  return function(q, m, d) {
                    return z.call(W, q, m, d);
                  };
              }
              return function() {
                return z.apply(W, arguments);
              };
            };
          }
        ),
        /***/
        "9c6c": (
          /***/
          function(c, M, T) {
            var F = T("2b4c")("unscopables"), z = Array.prototype;
            z[F] == null && T("32e9")(z, F, {}), c.exports = function(W) {
              z[F][W] = !0;
            };
          }
        ),
        /***/
        "9def": (
          /***/
          function(c, M, T) {
            var F = T("4588"), z = Math.min;
            c.exports = function(W) {
              return W > 0 ? z(F(W), 9007199254740991) : 0;
            };
          }
        ),
        /***/
        "9e1e": (
          /***/
          function(c, M, T) {
            c.exports = !T("79e5")(function() {
              return Object.defineProperty({}, "a", { get: function() {
                return 7;
              } }).a != 7;
            });
          }
        ),
        /***/
        a352: (
          /***/
          function(c, M) {
            c.exports = l;
          }
        ),
        /***/
        a481: (
          /***/
          function(c, M, T) {
            var F = T("cb7c"), z = T("4bf8"), W = T("9def"), K = T("4588"), q = T("0390"), m = T("5f1b"), d = Math.max, r = Math.min, u = Math.floor, v = /\$([$&`']|\d\d?|<[^>]*>)/g, C = /\$([$&`']|\d\d?)/g, p = function(b) {
              return b === void 0 ? b : String(b);
            };
            T("214f")("replace", 2, function(b, x, g, _) {
              return [
                // `String.prototype.replace` method
                // https://tc39.github.io/ecma262/#sec-string.prototype.replace
                function(S, D) {
                  var k = b(this), L = S == null ? void 0 : S[x];
                  return L !== void 0 ? L.call(S, k, D) : g.call(String(k), S, D);
                },
                // `RegExp.prototype[@@replace]` method
                // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
                function(f, S) {
                  var D = _(g, f, this, S);
                  if (D.done) return D.value;
                  var k = F(f), L = String(this), h = typeof S == "function";
                  h || (S = String(S));
                  var E = k.global;
                  if (E) {
                    var w = k.unicode;
                    k.lastIndex = 0;
                  }
                  for (var O = []; ; ) {
                    var R = m(k, L);
                    if (R === null || (O.push(R), !E)) break;
                    var I = String(R[0]);
                    I === "" && (k.lastIndex = q(L, W(k.lastIndex), w));
                  }
                  for (var H = "", $ = 0, Q = 0; Q < O.length; Q++) {
                    R = O[Q];
                    for (var U = String(R[0]), Y = d(r(K(R.index), L.length), 0), X = [], G = 1; G < R.length; G++) X.push(p(R[G]));
                    var J = R.groups;
                    if (h) {
                      var ee = [U].concat(X, Y, L);
                      J !== void 0 && ee.push(J);
                      var re = String(S.apply(void 0, ee));
                    } else
                      re = A(U, L, Y, X, J, S);
                    Y >= $ && (H += L.slice($, Y) + re, $ = Y + U.length);
                  }
                  return H + L.slice($);
                }
              ];
              function A(f, S, D, k, L, h) {
                var E = D + f.length, w = k.length, O = C;
                return L !== void 0 && (L = z(L), O = v), g.call(h, O, function(R, I) {
                  var H;
                  switch (I.charAt(0)) {
                    case "$":
                      return "$";
                    case "&":
                      return f;
                    case "`":
                      return S.slice(0, D);
                    case "'":
                      return S.slice(E);
                    case "<":
                      H = L[I.slice(1, -1)];
                      break;
                    default:
                      var $ = +I;
                      if ($ === 0) return R;
                      if ($ > w) {
                        var Q = u($ / 10);
                        return Q === 0 ? R : Q <= w ? k[Q - 1] === void 0 ? I.charAt(1) : k[Q - 1] + I.charAt(1) : R;
                      }
                      H = k[$ - 1];
                  }
                  return H === void 0 ? "" : H;
                });
              }
            });
          }
        ),
        /***/
        aae3: (
          /***/
          function(c, M, T) {
            var F = T("d3f4"), z = T("2d95"), W = T("2b4c")("match");
            c.exports = function(K) {
              var q;
              return F(K) && ((q = K[W]) !== void 0 ? !!q : z(K) == "RegExp");
            };
          }
        ),
        /***/
        ac6a: (
          /***/
          function(c, M, T) {
            for (var F = T("cadf"), z = T("0d58"), W = T("2aba"), K = T("7726"), q = T("32e9"), m = T("84f2"), d = T("2b4c"), r = d("iterator"), u = d("toStringTag"), v = m.Array, C = {
              CSSRuleList: !0,
              // TODO: Not spec compliant, should be false.
              CSSStyleDeclaration: !1,
              CSSValueList: !1,
              ClientRectList: !1,
              DOMRectList: !1,
              DOMStringList: !1,
              DOMTokenList: !0,
              DataTransferItemList: !1,
              FileList: !1,
              HTMLAllCollection: !1,
              HTMLCollection: !1,
              HTMLFormElement: !1,
              HTMLSelectElement: !1,
              MediaList: !0,
              // TODO: Not spec compliant, should be false.
              MimeTypeArray: !1,
              NamedNodeMap: !1,
              NodeList: !0,
              PaintRequestList: !1,
              Plugin: !1,
              PluginArray: !1,
              SVGLengthList: !1,
              SVGNumberList: !1,
              SVGPathSegList: !1,
              SVGPointList: !1,
              SVGStringList: !1,
              SVGTransformList: !1,
              SourceBufferList: !1,
              StyleSheetList: !0,
              // TODO: Not spec compliant, should be false.
              TextTrackCueList: !1,
              TextTrackList: !1,
              TouchList: !1
            }, p = z(C), b = 0; b < p.length; b++) {
              var x = p[b], g = C[x], _ = K[x], A = _ && _.prototype, f;
              if (A && (A[r] || q(A, r, v), A[u] || q(A, u, x), m[x] = v, g))
                for (f in F) A[f] || W(A, f, F[f], !0);
            }
          }
        ),
        /***/
        b0c5: (
          /***/
          function(c, M, T) {
            var F = T("520a");
            T("5ca1")({
              target: "RegExp",
              proto: !0,
              forced: F !== /./.exec
            }, {
              exec: F
            });
          }
        ),
        /***/
        be13: (
          /***/
          function(c, M) {
            c.exports = function(T) {
              if (T == null) throw TypeError("Can't call method on  " + T);
              return T;
            };
          }
        ),
        /***/
        c366: (
          /***/
          function(c, M, T) {
            var F = T("6821"), z = T("9def"), W = T("77f1");
            c.exports = function(K) {
              return function(q, m, d) {
                var r = F(q), u = z(r.length), v = W(d, u), C;
                if (K && m != m) {
                  for (; u > v; )
                    if (C = r[v++], C != C) return !0;
                } else for (; u > v; v++) if ((K || v in r) && r[v] === m)
                  return K || v || 0;
                return !K && -1;
              };
            };
          }
        ),
        /***/
        c649: (
          /***/
          function(c, M, T) {
            (function(F) {
              T.d(M, "c", function() {
                return r;
              }), T.d(M, "a", function() {
                return m;
              }), T.d(M, "b", function() {
                return W;
              }), T.d(M, "d", function() {
                return d;
              }), T("a481");
              function z() {
                return typeof window != "undefined" ? window.console : F.console;
              }
              var W = z();
              function K(u) {
                var v = /* @__PURE__ */ Object.create(null);
                return function(p) {
                  var b = v[p];
                  return b || (v[p] = u(p));
                };
              }
              var q = /-(\w)/g, m = K(function(u) {
                return u.replace(q, function(v, C) {
                  return C ? C.toUpperCase() : "";
                });
              });
              function d(u) {
                u.parentElement !== null && u.parentElement.removeChild(u);
              }
              function r(u, v, C) {
                var p = C === 0 ? u.children[0] : u.children[C - 1].nextSibling;
                u.insertBefore(v, p);
              }
            }).call(this, T("c8ba"));
          }
        ),
        /***/
        c69a: (
          /***/
          function(c, M, T) {
            c.exports = !T("9e1e") && !T("79e5")(function() {
              return Object.defineProperty(T("230e")("div"), "a", { get: function() {
                return 7;
              } }).a != 7;
            });
          }
        ),
        /***/
        c8ba: (
          /***/
          function(c, M) {
            var T;
            T = /* @__PURE__ */ function() {
              return this;
            }();
            try {
              T = T || new Function("return this")();
            } catch (F) {
              typeof window == "object" && (T = window);
            }
            c.exports = T;
          }
        ),
        /***/
        ca5a: (
          /***/
          function(c, M) {
            var T = 0, F = Math.random();
            c.exports = function(z) {
              return "Symbol(".concat(z === void 0 ? "" : z, ")_", (++T + F).toString(36));
            };
          }
        ),
        /***/
        cadf: (
          /***/
          function(c, M, T) {
            var F = T("9c6c"), z = T("d53b"), W = T("84f2"), K = T("6821");
            c.exports = T("01f9")(Array, "Array", function(q, m) {
              this._t = K(q), this._i = 0, this._k = m;
            }, function() {
              var q = this._t, m = this._k, d = this._i++;
              return !q || d >= q.length ? (this._t = void 0, z(1)) : m == "keys" ? z(0, d) : m == "values" ? z(0, q[d]) : z(0, [d, q[d]]);
            }, "values"), W.Arguments = W.Array, F("keys"), F("values"), F("entries");
          }
        ),
        /***/
        cb7c: (
          /***/
          function(c, M, T) {
            var F = T("d3f4");
            c.exports = function(z) {
              if (!F(z)) throw TypeError(z + " is not an object!");
              return z;
            };
          }
        ),
        /***/
        ce10: (
          /***/
          function(c, M, T) {
            var F = T("69a8"), z = T("6821"), W = T("c366")(!1), K = T("613b")("IE_PROTO");
            c.exports = function(q, m) {
              var d = z(q), r = 0, u = [], v;
              for (v in d) v != K && F(d, v) && u.push(v);
              for (; m.length > r; ) F(d, v = m[r++]) && (~W(u, v) || u.push(v));
              return u;
            };
          }
        ),
        /***/
        d2c8: (
          /***/
          function(c, M, T) {
            var F = T("aae3"), z = T("be13");
            c.exports = function(W, K, q) {
              if (F(K)) throw TypeError("String#" + q + " doesn't accept regex!");
              return String(z(W));
            };
          }
        ),
        /***/
        d3f4: (
          /***/
          function(c, M) {
            c.exports = function(T) {
              return typeof T == "object" ? T !== null : typeof T == "function";
            };
          }
        ),
        /***/
        d53b: (
          /***/
          function(c, M) {
            c.exports = function(T, F) {
              return { value: F, done: !!T };
            };
          }
        ),
        /***/
        d8e8: (
          /***/
          function(c, M) {
            c.exports = function(T) {
              if (typeof T != "function") throw TypeError(T + " is not a function!");
              return T;
            };
          }
        ),
        /***/
        e11e: (
          /***/
          function(c, M) {
            c.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
          }
        ),
        /***/
        f559: (
          /***/
          function(c, M, T) {
            var F = T("5ca1"), z = T("9def"), W = T("d2c8"), K = "startsWith", q = ""[K];
            F(F.P + F.F * T("5147")(K), "String", {
              startsWith: function(d) {
                var r = W(this, d, K), u = z(Math.min(arguments.length > 1 ? arguments[1] : void 0, r.length)), v = String(d);
                return q ? q.call(r, v, u) : r.slice(u, u + v.length) === v;
              }
            });
          }
        ),
        /***/
        f6fd: (
          /***/
          function(c, M) {
            (function(T) {
              var F = "currentScript", z = T.getElementsByTagName("script");
              F in T || Object.defineProperty(T, F, {
                get: function() {
                  try {
                    throw new Error();
                  } catch (q) {
                    var W, K = (/.*at [^\(]*\((.*):.+:.+\)$/ig.exec(q.stack) || [!1])[1];
                    for (W in z)
                      if (z[W].src == K || z[W].readyState == "interactive")
                        return z[W];
                    return null;
                  }
                }
              });
            })(document);
          }
        ),
        /***/
        f751: (
          /***/
          function(c, M, T) {
            var F = T("5ca1");
            F(F.S + F.F, "Object", { assign: T("7333") });
          }
        ),
        /***/
        fa5b: (
          /***/
          function(c, M, T) {
            c.exports = T("5537")("native-function-to-string", Function.toString);
          }
        ),
        /***/
        fab2: (
          /***/
          function(c, M, T) {
            var F = T("7726").document;
            c.exports = F && F.documentElement;
          }
        ),
        /***/
        fb15: (
          /***/
          function(c, M, T) {
            if (T.r(M), typeof window != "undefined") {
              T("f6fd");
              var F;
              (F = window.document.currentScript) && (F = F.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)) && (T.p = F[1]);
            }
            T("f751"), T("f559"), T("ac6a"), T("cadf"), T("456d");
            function z(U) {
              if (Array.isArray(U)) return U;
            }
            function W(U, Y) {
              if (!(typeof Symbol == "undefined" || !(Symbol.iterator in Object(U)))) {
                var X = [], G = !0, J = !1, ee = void 0;
                try {
                  for (var re = U[Symbol.iterator](), oe; !(G = (oe = re.next()).done) && (X.push(oe.value), !(Y && X.length === Y)); G = !0)
                    ;
                } catch (ae) {
                  J = !0, ee = ae;
                } finally {
                  try {
                    !G && re.return != null && re.return();
                  } finally {
                    if (J) throw ee;
                  }
                }
                return X;
              }
            }
            function K(U, Y) {
              (Y == null || Y > U.length) && (Y = U.length);
              for (var X = 0, G = new Array(Y); X < Y; X++)
                G[X] = U[X];
              return G;
            }
            function q(U, Y) {
              if (U) {
                if (typeof U == "string") return K(U, Y);
                var X = Object.prototype.toString.call(U).slice(8, -1);
                if (X === "Object" && U.constructor && (X = U.constructor.name), X === "Map" || X === "Set") return Array.from(U);
                if (X === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(X)) return K(U, Y);
              }
            }
            function m() {
              throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            function d(U, Y) {
              return z(U) || W(U, Y) || q(U, Y) || m();
            }
            T("6762"), T("2fdb");
            function r(U) {
              if (Array.isArray(U)) return K(U);
            }
            function u(U) {
              if (typeof Symbol != "undefined" && Symbol.iterator in Object(U)) return Array.from(U);
            }
            function v() {
              throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            function C(U) {
              return r(U) || u(U) || q(U) || v();
            }
            var p = T("a352"), b = /* @__PURE__ */ T.n(p), x = T("c649");
            function g(U, Y, X) {
              return X === void 0 || (U = U || {}, U[Y] = X), U;
            }
            function _(U, Y) {
              return U.map(function(X) {
                return X.elm;
              }).indexOf(Y);
            }
            function A(U, Y, X, G) {
              if (!U)
                return [];
              var J = U.map(function(oe) {
                return oe.elm;
              }), ee = Y.length - G, re = C(Y).map(function(oe, ae) {
                return ae >= ee ? J.length : J.indexOf(oe);
              });
              return X ? re.filter(function(oe) {
                return oe !== -1;
              }) : re;
            }
            function f(U, Y) {
              var X = this;
              this.$nextTick(function() {
                return X.$emit(U.toLowerCase(), Y);
              });
            }
            function S(U) {
              var Y = this;
              return function(X) {
                Y.realList !== null && Y["onDrag" + U](X), f.call(Y, U, X);
              };
            }
            function D(U) {
              return ["transition-group", "TransitionGroup"].includes(U);
            }
            function k(U) {
              if (!U || U.length !== 1)
                return !1;
              var Y = d(U, 1), X = Y[0].componentOptions;
              return X ? D(X.tag) : !1;
            }
            function L(U, Y, X) {
              return U[X] || (Y[X] ? Y[X]() : void 0);
            }
            function h(U, Y, X) {
              var G = 0, J = 0, ee = L(Y, X, "header");
              ee && (G = ee.length, U = U ? [].concat(C(ee), C(U)) : C(ee));
              var re = L(Y, X, "footer");
              return re && (J = re.length, U = U ? [].concat(C(U), C(re)) : C(re)), {
                children: U,
                headerOffset: G,
                footerOffset: J
              };
            }
            function E(U, Y) {
              var X = null, G = function(se, ve) {
                X = g(X, se, ve);
              }, J = Object.keys(U).filter(function(ae) {
                return ae === "id" || ae.startsWith("data-");
              }).reduce(function(ae, se) {
                return ae[se] = U[se], ae;
              }, {});
              if (G("attrs", J), !Y)
                return X;
              var ee = Y.on, re = Y.props, oe = Y.attrs;
              return G("on", ee), G("props", re), Object.assign(X.attrs, oe), X;
            }
            var w = ["Start", "Add", "Remove", "Update", "End"], O = ["Choose", "Unchoose", "Sort", "Filter", "Clone"], R = ["Move"].concat(w, O).map(function(U) {
              return "on" + U;
            }), I = null, H = {
              options: Object,
              list: {
                type: Array,
                required: !1,
                default: null
              },
              value: {
                type: Array,
                required: !1,
                default: null
              },
              noTransitionOnDrag: {
                type: Boolean,
                default: !1
              },
              clone: {
                type: Function,
                default: function(Y) {
                  return Y;
                }
              },
              element: {
                type: String,
                default: "div"
              },
              tag: {
                type: String,
                default: null
              },
              move: {
                type: Function,
                default: null
              },
              componentData: {
                type: Object,
                required: !1,
                default: null
              }
            }, $ = {
              name: "draggable",
              inheritAttrs: !1,
              props: H,
              data: function() {
                return {
                  transitionMode: !1,
                  noneFunctionalComponentMode: !1
                };
              },
              render: function(Y) {
                var X = this.$slots.default;
                this.transitionMode = k(X);
                var G = h(X, this.$slots, this.$scopedSlots), J = G.children, ee = G.headerOffset, re = G.footerOffset;
                this.headerOffset = ee, this.footerOffset = re;
                var oe = E(this.$attrs, this.componentData);
                return Y(this.getTag(), oe, J);
              },
              created: function() {
                this.list !== null && this.value !== null && x.b.error("Value and list props are mutually exclusive! Please set one or another."), this.element !== "div" && x.b.warn("Element props is deprecated please use tag props instead. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#element-props"), this.options !== void 0 && x.b.warn("Options props is deprecated, add sortable options directly as vue.draggable item, or use v-bind. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#options-props");
              },
              mounted: function() {
                var Y = this;
                if (this.noneFunctionalComponentMode = this.getTag().toLowerCase() !== this.$el.nodeName.toLowerCase() && !this.getIsFunctional(), this.noneFunctionalComponentMode && this.transitionMode)
                  throw new Error("Transition-group inside component is not supported. Please alter tag value or remove transition-group. Current tag value: ".concat(this.getTag()));
                var X = {};
                w.forEach(function(ee) {
                  X["on" + ee] = S.call(Y, ee);
                }), O.forEach(function(ee) {
                  X["on" + ee] = f.bind(Y, ee);
                });
                var G = Object.keys(this.$attrs).reduce(function(ee, re) {
                  return ee[Object(x.a)(re)] = Y.$attrs[re], ee;
                }, {}), J = Object.assign({}, this.options, G, X, {
                  onMove: function(re, oe) {
                    return Y.onDragMove(re, oe);
                  }
                });
                !("draggable" in J) && (J.draggable = ">*"), this._sortable = new b.a(this.rootContainer, J), this.computeIndexes();
              },
              beforeDestroy: function() {
                this._sortable !== void 0 && this._sortable.destroy();
              },
              computed: {
                rootContainer: function() {
                  return this.transitionMode ? this.$el.children[0] : this.$el;
                },
                realList: function() {
                  return this.list ? this.list : this.value;
                }
              },
              watch: {
                options: {
                  handler: function(Y) {
                    this.updateOptions(Y);
                  },
                  deep: !0
                },
                $attrs: {
                  handler: function(Y) {
                    this.updateOptions(Y);
                  },
                  deep: !0
                },
                realList: function() {
                  this.computeIndexes();
                }
              },
              methods: {
                getIsFunctional: function() {
                  var Y = this._vnode.fnOptions;
                  return Y && Y.functional;
                },
                getTag: function() {
                  return this.tag || this.element;
                },
                updateOptions: function(Y) {
                  for (var X in Y) {
                    var G = Object(x.a)(X);
                    R.indexOf(G) === -1 && this._sortable.option(G, Y[X]);
                  }
                },
                getChildrenNodes: function() {
                  if (this.noneFunctionalComponentMode)
                    return this.$children[0].$slots.default;
                  var Y = this.$slots.default;
                  return this.transitionMode ? Y[0].child.$slots.default : Y;
                },
                computeIndexes: function() {
                  var Y = this;
                  this.$nextTick(function() {
                    Y.visibleIndexes = A(Y.getChildrenNodes(), Y.rootContainer.children, Y.transitionMode, Y.footerOffset);
                  });
                },
                getUnderlyingVm: function(Y) {
                  var X = _(this.getChildrenNodes() || [], Y);
                  if (X === -1)
                    return null;
                  var G = this.realList[X];
                  return {
                    index: X,
                    element: G
                  };
                },
                getUnderlyingPotencialDraggableComponent: function(Y) {
                  var X = Y.__vue__;
                  return !X || !X.$options || !D(X.$options._componentTag) ? !("realList" in X) && X.$children.length === 1 && "realList" in X.$children[0] ? X.$children[0] : X : X.$parent;
                },
                emitChanges: function(Y) {
                  var X = this;
                  this.$nextTick(function() {
                    X.$emit("change", Y);
                  });
                },
                alterList: function(Y) {
                  if (this.list) {
                    Y(this.list);
                    return;
                  }
                  var X = C(this.value);
                  Y(X), this.$emit("input", X);
                },
                spliceList: function() {
                  var Y = arguments, X = function(J) {
                    return J.splice.apply(J, C(Y));
                  };
                  this.alterList(X);
                },
                updatePosition: function(Y, X) {
                  var G = function(ee) {
                    return ee.splice(X, 0, ee.splice(Y, 1)[0]);
                  };
                  this.alterList(G);
                },
                getRelatedContextFromMoveEvent: function(Y) {
                  var X = Y.to, G = Y.related, J = this.getUnderlyingPotencialDraggableComponent(X);
                  if (!J)
                    return {
                      component: J
                    };
                  var ee = J.realList, re = {
                    list: ee,
                    component: J
                  };
                  if (X !== G && ee && J.getUnderlyingVm) {
                    var oe = J.getUnderlyingVm(G);
                    if (oe)
                      return Object.assign(oe, re);
                  }
                  return re;
                },
                getVmIndex: function(Y) {
                  var X = this.visibleIndexes, G = X.length;
                  return Y > G - 1 ? G : X[Y];
                },
                getComponent: function() {
                  return this.$slots.default[0].componentInstance;
                },
                resetTransitionData: function(Y) {
                  if (!(!this.noTransitionOnDrag || !this.transitionMode)) {
                    var X = this.getChildrenNodes();
                    X[Y].data = null;
                    var G = this.getComponent();
                    G.children = [], G.kept = void 0;
                  }
                },
                onDragStart: function(Y) {
                  this.context = this.getUnderlyingVm(Y.item), Y.item._underlying_vm_ = this.clone(this.context.element), I = Y.item;
                },
                onDragAdd: function(Y) {
                  var X = Y.item._underlying_vm_;
                  if (X !== void 0) {
                    Object(x.d)(Y.item);
                    var G = this.getVmIndex(Y.newIndex);
                    this.spliceList(G, 0, X), this.computeIndexes();
                    var J = {
                      element: X,
                      newIndex: G
                    };
                    this.emitChanges({
                      added: J
                    });
                  }
                },
                onDragRemove: function(Y) {
                  if (Object(x.c)(this.rootContainer, Y.item, Y.oldIndex), Y.pullMode === "clone") {
                    Object(x.d)(Y.clone);
                    return;
                  }
                  var X = this.context.index;
                  this.spliceList(X, 1);
                  var G = {
                    element: this.context.element,
                    oldIndex: X
                  };
                  this.resetTransitionData(X), this.emitChanges({
                    removed: G
                  });
                },
                onDragUpdate: function(Y) {
                  Object(x.d)(Y.item), Object(x.c)(Y.from, Y.item, Y.oldIndex);
                  var X = this.context.index, G = this.getVmIndex(Y.newIndex);
                  this.updatePosition(X, G);
                  var J = {
                    element: this.context.element,
                    oldIndex: X,
                    newIndex: G
                  };
                  this.emitChanges({
                    moved: J
                  });
                },
                updateProperty: function(Y, X) {
                  Y.hasOwnProperty(X) && (Y[X] += this.headerOffset);
                },
                computeFutureIndex: function(Y, X) {
                  if (!Y.element)
                    return 0;
                  var G = C(X.to.children).filter(function(oe) {
                    return oe.style.display !== "none";
                  }), J = G.indexOf(X.related), ee = Y.component.getVmIndex(J), re = G.indexOf(I) !== -1;
                  return re || !X.willInsertAfter ? ee : ee + 1;
                },
                onDragMove: function(Y, X) {
                  var G = this.move;
                  if (!G || !this.realList)
                    return !0;
                  var J = this.getRelatedContextFromMoveEvent(Y), ee = this.context, re = this.computeFutureIndex(J, Y);
                  Object.assign(ee, {
                    futureIndex: re
                  });
                  var oe = Object.assign({}, Y, {
                    relatedContext: J,
                    draggedContext: ee
                  });
                  return G(oe, X);
                },
                onDragEnd: function() {
                  this.computeIndexes(), I = null;
                }
              }
            };
            typeof window != "undefined" && "Vue" in window && window.Vue.component("draggable", $);
            var Q = $;
            M.default = Q;
          }
        )
        /******/
      }).default
    );
  });
})(fd);
var Iy = fd.exports;
const xs = /* @__PURE__ */ Ts(Iy), Ly = {
  name: "DragBox",
  props: ["rule", "subRule", "tag", "list"],
  components: {
    draggable: xs
  },
  render(i) {
    const t = this.$props.rule || {};
    let l = "_fd-" + this.$props.tag + "-drag _fd-drag-box";
    (!this.$slots.default || !this.$slots.default.length) && (l += " drag-holder"), t.class = l;
    const c = vr(rt({}, this.$props.rule), { on: this.$listeners });
    return this.$props.list && (c.props.list = this.$props.list), i(xs, c, this.$slots.default);
  }
}, Fy = null, By = null;
var Py = /* @__PURE__ */ lt(
  Ly,
  Fy,
  By,
  !1,
  null,
  null
);
const dd = Py.exports, Hy = ft({
  name: "FcTableView",
  props: {
    label: String,
    width: [Number, String],
    formCreateInject: Object,
    border: {
      type: Boolean,
      default: !0
    },
    borderWidth: String,
    borderColor: String,
    rule: {
      type: Object,
      default: () => ({ row: 1, col: 1 })
    }
  },
  inject: ["designer"],
  components: {
    DragTool: ud,
    DragBox: dd
  },
  watch: {
    rule: {
      handler() {
        this.initRule(), this.style = this.rule.style;
      },
      immediate: !0
    }
  },
  data() {
    return {
      unique: {},
      style: {},
      dragProp: {
        rule: {
          props: {
            tag: "el-col"
          },
          attrs: {
            group: "default",
            ghostClass: "ghost",
            animation: 150,
            handle: "._fd-drag-btn",
            emptyInsertThreshold: 0,
            direction: "vertical"
          }
        },
        tag: "tableCell"
      },
      lattice: {},
      uni: {}
    };
  },
  computed: {
    t() {
      return this.designer.t;
    },
    tableColor() {
      const i = {};
      return this.border === !1 ? i.border = "0 none" : (this.borderColor && (i.borderColor = this.borderColor), this.borderWidth && (i.borderWidth = this.borderWidth)), i;
    }
  },
  methods: {
    getUnique(i) {
      return this.unique[i] || (this.unique[i] = Je()), this.unique[i];
    },
    getSlotChildren(i) {
      const t = [];
      return this.formCreateInject.children.forEach((l) => {
        i.indexOf(l.slot) > -1 && t.push(l);
      }), t;
    },
    dragAdd(i, t) {
      const l = this.designer, c = this.formCreateInject.children, M = `${t.pid}:${t.idx}`, T = i.item._underlying_vm_ || i.item.__rule__, F = l.addRule && l.addRule.children === l.moveRule;
      F && l.moveRule.splice(l.moveRule.indexOf(T), 1);
      let z = 0;
      const W = "drag" + t.pid + t.idx;
      if (this.$refs[W][0].list.length) {
        let K = this.$refs[W][0].list[i.newIndex ? i.newIndex - 1 : 0];
        z = c.indexOf(K) + (i.newIndex ? 1 : 0);
      } else if (c.length) {
        const K = Object.keys(this.$refs);
        for (let q = K.indexOf(W) - 1; q >= 0; q--) {
          if (!this.$refs[K[q]] || !this.$refs[K[q]].length)
            continue;
          const m = this.$refs[K[q]][0].list || [];
          if (m.length) {
            z = c.indexOf(m[m.length - 1]) + 1;
            break;
          }
        }
      }
      i.newIndex = z, F ? (T.slot = M, c.splice(i.newIndex, 0, T), l.added = !0, l.handleSortAfter({ rule: T })) : l.dragAdd(c, i, `${t.pid}:${t.idx}`);
    },
    dragEnd(i, t) {
      const l = this.designer, c = this.formCreateInject.children, M = i.item._underlying_vm_, T = c.indexOf(M);
      i.newIndex = T + (i.newIndex - i.oldIndex), i.oldIndex = T, l.dragEnd(this.formCreateInject.children, i, `${t.pid}:${t.idx}`);
    },
    dragStart() {
      this.designer.dragStart(this.formCreateInject.children);
    },
    dragUnchoose(i) {
      this.designer.dragUnchoose(this.formCreateInject.children, i);
    },
    initRule() {
      const i = this.rule;
      i.style || (i.style = {}), i.class || (i.class = {}), i.layout || (i.layout = []), i.row || (i.row = 1), i.col || (i.col = 1);
    },
    active(i) {
      const t = `${i.pid}:${i.idx}`;
      this.designer.customActive({
        name: "fcTableGrid",
        style: {
          formData: {
            style: this.rule.style[t] || {},
            class: this.rule.class[t] || ""
          },
          change: (l, c) => {
            this.$set(this.rule[l], t, c);
          }
        }
      });
    },
    command(i) {
      this[i[0]](...i[1]);
    },
    rmSlot(i, t) {
      const l = Object.keys(i), c = this.formCreateInject.children;
      let M = 0;
      [...c].forEach((T, F) => {
        if (!T.slot)
          return;
        let z;
        t.indexOf(T.slot) > -1 ? (c.splice(F - M, 1), M++) : (z = l.indexOf(T.slot)) > -1 && (T.slot = i[l[z]]);
      }), t.forEach((T) => {
        delete this.style[T];
      }), this.loadRule();
    },
    rmRow(i) {
      this.rule.row--;
      const t = {}, l = [];
      for (let T = i.pid; T < this.rule.row + 1; T++)
        for (let F = 0; F < this.rule.col; F++)
          T === i.pid ? l.push(`${i.pid}:${F}`) : t[`${T}:${F}`] = `${T - 1}:${F}`;
      let c = 0;
      const M = this.rule.layout;
      [...M].forEach((T, F) => {
        T.top === i.pid && (M.splice(F - c, 1), c++);
      }), M.forEach((T) => {
        T.top > i.pid && T.top--;
      }), this.rmSlot(t, l);
    },
    rmCol(i) {
      this.rule.col--;
      const t = {}, l = [];
      for (let T = 0; T < this.rule.row; T++) {
        for (let F = i.idx + 1; F < this.rule.col + 1; F++)
          t[`${T}:${F}`] = `${T}:${F - 1}`;
        l.push(`${T}:${i.idx}`);
      }
      let c = 0;
      const M = this.rule.layout;
      [...M].forEach((T, F) => {
        T.left === i.idx && (M.splice(F - c, 1), c++);
      }), M.forEach((T) => {
        T.left > i.idx && T.left--;
      }), this.rmSlot(t, l);
    },
    splitRow(i) {
      const t = i.data.layout, l = t.row;
      if (t.row = 0, l > 1)
        for (let c = 1; c < l; c++)
          this.rule.layout.push(vr(rt({}, t), {
            top: t.top + c
          }));
      this.loadRule();
    },
    splitCol(i) {
      const t = i.data.layout, l = t.col;
      if (t.col = 0, l > 1)
        for (let c = 1; c < l; c++)
          this.rule.layout.push(vr(rt({}, t), {
            left: t.left + c
          }));
      this.loadRule();
    },
    makeMap(i) {
      let t = [];
      for (let l = i.top; l < (i.row || i.top + 1); l++)
        for (let c = i.left; c < (i.col || i.left + 1); c++)
          t.push(`${l}:${c}`);
      return t;
    },
    mergeRight(i) {
      let t;
      if (i.data.layout) {
        const c = (i.data.layout.col || 1) + 1;
        i.data.layout.col = c + i.idx > this.rule.col ? this.rule.col - i.idx : c, t = i.data.layout;
      } else
        t = {
          top: i.pid,
          left: i.idx,
          col: 2
        }, this.rule.layout.push(t);
      const l = this.makeMap(t);
      this.formCreateInject.children.forEach((c) => {
        c.slot && l.indexOf(c.slot) > -1 && (c.slot = `${i.pid}:${i.idx}`);
      }), this.loadRule();
    },
    mergeBottom(i) {
      let t;
      if (i.data.layout) {
        const c = (i.data.layout.row || 1) + 1;
        i.data.layout.row = c + c.pid > this.rule.col ? this.rule.col - i.pid : c, t = i.data.layout;
      } else
        t = {
          top: i.pid,
          left: i.idx,
          row: 2
        }, this.rule.layout.push(t);
      const l = this.makeMap(t);
      this.formCreateInject.children.forEach((c) => {
        c.slot && l.indexOf(c.slot) > -1 && (c.slot = `${i.pid}:${i.idx}`);
      }), this.loadRule();
    },
    addCol(i, t) {
      if (this.rule.col++, this.rule.layout.forEach((l) => {
        l.left > (t ? i.idx - 1 : i.idx) && l.left++;
      }), t || i.idx < this.rule.col - 2) {
        const l = {};
        for (let M = 0; M < this.rule.row; M++)
          for (let T = t ? i.idx - 1 : i.idx + 1; T < this.rule.col - 1; T++)
            l[`${M}:${T}`] = `${M}:${T + 1}`;
        const c = Object.keys(l);
        this.formCreateInject.children.forEach((M) => {
          let T;
          M.slot && (T = c.indexOf(M.slot)) > -1 && (M.slot = l[c[T]]);
        }), c.forEach((M) => {
          this.style[M] && (this.style[l[M]] = this.style[M], delete this.style[M]);
        });
      }
      this.loadRule();
    },
    addRow(i, t) {
      if (this.rule.row++, this.rule.layout.forEach((l) => {
        l.top > (t ? i.pid - 1 : i.pid) && l.top++;
      }), t || i.pid < this.rule.row - 2) {
        const l = {};
        for (let M = t ? i.pid - 1 : i.pid + 1; M < this.rule.row; M++)
          for (let T = 0; T < this.rule.col; T++)
            l[`${M}:${T}`] = `${M + 1}:${T}`;
        const c = Object.keys(l);
        this.formCreateInject.children.forEach((M) => {
          let T;
          M.slot && (T = c.indexOf(M.slot)) > -1 && (M.slot = l[c[T]]);
        }), c.reverse().forEach((M) => {
          this.style[M] && (this.style[l[M]] = this.style[M], delete this.style[M]);
        });
      }
      this.loadRule();
    },
    loadRule() {
      const i = [], t = this.rule || { row: 1, col: 1 };
      for (let c = 0; c < t.row; c++) {
        const M = [];
        i.push(M);
        for (let T = 0; T < t.col; T++)
          M.push({ rowspan: 1, colspan: 1, slot: [], show: !0, id: this.getUnique(`${c}${T}`) });
      }
      [...t.layout || []].forEach((c, M) => {
        if ((!c.row || c.row <= 0) && (!c.col || c.col <= 0) || !i[c.top] || !i[c.top][c.left] || !i[c.top][c.left].show) {
          t.layout.splice(M, 1);
          return;
        }
        const T = i[c.top][c.left];
        T.layout = c;
        let F = 1, z = 1;
        if (c.col && (F = c.col + c.left > t.col ? t.col - c.left : c.col, T.colspan = F), c.row && (z = c.row + c.top > t.row ? t.row - c.top : c.row, T.rowspan = z), z && F)
          for (let W = 0; W < z; W++) {
            const K = i[c.top + W];
            if (K)
              for (let q = 0; q < F; q++)
                !q && !W || (K[c.left + q] && (K[c.left + q].show = !1), T.slot.push(`${c.top + W}:${c.left + q}`));
          }
      });
      const l = (c) => !!(!c || c.layout || !c.show);
      i.forEach((c, M) => {
        c.forEach((T, F) => {
          let z = !1, W = !1;
          if (T.layout) {
            const K = T.layout.col || 1, q = T.layout.row || 1;
            for (let m = 0; m < K; m++)
              if (!i[M + q] || l(i[M + q][F + m])) {
                W = !0;
                continue;
              }
            for (let m = 0; m < q; m++)
              if (!i[M + m] || l(i[M + m][F + K])) {
                z = !0;
                continue;
              }
          } else
            z = l(c[F + 1]), W = i[M + 1] ? l(i[M + 1][F]) : !0;
          T.right = z, T.bottom = W;
        });
      }), this.lattice = i, this.formCreateInject.rule.props.rule = t;
    }
  },
  beforeMount() {
    this.loadRule();
  }
});
var jy = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_fd-table-view" }, [l("table", { style: t.tableColor, attrs: { border: "1", cellspacing: "0", cellpadding: "0" } }, [t._l(t.rule.row, function(c, M) {
    return [l("tr", { key: M }, [t._l(t.rule.col, function(T, F) {
      return [t.lattice[M][F].show ? l("td", t._b({ key: `${M}${F}`, class: t.rule.class && t.rule.class[`${M}:${F}`] || "", style: [t.tableColor, t.style && t.style[`${M}:${F}`] || {}] }, "td", t.lattice[M][F] ? { colspan: t.lattice[M][F].colspan, rowspan: t.lattice[M][F].rowspan } : {}, !1), [l("div", { staticClass: "_fd-table-view-cell" }, [l("DragTool", { attrs: { "drag-btn": !1, "handle-btn": !0, unique: t.lattice[M][F].id }, on: { active: function(z) {
        return t.active({ pid: M, idx: F });
      } }, scopedSlots: t._u([{ key: "handle", fn: function() {
        return [l("div", { staticClass: "_fd-drag-btn _fd-table-view-btn", on: { click: function(z) {
          return t.addRow({ pid: M, idx: F, data: t.lattice[M][F] }, 0);
        } } }, [l("i", { staticClass: "fc-icon icon-add-tr" })]), l("div", { staticClass: "_fd-drag-btn _fd-table-view-btn", on: { click: function(z) {
          return t.addCol({ pid: M, idx: F, data: t.lattice[M][F] }, 0);
        } } }, [l("i", { staticClass: "fc-icon icon-add-tr", staticStyle: { transform: "rotate(90deg)" } })]), l("div", { staticClass: "_fd-drag-btn _fd-table-view-btn" }, [l("el-dropdown", { attrs: { trigger: "click" }, on: { command: t.command }, scopedSlots: t._u([{ key: "dropdown", fn: function() {
          return [l("el-dropdown-menu", [l("el-dropdown-item", { attrs: { command: ["addCol", [{ pid: M, idx: F, data: t.lattice[M][F] }, 1]] } }, [t._v(" " + t._s(t.t("tableOptions.addLeft")) + " ")]), l("el-dropdown-item", { attrs: { command: ["addCol", [{ pid: M, idx: F, data: t.lattice[M][F] }, 0]] } }, [t._v(" " + t._s(t.t("tableOptions.addRight")) + " ")]), l("el-dropdown-item", { attrs: { command: ["addRow", [{ pid: M, idx: F, data: t.lattice[M][F] }, 1]] } }, [t._v(" " + t._s(t.t("tableOptions.addTop")) + " ")]), l("el-dropdown-item", { attrs: { command: ["addRow", [{ pid: M, idx: F, data: t.lattice[M][F] }, 0]] } }, [t._v(" " + t._s(t.t("tableOptions.addBottom")) + " ")]), l("el-dropdown-item", { attrs: { divided: "", disabled: t.lattice[M][F].right, command: ["mergeRight", [{ pid: M, idx: F, data: t.lattice[M][F] }]] } }, [t._v(" " + t._s(t.t("tableOptions.mergeRight")) + " ")]), l("el-dropdown-item", { attrs: { disabled: t.lattice[M][F].bottom, command: ["mergeBottom", [{ pid: M, idx: F, data: t.lattice[M][F] }]] } }, [t._v(" " + t._s(t.t("tableOptions.mergeBottom")) + " ")]), l("el-dropdown-item", { attrs: { divided: "", disabled: !(t.lattice[M][F].layout && t.lattice[M][F].layout.col > 1), command: ["splitCol", [{ pid: M, idx: F, data: t.lattice[M][F] }]] } }, [t._v(" " + t._s(t.t("tableOptions.splitCol")) + " ")]), l("el-dropdown-item", { attrs: { disabled: !(t.lattice[M][F].layout && t.lattice[M][F].layout.row > 1), command: ["splitRow", [{ pid: M, idx: F, data: t.lattice[M][F] }]] } }, [t._v(" " + t._s(t.t("tableOptions.splitRow")) + " ")]), l("el-dropdown-item", { attrs: { divided: "", disabled: t.rule.col < 2, command: ["rmCol", [{ pid: M, idx: F, data: t.lattice[M][F] }]] } }, [t._v(" " + t._s(t.t("tableOptions.rmCol")) + " ")]), l("el-dropdown-item", { attrs: { disabled: t.rule.row < 2, command: ["rmRow", [{ pid: M, idx: F, data: t.lattice[M][F] }]] } }, [t._v(" " + t._s(t.t("tableOptions.rmRow")) + " ")])], 1)];
        }, proxy: !0 }], null, !0) }, [l("i", { staticClass: "fc-icon icon-setting" })])], 1)];
      }, proxy: !0 }], null, !0) }, [l("DragBox", t._b({ ref: "drag" + M + F, refInFor: !0, attrs: { list: t.getSlotChildren([`${M}:${F}`, ...t.lattice[M][F].slot]) }, on: { add: (z) => t.dragAdd(z, { pid: M, idx: F }), end: (z) => t.dragEnd(z, { pid: M, idx: F }), start: (z) => t.dragStart(z), unchoose: (z) => t.dragUnchoose(z) } }, "DragBox", t.dragProp, !1), [t._t(`${M}:${F}`)], 2)], 1)], 1)]) : t._e()];
    })], 2)];
  })], 2)]);
}, $y = [], zy = /* @__PURE__ */ lt(
  Hy,
  jy,
  $y,
  !1,
  null,
  null
);
const Uy = zy.exports, Wy = {
  name: "FcTable",
  props: {
    label: String,
    width: [Number, String],
    border: {
      type: Boolean,
      default: !0
    },
    borderWidth: String,
    borderColor: String,
    rule: {
      type: Object,
      default: () => ({ row: 1, col: 1 })
    }
  },
  watch: {
    rule: {
      handler() {
        this.initRule(), this.loadRule(), this.tdStyle = this.rule.style || {}, this.tdClass = this.rule.class || {};
      },
      immediate: !0,
      deep: !0
    }
  },
  data() {
    return {
      tdStyle: {},
      tdClass: {},
      lattice: {}
    };
  },
  computed: {
    tableColor() {
      const i = {};
      return this.border === !1 ? i.border = "0 none" : (this.borderColor && (i.borderColor = this.borderColor), this.borderWidth && (i.borderWidth = this.borderWidth)), i;
    }
  },
  methods: {
    initRule() {
      const i = this.rule;
      i.style || (i.style = {}), i.layout || (i.layout = []), i.row || (i.row = 1), i.col || (i.col = 1);
    },
    loadRule() {
      const i = [], t = this.rule || { row: 1, col: 1 };
      for (let c = 0; c < t.row; c++) {
        const M = [];
        i.push(M);
        for (let T = 0; T < t.col; T++)
          M.push({ rowspan: 1, colspan: 1, slot: [], show: !0 });
      }
      [...t.layout || []].forEach((c, M) => {
        if ((!c.row || c.row <= 0) && (!c.col || c.col <= 0) || !i[c.top] || !i[c.top][c.left] || !i[c.top][c.left].show) {
          t.layout.splice(M, 1);
          return;
        }
        const T = i[c.top][c.left];
        T.layout = c;
        let F = 1, z = 1;
        if (c.col && (F = c.col + c.left > t.col ? t.col - c.left : c.col, T.colspan = F), c.row && (z = c.row + c.top > t.row ? t.row - c.top : c.row, T.rowspan = z), z && F)
          for (let W = 0; W < z; W++) {
            const K = i[c.top + W];
            if (K)
              for (let q = 0; q < F; q++)
                !q && !W || (K[c.left + q] && (K[c.left + q].show = !1), T.slot.push(`${c.top + W}:${c.left + q}`));
          }
      });
      const l = (c) => !!(!c || c.layout || !c.show);
      i.forEach((c, M) => {
        c.forEach((T, F) => {
          let z = !1, W = !1;
          if (T.layout) {
            const K = T.layout.col || 1, q = T.layout.row || 1;
            for (let m = 0; m < K; m++)
              if (!i[M + q] || l(i[M + q][F + m])) {
                W = !0;
                continue;
              }
            for (let m = 0; m < q; m++)
              if (!i[M + m] || l(i[M + m][F + K])) {
                z = !0;
                continue;
              }
          } else
            z = l(c[F + 1]), W = i[M + 1] ? l(i[M + 1][F]) : !0;
          T.right = z, T.bottom = W;
        });
      }), this.lattice = i;
    }
  }
};
var Qy = function() {
  var t = this, l = t._self._c;
  return l("el-col", { attrs: { span: 24 } }, [l("div", { staticClass: "_fc-table" }, [l("table", { style: t.tableColor, attrs: { border: "1", cellspacing: "0", cellpadding: "0" } }, [t._l(t.rule.row, function(c, M) {
    return [l("tr", { key: M }, [t._l(t.rule.col, function(T, F) {
      return [t.lattice[M][F].show ? l("td", t._b({ key: `${M}${F}`, class: t.tdClass && t.tdClass[`${M}:${F}`] || "", style: [t.tableColor, t.tdStyle && t.tdStyle[`${M}:${F}`] || {}], attrs: { valign: "top" } }, "td", t.lattice[M][F] ? { colspan: t.lattice[M][F].colspan, rowspan: t.lattice[M][F].rowspan } : {}, !1), [t._t(`${M}:${F}`), t._l(t.lattice[M][F].slot, function(z) {
        return [t._t(`${z}`)];
      })], 2) : t._e()];
    })], 2)];
  })], 2)])]);
}, Vy = [], Gy = /* @__PURE__ */ lt(
  Wy,
  Qy,
  Vy,
  !1,
  null,
  null
);
const Yy = Gy.exports, Ky = ft({
  name: "Validate",
  inject: ["designer"],
  emits: ["input"],
  props: {
    value: Array
  },
  components: {
    FnInput: cd
  },
  watch: {
    value(i) {
      this.validate = this.parseValue(i || []);
    }
  },
  data() {
    return {
      validate: this.parseValue(this.value || [])
    };
  },
  computed: {
    t() {
      return this.designer.t;
    },
    modes() {
      const i = this.designer.activeRule;
      return i && i._menu.subForm === "object" ? {
        validator: this.t("validate.modes.validator")
      } : {
        min: this.t("validate.modes.min"),
        max: this.t("validate.modes.max"),
        len: this.t("validate.modes.len"),
        pattern: this.t("validate.modes.pattern"),
        validator: this.t("validate.modes.validator")
      };
    },
    triggers() {
      return Jt(this.t, [
        { label: "blur", value: "blur" },
        { label: "change", value: "change" },
        { label: "submit", value: "submit" }
      ]);
    }
  },
  methods: {
    handleCommand(i) {
      this.validate.push({
        transform: new Function("val", "this.type = val == null ? 'string' : (Array.isArray(val) ? 'array' : (typeof val)); return val;"),
        mode: i,
        trigger: "blur"
      });
    },
    autoMessage(i) {
      const t = this.designer.activeRule.title;
      this.designer.activeRule && (i.message = this.t("validate.autoRequired", { title: t }), this.onInput());
    },
    getSpan(i) {
      return ["pattern", "validator", "required"].indexOf(i.mode) > -1 ? 24 : 12;
    },
    onInput: function() {
      this.$emit("input", this.validate.map((i) => (i = rt({}, i), i.message || delete i.message, i)));
    },
    remove(i) {
      this.validate.splice(i, 1), this.onInput();
    },
    parseValue(i) {
      return Nt(i.map((t) => (t.validator && (t.mode = "validator"), t.mode || Object.keys(t).forEach((l) => {
        ["message", "type", "trigger", "mode"].indexOf(l) < 0 && (t.mode = l);
      }), t)));
    }
  }
});
var Xy = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_fd-validate" }, [t._l(t.validate, function(c, M) {
    return [l("div", { staticClass: "_fd-validate-item" }, [l("div", { staticClass: "_fd-validate-title" }, [l("div", [l("span", [t._v(t._s(M + 1))]), t._v(" " + t._s(t.modes[c.mode]) + " ")]), l("i", { staticClass: "fc-icon icon-delete2", on: { click: function(T) {
      return t.remove(M);
    } } })]), l("el-row", [l("el-col", { attrs: { span: t.getSpan(c) } }, [l("el-form-item", { attrs: { label: t.t("validate.mode") } }, [l("el-select", { on: { change: t.onInput }, model: { value: c.trigger, callback: function(T) {
      t.$set(c, "trigger", T);
    }, expression: "item.trigger" } }, t._l(t.triggers, function(T) {
      return l("el-option", { key: T.value, attrs: { label: T.label, value: T.value } });
    }), 1)], 1)], 1), l("el-col", { attrs: { span: t.getSpan(c) } }, [l("el-form-item", { attrs: { label: t.modes[c.mode] } }, [c.mode === "pattern" ? [l("elInput", { on: { change: t.onInput }, model: { value: c[c.mode], callback: function(T) {
      t.$set(c, c.mode, T);
    }, expression: "item[item.mode]" } })] : c.mode === "validator" ? [l("FnInput", { attrs: { name: "name", args: ["rule", "value", "callback"] }, on: { change: t.onInput }, model: { value: c[c.mode], callback: function(T) {
      t.$set(c, c.mode, T);
    }, expression: "item[item.mode]" } }, [t._v(t._s(t.t("validate.modes.validator")) + " ")])] : [l("el-input-number", { on: { change: t.onInput }, model: { value: c[c.mode], callback: function(T) {
      t.$set(c, c.mode, T);
    }, expression: "item[item.mode]" } })]], 2)], 1), l("el-col", { attrs: { span: 24 } }, [l("el-form-item", { attrs: { label: t.t("validate.message") } }, [l("el-input", { attrs: { placeholder: t.t("validate.requiredPlaceholder") }, on: { blur: t.onInput }, scopedSlots: t._u([{ key: "append", fn: function() {
      return [l("span", { staticClass: "append-msg", on: { click: function(T) {
        return t.autoMessage(c);
      } } }, [t._v(" " + t._s(t.t("validate.auto")) + " ")])];
    }, proxy: !0 }], null, !0), model: { value: c.message, callback: function(T) {
      t.$set(c, "message", T);
    }, expression: "item.message" } })], 1)], 1)], 1)], 1)];
  }), l("el-dropdown", { attrs: { trigger: "click", size: "default", "popper-class": "_fd-validate-pop" }, on: { command: t.handleCommand }, scopedSlots: t._u([{ key: "dropdown", fn: function() {
    return [l("el-dropdown-menu", t._l(t.modes, function(c, M) {
      return l("el-dropdown-item", { key: M, staticStyle: { width: "240px" }, attrs: { command: M } }, [l("div", [t._v(t._s(c))])]);
    }), 1)];
  }, proxy: !0 }]) }, [l("el-button", { staticClass: "_fd-validate-btn", attrs: { size: "mini" } }, [t._v(t._s(t.t("validate.rule")) + " +")])], 1)], 2);
}, Jy = [], qy = /* @__PURE__ */ lt(
  Ky,
  Xy,
  Jy,
  !1,
  null,
  null
);
const Zy = qy.exports, e0 = ft({
  name: "Required",
  emits: ["input"],
  props: {
    value: {}
  },
  inject: ["designer"],
  watch: {
    required() {
      this.update();
    },
    requiredMsg() {
      this.update();
    },
    value(i) {
      const t = at.String(i);
      this.required = i === void 0 ? !1 : t ? !0 : !!i, this.requiredMsg = t ? i : "";
    }
  },
  computed: {
    t() {
      return this.designer.t;
    }
  },
  data() {
    const i = at.String(this.value);
    return {
      required: this.value === void 0 ? !1 : i ? !0 : !!this.value,
      requiredMsg: i ? this.value : ""
    };
  },
  methods: {
    update() {
      let i;
      this.required === !1 ? i = !1 : i = this.requiredMsg || !0, this.$emit("input", i);
    }
  }
});
var t0 = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_fd-required" }, [l("el-switch", { model: { value: t.required, callback: function(c) {
    t.required = c;
  }, expression: "required" } }), t.required ? l("el-input", { attrs: { placeholder: t.t("validate.requiredPlaceholder") }, model: { value: t.requiredMsg, callback: function(c) {
    t.requiredMsg = c;
  }, expression: "requiredMsg" } }) : t._e()], 1);
}, n0 = [], r0 = /* @__PURE__ */ lt(
  e0,
  t0,
  n0,
  !1,
  null,
  null
);
const i0 = r0.exports;
function o0(i) {
  return typeof i != "object" || i === null ? i : i instanceof Array ? [...i] : rt({}, i);
}
const a0 = ft({
  name: "TableOptions",
  emits: ["input", "change"],
  props: {
    value: [Array, Object],
    column: {
      type: Array,
      default: () => [{ label: "label", key: "label" }, { label: "value", key: "value" }]
    },
    valueType: String,
    max: Number,
    size: String
  },
  inject: ["designer"],
  watch: {
    value() {
      this.formValue = this.tidyModelValue();
    }
  },
  computed: {
    t() {
      return this.designer.t;
    }
  },
  data() {
    return {
      formValue: this.tidyModelValue()
    };
  },
  methods: {
    tidyModelValue() {
      const i = this.value;
      return this.valueType === "string" ? (i || []).map((t) => ({ value: "" + t })) : this.valueType === "object" ? Object.keys(i || {}).map((t) => ({ label: t, value: i[t] })) : [...i || []].map((t) => o0(t));
    },
    tidyValue() {
      if (this.valueType === "object") {
        const i = {};
        return this.formValue.forEach((t) => {
          t.label && t.value && (i[t.label] = t.value);
        }), i;
      } else
        return this.formValue.map((i) => this.valueType === "string" ? i.value : rt({}, i));
    },
    onInput(i) {
      if (this.column.length === 1 && !i[this.column[0].key])
        return;
      this.column.every((l) => l.required === !1 ? !0 : ["object", "string"].indexOf(this.valueType) > -1 ? i[l.key] !== void 0 && i[l.key] !== "" && i[l.key] !== null : i[l.key] !== void 0) && this.input();
    },
    input() {
      const i = this.tidyValue();
      this.$emit("input", i), this.$emit("change", i);
    },
    add() {
      this.formValue.push(this.column.reduce((i, t) => (i[t.key] = "", i), {}));
    },
    del(i) {
      this.formValue.splice(i, 1), this.input();
    }
  }
});
var l0 = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_td-table-opt" }, [l("el-table", { staticStyle: { width: "100%" }, attrs: { data: t.formValue, border: "", size: t.size || "mini" } }, [t._l(t.column, function(c, M) {
    return [l("el-table-column", { key: c.label + M, attrs: { label: c.label }, scopedSlots: t._u([{ key: "default", fn: function(T) {
      return [l("el-input", { attrs: { size: t.size || "mini", value: T.row[c.key] || "" }, on: { input: (F) => T.row[c.key] = F, blur: function(F) {
        return t.onInput(T.row);
      } } })];
    } }], null, !0) })];
  }), l("el-table-column", { attrs: { width: "70", align: "center", fixed: "right", label: t.t("tableOptions.handle") }, scopedSlots: t._u([{ key: "default", fn: function(c) {
    return [l("i", { staticClass: "fc-icon icon-delete", on: { click: function(M) {
      return t.del(c.$index);
    } } })];
  } }]) })], 2), l("div", { staticClass: "_td-table-opt-handle" }, [!t.max || t.max > t.formValue.length ? l("el-button", { attrs: { type: "text" }, on: { click: t.add } }, [l("i", { staticClass: "fc-icon icon-add" }), t._v(" " + t._s(t.t("tableOptions.add")) + " ")]) : t._e()], 1)], 1);
}, s0 = [], u0 = /* @__PURE__ */ lt(
  a0,
  l0,
  s0,
  !1,
  null,
  "79b8ca47"
);
const pd = u0.exports, c0 = ft({
  name: "TreeOptions",
  emits: ["input"],
  props: {
    value: Array,
    columns: Object
  },
  inject: ["designer"],
  data() {
    return {
      formValue: [...Nt(this.value || [])]
    };
  },
  computed: {
    t() {
      return this.designer.t;
    },
    overColumns() {
      return this.columns ? {
        label: this.columns.label || "label",
        value: this.columns.value || "value"
      } : {
        label: "label",
        value: "value"
      };
    }
  },
  created() {
    this.formValue.length || (this.formValue = [{}]);
  },
  methods: {
    tidyValue() {
      return Nt(this.formValue);
    },
    change() {
      this.$emit("input", this.tidyValue());
    },
    add(i) {
      const t = i.parent;
      (t.data.children || t.data).push({});
    },
    append(i) {
      i.children || this.$set(i, "children", []), i.children.push({});
    },
    remove(i, t) {
      const l = i.parent;
      l.data.children ? (l.data.children.splice(l.data.children.indexOf(t), 1), l.data.children.length || delete l.data.children) : l.data.splice(l.data.indexOf(t), 1), this.change();
    }
  }
});
var f0 = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_fd-tree-opt" }, [l("el-tree", { attrs: { data: t.formValue, "node-key": "index", "expand-on-click-node": !1 }, scopedSlots: t._u([{ key: "default", fn: function({ node: c, data: M }) {
    return [l("div", { staticClass: "_fd-tree-opt-node" }, [l("el-input", { staticClass: "_fd-tree-opt-first", attrs: { size: "mini" }, on: { blur: t.change }, model: { value: M[t.overColumns.label], callback: function(T) {
      t.$set(M, t.overColumns.label, T);
    }, expression: "data[overColumns.label]" } }), l("el-input", { staticClass: "_fd-tree-opt-last", on: { blur: t.change }, scopedSlots: t._u([{ key: "append", fn: function() {
      return [l("div", { staticClass: "_fd-tree-opt-btn", on: { click: function(T) {
        return t.add(c, M);
      } } }, [l("i", { staticClass: "fc-icon icon-add" })]), l("div", { staticClass: "_fd-tree-opt-btn", on: { click: function(T) {
        return t.append(M);
      } } }, [l("i", { staticClass: "fc-icon icon-add-child" })]), l("div", { staticClass: "_fd-tree-opt-btn _fd-tree-opt-danger", on: { click: function(T) {
        return t.remove(c, M);
      } } }, [l("i", { staticClass: "fc-icon icon-delete" })])];
    }, proxy: !0 }], null, !0), model: { value: M[t.overColumns.value], callback: function(T) {
      t.$set(M, t.overColumns.value, T);
    }, expression: "data[overColumns.value]" } })], 1)];
  } }]) })], 1);
}, d0 = [], p0 = /* @__PURE__ */ lt(
  c0,
  f0,
  d0,
  !1,
  null,
  null
);
const h0 = p0.exports, v0 = ft({
  name: "SizeInput",
  inject: ["designer"],
  emits: ["input", "change"],
  props: {
    value: String,
    size: String,
    unit: {
      type: Array,
      default: () => ["auto", "px", "%", "vh", "vw", "em", "rem"]
    },
    defaultUnit: {
      type: String,
      default: "px"
    }
  },
  watch: {
    value() {
      this.parseValue();
    }
  },
  data() {
    return {
      idx: 1,
      num: 0,
      oldValue: this.value || ""
    };
  },
  methods: {
    parseValue() {
      this.value !== "auto" ? (this.idx = Math.max(this.unit.indexOf(this.defaultUnit), 0), this.unit.forEach((i, t) => {
        (this.value || "").indexOf(i) > -1 && (this.idx = t);
      }), this.num = qn(this.value) ? null : parseFloat(this.value || 0)) : (this.idx = 0, this.num = 0);
    },
    submit() {
      this.oldValue = qn(this.num) ? "" : "" + this.num + this.unit[this.idx], this.$emit("input", this.oldValue), this.$emit("change", this.oldValue);
    },
    changeType(i) {
      if (i !== void 0) {
        if (this.idx === i)
          return;
        this.idx = i;
      } else
        this.idx++, this.idx > 4 && (this.idx = 0);
      this.unit[this.idx] === "auto" ? (this.oldValue = "auto", this.$emit("input", "auto"), this.$emit("change", "auto")) : this.submit();
    }
  },
  created() {
    this.parseValue();
  }
});
var g0 = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_fd-size-input" }, [t.unit[t.idx] === "auto" ? [l("el-button", { staticStyle: { width: "150px" }, attrs: { size: t.size }, on: { click: function(c) {
    return t.changeType();
  } } }, [t._v(t._s(t.unit[t.idx]))])] : [l("el-inputNumber", { attrs: { size: t.size || "mini", "controls-position": "right" }, on: { change: t.submit }, model: { value: t.num, callback: function(c) {
    t.num = c;
  }, expression: "num" } }), l("el-dropdown", { attrs: { trigger: "click", size: "mini" }, on: { command: t.changeType }, scopedSlots: t._u([{ key: "dropdown", fn: function() {
    return [l("el-dropdown-menu", t._l(t.unit, function(c, M) {
      return l("el-dropdown-item", { key: c, attrs: { command: M } }, [l("div", [t._v(t._s(c))])]);
    }), 1)];
  }, proxy: !0 }]) }, [l("el-button", { attrs: { size: t.size } }, [t._v(t._s(t.unit[t.idx]))])], 1)]], 2);
}, m0 = [], y0 = /* @__PURE__ */ lt(
  v0,
  g0,
  m0,
  !1,
  null,
  null
);
const Ea = y0.exports, b0 = ft({
  name: "ColorInput",
  inject: ["designer"],
  emits: ["input", "change"],
  props: {
    value: String
  },
  watch: {
    value() {
      this.value = this.value || "";
    },
    color(i) {
      this.$emit("input", i), this.$emit("change", i);
    }
  },
  data() {
    return {
      color: this.value || ""
    };
  },
  methods: {},
  created() {
  }
});
var A0 = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_fd-color-input" }, [l("el-input", { attrs: { clearable: "" }, scopedSlots: t._u([{ key: "append", fn: function() {
    return [l("el-color-picker", { attrs: { "show-alpha": "", "color-format": "hex" }, model: { value: t.color, callback: function(c) {
      t.color = c;
    }, expression: "color" } })];
  }, proxy: !0 }]), model: { value: t.color, callback: function(c) {
    t.color = c;
  }, expression: "color" } })], 1);
}, x0 = [], w0 = /* @__PURE__ */ lt(
  b0,
  A0,
  x0,
  !1,
  null,
  null
);
const yo = w0.exports, _0 = ft({
  name: "BoxSizeInput",
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  inject: ["designer"],
  emits: ["input", "change"],
  data() {
    return {
      position: ["Top", "Right", "Bottom", "Left"],
      boxStyle: {
        margin: "",
        padding: "",
        marginLeft: "",
        marginRight: "",
        marginTop: "",
        marginBottom: "",
        paddingLeft: "",
        paddingRight: "",
        paddingTop: "",
        paddingBottom: "",
        width: "",
        height: ""
      },
      marginLock: !1,
      paddingLock: !1
    };
  },
  watch: {
    value() {
      this.tidyValue();
    }
  },
  computed: {
    t() {
      return this.designer.t;
    }
  },
  methods: {
    tidyValue() {
      this.boxStyle = {}, ["margin", "padding"].forEach((i) => {
        this.boxStyle[i] = this.value[i] || "", this.position.forEach((t) => {
          this.boxStyle[i + t] = this.tidySize(this.value[i + t] || this.value[i] || "");
        });
      }), this.boxStyle.height = this.tidySize(this.value.height), this.boxStyle.width = this.tidySize(this.value.width || "");
    },
    onInput() {
      const i = Object.keys(this.boxStyle).reduce((t, l) => (this.boxStyle[l] !== "" && (t[l] = this.boxStyle[l]), t), {});
      this.$emit("input", i), this.$emit("change", i);
    },
    tidySize(i) {
      if (!/^(\d*\.?\d+)(px|rem|%|vh|vw|em)$/.test(i)) {
        if (i === "auto")
          return i;
        const l = parseInt(i);
        return isNaN(l) ? "" : l + "px";
      }
      return i;
    },
    setValue(i, t, l) {
      const c = this.tidySize(l.target.value);
      i ? this[i + "Lock"] ? this.position.forEach((M) => {
        this.boxStyle[i + M] = c;
      }) : this.boxStyle[i + t] = c : this.boxStyle[t] = c, this.onInput();
    },
    change(i, t) {
      this.boxStyle[i] = t.target.value;
    },
    clear(i) {
      this.position.forEach((t) => {
        this.boxStyle[i + t] = "";
      });
    },
    lock(i) {
      const t = i + "Lock";
      this[t] = !this[t];
    }
  },
  created() {
    this.tidyValue();
  }
});
var C0 = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_fd-box-size-input" }, [l("div", { staticClass: "_padding" }, [l("span", { staticClass: "_padding-title" }, [t._v(" " + t._s(t.t("style.margin")) + " ")]), l("input", { staticClass: "_fd-input _fd-top", attrs: { placeholder: "      ", type: "text" }, domProps: { value: t.boxStyle.marginTop }, on: { blur: (c) => t.setValue("margin", "Top", c), input: (c) => t.change("marginTop", c) } }), l("input", { staticClass: "_fd-input _fd-right", attrs: { placeholder: "      ", type: "text" }, domProps: { value: t.boxStyle.marginRight }, on: { blur: (c) => t.setValue("margin", "Right", c), input: (c) => t.change("marginRight", c) } }), l("input", { staticClass: "_fd-input _fd-bottom", attrs: { placeholder: "      ", type: "text" }, domProps: { value: t.boxStyle.marginBottom }, on: { blur: (c) => t.setValue("margin", "Bottom", c), input: (c) => t.change("marginBottom", c) } }), l("input", { staticClass: "_fd-input _fd-left", attrs: { placeholder: "      ", type: "text" }, domProps: { value: t.boxStyle.marginLeft }, on: { blur: (c) => t.setValue("margin", "Left", c), input: (c) => t.change("marginLeft", c) } }), l("div", { staticClass: "_fd-help" }, [l("i", { staticClass: "fc-icon icon-link2", class: t.marginLock ? "active" : "", attrs: { title: "lock" }, on: { click: function(c) {
    return t.lock("margin");
  } } }), l("i", { staticClass: "fc-icon icon-delete2", attrs: { title: "clear" }, on: { click: function(c) {
    return t.clear("margin");
  } } })]), l("div", { staticClass: "_margin" }, [l("span", { staticClass: "_margin-title" }, [t._v(" " + t._s(t.t("style.padding")) + " ")]), l("div", { staticClass: "_fd-help" }, [l("i", { staticClass: "fc-icon icon-link2", class: t.paddingLock ? "active" : "", attrs: { title: "lock" }, on: { click: function(c) {
    return t.lock("padding");
  } } }), l("i", { staticClass: "fc-icon icon-delete2", attrs: { title: "clear" }, on: { click: function(c) {
    return t.clear("padding");
  } } })]), l("input", { staticClass: "_fd-input _fd-top", attrs: { placeholder: "      ", type: "text" }, domProps: { value: t.boxStyle.paddingTop }, on: { blur: (c) => t.setValue("padding", "Top", c), input: (c) => t.change("paddingTop", c) } }), l("input", { staticClass: "_fd-input _fd-right", attrs: { placeholder: "      ", type: "text" }, domProps: { value: t.boxStyle.paddingRight }, on: { blur: (c) => t.setValue("padding", "Right", c), input: (c) => t.change("paddingRight", c) } }), l("input", { staticClass: "_fd-input _fd-bottom", attrs: { placeholder: "      ", type: "text" }, domProps: { value: t.boxStyle.paddingBottom }, on: { blur: (c) => t.setValue("padding", "Bottom", c), input: (c) => t.change("paddingBottom", c) } }), l("input", { staticClass: "_fd-input _fd-left", attrs: { placeholder: "      ", type: "text" }, domProps: { value: t.boxStyle.paddingLeft }, on: { blur: (c) => t.setValue("padding", "Left", c), input: (c) => t.change("paddingLeft", c) } }), l("div", { staticClass: "_box" }, [l("input", { staticClass: "_fd-input", attrs: { placeholder: "      ", type: "text" }, domProps: { value: t.boxStyle.width }, on: { blur: (c) => t.setValue("", "width", c), input: (c) => t.change("width", c) } }), l("div", { staticClass: "_fd-x" }, [t._v("x")]), l("input", { staticClass: "_fd-input", attrs: { placeholder: "      ", type: "text" }, domProps: { value: t.boxStyle.height }, on: { blur: (c) => t.setValue("", "height", c), input: (c) => t.change("height", c) } })])])])]);
}, S0 = [], E0 = /* @__PURE__ */ lt(
  _0,
  C0,
  S0,
  !1,
  null,
  null
);
const k0 = E0.exports, T0 = ft({
  name: "ConfigItem",
  props: {
    label: String,
    info: String,
    appendBackground: String,
    arrow: {
      type: Boolean,
      default: !0
    },
    showAppend: Boolean
  },
  data() {
    return {
      visit: !1
    };
  }
});
var D0 = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_fd-config-item" }, [l("div", { staticClass: "_fd-ci-head" }, [l("div", { staticClass: "_fd-ci-label", class: t.$slots.append && t.arrow !== !1 ? "is-arrow" : "", on: { click: function(c) {
    t.visit = t.$slots.append && t.arrow !== !1 && !t.visit;
  } } }, [t._t("label", function() {
    return [l("span", [t._v(t._s(t.label))])];
  }), t.$slots.append && t.arrow !== !1 ? l("i", { staticClass: "fc-icon icon-down", class: t.showAppend || t.visit ? "down" : "" }) : t._e()], 2), t.$slots.default || t.info ? l("div", { staticClass: "_fd-ci-con" }, [t.$slots.default ? [t._t("default")] : l("span", { staticClass: "_fd-ci-info" }, [t._v(t._s(t.info))])], 2) : t._e()]), t.showAppend || t.visit ? l("div", { staticClass: "_fd-ci-append", style: "background:" + t.appendBackground }, [t._t("append")], 2) : t._e()]);
}, M0 = [], N0 = /* @__PURE__ */ lt(
  T0,
  D0,
  M0,
  !1,
  null,
  null
);
const yi = N0.exports;
function hd(i) {
  let t = i.replace(/([A-Z])/g, "-$1").toLocaleLowerCase();
  return t.indexOf("-") === 0 && (t = t.substr(1)), t;
}
const O0 = ft({
  name: "BorderInput",
  components: { ColorInput: yo, SizeInput: Ea, ConfigItem: yi },
  inject: ["designer"],
  emits: ["input", "change"],
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    value() {
      this.tidyValue(), this.initCur();
    },
    active() {
      this.initCur();
    }
  },
  computed: {
    borderStyleStr() {
      let i = "";
      return Object.keys(this.borderStyle).forEach((t) => {
        this.borderStyle[t] !== "" && (i += hd(t) + ": " + this.borderStyle[t] + ";");
      }, {}), i;
    }
  },
  data() {
    const i = this.designer.t;
    return {
      t: i,
      active: "",
      borderStyle: {},
      curStyle: "",
      curColor: "",
      curWidth: "",
      lineType: ["solid", "dashed", "dotted", "double"].map((t) => ({ value: t, label: i("style." + t) })),
      position: ["Top", "Left", "Bottom", "Right"],
      type: ["Style", "Color", "Width"],
      unwatch: null
    };
  },
  methods: {
    tidyValue() {
      const i = [];
      this.borderStyle = {}, ["", ...this.position].forEach((t) => {
        this.type.forEach((l) => {
          i.push("border" + t + l);
        });
      }), i.forEach((t) => {
        this.borderStyle[t] = this.value[t] || "";
      });
    },
    onInput() {
      const i = Object.keys(this.borderStyle).reduce((t, l) => (this.borderStyle[l] !== "" && (t[l] = this.borderStyle[l]), t), {});
      this.$emit("input", i), this.$emit("change", i);
    },
    pushCur() {
      this.borderStyle["border" + this.active + "Style"] = this.curStyle || "", this.borderStyle["border" + this.active + "Color"] = this.curColor || "", this.borderStyle["border" + this.active + "Width"] = this.curWidth || "", this.onInput();
    },
    initCur() {
      this.unwatch && this.unwatch(), this.curStyle = this.borderStyle["border" + this.active + "Style"] || "", this.curColor = this.borderStyle["border" + this.active + "Color"] || "", this.curWidth = this.borderStyle["border" + this.active + "Width"] || "", this.unwatch = this.$watch(() => [this.curStyle, this.curColor, this.curWidth], () => {
        this.pushCur();
      });
    }
  },
  created() {
    this.tidyValue(), this.initCur();
  }
});
var R0 = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("ConfigItem", { attrs: { label: t.t("style.border") }, scopedSlots: t._u([{ key: "append", fn: function() {
    return [l("div", { staticClass: "_fd-border-input" }, [l("div", { staticClass: "_fd-bi-left" }, [l("div", { staticClass: "_fd-bil-row" }, [l("div", { staticClass: "_fd-bil-col", class: t.active === "Top" ? "active" : "", on: { click: function(c) {
      t.active = "Top";
    } } }, [t._v("┳ ")])]), l("div", { staticClass: "_fd-bil-row" }, [l("div", { staticClass: "_fd-bil-col", class: t.active === "Left" ? "active" : "", on: { click: function(c) {
      t.active = "Left";
    } } }, [t._v("┣ ")]), l("div", { staticClass: "_fd-bil-col", class: t.active === "" ? "active" : "", on: { click: function(c) {
      t.active = "";
    } } }, [t._v("╋")]), l("div", { staticClass: "_fd-bil-col", class: t.active === "Right" ? "active" : "", on: { click: function(c) {
      t.active = "Right";
    } } }, [t._v(" ┫ ")])]), l("div", { staticClass: "_fd-bil-row" }, [l("div", { staticClass: "_fd-bil-col", class: t.active === "Bottom" ? "active" : "", on: { click: function(c) {
      t.active = "Bottom";
    } } }, [t._v("┻ ")])])]), l("div", { staticClass: "_fd-bi-right" }, [l("el-select", { attrs: { clearable: "" }, model: { value: t.curStyle, callback: function(c) {
      t.curStyle = c;
    }, expression: "curStyle" } }, t._l(t.lineType, function(c) {
      return l("el-option", { key: c.value, attrs: { label: c.label, value: c.value } }, [l("div", { staticClass: "_fd-bi-opt" }, [l("div", { staticClass: "_line", class: c.value })])]);
    }), 1), l("SizeInput", { model: { value: t.curWidth, callback: function(c) {
      t.curWidth = c;
    }, expression: "curWidth" } }), l("ColorInput", { model: { value: t.curColor, callback: function(c) {
      t.curColor = c;
    }, expression: "curColor" } })], 1)])];
  }, proxy: !0 }]) }, [l("div", { staticClass: "line-box", style: t.borderStyleStr }, [l("div", { staticClass: "line-box-con" })])]);
}, I0 = [], L0 = /* @__PURE__ */ lt(
  O0,
  R0,
  I0,
  !1,
  null,
  null
);
const F0 = L0.exports, B0 = ft({
  name: "RadiusInput",
  components: { ConfigItem: yi, ColorInput: yo, SizeInput: Ea },
  inject: ["designer"],
  emits: ["input", "change"],
  props: {
    value: String
  },
  watch: {
    value(i) {
      i !== this.oldValue && this.tidyValue();
    }
  },
  computed: {
    t() {
      return this.designer.t;
    }
  },
  data() {
    return {
      visit: !1,
      active: "",
      style: {
        com: "",
        left: "",
        right: "",
        top: "",
        bottom: ""
      },
      unit: ["px", "%"],
      oldValue: ""
    };
  },
  methods: {
    batch() {
      this.style.left = this.style.com, this.style.right = this.style.com, this.style.top = this.style.com, this.style.bottom = this.style.com, this.onInput();
    },
    tidyValue() {
      if (this.style = {
        com: "",
        left: "",
        right: "",
        top: "",
        bottom: ""
      }, !this.value)
        return;
      let i = (this.value || "").split(" ").filter((t) => t !== "");
      i.length === 1 ? i = [i[0], i[0], i[0], i[0]] : i.length === 2 ? i = [i[0], i[1], i[0], i[1]] : i.length === 3 && (i = [i[0], i[1], i[2], i[1]]), this.style.left = i[0], this.style.top = i[1], this.style.right = i[2], this.style.bottom = i[3], this.updateCom();
    },
    updateCom() {
      let i = `${this.style.left || "0px"} ${this.style.top || "0px"} ${this.style.right || "0px"} ${this.style.bottom || "0px"}`;
      this.style.com = i.replaceAll(this.style.left, "").trim() === "" ? this.style.left : "";
    },
    onInput() {
      let i = `${this.style.left || "0px"} ${this.style.top || "0px"} ${this.style.right || "0px"} ${this.style.bottom || "0px"}`;
      `${this.style.left}${this.style.top}${this.style.right}${this.style.bottom}`.trim() === "" ? i = "" : this.updateCom(), this.oldValue = i, this.$emit("input", i), this.$emit("change", i);
    }
  },
  created() {
    this.tidyValue();
  }
});
var P0 = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_fd-radius-input" }, [l("ConfigItem", { attrs: { label: t.t("style.borderRadius") }, scopedSlots: t._u([{ key: "append", fn: function() {
    return [l("div", { staticClass: "_fd-radius-con" }, [l("div", { staticClass: "_fd-radius-item" }, [l("div", { staticClass: "_fd-radius-icon", staticStyle: { transform: "rotate(180deg)" } }, [l("i", { staticClass: "fc-icon icon-radius" })]), l("SizeInput", { attrs: { unit: t.unit }, on: { change: t.onInput }, model: { value: t.style.left, callback: function(c) {
      t.$set(t.style, "left", c);
    }, expression: "style.left" } })], 1), l("div", { staticClass: "_fd-radius-item" }, [l("div", { staticClass: "_fd-radius-icon", staticStyle: { transform: "rotate(-90deg)" } }, [l("i", { staticClass: "fc-icon icon-radius" })]), l("SizeInput", { attrs: { unit: t.unit }, on: { change: t.onInput }, model: { value: t.style.top, callback: function(c) {
      t.$set(t.style, "top", c);
    }, expression: "style.top" } })], 1), l("div", { staticClass: "_fd-radius-item" }, [l("div", { staticClass: "_fd-radius-icon", staticStyle: { transform: "rotate(90deg)" } }, [l("i", { staticClass: "fc-icon icon-radius" })]), l("SizeInput", { attrs: { unit: t.unit }, on: { change: t.onInput }, model: { value: t.style.bottom, callback: function(c) {
      t.$set(t.style, "bottom", c);
    }, expression: "style.bottom" } })], 1), l("div", { staticClass: "_fd-radius-item" }, [l("div", { staticClass: "_fd-radius-icon" }, [l("i", { staticClass: "fc-icon icon-radius" })]), l("SizeInput", { attrs: { unit: t.unit }, on: { change: t.onInput }, model: { value: t.style.right, callback: function(c) {
      t.$set(t.style, "right", c);
    }, expression: "style.right" } })], 1)])];
  }, proxy: !0 }]) }, [l("SizeInput", { attrs: { unit: t.unit }, on: { change: t.batch }, model: { value: t.style.com, callback: function(c) {
    t.$set(t.style, "com", c);
  }, expression: "style.com" } })], 1)], 1);
}, H0 = [], j0 = /* @__PURE__ */ lt(
  B0,
  P0,
  H0,
  !1,
  null,
  null
);
const $0 = j0.exports, z0 = ft({
  name: "BorderInput",
  components: { ColorInput: yo, SizeInput: Ea, ConfigItem: yi },
  inject: ["designer"],
  emits: ["input", "change"],
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    value() {
      this.tidyValue();
    }
  },
  computed: {
    borderStyleStr() {
      let i = "";
      return Object.keys(this.borderStyle).forEach((t) => {
        this.borderStyle[t] !== "" && (i += hd(t) + ": " + this.borderStyle[t] + ";");
      }, {}), i;
    },
    alignType() {
      return ["left", "center", "right"].map((i) => ({ label: this.t("props." + i), value: i }));
    },
    decorationType() {
      return ["underline", "line-through", "overline"].map((i) => ({ label: this.t("style.decoration." + i), value: i }));
    },
    weightType() {
      return [300, 400, 500, 700].map((i) => ({ label: this.t("style.weight." + i), value: i }));
    }
  },
  data() {
    return {
      t: this.designer.t,
      fontStyle: {
        fontSize: "",
        fontWeight: "",
        fontStyle: "",
        textDecoration: "",
        textAlign: "",
        lineHeight: "",
        letterSpacing: ""
      }
    };
  },
  methods: {
    tidyValue() {
      Object.keys(this.fontStyle).forEach((i) => {
        this.fontStyle[i] = this.value[i] || "";
      });
    },
    onInput() {
      const i = Object.keys(this.fontStyle).reduce((t, l) => (this.fontStyle[l] !== "" && (t[l] = this.fontStyle[l]), t), {});
      this.$emit("input", i), this.$emit("change", i);
    }
  },
  created() {
    this.tidyValue();
  }
});
var U0 = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("ConfigItem", { attrs: { label: t.t("style.font.name") }, scopedSlots: t._u([{ key: "append", fn: function() {
    return [l("div", { staticClass: "_fd-font-input" }, [l("el-form", { attrs: { "label-width": "50px", "label-position": "top", inline: "", size: "mini" } }, [l("el-form-item", { attrs: { label: t.t("style.font.size") } }, [l("SizeInput", { on: { change: t.onInput }, model: { value: t.fontStyle.fontSize, callback: function(c) {
      t.$set(t.fontStyle, "fontSize", c);
    }, expression: "fontStyle.fontSize" } })], 1), l("el-form-item", { attrs: { label: t.t("style.weight.name") } }, [l("el-select", { attrs: { clearable: "" }, on: { change: t.onInput }, model: { value: t.fontStyle.fontWeight, callback: function(c) {
      t.$set(t.fontStyle, "fontWeight", c);
    }, expression: "fontStyle.fontWeight" } }, t._l(t.weightType, function(c) {
      return l("el-option", { key: c.value, attrs: { label: c.label, value: c.value } }, [l("span", { style: { fontWeight: c.value } }, [t._v(t._s(c.label))])]);
    }), 1)], 1), l("el-form-item", { attrs: { label: t.t("style.decoration.name") } }, [l("el-select", { attrs: { clearable: "" }, on: { change: t.onInput }, model: { value: t.fontStyle.textDecoration, callback: function(c) {
      t.$set(t.fontStyle, "textDecoration", c);
    }, expression: "fontStyle.textDecoration" } }, t._l(t.decorationType, function(c) {
      return l("el-option", { key: c.value, attrs: { label: c.label, value: c.value } }, [l("span", { style: { textDecoration: c.value } }, [t._v(t._s(c.label))])]);
    }), 1)], 1), l("el-form-item", { attrs: { label: t.t("style.font.align") } }, [l("el-select", { attrs: { clearable: "" }, on: { change: t.onInput }, model: { value: t.fontStyle.textAlign, callback: function(c) {
      t.$set(t.fontStyle, "textAlign", c);
    }, expression: "fontStyle.textAlign" } }, t._l(t.alignType, function(c) {
      return l("el-option", { key: c.value, attrs: { label: c.label, value: c.value } });
    }), 1)], 1), l("el-form-item", { attrs: { label: t.t("style.font.height") } }, [l("SizeInput", { on: { change: t.onInput }, model: { value: t.fontStyle.lineHeight, callback: function(c) {
      t.$set(t.fontStyle, "lineHeight", c);
    }, expression: "fontStyle.lineHeight" } })], 1), l("el-form-item", { attrs: { label: t.t("style.font.spacing") } }, [l("SizeInput", { on: { change: t.onInput }, model: { value: t.fontStyle.letterSpacing, callback: function(c) {
      t.$set(t.fontStyle, "letterSpacing", c);
    }, expression: "fontStyle.letterSpacing" } })], 1)], 1)], 1)];
  }, proxy: !0 }]) }, [l("div", { staticClass: "_fd-fi-box", style: t.fontStyle }, [t._v(" " + t._s(t.t("style.font.preview")) + " ")])]);
}, W0 = [], Q0 = /* @__PURE__ */ lt(
  z0,
  U0,
  W0,
  !1,
  null,
  null
);
const V0 = Q0.exports, G0 = ft({
  name: "ShadowInput",
  emits: ["input", "change"],
  components: { ConfigItem: yi },
  inject: ["designer"],
  props: {
    value: String
  },
  watch: {
    value() {
      this.value = this.value || "";
    },
    shadow(i) {
      this.$emit("input", i), this.$emit("change", i);
    }
  },
  data() {
    const i = this.designer.t;
    return {
      t: i,
      options: [
        { label: i("style.shadow.classic"), value: "3px 5px 7px 2px #CBCBCBFF" },
        { label: i("style.shadow.flat"), value: "4px 4px 3px -2px #E7E5E5FF" },
        { label: i("style.shadow.solid"), value: "1px 2px 4px 2px #979797FF" }
      ],
      shadow: this.value || ""
    };
  },
  methods: {
    changeValue(i) {
      this.value = i;
    }
  },
  created() {
  }
});
var Y0 = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_fd-shadow-input" }, [l("ConfigItem", { attrs: { label: t.t("style.shadow.name") } }, [l("el-input", { staticClass: "_fd-si-input", attrs: { clearable: "" }, scopedSlots: t._u([{ key: "append", fn: function() {
    return [l("el-dropdown", { scopedSlots: t._u([{ key: "dropdown", fn: function() {
      return [l("el-dropdown-menu", t._l(t.options, function(c) {
        return l("el-dropdown-item", { on: { click: function(M) {
          return t.changeValue(c.value);
        } } }, [t._v(" " + t._s(c.label) + " ")]);
      }), 1)];
    }, proxy: !0 }]) }, [l("i", { staticClass: "fc-icon icon-setting" })])];
  }, proxy: !0 }]), model: { value: t.shadow, callback: function(c) {
    t.shadow = c;
  }, expression: "shadow" } })], 1)], 1);
}, K0 = [], X0 = /* @__PURE__ */ lt(
  G0,
  Y0,
  K0,
  !1,
  null,
  null
);
const J0 = X0.exports, vd = [
  "fontSize",
  "fontWeight",
  "fontStyle",
  "textDecoration",
  "textAlign",
  "lineHeight",
  "letterSpacing"
], Tf = [
  "color",
  "backgroundColor",
  "scale",
  "borderRadius",
  "boxShadow",
  "marginTop",
  "marginRight",
  "marginBottom",
  "marginLeft",
  "paddingTop",
  "paddingRight",
  "paddingBottom",
  "paddingLeft",
  "margin",
  "padding",
  "opacity",
  "height",
  "width",
  "borderStyle",
  "borderColor",
  "borderWidth",
  "borderTopStyle",
  "borderTopColor",
  "borderTopWidth",
  "borderLeftStyle",
  "borderLeftColor",
  "borderLeftWidth",
  "borderBottomStyle",
  "borderBottomColor",
  "borderBottomWidth",
  "borderRightStyle",
  "borderRightColor",
  "borderRightWidth",
  ...vd
], q0 = ft({
  name: "StyleConfig",
  inject: ["designer"],
  emits: ["input"],
  components: {
    TableOptions: pd,
    ColorInput: yo,
    ConfigItem: yi,
    RadiusInput: $0,
    BoxSizeInput: k0,
    BorderInput: F0,
    ShadowInput: J0,
    FontInput: V0
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    value() {
      this.tidyStyle();
    }
  },
  data() {
    return {
      t: this.designer.t,
      formData: {},
      size: {},
      border: {},
      font: {},
      radius: "",
      backgroundColor: "",
      color: "",
      boxShadow: "",
      opacity: 100,
      scale: 100
    };
  },
  methods: {
    tidyStyle() {
      const i = rt({}, this.value || {}), t = {};
      Object.keys(i).forEach((F) => {
        (["margin", "padding", "height", "width"].indexOf(F) > -1 || F.indexOf("margin") > -1 || F.indexOf("padding") > -1) && (t[F] = i[F]);
      });
      const l = {};
      Object.keys(i).forEach((F) => {
        F.indexOf("border") === 0 && (l[F] = i[F]);
      });
      let c = qn(i.opacity) ? 100 : parseFloat(i.opacity) || 0;
      c && c < 1 && (c = c * 100);
      let M = i.scale;
      qn(i.scale) ? M = 100 : isNaN(Number(M)) ? M = parseFloat(M) || 100 : M = M > 0 ? M * 100 : 0;
      const T = {};
      vd.forEach((F) => {
        i[F] && (T[F] = i[F]);
      }), this.opacity = c, this.scale = M, this.size = t, this.border = l, this.font = T, this.radius = i.borderRadius || "", this.boxShadow = i.boxShadow || "", this.color = i.color || "", this.backgroundColor = i.backgroundColor || "", Tf.forEach((F) => {
        delete i[F];
      }), this.formData = i;
    },
    onInput() {
      let i = rt({}, this.formData);
      Tf.forEach((l) => {
        delete i[l];
      });
      const t = rt(rt(rt(vr(rt({}, i), {
        color: this.color || "",
        backgroundColor: this.backgroundColor || "",
        opacity: this.opacity >= 0 && this.opacity < 100 ? this.opacity + "%" : "",
        borderRadius: this.radius || "",
        boxShadow: this.boxShadow || "",
        scale: this.scale >= 0 && this.scale !== 100 ? this.scale + "%" : ""
      }), this.size), this.border), this.font);
      Object.keys(t).forEach((l) => {
        qn(t[l]) && delete t[l];
      }), this.$emit("input", t);
    }
  },
  created() {
    this.tidyStyle();
  }
});
var Z0 = function() {
  var t = this, l = t._self._c;
  return t._self._setupProxy, l("div", { staticClass: "_fd-style-config" }, [l("BoxSizeInput", { staticStyle: { "margin-bottom": "15px" }, on: { change: t.onInput }, model: { value: t.size, callback: function(c) {
    t.size = c;
  }, expression: "size" } }), l("ConfigItem", { attrs: { label: t.t("style.color") } }, [l("ColorInput", { on: { change: t.onInput }, model: { value: t.color, callback: function(c) {
    t.color = c;
  }, expression: "color" } })], 1), l("ConfigItem", { attrs: { label: t.t("style.backgroundColor") } }, [l("ColorInput", { on: { change: t.onInput }, model: { value: t.backgroundColor, callback: function(c) {
    t.backgroundColor = c;
  }, expression: "backgroundColor" } })], 1), l("BorderInput", { on: { change: t.onInput }, model: { value: t.border, callback: function(c) {
    t.border = c;
  }, expression: "border" } }), l("RadiusInput", { on: { change: t.onInput }, model: { value: t.radius, callback: function(c) {
    t.radius = c;
  }, expression: "radius" } }), l("FontInput", { on: { change: t.onInput }, model: { value: t.font, callback: function(c) {
    t.font = c;
  }, expression: "font" } }), l("ShadowInput", { on: { change: t.onInput }, model: { value: t.boxShadow, callback: function(c) {
    t.boxShadow = c;
  }, expression: "boxShadow" } }), l("ConfigItem", { staticClass: "_fd-opacity-input", attrs: { label: t.t("style.opacity") } }, [l("el-slider", { attrs: { "show-tooltip": !1 }, on: { change: t.onInput }, model: { value: t.opacity, callback: function(c) {
    t.opacity = c;
  }, expression: "opacity" } }), l("span", [t._v(t._s(t.opacity) + "%")])], 1), l("ConfigItem", { staticClass: "_fd-opacity-input", attrs: { label: t.t("style.scale") } }, [l("el-slider", { attrs: { min: 80, max: 120, "show-tooltip": !1 }, on: { change: t.onInput }, model: { value: t.scale, callback: function(c) {
    t.scale = c;
  }, expression: "scale" } }), l("span", [t._v(t._s(t.scale) + "%")])], 1), l("ConfigItem", { attrs: { label: t.t("props.custom"), info: Object.keys(t.formData).length > 0 ? t.t("struct.configured") : "" }, scopedSlots: t._u([{ key: "append", fn: function() {
    return [l("TableOptions", t._b({ on: { change: t.onInput }, model: { value: t.formData, callback: function(c) {
      t.formData = c;
    }, expression: "formData" } }, "TableOptions", {
      column: [{ label: t.t("props.key"), key: "label" }, { label: t.t("props.value"), key: "value" }],
      valueType: "object"
    }, !1))];
  }, proxy: !0 }]) })], 1);
}, eb = [], tb = /* @__PURE__ */ lt(
  q0,
  Z0,
  eb,
  !1,
  null,
  null
);
const nb = tb.exports;
var gd = { exports: {} };
/*!
 * @form-create/component-wangeditor v2.5.15
 * (c) 2018-2021 xaboy
 * Github https://github.com/xaboy/form-create with @form-create/component-wangeditor
 * Released under the MIT License.
 */
(function(i, t) {
  (function(l, c) {
    i.exports = c();
  })(ks, function() {
    var l, c, M = (function(W, K) {
      var q;
      q = function() {
        return function(m) {
          var d = {};
          function r(u) {
            if (d[u]) return d[u].exports;
            var v = d[u] = { i: u, l: !1, exports: {} };
            return m[u].call(v.exports, v, v.exports, r), v.l = !0, v.exports;
          }
          return r.m = m, r.c = d, r.d = function(u, v, C) {
            r.o(u, v) || Object.defineProperty(u, v, { enumerable: !0, get: C });
          }, r.r = function(u) {
            typeof Symbol != "undefined" && Symbol.toStringTag && Object.defineProperty(u, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(u, "__esModule", { value: !0 });
          }, r.t = function(u, v) {
            if (1 & v && (u = r(u)), 8 & v || 4 & v && typeof u == "object" && u && u.__esModule) return u;
            var C = /* @__PURE__ */ Object.create(null);
            if (r.r(C), Object.defineProperty(C, "default", { enumerable: !0, value: u }), 2 & v && typeof u != "string") for (var p in u) r.d(C, p, function(b) {
              return u[b];
            }.bind(null, p));
            return C;
          }, r.n = function(u) {
            var v = u && u.__esModule ? function() {
              return u.default;
            } : function() {
              return u;
            };
            return r.d(v, "a", v), v;
          }, r.o = function(u, v) {
            return Object.prototype.hasOwnProperty.call(u, v);
          }, r.p = "", r(r.s = 135);
        }([function(m, d) {
          m.exports = function(r) {
            return r && r.__esModule ? r : { default: r };
          }, m.exports.default = m.exports, m.exports.__esModule = !0;
        }, function(m, d, r) {
          m.exports = r(136);
        }, function(m, d, r) {
          r.r(d), r.d(d, "__extends", function() {
            return v;
          }), r.d(d, "__assign", function() {
            return C;
          }), r.d(d, "__rest", function() {
            return p;
          }), r.d(d, "__decorate", function() {
            return b;
          }), r.d(d, "__param", function() {
            return x;
          }), r.d(d, "__metadata", function() {
            return g;
          }), r.d(d, "__awaiter", function() {
            return _;
          }), r.d(d, "__generator", function() {
            return A;
          }), r.d(d, "__createBinding", function() {
            return f;
          }), r.d(d, "__exportStar", function() {
            return S;
          }), r.d(d, "__values", function() {
            return D;
          }), r.d(d, "__read", function() {
            return k;
          }), r.d(d, "__spread", function() {
            return L;
          }), r.d(d, "__spreadArrays", function() {
            return h;
          }), r.d(d, "__spreadArray", function() {
            return E;
          }), r.d(d, "__await", function() {
            return w;
          }), r.d(d, "__asyncGenerator", function() {
            return O;
          }), r.d(d, "__asyncDelegator", function() {
            return R;
          }), r.d(d, "__asyncValues", function() {
            return I;
          }), r.d(d, "__makeTemplateObject", function() {
            return H;
          }), r.d(d, "__importStar", function() {
            return Q;
          }), r.d(d, "__importDefault", function() {
            return U;
          }), r.d(d, "__classPrivateFieldGet", function() {
            return Y;
          }), r.d(d, "__classPrivateFieldSet", function() {
            return X;
          });
          var u = function(G, J) {
            return (u = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ee, re) {
              ee.__proto__ = re;
            } || function(ee, re) {
              for (var oe in re) Object.prototype.hasOwnProperty.call(re, oe) && (ee[oe] = re[oe]);
            })(G, J);
          };
          function v(G, J) {
            if (typeof J != "function" && J !== null) throw new TypeError("Class extends value " + String(J) + " is not a constructor or null");
            function ee() {
              this.constructor = G;
            }
            u(G, J), G.prototype = J === null ? Object.create(J) : (ee.prototype = J.prototype, new ee());
          }
          var C = function() {
            return (C = Object.assign || function(G) {
              for (var J, ee = 1, re = arguments.length; ee < re; ee++) for (var oe in J = arguments[ee]) Object.prototype.hasOwnProperty.call(J, oe) && (G[oe] = J[oe]);
              return G;
            }).apply(this, arguments);
          };
          function p(G, J) {
            var ee = {};
            for (var re in G) Object.prototype.hasOwnProperty.call(G, re) && J.indexOf(re) < 0 && (ee[re] = G[re]);
            if (G != null && typeof Object.getOwnPropertySymbols == "function") {
              var oe = 0;
              for (re = Object.getOwnPropertySymbols(G); oe < re.length; oe++) J.indexOf(re[oe]) < 0 && Object.prototype.propertyIsEnumerable.call(G, re[oe]) && (ee[re[oe]] = G[re[oe]]);
            }
            return ee;
          }
          function b(G, J, ee, re) {
            var oe, ae = arguments.length, se = ae < 3 ? J : re === null ? re = Object.getOwnPropertyDescriptor(J, ee) : re;
            if (typeof Reflect == "object" && typeof Reflect.decorate == "function") se = Reflect.decorate(G, J, ee, re);
            else for (var ve = G.length - 1; ve >= 0; ve--) (oe = G[ve]) && (se = (ae < 3 ? oe(se) : ae > 3 ? oe(J, ee, se) : oe(J, ee)) || se);
            return ae > 3 && se && Object.defineProperty(J, ee, se), se;
          }
          function x(G, J) {
            return function(ee, re) {
              J(ee, re, G);
            };
          }
          function g(G, J) {
            if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(G, J);
          }
          function _(G, J, ee, re) {
            return new (ee || (ee = Promise))(function(oe, ae) {
              function se(ye) {
                try {
                  Ae(re.next(ye));
                } catch (ce) {
                  ae(ce);
                }
              }
              function ve(ye) {
                try {
                  Ae(re.throw(ye));
                } catch (ce) {
                  ae(ce);
                }
              }
              function Ae(ye) {
                var ce;
                ye.done ? oe(ye.value) : (ce = ye.value, ce instanceof ee ? ce : new ee(function(he) {
                  he(ce);
                })).then(se, ve);
              }
              Ae((re = re.apply(G, J || [])).next());
            });
          }
          function A(G, J) {
            var ee, re, oe, ae, se = { label: 0, sent: function() {
              if (1 & oe[0]) throw oe[1];
              return oe[1];
            }, trys: [], ops: [] };
            return ae = { next: ve(0), throw: ve(1), return: ve(2) }, typeof Symbol == "function" && (ae[Symbol.iterator] = function() {
              return this;
            }), ae;
            function ve(Ae) {
              return function(ye) {
                return function(ce) {
                  if (ee) throw new TypeError("Generator is already executing.");
                  for (; se; ) try {
                    if (ee = 1, re && (oe = 2 & ce[0] ? re.return : ce[0] ? re.throw || ((oe = re.return) && oe.call(re), 0) : re.next) && !(oe = oe.call(re, ce[1])).done) return oe;
                    switch (re = 0, oe && (ce = [2 & ce[0], oe.value]), ce[0]) {
                      case 0:
                      case 1:
                        oe = ce;
                        break;
                      case 4:
                        return se.label++, { value: ce[1], done: !1 };
                      case 5:
                        se.label++, re = ce[1], ce = [0];
                        continue;
                      case 7:
                        ce = se.ops.pop(), se.trys.pop();
                        continue;
                      default:
                        if (!(oe = (oe = se.trys).length > 0 && oe[oe.length - 1]) && (ce[0] === 6 || ce[0] === 2)) {
                          se = 0;
                          continue;
                        }
                        if (ce[0] === 3 && (!oe || ce[1] > oe[0] && ce[1] < oe[3])) {
                          se.label = ce[1];
                          break;
                        }
                        if (ce[0] === 6 && se.label < oe[1]) {
                          se.label = oe[1], oe = ce;
                          break;
                        }
                        if (oe && se.label < oe[2]) {
                          se.label = oe[2], se.ops.push(ce);
                          break;
                        }
                        oe[2] && se.ops.pop(), se.trys.pop();
                        continue;
                    }
                    ce = J.call(G, se);
                  } catch (he) {
                    ce = [6, he], re = 0;
                  } finally {
                    ee = oe = 0;
                  }
                  if (5 & ce[0]) throw ce[1];
                  return { value: ce[0] ? ce[1] : void 0, done: !0 };
                }([Ae, ye]);
              };
            }
          }
          var f = Object.create ? function(G, J, ee, re) {
            re === void 0 && (re = ee), Object.defineProperty(G, re, { enumerable: !0, get: function() {
              return J[ee];
            } });
          } : function(G, J, ee, re) {
            re === void 0 && (re = ee), G[re] = J[ee];
          };
          function S(G, J) {
            for (var ee in G) ee === "default" || Object.prototype.hasOwnProperty.call(J, ee) || f(J, G, ee);
          }
          function D(G) {
            var J = typeof Symbol == "function" && Symbol.iterator, ee = J && G[J], re = 0;
            if (ee) return ee.call(G);
            if (G && typeof G.length == "number") return { next: function() {
              return G && re >= G.length && (G = void 0), { value: G && G[re++], done: !G };
            } };
            throw new TypeError(J ? "Object is not iterable." : "Symbol.iterator is not defined.");
          }
          function k(G, J) {
            var ee = typeof Symbol == "function" && G[Symbol.iterator];
            if (!ee) return G;
            var re, oe, ae = ee.call(G), se = [];
            try {
              for (; (J === void 0 || J-- > 0) && !(re = ae.next()).done; ) se.push(re.value);
            } catch (ve) {
              oe = { error: ve };
            } finally {
              try {
                re && !re.done && (ee = ae.return) && ee.call(ae);
              } finally {
                if (oe) throw oe.error;
              }
            }
            return se;
          }
          function L() {
            for (var G = [], J = 0; J < arguments.length; J++) G = G.concat(k(arguments[J]));
            return G;
          }
          function h() {
            for (var G = 0, J = 0, ee = arguments.length; J < ee; J++) G += arguments[J].length;
            var re = Array(G), oe = 0;
            for (J = 0; J < ee; J++) for (var ae = arguments[J], se = 0, ve = ae.length; se < ve; se++, oe++) re[oe] = ae[se];
            return re;
          }
          function E(G, J) {
            for (var ee = 0, re = J.length, oe = G.length; ee < re; ee++, oe++) G[oe] = J[ee];
            return G;
          }
          function w(G) {
            return this instanceof w ? (this.v = G, this) : new w(G);
          }
          function O(G, J, ee) {
            if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
            var re, oe = ee.apply(G, J || []), ae = [];
            return re = {}, se("next"), se("throw"), se("return"), re[Symbol.asyncIterator] = function() {
              return this;
            }, re;
            function se(he) {
              oe[he] && (re[he] = function(ke) {
                return new Promise(function(je, He) {
                  ae.push([he, ke, je, He]) > 1 || ve(he, ke);
                });
              });
            }
            function ve(he, ke) {
              try {
                (je = oe[he](ke)).value instanceof w ? Promise.resolve(je.value.v).then(Ae, ye) : ce(ae[0][2], je);
              } catch (He) {
                ce(ae[0][3], He);
              }
              var je;
            }
            function Ae(he) {
              ve("next", he);
            }
            function ye(he) {
              ve("throw", he);
            }
            function ce(he, ke) {
              he(ke), ae.shift(), ae.length && ve(ae[0][0], ae[0][1]);
            }
          }
          function R(G) {
            var J, ee;
            return J = {}, re("next"), re("throw", function(oe) {
              throw oe;
            }), re("return"), J[Symbol.iterator] = function() {
              return this;
            }, J;
            function re(oe, ae) {
              J[oe] = G[oe] ? function(se) {
                return (ee = !ee) ? { value: w(G[oe](se)), done: oe === "return" } : ae ? ae(se) : se;
              } : ae;
            }
          }
          function I(G) {
            if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
            var J, ee = G[Symbol.asyncIterator];
            return ee ? ee.call(G) : (G = D(G), J = {}, re("next"), re("throw"), re("return"), J[Symbol.asyncIterator] = function() {
              return this;
            }, J);
            function re(oe) {
              J[oe] = G[oe] && function(ae) {
                return new Promise(function(se, ve) {
                  (function(Ae, ye, ce, he) {
                    Promise.resolve(he).then(function(ke) {
                      Ae({ value: ke, done: ce });
                    }, ye);
                  })(se, ve, (ae = G[oe](ae)).done, ae.value);
                });
              };
            }
          }
          function H(G, J) {
            return Object.defineProperty ? Object.defineProperty(G, "raw", { value: J }) : G.raw = J, G;
          }
          var $ = Object.create ? function(G, J) {
            Object.defineProperty(G, "default", { enumerable: !0, value: J });
          } : function(G, J) {
            G.default = J;
          };
          function Q(G) {
            if (G && G.__esModule) return G;
            var J = {};
            if (G != null) for (var ee in G) ee !== "default" && Object.prototype.hasOwnProperty.call(G, ee) && f(J, G, ee);
            return $(J, G), J;
          }
          function U(G) {
            return G && G.__esModule ? G : { default: G };
          }
          function Y(G, J) {
            if (!J.has(G)) throw new TypeError("attempted to get private field on non-instance");
            return J.get(G);
          }
          function X(G, J, ee) {
            if (!J.has(G)) throw new TypeError("attempted to set private field on non-instance");
            return J.set(G, ee), ee;
          }
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(90)), p = u(r(4)), b = u(r(25)), x = u(r(19)), g = u(r(116)), _ = u(r(26)), A = u(r(92)), f = u(r(72)), S = u(r(73)), D = u(r(53));
          (0, v.default)(d, "__esModule", { value: !0 }), d.DomElement = void 0;
          var k = r(2), L = r(6), h = [];
          function E(R) {
            var I = [], H = [];
            return I = (0, C.default)(R) ? R : R.split(";"), (0, p.default)(I).call(I, function($) {
              var Q, U = (0, b.default)(Q = $.split(":")).call(Q, function(Y) {
                return (0, x.default)(Y).call(Y);
              });
              U.length === 2 && H.push(U[0] + ":" + U[1]);
            }), H;
          }
          var w = function() {
            function R(I) {
              if (this.elems = [], this.length = this.elems.length, this.dataSource = new g.default(), I) {
                if (I instanceof R) return I;
                var H = [], $ = I instanceof Node ? I.nodeType : -1;
                if (this.selector = I, $ === 1 || $ === 9) H = [I];
                else if (function(G) {
                  return !!G && (G instanceof HTMLCollection || G instanceof NodeList);
                }(I)) H = L.toArray(I);
                else if (I instanceof Array) H = I;
                else if (typeof I == "string") {
                  var Q, U = (0, x.default)(Q = I.replace(`/
/mg`, "")).call(Q);
                  H = (0, _.default)(U).call(U, "<") === 0 ? function(G) {
                    var J = document.createElement("div");
                    J.innerHTML = G;
                    var ee = J.children;
                    return L.toArray(ee);
                  }(U) : function(G) {
                    var J = document.querySelectorAll(G);
                    return L.toArray(J);
                  }(U);
                }
                var Y = H.length;
                if (!Y) return this;
                for (var X = 0; X < Y; X++) this.elems.push(H[X]);
                this.length = Y;
              }
            }
            return (0, v.default)(R.prototype, "id", { get: function() {
              return this.elems[0].id;
            }, enumerable: !1, configurable: !0 }), R.prototype.forEach = function(I) {
              for (var H = 0; H < this.length; H++) {
                var $ = this.elems[H];
                if (I.call($, $, H) === !1) break;
              }
              return this;
            }, R.prototype.clone = function(I) {
              var H;
              I === void 0 && (I = !1);
              var $ = [];
              return (0, p.default)(H = this.elems).call(H, function(Q) {
                $.push(Q.cloneNode(!!I));
              }), O($);
            }, R.prototype.get = function(I) {
              I === void 0 && (I = 0);
              var H = this.length;
              return I >= H && (I %= H), O(this.elems[I]);
            }, R.prototype.first = function() {
              return this.get(0);
            }, R.prototype.last = function() {
              var I = this.length;
              return this.get(I - 1);
            }, R.prototype.on = function(I, H, $) {
              var Q;
              return I ? (typeof H == "function" && ($ = H, H = ""), (0, p.default)(Q = this).call(Q, function(U) {
                if (H) {
                  var Y = function(X) {
                    var G = X.target;
                    G.matches(H) && $.call(G, X);
                  };
                  U.addEventListener(I, Y), h.push({ elem: U, selector: H, fn: $, agentFn: Y });
                } else U.addEventListener(I, $);
              })) : this;
            }, R.prototype.off = function(I, H, $) {
              var Q;
              return I ? (typeof H == "function" && ($ = H, H = ""), (0, p.default)(Q = this).call(Q, function(U) {
                if (H) {
                  for (var Y = -1, X = 0; X < h.length; X++) {
                    var G = h[X];
                    if (G.selector === H && G.fn === $ && G.elem === U) {
                      Y = X;
                      break;
                    }
                  }
                  if (Y !== -1) {
                    var J = (0, A.default)(h).call(h, Y, 1)[0].agentFn;
                    U.removeEventListener(I, J);
                  }
                } else U.removeEventListener(I, $);
              })) : this;
            }, R.prototype.attr = function(I, H) {
              var $;
              return H == null ? this.elems[0].getAttribute(I) || "" : (0, p.default)($ = this).call($, function(Q) {
                Q.setAttribute(I, H);
              });
            }, R.prototype.removeAttr = function(I) {
              var H;
              (0, p.default)(H = this).call(H, function($) {
                $.removeAttribute(I);
              });
            }, R.prototype.addClass = function(I) {
              var H;
              return I ? (0, p.default)(H = this).call(H, function($) {
                if ($.className) {
                  var Q = $.className.split(/\s/);
                  Q = (0, f.default)(Q).call(Q, function(U) {
                    return !!(0, x.default)(U).call(U);
                  }), (0, _.default)(Q).call(Q, I) < 0 && Q.push(I), $.className = Q.join(" ");
                } else $.className = I;
              }) : this;
            }, R.prototype.removeClass = function(I) {
              var H;
              return I ? (0, p.default)(H = this).call(H, function($) {
                if ($.className) {
                  var Q = $.className.split(/\s/);
                  Q = (0, f.default)(Q).call(Q, function(U) {
                    return !(!(U = (0, x.default)(U).call(U)) || U === I);
                  }), $.className = Q.join(" ");
                }
              }) : this;
            }, R.prototype.hasClass = function(I) {
              if (!I) return !1;
              var H = this.elems[0];
              if (!H.className) return !1;
              var $ = H.className.split(/\s/);
              return (0, S.default)($).call($, I);
            }, R.prototype.css = function(I, H) {
              var $, Q;
              return Q = H == "" ? "" : I + ":" + H + ";", (0, p.default)($ = this).call($, function(U) {
                var Y, X = (0, x.default)(Y = U.getAttribute("style") || "").call(Y);
                if (X) {
                  var G = E(X);
                  G = (0, b.default)(G).call(G, function(J) {
                    return (0, _.default)(J).call(J, I) === 0 ? Q : J;
                  }), Q != "" && (0, _.default)(G).call(G, Q) < 0 && G.push(Q), Q == "" && (G = E(G)), U.setAttribute("style", G.join("; "));
                } else U.setAttribute("style", Q);
              });
            }, R.prototype.getBoundingClientRect = function() {
              return this.elems[0].getBoundingClientRect();
            }, R.prototype.show = function() {
              return this.css("display", "block");
            }, R.prototype.hide = function() {
              return this.css("display", "none");
            }, R.prototype.children = function() {
              var I = this.elems[0];
              return I ? O(I.children) : null;
            }, R.prototype.childNodes = function() {
              var I = this.elems[0];
              return I ? O(I.childNodes) : null;
            }, R.prototype.replaceChildAll = function(I) {
              for (var H = this.getNode(), $ = this.elems[0]; $.hasChildNodes(); ) H.firstChild && $.removeChild(H.firstChild);
              this.append(I);
            }, R.prototype.append = function(I) {
              var H;
              return (0, p.default)(H = this).call(H, function($) {
                (0, p.default)(I).call(I, function(Q) {
                  $.appendChild(Q);
                });
              });
            }, R.prototype.remove = function() {
              var I;
              return (0, p.default)(I = this).call(I, function(H) {
                if (H.remove) H.remove();
                else {
                  var $ = H.parentElement;
                  $ && $.removeChild(H);
                }
              });
            }, R.prototype.isContain = function(I) {
              var H = this.elems[0], $ = I.elems[0];
              return H.contains($);
            }, R.prototype.getNodeName = function() {
              return this.elems[0].nodeName;
            }, R.prototype.getNode = function(I) {
              return I === void 0 && (I = 0), this.elems[I];
            }, R.prototype.find = function(I) {
              return O(this.elems[0].querySelectorAll(I));
            }, R.prototype.text = function(I) {
              var H;
              return I ? (0, p.default)(H = this).call(H, function($) {
                $.innerHTML = I;
              }) : this.elems[0].innerHTML.replace(/<[^>]+>/g, function() {
                return "";
              });
            }, R.prototype.html = function(I) {
              var H = this.elems[0];
              return I ? (H.innerHTML = I, this) : H.innerHTML;
            }, R.prototype.val = function() {
              var I, H = this.elems[0];
              return (0, x.default)(I = H.value).call(I);
            }, R.prototype.focus = function() {
              var I;
              return (0, p.default)(I = this).call(I, function(H) {
                H.focus();
              });
            }, R.prototype.prev = function() {
              return O(this.elems[0].previousElementSibling);
            }, R.prototype.next = function() {
              return O(this.elems[0].nextElementSibling);
            }, R.prototype.getNextSibling = function() {
              return O(this.elems[0].nextSibling);
            }, R.prototype.parent = function() {
              return O(this.elems[0].parentElement);
            }, R.prototype.parentUntil = function(I, H) {
              var $ = H || this.elems[0];
              if ($.nodeName === "BODY") return null;
              var Q = $.parentElement;
              return Q === null ? null : Q.matches(I) ? O(Q) : this.parentUntil(I, Q);
            }, R.prototype.parentUntilEditor = function(I, H, $) {
              var Q = $ || this.elems[0];
              if (O(Q).equal(H.$textContainerElem) || O(Q).equal(H.$toolbarElem)) return null;
              var U = Q.parentElement;
              return U === null ? null : U.matches(I) ? O(U) : this.parentUntilEditor(I, H, U);
            }, R.prototype.equal = function(I) {
              return I instanceof R ? this.elems[0] === I.elems[0] : I instanceof HTMLElement && this.elems[0] === I;
            }, R.prototype.insertBefore = function(I) {
              var H, $ = O(I).elems[0];
              return $ ? (0, p.default)(H = this).call(H, function(Q) {
                $.parentNode.insertBefore(Q, $);
              }) : this;
            }, R.prototype.insertAfter = function(I) {
              var H, $ = O(I).elems[0], Q = $ && $.nextSibling;
              return $ ? (0, p.default)(H = this).call(H, function(U) {
                var Y = $.parentNode;
                Q ? Y.insertBefore(U, Q) : Y.appendChild(U);
              }) : this;
            }, R.prototype.data = function(I, H) {
              if (H == null) return this.dataSource.get(I);
              this.dataSource.set(I, H);
            }, R.prototype.getNodeTop = function(I) {
              if (this.length < 1) return this;
              var H = this.parent();
              return I.$textElem.equal(this) || I.$textElem.equal(H) ? this : (H.prior = this, H.getNodeTop(I));
            }, R.prototype.getOffsetData = function() {
              var I = this.elems[0];
              return { top: I.offsetTop, left: I.offsetLeft, width: I.offsetWidth, height: I.offsetHeight, parent: I.offsetParent };
            }, R.prototype.scrollTop = function(I) {
              this.elems[0].scrollTo({ top: I });
            }, R;
          }();
          function O() {
            for (var R = [], I = 0; I < arguments.length; I++) R[I] = arguments[I];
            return new ((0, D.default)(w).apply(w, k.__spreadArray([void 0], R)))();
          }
          d.DomElement = w, d.default = O;
        }, function(m, d, r) {
          m.exports = r(180);
        }, function(m, d, r) {
          var u = r(8), v = r(74).f, C = r(101), p = r(12), b = r(47), x = r(17), g = r(16), _ = function(A) {
            var f = function(S, D, k) {
              if (this instanceof A) {
                switch (arguments.length) {
                  case 0:
                    return new A();
                  case 1:
                    return new A(S);
                  case 2:
                    return new A(S, D);
                }
                return new A(S, D, k);
              }
              return A.apply(this, arguments);
            };
            return f.prototype = A.prototype, f;
          };
          m.exports = function(A, f) {
            var S, D, k, L, h, E, w, O, R = A.target, I = A.global, H = A.stat, $ = A.proto, Q = I ? u : H ? u[R] : (u[R] || {}).prototype, U = I ? p : p[R] || (p[R] = {}), Y = U.prototype;
            for (k in f) S = !C(I ? k : R + (H ? "." : "#") + k, A.forced) && Q && g(Q, k), h = U[k], S && (E = A.noTargetGet ? (O = v(Q, k)) && O.value : Q[k]), L = S && E ? E : f[k], S && typeof h == typeof L || (w = A.bind && S ? b(L, u) : A.wrap && S ? _(L) : $ && typeof L == "function" ? b(Function.call, L) : L, (A.sham || L && L.sham || h && h.sham) && x(w, "sham", !0), U[k] = w, $ && (g(p, D = R + "Prototype") || x(p, D, {}), p[D][k] = L, A.real && Y && !Y[k] && x(Y, k, L)));
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(94)), C = u(r(1)), p = u(r(257)), b = u(r(43)), x = u(r(54)), g = u(r(90)), _ = u(r(25));
          (0, C.default)(d, "__esModule", { value: !0 }), d.hexToRgb = d.getRandomCode = d.toArray = d.deepClone = d.isFunction = d.debounce = d.throttle = d.arrForEach = d.forEach = d.replaceSpecialSymbol = d.replaceHtmlSymbol = d.getRandom = d.UA = void 0;
          var A = r(2), f = function() {
            function S() {
              this._ua = navigator.userAgent;
              var D = this._ua.match(/(Edge?)\/(\d+)/);
              this.isOldEdge = !!(D && D[1] == "Edge" && (0, p.default)(D[2]) < 19), this.isFirefox = !(!/Firefox\/\d+/.test(this._ua) || /Seamonkey\/\d+/.test(this._ua));
            }
            return S.prototype.isIE = function() {
              return "ActiveXObject" in window;
            }, S.prototype.isWebkit = function() {
              return /webkit/i.test(this._ua);
            }, S;
          }();
          d.UA = new f(), d.getRandom = function(S) {
            var D;
            return S === void 0 && (S = ""), S + (0, b.default)(D = Math.random().toString()).call(D, 2);
          }, d.replaceHtmlSymbol = function(S) {
            return S.replace(/</gm, "&lt;").replace(/>/gm, "&gt;").replace(/"/gm, "&quot;").replace(/(\r\n|\r|\n)/g, "<br/>");
          }, d.replaceSpecialSymbol = function(S) {
            return S.replace(/&lt;/gm, "<").replace(/&gt;/gm, ">").replace(/&quot;/gm, '"');
          }, d.forEach = function(S, D) {
            for (var k in S) if (Object.prototype.hasOwnProperty.call(S, k) && D(k, S[k]) === !1) break;
          }, d.arrForEach = function(S, D) {
            var k, L, h = S.length || 0;
            for (k = 0; k < h && (L = S[k], D.call(S, L, k) !== !1); k++) ;
          }, d.throttle = function(S, D) {
            D === void 0 && (D = 200);
            var k = !1;
            return function() {
              for (var L = this, h = [], E = 0; E < arguments.length; E++) h[E] = arguments[E];
              k || (k = !0, (0, x.default)(function() {
                k = !1, S.call.apply(S, A.__spreadArray([L], h));
              }, D));
            };
          }, d.debounce = function(S, D) {
            D === void 0 && (D = 200);
            var k = 0;
            return function() {
              for (var L = this, h = [], E = 0; E < arguments.length; E++) h[E] = arguments[E];
              k && window.clearTimeout(k), k = (0, x.default)(function() {
                k = 0, S.call.apply(S, A.__spreadArray([L], h));
              }, D);
            };
          }, d.isFunction = function(S) {
            return typeof S == "function";
          }, d.deepClone = function S(D) {
            if ((0, v.default)(D) !== "object" || typeof D == "function" || D === null) return D;
            var k;
            for (var L in (0, g.default)(D) && (k = []), (0, g.default)(D) || (k = {}), D) Object.prototype.hasOwnProperty.call(D, L) && (k[L] = S(D[L]));
            return k;
          }, d.toArray = function(S) {
            return (0, b.default)(Array.prototype).call(S);
          }, d.getRandomCode = function() {
            var S;
            return (0, b.default)(S = Math.random().toString(36)).call(S, -5);
          }, d.hexToRgb = function(S) {
            var D = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(S);
            if (D == null) return null;
            var k = (0, _.default)(D).call(D, function(L) {
              return (0, p.default)(L, 16);
            });
            return "rgb(" + k[1] + ", " + k[2] + ", " + k[3] + ")";
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 }), d.EMPTY_P_REGEX = d.EMPTY_P_LAST_REGEX = d.EMPTY_P = d.urlRegex = d.EMPTY_FN = void 0, d.EMPTY_FN = function() {
          }, d.urlRegex = /^(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&amp;:/~+#]*[\w\-@?^=%&amp;/~+#])?/, d.EMPTY_P = '<p data-we-empty-p=""><br></p>', d.EMPTY_P_LAST_REGEX = /<p data-we-empty-p=""><br\/?><\/p>$/gim, d.EMPTY_P_REGEX = /<p data-we-empty-p="">/gim;
        }, function(m, d, r) {
          (function(u) {
            var v = function(C) {
              return C && C.Math == Math && C;
            };
            m.exports = v(typeof globalThis == "object" && globalThis) || v(typeof window == "object" && window) || v(typeof self == "object" && self) || v(typeof u == "object" && u) || /* @__PURE__ */ function() {
              return this;
            }() || Function("return this")();
          }).call(this, r(139));
        }, function(m, d, r) {
          var u = r(8), v = r(78), C = r(16), p = r(59), b = r(83), x = r(105), g = v("wks"), _ = u.Symbol, A = x ? _ : _ && _.withoutSetter || p;
          m.exports = function(f) {
            return C(g, f) && (b || typeof g[f] == "string") || (b && C(_, f) ? g[f] = _[f] : g[f] = A("Symbol." + f)), g[f];
          };
        }, function(m, d, r) {
          var u = r(12), v = r(16), C = r(95), p = r(18).f;
          m.exports = function(b) {
            var x = u.Symbol || (u.Symbol = {});
            v(x, b) || p(x, b, { value: C.f(b) });
          };
        }, function(m, d) {
          m.exports = function(r) {
            try {
              return !!r();
            } catch (u) {
              return !0;
            }
          };
        }, function(m, d) {
          m.exports = {};
        }, function(m, d) {
          m.exports = function(r) {
            return typeof r == "object" ? r !== null : typeof r == "function";
          };
        }, function(m, d, r) {
          var u = r(12);
          m.exports = function(v) {
            return u[v + "Prototype"];
          };
        }, function(m, d, r) {
          var u = r(11);
          m.exports = !u(function() {
            return Object.defineProperty({}, 1, { get: function() {
              return 7;
            } })[1] != 7;
          });
        }, function(m, d) {
          var r = {}.hasOwnProperty;
          m.exports = function(u, v) {
            return r.call(u, v);
          };
        }, function(m, d, r) {
          var u = r(15), v = r(18), C = r(35);
          m.exports = u ? function(p, b, x) {
            return v.f(p, b, C(1, x));
          } : function(p, b, x) {
            return p[b] = x, p;
          };
        }, function(m, d, r) {
          var u = r(15), v = r(100), C = r(24), p = r(57), b = Object.defineProperty;
          d.f = u ? b : function(x, g, _) {
            if (C(x), g = p(g, !0), C(_), v) try {
              return b(x, g, _);
            } catch (A) {
            }
            if ("get" in _ || "set" in _) throw TypeError("Accessors not supported");
            return "value" in _ && (x[g] = _.value), x;
          };
        }, function(m, d, r) {
          m.exports = r(192);
        }, function(m, d, r) {
          var u, v = function() {
            return u === void 0 && (u = !!(window && document && document.all && !window.atob)), u;
          }, C = /* @__PURE__ */ function() {
            var L = {};
            return function(h) {
              if (L[h] === void 0) {
                var E = document.querySelector(h);
                if (window.HTMLIFrameElement && E instanceof window.HTMLIFrameElement) try {
                  E = E.contentDocument.head;
                } catch (w) {
                  E = null;
                }
                L[h] = E;
              }
              return L[h];
            };
          }(), p = [];
          function b(L) {
            for (var h = -1, E = 0; E < p.length; E++) if (p[E].identifier === L) {
              h = E;
              break;
            }
            return h;
          }
          function x(L, h) {
            for (var E = {}, w = [], O = 0; O < L.length; O++) {
              var R = L[O], I = h.base ? R[0] + h.base : R[0], H = E[I] || 0, $ = "".concat(I, " ").concat(H);
              E[I] = H + 1;
              var Q = b($), U = { css: R[1], media: R[2], sourceMap: R[3] };
              Q !== -1 ? (p[Q].references++, p[Q].updater(U)) : p.push({ identifier: $, updater: k(U, h), references: 1 }), w.push($);
            }
            return w;
          }
          function g(L) {
            var h = document.createElement("style"), E = L.attributes || {};
            if (E.nonce === void 0) {
              var w = r.nc;
              w && (E.nonce = w);
            }
            if (Object.keys(E).forEach(function(R) {
              h.setAttribute(R, E[R]);
            }), typeof L.insert == "function") L.insert(h);
            else {
              var O = C(L.insert || "head");
              if (!O) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
              O.appendChild(h);
            }
            return h;
          }
          var _, A = (_ = [], function(L, h) {
            return _[L] = h, _.filter(Boolean).join(`
`);
          });
          function f(L, h, E, w) {
            var O = E ? "" : w.media ? "@media ".concat(w.media, " {").concat(w.css, "}") : w.css;
            if (L.styleSheet) L.styleSheet.cssText = A(h, O);
            else {
              var R = document.createTextNode(O), I = L.childNodes;
              I[h] && L.removeChild(I[h]), I.length ? L.insertBefore(R, I[h]) : L.appendChild(R);
            }
          }
          var S = null, D = 0;
          function k(L, h) {
            var E, w, O;
            if (h.singleton) {
              var R = D++;
              E = S || (S = g(h)), w = f.bind(null, E, R, !1), O = f.bind(null, E, R, !0);
            } else E = g(h), w = function(I, H, $) {
              var Q = $.css, U = $.media, Y = $.sourceMap;
              if (U ? I.setAttribute("media", U) : I.removeAttribute("media"), Y && typeof btoa != "undefined" && (Q += `
/*# sourceMappingURL=data:application/json;base64,`.concat(btoa(unescape(encodeURIComponent(JSON.stringify(Y)))), " */")), I.styleSheet) I.styleSheet.cssText = Q;
              else {
                for (; I.firstChild; ) I.removeChild(I.firstChild);
                I.appendChild(document.createTextNode(Q));
              }
            }.bind(null, E, h), O = function() {
              (function(I) {
                if (I.parentNode === null) return !1;
                I.parentNode.removeChild(I);
              })(E);
            };
            return w(L), function(I) {
              if (I) {
                if (I.css === L.css && I.media === L.media && I.sourceMap === L.sourceMap) return;
                w(L = I);
              } else O();
            };
          }
          m.exports = function(L, h) {
            (h = h || {}).singleton || typeof h.singleton == "boolean" || (h.singleton = v());
            var E = x(L = L || [], h);
            return function(w) {
              if (w = w || [], Object.prototype.toString.call(w) === "[object Array]") {
                for (var O = 0; O < E.length; O++) {
                  var R = b(E[O]);
                  p[R].references--;
                }
                for (var I = x(w, h), H = 0; H < E.length; H++) {
                  var $ = b(E[H]);
                  p[$].references === 0 && (p[$].updater(), p.splice($, 1));
                }
                E = I;
              }
            };
          };
        }, function(m, d, r) {
          m.exports = function(u) {
            var v = [];
            return v.toString = function() {
              return this.map(function(C) {
                var p = function(b, x) {
                  var g = b[1] || "", _ = b[3];
                  if (!_) return g;
                  if (x && typeof btoa == "function") {
                    var A = (S = _, D = btoa(unescape(encodeURIComponent(JSON.stringify(S)))), k = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(D), "/*# ".concat(k, " */")), f = _.sources.map(function(L) {
                      return "/*# sourceURL=".concat(_.sourceRoot || "").concat(L, " */");
                    });
                    return [g].concat(f).concat([A]).join(`
`);
                  }
                  var S, D, k;
                  return [g].join(`
`);
                }(C, u);
                return C[2] ? "@media ".concat(C[2], " {").concat(p, "}") : p;
              }).join("");
            }, v.i = function(C, p, b) {
              typeof C == "string" && (C = [[null, C, ""]]);
              var x = {};
              if (b) for (var g = 0; g < this.length; g++) {
                var _ = this[g][0];
                _ != null && (x[_] = !0);
              }
              for (var A = 0; A < C.length; A++) {
                var f = [].concat(C[A]);
                b && x[f[0]] || (p && (f[2] ? f[2] = "".concat(p, " and ").concat(f[2]) : f[2] = p), v.push(f));
              }
            }, v;
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = function(C) {
            function p(b, x) {
              return C.call(this, b, x) || this;
            }
            return u.__extends(p, C), p;
          }(u.__importDefault(r(96)).default);
          d.default = v;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4)), p = u(r(54));
          (0, v.default)(d, "__esModule", { value: !0 });
          var b = r(2), x = b.__importDefault(r(3)), g = b.__importDefault(r(96)), _ = b.__importDefault(r(128)), A = function(f) {
            function S(D, k, L) {
              var h = f.call(this, D, k) || this;
              L.title = k.i18next.t("menus.dropListMenu." + L.title);
              var E, w = k.config.lang === "zh-CN" ? "" : "w-e-drop-list-tl";
              w !== "" && L.type === "list" && (0, C.default)(E = L.list).call(E, function(R) {
                var I = R.$elem, H = x.default(I.children());
                if (H.length > 0) {
                  var $ = H == null ? void 0 : H.getNodeName();
                  $ && $ === "I" && I.addClass(w);
                }
              });
              var O = new _.default(h, L);
              return h.dropList = O, D.on("click", function() {
                var R;
                k.selection.getRange() != null && (D.css("z-index", k.zIndex.get("menu")), (0, C.default)(R = k.txt.eventHooks.dropListMenuHoverEvents).call(R, function(I) {
                  return I();
                }), O.show());
              }).on("mouseleave", function() {
                D.css("z-index", "auto"), O.hideTimeoutId = (0, p.default)(function() {
                  O.hide();
                });
              }), h;
            }
            return b.__extends(S, f), S;
          }(g.default);
          d.default = A;
        }, function(m, d, r) {
          var u = r(13);
          m.exports = function(v) {
            if (!u(v)) throw TypeError(String(v) + " is not an object");
            return v;
          };
        }, function(m, d, r) {
          m.exports = r(188);
        }, function(m, d, r) {
          m.exports = r(201);
        }, function(m, d, r) {
          var u = r(75), v = r(46);
          m.exports = function(C) {
            return u(v(C));
          };
        }, function(m, d, r) {
          var u = r(12), v = r(8), C = function(p) {
            return typeof p == "function" ? p : void 0;
          };
          m.exports = function(p, b) {
            return arguments.length < 2 ? C(u[p]) || C(v[p]) : u[p] && u[p][b] || v[p] && v[p][b];
          };
        }, function(m, d, r) {
          var u = r(47), v = r(75), C = r(36), p = r(38), b = r(89), x = [].push, g = function(_) {
            var A = _ == 1, f = _ == 2, S = _ == 3, D = _ == 4, k = _ == 6, L = _ == 7, h = _ == 5 || k;
            return function(E, w, O, R) {
              for (var I, H, $ = C(E), Q = v($), U = u(w, O, 3), Y = p(Q.length), X = 0, G = R || b, J = A ? G(E, Y) : f || L ? G(E, 0) : void 0; Y > X; X++) if ((h || X in Q) && (H = U(I = Q[X], X, $), _)) if (A) J[X] = H;
              else if (H) switch (_) {
                case 3:
                  return !0;
                case 5:
                  return I;
                case 6:
                  return X;
                case 2:
                  x.call(J, I);
              }
              else switch (_) {
                case 4:
                  return !1;
                case 7:
                  x.call(J, I);
              }
              return k ? -1 : S || D ? D : J;
            };
          };
          m.exports = { forEach: g(0), map: g(1), filter: g(2), some: g(3), every: g(4), find: g(5), findIndex: g(6), filterOut: g(7) };
        }, function(m, d, r) {
          m.exports = r(286);
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4)), p = u(r(30)), b = u(r(125));
          (0, v.default)(d, "__esModule", { value: !0 });
          var x = r(2), g = x.__importDefault(r(3)), _ = r(7), A = function() {
            function f(S, D) {
              this.menu = S, this.conf = D, this.$container = g.default('<div class="w-e-panel-container"></div>');
              var k = S.editor;
              k.txt.eventHooks.clickEvents.push(f.hideCurAllPanels), k.txt.eventHooks.toolbarClickEvents.push(f.hideCurAllPanels), k.txt.eventHooks.dropListMenuHoverEvents.push(f.hideCurAllPanels);
            }
            return f.prototype.create = function() {
              var S = this, D = this.menu;
              if (!f.createdMenus.has(D)) {
                var k = this.conf, L = this.$container, h = k.width || 300, E = D.editor.$toolbarElem.getBoundingClientRect(), w = D.$elem.getBoundingClientRect(), O = E.height + E.top - w.top, R = (E.width - h) / 2 + E.left - w.left;
                L.css("width", h + "px").css("margin-top", O + "px").css("margin-left", R + "px").css("z-index", D.editor.zIndex.get("panel"));
                var I = g.default('<i class="w-e-icon-close w-e-panel-close"></i>');
                L.append(I), I.on("click", function() {
                  S.remove();
                });
                var H = g.default('<ul class="w-e-panel-tab-title"></ul>'), $ = g.default('<div class="w-e-panel-tab-content"></div>');
                L.append(H).append($);
                var Q = k.height;
                Q && $.css("height", Q + "px").css("overflow-y", "auto");
                var U = k.tabs || [], Y = [], X = [];
                (0, C.default)(U).call(U, function(J, ee) {
                  if (J) {
                    var re = J.title || "", oe = J.tpl || "", ae = g.default('<li class="w-e-item">' + re + "</li>");
                    H.append(ae);
                    var se = g.default(oe);
                    $.append(se), Y.push(ae), X.push(se), ee === 0 ? (ae.data("active", !0), ae.addClass("w-e-active")) : se.hide(), ae.on("click", function() {
                      ae.data("active") || ((0, C.default)(Y).call(Y, function(ve) {
                        ve.data("active", !1), ve.removeClass("w-e-active");
                      }), (0, C.default)(X).call(X, function(ve) {
                        ve.hide();
                      }), ae.data("active", !0), ae.addClass("w-e-active"), se.show());
                    });
                  }
                }), L.on("click", function(J) {
                  J.stopPropagation();
                }), D.$elem.append(L), (0, C.default)(U).call(U, function(J, ee) {
                  if (J) {
                    var re = J.events || [];
                    (0, C.default)(re).call(re, function(oe) {
                      var ae = oe.selector, se = oe.type, ve = oe.fn || _.EMPTY_FN, Ae = X[ee];
                      (0, p.default)(Ae).call(Ae, ae).on(se, function(ye) {
                        return x.__awaiter(S, void 0, void 0, function() {
                          return x.__generator(this, function(ce) {
                            switch (ce.label) {
                              case 0:
                                return ye.stopPropagation(), [4, ve(ye)];
                              case 1:
                                return ce.sent() && this.remove(), [2];
                            }
                          });
                        });
                      });
                    });
                  }
                });
                var G = (0, p.default)(L).call(L, "input[type=text],textarea");
                G.length && G.get(0).focus(), f.hideCurAllPanels(), D.setPanel(this), f.createdMenus.add(D);
              }
            }, f.prototype.remove = function() {
              var S = this.menu, D = this.$container;
              D && D.remove(), f.createdMenus.delete(S);
            }, f.hideCurAllPanels = function() {
              var S;
              f.createdMenus.size !== 0 && (0, C.default)(S = f.createdMenus).call(S, function(D) {
                var k = D.panel;
                k && k.remove();
              });
            }, f.createdMenus = new b.default(), f;
          }();
          d.default = A;
        }, function(m, d) {
          m.exports = function(r) {
            if (typeof r != "function") throw TypeError(String(r) + " is not a function");
            return r;
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = function(C) {
            function p(b, x) {
              return C.call(this, b, x) || this;
            }
            return u.__extends(p, C), p.prototype.setPanel = function(b) {
              this.panel = b;
            }, p;
          }(u.__importDefault(r(96)).default);
          d.default = v;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4)), p = u(r(53));
          (0, v.default)(d, "__esModule", { value: !0 });
          var b = r(2).__importDefault(r(3)), x = function() {
            function g(_, A, f) {
              this.editor = _, this.$targetElem = A, this.conf = f, this._show = !1, this._isInsertTextContainer = !1;
              var S = b.default("<div></div>");
              S.addClass("w-e-tooltip"), this.$container = S;
            }
            return g.prototype.getPositionData = function() {
              var _ = this.$container, A = 0, f = 0, S = document.documentElement.scrollTop, D = this.$targetElem.getBoundingClientRect(), k = this.editor.$textElem.getBoundingClientRect(), L = this.$targetElem.getOffsetData(), h = b.default(L.parent), E = this.editor.$textElem.elems[0].scrollTop;
              if (this._isInsertTextContainer = h.equal(this.editor.$textContainerElem), this._isInsertTextContainer) {
                var w = h.getBoundingClientRect().height, O = L.top, R = L.left, I = L.height, H = O - E;
                H > 25 ? (A = H - 20 - 15, _.addClass("w-e-tooltip-up")) : H + I + 20 < w ? (A = H + I + 10, _.addClass("w-e-tooltip-down")) : (A = (H > 0 ? H : 0) + 20 + 10, _.addClass("w-e-tooltip-down")), f = R < 0 ? 0 : R;
              } else D.top < 20 || D.top - k.top < 20 ? (A = D.bottom + S + 5, _.addClass("w-e-tooltip-down")) : (A = D.top + S - 20 - 15, _.addClass("w-e-tooltip-up")), f = D.left < 0 ? 0 : D.left;
              return { top: A, left: f };
            }, g.prototype.appendMenus = function() {
              var _ = this, A = this.conf, f = this.editor, S = this.$targetElem, D = this.$container;
              (0, C.default)(A).call(A, function(k, L) {
                var h = k.$elem, E = b.default("<div></div>");
                E.addClass("w-e-tooltip-item-wrapper "), E.append(h), D.append(E), h.on("click", function(w) {
                  w.preventDefault(), k.onClick(f, S) && _.remove();
                });
              });
            }, g.prototype.create = function() {
              var _, A, f = this.editor, S = this.$container;
              this.appendMenus();
              var D = this.getPositionData(), k = D.top, L = D.left;
              S.css("top", k + "px"), S.css("left", L + "px"), S.css("z-index", f.zIndex.get("tooltip")), this._isInsertTextContainer ? this.editor.$textContainerElem.append(S) : b.default("body").append(S), this._show = !0, f.beforeDestroy((0, p.default)(_ = this.remove).call(_, this)), f.txt.eventHooks.onBlurEvents.push((0, p.default)(A = this.remove).call(A, this));
            }, g.prototype.remove = function() {
              this.$container.remove(), this._show = !1;
            }, (0, v.default)(g.prototype, "isShow", { get: function() {
              return this._show;
            }, enumerable: !1, configurable: !0 }), g;
          }();
          d.default = x;
        }, function(m, d) {
          m.exports = function(r, u) {
            return { enumerable: !(1 & r), configurable: !(2 & r), writable: !(4 & r), value: u };
          };
        }, function(m, d, r) {
          var u = r(46);
          m.exports = function(v) {
            return Object(u(v));
          };
        }, function(m, d) {
          m.exports = !0;
        }, function(m, d, r) {
          var u = r(62), v = Math.min;
          m.exports = function(C) {
            return C > 0 ? v(u(C), 9007199254740991) : 0;
          };
        }, function(m, d, r) {
          var u = r(24), v = r(163), C = r(38), p = r(47), b = r(164), x = r(165), g = function(_, A) {
            this.stopped = _, this.result = A;
          };
          m.exports = function(_, A, f) {
            var S, D, k, L, h, E, w, O = f && f.that, R = !(!f || !f.AS_ENTRIES), I = !(!f || !f.IS_ITERATOR), H = !(!f || !f.INTERRUPTED), $ = p(A, O, 1 + R + H), Q = function(Y) {
              return S && x(S), new g(!0, Y);
            }, U = function(Y) {
              return R ? (u(Y), H ? $(Y[0], Y[1], Q) : $(Y[0], Y[1])) : H ? $(Y, Q) : $(Y);
            };
            if (I) S = _;
            else {
              if (typeof (D = b(_)) != "function") throw TypeError("Target is not iterable");
              if (v(D)) {
                for (k = 0, L = C(_.length); L > k; k++) if ((h = U(_[k])) && h instanceof g) return h;
                return new g(!1);
              }
              S = D.call(_);
            }
            for (E = S.next; !(w = E.call(S)).done; ) {
              try {
                h = U(w.value);
              } catch (Y) {
                throw x(S), Y;
              }
              if (typeof h == "object" && h && h instanceof g) return h;
            }
            return new g(!1);
          };
        }, function(m, d) {
          m.exports = {};
        }, function(m, d, r) {
          var u = r(84), v = r(18).f, C = r(17), p = r(16), b = r(167), x = r(9)("toStringTag");
          m.exports = function(g, _, A, f) {
            if (g) {
              var S = A ? g : g.prototype;
              p(S, x) || v(S, x, { configurable: !0, value: _ }), f && !u && C(S, "toString", b);
            }
          };
        }, function(m, d, r) {
          var u, v, C, p = r(172), b = r(8), x = r(13), g = r(17), _ = r(16), A = r(79), f = r(58), S = r(48), D = b.WeakMap;
          if (p) {
            var k = A.state || (A.state = new D()), L = k.get, h = k.has, E = k.set;
            u = function(O, R) {
              return R.facade = O, E.call(k, O, R), R;
            }, v = function(O) {
              return L.call(k, O) || {};
            }, C = function(O) {
              return h.call(k, O);
            };
          } else {
            var w = f("state");
            S[w] = !0, u = function(O, R) {
              return R.facade = O, g(O, w, R), R;
            }, v = function(O) {
              return _(O, w) ? O[w] : {};
            }, C = function(O) {
              return _(O, w);
            };
          }
          m.exports = { set: u, get: v, has: C, enforce: function(O) {
            return C(O) ? v(O) : u(O, {});
          }, getterFor: function(O) {
            return function(R) {
              var I;
              if (!x(R) || (I = v(R)).type !== O) throw TypeError("Incompatible receiver, " + O + " required");
              return I;
            };
          } };
        }, function(m, d, r) {
          m.exports = r(262);
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4));
          (0, v.default)(d, "__esModule", { value: !0 }), d.createElementFragment = d.createDocumentFragment = d.createElement = d.insertBefore = d.getEndPoint = d.getStartPoint = d.updateRange = d.filterSelectionNodes = void 0;
          var p = r(2), b = r(132), x = p.__importDefault(r(3));
          function g(_) {
            return document.createElement(_);
          }
          d.filterSelectionNodes = function(_) {
            var A = [];
            return (0, C.default)(_).call(_, function(f) {
              var S = f.getNodeName();
              if (S !== b.ListType.OrderedList && S !== b.ListType.UnorderedList) A.push(f);
              else if (f.prior) A.push(f.prior);
              else {
                var D = f.children();
                D == null || (0, C.default)(D).call(D, function(k) {
                  A.push(x.default(k));
                });
              }
            }), A;
          }, d.updateRange = function(_, A, f) {
            var S = _.selection, D = document.createRange();
            A.length > 1 ? (D.setStart(A.elems[0], 0), D.setEnd(A.elems[A.length - 1], A.elems[A.length - 1].childNodes.length)) : D.selectNodeContents(A.elems[0]), f && D.collapse(!1), S.saveRange(D), S.restoreSelection();
          }, d.getStartPoint = function(_) {
            var A;
            return _.prior ? _.prior : x.default((A = _.children()) === null || A === void 0 ? void 0 : A.elems[0]);
          }, d.getEndPoint = function(_) {
            var A;
            return _.prior ? _.prior : x.default((A = _.children()) === null || A === void 0 ? void 0 : A.last().elems[0]);
          }, d.insertBefore = function(_, A, f) {
            f === void 0 && (f = null), _.parent().elems[0].insertBefore(A, f);
          }, d.createElement = g, d.createDocumentFragment = function() {
            return document.createDocumentFragment();
          }, d.createElementFragment = function(_, A, f) {
            return f === void 0 && (f = "li"), (0, C.default)(_).call(_, function(S) {
              var D = g(f);
              D.innerHTML = S.html(), A.append(D), S.remove();
            }), A;
          };
        }, function(m, d) {
          var r = {}.toString;
          m.exports = function(u) {
            return r.call(u).slice(8, -1);
          };
        }, function(m, d) {
          m.exports = function(r) {
            if (r == null) throw TypeError("Can't call method on " + r);
            return r;
          };
        }, function(m, d, r) {
          var u = r(32);
          m.exports = function(v, C, p) {
            if (u(v), C === void 0) return v;
            switch (p) {
              case 0:
                return function() {
                  return v.call(C);
                };
              case 1:
                return function(b) {
                  return v.call(C, b);
                };
              case 2:
                return function(b, x) {
                  return v.call(C, b, x);
                };
              case 3:
                return function(b, x, g) {
                  return v.call(C, b, x, g);
                };
            }
            return function() {
              return v.apply(C, arguments);
            };
          };
        }, function(m, d) {
          m.exports = {};
        }, function(m, d, r) {
          var u = r(17);
          m.exports = function(v, C, p, b) {
            b && b.enumerable ? v[C] = p : u(v, C, p);
          };
        }, function(m, d, r) {
          r(178);
          var u = r(179), v = r(8), C = r(66), p = r(17), b = r(40), x = r(9)("toStringTag");
          for (var g in u) {
            var _ = v[g], A = _ && _.prototype;
            A && C(A) !== x && p(A, x, g), b[g] = b.Array;
          }
        }, function(m, d, r) {
          var u = r(45);
          m.exports = Array.isArray || function(v) {
            return u(v) == "Array";
          };
        }, function(m, d, r) {
          var u = r(11), v = r(9), C = r(64), p = v("species");
          m.exports = function(b) {
            return C >= 51 || !u(function() {
              var x = [];
              return (x.constructor = {})[p] = function() {
                return { foo: 1 };
              }, x[b](Boolean).foo !== 1;
            });
          };
        }, function(m, d, r) {
          m.exports = r(222);
        }, function(m, d, r) {
          m.exports = r(266);
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 }), d.ListHandle = void 0;
          var u = r(2).__importDefault(r(370)), v = /* @__PURE__ */ function() {
            return function(C) {
              this.options = C, this.selectionRangeElem = new u.default();
            };
          }();
          d.ListHandle = v;
        }, function(m, d, r) {
          var u = {}.propertyIsEnumerable, v = Object.getOwnPropertyDescriptor, C = v && !u.call({ 1: 2 }, 1);
          d.f = C ? function(p) {
            var b = v(this, p);
            return !!b && b.enumerable;
          } : u;
        }, function(m, d, r) {
          var u = r(13);
          m.exports = function(v, C) {
            if (!u(v)) return v;
            var p, b;
            if (C && typeof (p = v.toString) == "function" && !u(b = p.call(v)) || typeof (p = v.valueOf) == "function" && !u(b = p.call(v)) || !C && typeof (p = v.toString) == "function" && !u(b = p.call(v))) return b;
            throw TypeError("Can't convert object to primitive value");
          };
        }, function(m, d, r) {
          var u = r(78), v = r(59), C = u("keys");
          m.exports = function(p) {
            return C[p] || (C[p] = v(p));
          };
        }, function(m, d) {
          var r = 0, u = Math.random();
          m.exports = function(v) {
            return "Symbol(" + String(v === void 0 ? "" : v) + ")_" + (++r + u).toString(36);
          };
        }, function(m, d, r) {
          var u, v = r(24), C = r(162), p = r(82), b = r(48), x = r(104), g = r(76), _ = r(58), A = _("IE_PROTO"), f = function() {
          }, S = function(k) {
            return "<script>" + k + "<\/script>";
          }, D = function() {
            try {
              u = document.domain && new ActiveXObject("htmlfile");
            } catch (E) {
            }
            var k, L;
            D = u ? function(E) {
              E.write(S("")), E.close();
              var w = E.parentWindow.Object;
              return E = null, w;
            }(u) : ((L = g("iframe")).style.display = "none", x.appendChild(L), L.src = "javascript:", (k = L.contentWindow.document).open(), k.write(S("document.F=Object")), k.close(), k.F);
            for (var h = p.length; h--; ) delete D.prototype[p[h]];
            return D();
          };
          b[A] = !0, m.exports = Object.create || function(k, L) {
            var h;
            return k !== null ? (f.prototype = v(k), h = new f(), f.prototype = null, h[A] = k) : h = D(), L === void 0 ? h : C(h, L);
          };
        }, function(m, d, r) {
          var u = r(103), v = r(82);
          m.exports = Object.keys || function(C) {
            return u(C, v);
          };
        }, function(m, d) {
          var r = Math.ceil, u = Math.floor;
          m.exports = function(v) {
            return isNaN(v = +v) ? 0 : (v > 0 ? u : r)(v);
          };
        }, function(m, d, r) {
          var u = r(45), v = r(8);
          m.exports = u(v.process) == "process";
        }, function(m, d, r) {
          var u, v, C = r(8), p = r(65), b = C.process, x = b && b.versions, g = x && x.v8;
          g ? v = (u = g.split("."))[0] + u[1] : p && (!(u = p.match(/Edge\/(\d+)/)) || u[1] >= 74) && (u = p.match(/Chrome\/(\d+)/)) && (v = u[1]), m.exports = v && +v;
        }, function(m, d, r) {
          var u = r(28);
          m.exports = u("navigator", "userAgent") || "";
        }, function(m, d, r) {
          var u = r(84), v = r(45), C = r(9)("toStringTag"), p = v(/* @__PURE__ */ function() {
            return arguments;
          }()) == "Arguments";
          m.exports = u ? v : function(b) {
            var x, g, _;
            return b === void 0 ? "Undefined" : b === null ? "Null" : typeof (g = function(A, f) {
              try {
                return A[f];
              } catch (S) {
              }
            }(x = Object(b), C)) == "string" ? g : p ? v(x) : (_ = v(x)) == "Object" && typeof x.callee == "function" ? "Arguments" : _;
          };
        }, function(m, d) {
        }, function(m, d, r) {
          var u = r(32), v = function(C) {
            var p, b;
            this.promise = new C(function(x, g) {
              if (p !== void 0 || b !== void 0) throw TypeError("Bad Promise constructor");
              p = x, b = g;
            }), this.resolve = u(p), this.reject = u(b);
          };
          m.exports.f = function(C) {
            return new v(C);
          };
        }, function(m, d, r) {
          var u = r(176).charAt, v = r(42), C = r(87), p = v.set, b = v.getterFor("String Iterator");
          C(String, "String", function(x) {
            p(this, { type: "String Iterator", string: String(x), index: 0 });
          }, function() {
            var x, g = b(this), _ = g.string, A = g.index;
            return A >= _.length ? { value: void 0, done: !0 } : (x = u(_, A), g.index += x.length, { value: x, done: !1 });
          });
        }, function(m, d, r) {
          var u = r(11);
          m.exports = function(v, C) {
            var p = [][v];
            return !!p && u(function() {
              p.call(null, C || function() {
                throw 1;
              }, 1);
            });
          };
        }, function(m, d) {
          m.exports = `	
\v\f\r                　\u2028\u2029\uFEFF`;
        }, function(m, d, r) {
          m.exports = r(209);
        }, function(m, d, r) {
          m.exports = r(213);
        }, function(m, d, r) {
          var u = r(15), v = r(56), C = r(35), p = r(27), b = r(57), x = r(16), g = r(100), _ = Object.getOwnPropertyDescriptor;
          d.f = u ? _ : function(A, f) {
            if (A = p(A), f = b(f, !0), g) try {
              return _(A, f);
            } catch (S) {
            }
            if (x(A, f)) return C(!v.f.call(A, f), A[f]);
          };
        }, function(m, d, r) {
          var u = r(11), v = r(45), C = "".split;
          m.exports = u(function() {
            return !Object("z").propertyIsEnumerable(0);
          }) ? function(p) {
            return v(p) == "String" ? C.call(p, "") : Object(p);
          } : Object;
        }, function(m, d, r) {
          var u = r(8), v = r(13), C = u.document, p = v(C) && v(C.createElement);
          m.exports = function(b) {
            return p ? C.createElement(b) : {};
          };
        }, function(m, d, r) {
          var u = r(16), v = r(36), C = r(58), p = r(160), b = C("IE_PROTO"), x = Object.prototype;
          m.exports = p ? Object.getPrototypeOf : function(g) {
            return g = v(g), u(g, b) ? g[b] : typeof g.constructor == "function" && g instanceof g.constructor ? g.constructor.prototype : g instanceof Object ? x : null;
          };
        }, function(m, d, r) {
          var u = r(37), v = r(79);
          (m.exports = function(C, p) {
            return v[C] || (v[C] = p !== void 0 ? p : {});
          })("versions", []).push({ version: "3.9.1", mode: u ? "pure" : "global", copyright: "© 2021 Denis Pushkarev (zloirock.ru)" });
        }, function(m, d, r) {
          var u = r(8), v = r(159), C = u["__core-js_shared__"] || v("__core-js_shared__", {});
          m.exports = C;
        }, function(m, d, r) {
          var u = r(27), v = r(38), C = r(81), p = function(b) {
            return function(x, g, _) {
              var A, f = u(x), S = v(f.length), D = C(_, S);
              if (b && g != g) {
                for (; S > D; ) if ((A = f[D++]) != A) return !0;
              } else for (; S > D; D++) if ((b || D in f) && f[D] === g) return b || D || 0;
              return !b && -1;
            };
          };
          m.exports = { includes: p(!0), indexOf: p(!1) };
        }, function(m, d, r) {
          var u = r(62), v = Math.max, C = Math.min;
          m.exports = function(p, b) {
            var x = u(p);
            return x < 0 ? v(x + b, 0) : C(x, b);
          };
        }, function(m, d) {
          m.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
        }, function(m, d, r) {
          var u = r(63), v = r(64), C = r(11);
          m.exports = !!Object.getOwnPropertySymbols && !C(function() {
            return !Symbol.sham && (u ? v === 38 : v > 37 && v < 41);
          });
        }, function(m, d, r) {
          var u = {};
          u[r(9)("toStringTag")] = "z", m.exports = String(u) === "[object z]";
        }, function(m, d) {
          m.exports = function(r, u, v) {
            if (!(r instanceof u)) throw TypeError("Incorrect " + (v ? v + " " : "") + "invocation");
            return r;
          };
        }, function(m, d) {
          m.exports = function(r) {
            try {
              return { error: !1, value: r() };
            } catch (u) {
              return { error: !0, value: u };
            }
          };
        }, function(m, d, r) {
          var u = r(5), v = r(177), C = r(77), p = r(102), b = r(41), x = r(17), g = r(49), _ = r(9), A = r(37), f = r(40), S = r(114), D = S.IteratorPrototype, k = S.BUGGY_SAFARI_ITERATORS, L = _("iterator"), h = function() {
            return this;
          };
          m.exports = function(E, w, O, R, I, H, $) {
            v(O, w, R);
            var Q, U, Y, X = function(se) {
              if (se === I && oe) return oe;
              if (!k && se in ee) return ee[se];
              switch (se) {
                case "keys":
                case "values":
                case "entries":
                  return function() {
                    return new O(this, se);
                  };
              }
              return function() {
                return new O(this);
              };
            }, G = w + " Iterator", J = !1, ee = E.prototype, re = ee[L] || ee["@@iterator"] || I && ee[I], oe = !k && re || X(I), ae = w == "Array" && ee.entries || re;
            if (ae && (Q = C(ae.call(new E())), D !== Object.prototype && Q.next && (A || C(Q) === D || (p ? p(Q, D) : typeof Q[L] != "function" && x(Q, L, h)), b(Q, G, !0, !0), A && (f[G] = h))), I == "values" && re && re.name !== "values" && (J = !0, oe = function() {
              return re.call(this);
            }), A && !$ || ee[L] === oe || x(ee, L, oe), f[w] = oe, I) if (U = { values: X("values"), keys: H ? oe : X("keys"), entries: X("entries") }, $) for (Y in U) !k && !J && Y in ee || g(ee, Y, U[Y]);
            else u({ target: w, proto: !0, forced: k || J }, U);
            return U;
          };
        }, function(m, d) {
          m.exports = function() {
          };
        }, function(m, d, r) {
          var u = r(13), v = r(51), C = r(9)("species");
          m.exports = function(p, b) {
            var x;
            return v(p) && (typeof (x = p.constructor) != "function" || x !== Array && !v(x.prototype) ? u(x) && (x = x[C]) === null && (x = void 0) : x = void 0), new (x === void 0 ? Array : x)(b === 0 ? 0 : b);
          };
        }, function(m, d, r) {
          m.exports = r(185);
        }, function(m, d, r) {
          var u = r(46), v = "[" + r(71) + "]", C = RegExp("^" + v + v + "*"), p = RegExp(v + v + "*$"), b = function(x) {
            return function(g) {
              var _ = String(u(g));
              return 1 & x && (_ = _.replace(C, "")), 2 & x && (_ = _.replace(p, "")), _;
            };
          };
          m.exports = { start: b(1), end: b(2), trim: b(3) };
        }, function(m, d, r) {
          m.exports = r(205);
        }, function(m, d, r) {
          var u = r(57), v = r(18), C = r(35);
          m.exports = function(p, b, x) {
            var g = u(b);
            g in p ? v.f(p, g, C(0, x)) : p[g] = x;
          };
        }, function(m, d, r) {
          var u = r(227), v = r(254);
          function C(p) {
            return typeof u == "function" && typeof v == "symbol" ? (m.exports = C = function(b) {
              return typeof b;
            }, m.exports.default = m.exports, m.exports.__esModule = !0) : (m.exports = C = function(b) {
              return b && typeof u == "function" && b.constructor === u && b !== u.prototype ? "symbol" : typeof b;
            }, m.exports.default = m.exports, m.exports.__esModule = !0), C(p);
          }
          m.exports = C, m.exports.default = m.exports, m.exports.__esModule = !0;
        }, function(m, d, r) {
          var u = r(9);
          d.f = u;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2).__importDefault(r(31)), b = function() {
            function x(g, _) {
              var A = this;
              this.$elem = g, this.editor = _, this._active = !1, g.on("click", function(f) {
                var S;
                p.default.hideCurAllPanels(), (0, C.default)(S = _.txt.eventHooks.menuClickEvents).call(S, function(D) {
                  return D();
                }), f.stopPropagation(), _.selection.getRange() != null && A.clickHandler(f);
              });
            }
            return x.prototype.clickHandler = function(g) {
            }, x.prototype.active = function() {
              this._active = !0, this.$elem.addClass("w-e-active");
            }, x.prototype.unActive = function() {
              this._active = !1, this.$elem.removeClass("w-e-active");
            }, (0, v.default)(x.prototype, "isActive", { get: function() {
              return this._active;
            }, enumerable: !1, configurable: !0 }), x;
          }();
          d.default = b;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(53)), p = u(r(4)), b = u(r(26));
          (0, v.default)(d, "__esModule", { value: !0 });
          var x = r(2), g = r(6), _ = x.__importDefault(r(130)), A = x.__importDefault(r(131)), f = function() {
            function S(D) {
              this.editor = D;
            }
            return S.prototype.insertImg = function(D, k, L) {
              var h = this.editor, E = h.config, w = function(H, $) {
                return $ === void 0 && ($ = "validate."), h.i18next.t($ + H);
              }, O = k ? 'alt="' + k + '" ' : "", R = L ? 'data-href="' + encodeURIComponent(L) + '" ' : "";
              h.cmd.do("insertHTML", '<img src="' + D + '" ' + O + R + 'style="max-width:100%;"/>'), E.linkImgCallback(D, k, L);
              var I = document.createElement("img");
              I.onload = function() {
                I = null;
              }, I.onerror = function() {
                E.customAlert(w("插入图片错误"), "error", "wangEditor: " + w("插入图片错误") + "，" + w("图片链接") + ' "' + D + '"，' + w("下载链接失败")), I = null;
              }, I.onabort = function() {
                return I = null;
              }, I.src = D;
            }, S.prototype.uploadImg = function(D) {
              var k = this;
              if (D.length) {
                var L = this.editor, h = L.config, E = function(ce) {
                  return L.i18next.t("validate." + ce);
                }, w = h.uploadImgServer, O = h.uploadImgShowBase64, R = h.uploadImgMaxSize, I = R / 1024 / 1024, H = h.uploadImgMaxLength, $ = h.uploadFileName, Q = h.uploadImgParams, U = h.uploadImgParamsWithUrl, Y = h.uploadImgHeaders, X = h.uploadImgHooks, G = h.uploadImgTimeout, J = h.withCredentials, ee = h.customUploadImg;
                if (ee || w || O) {
                  var re = [], oe = [];
                  if (g.arrForEach(D, function(ce) {
                    var he = ce.name, ke = ce.size;
                    if (he && ke) {
                      var je = L.config.uploadImgAccept.join("|");
                      new RegExp(".(" + je + ")$", "i").test(he) !== !1 ? R < ke ? oe.push("【" + he + "】" + E("大于") + " " + I + "M") : re.push(ce) : oe.push("【" + he + "】" + E("不是图片"));
                    }
                  }), oe.length) h.customAlert(E("图片验证未通过") + `: 
` + oe.join(`
`), "warning");
                  else if (re.length !== 0) if (re.length > H) h.customAlert(E("一次最多上传") + H + E("张图片"), "warning");
                  else if (ee && typeof ee == "function") {
                    var ae;
                    ee(re, (0, C.default)(ae = this.insertImg).call(ae, this));
                  } else {
                    var se = new FormData();
                    if ((0, p.default)(re).call(re, function(ce, he) {
                      var ke = $ || ce.name;
                      re.length > 1 && (ke += he + 1), se.append(ke, ce);
                    }), w) {
                      var ve = w.split("#");
                      w = ve[0];
                      var Ae = ve[1] || "";
                      (0, p.default)(g).call(g, Q, function(ce, he) {
                        U && ((0, b.default)(w).call(w, "?") > 0 ? w += "&" : w += "?", w = w + ce + "=" + he), se.append(ce, he);
                      }), Ae && (w += "#" + Ae);
                      var ye = _.default(w, { timeout: G, formData: se, headers: Y, withCredentials: !!J, beforeSend: function(ce) {
                        if (X.before) return X.before(ce, L, re);
                      }, onTimeout: function(ce) {
                        h.customAlert(E("上传图片超时"), "error"), X.timeout && X.timeout(ce, L);
                      }, onProgress: function(ce, he) {
                        var ke = new A.default(L);
                        he.lengthComputable && (ce = he.loaded / he.total, ke.show(ce));
                      }, onError: function(ce) {
                        h.customAlert(E("上传图片错误"), "error", E("上传图片错误") + "，" + E("服务器返回状态") + ": " + ce.status), X.error && X.error(ce, L);
                      }, onFail: function(ce, he) {
                        h.customAlert(E("上传图片失败"), "error", E("上传图片返回结果错误") + "，" + E("返回结果") + ": " + he), X.fail && X.fail(ce, L, he);
                      }, onSuccess: function(ce, he) {
                        if (X.customInsert) {
                          var ke;
                          X.customInsert((0, C.default)(ke = k.insertImg).call(ke, k), he, L);
                        } else {
                          if (he.errno != "0") return h.customAlert(E("上传图片失败"), "error", E("上传图片返回结果错误") + "，" + E("返回结果") + " errno=" + he.errno), void (X.fail && X.fail(ce, L, he));
                          var je = he.data;
                          (0, p.default)(je).call(je, function(He) {
                            typeof He == "string" ? k.insertImg(He) : k.insertImg(He.url, He.alt, He.href);
                          }), X.success && X.success(ce, L, he);
                        }
                      } });
                      typeof ye == "string" && h.customAlert(ye, "error");
                    } else O && g.arrForEach(D, function(ce) {
                      var he = k, ke = new FileReader();
                      ke.readAsDataURL(ce), ke.onload = function() {
                        if (this.result) {
                          var je = this.result.toString();
                          he.insertImg(je, je);
                        }
                      };
                    });
                  }
                  else h.customAlert(E("传入的文件不合法"), "warning");
                }
              }
            }, S;
          }();
          d.default = f;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(403)), p = u(r(4)), b = u(r(43));
          function x(A) {
            return !!A.length && A.attr("class") === "w-e-todo";
          }
          function g(A, f) {
            return A.nodeType === 3 ? A.nodeValue === f.nodeValue : A.contains(f);
          }
          function _(A, f, S) {
            S === void 0 && (S = !0);
            var D = A.nodeValue, k = D == null ? void 0 : (0, b.default)(D).call(D, 0, f);
            if (D = D == null ? void 0 : (0, b.default)(D).call(D, f), !S) {
              var L = D;
              D = k, k = L;
            }
            return A.nodeValue = k, D;
          }
          (0, v.default)(d, "__esModule", { value: !0 }), d.dealTextNode = d.isAllTodo = d.isTodo = d.getCursorNextNode = void 0, d.isTodo = x, d.isAllTodo = function(A) {
            var f = A.selection.getSelectionRangeTopNodes();
            if (f.length !== 0) return (0, C.default)(f).call(f, function(S) {
              return x(S);
            });
          }, d.getCursorNextNode = function A(f, S, D) {
            var k;
            if (f.hasChildNodes()) {
              var L = f.cloneNode(), h = !1;
              S.nodeValue === "" && (h = !0);
              var E = [];
              return (0, p.default)(k = f.childNodes).call(k, function(w) {
                if (!g(w, S) && h && (L.appendChild(w.cloneNode(!0)), w.nodeName !== "BR" && E.push(w)), g(w, S)) {
                  if (w.nodeType === 1) {
                    var O = A(w, S, D);
                    O && O.textContent !== "" && (L == null || L.appendChild(O));
                  }
                  if (w.nodeType === 3 && S.isEqualNode(w)) {
                    var R = _(w, D);
                    L.textContent = R;
                  }
                  h = !0;
                }
              }), (0, p.default)(E).call(E, function(w) {
                w.remove();
              }), L;
            }
          }, d.dealTextNode = _;
        }, function(m, d, r) {
          var u = r(0)(r(1));
          (0, u.default)(d, "__esModule", { value: !0 });
          var v = r(423), C = function() {
            function p(b) {
              this.maxSize = b, this.isRe = !1, this.data = new v.CeilStack(b), this.revokeData = new v.CeilStack(b);
            }
            return (0, u.default)(p.prototype, "size", { get: function() {
              return [this.data.size, this.revokeData.size];
            }, enumerable: !1, configurable: !0 }), p.prototype.resetMaxSize = function(b) {
              this.data.resetMax(b), this.revokeData.resetMax(b);
            }, p.prototype.save = function(b) {
              return this.isRe && (this.revokeData.clear(), this.isRe = !1), this.data.instack(b), this;
            }, p.prototype.revoke = function(b) {
              !this.isRe && (this.isRe = !0);
              var x = this.data.outstack();
              return !!x && (this.revokeData.instack(x), b(x), !0);
            }, p.prototype.restore = function(b) {
              !this.isRe && (this.isRe = !0);
              var x = this.revokeData.outstack();
              return !!x && (this.data.instack(x), b(x), !0);
            }, p;
          }();
          d.default = C;
        }, function(m, d, r) {
          var u = r(15), v = r(11), C = r(76);
          m.exports = !u && !v(function() {
            return Object.defineProperty(C("div"), "a", { get: function() {
              return 7;
            } }).a != 7;
          });
        }, function(m, d, r) {
          var u = r(11), v = /#|\.prototype\./, C = function(_, A) {
            var f = b[p(_)];
            return f == g || f != x && (typeof A == "function" ? u(A) : !!A);
          }, p = C.normalize = function(_) {
            return String(_).replace(v, ".").toLowerCase();
          }, b = C.data = {}, x = C.NATIVE = "N", g = C.POLYFILL = "P";
          m.exports = C;
        }, function(m, d, r) {
          var u = r(24), v = r(161);
          m.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
            var C, p = !1, b = {};
            try {
              (C = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(b, []), p = b instanceof Array;
            } catch (x) {
            }
            return function(x, g) {
              return u(x), v(g), p ? C.call(x, g) : x.__proto__ = g, x;
            };
          }() : void 0);
        }, function(m, d, r) {
          var u = r(16), v = r(27), C = r(80).indexOf, p = r(48);
          m.exports = function(b, x) {
            var g, _ = v(b), A = 0, f = [];
            for (g in _) !u(p, g) && u(_, g) && f.push(g);
            for (; x.length > A; ) u(_, g = x[A++]) && (~C(f, g) || f.push(g));
            return f;
          };
        }, function(m, d, r) {
          var u = r(28);
          m.exports = u("document", "documentElement");
        }, function(m, d, r) {
          var u = r(83);
          m.exports = u && !Symbol.sham && typeof Symbol.iterator == "symbol";
        }, function(m, d, r) {
          var u = r(8);
          m.exports = u.Promise;
        }, function(m, d, r) {
          var u = r(49);
          m.exports = function(v, C, p) {
            for (var b in C) p && p.unsafe && v[b] ? v[b] = C[b] : u(v, b, C[b], p);
            return v;
          };
        }, function(m, d, r) {
          var u = r(28), v = r(18), C = r(9), p = r(15), b = C("species");
          m.exports = function(x) {
            var g = u(x), _ = v.f;
            p && g && !g[b] && _(g, b, { configurable: !0, get: function() {
              return this;
            } });
          };
        }, function(m, d, r) {
          var u = r(79), v = Function.toString;
          typeof u.inspectSource != "function" && (u.inspectSource = function(C) {
            return v.call(C);
          }), m.exports = u.inspectSource;
        }, function(m, d, r) {
          var u = r(24), v = r(32), C = r(9)("species");
          m.exports = function(p, b) {
            var x, g = u(p).constructor;
            return g === void 0 || (x = u(g)[C]) == null ? b : v(x);
          };
        }, function(m, d, r) {
          var u, v, C, p = r(8), b = r(11), x = r(47), g = r(104), _ = r(76), A = r(112), f = r(63), S = p.location, D = p.setImmediate, k = p.clearImmediate, L = p.process, h = p.MessageChannel, E = p.Dispatch, w = 0, O = {}, R = function(Q) {
            if (O.hasOwnProperty(Q)) {
              var U = O[Q];
              delete O[Q], U();
            }
          }, I = function(Q) {
            return function() {
              R(Q);
            };
          }, H = function(Q) {
            R(Q.data);
          }, $ = function(Q) {
            p.postMessage(Q + "", S.protocol + "//" + S.host);
          };
          D && k || (D = function(Q) {
            for (var U = [], Y = 1; arguments.length > Y; ) U.push(arguments[Y++]);
            return O[++w] = function() {
              (typeof Q == "function" ? Q : Function(Q)).apply(void 0, U);
            }, u(w), w;
          }, k = function(Q) {
            delete O[Q];
          }, f ? u = function(Q) {
            L.nextTick(I(Q));
          } : E && E.now ? u = function(Q) {
            E.now(I(Q));
          } : h && !A ? (C = (v = new h()).port2, v.port1.onmessage = H, u = x(C.postMessage, C, 1)) : p.addEventListener && typeof postMessage == "function" && !p.importScripts && S && S.protocol !== "file:" && !b($) ? (u = $, p.addEventListener("message", H, !1)) : u = "onreadystatechange" in _("script") ? function(Q) {
            g.appendChild(_("script")).onreadystatechange = function() {
              g.removeChild(this), R(Q);
            };
          } : function(Q) {
            setTimeout(I(Q), 0);
          }), m.exports = { set: D, clear: k };
        }, function(m, d, r) {
          var u = r(65);
          m.exports = /(iphone|ipod|ipad).*applewebkit/i.test(u);
        }, function(m, d, r) {
          var u = r(24), v = r(13), C = r(68);
          m.exports = function(p, b) {
            if (u(p), v(b) && b.constructor === p) return b;
            var x = C.f(p);
            return (0, x.resolve)(b), x.promise;
          };
        }, function(m, d, r) {
          var u, v, C, p = r(11), b = r(77), x = r(17), g = r(16), _ = r(9), A = r(37), f = _("iterator"), S = !1;
          [].keys && ("next" in (C = [].keys()) ? (v = b(b(C))) !== Object.prototype && (u = v) : S = !0);
          var D = u == null || p(function() {
            var k = {};
            return u[f].call(k) !== k;
          });
          D && (u = {}), A && !D || g(u, f) || x(u, f, function() {
            return this;
          }), m.exports = { IteratorPrototype: u, BUGGY_SAFARI_ITERATORS: S };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2), b = p.__importDefault(r(3)), x = r(6), g = p.__importDefault(r(268)), _ = p.__importDefault(r(283)), A = p.__importDefault(r(284)), f = p.__importDefault(r(285)), S = p.__importDefault(r(304)), D = p.__importDefault(r(409)), k = p.__importDefault(r(410)), L = p.__importDefault(r(411)), h = p.__importDefault(r(412)), E = p.__importStar(r(413)), w = p.__importDefault(r(416)), O = p.__importDefault(r(417)), R = p.__importDefault(r(418)), I = p.__importDefault(r(420)), H = p.__importDefault(r(430)), $ = p.__importDefault(r(22)), Q = p.__importDefault(r(128)), U = p.__importDefault(r(23)), Y = p.__importDefault(r(31)), X = p.__importDefault(r(33)), G = p.__importDefault(r(34)), J = 1, ee = function() {
            function re(oe, ae) {
              if (this.beforeDestroyHooks = [], this.id = "wangEditor-" + J++, this.toolbarSelector = oe, this.textSelector = ae, oe == null) throw new Error("错误：初始化编辑器时候未传入任何参数，请查阅文档");
              this.config = x.deepClone(g.default), this.$toolbarElem = b.default("<div></div>"), this.$textContainerElem = b.default("<div></div>"), this.$textElem = b.default("<div></div>"), this.toolbarElemId = "", this.textElemId = "", this.isFocus = !1, this.isComposing = !1, this.isCompatibleMode = !1, this.selection = new _.default(this), this.cmd = new A.default(this), this.txt = new f.default(this), this.menus = new S.default(this), this.zIndex = new O.default(), this.change = new R.default(this), this.history = new I.default(this);
              var se = H.default(this), ve = se.disable, Ae = se.enable;
              this.disable = ve, this.enable = Ae;
            }
            return re.prototype.initSelection = function(oe) {
              k.default(this, oe);
            }, re.prototype.create = function() {
              this.zIndex.init(this), this.isCompatibleMode = this.config.compatibleMode(), this.isCompatibleMode || (this.config.onchangeTimeout = 30), h.default(this), D.default(this), this.txt.init(), this.menus.init(), E.default(this), this.initSelection(!0), L.default(this), this.change.observe(), this.history.observe();
            }, re.prototype.beforeDestroy = function(oe) {
              return this.beforeDestroyHooks.push(oe), this;
            }, re.prototype.destroy = function() {
              var oe, ae = this;
              (0, C.default)(oe = this.beforeDestroyHooks).call(oe, function(se) {
                return se.call(ae);
              }), this.$toolbarElem.remove(), this.$textContainerElem.remove();
            }, re.prototype.fullScreen = function() {
              E.setFullScreen(this);
            }, re.prototype.unFullScreen = function() {
              E.setUnFullScreen(this);
            }, re.prototype.scrollToHead = function(oe) {
              w.default(this, oe);
            }, re.registerMenu = function(oe, ae) {
              ae && typeof ae == "function" && (re.globalCustomMenuConstructorList[oe] = ae);
            }, re.$ = b.default, re.BtnMenu = $.default, re.DropList = Q.default, re.DropListMenu = U.default, re.Panel = Y.default, re.PanelMenu = X.default, re.Tooltip = G.default, re.globalCustomMenuConstructorList = {}, re;
          }();
          d.default = ee;
        }, function(m, d, r) {
          m.exports = r(197);
        }, function(m, d, r) {
          var u = r(5), v = r(8), C = r(118), p = r(11), b = r(17), x = r(39), g = r(85), _ = r(13), A = r(41), f = r(18).f, S = r(29).forEach, D = r(15), k = r(42), L = k.set, h = k.getterFor;
          m.exports = function(E, w, O) {
            var R, I = E.indexOf("Map") !== -1, H = E.indexOf("Weak") !== -1, $ = I ? "set" : "add", Q = v[E], U = Q && Q.prototype, Y = {};
            if (D && typeof Q == "function" && (H || U.forEach && !p(function() {
              new Q().entries().next();
            }))) {
              R = w(function(G, J) {
                L(g(G, R, E), { type: E, collection: new Q() }), J != null && x(J, G[$], { that: G, AS_ENTRIES: I });
              });
              var X = h(E);
              S(["add", "clear", "delete", "forEach", "get", "has", "set", "keys", "values", "entries"], function(G) {
                var J = G == "add" || G == "set";
                G in U && (!H || G != "clear") && b(R.prototype, G, function(ee, re) {
                  var oe = X(this).collection;
                  if (!J && H && !_(ee)) return G == "get" && void 0;
                  var ae = oe[G](ee === 0 ? 0 : ee, re);
                  return J ? this : ae;
                });
              }), H || f(R.prototype, "size", { configurable: !0, get: function() {
                return X(this).collection.size;
              } });
            } else R = O.getConstructor(w, E, I, $), C.REQUIRED = !0;
            return A(R, E, !1, !0), Y[E] = R, u({ global: !0, forced: !0 }, Y), H || O.setStrong(R, E, I), R;
          };
        }, function(m, d, r) {
          var u = r(48), v = r(13), C = r(16), p = r(18).f, b = r(59), x = r(200), g = b("meta"), _ = 0, A = Object.isExtensible || function() {
            return !0;
          }, f = function(D) {
            p(D, g, { value: { objectID: "O" + ++_, weakData: {} } });
          }, S = m.exports = { REQUIRED: !1, fastKey: function(D, k) {
            if (!v(D)) return typeof D == "symbol" ? D : (typeof D == "string" ? "S" : "P") + D;
            if (!C(D, g)) {
              if (!A(D)) return "F";
              if (!k) return "E";
              f(D);
            }
            return D[g].objectID;
          }, getWeakData: function(D, k) {
            if (!C(D, g)) {
              if (!A(D)) return !0;
              if (!k) return !1;
              f(D);
            }
            return D[g].weakData;
          }, onFreeze: function(D) {
            return x && S.REQUIRED && A(D) && !C(D, g) && f(D), D;
          } };
          u[g] = !0;
        }, function(m, d, r) {
          var u = r(18).f, v = r(60), C = r(107), p = r(47), b = r(85), x = r(39), g = r(87), _ = r(108), A = r(15), f = r(118).fastKey, S = r(42), D = S.set, k = S.getterFor;
          m.exports = { getConstructor: function(L, h, E, w) {
            var O = L(function($, Q) {
              b($, O, h), D($, { type: h, index: v(null), first: void 0, last: void 0, size: 0 }), A || ($.size = 0), Q != null && x(Q, $[w], { that: $, AS_ENTRIES: E });
            }), R = k(h), I = function($, Q, U) {
              var Y, X, G = R($), J = H($, Q);
              return J ? J.value = U : (G.last = J = { index: X = f(Q, !0), key: Q, value: U, previous: Y = G.last, next: void 0, removed: !1 }, G.first || (G.first = J), Y && (Y.next = J), A ? G.size++ : $.size++, X !== "F" && (G.index[X] = J)), $;
            }, H = function($, Q) {
              var U, Y = R($), X = f(Q);
              if (X !== "F") return Y.index[X];
              for (U = Y.first; U; U = U.next) if (U.key == Q) return U;
            };
            return C(O.prototype, { clear: function() {
              for (var $ = R(this), Q = $.index, U = $.first; U; ) U.removed = !0, U.previous && (U.previous = U.previous.next = void 0), delete Q[U.index], U = U.next;
              $.first = $.last = void 0, A ? $.size = 0 : this.size = 0;
            }, delete: function($) {
              var Q = R(this), U = H(this, $);
              if (U) {
                var Y = U.next, X = U.previous;
                delete Q.index[U.index], U.removed = !0, X && (X.next = Y), Y && (Y.previous = X), Q.first == U && (Q.first = Y), Q.last == U && (Q.last = X), A ? Q.size-- : this.size--;
              }
              return !!U;
            }, forEach: function($) {
              for (var Q, U = R(this), Y = p($, arguments.length > 1 ? arguments[1] : void 0, 3); Q = Q ? Q.next : U.first; ) for (Y(Q.value, Q.key, this); Q && Q.removed; ) Q = Q.previous;
            }, has: function($) {
              return !!H(this, $);
            } }), C(O.prototype, E ? { get: function($) {
              var Q = H(this, $);
              return Q && Q.value;
            }, set: function($, Q) {
              return I(this, $ === 0 ? 0 : $, Q);
            } } : { add: function($) {
              return I(this, $ = $ === 0 ? 0 : $, $);
            } }), A && u(O.prototype, "size", { get: function() {
              return R(this).size;
            } }), O;
          }, setStrong: function(L, h, E) {
            var w = h + " Iterator", O = k(h), R = k(w);
            g(L, h, function(I, H) {
              D(this, { type: w, target: I, state: O(I), kind: H, last: void 0 });
            }, function() {
              for (var I = R(this), H = I.kind, $ = I.last; $ && $.removed; ) $ = $.previous;
              return I.target && (I.last = $ = $ ? $.next : I.state.first) ? H == "keys" ? { value: $.key, done: !1 } : H == "values" ? { value: $.value, done: !1 } : { value: [$.key, $.value], done: !1 } : (I.target = void 0, { value: void 0, done: !0 });
            }, E ? "entries" : "values", !E, !0), _(h);
          } };
        }, function(m, d, r) {
          var u = r(103), v = r(82).concat("length", "prototype");
          d.f = Object.getOwnPropertyNames || function(C) {
            return u(C, v);
          };
        }, function(m, d) {
          d.f = Object.getOwnPropertySymbols;
        }, function(m, d, r) {
          r(10)("iterator");
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 }), d.default = { zIndex: 1e4 };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4));
          (0, v.default)(d, "__esModule", { value: !0 }), d.getPasteImgs = d.getPasteHtml = d.getPasteText = void 0;
          var p = r(2), b = r(6), x = p.__importDefault(r(295));
          function g(_) {
            var A = _.clipboardData, f = "";
            return f = A == null ? window.clipboardData && window.clipboardData.getData("text") : A.getData("text/plain"), b.replaceHtmlSymbol(f);
          }
          d.getPasteText = g, d.getPasteHtml = function(_, A, f) {
            A === void 0 && (A = !0), f === void 0 && (f = !1);
            var S = _.clipboardData, D = "";
            if (S && (D = S.getData("text/html")), !D) {
              var k = g(_);
              if (!k) return "";
              D = "<p>" + k + "</p>";
            }
            return D = x.default(D, A, f);
          }, d.getPasteImgs = function(_) {
            var A, f = [];
            if (g(_)) return f;
            var S = (A = _.clipboardData) === null || A === void 0 ? void 0 : A.items;
            return S && (0, C.default)(b).call(b, S, function(D, k) {
              var L = k.type;
              /image/i.test(L) && f.push(k.getAsFile());
            }), f;
          };
        }, function(m, d, r) {
          m.exports = r(297);
        }, function(m, d, r) {
          m.exports = r(305);
        }, function(m, d, r) {
          m.exports = r(309);
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4)), p = u(r(54));
          (0, v.default)(d, "__esModule", { value: !0 });
          var b = r(2).__importDefault(r(3)), x = r(7), g = function() {
            function _(A, f) {
              var S = this;
              this.hideTimeoutId = 0, this.menu = A, this.conf = f;
              var D = b.default('<div class="w-e-droplist"></div>'), k = b.default("<p>" + f.title + "</p>");
              k.addClass("w-e-dp-title"), D.append(k);
              var L = f.list || [], h = f.type || "list", E = f.clickHandler || x.EMPTY_FN, w = b.default('<ul class="' + (h === "list" ? "w-e-list" : "w-e-block") + '"></ul>');
              (0, C.default)(L).call(L, function(O) {
                var R = O.$elem, I = O.value, H = b.default('<li class="w-e-item"></li>');
                R && (H.append(R), w.append(H), H.on("click", function($) {
                  E(I), $.stopPropagation(), S.hideTimeoutId = (0, p.default)(function() {
                    S.hide();
                  });
                }));
              }), D.append(w), D.on("mouseleave", function() {
                S.hideTimeoutId = (0, p.default)(function() {
                  S.hide();
                });
              }), this.$container = D, this.rendered = !1, this._show = !1;
            }
            return _.prototype.show = function() {
              this.hideTimeoutId && clearTimeout(this.hideTimeoutId);
              var A = this.menu.$elem, f = this.$container;
              if (!this._show) {
                if (this.rendered) f.show();
                else {
                  var S = A.getBoundingClientRect().height || 0, D = this.conf.width || 100;
                  f.css("margin-top", S + "px").css("width", D + "px"), A.append(f), this.rendered = !0;
                }
                this._show = !0;
              }
            }, _.prototype.hide = function() {
              var A = this.$container;
              this._show && (A.hide(), this._show = !1);
            }, (0, v.default)(_.prototype, "isShow", { get: function() {
              return this._show;
            }, enumerable: !1, configurable: !0 }), _;
          }();
          d.default = g;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 }), d.default = function(u) {
            var v = u.selection.getSelectionContainerElem();
            return !(v == null || !v.length) && v.getNodeName() === "A";
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(94)), C = u(r(1)), p = u(r(4));
          (0, C.default)(d, "__esModule", { value: !0 });
          var b = r(6);
          d.default = function(x, g) {
            var _ = new XMLHttpRequest();
            if (_.open("POST", x), _.timeout = g.timeout || 1e4, _.ontimeout = function() {
              console.error("wangEditor - 请求超时"), g.onTimeout && g.onTimeout(_);
            }, _.upload && (_.upload.onprogress = function(f) {
              var S = f.loaded / f.total;
              g.onProgress && g.onProgress(S, f);
            }), g.headers && (0, p.default)(b).call(b, g.headers, function(f, S) {
              _.setRequestHeader(f, S);
            }), _.withCredentials = !!g.withCredentials, g.beforeSend) {
              var A = g.beforeSend(_);
              if (A && (0, v.default)(A) === "object" && A.prevent) return A.msg;
            }
            return _.onreadystatechange = function() {
              if (_.readyState === 4) {
                var f = _.status;
                if (!(f < 200 || f >= 300 && f < 400)) {
                  if (f >= 400) return console.error("wangEditor - XHR 报错，状态码 " + f), void (g.onError && g.onError(_));
                  var S, D = _.responseText;
                  if ((0, v.default)(D) !== "object") try {
                    S = JSON.parse(D);
                  } catch (k) {
                    return console.error("wangEditor - 返回结果不是 JSON 格式", D), void (g.onFail && g.onFail(_, D));
                  }
                  else S = D;
                  g.onSuccess(_, S);
                }
              }
            }, _.send(g.formData || null), _;
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(341)), p = u(r(54));
          (0, v.default)(d, "__esModule", { value: !0 });
          var b = r(2).__importDefault(r(3)), x = function() {
            function g(_) {
              this.editor = _, this.$textContainer = _.$textContainerElem, this.$bar = b.default('<div class="w-e-progress"></div>'), this.isShow = !1, this.time = 0, this.timeoutId = 0;
            }
            return g.prototype.show = function(_) {
              var A = this;
              if (!this.isShow) {
                this.isShow = !0;
                var f = this.$bar;
                this.$textContainer.append(f), (0, C.default)() - this.time > 100 && _ <= 1 && (f.css("width", 100 * _ + "%"), this.time = (0, C.default)());
                var S = this.timeoutId;
                S && clearTimeout(S), this.timeoutId = (0, p.default)(function() {
                  A.hide();
                }, 500);
              }
            }, g.prototype.hide = function() {
              this.$bar.remove(), this.isShow = !1, this.time = 0, this.timeoutId = 0;
            }, g;
          }();
          d.default = x;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 }), d.ListType = void 0;
          var u, v = r(2), C = v.__importDefault(r(3)), p = v.__importDefault(r(23)), b = r(44), x = v.__importStar(r(368));
          (function(_) {
            _.OrderedList = "OL", _.UnorderedList = "UL";
          })(u = d.ListType || (d.ListType = {}));
          var g = function(_) {
            function A(f) {
              var S = this, D = C.default(`<div class="w-e-menu" data-title="序列">
                <i class="w-e-icon-list2"></i>
            </div>`), k = { width: 130, title: "序列", type: "list", list: [{ $elem: C.default(`
                        <p>
                            <i class="w-e-icon-list2 w-e-drop-list-item"></i>
                            ` + f.i18next.t("menus.dropListMenu.list.无序列表") + `
                        <p>`), value: u.UnorderedList }, { $elem: C.default(`<p>
                            <i class="w-e-icon-list-numbered w-e-drop-list-item"></i>
                            ` + f.i18next.t("menus.dropListMenu.list.有序列表") + `
                        <p>`), value: u.OrderedList }], clickHandler: function(L) {
                S.command(L);
              } };
              return S = _.call(this, D, f, k) || this;
            }
            return v.__extends(A, _), A.prototype.command = function(f) {
              this.editor.selection.getSelectionContainerElem() !== void 0 && (this.handleSelectionRangeNodes(f), this.tryChangeActive());
            }, A.prototype.validator = function(f, S, D) {
              return !(!f.length || !S.length || D.equal(f) || D.equal(S));
            }, A.prototype.handleSelectionRangeNodes = function(f) {
              var S = this.editor, D = S.selection, k = f.toLowerCase(), L = D.getSelectionContainerElem(), h = D.getSelectionStartElem().getNodeTop(S), E = D.getSelectionEndElem().getNodeTop(S);
              if (this.validator(h, E, S.$textElem)) {
                var w = D.getRange(), O = w == null ? void 0 : w.collapsed;
                S.$textElem.equal(L) || (L = L.getNodeTop(S));
                var R, I = { editor: S, listType: f, listTarget: k, $selectionElem: L, $startElem: h, $endElem: E };
                R = this.isOrderElem(L) ? x.ClassType.Wrap : this.isOrderElem(h) && this.isOrderElem(E) ? x.ClassType.Join : this.isOrderElem(h) ? x.ClassType.StartJoin : this.isOrderElem(E) ? x.ClassType.EndJoin : x.ClassType.Other;
                var H = new x.default(x.createListHandle(R, I, w));
                b.updateRange(S, H.getSelectionRangeElem(), !!O);
              }
            }, A.prototype.isOrderElem = function(f) {
              var S = f.getNodeName();
              return S === u.OrderedList || S === u.UnorderedList;
            }, A.prototype.tryChangeActive = function() {
            }, A;
          }(p.default);
          d.default = g;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 }), d.default = function(u) {
            var v = u.selection.getSelectionContainerElem();
            return !(v == null || !v.length || v.getNodeName() != "CODE" && v.getNodeName() != "PRE" && v.parent().getNodeName() != "CODE" && v.parent().getNodeName() != "PRE" && !/hljs/.test(v.parent().attr("class")));
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(30));
          (0, v.default)(d, "__esModule", { value: !0 }), d.todo = void 0;
          var p = r(2).__importDefault(r(3)), b = function() {
            function x(g) {
              var _;
              this.template = '<ul class="w-e-todo"><li><span contenteditable="false"><input type="checkbox"></span></li></ul>', this.checked = !1, this.$todo = p.default(this.template), this.$child = (_ = g == null ? void 0 : g.childNodes()) === null || _ === void 0 ? void 0 : _.clone(!0);
            }
            return x.prototype.init = function() {
              var g = this, _ = this.getInput(), A = this.$child, f = this.getInputContainer();
              A && A.insertAfter(f), _.on("click", function() {
                g.checked ? _ == null || _.removeAttr("checked") : _ == null || _.attr("checked", ""), g.checked = !g.checked;
              });
            }, x.prototype.getInput = function() {
              var g = this.$todo;
              return (0, C.default)(g).call(g, "input");
            }, x.prototype.getInputContainer = function() {
              return this.getInput().parent();
            }, x.prototype.getTodo = function() {
              return this.$todo;
            }, x;
          }();
          d.todo = b, d.default = function(x) {
            var g = new b(x);
            return g.init(), g;
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2);
          r(140), r(142), r(146), r(148), r(150), r(152), r(154);
          var v = u.__importDefault(r(115));
          u.__exportStar(r(433), d), d.default = v.default;
        }, function(m, d, r) {
          var u = r(137);
          m.exports = u;
        }, function(m, d, r) {
          r(138);
          var u = r(12).Object, v = m.exports = function(C, p, b) {
            return u.defineProperty(C, p, b);
          };
          u.defineProperty.sham && (v.sham = !0);
        }, function(m, d, r) {
          var u = r(5), v = r(15);
          u({ target: "Object", stat: !0, forced: !v, sham: !v }, { defineProperty: r(18).f });
        }, function(m, d) {
          var r;
          r = /* @__PURE__ */ function() {
            return this;
          }();
          try {
            r = r || new Function("return this")();
          } catch (u) {
            typeof window == "object" && (r = window);
          }
          m.exports = r;
        }, function(m, d, r) {
          var u = r(20), v = r(141);
          typeof (v = v.__esModule ? v.default : v) == "string" && (v = [[m.i, v, ""]]);
          var C = { insert: "head", singleton: !1 };
          u(v, C), m.exports = v.locals || {};
        }, function(m, d, r) {
          (d = r(21)(!1)).push([m.i, `.w-e-toolbar,
.w-e-text-container,
.w-e-menu-panel {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  background-color: #fff;
  /*表情菜单样式*/
  /*分割线样式*/
}
.w-e-toolbar h1,
.w-e-text-container h1,
.w-e-menu-panel h1 {
  font-size: 2em !important;
}
.w-e-toolbar h2,
.w-e-text-container h2,
.w-e-menu-panel h2 {
  font-size: 1.5em !important;
}
.w-e-toolbar h3,
.w-e-text-container h3,
.w-e-menu-panel h3 {
  font-size: 1.17em !important;
}
.w-e-toolbar h4,
.w-e-text-container h4,
.w-e-menu-panel h4 {
  font-size: 1em !important;
}
.w-e-toolbar h5,
.w-e-text-container h5,
.w-e-menu-panel h5 {
  font-size: 0.83em !important;
}
.w-e-toolbar p,
.w-e-text-container p,
.w-e-menu-panel p {
  font-size: 1em !important;
}
.w-e-toolbar .eleImg,
.w-e-text-container .eleImg,
.w-e-menu-panel .eleImg {
  cursor: pointer;
  display: inline-block;
  font-size: 18px;
  padding: 0 3px;
}
.w-e-toolbar *,
.w-e-text-container *,
.w-e-menu-panel * {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.w-e-toolbar hr,
.w-e-text-container hr,
.w-e-menu-panel hr {
  cursor: pointer;
  display: block;
  height: 0px;
  border: 0;
  border-top: 3px solid #ccc;
  margin: 20px 0;
}
.w-e-clear-fix:after {
  content: "";
  display: table;
  clear: both;
}
.w-e-drop-list-item {
  position: relative;
  top: 1px;
  padding-right: 7px;
  color: #333 !important;
}
.w-e-drop-list-tl {
  padding-left: 10px;
  text-align: left;
}
`, ""]), m.exports = d;
        }, function(m, d, r) {
          var u = r(20), v = r(143);
          typeof (v = v.__esModule ? v.default : v) == "string" && (v = [[m.i, v, ""]]);
          var C = { insert: "head", singleton: !1 };
          u(v, C), m.exports = v.locals || {};
        }, function(m, d, r) {
          var u = r(21), v = r(144), C = r(145);
          d = u(!1);
          var p = v(C);
          d.push([m.i, `@font-face {
  font-family: 'w-e-icon';
  src: url(` + p + `) format('truetype');
  font-weight: normal;
  font-style: normal;
}
[class^="w-e-icon-"],
[class*=" w-e-icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'w-e-icon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.w-e-icon-close:before {
  content: "\\f00d";
}
.w-e-icon-upload2:before {
  content: "\\e9c6";
}
.w-e-icon-trash-o:before {
  content: "\\f014";
}
.w-e-icon-header:before {
  content: "\\f1dc";
}
.w-e-icon-pencil2:before {
  content: "\\e906";
}
.w-e-icon-paint-brush:before {
  content: "\\f1fc";
}
.w-e-icon-image:before {
  content: "\\e90d";
}
.w-e-icon-play:before {
  content: "\\e912";
}
.w-e-icon-location:before {
  content: "\\e947";
}
.w-e-icon-undo:before {
  content: "\\e965";
}
.w-e-icon-redo:before {
  content: "\\e966";
}
.w-e-icon-quotes-left:before {
  content: "\\e977";
}
.w-e-icon-list-numbered:before {
  content: "\\e9b9";
}
.w-e-icon-list2:before {
  content: "\\e9bb";
}
.w-e-icon-link:before {
  content: "\\e9cb";
}
.w-e-icon-happy:before {
  content: "\\e9df";
}
.w-e-icon-bold:before {
  content: "\\ea62";
}
.w-e-icon-underline:before {
  content: "\\ea63";
}
.w-e-icon-italic:before {
  content: "\\ea64";
}
.w-e-icon-strikethrough:before {
  content: "\\ea65";
}
.w-e-icon-table2:before {
  content: "\\ea71";
}
.w-e-icon-paragraph-left:before {
  content: "\\ea77";
}
.w-e-icon-paragraph-center:before {
  content: "\\ea78";
}
.w-e-icon-paragraph-right:before {
  content: "\\ea79";
}
.w-e-icon-paragraph-justify:before {
  content: "\\ea7a";
}
.w-e-icon-terminal:before {
  content: "\\f120";
}
.w-e-icon-page-break:before {
  content: "\\ea68";
}
.w-e-icon-cancel-circle:before {
  content: "\\ea0d";
}
.w-e-icon-font:before {
  content: "\\ea5c";
}
.w-e-icon-text-heigh:before {
  content: "\\ea5f";
}
.w-e-icon-paint-format:before {
  content: "\\e90c";
}
.w-e-icon-indent-increase:before {
  content: "\\ea7b";
}
.w-e-icon-indent-decrease:before {
  content: "\\ea7c";
}
.w-e-icon-row-height:before {
  content: "\\e9be";
}
.w-e-icon-fullscreen_exit:before {
  content: "\\e900";
}
.w-e-icon-fullscreen:before {
  content: "\\e901";
}
.w-e-icon-split-line:before {
  content: "\\ea0b";
}
.w-e-icon-checkbox-checked:before {
  content: "\\ea52";
}
`, ""]), m.exports = d;
        }, function(m, d, r) {
          m.exports = function(u, v) {
            return v || (v = {}), typeof (u = u && u.__esModule ? u.default : u) != "string" ? u : (/^['"].*['"]$/.test(u) && (u = u.slice(1, -1)), v.hash && (u += v.hash), /["'() \t\n]/.test(u) || v.needQuotes ? '"'.concat(u.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : u);
          };
        }, function(m, d, r) {
          r.r(d), d.default = "data:font/woff;base64,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";
        }, function(m, d, r) {
          var u = r(20), v = r(147);
          typeof (v = v.__esModule ? v.default : v) == "string" && (v = [[m.i, v, ""]]);
          var C = { insert: "head", singleton: !1 };
          u(v, C), m.exports = v.locals || {};
        }, function(m, d, r) {
          (d = r(21)(!1)).push([m.i, `.w-e-toolbar {
  display: flex;
  padding: 0 6px;
  flex-wrap: wrap;
  position: relative;
  /* 单个菜单 */
}
.w-e-toolbar .w-e-menu {
  position: relative;
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
}
.w-e-toolbar .w-e-menu i {
  color: #999;
}
.w-e-toolbar .w-e-menu:hover {
  background-color: #F6F6F6;
}
.w-e-toolbar .w-e-menu:hover i {
  color: #333;
}
.w-e-toolbar .w-e-active i {
  color: #1e88e5;
}
.w-e-toolbar .w-e-active:hover i {
  color: #1e88e5;
}
.w-e-menu-tooltip {
  position: absolute;
  display: flex;
  color: #f1f1f1;
  background-color: rgba(0, 0, 0, 0.75);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding: 4px 5px 6px;
  justify-content: center;
  align-items: center;
}
.w-e-menu-tooltip-up::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border: 5px solid rgba(0, 0, 0, 0);
  border-top-color: rgba(0, 0, 0, 0.73);
}
.w-e-menu-tooltip-down::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border: 5px solid rgba(0, 0, 0, 0);
  border-bottom-color: rgba(0, 0, 0, 0.73);
}
.w-e-menu-tooltip-item-wrapper {
  font-size: 14px;
  margin: 0 5px;
}
`, ""]), m.exports = d;
        }, function(m, d, r) {
          var u = r(20), v = r(149);
          typeof (v = v.__esModule ? v.default : v) == "string" && (v = [[m.i, v, ""]]);
          var C = { insert: "head", singleton: !1 };
          u(v, C), m.exports = v.locals || {};
        }, function(m, d, r) {
          (d = r(21)(!1)).push([m.i, `.w-e-text-container {
  position: relative;
  height: 100%;
}
.w-e-text-container .w-e-progress {
  position: absolute;
  background-color: #1e88e5;
  top: 0;
  left: 0;
  height: 1px;
}
.w-e-text-container .placeholder {
  color: #D4D4D4;
  position: absolute;
  font-size: 11pt;
  line-height: 22px;
  left: 10px;
  top: 10px;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  z-index: -1;
}
.w-e-text {
  padding: 0 10px;
  overflow-y: auto;
}
.w-e-text p,
.w-e-text h1,
.w-e-text h2,
.w-e-text h3,
.w-e-text h4,
.w-e-text h5,
.w-e-text table,
.w-e-text pre {
  margin: 10px 0;
  line-height: 1.5;
}
.w-e-text ul,
.w-e-text ol {
  margin: 10px 0 10px 20px;
}
.w-e-text blockquote {
  display: block;
  border-left: 8px solid #d0e5f2;
  padding: 5px 10px;
  margin: 10px 0;
  line-height: 1.4;
  font-size: 100%;
  background-color: #f1f1f1;
}
.w-e-text code {
  display: inline-block;
  background-color: #f1f1f1;
  border-radius: 3px;
  padding: 3px 5px;
  margin: 0 3px;
}
.w-e-text pre code {
  display: block;
}
.w-e-text table {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}
.w-e-text table td,
.w-e-text table th {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 3px 5px;
  min-height: 30px;
}
.w-e-text table th {
  border-bottom: 2px solid #ccc;
  text-align: center;
  background-color: #f1f1f1;
}
.w-e-text:focus {
  outline: none;
}
.w-e-text img {
  cursor: pointer;
}
.w-e-text img:hover {
  box-shadow: 0 0 5px #333;
}
.w-e-text .w-e-todo {
  margin: 0 0 0 20px;
}
.w-e-text .w-e-todo li {
  list-style: none;
  font-size: 1em;
}
.w-e-text .w-e-todo li span:nth-child(1) {
  position: relative;
  left: -18px;
}
.w-e-text .w-e-todo li span:nth-child(1) input {
  position: absolute;
  margin-right: 3px;
}
.w-e-text .w-e-todo li span:nth-child(1) input[type=checkbox] {
  top: 50%;
  margin-top: -6px;
}
.w-e-tooltip {
  position: absolute;
  display: flex;
  color: #f1f1f1;
  background-color: rgba(0, 0, 0, 0.75);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding: 4px 5px 6px;
  justify-content: center;
  align-items: center;
}
.w-e-tooltip-up::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border: 5px solid rgba(0, 0, 0, 0);
  border-top-color: rgba(0, 0, 0, 0.73);
}
.w-e-tooltip-down::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border: 5px solid rgba(0, 0, 0, 0);
  border-bottom-color: rgba(0, 0, 0, 0.73);
}
.w-e-tooltip-item-wrapper {
  cursor: pointer;
  font-size: 14px;
  margin: 0 5px;
}
.w-e-tooltip-item-wrapper:hover {
  color: #ccc;
  text-decoration: underline;
}
`, ""]), m.exports = d;
        }, function(m, d, r) {
          var u = r(20), v = r(151);
          typeof (v = v.__esModule ? v.default : v) == "string" && (v = [[m.i, v, ""]]);
          var C = { insert: "head", singleton: !1 };
          u(v, C), m.exports = v.locals || {};
        }, function(m, d, r) {
          (d = r(21)(!1)).push([m.i, `.w-e-menu .w-e-panel-container {
  position: absolute;
  top: 0;
  left: 50%;
  border: 1px solid #ccc;
  border-top: 0;
  box-shadow: 1px 1px 2px #ccc;
  color: #333;
  background-color: #fff;
  text-align: left;
  /* 为 emotion panel 定制的样式 */
  /* 上传图片、上传视频的 panel 定制样式 */
}
.w-e-menu .w-e-panel-container .w-e-panel-close {
  position: absolute;
  right: 0;
  top: 0;
  padding: 5px;
  margin: 2px 5px 0 0;
  cursor: pointer;
  color: #999;
}
.w-e-menu .w-e-panel-container .w-e-panel-close:hover {
  color: #333;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-title {
  list-style: none;
  display: flex;
  font-size: 14px;
  margin: 2px 10px 0 10px;
  border-bottom: 1px solid #f1f1f1;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-title .w-e-item {
  padding: 3px 5px;
  color: #999;
  cursor: pointer;
  margin: 0 3px;
  position: relative;
  top: 1px;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-title .w-e-active {
  color: #333;
  border-bottom: 1px solid #333;
  cursor: default;
  font-weight: 700;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content {
  padding: 10px 15px 10px 15px;
  font-size: 16px;
  /* 输入框的样式 */
  /* 按钮的样式 */
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content input:focus,
.w-e-menu .w-e-panel-container .w-e-panel-tab-content textarea:focus,
.w-e-menu .w-e-panel-container .w-e-panel-tab-content button:focus {
  outline: none;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content textarea {
  width: 100%;
  border: 1px solid #ccc;
  padding: 5px;
  margin-top: 10px;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content textarea:focus {
  border-color: #1e88e5;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content input[type=text] {
  border: none;
  border-bottom: 1px solid #ccc;
  font-size: 14px;
  height: 20px;
  color: #333;
  text-align: left;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content input[type=text].small {
  width: 30px;
  text-align: center;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content input[type=text].block {
  display: block;
  width: 100%;
  margin: 10px 0;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content input[type=text]:focus {
  border-bottom: 2px solid #1e88e5;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button {
  font-size: 14px;
  color: #1e88e5;
  border: none;
  padding: 5px 10px;
  background-color: #fff;
  cursor: pointer;
  border-radius: 3px;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button.left {
  float: left;
  margin-right: 10px;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button.right {
  float: right;
  margin-left: 10px;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button.gray {
  color: #999;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button.red {
  color: #c24f4a;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button:hover {
  background-color: #f1f1f1;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container:after {
  content: "";
  display: table;
  clear: both;
}
.w-e-menu .w-e-panel-container .w-e-emoticon-container .w-e-item {
  cursor: pointer;
  font-size: 18px;
  padding: 0 3px;
  display: inline-block;
}
.w-e-menu .w-e-panel-container .w-e-up-img-container,
.w-e-menu .w-e-panel-container .w-e-up-video-container {
  text-align: center;
}
.w-e-menu .w-e-panel-container .w-e-up-img-container .w-e-up-btn,
.w-e-menu .w-e-panel-container .w-e-up-video-container .w-e-up-btn {
  display: inline-block;
  color: #999;
  cursor: pointer;
  font-size: 60px;
  line-height: 1;
}
.w-e-menu .w-e-panel-container .w-e-up-img-container .w-e-up-btn:hover,
.w-e-menu .w-e-panel-container .w-e-up-video-container .w-e-up-btn:hover {
  color: #333;
}
`, ""]), m.exports = d;
        }, function(m, d, r) {
          var u = r(20), v = r(153);
          typeof (v = v.__esModule ? v.default : v) == "string" && (v = [[m.i, v, ""]]);
          var C = { insert: "head", singleton: !1 };
          u(v, C), m.exports = v.locals || {};
        }, function(m, d, r) {
          (d = r(21)(!1)).push([m.i, `.w-e-toolbar .w-e-droplist {
  position: absolute;
  left: 0;
  top: 0;
  background-color: #fff;
  border: 1px solid #f1f1f1;
  border-right-color: #ccc;
  border-bottom-color: #ccc;
}
.w-e-toolbar .w-e-droplist .w-e-dp-title {
  text-align: center;
  color: #999;
  line-height: 2;
  border-bottom: 1px solid #f1f1f1;
  font-size: 13px;
}
.w-e-toolbar .w-e-droplist ul.w-e-list {
  list-style: none;
  line-height: 1;
}
.w-e-toolbar .w-e-droplist ul.w-e-list li.w-e-item {
  color: #333;
  padding: 5px 0;
}
.w-e-toolbar .w-e-droplist ul.w-e-list li.w-e-item:hover {
  background-color: #f1f1f1;
}
.w-e-toolbar .w-e-droplist ul.w-e-block {
  list-style: none;
  text-align: left;
  padding: 5px;
}
.w-e-toolbar .w-e-droplist ul.w-e-block li.w-e-item {
  display: inline-block;
  padding: 3px 5px;
}
.w-e-toolbar .w-e-droplist ul.w-e-block li.w-e-item:hover {
  background-color: #f1f1f1;
}
`, ""]), m.exports = d;
        }, function(m, d, r) {
          var u = r(0)(r(155));
          Element.prototype.matches || (Element.prototype.matches = function(v) {
            for (var C = this.ownerDocument.querySelectorAll(v), p = C.length; p >= 0 && C.item(p) !== this; p--) ;
            return p > -1;
          }), u.default || (window.Promise = u.default);
        }, function(m, d, r) {
          m.exports = r(156);
        }, function(m, d, r) {
          var u = r(157);
          m.exports = u;
        }, function(m, d, r) {
          r(158), r(67), r(166), r(173), r(174), r(175), r(69), r(50);
          var u = r(12);
          m.exports = u.Promise;
        }, function(m, d, r) {
          var u = r(5), v = r(77), C = r(102), p = r(60), b = r(17), x = r(35), g = r(39), _ = function(A, f) {
            var S = this;
            if (!(S instanceof _)) return new _(A, f);
            C && (S = C(new Error(void 0), v(S))), f !== void 0 && b(S, "message", String(f));
            var D = [];
            return g(A, D.push, { that: D }), b(S, "errors", D), S;
          };
          _.prototype = p(Error.prototype, { constructor: x(5, _), message: x(5, ""), name: x(5, "AggregateError") }), u({ global: !0 }, { AggregateError: _ });
        }, function(m, d, r) {
          var u = r(8), v = r(17);
          m.exports = function(C, p) {
            try {
              v(u, C, p);
            } catch (b) {
              u[C] = p;
            }
            return p;
          };
        }, function(m, d, r) {
          var u = r(11);
          m.exports = !u(function() {
            function v() {
            }
            return v.prototype.constructor = null, Object.getPrototypeOf(new v()) !== v.prototype;
          });
        }, function(m, d, r) {
          var u = r(13);
          m.exports = function(v) {
            if (!u(v) && v !== null) throw TypeError("Can't set " + String(v) + " as a prototype");
            return v;
          };
        }, function(m, d, r) {
          var u = r(15), v = r(18), C = r(24), p = r(61);
          m.exports = u ? Object.defineProperties : function(b, x) {
            C(b);
            for (var g, _ = p(x), A = _.length, f = 0; A > f; ) v.f(b, g = _[f++], x[g]);
            return b;
          };
        }, function(m, d, r) {
          var u = r(9), v = r(40), C = u("iterator"), p = Array.prototype;
          m.exports = function(b) {
            return b !== void 0 && (v.Array === b || p[C] === b);
          };
        }, function(m, d, r) {
          var u = r(66), v = r(40), C = r(9)("iterator");
          m.exports = function(p) {
            if (p != null) return p[C] || p["@@iterator"] || v[u(p)];
          };
        }, function(m, d, r) {
          var u = r(24);
          m.exports = function(v) {
            var C = v.return;
            if (C !== void 0) return u(C.call(v)).value;
          };
        }, function(m, d, r) {
          var u, v, C, p, b = r(5), x = r(37), g = r(8), _ = r(28), A = r(106), f = r(49), S = r(107), D = r(41), k = r(108), L = r(13), h = r(32), E = r(85), w = r(109), O = r(39), R = r(168), I = r(110), H = r(111).set, $ = r(169), Q = r(113), U = r(171), Y = r(68), X = r(86), G = r(42), J = r(101), ee = r(9), re = r(63), oe = r(64), ae = ee("species"), se = "Promise", ve = G.get, Ae = G.set, ye = G.getterFor(se), ce = A, he = g.TypeError, ke = g.document, je = g.process, He = _("fetch"), Ve = Y.f, qt = Ve, ln = !!(ke && ke.createEvent && g.dispatchEvent), Ft = typeof PromiseRejectionEvent == "function", pn = J(se, function() {
            if (w(ce) === String(ce) && (oe === 66 || !re && !Ft) || x && !ce.prototype.finally) return !0;
            if (oe >= 51 && /native code/.test(ce)) return !1;
            var fe = ce.resolve(1), Ne = function(_e) {
              _e(function() {
              }, function() {
              });
            };
            return (fe.constructor = {})[ae] = Ne, !(fe.then(function() {
            }) instanceof Ne);
          }), _r = pn || !R(function(fe) {
            ce.all(fe).catch(function() {
            });
          }), Bt = function(fe) {
            var Ne;
            return !(!L(fe) || typeof (Ne = fe.then) != "function") && Ne;
          }, jt = function(fe, Ne) {
            if (!fe.notified) {
              fe.notified = !0;
              var _e = fe.reactions;
              $(function() {
                for (var Oe = fe.value, $e = fe.state == 1, Ct = 0; _e.length > Ct; ) {
                  var nt, be, Te, Ie = _e[Ct++], ze = $e ? Ie.ok : Ie.fail, it = Ie.resolve, dt = Ie.reject, Vt = Ie.domain;
                  try {
                    ze ? ($e || (fe.rejection === 2 && $t(fe), fe.rejection = 1), ze === !0 ? nt = Oe : (Vt && Vt.enter(), nt = ze(Oe), Vt && (Vt.exit(), Te = !0)), nt === Ie.promise ? dt(he("Promise-chain cycle")) : (be = Bt(nt)) ? be.call(nt, it, dt) : it(nt)) : dt(Oe);
                  } catch (Rn) {
                    Vt && !Te && Vt.exit(), dt(Rn);
                  }
                }
                fe.reactions = [], fe.notified = !1, Ne && !fe.rejection && Zt(fe);
              });
            }
          }, sn = function(fe, Ne, _e) {
            var Oe, $e;
            ln ? ((Oe = ke.createEvent("Event")).promise = Ne, Oe.reason = _e, Oe.initEvent(fe, !1, !0), g.dispatchEvent(Oe)) : Oe = { promise: Ne, reason: _e }, !Ft && ($e = g["on" + fe]) ? $e(Oe) : fe === "unhandledrejection" && U("Unhandled promise rejection", _e);
          }, Zt = function(fe) {
            H.call(g, function() {
              var Ne, _e = fe.facade, Oe = fe.value;
              if (st(fe) && (Ne = X(function() {
                re ? je.emit("unhandledRejection", Oe, _e) : sn("unhandledrejection", _e, Oe);
              }), fe.rejection = re || st(fe) ? 2 : 1, Ne.error)) throw Ne.value;
            });
          }, st = function(fe) {
            return fe.rejection !== 1 && !fe.parent;
          }, $t = function(fe) {
            H.call(g, function() {
              var Ne = fe.facade;
              re ? je.emit("rejectionHandled", Ne) : sn("rejectionhandled", Ne, fe.value);
            });
          }, zt = function(fe, Ne, _e) {
            return function(Oe) {
              fe(Ne, Oe, _e);
            };
          }, ct = function(fe, Ne, _e) {
            fe.done || (fe.done = !0, _e && (fe = _e), fe.value = Ne, fe.state = 2, jt(fe, !0));
          }, An = function(fe, Ne, _e) {
            if (!fe.done) {
              fe.done = !0, _e && (fe = _e);
              try {
                if (fe.facade === Ne) throw he("Promise can't be resolved itself");
                var Oe = Bt(Ne);
                Oe ? $(function() {
                  var $e = { done: !1 };
                  try {
                    Oe.call(Ne, zt(An, $e, fe), zt(ct, $e, fe));
                  } catch (Ct) {
                    ct($e, Ct, fe);
                  }
                }) : (fe.value = Ne, fe.state = 1, jt(fe, !1));
              } catch ($e) {
                ct({ done: !1 }, $e, fe);
              }
            }
          };
          pn && (ce = function(fe) {
            E(this, ce, se), h(fe), u.call(this);
            var Ne = ve(this);
            try {
              fe(zt(An, Ne), zt(ct, Ne));
            } catch (_e) {
              ct(Ne, _e);
            }
          }, (u = function(fe) {
            Ae(this, { type: se, done: !1, notified: !1, parent: !1, reactions: [], rejection: !1, state: 0, value: void 0 });
          }).prototype = S(ce.prototype, { then: function(fe, Ne) {
            var _e = ye(this), Oe = Ve(I(this, ce));
            return Oe.ok = typeof fe != "function" || fe, Oe.fail = typeof Ne == "function" && Ne, Oe.domain = re ? je.domain : void 0, _e.parent = !0, _e.reactions.push(Oe), _e.state != 0 && jt(_e, !1), Oe.promise;
          }, catch: function(fe) {
            return this.then(void 0, fe);
          } }), v = function() {
            var fe = new u(), Ne = ve(fe);
            this.promise = fe, this.resolve = zt(An, Ne), this.reject = zt(ct, Ne);
          }, Y.f = Ve = function(fe) {
            return fe === ce || fe === C ? new v(fe) : qt(fe);
          }, x || typeof A != "function" || (p = A.prototype.then, f(A.prototype, "then", function(fe, Ne) {
            var _e = this;
            return new ce(function(Oe, $e) {
              p.call(_e, Oe, $e);
            }).then(fe, Ne);
          }, { unsafe: !0 }), typeof He == "function" && b({ global: !0, enumerable: !0, forced: !0 }, { fetch: function(fe) {
            return Q(ce, He.apply(g, arguments));
          } }))), b({ global: !0, wrap: !0, forced: pn }, { Promise: ce }), D(ce, se, !1, !0), k(se), C = _(se), b({ target: se, stat: !0, forced: pn }, { reject: function(fe) {
            var Ne = Ve(this);
            return Ne.reject.call(void 0, fe), Ne.promise;
          } }), b({ target: se, stat: !0, forced: x || pn }, { resolve: function(fe) {
            return Q(x && this === C ? ce : this, fe);
          } }), b({ target: se, stat: !0, forced: _r }, { all: function(fe) {
            var Ne = this, _e = Ve(Ne), Oe = _e.resolve, $e = _e.reject, Ct = X(function() {
              var nt = h(Ne.resolve), be = [], Te = 0, Ie = 1;
              O(fe, function(ze) {
                var it = Te++, dt = !1;
                be.push(void 0), Ie++, nt.call(Ne, ze).then(function(Vt) {
                  dt || (dt = !0, be[it] = Vt, --Ie || Oe(be));
                }, $e);
              }), --Ie || Oe(be);
            });
            return Ct.error && $e(Ct.value), _e.promise;
          }, race: function(fe) {
            var Ne = this, _e = Ve(Ne), Oe = _e.reject, $e = X(function() {
              var Ct = h(Ne.resolve);
              O(fe, function(nt) {
                Ct.call(Ne, nt).then(_e.resolve, Oe);
              });
            });
            return $e.error && Oe($e.value), _e.promise;
          } });
        }, function(m, d, r) {
          var u = r(84), v = r(66);
          m.exports = u ? {}.toString : function() {
            return "[object " + v(this) + "]";
          };
        }, function(m, d, r) {
          var u = r(9)("iterator"), v = !1;
          try {
            var C = 0, p = { next: function() {
              return { done: !!C++ };
            }, return: function() {
              v = !0;
            } };
            p[u] = function() {
              return this;
            }, Array.from(p, function() {
              throw 2;
            });
          } catch (b) {
          }
          m.exports = function(b, x) {
            if (!x && !v) return !1;
            var g = !1;
            try {
              var _ = {};
              _[u] = function() {
                return { next: function() {
                  return { done: g = !0 };
                } };
              }, b(_);
            } catch (A) {
            }
            return g;
          };
        }, function(m, d, r) {
          var u, v, C, p, b, x, g, _, A = r(8), f = r(74).f, S = r(111).set, D = r(112), k = r(170), L = r(63), h = A.MutationObserver || A.WebKitMutationObserver, E = A.document, w = A.process, O = A.Promise, R = f(A, "queueMicrotask"), I = R && R.value;
          I || (u = function() {
            var H, $;
            for (L && (H = w.domain) && H.exit(); v; ) {
              $ = v.fn, v = v.next;
              try {
                $();
              } catch (Q) {
                throw v ? p() : C = void 0, Q;
              }
            }
            C = void 0, H && H.enter();
          }, D || L || k || !h || !E ? O && O.resolve ? (g = O.resolve(void 0), _ = g.then, p = function() {
            _.call(g, u);
          }) : p = L ? function() {
            w.nextTick(u);
          } : function() {
            S.call(A, u);
          } : (b = !0, x = E.createTextNode(""), new h(u).observe(x, { characterData: !0 }), p = function() {
            x.data = b = !b;
          })), m.exports = I || function(H) {
            var $ = { fn: H, next: void 0 };
            C && (C.next = $), v || (v = $, p()), C = $;
          };
        }, function(m, d, r) {
          var u = r(65);
          m.exports = /web0s(?!.*chrome)/i.test(u);
        }, function(m, d, r) {
          var u = r(8);
          m.exports = function(v, C) {
            var p = u.console;
            p && p.error && (arguments.length === 1 ? p.error(v) : p.error(v, C));
          };
        }, function(m, d, r) {
          var u = r(8), v = r(109), C = u.WeakMap;
          m.exports = typeof C == "function" && /native code/.test(v(C));
        }, function(m, d, r) {
          var u = r(5), v = r(32), C = r(68), p = r(86), b = r(39);
          u({ target: "Promise", stat: !0 }, { allSettled: function(x) {
            var g = this, _ = C.f(g), A = _.resolve, f = _.reject, S = p(function() {
              var D = v(g.resolve), k = [], L = 0, h = 1;
              b(x, function(E) {
                var w = L++, O = !1;
                k.push(void 0), h++, D.call(g, E).then(function(R) {
                  O || (O = !0, k[w] = { status: "fulfilled", value: R }, --h || A(k));
                }, function(R) {
                  O || (O = !0, k[w] = { status: "rejected", reason: R }, --h || A(k));
                });
              }), --h || A(k);
            });
            return S.error && f(S.value), _.promise;
          } });
        }, function(m, d, r) {
          var u = r(5), v = r(32), C = r(28), p = r(68), b = r(86), x = r(39);
          u({ target: "Promise", stat: !0 }, { any: function(g) {
            var _ = this, A = p.f(_), f = A.resolve, S = A.reject, D = b(function() {
              var k = v(_.resolve), L = [], h = 0, E = 1, w = !1;
              x(g, function(O) {
                var R = h++, I = !1;
                L.push(void 0), E++, k.call(_, O).then(function(H) {
                  I || w || (w = !0, f(H));
                }, function(H) {
                  I || w || (I = !0, L[R] = H, --E || S(new (C("AggregateError"))(L, "No one promise resolved")));
                });
              }), --E || S(new (C("AggregateError"))(L, "No one promise resolved"));
            });
            return D.error && S(D.value), A.promise;
          } });
        }, function(m, d, r) {
          var u = r(5), v = r(37), C = r(106), p = r(11), b = r(28), x = r(110), g = r(113), _ = r(49);
          u({ target: "Promise", proto: !0, real: !0, forced: !!C && p(function() {
            C.prototype.finally.call({ then: function() {
            } }, function() {
            });
          }) }, { finally: function(A) {
            var f = x(this, b("Promise")), S = typeof A == "function";
            return this.then(S ? function(D) {
              return g(f, A()).then(function() {
                return D;
              });
            } : A, S ? function(D) {
              return g(f, A()).then(function() {
                throw D;
              });
            } : A);
          } }), v || typeof C != "function" || C.prototype.finally || _(C.prototype, "finally", b("Promise").prototype.finally);
        }, function(m, d, r) {
          var u = r(62), v = r(46), C = function(p) {
            return function(b, x) {
              var g, _, A = String(v(b)), f = u(x), S = A.length;
              return f < 0 || f >= S ? p ? "" : void 0 : (g = A.charCodeAt(f)) < 55296 || g > 56319 || f + 1 === S || (_ = A.charCodeAt(f + 1)) < 56320 || _ > 57343 ? p ? A.charAt(f) : g : p ? A.slice(f, f + 2) : _ - 56320 + (g - 55296 << 10) + 65536;
            };
          };
          m.exports = { codeAt: C(!1), charAt: C(!0) };
        }, function(m, d, r) {
          var u = r(114).IteratorPrototype, v = r(60), C = r(35), p = r(41), b = r(40), x = function() {
            return this;
          };
          m.exports = function(g, _, A) {
            var f = _ + " Iterator";
            return g.prototype = v(u, { next: C(1, A) }), p(g, f, !1, !0), b[f] = x, g;
          };
        }, function(m, d, r) {
          var u = r(27), v = r(88), C = r(40), p = r(42), b = r(87), x = p.set, g = p.getterFor("Array Iterator");
          m.exports = b(Array, "Array", function(_, A) {
            x(this, { type: "Array Iterator", target: u(_), index: 0, kind: A });
          }, function() {
            var _ = g(this), A = _.target, f = _.kind, S = _.index++;
            return !A || S >= A.length ? (_.target = void 0, { value: void 0, done: !0 }) : f == "keys" ? { value: S, done: !1 } : f == "values" ? { value: A[S], done: !1 } : { value: [S, A[S]], done: !1 };
          }, "values"), C.Arguments = C.Array, v("keys"), v("values"), v("entries");
        }, function(m, d) {
          m.exports = { CSSRuleList: 0, CSSStyleDeclaration: 0, CSSValueList: 0, ClientRectList: 0, DOMRectList: 0, DOMStringList: 0, DOMTokenList: 1, DataTransferItemList: 0, FileList: 0, HTMLAllCollection: 0, HTMLCollection: 0, HTMLFormElement: 0, HTMLSelectElement: 0, MediaList: 0, MimeTypeArray: 0, NamedNodeMap: 0, NodeList: 1, PaintRequestList: 0, Plugin: 0, PluginArray: 0, SVGLengthList: 0, SVGNumberList: 0, SVGPathSegList: 0, SVGPointList: 0, SVGStringList: 0, SVGTransformList: 0, SourceBufferList: 0, StyleSheetList: 0, TextTrackCueList: 0, TextTrackList: 0, TouchList: 0 };
        }, function(m, d, r) {
          r(50);
          var u = r(181), v = r(66), C = Array.prototype, p = { DOMTokenList: !0, NodeList: !0 };
          m.exports = function(b) {
            var x = b.forEach;
            return b === C || b instanceof Array && x === C.forEach || p.hasOwnProperty(v(b)) ? u : x;
          };
        }, function(m, d, r) {
          var u = r(182);
          m.exports = u;
        }, function(m, d, r) {
          r(183);
          var u = r(14);
          m.exports = u("Array").forEach;
        }, function(m, d, r) {
          var u = r(5), v = r(184);
          u({ target: "Array", proto: !0, forced: [].forEach != v }, { forEach: v });
        }, function(m, d, r) {
          var u = r(29).forEach, v = r(70)("forEach");
          m.exports = v ? [].forEach : function(C) {
            return u(this, C, arguments.length > 1 ? arguments[1] : void 0);
          };
        }, function(m, d, r) {
          var u = r(186);
          m.exports = u;
        }, function(m, d, r) {
          r(187);
          var u = r(12);
          m.exports = u.Array.isArray;
        }, function(m, d, r) {
          r(5)({ target: "Array", stat: !0 }, { isArray: r(51) });
        }, function(m, d, r) {
          var u = r(189);
          m.exports = u;
        }, function(m, d, r) {
          var u = r(190), v = Array.prototype;
          m.exports = function(C) {
            var p = C.map;
            return C === v || C instanceof Array && p === v.map ? u : p;
          };
        }, function(m, d, r) {
          r(191);
          var u = r(14);
          m.exports = u("Array").map;
        }, function(m, d, r) {
          var u = r(5), v = r(29).map;
          u({ target: "Array", proto: !0, forced: !r(52)("map") }, { map: function(C) {
            return v(this, C, arguments.length > 1 ? arguments[1] : void 0);
          } });
        }, function(m, d, r) {
          var u = r(193);
          m.exports = u;
        }, function(m, d, r) {
          var u = r(194), v = String.prototype;
          m.exports = function(C) {
            var p = C.trim;
            return typeof C == "string" || C === v || C instanceof String && p === v.trim ? u : p;
          };
        }, function(m, d, r) {
          r(195);
          var u = r(14);
          m.exports = u("String").trim;
        }, function(m, d, r) {
          var u = r(5), v = r(91).trim;
          u({ target: "String", proto: !0, forced: r(196)("trim") }, { trim: function() {
            return v(this);
          } });
        }, function(m, d, r) {
          var u = r(11), v = r(71);
          m.exports = function(C) {
            return u(function() {
              return !!v[C]() || "​᠎"[C]() != "​᠎" || v[C].name !== C;
            });
          };
        }, function(m, d, r) {
          var u = r(198);
          m.exports = u;
        }, function(m, d, r) {
          r(199), r(67), r(69), r(50);
          var u = r(12);
          m.exports = u.Map;
        }, function(m, d, r) {
          var u = r(117), v = r(119);
          m.exports = u("Map", function(C) {
            return function() {
              return C(this, arguments.length ? arguments[0] : void 0);
            };
          }, v);
        }, function(m, d, r) {
          var u = r(11);
          m.exports = !u(function() {
            return Object.isExtensible(Object.preventExtensions({}));
          });
        }, function(m, d, r) {
          var u = r(202);
          m.exports = u;
        }, function(m, d, r) {
          var u = r(203), v = Array.prototype;
          m.exports = function(C) {
            var p = C.indexOf;
            return C === v || C instanceof Array && p === v.indexOf ? u : p;
          };
        }, function(m, d, r) {
          r(204);
          var u = r(14);
          m.exports = u("Array").indexOf;
        }, function(m, d, r) {
          var u = r(5), v = r(80).indexOf, C = r(70), p = [].indexOf, b = !!p && 1 / [1].indexOf(1, -0) < 0, x = C("indexOf");
          u({ target: "Array", proto: !0, forced: b || !x }, { indexOf: function(g) {
            return b ? p.apply(this, arguments) || 0 : v(this, g, arguments.length > 1 ? arguments[1] : void 0);
          } });
        }, function(m, d, r) {
          var u = r(206);
          m.exports = u;
        }, function(m, d, r) {
          var u = r(207), v = Array.prototype;
          m.exports = function(C) {
            var p = C.splice;
            return C === v || C instanceof Array && p === v.splice ? u : p;
          };
        }, function(m, d, r) {
          r(208);
          var u = r(14);
          m.exports = u("Array").splice;
        }, function(m, d, r) {
          var u = r(5), v = r(81), C = r(62), p = r(38), b = r(36), x = r(89), g = r(93), _ = r(52)("splice"), A = Math.max, f = Math.min;
          u({ target: "Array", proto: !0, forced: !_ }, { splice: function(S, D) {
            var k, L, h, E, w, O, R = b(this), I = p(R.length), H = v(S, I), $ = arguments.length;
            if ($ === 0 ? k = L = 0 : $ === 1 ? (k = 0, L = I - H) : (k = $ - 2, L = f(A(C(D), 0), I - H)), I + k - L > 9007199254740991) throw TypeError("Maximum allowed length exceeded");
            for (h = x(R, L), E = 0; E < L; E++) (w = H + E) in R && g(h, E, R[w]);
            if (h.length = L, k < L) {
              for (E = H; E < I - L; E++) O = E + k, (w = E + L) in R ? R[O] = R[w] : delete R[O];
              for (E = I; E > I - L + k; E--) delete R[E - 1];
            } else if (k > L) for (E = I - L; E > H; E--) O = E + k - 1, (w = E + L - 1) in R ? R[O] = R[w] : delete R[O];
            for (E = 0; E < k; E++) R[E + H] = arguments[E + 2];
            return R.length = I - L + k, h;
          } });
        }, function(m, d, r) {
          var u = r(210);
          m.exports = u;
        }, function(m, d, r) {
          var u = r(211), v = Array.prototype;
          m.exports = function(C) {
            var p = C.filter;
            return C === v || C instanceof Array && p === v.filter ? u : p;
          };
        }, function(m, d, r) {
          r(212);
          var u = r(14);
          m.exports = u("Array").filter;
        }, function(m, d, r) {
          var u = r(5), v = r(29).filter;
          u({ target: "Array", proto: !0, forced: !r(52)("filter") }, { filter: function(C) {
            return v(this, C, arguments.length > 1 ? arguments[1] : void 0);
          } });
        }, function(m, d, r) {
          var u = r(214);
          m.exports = u;
        }, function(m, d, r) {
          var u = r(215), v = r(217), C = Array.prototype, p = String.prototype;
          m.exports = function(b) {
            var x = b.includes;
            return b === C || b instanceof Array && x === C.includes ? u : typeof b == "string" || b === p || b instanceof String && x === p.includes ? v : x;
          };
        }, function(m, d, r) {
          r(216);
          var u = r(14);
          m.exports = u("Array").includes;
        }, function(m, d, r) {
          var u = r(5), v = r(80).includes, C = r(88);
          u({ target: "Array", proto: !0 }, { includes: function(p) {
            return v(this, p, arguments.length > 1 ? arguments[1] : void 0);
          } }), C("includes");
        }, function(m, d, r) {
          r(218);
          var u = r(14);
          m.exports = u("String").includes;
        }, function(m, d, r) {
          var u = r(5), v = r(219), C = r(46);
          u({ target: "String", proto: !0, forced: !r(221)("includes") }, { includes: function(p) {
            return !!~String(C(this)).indexOf(v(p), arguments.length > 1 ? arguments[1] : void 0);
          } });
        }, function(m, d, r) {
          var u = r(220);
          m.exports = function(v) {
            if (u(v)) throw TypeError("The method doesn't accept regular expressions");
            return v;
          };
        }, function(m, d, r) {
          var u = r(13), v = r(45), C = r(9)("match");
          m.exports = function(p) {
            var b;
            return u(p) && ((b = p[C]) !== void 0 ? !!b : v(p) == "RegExp");
          };
        }, function(m, d, r) {
          var u = r(9)("match");
          m.exports = function(v) {
            var C = /./;
            try {
              "/./"[v](C);
            } catch (p) {
              try {
                return C[u] = !1, "/./"[v](C);
              } catch (b) {
              }
            }
            return !1;
          };
        }, function(m, d, r) {
          var u = r(223);
          m.exports = u;
        }, function(m, d, r) {
          var u = r(224), v = Function.prototype;
          m.exports = function(C) {
            var p = C.bind;
            return C === v || C instanceof Function && p === v.bind ? u : p;
          };
        }, function(m, d, r) {
          r(225);
          var u = r(14);
          m.exports = u("Function").bind;
        }, function(m, d, r) {
          r(5)({ target: "Function", proto: !0 }, { bind: r(226) });
        }, function(m, d, r) {
          var u = r(32), v = r(13), C = [].slice, p = {};
          m.exports = Function.bind || function(b) {
            var x = u(this), g = C.call(arguments, 1), _ = function() {
              var A = g.concat(C.call(arguments));
              return this instanceof _ ? function(f, S, D) {
                if (!(S in p)) {
                  for (var k = [], L = 0; L < S; L++) k[L] = "a[" + L + "]";
                  p[S] = Function("C,a", "return new C(" + k.join(",") + ")");
                }
                return p[S](f, D);
              }(x, A.length, A) : x.apply(b, A);
            };
            return v(x.prototype) && (_.prototype = x.prototype), _;
          };
        }, function(m, d, r) {
          m.exports = r(228);
        }, function(m, d, r) {
          var u = r(229);
          r(249), r(250), r(251), r(252), r(253), m.exports = u;
        }, function(m, d, r) {
          r(230), r(67), r(231), r(233), r(234), r(235), r(236), r(122), r(237), r(238), r(239), r(240), r(241), r(242), r(243), r(244), r(245), r(246), r(247), r(248);
          var u = r(12);
          m.exports = u.Symbol;
        }, function(m, d, r) {
          var u = r(5), v = r(11), C = r(51), p = r(13), b = r(36), x = r(38), g = r(93), _ = r(89), A = r(52), f = r(9), S = r(64), D = f("isConcatSpreadable"), k = S >= 51 || !v(function() {
            var E = [];
            return E[D] = !1, E.concat()[0] !== E;
          }), L = A("concat"), h = function(E) {
            if (!p(E)) return !1;
            var w = E[D];
            return w !== void 0 ? !!w : C(E);
          };
          u({ target: "Array", proto: !0, forced: !k || !L }, { concat: function(E) {
            var w, O, R, I, H, $ = b(this), Q = _($, 0), U = 0;
            for (w = -1, R = arguments.length; w < R; w++) if (H = w === -1 ? $ : arguments[w], h(H)) {
              if (U + (I = x(H.length)) > 9007199254740991) throw TypeError("Maximum allowed index exceeded");
              for (O = 0; O < I; O++, U++) O in H && g(Q, U, H[O]);
            } else {
              if (U >= 9007199254740991) throw TypeError("Maximum allowed index exceeded");
              g(Q, U++, H);
            }
            return Q.length = U, Q;
          } });
        }, function(m, d, r) {
          var u = r(5), v = r(8), C = r(28), p = r(37), b = r(15), x = r(83), g = r(105), _ = r(11), A = r(16), f = r(51), S = r(13), D = r(24), k = r(36), L = r(27), h = r(57), E = r(35), w = r(60), O = r(61), R = r(120), I = r(232), H = r(121), $ = r(74), Q = r(18), U = r(56), Y = r(17), X = r(49), G = r(78), J = r(58), ee = r(48), re = r(59), oe = r(9), ae = r(95), se = r(10), ve = r(41), Ae = r(42), ye = r(29).forEach, ce = J("hidden"), he = oe("toPrimitive"), ke = Ae.set, je = Ae.getterFor("Symbol"), He = Object.prototype, Ve = v.Symbol, qt = C("JSON", "stringify"), ln = $.f, Ft = Q.f, pn = I.f, _r = U.f, Bt = G("symbols"), jt = G("op-symbols"), sn = G("string-to-symbol-registry"), Zt = G("symbol-to-string-registry"), st = G("wks"), $t = v.QObject, zt = !$t || !$t.prototype || !$t.prototype.findChild, ct = b && _(function() {
            return w(Ft({}, "a", { get: function() {
              return Ft(this, "a", { value: 7 }).a;
            } })).a != 7;
          }) ? function(be, Te, Ie) {
            var ze = ln(He, Te);
            ze && delete He[Te], Ft(be, Te, Ie), ze && be !== He && Ft(He, Te, ze);
          } : Ft, An = function(be, Te) {
            var Ie = Bt[be] = w(Ve.prototype);
            return ke(Ie, { type: "Symbol", tag: be, description: Te }), b || (Ie.description = Te), Ie;
          }, fe = g ? function(be) {
            return typeof be == "symbol";
          } : function(be) {
            return Object(be) instanceof Ve;
          }, Ne = function(be, Te, Ie) {
            be === He && Ne(jt, Te, Ie), D(be);
            var ze = h(Te, !0);
            return D(Ie), A(Bt, ze) ? (Ie.enumerable ? (A(be, ce) && be[ce][ze] && (be[ce][ze] = !1), Ie = w(Ie, { enumerable: E(0, !1) })) : (A(be, ce) || Ft(be, ce, E(1, {})), be[ce][ze] = !0), ct(be, ze, Ie)) : Ft(be, ze, Ie);
          }, _e = function(be, Te) {
            D(be);
            var Ie = L(Te), ze = O(Ie).concat(nt(Ie));
            return ye(ze, function(it) {
              b && !Oe.call(Ie, it) || Ne(be, it, Ie[it]);
            }), be;
          }, Oe = function(be) {
            var Te = h(be, !0), Ie = _r.call(this, Te);
            return !(this === He && A(Bt, Te) && !A(jt, Te)) && (!(Ie || !A(this, Te) || !A(Bt, Te) || A(this, ce) && this[ce][Te]) || Ie);
          }, $e = function(be, Te) {
            var Ie = L(be), ze = h(Te, !0);
            if (Ie !== He || !A(Bt, ze) || A(jt, ze)) {
              var it = ln(Ie, ze);
              return !it || !A(Bt, ze) || A(Ie, ce) && Ie[ce][ze] || (it.enumerable = !0), it;
            }
          }, Ct = function(be) {
            var Te = pn(L(be)), Ie = [];
            return ye(Te, function(ze) {
              A(Bt, ze) || A(ee, ze) || Ie.push(ze);
            }), Ie;
          }, nt = function(be) {
            var Te = be === He, Ie = pn(Te ? jt : L(be)), ze = [];
            return ye(Ie, function(it) {
              !A(Bt, it) || Te && !A(He, it) || ze.push(Bt[it]);
            }), ze;
          };
          x || (X((Ve = function() {
            if (this instanceof Ve) throw TypeError("Symbol is not a constructor");
            var be = arguments.length && arguments[0] !== void 0 ? String(arguments[0]) : void 0, Te = re(be), Ie = function(ze) {
              this === He && Ie.call(jt, ze), A(this, ce) && A(this[ce], Te) && (this[ce][Te] = !1), ct(this, Te, E(1, ze));
            };
            return b && zt && ct(He, Te, { configurable: !0, set: Ie }), An(Te, be);
          }).prototype, "toString", function() {
            return je(this).tag;
          }), X(Ve, "withoutSetter", function(be) {
            return An(re(be), be);
          }), U.f = Oe, Q.f = Ne, $.f = $e, R.f = I.f = Ct, H.f = nt, ae.f = function(be) {
            return An(oe(be), be);
          }, b && (Ft(Ve.prototype, "description", { configurable: !0, get: function() {
            return je(this).description;
          } }), p || X(He, "propertyIsEnumerable", Oe, { unsafe: !0 }))), u({ global: !0, wrap: !0, forced: !x, sham: !x }, { Symbol: Ve }), ye(O(st), function(be) {
            se(be);
          }), u({ target: "Symbol", stat: !0, forced: !x }, { for: function(be) {
            var Te = String(be);
            if (A(sn, Te)) return sn[Te];
            var Ie = Ve(Te);
            return sn[Te] = Ie, Zt[Ie] = Te, Ie;
          }, keyFor: function(be) {
            if (!fe(be)) throw TypeError(be + " is not a symbol");
            if (A(Zt, be)) return Zt[be];
          }, useSetter: function() {
            zt = !0;
          }, useSimple: function() {
            zt = !1;
          } }), u({ target: "Object", stat: !0, forced: !x, sham: !b }, { create: function(be, Te) {
            return Te === void 0 ? w(be) : _e(w(be), Te);
          }, defineProperty: Ne, defineProperties: _e, getOwnPropertyDescriptor: $e }), u({ target: "Object", stat: !0, forced: !x }, { getOwnPropertyNames: Ct, getOwnPropertySymbols: nt }), u({ target: "Object", stat: !0, forced: _(function() {
            H.f(1);
          }) }, { getOwnPropertySymbols: function(be) {
            return H.f(k(be));
          } }), qt && u({ target: "JSON", stat: !0, forced: !x || _(function() {
            var be = Ve();
            return qt([be]) != "[null]" || qt({ a: be }) != "{}" || qt(Object(be)) != "{}";
          }) }, { stringify: function(be, Te, Ie) {
            for (var ze, it = [be], dt = 1; arguments.length > dt; ) it.push(arguments[dt++]);
            if (ze = Te, (S(Te) || be !== void 0) && !fe(be)) return f(Te) || (Te = function(Vt, Rn) {
              if (typeof ze == "function" && (Rn = ze.call(this, Vt, Rn)), !fe(Rn)) return Rn;
            }), it[1] = Te, qt.apply(null, it);
          } }), Ve.prototype[he] || Y(Ve.prototype, he, Ve.prototype.valueOf), ve(Ve, "Symbol"), ee[ce] = !0;
        }, function(m, d, r) {
          var u = r(27), v = r(120).f, C = {}.toString, p = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
          m.exports.f = function(b) {
            return p && C.call(b) == "[object Window]" ? function(x) {
              try {
                return v(x);
              } catch (g) {
                return p.slice();
              }
            }(b) : v(u(b));
          };
        }, function(m, d, r) {
          r(10)("asyncIterator");
        }, function(m, d) {
        }, function(m, d, r) {
          r(10)("hasInstance");
        }, function(m, d, r) {
          r(10)("isConcatSpreadable");
        }, function(m, d, r) {
          r(10)("match");
        }, function(m, d, r) {
          r(10)("matchAll");
        }, function(m, d, r) {
          r(10)("replace");
        }, function(m, d, r) {
          r(10)("search");
        }, function(m, d, r) {
          r(10)("species");
        }, function(m, d, r) {
          r(10)("split");
        }, function(m, d, r) {
          r(10)("toPrimitive");
        }, function(m, d, r) {
          r(10)("toStringTag");
        }, function(m, d, r) {
          r(10)("unscopables");
        }, function(m, d, r) {
          var u = r(8);
          r(41)(u.JSON, "JSON", !0);
        }, function(m, d) {
        }, function(m, d) {
        }, function(m, d, r) {
          r(10)("asyncDispose");
        }, function(m, d, r) {
          r(10)("dispose");
        }, function(m, d, r) {
          r(10)("observable");
        }, function(m, d, r) {
          r(10)("patternMatch");
        }, function(m, d, r) {
          r(10)("replaceAll");
        }, function(m, d, r) {
          m.exports = r(255);
        }, function(m, d, r) {
          var u = r(256);
          m.exports = u;
        }, function(m, d, r) {
          r(122), r(69), r(50);
          var u = r(95);
          m.exports = u.f("iterator");
        }, function(m, d, r) {
          m.exports = r(258);
        }, function(m, d, r) {
          var u = r(259);
          m.exports = u;
        }, function(m, d, r) {
          r(260);
          var u = r(12);
          m.exports = u.parseInt;
        }, function(m, d, r) {
          var u = r(5), v = r(261);
          u({ global: !0, forced: parseInt != v }, { parseInt: v });
        }, function(m, d, r) {
          var u = r(8), v = r(91).trim, C = r(71), p = u.parseInt, b = /^[+-]?0[Xx]/, x = p(C + "08") !== 8 || p(C + "0x16") !== 22;
          m.exports = x ? function(g, _) {
            var A = v(String(g));
            return p(A, _ >>> 0 || (b.test(A) ? 16 : 10));
          } : p;
        }, function(m, d, r) {
          var u = r(263);
          m.exports = u;
        }, function(m, d, r) {
          var u = r(264), v = Array.prototype;
          m.exports = function(C) {
            var p = C.slice;
            return C === v || C instanceof Array && p === v.slice ? u : p;
          };
        }, function(m, d, r) {
          r(265);
          var u = r(14);
          m.exports = u("Array").slice;
        }, function(m, d, r) {
          var u = r(5), v = r(13), C = r(51), p = r(81), b = r(38), x = r(27), g = r(93), _ = r(9), A = r(52)("slice"), f = _("species"), S = [].slice, D = Math.max;
          u({ target: "Array", proto: !0, forced: !A }, { slice: function(k, L) {
            var h, E, w, O = x(this), R = b(O.length), I = p(k, R), H = p(L === void 0 ? R : L, R);
            if (C(O) && (typeof (h = O.constructor) != "function" || h !== Array && !C(h.prototype) ? v(h) && (h = h[f]) === null && (h = void 0) : h = void 0, h === Array || h === void 0)) return S.call(O, I, H);
            for (E = new (h === void 0 ? Array : h)(D(H - I, 0)), w = 0; I < H; I++, w++) I in O && g(E, w, O[I]);
            return E.length = w, E;
          } });
        }, function(m, d, r) {
          r(267);
          var u = r(12);
          m.exports = u.setTimeout;
        }, function(m, d, r) {
          var u = r(5), v = r(8), C = r(65), p = [].slice, b = function(x) {
            return function(g, _) {
              var A = arguments.length > 2, f = A ? p.call(arguments, 2) : void 0;
              return x(A ? function() {
                (typeof g == "function" ? g : Function(g)).apply(this, f);
              } : g, _);
            };
          };
          u({ global: !0, bind: !0, forced: /MSIE .\./.test(C) }, { setTimeout: b(v.setTimeout), setInterval: b(v.setInterval) });
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(269));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2), b = p.__importDefault(r(274)), x = p.__importDefault(r(275)), g = p.__importDefault(r(123)), _ = p.__importDefault(r(276)), A = p.__importDefault(r(277)), f = p.__importDefault(r(278)), S = p.__importDefault(r(279)), D = p.__importDefault(r(280)), k = p.__importDefault(r(281)), L = p.__importDefault(r(282)), h = (0, C.default)({}, b.default, x.default, g.default, A.default, _.default, f.default, S.default, D.default, k.default, L.default, { linkCheck: function(E, w) {
            return !0;
          } });
          d.default = h;
        }, function(m, d, r) {
          m.exports = r(270);
        }, function(m, d, r) {
          var u = r(271);
          m.exports = u;
        }, function(m, d, r) {
          r(272);
          var u = r(12);
          m.exports = u.Object.assign;
        }, function(m, d, r) {
          var u = r(5), v = r(273);
          u({ target: "Object", stat: !0, forced: Object.assign !== v }, { assign: v });
        }, function(m, d, r) {
          var u = r(15), v = r(11), C = r(61), p = r(121), b = r(56), x = r(36), g = r(75), _ = Object.assign, A = Object.defineProperty;
          m.exports = !_ || v(function() {
            if (u && _({ b: 1 }, _(A({}, "a", { enumerable: !0, get: function() {
              A(this, "b", { value: 3, enumerable: !1 });
            } }), { b: 2 })).b !== 1) return !0;
            var f = {}, S = {}, D = Symbol();
            return f[D] = 7, "abcdefghijklmnopqrst".split("").forEach(function(k) {
              S[k] = k;
            }), _({}, f)[D] != 7 || C(_({}, S)).join("") != "abcdefghijklmnopqrst";
          }) ? function(f, S) {
            for (var D = x(f), k = arguments.length, L = 1, h = p.f, E = b.f; k > L; ) for (var w, O = g(arguments[L++]), R = h ? C(O).concat(h(O)) : C(O), I = R.length, H = 0; I > H; ) w = R[H++], u && !E.call(O, w) || (D[w] = O[w]);
            return D;
          } : _;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 }), d.default = { menus: ["head", "bold", "fontSize", "fontName", "italic", "underline", "strikeThrough", "indent", "lineHeight", "foreColor", "backColor", "link", "list", "todo", "justify", "quote", "emoticon", "image", "video", "table", "code", "splitLine", "undo", "redo"], fontNames: ["黑体", "仿宋", "楷体", "标楷体", "华文仿宋", "华文楷体", "宋体", "微软雅黑", "Arial", "Tahoma", "Verdana", "Times New Roman", "Courier New"], fontSizes: { "x-small": { name: "10px", value: "1" }, small: { name: "13px", value: "2" }, normal: { name: "16px", value: "3" }, large: { name: "18px", value: "4" }, "x-large": { name: "24px", value: "5" }, "xx-large": { name: "32px", value: "6" }, "xxx-large": { name: "48px", value: "7" } }, colors: ["#000000", "#ffffff", "#eeece0", "#1c487f", "#4d80bf", "#c24f4a", "#8baa4a", "#7b5ba1", "#46acc8", "#f9963b"], languageType: ["Bash", "C", "C#", "C++", "CSS", "Java", "JavaScript", "JSON", "TypeScript", "Plain text", "Html", "XML", "SQL", "Go", "Kotlin", "Lua", "Markdown", "PHP", "Python", "Shell Session", "Ruby"], languageTab: "　　　　", emotions: [{ title: "表情", type: "emoji", content: "😀 😃 😄 😁 😆 😅 😂 🤣 😊 😇 🙂 🙃 😉 😌 😍 😘 😗 😙 😚 😋 😛 😝 😜 🤓 😎 😏 😒 😞 😔 😟 😕 🙁 😣 😖 😫 😩 😢 😭 😤 😠 😡 😳 😱 😨 🤗 🤔 😶 😑 😬 🙄 😯 😴 😷 🤑 😈 🤡 💩 👻 💀 👀 👣".split(/\s/) }, { title: "手势", type: "emoji", content: "👐 🙌 👏 🤝 👍 👎 👊 ✊ 🤛 🤜 🤞 ✌️ 🤘 👌 👈 👉 👆 👇 ☝️ ✋ 🤚 🖐 🖖 👋 🤙 💪 🖕 ✍️ 🙏".split(/\s/) }], lineHeights: ["1", "1.15", "1.6", "2", "2.5", "3"], undoLimit: 20, indentation: "2em", showMenuTooltips: !0, menuTooltipPosition: "up" };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(7);
          d.default = { onchangeTimeout: 200, onchange: null, onfocus: u.EMPTY_FN, onblur: u.EMPTY_FN, onCatalogChange: null, customAlert: function(v, C, p) {
            window.alert(v), p && console.error("wangEditor: " + p);
          } };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 }), d.default = { pasteFilterStyle: !0, pasteIgnoreImg: !1, pasteTextHandle: function(u) {
            return u;
          } };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 }), d.default = { styleWithCSS: !1 };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(7);
          d.default = { linkImgCheck: function(v, C, p) {
            return !0;
          }, showLinkImg: !0, showLinkImgAlt: !0, showLinkImgHref: !0, linkImgCallback: u.EMPTY_FN, uploadImgAccept: ["jpg", "jpeg", "png", "gif", "bmp"], uploadImgServer: "", uploadImgShowBase64: !1, uploadImgMaxSize: 5242880, uploadImgMaxLength: 100, uploadFileName: "", uploadImgParams: {}, uploadImgParamsWithUrl: !1, uploadImgHeaders: {}, uploadImgHooks: {}, uploadImgTimeout: 1e4, withCredentials: !1, customUploadImg: null };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 }), d.default = { focus: !0, height: 300, placeholder: "请输入正文", zIndexFullScreen: 10002, showFullScreen: !0 };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 }), d.default = { lang: "zh-CN", languages: { "zh-CN": { wangEditor: { 重置: "重置", 插入: "插入", 默认: "默认", 创建: "创建", 修改: "修改", 如: "如", 请输入正文: "请输入正文", menus: { title: { 标题: "标题", 加粗: "加粗", 字号: "字号", 字体: "字体", 斜体: "斜体", 下划线: "下划线", 删除线: "删除线", 缩进: "缩进", 行高: "行高", 文字颜色: "文字颜色", 背景色: "背景色", 链接: "链接", 序列: "序列", 对齐: "对齐", 引用: "引用", 表情: "表情", 图片: "图片", 视频: "视频", 表格: "表格", 代码: "代码", 分割线: "分割线", 恢复: "恢复", 撤销: "撤销", 全屏: "全屏", 取消全屏: "取消全屏", 待办事项: "待办事项" }, dropListMenu: { 设置标题: "设置标题", 背景颜色: "背景颜色", 文字颜色: "文字颜色", 设置字号: "设置字号", 设置字体: "设置字体", 设置缩进: "设置缩进", 对齐方式: "对齐方式", 设置行高: "设置行高", 序列: "序列", head: { 正文: "正文" }, indent: { 增加缩进: "增加缩进", 减少缩进: "减少缩进" }, justify: { 靠左: "靠左", 居中: "居中", 靠右: "靠右", 两端: "两端" }, list: { 无序列表: "无序列表", 有序列表: "有序列表" } }, panelMenus: { emoticon: { 默认: "默认", 新浪: "新浪", emoji: "emoji", 手势: "手势" }, image: { 上传图片: "上传图片", 网络图片: "网络图片", 图片地址: "图片地址", 图片文字说明: "图片文字说明", 跳转链接: "跳转链接" }, link: { 链接: "链接", 链接文字: "链接文字", 取消链接: "取消链接", 查看链接: "查看链接" }, video: { 插入视频: "插入视频", 上传视频: "上传视频" }, table: { 行: "行", 列: "列", 的: "的", 表格: "表格", 添加行: "添加行", 删除行: "删除行", 添加列: "添加列", 删除列: "删除列", 设置表头: "设置表头", 取消表头: "取消表头", 插入表格: "插入表格", 删除表格: "删除表格" }, code: { 删除代码: "删除代码", 修改代码: "修改代码", 插入代码: "插入代码" } } }, validate: { 张图片: "张图片", 大于: "大于", 图片链接: "图片链接", 不是图片: "不是图片", 返回结果: "返回结果", 上传图片超时: "上传图片超时", 上传图片错误: "上传图片错误", 上传图片失败: "上传图片失败", 插入图片错误: "插入图片错误", 一次最多上传: "一次最多上传", 下载链接失败: "下载链接失败", 图片验证未通过: "图片验证未通过", 服务器返回状态: "服务器返回状态", 上传图片返回结果错误: "上传图片返回结果错误", 请替换为支持的图片类型: "请替换为支持的图片类型", 您插入的网络图片无法识别: "您插入的网络图片无法识别", 您刚才插入的图片链接未通过编辑器校验: "您刚才插入的图片链接未通过编辑器校验", 插入视频错误: "插入视频错误", 视频链接: "视频链接", 不是视频: "不是视频", 视频验证未通过: "视频验证未通过", 个视频: "个视频", 上传视频超时: "上传视频超时", 上传视频错误: "上传视频错误", 上传视频失败: "上传视频失败", 上传视频返回结果错误: "上传视频返回结果错误" } } }, en: { wangEditor: { 重置: "reset", 插入: "insert", 默认: "default", 创建: "create", 修改: "edit", 如: "like", 请输入正文: "please enter the text", menus: { title: { 标题: "head", 加粗: "bold", 字号: "font size", 字体: "font family", 斜体: "italic", 下划线: "underline", 删除线: "strikethrough", 缩进: "indent", 行高: "line heihgt", 文字颜色: "font color", 背景色: "background", 链接: "link", 序列: "numbered list", 对齐: "align", 引用: "quote", 表情: "emoticons", 图片: "image", 视频: "media", 表格: "table", 代码: "code", 分割线: "split line", 恢复: "undo", 撤销: "redo", 全屏: "fullscreen", 取消全屏: "cancel fullscreen", 待办事项: "todo" }, dropListMenu: { 设置标题: "title", 背景颜色: "background", 文字颜色: "font color", 设置字号: "font size", 设置字体: "font family", 设置缩进: "indent", 对齐方式: "align", 设置行高: "line heihgt", 序列: "list", head: { 正文: "text" }, indent: { 增加缩进: "indent", 减少缩进: "outdent" }, justify: { 靠左: "left", 居中: "center", 靠右: "right", 两端: "justify" }, list: { 无序列表: "unordered", 有序列表: "ordered" } }, panelMenus: { emoticon: { 表情: "emoji", 手势: "gesture" }, image: { 上传图片: "upload image", 网络图片: "network image", 图片地址: "image link", 图片文字说明: "image alt", 跳转链接: "hyperlink" }, link: { 链接: "link", 链接文字: "link text", 取消链接: "unlink", 查看链接: "view links" }, video: { 插入视频: "insert video", 上传视频: "upload local video" }, table: { 行: "rows", 列: "columns", 的: " ", 表格: "table", 添加行: "insert row", 删除行: "delete row", 添加列: "insert column", 删除列: "delete column", 设置表头: "set header", 取消表头: "cancel header", 插入表格: "insert table", 删除表格: "delete table" }, code: { 删除代码: "delete code", 修改代码: "edit code", 插入代码: "insert code" } } }, validate: { 张图片: "images", 大于: "greater than", 图片链接: "image link", 不是图片: "is not image", 返回结果: "return results", 上传图片超时: "upload image timeout", 上传图片错误: "upload image error", 上传图片失败: "upload image failed", 插入图片错误: "insert image error", 一次最多上传: "once most at upload", 下载链接失败: "download link failed", 图片验证未通过: "image validate failed", 服务器返回状态: "server return status", 上传图片返回结果错误: "upload image return results error", 请替换为支持的图片类型: "please replace with a supported image type", 您插入的网络图片无法识别: "the network picture you inserted is not recognized", 您刚才插入的图片链接未通过编辑器校验: "the image link you just inserted did not pass the editor verification", 插入视频错误: "insert video error", 视频链接: "video link", 不是视频: "is not video", 视频验证未通过: "video validate failed", 个视频: "videos", 上传视频超时: "upload video timeout", 上传视频错误: "upload video error", 上传视频失败: "upload video failed", 上传视频返回结果错误: "upload video return results error" } } } } };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(6);
          d.default = { compatibleMode: function() {
            return !(!u.UA.isIE() && !u.UA.isOldEdge);
          }, historyMaxSize: 30 };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(7);
          d.default = { onlineVideoCheck: function(v) {
            return !0;
          }, onlineVideoCallback: u.EMPTY_FN, showLinkVideo: !0, uploadVideoAccept: ["mp4"], uploadVideoServer: "", uploadVideoMaxSize: 1073741824, uploadVideoName: "", uploadVideoParams: {}, uploadVideoParamsWithUrl: !1, uploadVideoHeaders: {}, uploadVideoHooks: {}, uploadVideoTimeout: 72e5, withVideoCredentials: !1, customUploadVideo: null, customInsertVideo: null };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(19));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2).__importDefault(r(3)), b = r(6), x = r(7), g = function() {
            function _(A) {
              this._currentRange = null, this.editor = A;
            }
            return _.prototype.getRange = function() {
              return this._currentRange;
            }, _.prototype.saveRange = function(A) {
              if (A) this._currentRange = A;
              else {
                var f = window.getSelection();
                if (f.rangeCount !== 0) {
                  var S = f.getRangeAt(0), D = this.getSelectionContainerElem(S);
                  if (D != null && D.length && D.attr("contenteditable") !== "false" && !D.parentUntil("[contenteditable=false]")) {
                    var k = this.editor, L = k.$textElem;
                    if (L.isContain(D)) {
                      var h;
                      if (L.elems[0] === D.elems[0] && (0, C.default)(h = L.html()).call(h) === x.EMPTY_P) {
                        var E = L.children(), w = E == null ? void 0 : E.last();
                        k.selection.createRangeByElem(w, !0, !0), k.selection.restoreSelection();
                      }
                      this._currentRange = S;
                    }
                  }
                }
              }
            }, _.prototype.collapseRange = function(A) {
              A === void 0 && (A = !1);
              var f = this._currentRange;
              f && f.collapse(A);
            }, _.prototype.getSelectionText = function() {
              var A = this._currentRange;
              return A ? A.toString() : "";
            }, _.prototype.getSelectionContainerElem = function(A) {
              var f, S;
              if (f = A || this._currentRange) return S = f.commonAncestorContainer, p.default(S.nodeType === 1 ? S : S.parentNode);
            }, _.prototype.getSelectionStartElem = function(A) {
              var f, S;
              if (f = A || this._currentRange) return S = f.startContainer, p.default(S.nodeType === 1 ? S : S.parentNode);
            }, _.prototype.getSelectionEndElem = function(A) {
              var f, S;
              if (f = A || this._currentRange) return S = f.endContainer, p.default(S.nodeType === 1 ? S : S.parentNode);
            }, _.prototype.isSelectionEmpty = function() {
              var A = this._currentRange;
              return !(!A || !A.startContainer || A.startContainer !== A.endContainer || A.startOffset !== A.endOffset);
            }, _.prototype.restoreSelection = function() {
              var A = window.getSelection(), f = this._currentRange;
              A && f && (A.removeAllRanges(), A.addRange(f));
            }, _.prototype.createEmptyRange = function() {
              var A, f = this.editor, S = this.getRange();
              if (S && this.isSelectionEmpty()) try {
                b.UA.isWebkit() ? (f.cmd.do("insertHTML", "&#8203;"), S.setEnd(S.endContainer, S.endOffset + 1), this.saveRange(S)) : (A = p.default("<strong>&#8203;</strong>"), f.cmd.do("insertElem", A), this.createRangeByElem(A, !0));
              } catch (D) {
              }
            }, _.prototype.createRangeByElems = function(A, f) {
              var S = window.getSelection ? window.getSelection() : document.getSelection();
              S == null || S.removeAllRanges();
              var D = document.createRange();
              D.setStart(A, 0), D.setEnd(f, f.childNodes.length || 1), this.saveRange(D), this.restoreSelection();
            }, _.prototype.createRangeByElem = function(A, f, S) {
              if (A.length) {
                var D = A.elems[0], k = document.createRange();
                S ? k.selectNodeContents(D) : k.selectNode(D), f != null && (k.collapse(f), f || (this.saveRange(k), this.editor.selection.moveCursor(D))), this.saveRange(k);
              }
            }, _.prototype.getSelectionRangeTopNodes = function() {
              var A, f, S = (A = this.getSelectionStartElem()) === null || A === void 0 ? void 0 : A.getNodeTop(this.editor), D = (f = this.getSelectionEndElem()) === null || f === void 0 ? void 0 : f.getNodeTop(this.editor);
              return this.recordSelectionNodes(p.default(S), p.default(D));
            }, _.prototype.moveCursor = function(A, f) {
              var S, D = this.getRange(), k = A.nodeType === 3 ? (S = A.nodeValue) === null || S === void 0 ? void 0 : S.length : A.childNodes.length;
              (b.UA.isFirefox || b.UA.isIE()) && k !== 0 && (A.nodeType !== 3 && A.childNodes[k - 1].nodeName !== "BR" || (k -= 1));
              var L = f != null ? f : k;
              D && A && (D.setStart(A, L), D.setEnd(A, L), this.restoreSelection());
            }, _.prototype.getCursorPos = function() {
              var A = window.getSelection();
              return A == null ? void 0 : A.anchorOffset;
            }, _.prototype.clearWindowSelectionRange = function() {
              var A = window.getSelection();
              A && A.removeAllRanges();
            }, _.prototype.recordSelectionNodes = function(A, f) {
              for (var S = [], D = A, k = this.editor.$textElem, L = !0; L; ) {
                var h = D == null ? void 0 : D.getNodeTop(this.editor);
                h.getNodeName() === "BODY" && (L = !1), h.length > 0 && (S.push(p.default(D)), f != null && f.equal(h) || k.equal(h) ? L = !1 : D = h.getNextSibling());
              }
              return S;
            }, _.prototype.setRangeToContainerElem = function(A) {
              var f = this.getRange();
              f == null || f.setStart(A, 0), f == null || f.setEnd(A, 0);
            }, _;
          }();
          d.default = g;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2).__importDefault(r(3)), v = function() {
            function C(p) {
              this.editor = p;
            }
            return C.prototype.do = function(p, b) {
              var x = this.editor;
              x.config.styleWithCSS && document.execCommand("styleWithCSS", !1, "true");
              var g = x.selection;
              if (g.getRange()) {
                switch (g.restoreSelection(), p) {
                  case "insertHTML":
                    this.insertHTML(b);
                    break;
                  case "insertElem":
                    this.insertElem(b);
                    break;
                  default:
                    this.execCommand(p, b);
                }
                x.menus.changeActive(), g.saveRange(), g.restoreSelection();
              }
            }, C.prototype.insertHTML = function(p) {
              var b = this.editor, x = b.selection.getRange();
              if (x != null) {
                if (this.queryCommandSupported("insertHTML")) this.execCommand("insertHTML", p);
                else if (x.insertNode) {
                  if (x.deleteContents(), u.default(p).elems.length > 0) x.insertNode(u.default(p).elems[0]);
                  else {
                    var g = document.createElement("p");
                    g.appendChild(document.createTextNode(p)), x.insertNode(g);
                  }
                  b.selection.collapseRange();
                }
              }
            }, C.prototype.insertElem = function(p) {
              var b = this.editor.selection.getRange();
              b != null && b.insertNode && (b.deleteContents(), b.insertNode(p.elems[0]));
            }, C.prototype.execCommand = function(p, b) {
              document.execCommand(p, !1, b);
            }, C.prototype.queryCommandValue = function(p) {
              return document.queryCommandValue(p);
            }, C.prototype.queryCommandState = function(p) {
              return document.queryCommandState(p);
            }, C.prototype.queryCommandSupported = function(p) {
              return document.queryCommandSupported(p);
            }, C;
          }();
          d.default = v;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(30)), p = u(r(4)), b = u(r(19)), x = u(r(26));
          (0, v.default)(d, "__esModule", { value: !0 });
          var g = r(2), _ = g.__importDefault(r(3)), A = g.__importDefault(r(290)), f = r(6), S = g.__importDefault(r(302)), D = g.__importDefault(r(303)), k = r(7), L = function() {
            function h(E) {
              this.editor = E, this.eventHooks = { onBlurEvents: [], changeEvents: [], dropEvents: [], clickEvents: [], keydownEvents: [], keyupEvents: [], tabUpEvents: [], tabDownEvents: [], enterUpEvents: [], enterDownEvents: [], deleteUpEvents: [], deleteDownEvents: [], pasteEvents: [], linkClickEvents: [], codeClickEvents: [], textScrollEvents: [], toolbarClickEvents: [], imgClickEvents: [], imgDragBarMouseDownEvents: [], tableClickEvents: [], menuClickEvents: [], dropListMenuHoverEvents: [], splitLineEvents: [], videoClickEvents: [] };
            }
            return h.prototype.init = function() {
              this._saveRange(), this._bindEventHooks(), A.default(this);
            }, h.prototype.togglePlaceholder = function() {
              var E, w = this.html(), O = (0, C.default)(E = this.editor.$textContainerElem).call(E, ".placeholder");
              O.hide(), w && w !== " " || O.show();
            }, h.prototype.clear = function() {
              this.html(k.EMPTY_P);
            }, h.prototype.html = function(E) {
              var w = this.editor, O = w.$textElem;
              if (E == null) {
                var R = O.html(), I = (R = (R = (R = (R = R.replace(/\u200b/gm, "")).replace(/<p><\/p>/gim, "")).replace(k.EMPTY_P_LAST_REGEX, "")).replace(k.EMPTY_P_REGEX, "<p>")).match(/<(img|br|hr|input)[^>]*>/gi);
                return I !== null && (0, p.default)(I).call(I, function(H) {
                  H.match(/\/>/) || (R = R.replace(H, H.substring(0, H.length - 1) + "/>"));
                }), R;
              }
              (E = (0, b.default)(E).call(E)) === "" && (E = k.EMPTY_P), (0, x.default)(E).call(E, "<") !== 0 && (E = "<p>" + E + "</p>"), E = E.replace(/\s+</g, "<"), O.html(E), w.initSelection();
            }, h.prototype.setJSON = function(E) {
              var w = D.default(E).children(), O = this.editor.$textElem;
              w && O.replaceChildAll(w);
            }, h.prototype.getJSON = function() {
              var E = this.editor.$textElem;
              return S.default(E);
            }, h.prototype.text = function(E) {
              var w = this.editor, O = w.$textElem;
              if (E == null) {
                var R = O.text();
                return R = R.replace(/\u200b/gm, "");
              }
              O.text("<p>" + E + "</p>"), w.initSelection();
            }, h.prototype.append = function(E) {
              var w = this.editor;
              (0, x.default)(E).call(E, "<") !== 0 && (E = "<p>" + E + "</p>"), this.html(this.html() + E), w.initSelection();
            }, h.prototype._saveRange = function() {
              var E = this.editor, w = E.$textElem, O = _.default(document);
              function R() {
                E.selection.saveRange(), E.menus.changeActive();
              }
              function I() {
                R(), O.off("mouseup", I);
              }
              function H() {
                O.on("mouseup", I), w.off("mouseleave", H);
              }
              w.on("keyup", R), w.on("click", function $() {
                R(), w.off("click", $);
              }), w.on("mousedown", function() {
                w.on("mouseleave", H);
              }), w.on("mouseup", function($) {
                w.off("mouseleave", H), E.selection.getRange() !== null && R();
              });
            }, h.prototype._bindEventHooks = function() {
              var E = this.editor, w = E.$textElem, O = this.eventHooks;
              function R(I) {
                I.preventDefault();
              }
              w.on("click", function(I) {
                var H = O.clickEvents;
                (0, p.default)(H).call(H, function($) {
                  return $(I);
                });
              }), w.on("keyup", function(I) {
                if (I.keyCode === 13) {
                  var H = O.enterUpEvents;
                  (0, p.default)(H).call(H, function($) {
                    return $(I);
                  });
                }
              }), w.on("keyup", function(I) {
                var H = O.keyupEvents;
                (0, p.default)(H).call(H, function($) {
                  return $(I);
                });
              }), w.on("keydown", function(I) {
                var H = O.keydownEvents;
                (0, p.default)(H).call(H, function($) {
                  return $(I);
                });
              }), w.on("keyup", function(I) {
                if (I.keyCode === 8) {
                  var H = O.deleteUpEvents;
                  (0, p.default)(H).call(H, function($) {
                    return $(I);
                  });
                }
              }), w.on("keydown", function(I) {
                if (I.keyCode === 8) {
                  var H = O.deleteDownEvents;
                  (0, p.default)(H).call(H, function($) {
                    return $(I);
                  });
                }
              }), w.on("paste", function(I) {
                if (!f.UA.isIE()) {
                  I.preventDefault();
                  var H = O.pasteEvents;
                  (0, p.default)(H).call(H, function($) {
                    return $(I);
                  });
                }
              }), w.on("keydown", function(I) {
                (E.isFocus || E.isCompatibleMode) && (I.ctrlKey || I.metaKey) && I.keyCode === 90 && (I.preventDefault(), I.shiftKey ? E.history.restore() : E.history.revoke());
              }), w.on("keyup", function(I) {
                if (I.keyCode === 9) {
                  I.preventDefault();
                  var H = O.tabUpEvents;
                  (0, p.default)(H).call(H, function($) {
                    return $(I);
                  });
                }
              }), w.on("keydown", function(I) {
                if (I.keyCode === 9) {
                  I.preventDefault();
                  var H = O.tabDownEvents;
                  (0, p.default)(H).call(H, function($) {
                    return $(I);
                  });
                }
              }), w.on("scroll", f.throttle(function(I) {
                var H = O.textScrollEvents;
                (0, p.default)(H).call(H, function($) {
                  return $(I);
                });
              }, 100)), _.default(document).on("dragleave", R).on("drop", R).on("dragenter", R).on("dragover", R), E.beforeDestroy(function() {
                _.default(document).off("dragleave", R).off("drop", R).off("dragenter", R).off("dragover", R);
              }), w.on("drop", function(I) {
                I.preventDefault();
                var H = O.dropEvents;
                (0, p.default)(H).call(H, function($) {
                  return $(I);
                });
              }), w.on("click", function(I) {
                var H = null, $ = I.target, Q = _.default($);
                if (Q.getNodeName() === "A") H = Q;
                else {
                  var U = Q.parentUntil("a");
                  U != null && (H = U);
                }
                if (H) {
                  var Y = O.linkClickEvents;
                  (0, p.default)(Y).call(Y, function(X) {
                    return X(H);
                  });
                }
              }), w.on("click", function(I) {
                var H = null, $ = I.target, Q = _.default($);
                if (Q.getNodeName() !== "IMG" || Q.elems[0].getAttribute("data-emoji") || (I.stopPropagation(), H = Q), H) {
                  var U = O.imgClickEvents;
                  (0, p.default)(U).call(U, function(Y) {
                    return Y(H);
                  });
                }
              }), w.on("click", function(I) {
                var H = null, $ = I.target, Q = _.default($);
                if (Q.getNodeName() === "PRE") H = Q;
                else {
                  var U = Q.parentUntil("pre");
                  U !== null && (H = U);
                }
                if (H) {
                  var Y = O.codeClickEvents;
                  (0, p.default)(Y).call(Y, function(X) {
                    return X(H);
                  });
                }
              }), w.on("click", function(I) {
                var H = null, $ = I.target, Q = _.default($);
                if (Q.getNodeName() === "HR" && (H = Q), H) {
                  E.selection.createRangeByElem(H), E.selection.restoreSelection();
                  var U = O.splitLineEvents;
                  (0, p.default)(U).call(U, function(Y) {
                    return Y(H);
                  });
                }
              }), E.$toolbarElem.on("click", function(I) {
                var H = O.toolbarClickEvents;
                (0, p.default)(H).call(H, function($) {
                  return $(I);
                });
              }), E.$textContainerElem.on("mousedown", function(I) {
                var H = I.target;
                if (_.default(H).hasClass("w-e-img-drag-rb")) {
                  var $ = O.imgDragBarMouseDownEvents;
                  (0, p.default)($).call($, function(Q) {
                    return Q();
                  });
                }
              }), w.on("click", function(I) {
                var H, $ = I.target;
                if (H = _.default($).parentUntilEditor("TABLE", E, $)) {
                  var Q = O.tableClickEvents;
                  (0, p.default)(Q).call(Q, function(U) {
                    return U(H);
                  });
                }
              }), w.on("keydown", function(I) {
                if (I.keyCode === 13) {
                  var H = O.enterDownEvents;
                  (0, p.default)(H).call(H, function($) {
                    return $(I);
                  });
                }
              }), w.on("click", function(I) {
                var H = null, $ = I.target, Q = _.default($);
                if (Q.getNodeName() === "VIDEO" && (I.stopPropagation(), H = Q), H) {
                  var U = O.videoClickEvents;
                  (0, p.default)(U).call(U, function(Y) {
                    return Y(H);
                  });
                }
              });
            }, h;
          }();
          d.default = L;
        }, function(m, d, r) {
          var u = r(287);
          m.exports = u;
        }, function(m, d, r) {
          var u = r(288), v = Array.prototype;
          m.exports = function(C) {
            var p = C.find;
            return C === v || C instanceof Array && p === v.find ? u : p;
          };
        }, function(m, d, r) {
          r(289);
          var u = r(14);
          m.exports = u("Array").find;
        }, function(m, d, r) {
          var u = r(5), v = r(29).find, C = r(88), p = !0;
          "find" in [] && Array(1).find(function() {
            p = !1;
          }), u({ target: "Array", proto: !0, forced: p }, { find: function(b) {
            return v(this, b, arguments.length > 1 ? arguments[1] : void 0);
          } }), C("find");
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(291)), C = u.__importDefault(r(292)), p = u.__importDefault(r(293)), b = u.__importDefault(r(294)), x = u.__importDefault(r(301));
          d.default = function(g) {
            var _ = g.editor, A = g.eventHooks;
            v.default(_, A.enterUpEvents, A.enterDownEvents), C.default(_, A.deleteUpEvents, A.deleteDownEvents), p.default(_, A.tabDownEvents), b.default(_, A.pasteEvents), x.default(_, A.imgClickEvents);
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(26));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2).__importDefault(r(3));
          d.default = function(b, x, g) {
            function _(A) {
              var f, S = p.default("<p><br></p>");
              S.insertBefore(A), (0, C.default)(f = A.html()).call(f, "<img") >= 0 ? S.remove() : (b.selection.createRangeByElem(S, !0, !0), b.selection.restoreSelection(), A.remove());
            }
            x.push(function() {
              var A = b.$textElem, f = b.selection.getSelectionContainerElem(), S = f.parent();
              S.html() !== "<code><br></code>" ? S.equal(A) && (f.getNodeName() === "P" && f.attr("data-we-empty-p") === null || f.text() || _(f)) : _(f);
            }), g.push(function(A) {
              var f;
              b.selection.saveRange((f = getSelection()) === null || f === void 0 ? void 0 : f.getRangeAt(0)), b.selection.getSelectionContainerElem().id === b.textElemId && (A.preventDefault(), b.cmd.do("insertHTML", "<p><br></p>"));
            });
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(19));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2), b = r(7), x = p.__importDefault(r(3));
          d.default = function(g, _, A) {
            _.push(function() {
              var f, S = g.$textElem, D = (0, C.default)(f = S.html().toLowerCase()).call(f);
              if (!D || D === "<br>") {
                var k = x.default(b.EMPTY_P);
                S.html(" "), S.append(k), g.selection.createRangeByElem(k, !1, !0), g.selection.restoreSelection(), g.selection.moveCursor(k.getNode(), 0);
              }
            }), A.push(function(f) {
              var S, D = g.$textElem;
              (0, C.default)(S = D.html().toLowerCase()).call(S) !== b.EMPTY_P || f.preventDefault();
            });
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 }), d.default = function(u, v) {
            v.push(function() {
              if (u.cmd.queryCommandSupported("insertHTML")) {
                var C = u.selection.getSelectionContainerElem();
                if (C) {
                  var p = C.parent(), b = C.getNodeName(), x = p.getNodeName();
                  b == "CODE" || x === "CODE" || x === "PRE" || /hljs/.test(x) ? u.cmd.do("insertHTML", u.config.languageTab) : u.cmd.do("insertHTML", "&nbsp;&nbsp;&nbsp;&nbsp;");
                }
              }
            });
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(19));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(124), b = r(6), x = r(7);
          function g(_) {
            var A = _;
            return A = (A = A.replace(/<div>/gim, "<p>").replace(/<\/div>/gim, "</p>")).replace(/<p><\/p>/gim, "<p><br></p>"), (0, C.default)(A).call(A);
          }
          d.default = function(_, A) {
            A.push(function(f) {
              var S = _.config, D = S.pasteFilterStyle, k = S.pasteIgnoreImg, L = S.pasteTextHandle, h = p.getPasteHtml(f, D, k), E = p.getPasteText(f);
              E = E.replace(/\n/gm, "<br>");
              var w = _.selection.getSelectionContainerElem();
              if (w) {
                var O, R = w == null ? void 0 : w.getNodeName(), I = w == null ? void 0 : w.getNodeTop(_), H = "";
                if (I.elems[0] && (H = I == null ? void 0 : I.getNodeName()), R === "CODE" || H === "PRE") return L && b.isFunction(L) && (E = "" + (L(E) || "")), void _.cmd.do("insertHTML", (O = E, O.replace(/<br>|<br\/>/gm, `
`).replace(/<[^>]+>/gm, "")));
                if (x.urlRegex.test(E) && D) return _.cmd.do("insertHTML", '<a href="' + E + '" target="_blank">' + E + "</a>");
                if (h) try {
                  if (L && b.isFunction(L) && (h = "" + (L(h) || "")), /[\.\#\@]?\w+[ ]+\{[^}]*\}/.test(h) && D) _.cmd.do("insertHTML", "" + g(E));
                  else {
                    var $ = g(h);
                    if (function(U) {
                      var Y;
                      if (U === "") return !1;
                      var X = document.createElement("div");
                      return X.innerHTML = U, ((Y = X.firstChild) === null || Y === void 0 ? void 0 : Y.nodeName) === "P";
                    }($)) {
                      var Q = _.$textElem;
                      if (_.cmd.do("insertHTML", $), Q.equal(w)) return void _.selection.createEmptyRange();
                      (function(U) {
                        if (!(U != null && U.length)) return !1;
                        var Y = U.elems[0];
                        return Y.nodeName === "P" && Y.innerHTML === "<br>";
                      })(I) && I.remove();
                    } else _.cmd.do("insertHTML", $);
                  }
                } catch (U) {
                  L && b.isFunction(L) && (E = "" + (L(E) || "")), _.cmd.do("insertHTML", "" + g(E));
                }
              }
            });
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(19)), p = u(r(4)), b = u(r(73));
          (0, v.default)(d, "__esModule", { value: !0 });
          var x = r(2), g = r(296), _ = x.__importDefault(r(300));
          function A(f, S) {
            var D;
            return f = (0, C.default)(D = f.toLowerCase()).call(D), !!g.IGNORE_TAGS.has(f) || !(!S || f !== "img");
          }
          d.default = function(f, S, D) {
            S === void 0 && (S = !0), D === void 0 && (D = !1);
            var k = [], L = "";
            new _.default().parse(f, { startElement: function(E, w) {
              if (function(H) {
                (H = (0, C.default)(H).call(H)) && (g.EMPTY_TAGS.has(H) || (L = H));
              }(E), !A(E, D)) {
                var O = g.NECESSARY_ATTRS.get(E) || [], R = [];
                (0, p.default)(w).call(w, function(H) {
                  var $ = H.name;
                  $ !== "style" ? (0, b.default)(O).call(O, $) !== !1 && R.push(H) : S || R.push(H);
                });
                var I = function(H, $) {
                  var Q = "";
                  Q = "<" + H;
                  var U = [];
                  return (0, p.default)($).call($, function(Y) {
                    U.push(Y.name + '="' + Y.value + '"');
                  }), U.length > 0 && (Q = Q + " " + U.join(" ")), Q = Q + (g.EMPTY_TAGS.has(H) ? "/" : "") + ">";
                }(E, R);
                k.push(I);
              }
            }, characters: function(E) {
              E && (A(L, D) || k.push(E));
            }, endElement: function(E) {
              if (!A(E, D)) {
                var w = function(O) {
                  return "</" + O + ">";
                }(E);
                k.push(w), L = "";
              }
            }, comment: function(E) {
            } });
            var h = k.join("");
            return h = function(E) {
              var w = /<span>(.*?)<\/span>/;
              return E.replace(/<span>.*?<\/span>/gi, function(O) {
                var R = O.match(w);
                return R == null ? "" : R[1];
              });
            }(h);
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(125)), p = u(r(116));
          (0, v.default)(d, "__esModule", { value: !0 }), d.TOP_LEVEL_TAGS = d.EMPTY_TAGS = d.NECESSARY_ATTRS = d.IGNORE_TAGS = void 0, d.IGNORE_TAGS = new C.default(["doctype", "!doctype", "html", "head", "meta", "body", "script", "style", "link", "frame", "iframe", "title", "svg", "center", "o:p"]), d.NECESSARY_ATTRS = new p.default([["img", ["src", "alt"]], ["a", ["href", "target"]], ["td", ["colspan", "rowspan"]], ["th", ["colspan", "rowspan"]]]), d.EMPTY_TAGS = new C.default(["area", "base", "basefont", "br", "col", "hr", "img", "input", "isindex", "embed"]), d.TOP_LEVEL_TAGS = new C.default(["h1", "h2", "h3", "h4", "h5", "p", "ul", "ol", "table", "blockquote", "pre", "hr", "form"]);
        }, function(m, d, r) {
          var u = r(298);
          m.exports = u;
        }, function(m, d, r) {
          r(299), r(67), r(69), r(50);
          var u = r(12);
          m.exports = u.Set;
        }, function(m, d, r) {
          var u = r(117), v = r(119);
          m.exports = u("Set", function(C) {
            return function() {
              return C(this, arguments.length ? arguments[0] : void 0);
            };
          }, v);
        }, function(m, d) {
          function r() {
          }
          r.prototype = { handler: null, startTagRe: /^<([^>\s\/]+)((\s+[^=>\s]+(\s*=\s*((\"[^"]*\")|(\'[^']*\')|[^>\s]+))?)*)\s*\/?\s*>/m, endTagRe: /^<\/([^>\s]+)[^>]*>/m, attrRe: /([^=\s]+)(\s*=\s*((\"([^"]*)\")|(\'([^']*)\')|[^>\s]+))?/gm, parse: function(u, v) {
            var C, p, b;
            v && (this.contentHandler = v);
            for (var x = !1, g = this; u.length > 0; ) u.substring(0, 4) == "<!--" ? (b = u.indexOf("-->")) != -1 ? (this.contentHandler.comment(u.substring(4, b)), u = u.substring(b + 3), x = !1) : x = !0 : u.substring(0, 2) == "</" ? this.endTagRe.test(u) ? (C = RegExp.lastMatch, p = RegExp.rightContext, C.replace(this.endTagRe, function() {
              return g.parseEndTag.apply(g, arguments);
            }), u = p, x = !1) : x = !0 : u.charAt(0) == "<" && (this.startTagRe.test(u) ? (C = RegExp.lastMatch, p = RegExp.rightContext, C.replace(this.startTagRe, function() {
              return g.parseStartTag.apply(g, arguments);
            }), u = p, x = !1) : x = !0), x && ((b = u.indexOf("<")) == -1 ? (this.contentHandler.characters(u), u = "") : (this.contentHandler.characters(u.substring(0, b)), u = u.substring(b))), x = !0;
          }, parseStartTag: function(u, v, C) {
            var p = this.parseAttributes(v, C);
            this.contentHandler.startElement(v, p);
          }, parseEndTag: function(u, v) {
            this.contentHandler.endElement(v);
          }, parseAttributes: function(u, v) {
            var C = this, p = [];
            return v.replace(this.attrRe, function(b, x, g, _, A, f, S, D) {
              p.push(C.parseAttribute(u, b, x, g, _, A, f, S, D));
            }), p;
          }, parseAttribute: function(u, v, C) {
            var p = "";
            return arguments[7] ? p = arguments[8] : arguments[5] ? p = arguments[6] : arguments[3] && (p = arguments[4]), { name: C, value: !p && !arguments[3] ? null : p };
          } }, m.exports = r;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 }), d.default = function(u, v) {
            v.push(function(C) {
              u.selection.createRangeByElem(C), u.selection.restoreSelection();
            });
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2), b = r(6), x = p.__importDefault(r(3));
          d.default = function g(_) {
            var A = [], f = _.childNodes() || [];
            return (0, C.default)(f).call(f, function(S) {
              var D, k = S.nodeType;
              if (k === 3 && (D = S.textContent || "", D = b.replaceHtmlSymbol(D)), k === 1) {
                (D = D = {}).tag = S.nodeName.toLowerCase();
                for (var L = [], h = S.attributes, E = h.length || 0, w = 0; w < E; w++) {
                  var O = h[w];
                  L.push({ name: O.name, value: O.value });
                }
                D.attrs = L, D.children = g(x.default(S));
              }
              D && A.push(D);
            }), A;
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(94)), C = u(r(1)), p = u(r(4));
          (0, C.default)(d, "__esModule", { value: !0 });
          var b = r(2).__importDefault(r(3));
          d.default = function x(g, _) {
            _ === void 0 && (_ = document.createElement("div"));
            var A = _;
            return (0, p.default)(g).call(g, function(f) {
              var S, D;
              typeof f == "string" && (S = document.createTextNode(f)), (0, v.default)(f) === "object" && (S = document.createElement(f.tag), (0, p.default)(D = f.attrs).call(D, function(k) {
                b.default(S).attr(k.name, k.value);
              }), f.children && f.children.length > 0 && x(f.children, S.getRootNode())), S && A.appendChild(S);
            }), b.default(A);
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(90)), p = u(r(72)), b = u(r(73)), x = u(r(4)), g = u(r(126)), _ = u(r(127)), A = u(r(54)), f = u(r(53));
          (0, v.default)(d, "__esModule", { value: !0 });
          var S = r(2), D = S.__importDefault(r(115)), k = S.__importDefault(r(313)), L = S.__importDefault(r(3)), h = function() {
            function E(w) {
              this.editor = w, this.menuList = [], this.constructorList = k.default;
            }
            return E.prototype.extend = function(w, O) {
              O && typeof O == "function" && (this.constructorList[w] = O);
            }, E.prototype.init = function() {
              var w, O, R = this, I = this.editor.config, H = I.excludeMenus;
              (0, C.default)(H) === !1 && (H = []), I.menus = (0, p.default)(w = I.menus).call(w, function(G) {
                return (0, b.default)(H).call(H, G) === !1;
              }), (0, x.default)(O = I.menus).call(O, function(G) {
                var J = R.constructorList[G];
                R._initMenuList(G, J);
              });
              for (var $ = 0, Q = (0, g.default)(D.default.globalCustomMenuConstructorList); $ < Q.length; $++) {
                var U = Q[$], Y = U[0], X = U[1];
                this._initMenuList(Y, X);
              }
              this._addToToolbar(), I.showMenuTooltips && this._bindMenuTooltips();
            }, E.prototype._initMenuList = function(w, O) {
              var R;
              if (O != null && typeof O == "function") if ((0, _.default)(R = this.menuList).call(R, function(H) {
                return H.key === w;
              })) console.warn("菜单名称重复:" + w);
              else {
                var I = new O(this.editor);
                I.key = w, this.menuList.push(I);
              }
            }, E.prototype._bindMenuTooltips = function() {
              var w = this.editor, O = w.$toolbarElem, R = w.config.menuTooltipPosition, I = L.default('<div class="w-e-menu-tooltip w-e-menu-tooltip-' + R + `">
            <div class="w-e-menu-tooltip-item-wrapper">
              <div></div>
            </div>
          </div>`);
              I.css("visibility", "hidden"), O.append(I), I.css("z-index", w.zIndex.get("tooltip"));
              var H = 0;
              function $() {
                H && clearTimeout(H);
              }
              function Q() {
                $(), I.css("visibility", "hidden");
              }
              O.on("mouseover", function(U) {
                var Y, X, G = U.target, J = L.default(G);
                if (J.isContain(O)) Q();
                else {
                  if (J.parentUntil(".w-e-droplist") != null) Q();
                  else if (J.attr("data-title")) Y = J.attr("data-title"), X = J;
                  else {
                    var ee = J.parentUntil(".w-e-menu");
                    ee != null && (Y = ee.attr("data-title"), X = ee);
                  }
                  if (Y && X) {
                    $();
                    var re = X.getOffsetData();
                    I.text(w.i18next.t("menus.title." + Y));
                    var oe = I.getOffsetData(), ae = re.left + re.width / 2 - oe.width / 2;
                    I.css("left", ae + "px"), R === "up" ? I.css("top", re.top - oe.height - 8 + "px") : R === "down" && I.css("top", re.top + re.height + 8 + "px"), H = (0, A.default)(function() {
                      I.css("visibility", "visible");
                    }, 200);
                  } else Q();
                }
              }).on("mouseleave", function() {
                Q();
              });
            }, E.prototype._addToToolbar = function() {
              var w, O = this.editor.$toolbarElem;
              (0, x.default)(w = this.menuList).call(w, function(R) {
                var I = R.$elem;
                I && O.append(I);
              });
            }, E.prototype.menuFind = function(w) {
              for (var O = this.menuList, R = 0, I = O.length; R < I; R++) if (O[R].key === w) return O[R];
              return O[0];
            }, E.prototype.changeActive = function() {
              var w;
              (0, x.default)(w = this.menuList).call(w, function(O) {
                var R;
                (0, A.default)((0, f.default)(R = O.tryChangeActive).call(R, O), 100);
              });
            }, E;
          }();
          d.default = h;
        }, function(m, d, r) {
          var u = r(306);
          m.exports = u;
        }, function(m, d, r) {
          r(307);
          var u = r(12);
          m.exports = u.Object.entries;
        }, function(m, d, r) {
          var u = r(5), v = r(308).entries;
          u({ target: "Object", stat: !0 }, { entries: function(C) {
            return v(C);
          } });
        }, function(m, d, r) {
          var u = r(15), v = r(61), C = r(27), p = r(56).f, b = function(x) {
            return function(g) {
              for (var _, A = C(g), f = v(A), S = f.length, D = 0, k = []; S > D; ) _ = f[D++], u && !p.call(A, _) || k.push(x ? [_, A[_]] : A[_]);
              return k;
            };
          };
          m.exports = { entries: b(!0), values: b(!1) };
        }, function(m, d, r) {
          var u = r(310);
          m.exports = u;
        }, function(m, d, r) {
          var u = r(311), v = Array.prototype;
          m.exports = function(C) {
            var p = C.some;
            return C === v || C instanceof Array && p === v.some ? u : p;
          };
        }, function(m, d, r) {
          r(312);
          var u = r(14);
          m.exports = u("Array").some;
        }, function(m, d, r) {
          var u = r(5), v = r(29).some;
          u({ target: "Array", proto: !0, forced: !r(70)("some") }, { some: function(C) {
            return v(this, C, arguments.length > 1 ? arguments[1] : void 0);
          } });
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(314)), C = u.__importDefault(r(315)), p = u.__importDefault(r(320)), b = u.__importDefault(r(325)), x = u.__importDefault(r(326)), g = u.__importDefault(r(327)), _ = u.__importDefault(r(328)), A = u.__importDefault(r(330)), f = u.__importDefault(r(332)), S = u.__importDefault(r(333)), D = u.__importDefault(r(336)), k = u.__importDefault(r(337)), L = u.__importDefault(r(338)), h = u.__importDefault(r(348)), E = u.__importDefault(r(362)), w = u.__importDefault(r(366)), O = u.__importDefault(r(132)), R = u.__importDefault(r(375)), I = u.__importDefault(r(377)), H = u.__importDefault(r(378)), $ = u.__importDefault(r(379)), Q = u.__importDefault(r(394)), U = u.__importDefault(r(399)), Y = u.__importDefault(r(402));
          d.default = { bold: v.default, head: C.default, italic: b.default, link: p.default, underline: x.default, strikeThrough: g.default, fontName: _.default, fontSize: A.default, justify: f.default, quote: S.default, backColor: D.default, foreColor: k.default, video: L.default, image: h.default, indent: E.default, emoticon: w.default, list: O.default, lineHeight: R.default, undo: I.default, redo: H.default, table: $.default, code: Q.default, splitLine: U.default, todo: Y.default };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(22)), C = u.__importDefault(r(3)), p = function(b) {
            function x(g) {
              var _ = C.default(`<div class="w-e-menu" data-title="加粗">
                <i class="w-e-icon-bold"></i>
            </div>`);
              return b.call(this, _, g) || this;
            }
            return u.__extends(x, b), x.prototype.clickHandler = function() {
              var g = this.editor, _ = g.selection.isSelectionEmpty();
              _ && g.selection.createEmptyRange(), g.cmd.do("bold"), _ && (g.selection.collapseRange(), g.selection.restoreSelection());
            }, x.prototype.tryChangeActive = function() {
              this.editor.cmd.queryCommandState("bold") ? this.active() : this.unActive();
            }, x;
          }(v.default);
          d.default = p;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(26)), p = u(r(30)), b = u(r(4)), x = u(r(316)), g = u(r(73));
          (0, v.default)(d, "__esModule", { value: !0 });
          var _ = r(2), A = _.__importDefault(r(23)), f = _.__importDefault(r(3)), S = r(6), D = r(7), k = function(L) {
            function h(E) {
              var w = this, O = f.default('<div class="w-e-menu" data-title="标题"><i class="w-e-icon-header"></i></div>'), R = { width: 100, title: "设置标题", type: "list", list: [{ $elem: f.default("<h1>H1</h1>"), value: "<h1>" }, { $elem: f.default("<h2>H2</h2>"), value: "<h2>" }, { $elem: f.default("<h3>H3</h3>"), value: "<h3>" }, { $elem: f.default("<h4>H4</h4>"), value: "<h4>" }, { $elem: f.default("<h5>H5</h5>"), value: "<h5>" }, { $elem: f.default("<p>" + E.i18next.t("menus.dropListMenu.head.正文") + "</p>"), value: "<p>" }], clickHandler: function(I) {
                w.command(I);
              } };
              return w = L.call(this, O, E, R) || this, E.config.onCatalogChange && (w.oldCatalogs = [], w.addListenerCatalog(), w.getCatalogs()), w;
            }
            return _.__extends(h, L), h.prototype.command = function(E) {
              var w = this.editor, O = w.selection.getSelectionContainerElem();
              if (O && w.$textElem.equal(O)) this.setMultilineHead(E);
              else {
                var R;
                if ((0, C.default)(R = ["OL", "UL", "LI", "TABLE", "TH", "TR", "CODE", "HR"]).call(R, f.default(O).getNodeName()) > -1) return;
                w.cmd.do("formatBlock", E);
              }
              E !== "<p>" && this.addUidForSelectionElem();
            }, h.prototype.addUidForSelectionElem = function() {
              var E = this.editor.selection.getSelectionContainerElem(), w = S.getRandomCode();
              f.default(E).attr("id", w);
            }, h.prototype.addListenerCatalog = function() {
              var E = this;
              this.editor.txt.eventHooks.changeEvents.push(function() {
                E.getCatalogs();
              });
            }, h.prototype.getCatalogs = function() {
              var E = this.editor, w = this.editor.$textElem, O = E.config.onCatalogChange, R = (0, p.default)(w).call(w, "h1,h2,h3,h4,h5"), I = [];
              (0, b.default)(R).call(R, function(H, $) {
                var Q = f.default(H), U = Q.attr("id"), Y = Q.getNodeName(), X = Q.text();
                U || (U = S.getRandomCode(), Q.attr("id", U)), X && I.push({ tag: Y, id: U, text: X });
              }), (0, x.default)(this.oldCatalogs) !== (0, x.default)(I) && (this.oldCatalogs = I, O && O(I));
            }, h.prototype.setMultilineHead = function(E) {
              var w, O, R = this, I = this.editor, H = I.selection, $ = (w = H.getSelectionContainerElem()) === null || w === void 0 ? void 0 : w.elems[0], Q = ["IMG", "VIDEO", "TABLE", "TH", "TR", "UL", "OL", "PRE", "HR", "BLOCKQUOTE"], U = f.default(H.getSelectionStartElem()), Y = f.default(H.getSelectionEndElem());
              Y.elems[0].outerHTML !== f.default(D.EMPTY_P).elems[0].outerHTML || Y.elems[0].nextSibling || (Y = Y.prev());
              var X = [];
              X.push(U.getNodeTop(I));
              var G = [], J = (O = H.getRange()) === null || O === void 0 ? void 0 : O.commonAncestorContainer.childNodes;
              J == null || (0, b.default)(J).call(J, function(oe, ae) {
                oe === X[0].getNode() && G.push(ae), oe === Y.getNodeTop(I).getNode() && G.push(ae);
              });
              for (var ee = 0; X[ee].getNode() !== Y.getNodeTop(I).getNode(); ) {
                if (!X[ee].elems[0]) return;
                var re = f.default(X[ee].next().getNode());
                X.push(re), ee++;
              }
              X == null || (0, b.default)(X).call(X, function(oe, ae) {
                if (!R.hasTag(oe, Q)) {
                  var se = f.default(E), ve = oe.parent().getNode();
                  se.html("" + oe.html()), ve.insertBefore(se.getNode(), oe.getNode()), oe.remove();
                }
              }), H.createRangeByElems($.children[G[0]], $.children[G[1]]);
            }, h.prototype.hasTag = function(E, w) {
              var O, R = this;
              if (!E) return !1;
              if ((0, g.default)(w).call(w, E == null ? void 0 : E.getNodeName())) return !0;
              var I = !1;
              return (O = E.children()) === null || O === void 0 || (0, b.default)(O).call(O, function(H) {
                I = R.hasTag(f.default(H), w);
              }), I;
            }, h.prototype.tryChangeActive = function() {
              var E = this.editor.cmd.queryCommandValue("formatBlock");
              /^h/i.test(E) ? this.active() : this.unActive();
            }, h;
          }(A.default);
          d.default = k;
        }, function(m, d, r) {
          m.exports = r(317);
        }, function(m, d, r) {
          var u = r(318);
          m.exports = u;
        }, function(m, d, r) {
          r(319);
          var u = r(12);
          u.JSON || (u.JSON = { stringify: JSON.stringify }), m.exports = function(v, C, p) {
            return u.JSON.stringify.apply(null, arguments);
          };
        }, function(m, d, r) {
          var u = r(5), v = r(28), C = r(11), p = v("JSON", "stringify"), b = /[\uD800-\uDFFF]/g, x = /^[\uD800-\uDBFF]$/, g = /^[\uDC00-\uDFFF]$/, _ = function(f, S, D) {
            var k = D.charAt(S - 1), L = D.charAt(S + 1);
            return x.test(f) && !g.test(L) || g.test(f) && !x.test(k) ? "\\u" + f.charCodeAt(0).toString(16) : f;
          }, A = C(function() {
            return p("\uDF06\uD834") !== '"\\udf06\\ud834"' || p("\uDEAD") !== '"\\udead"';
          });
          p && u({ target: "JSON", stat: !0, forced: A }, { stringify: function(f, S, D) {
            var k = p.apply(null, arguments);
            return typeof k == "string" ? k.replace(b, _) : k;
          } });
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(33)), C = u.__importDefault(r(3)), p = u.__importDefault(r(321)), b = u.__importDefault(r(129)), x = u.__importDefault(r(31)), g = u.__importDefault(r(323)), _ = function(A) {
            function f(S) {
              var D, k = C.default('<div class="w-e-menu" data-title="链接"><i class="w-e-icon-link"></i></div>');
              return D = A.call(this, k, S) || this, g.default(S), D;
            }
            return u.__extends(f, A), f.prototype.clickHandler = function() {
              var S, D = this.editor;
              if (this.isActive) {
                if (!(S = D.selection.getSelectionContainerElem())) return;
                this.createPanel(S.text(), S.attr("href"));
              } else D.selection.isSelectionEmpty() ? this.createPanel("", "") : this.createPanel(D.selection.getSelectionText(), "");
            }, f.prototype.createPanel = function(S, D) {
              var k = p.default(this.editor, S, D);
              new x.default(this, k).create();
            }, f.prototype.tryChangeActive = function() {
              var S = this.editor;
              b.default(S) ? this.active() : this.unActive();
            }, f;
          }(v.default);
          d.default = _;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(19));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2), b = r(6), x = p.__importDefault(r(3)), g = p.__importDefault(r(129)), _ = r(322);
          d.default = function(A, f, S) {
            var D, k = b.getRandom("input-link"), L = b.getRandom("input-text"), h = b.getRandom("btn-ok"), E = b.getRandom("btn-del"), w = g.default(A) ? "inline-block" : "none";
            function O() {
              if (g.default(A)) {
                var R = A.selection.getSelectionContainerElem();
                R && (A.selection.createRangeByElem(R), A.selection.restoreSelection(), D = R);
              }
            }
            return { width: 300, height: 0, tabs: [{ title: A.i18next.t("menus.panelMenus.link.链接"), tpl: `<div>
                        <input
                            id="` + L + `"
                            type="text"
                            class="block"
                            value="` + f + `"
                            placeholder="` + A.i18next.t("menus.panelMenus.link.链接文字") + `"/>
                        </td>
                        <input
                            id="` + k + `"
                            type="text"
                            class="block"
                            value="` + S + `"
                            placeholder="` + A.i18next.t("如") + ` https://..."/>
                        </td>
                        <div class="w-e-button-container">
                            <button type="button" id="` + h + `" class="right">
                                ` + A.i18next.t("插入") + `
                            </button>
                            <button type="button" id="` + E + '" class="gray right" style="display:' + w + `">
                                ` + A.i18next.t("menus.panelMenus.link.取消链接") + `
                            </button>
                        </div>
                    </div>`, events: [{ selector: "#" + h, type: "click", fn: function() {
              var R, I, H, $;
              A.selection.restoreSelection();
              var Q = A.selection.getSelectionRangeTopNodes()[0].getNode(), U = window.getSelection(), Y = x.default("#" + k), X = x.default("#" + L), G = (0, C.default)(R = Y.val()).call(R), J = (0, C.default)(I = X.val()).call(I), ee = "";
              U && !(U != null && U.isCollapsed) && (ee = (H = _.insertHtml(U, Q)) === null || H === void 0 ? void 0 : (0, C.default)(H).call(H));
              var re = ee == null ? void 0 : ee.replace(/<.*?>/g, ""), oe = ($ = re == null ? void 0 : re.length) !== null && $ !== void 0 ? $ : 0;
              if (oe <= J.length) {
                var ae = J.substring(0, oe), se = J.substring(oe);
                re === ae && (J = ee + se);
              }
              if (G && (J || (J = G), function(ve, Ae) {
                var ye = A.config.linkCheck(ve, Ae);
                if (ye !== void 0) {
                  if (ye === !0) return !0;
                  A.config.customAlert(ye, "warning");
                }
                return !1;
              }(J, G))) return function(ve, Ae) {
                g.default(A) && O(), A.cmd.do("insertHTML", '<a href="' + Ae + '" target="_blank">' + ve + "</a>");
              }(J, G), !0;
            } }, { selector: "#" + E, type: "click", fn: function() {
              return function() {
                if (g.default(A)) {
                  O();
                  var R = D.text();
                  A.cmd.do("insertHTML", "<span>" + R + "</span>");
                }
              }(), !0;
            } }] }] };
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4));
          function p(_, A) {
            var f = _, S = _;
            do {
              if (f.textContent === A) break;
              S = f, f.parentNode && (f = f == null ? void 0 : f.parentNode);
            } while ((f == null ? void 0 : f.nodeName) !== "P");
            return S;
          }
          function b(_, A) {
            var f = _.nodeName, S = "";
            if (_.nodeType === 3) return A;
            if (_.nodeType === 1) {
              var D = _.getAttribute("style"), k = _.getAttribute("face"), L = _.getAttribute("color");
              D && (S = S + ' style="' + D + '"'), k && (S = S + ' face="' + k + '"'), L && (S = S + ' color="' + L + '"');
            }
            return "<" + (f = f.toLowerCase()) + S + ">" + A + "</" + f + ">";
          }
          function x(_, A, f, S) {
            var D, k = (D = A.textContent) === null || D === void 0 ? void 0 : D.substring(f, S), L = A, h = "";
            do
              k = h = b(L, k != null ? k : ""), L.parentElement && (L = L == null ? void 0 : L.parentElement);
            while (L.textContent !== _);
            return h;
          }
          function g(_, A) {
            return (0, C.default)(_).call(_, function(f) {
              A = b(f, A);
            }), A;
          }
          (0, v.default)(d, "__esModule", { value: !0 }), d.insertHtml = d.createPartHtml = d.makeHtmlString = d.getTopNode = void 0, d.getTopNode = p, d.makeHtmlString = b, d.createPartHtml = x, d.insertHtml = function(_, A) {
            var f, S, D, k, L, h = _.anchorNode, E = _.focusNode, w = _.anchorOffset, O = _.focusOffset, R = (f = A.textContent) !== null && f !== void 0 ? f : "", I = function(ee) {
              for (var re, oe = (re = ee.textContent) !== null && re !== void 0 ? re : "", ae = []; (ee == null ? void 0 : ee.textContent) === oe; ) ee.nodeName !== "P" && ae.push(ee), ee = ee.childNodes[0];
              return ae;
            }(A), H = "", $ = "", Q = "", U = h, Y = E, X = h;
            if (h != null && h.isEqualNode(E != null ? E : null)) {
              var G = x(R, h, w, O);
              return G = g(I, G);
            }
            for (h && (H = x(R, h, w != null ? w : 0)), E && (Q = x(R, E, 0, O)), h && (U = p(h, R)), E && (Y = p(E, R)), X = (S = U == null ? void 0 : U.nextSibling) !== null && S !== void 0 ? S : h; !(X != null && X.isEqualNode(Y != null ? Y : null)); ) {
              if ((X == null ? void 0 : X.nodeName) === "#text") $ += X == null ? void 0 : X.textContent;
              else {
                var J = (k = (D = X == null ? void 0 : X.firstChild) === null || D === void 0 ? void 0 : D.parentElement) === null || k === void 0 ? void 0 : k.innerHTML;
                X && ($ += b(X, J != null ? J : ""));
              }
              X = (L = X == null ? void 0 : X.nextSibling) !== null && L !== void 0 ? L : X;
            }
            return g(I, "" + H + $ + Q);
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2).__importDefault(r(324));
          d.default = function(v) {
            u.default(v);
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(3)), C = u.__importDefault(r(34));
          d.default = function(p) {
            var b = /* @__PURE__ */ function(_) {
              var A;
              return { showLinkTooltip: function(f) {
                var S = [{ $elem: v.default("<span>" + _.i18next.t("menus.panelMenus.link.查看链接") + "</span>"), onClick: function(D, k) {
                  var L = k.attr("href");
                  return window.open(L, "_target"), !0;
                } }, { $elem: v.default("<span>" + _.i18next.t("menus.panelMenus.link.取消链接") + "</span>"), onClick: function(D, k) {
                  D.selection.createRangeByElem(k), D.selection.restoreSelection();
                  var L = k.text();
                  return D.cmd.do("insertHTML", "<span>" + L + "</span>"), !0;
                } }];
                (A = new C.default(_, f, S)).create();
              }, hideLinkTooltip: function() {
                A && (A.remove(), A = null);
              } };
            }(p), x = b.showLinkTooltip, g = b.hideLinkTooltip;
            p.txt.eventHooks.linkClickEvents.push(x), p.txt.eventHooks.clickEvents.push(g), p.txt.eventHooks.keyupEvents.push(g), p.txt.eventHooks.toolbarClickEvents.push(g), p.txt.eventHooks.menuClickEvents.push(g), p.txt.eventHooks.textScrollEvents.push(g);
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(22)), C = u.__importDefault(r(3)), p = function(b) {
            function x(g) {
              var _ = C.default(`<div class="w-e-menu" data-title="斜体">
                <i class="w-e-icon-italic"></i>
            </div>`);
              return b.call(this, _, g) || this;
            }
            return u.__extends(x, b), x.prototype.clickHandler = function() {
              var g = this.editor, _ = g.selection.isSelectionEmpty();
              _ && g.selection.createEmptyRange(), g.cmd.do("italic"), _ && (g.selection.collapseRange(), g.selection.restoreSelection());
            }, x.prototype.tryChangeActive = function() {
              this.editor.cmd.queryCommandState("italic") ? this.active() : this.unActive();
            }, x;
          }(v.default);
          d.default = p;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(22)), C = u.__importDefault(r(3)), p = function(b) {
            function x(g) {
              var _ = C.default(`<div class="w-e-menu" data-title="下划线">
                <i class="w-e-icon-underline"></i>
            </div>`);
              return b.call(this, _, g) || this;
            }
            return u.__extends(x, b), x.prototype.clickHandler = function() {
              var g = this.editor, _ = g.selection.isSelectionEmpty();
              _ && g.selection.createEmptyRange(), g.cmd.do("underline"), _ && (g.selection.collapseRange(), g.selection.restoreSelection());
            }, x.prototype.tryChangeActive = function() {
              this.editor.cmd.queryCommandState("underline") ? this.active() : this.unActive();
            }, x;
          }(v.default);
          d.default = p;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(22)), C = u.__importDefault(r(3)), p = function(b) {
            function x(g) {
              var _ = C.default(`<div class="w-e-menu" data-title="删除线">
                <i class="w-e-icon-strikethrough"></i>
            </div>`);
              return b.call(this, _, g) || this;
            }
            return u.__extends(x, b), x.prototype.clickHandler = function() {
              var g = this.editor, _ = g.selection.isSelectionEmpty();
              _ && g.selection.createEmptyRange(), g.cmd.do("strikeThrough"), _ && (g.selection.collapseRange(), g.selection.restoreSelection());
            }, x.prototype.tryChangeActive = function() {
              this.editor.cmd.queryCommandState("strikeThrough") ? this.active() : this.unActive();
            }, x;
          }(v.default);
          d.default = p;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(23)), C = u.__importDefault(r(3)), p = u.__importDefault(r(329)), b = function(x) {
            function g(_) {
              var A = this, f = C.default(`<div class="w-e-menu" data-title="字体">
                <i class="w-e-icon-font"></i>
            </div>`), S = { width: 100, title: "设置字体", type: "list", list: new p.default(_.config.fontNames).getItemList(), clickHandler: function(D) {
                A.command(D);
              } };
              return A = x.call(this, f, _, S) || this;
            }
            return u.__extends(g, x), g.prototype.command = function(_) {
              var A, f = this.editor, S = f.selection.isSelectionEmpty(), D = (A = f.selection.getSelectionContainerElem()) === null || A === void 0 ? void 0 : A.elems[0];
              if (D != null) {
                var k = (D == null ? void 0 : D.nodeName.toLowerCase()) !== "p", L = (D == null ? void 0 : D.getAttribute("face")) === _;
                if (S) {
                  if (k && !L) {
                    var h = f.selection.getSelectionRangeTopNodes();
                    f.selection.createRangeByElem(h[0]), f.selection.moveCursor(h[0].elems[0]);
                  }
                  f.selection.setRangeToContainerElem(D), f.selection.createEmptyRange();
                }
                f.cmd.do("fontName", _), S && (f.selection.collapseRange(), f.selection.restoreSelection());
              }
            }, g.prototype.tryChangeActive = function() {
            }, g;
          }(v.default);
          d.default = b;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2).__importDefault(r(3)), b = function() {
            function x(g) {
              var _ = this;
              this.itemList = [], (0, C.default)(g).call(g, function(A) {
                _.itemList.push({ $elem: p.default(`<p style="font-family:'` + A + `'">` + A + "</p>"), value: A });
              });
            }
            return x.prototype.getItemList = function() {
              return this.itemList;
            }, x;
          }();
          d.default = b;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(23)), C = u.__importDefault(r(3)), p = u.__importDefault(r(331)), b = function(x) {
            function g(_) {
              var A = this, f = C.default(`<div class="w-e-menu" data-title="字号">
                <i class="w-e-icon-text-heigh"></i>
            </div>`), S = { width: 160, title: "设置字号", type: "list", list: new p.default(_.config.fontSizes).getItemList(), clickHandler: function(D) {
                A.command(D);
              } };
              return A = x.call(this, f, _, S) || this;
            }
            return u.__extends(g, x), g.prototype.command = function(_) {
              var A, f = this.editor, S = f.selection.isSelectionEmpty(), D = (A = f.selection.getSelectionContainerElem()) === null || A === void 0 ? void 0 : A.elems[0];
              if (D != null) {
                var k = (D == null ? void 0 : D.nodeName.toLowerCase()) !== "p", L = (D == null ? void 0 : D.getAttribute("size")) === _;
                if (S) {
                  if (k && !L) {
                    var h = f.selection.getSelectionRangeTopNodes();
                    f.selection.createRangeByElem(h[0]), f.selection.moveCursor(h[0].elems[0]);
                  }
                  f.selection.setRangeToContainerElem(D), f.selection.createEmptyRange();
                }
                f.cmd.do("fontSize", _), S && (f.selection.collapseRange(), f.selection.restoreSelection());
              }
            }, g.prototype.tryChangeActive = function() {
            }, g;
          }(v.default);
          d.default = b;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2).__importDefault(r(3)), v = function() {
            function C(p) {
              for (var b in this.itemList = [], p) {
                var x = p[b];
                this.itemList.push({ $elem: u.default('<p style="font-size:' + b + '">' + x.name + "</p>"), value: x.value });
              }
            }
            return C.prototype.getItemList = function() {
              return this.itemList;
            }, C;
          }();
          d.default = v;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4)), p = u(r(26));
          (0, v.default)(d, "__esModule", { value: !0 });
          var b = r(2), x = b.__importDefault(r(23)), g = b.__importDefault(r(3)), _ = ["LI"], A = ["UL", "BLOCKQUOTE"], f = function(S) {
            function D(k) {
              var L = this, h = g.default('<div class="w-e-menu" data-title="对齐"><i class="w-e-icon-paragraph-left"></i></div>'), E = { width: 100, title: "对齐方式", type: "list", list: [{ $elem: g.default(`<p>
                            <i class="w-e-icon-paragraph-left w-e-drop-list-item"></i>
                            ` + k.i18next.t("menus.dropListMenu.justify.靠左") + `
                        </p>`), value: "left" }, { $elem: g.default(`<p>
                            <i class="w-e-icon-paragraph-center w-e-drop-list-item"></i>
                            ` + k.i18next.t("menus.dropListMenu.justify.居中") + `
                        </p>`), value: "center" }, { $elem: g.default(`<p>
                            <i class="w-e-icon-paragraph-right w-e-drop-list-item"></i>
                            ` + k.i18next.t("menus.dropListMenu.justify.靠右") + `
                        </p>`), value: "right" }, { $elem: g.default(`<p>
                            <i class="w-e-icon-paragraph-justify w-e-drop-list-item"></i>
                            ` + k.i18next.t("menus.dropListMenu.justify.两端") + `
                        </p>`), value: "justify" }], clickHandler: function(w) {
                L.command(w);
              } };
              return L = S.call(this, h, k, E) || this;
            }
            return b.__extends(D, S), D.prototype.command = function(k) {
              var L = this.editor, h = L.selection, E = h.getSelectionContainerElem();
              h.saveRange();
              var w = L.selection.getSelectionRangeTopNodes();
              if (E != null && E.length) if (this.isSpecialNode(E, w[0]) || this.isSpecialTopNode(w[0])) {
                var O = this.getSpecialNodeUntilTop(E, w[0]);
                if (O == null) return;
                g.default(O).css("text-align", k);
              } else (0, C.default)(w).call(w, function(R) {
                R.css("text-align", k);
              });
              h.restoreSelection();
            }, D.prototype.getSpecialNodeUntilTop = function(k, L) {
              for (var h = k.elems[0], E = L.elems[0]; h != null; ) {
                if ((0, p.default)(_).call(_, h == null ? void 0 : h.nodeName) !== -1 || h.parentNode === E) return h;
                h = h.parentNode;
              }
              return h;
            }, D.prototype.isSpecialNode = function(k, L) {
              var h = this.getSpecialNodeUntilTop(k, L);
              return h != null && (0, p.default)(_).call(_, h.nodeName) !== -1;
            }, D.prototype.isSpecialTopNode = function(k) {
              var L;
              return k != null && (0, p.default)(A).call(A, (L = k.elems[0]) === null || L === void 0 ? void 0 : L.nodeName) !== -1;
            }, D.prototype.tryChangeActive = function() {
            }, D;
          }(x.default);
          d.default = f;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2), b = p.__importDefault(r(3)), x = p.__importDefault(r(22)), g = p.__importDefault(r(334)), _ = p.__importDefault(r(335)), A = r(7), f = function(S) {
            function D(k) {
              var L, h = b.default(`<div class="w-e-menu" data-title="引用">
                <i class="w-e-icon-quotes-left"></i>
            </div>`);
              return L = S.call(this, h, k) || this, g.default(k), L;
            }
            return p.__extends(D, S), D.prototype.clickHandler = function() {
              var k, L = this.editor, h = L.selection.isSelectionEmpty(), E = L.selection.getSelectionRangeTopNodes(), w = E[E.length - 1];
              if (this.getTopNodeName() !== "BLOCKQUOTE") {
                var O = _.default(E);
                O.insertAfter(w), this.delSelectNode(E);
                var R = (k = O.childNodes()) === null || k === void 0 ? void 0 : k.last().getNode();
                return R == null ? void 0 : (R.textContent ? L.selection.moveCursor(R) : L.selection.moveCursor(R, 0), this.tryChangeActive(), void b.default(A.EMPTY_P).insertAfter(O));
              }
              var I = b.default(w.childNodes()), H = I.length, $ = w;
              (0, C.default)(I).call(I, function(Q) {
                var U = b.default(Q);
                U.insertAfter($), $ = U;
              }), w.remove(), L.selection.moveCursor(I.elems[H - 1]), this.tryChangeActive(), h && (L.selection.collapseRange(), L.selection.restoreSelection());
            }, D.prototype.tryChangeActive = function() {
              var k;
              ((k = this.editor.selection.getSelectionRangeTopNodes()[0]) === null || k === void 0 ? void 0 : k.getNodeName()) === "BLOCKQUOTE" ? this.active() : this.unActive();
            }, D.prototype.getTopNodeName = function() {
              var k = this.editor.selection.getSelectionRangeTopNodes()[0];
              return k == null ? void 0 : k.getNodeName();
            }, D.prototype.delSelectNode = function(k) {
              (0, C.default)(k).call(k, function(L) {
                L.remove();
              });
            }, D;
          }(x.default);
          d.default = f;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = r(7), C = u.__importDefault(r(3));
          d.default = function(p) {
            p.txt.eventHooks.enterDownEvents.push(function(b) {
              var x, g = p.selection.getSelectionContainerElem(), _ = p.selection.getSelectionRangeTopNodes()[0];
              if ((_ == null ? void 0 : _.getNodeName()) === "BLOCKQUOTE") {
                if (g.getNodeName() === "BLOCKQUOTE") {
                  var A = (x = g.childNodes()) === null || x === void 0 ? void 0 : x.getNode();
                  p.selection.moveCursor(A);
                }
                if (g.text() === "") {
                  b.preventDefault(), g.remove();
                  var f = C.default(v.EMPTY_P);
                  f.insertAfter(_), p.selection.moveCursor(f.getNode(), 0);
                }
                _.text() === "" && _.remove();
              }
            });
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2).__importDefault(r(3));
          d.default = function(b) {
            var x = p.default("<blockquote></blockquote>");
            return (0, C.default)(b).call(b, function(g) {
              x.append(g.clone(!0));
            }), x;
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(25));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2), b = p.__importDefault(r(23)), x = p.__importDefault(r(3)), g = r(6), _ = function(A) {
            function f(S) {
              var D, k = this, L = x.default(`<div class="w-e-menu" data-title="背景色">
                <i class="w-e-icon-paint-brush"></i>
            </div>`), h = { width: 120, title: "背景颜色", type: "inline-block", list: (0, C.default)(D = S.config.colors).call(D, function(E) {
                return { $elem: x.default('<i style="color:' + E + ';" class="w-e-icon-paint-brush"></i>'), value: E };
              }), clickHandler: function(E) {
                k.command(E);
              } };
              return k = A.call(this, L, S, h) || this;
            }
            return p.__extends(f, A), f.prototype.command = function(S) {
              var D, k = this.editor, L = k.selection.isSelectionEmpty(), h = (D = k.selection.getSelectionContainerElem()) === null || D === void 0 ? void 0 : D.elems[0];
              if (h != null) {
                var E = (h == null ? void 0 : h.nodeName.toLowerCase()) !== "p", w = h == null ? void 0 : h.style.backgroundColor, O = g.hexToRgb(S) === w;
                if (L) {
                  if (E && !O) {
                    var R = k.selection.getSelectionRangeTopNodes();
                    k.selection.createRangeByElem(R[0]), k.selection.moveCursor(R[0].elems[0]);
                  }
                  k.selection.createEmptyRange();
                }
                k.cmd.do("backColor", S), L && (k.selection.collapseRange(), k.selection.restoreSelection());
              }
            }, f.prototype.tryChangeActive = function() {
            }, f;
          }(b.default);
          d.default = _;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(25));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2), b = p.__importDefault(r(23)), x = p.__importDefault(r(3)), g = function(_) {
            function A(f) {
              var S, D = this, k = x.default(`<div class="w-e-menu" data-title="文字颜色">
                <i class="w-e-icon-pencil2"></i>
            </div>`), L = { width: 120, title: "文字颜色", type: "inline-block", list: (0, C.default)(S = f.config.colors).call(S, function(h) {
                return { $elem: x.default('<i style="color:' + h + ';" class="w-e-icon-pencil2"></i>'), value: h };
              }), clickHandler: function(h) {
                D.command(h);
              } };
              return D = _.call(this, k, f, L) || this;
            }
            return p.__extends(A, _), A.prototype.command = function(f) {
              var S, D = this.editor, k = D.selection.isSelectionEmpty(), L = (S = D.selection.getSelectionContainerElem()) === null || S === void 0 ? void 0 : S.elems[0];
              if (L != null) {
                var h = (L == null ? void 0 : L.nodeName.toLowerCase()) !== "p", E = (L == null ? void 0 : L.getAttribute("color")) === f;
                if (k) {
                  if (h && !E) {
                    var w = D.selection.getSelectionRangeTopNodes();
                    D.selection.createRangeByElem(w[0]), D.selection.moveCursor(w[0].elems[0]);
                  }
                  D.selection.setRangeToContainerElem(L), D.selection.createEmptyRange();
                }
                var O = D.selection.getSelectionText();
                if (L.nodeName === "A" && L.textContent === O) {
                  var R = x.default("<span>&#8203;</span>").getNode();
                  L.appendChild(R);
                }
                D.cmd.do("foreColor", f), k && (D.selection.collapseRange(), D.selection.restoreSelection());
              }
            }, A.prototype.tryChangeActive = function() {
            }, A;
          }(b.default);
          d.default = g;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(3)), C = u.__importDefault(r(31)), p = u.__importDefault(r(33)), b = u.__importDefault(r(339)), x = u.__importDefault(r(345)), g = function(_) {
            function A(f) {
              var S, D = v.default(`<div class="w-e-menu" data-title="视频">
                <i class="w-e-icon-play"></i>
            </div>`);
              return S = _.call(this, D, f) || this, x.default(f), S;
            }
            return u.__extends(A, _), A.prototype.clickHandler = function() {
              this.createPanel("");
            }, A.prototype.createPanel = function(f) {
              var S = b.default(this.editor, f);
              new C.default(this, S).create();
            }, A.prototype.tryChangeActive = function() {
            }, A;
          }(p.default);
          d.default = g;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(19));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2), b = r(6), x = p.__importDefault(r(3)), g = p.__importDefault(r(340)), _ = r(7);
          d.default = function(A, f) {
            var S = A.config, D = new g.default(A), k = b.getRandom("input-iframe"), L = b.getRandom("btn-ok"), h = b.getRandom("input-upload"), E = b.getRandom("btn-local-ok"), w = [{ title: A.i18next.t("menus.panelMenus.video.上传视频"), tpl: `<div class="w-e-up-video-container">
                    <div id="` + E + `" class="w-e-up-btn">
                        <i class="w-e-icon-upload2"></i>
                    </div>
                    <div style="display:none;">
                        <input id="` + h + `" type="file" accept="video/*"/>
                    </div>
                 </div>`, events: [{ selector: "#" + E, type: "click", fn: function() {
              var R = x.default("#" + h).elems[0];
              if (!R) return !0;
              R.click();
            } }, { selector: "#" + h, type: "change", fn: function() {
              var R = x.default("#" + h).elems[0];
              if (!R) return !0;
              var I = R.files;
              return I.length && D.uploadVideo(I), !0;
            } }] }, { title: A.i18next.t("menus.panelMenus.video.插入视频"), tpl: `<div>
                    <input 
                        id="` + k + `" 
                        type="text" 
                        class="block" 
                        placeholder="` + A.i18next.t("如") + `：<iframe src=... ></iframe>"/>
                    </td>
                    <div class="w-e-button-container">
                        <button type="button" id="` + L + `" class="right">
                            ` + A.i18next.t("插入") + `
                        </button>
                    </div>
                </div>`, events: [{ selector: "#" + L, type: "click", fn: function() {
              var R, I = x.default("#" + k), H = (0, C.default)(R = I.val()).call(R);
              if (H && function($) {
                var Q = A.config.onlineVideoCheck($);
                return Q === !0 || (typeof Q == "string" && A.config.customAlert(Q, "error"), !1);
              }(H)) return function($) {
                A.cmd.do("insertHTML", $ + _.EMPTY_P), A.config.onlineVideoCallback($);
              }(H), !0;
            } }] }], O = { width: 300, height: 0, tabs: [] };
            return window.FileReader && (S.uploadVideoServer || S.customUploadVideo) && O.tabs.push(w[0]), S.showLinkVideo && O.tabs.push(w[1]), O;
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(127)), p = u(r(53)), b = u(r(4)), x = u(r(26));
          (0, v.default)(d, "__esModule", { value: !0 });
          var g = r(2), _ = r(6), A = g.__importDefault(r(130)), f = g.__importDefault(r(131)), S = r(7), D = r(6), k = function() {
            function L(h) {
              this.editor = h;
            }
            return L.prototype.uploadVideo = function(h) {
              var E = this;
              if (h.length) {
                var w = this.editor, O = w.config, R = function(he) {
                  return w.i18next.t("validate." + he);
                }, I = O.uploadVideoServer, H = O.uploadVideoMaxSize / 1024, $ = O.uploadVideoName, Q = O.uploadVideoParams, U = O.uploadVideoParamsWithUrl, Y = O.uploadVideoHeaders, X = O.uploadVideoHooks, G = O.uploadVideoTimeout, J = O.withVideoCredentials, ee = O.customUploadVideo, re = O.uploadVideoAccept, oe = [], ae = [];
                if (_.arrForEach(h, function(he) {
                  var ke = he.name, je = he.size / 1024 / 1024;
                  ke && je && (re instanceof Array ? (0, C.default)(re).call(re, function(He) {
                    return He === ke.split(".")[ke.split(".").length - 1];
                  }) ? H < je ? ae.push("【" + ke + "】" + R("大于") + " " + H + "M") : oe.push(he) : ae.push("【" + ke + "】" + R("不是视频")) : ae.push("【" + re + "】" + R("uploadVideoAccept 不是Array")));
                }), ae.length) O.customAlert(R("视频验证未通过") + `: 
` + ae.join(`
`), "warning");
                else if (oe.length !== 0) if (ee && typeof ee == "function") {
                  var se;
                  ee(oe, (0, p.default)(se = this.insertVideo).call(se, this));
                } else {
                  var ve = new FormData();
                  if ((0, b.default)(oe).call(oe, function(he, ke) {
                    var je = $ || he.name;
                    oe.length > 1 && (je += ke + 1), ve.append(je, he);
                  }), I) {
                    var Ae = I.split("#");
                    I = Ae[0];
                    var ye = Ae[1] || "";
                    (0, b.default)(_).call(_, Q, function(he, ke) {
                      U && ((0, x.default)(I).call(I, "?") > 0 ? I += "&" : I += "?", I = I + he + "=" + ke), ve.append(he, ke);
                    }), ye && (I += "#" + ye);
                    var ce = A.default(I, { timeout: G, formData: ve, headers: Y, withCredentials: !!J, beforeSend: function(he) {
                      if (X.before) return X.before(he, w, oe);
                    }, onTimeout: function(he) {
                      O.customAlert(R("上传视频超时"), "error"), X.timeout && X.timeout(he, w);
                    }, onProgress: function(he, ke) {
                      var je = new f.default(w);
                      ke.lengthComputable && (he = ke.loaded / ke.total, je.show(he));
                    }, onError: function(he) {
                      O.customAlert(R("上传视频错误"), "error", R("上传视频错误") + "，" + R("服务器返回状态") + ": " + he.status), X.error && X.error(he, w);
                    }, onFail: function(he, ke) {
                      O.customAlert(R("上传视频失败"), "error", R("上传视频返回结果错误") + "，" + R("返回结果") + ": " + ke), X.fail && X.fail(he, w, ke);
                    }, onSuccess: function(he, ke) {
                      if (X.customInsert) {
                        var je;
                        X.customInsert((0, p.default)(je = E.insertVideo).call(je, E), ke, w);
                      } else {
                        if (ke.errno != "0") return O.customAlert(R("上传视频失败"), "error", R("上传视频返回结果错误") + "，" + R("返回结果") + " errno=" + ke.errno), void (X.fail && X.fail(he, w, ke));
                        var He = ke.data;
                        E.insertVideo(He.url), X.success && X.success(he, w, ke);
                      }
                    } });
                    typeof ce == "string" && O.customAlert(ce, "error");
                  }
                }
                else O.customAlert(R("传入的文件不合法"), "warning");
              }
            }, L.prototype.insertVideo = function(h) {
              var E = this.editor, w = E.config, O = function(I, H) {
                return H === void 0 && (H = "validate."), E.i18next.t(H + I);
              };
              if (w.customInsertVideo) w.customInsertVideo(h);
              else {
                D.UA.isFirefox ? E.cmd.do("insertHTML", '<p data-we-video-p="true"><video src="' + h + '" controls="controls" style="max-width:100%"></video></p><p>&#8203</p>') : E.cmd.do("insertHTML", '<video src="' + h + '" controls="controls" style="max-width:100%"></video>' + S.EMPTY_P);
                var R = document.createElement("video");
                R.onload = function() {
                  R = null;
                }, R.onerror = function() {
                  w.customAlert(O("插入视频错误"), "error", "wangEditor: " + O("插入视频错误") + "，" + O("视频链接") + ' "' + h + '"，' + O("下载链接失败")), R = null;
                }, R.onabort = function() {
                  return R = null;
                }, R.src = h;
              }
            }, L;
          }();
          d.default = k;
        }, function(m, d, r) {
          m.exports = r(342);
        }, function(m, d, r) {
          var u = r(343);
          m.exports = u;
        }, function(m, d, r) {
          r(344);
          var u = r(12);
          m.exports = u.Date.now;
        }, function(m, d, r) {
          r(5)({ target: "Date", stat: !0 }, { now: function() {
            return (/* @__PURE__ */ new Date()).getTime();
          } });
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(346)), C = u.__importDefault(r(347));
          d.default = function(p) {
            v.default(p), C.default(p);
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 }), d.createShowHideFn = void 0;
          var u = r(2), v = u.__importDefault(r(3)), C = u.__importDefault(r(34));
          function p(b) {
            var x, g = function(_, A) {
              return A === void 0 && (A = ""), b.i18next.t(A + _);
            };
            return { showVideoTooltip: function(_) {
              var A = [{ $elem: v.default("<span class='w-e-icon-trash-o'></span>"), onClick: function(f, S) {
                return S.remove(), !0;
              } }, { $elem: v.default("<span>100%</span>"), onClick: function(f, S) {
                return S.attr("width", "100%"), S.removeAttr("height"), !0;
              } }, { $elem: v.default("<span>50%</span>"), onClick: function(f, S) {
                return S.attr("width", "50%"), S.removeAttr("height"), !0;
              } }, { $elem: v.default("<span>30%</span>"), onClick: function(f, S) {
                return S.attr("width", "30%"), S.removeAttr("height"), !0;
              } }, { $elem: v.default("<span>" + g("重置") + "</span>"), onClick: function(f, S) {
                return S.removeAttr("width"), S.removeAttr("height"), !0;
              } }];
              (x = new C.default(b, _, A)).create();
            }, hideVideoTooltip: function() {
              x && (x.remove(), x = null);
            } };
          }
          d.createShowHideFn = p, d.default = function(b) {
            var x = p(b), g = x.showVideoTooltip, _ = x.hideVideoTooltip;
            b.txt.eventHooks.videoClickEvents.push(g), b.txt.eventHooks.clickEvents.push(_), b.txt.eventHooks.keyupEvents.push(_), b.txt.eventHooks.toolbarClickEvents.push(_), b.txt.eventHooks.menuClickEvents.push(_), b.txt.eventHooks.textScrollEvents.push(_), b.txt.eventHooks.changeEvents.push(_);
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(6);
          d.default = function(v) {
            if (u.UA.isFirefox) {
              var C = v.txt, p = v.selection;
              C.eventHooks.keydownEvents.push(function(b) {
                var x = p.getSelectionContainerElem();
                if (x) {
                  var g = x.getNodeTop(v), _ = g.length && g.prev().length ? g.prev() : null;
                  _ && _.attr("data-we-video-p") && p.getCursorPos() === 0 && b.keyCode === 8 && _.remove();
                }
              });
            }
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(25));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2), b = r(7), x = p.__importDefault(r(3)), g = p.__importDefault(r(31)), _ = p.__importDefault(r(33)), A = p.__importDefault(r(349)), f = p.__importDefault(r(361)), S = function(D) {
            function k(L) {
              var h, E = this, w = x.default('<div class="w-e-menu" data-title="图片"><i class="w-e-icon-image"></i></div>'), O = f.default(L);
              return O.onlyUploadConf && (w = O.onlyUploadConf.$elem, (0, C.default)(h = O.onlyUploadConf.events).call(h, function(R) {
                var I = R.type, H = R.fn || b.EMPTY_FN;
                w.on(I, function($) {
                  $.stopPropagation(), H($);
                });
              })), (E = D.call(this, w, L) || this).imgPanelConfig = O, A.default(L), E;
            }
            return p.__extends(k, D), k.prototype.clickHandler = function() {
              this.imgPanelConfig.onlyUploadConf || this.createPanel();
            }, k.prototype.createPanel = function() {
              var L = this.imgPanelConfig, h = new g.default(this, L);
              this.setPanel(h), h.create();
            }, k.prototype.tryChangeActive = function() {
            }, k;
          }(_.default);
          d.default = S;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(350)), C = u.__importDefault(r(351)), p = u.__importDefault(r(352)), b = u.__importDefault(r(360));
          d.default = function(x) {
            v.default(x), C.default(x), p.default(x), b.default(x);
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = r(124), C = u.__importDefault(r(97));
          function p(b, x) {
            if (function(_, A) {
              for (var f, S = ((f = A.clipboardData) === null || f === void 0 ? void 0 : f.types) || [], D = 0; D < S.length; D++) if (S[D] === "Files") return !0;
              return !1;
            }(0, b) || !function(_, A) {
              var f = _.config, S = f.pasteFilterStyle, D = f.pasteIgnoreImg;
              return !!v.getPasteHtml(A, S, D) || !!v.getPasteText(A);
            }(x, b)) {
              var g = v.getPasteImgs(b);
              g.length && new C.default(x).uploadImg(g);
            }
          }
          d.default = function(b) {
            b.txt.eventHooks.pasteEvents.unshift(function(x) {
              p(x, b);
            });
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2).__importDefault(r(97));
          d.default = function(v) {
            v.txt.eventHooks.dropEvents.push(function(C) {
              var p = C.dataTransfer && C.dataTransfer.files;
              p && p.length && new u.default(v).uploadImg(p);
            });
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(30)), p = u(r(353));
          (0, v.default)(d, "__esModule", { value: !0 }), d.createShowHideFn = void 0;
          var b = r(2).__importDefault(r(3));
          r(358);
          var x = r(6);
          function g(A, f, S, D, k) {
            A.attr("style", "width:" + f + "px; height:" + S + "px; left:" + D + "px; top:" + k + "px;");
          }
          function _(A) {
            var f, S = A.$textContainerElem, D = function(L, h) {
              var E = b.default(`<div class="w-e-img-drag-mask">
            <div class="w-e-img-drag-show-size"></div>
            <div class="w-e-img-drag-rb"></div>
         </div>`);
              return E.hide(), h.append(E), E;
            }(0, S);
            function k() {
              (0, C.default)(S).call(S, ".w-e-img-drag-mask").hide();
            }
            return function(L, h) {
              L.on("click", function(E) {
                E.stopPropagation();
              }), L.on("mousedown", ".w-e-img-drag-rb", function(E) {
                if (E.preventDefault(), f) {
                  var w = E.clientX, O = E.clientY, R = h.getBoundingClientRect(), I = f.getBoundingClientRect(), H = I.width, $ = I.height, Q = I.left - R.left, U = I.top - R.top, Y = H / $, X = H, G = $, J = b.default(document);
                  J.on("mousemove", re), J.on("mouseup", oe), J.on("mouseleave", ee);
                }
                function ee() {
                  J.off("mousemove", re), J.off("mouseup", oe);
                }
                function re(ae) {
                  ae.stopPropagation(), ae.preventDefault(), X = H + (ae.clientX - w), G = $ + (ae.clientY - O), X / G != Y && (G = X / Y), X = (0, p.default)(X.toFixed(2)), G = (0, p.default)(G.toFixed(2)), (0, C.default)(L).call(L, ".w-e-img-drag-show-size").text(X.toFixed(2).replace(".00", "") + "px * " + G.toFixed(2).replace(".00", "") + "px"), g(L, X, G, Q, U);
                }
                function oe() {
                  f.attr("width", X + ""), f.attr("height", G + "");
                  var ae = f.getBoundingClientRect();
                  g(L, X, G, ae.left - R.left, ae.top - R.top), ee();
                }
              });
            }(D, S), b.default(document).on("click", k), A.beforeDestroy(function() {
              b.default(document).off("click", k);
            }), { showDrag: function(L) {
              if (x.UA.isIE()) return !1;
              L && function(h, E, w) {
                var O = h.getBoundingClientRect(), R = w.getBoundingClientRect(), I = R.width.toFixed(2), H = R.height.toFixed(2);
                (0, C.default)(E).call(E, ".w-e-img-drag-show-size").text(I + "px * " + H + "px"), g(E, (0, p.default)(I), (0, p.default)(H), R.left - O.left, R.top - O.top), E.show();
              }(S, D, f = L);
            }, hideDrag: k };
          }
          d.createShowHideFn = _, d.default = function(A) {
            var f = _(A), S = f.showDrag, D = f.hideDrag;
            A.txt.eventHooks.imgClickEvents.push(S), A.txt.eventHooks.textScrollEvents.push(D), A.txt.eventHooks.keyupEvents.push(D), A.txt.eventHooks.toolbarClickEvents.push(D), A.txt.eventHooks.menuClickEvents.push(D), A.txt.eventHooks.changeEvents.push(D);
          };
        }, function(m, d, r) {
          m.exports = r(354);
        }, function(m, d, r) {
          var u = r(355);
          m.exports = u;
        }, function(m, d, r) {
          r(356);
          var u = r(12);
          m.exports = u.parseFloat;
        }, function(m, d, r) {
          var u = r(5), v = r(357);
          u({ global: !0, forced: parseFloat != v }, { parseFloat: v });
        }, function(m, d, r) {
          var u = r(8), v = r(91).trim, C = r(71), p = u.parseFloat, b = 1 / p(C + "-0") != -1 / 0;
          m.exports = b ? function(x) {
            var g = v(String(x)), _ = p(g);
            return _ === 0 && g.charAt(0) == "-" ? -0 : _;
          } : p;
        }, function(m, d, r) {
          var u = r(20), v = r(359);
          typeof (v = v.__esModule ? v.default : v) == "string" && (v = [[m.i, v, ""]]);
          var C = { insert: "head", singleton: !1 };
          u(v, C), m.exports = v.locals || {};
        }, function(m, d, r) {
          (d = r(21)(!1)).push([m.i, `.w-e-text-container {
  overflow: hidden;
}
.w-e-img-drag-mask {
  position: absolute;
  z-index: 1;
  border: 1px dashed #ccc;
  box-sizing: border-box;
}
.w-e-img-drag-mask .w-e-img-drag-rb {
  position: absolute;
  right: -5px;
  bottom: -5px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #ccc;
  cursor: se-resize;
}
.w-e-img-drag-mask .w-e-img-drag-show-size {
  min-width: 110px;
  height: 22px;
  line-height: 22px;
  font-size: 14px;
  color: #999;
  position: absolute;
  left: 0;
  top: 0;
  background-color: #999;
  color: #fff;
  border-radius: 2px;
  padding: 0 5px;
}
`, ""]), m.exports = d;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 }), d.createShowHideFn = void 0;
          var u = r(2), v = u.__importDefault(r(3)), C = u.__importDefault(r(34));
          function p(b) {
            var x, g = function(_, A) {
              return A === void 0 && (A = ""), b.i18next.t(A + _);
            };
            return { showImgTooltip: function(_) {
              var A = [{ $elem: v.default("<span class='w-e-icon-trash-o'></span>"), onClick: function(f, S) {
                return f.selection.createRangeByElem(S), f.selection.restoreSelection(), f.cmd.do("delete"), !0;
              } }, { $elem: v.default("<span>30%</span>"), onClick: function(f, S) {
                return S.attr("width", "30%"), S.removeAttr("height"), !0;
              } }, { $elem: v.default("<span>50%</span>"), onClick: function(f, S) {
                return S.attr("width", "50%"), S.removeAttr("height"), !0;
              } }, { $elem: v.default("<span>100%</span>"), onClick: function(f, S) {
                return S.attr("width", "100%"), S.removeAttr("height"), !0;
              } }];
              A.push({ $elem: v.default("<span>" + g("重置") + "</span>"), onClick: function(f, S) {
                return S.removeAttr("width"), S.removeAttr("height"), !0;
              } }), _.attr("data-href") && A.push({ $elem: v.default("<span>" + g("查看链接") + "</span>"), onClick: function(f, S) {
                var D = S.attr("data-href");
                return D && (D = decodeURIComponent(D), window.open(D, "_target")), !0;
              } }), (x = new C.default(b, _, A)).create();
            }, hideImgTooltip: function() {
              x && (x.remove(), x = null);
            } };
          }
          d.createShowHideFn = p, d.default = function(b) {
            var x = p(b), g = x.showImgTooltip, _ = x.hideImgTooltip;
            b.txt.eventHooks.imgClickEvents.push(g), b.txt.eventHooks.clickEvents.push(_), b.txt.eventHooks.keyupEvents.push(_), b.txt.eventHooks.toolbarClickEvents.push(_), b.txt.eventHooks.menuClickEvents.push(_), b.txt.eventHooks.textScrollEvents.push(_), b.txt.eventHooks.imgDragBarMouseDownEvents.push(_), b.txt.eventHooks.changeEvents.push(_);
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(25)), p = u(r(19));
          (0, v.default)(d, "__esModule", { value: !0 });
          var b = r(2), x = b.__importDefault(r(3)), g = r(6), _ = b.__importDefault(r(97));
          d.default = function(A) {
            var f, S = A.config, D = new _.default(A), k = g.getRandom("up-trigger-id"), L = g.getRandom("up-file-id"), h = g.getRandom("input-link-url"), E = g.getRandom("input-link-url-alt"), w = g.getRandom("input-link-url-href"), O = g.getRandom("btn-link"), R = function(G, J) {
              return J === void 0 && (J = "menus.panelMenus.image."), A.i18next.t(J + G);
            }, I = S.uploadImgMaxLength === 1 ? "" : 'multiple="multiple"', H = (0, C.default)(f = S.uploadImgAccept).call(f, function(G) {
              return "image/" + G;
            }).join(","), $ = function(G, J, ee) {
              return '<div class="' + G + '" data-title="' + ee + `">
            <div id="` + k + `" class="w-e-up-btn">
                <i class="` + J + `"></i>
            </div>
            <div style="display:none;">
                <input id="` + L + '" type="file" ' + I + ' accept="' + H + `"/>
            </div>
        </div>`;
            }, Q = [{ selector: "#" + k, type: "click", fn: function() {
              var G = x.default("#" + L).elems[0];
              if (!G) return !0;
              G.click();
            } }, { selector: "#" + L, type: "change", fn: function() {
              var G = x.default("#" + L).elems[0];
              if (!G) return !0;
              var J = G.files;
              return J != null && J.length && D.uploadImg(J), !0;
            } }], U = [`<input
            id="` + h + `"
            type="text"
            class="block"
            placeholder="` + R("图片地址") + '"/>'];
            S.showLinkImgAlt && U.push(`
        <input
            id="` + E + `"
            type="text"
            class="block"
            placeholder="` + R("图片文字说明") + '"/>'), S.showLinkImgHref && U.push(`
        <input
            id="` + w + `"
            type="text"
            class="block"
            placeholder="` + R("跳转链接") + '"/>');
            var Y = [{ title: R("上传图片"), tpl: $("w-e-up-img-container", "w-e-icon-upload2", ""), events: Q }, { title: R("网络图片"), tpl: `<div>
                    ` + U.join("") + `
                    <div class="w-e-button-container">
                        <button type="button" id="` + O + '" class="right">' + R("插入", "") + `</button>
                    </div>
                </div>`, events: [{ selector: "#" + O, type: "click", fn: function() {
              var G, J, ee, re, oe, ae, se, ve = x.default("#" + h), Ae = (0, p.default)(G = ve.val()).call(G);
              if (Ae && (S.showLinkImgAlt && (J = (0, p.default)(ee = x.default("#" + E).val()).call(ee)), S.showLinkImgHref && (re = (0, p.default)(oe = x.default("#" + w).val()).call(oe)), ae = Ae, (se = S.linkImgCheck(ae)) === !0 || (typeof se == "string" && S.customAlert(se, "error"), 0))) return D.insertImg(Ae, J, re), !0;
            } }] }], X = { width: 300, height: 0, tabs: [], onlyUploadConf: { $elem: x.default($("w-e-menu", "w-e-icon-image", "图片")), events: Q } };
            return window.FileReader && (S.uploadImgShowBase64 || S.uploadImgServer || S.customUploadImg) && X.tabs.push(Y[0]), S.showLinkImg && (X.tabs.push(Y[1]), X.onlyUploadConf = void 0), X;
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2), b = p.__importDefault(r(3)), x = p.__importDefault(r(23)), g = p.__importDefault(r(363)), _ = function(A) {
            function f(S) {
              var D = this, k = b.default(`<div class="w-e-menu" data-title="缩进">
                <i class="w-e-icon-indent-increase"></i>
            </div>`), L = { width: 130, title: "设置缩进", type: "list", list: [{ $elem: b.default(`<p>
                            <i class="w-e-icon-indent-increase w-e-drop-list-item"></i>
                            ` + S.i18next.t("menus.dropListMenu.indent.增加缩进") + `
                        <p>`), value: "increase" }, { $elem: b.default(`<p>
                            <i class="w-e-icon-indent-decrease w-e-drop-list-item"></i>
                            ` + S.i18next.t("menus.dropListMenu.indent.减少缩进") + `
                        <p>`), value: "decrease" }], clickHandler: function(h) {
                D.command(h);
              } };
              return D = A.call(this, k, S, L) || this;
            }
            return p.__extends(f, A), f.prototype.command = function(S) {
              var D = this.editor, k = D.selection.getSelectionContainerElem();
              if (k && D.$textElem.equal(k)) {
                var L = D.selection.getSelectionRangeTopNodes();
                L.length > 0 && (0, C.default)(L).call(L, function(h) {
                  g.default(b.default(h), S, D);
                });
              } else k && k.length > 0 && (0, C.default)(k).call(k, function(h) {
                g.default(b.default(h), S, D);
              });
              D.selection.restoreSelection(), this.tryChangeActive();
            }, f.prototype.tryChangeActive = function() {
              var S = this.editor, D = S.selection.getSelectionStartElem(), k = b.default(D).getNodeTop(S);
              k.length <= 0 || (k.elems[0].style.paddingLeft != "" ? this.active() : this.unActive());
            }, f;
          }(x.default);
          d.default = _;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(43)), p = u(r(19));
          (0, v.default)(d, "__esModule", { value: !0 });
          var b = r(2), x = b.__importDefault(r(364)), g = b.__importDefault(r(365)), _ = /^(\d+)(\w+)$/, A = /^(\d+)%$/;
          function f(S) {
            var D = S.config.indentation;
            if (typeof D == "string") {
              if (_.test(D)) {
                var k, L = (0, C.default)(k = (0, p.default)(D).call(D).match(_)).call(k, 1, 3), h = L[0], E = L[1];
                return { value: Number(h), unit: E };
              }
              if (A.test(D)) return { value: Number((0, p.default)(D).call(D).match(A)[1]), unit: "%" };
            } else if (D.value !== void 0 && D.unit) return D;
            return { value: 2, unit: "em" };
          }
          d.default = function(S, D, k) {
            var L = S.getNodeTop(k);
            /^P$/i.test(L.getNodeName()) && (D === "increase" ? x.default(L, f(k)) : D === "decrease" && g.default(L, f(k)));
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(43));
          (0, v.default)(d, "__esModule", { value: !0 }), d.default = function(p, b) {
            var x = p.elems[0];
            if (x.style.paddingLeft === "") p.css("padding-left", b.value + b.unit);
            else {
              var g = x.style.paddingLeft, _ = (0, C.default)(g).call(g, 0, g.length - b.unit.length), A = Number(_) + b.value;
              p.css("padding-left", "" + A + b.unit);
            }
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(43));
          (0, v.default)(d, "__esModule", { value: !0 }), d.default = function(p, b) {
            var x = p.elems[0];
            if (x.style.paddingLeft !== "") {
              var g = x.style.paddingLeft, _ = (0, C.default)(g).call(g, 0, g.length - b.unit.length), A = Number(_) - b.value;
              A > 0 ? p.css("padding-left", "" + A + b.unit) : p.css("padding-left", "");
            }
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(3)), C = u.__importDefault(r(33)), p = u.__importDefault(r(31)), b = u.__importDefault(r(367)), x = function(g) {
            function _(A) {
              var f = v.default(`<div class="w-e-menu" data-title="表情">
                <i class="w-e-icon-happy"></i>
            </div>`);
              return g.call(this, f, A) || this;
            }
            return u.__extends(_, g), _.prototype.createPanel = function() {
              var A = b.default(this.editor);
              new p.default(this, A).create();
            }, _.prototype.clickHandler = function() {
              this.createPanel();
            }, _.prototype.tryChangeActive = function() {
            }, _;
          }(C.default);
          d.default = x;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(25)), p = u(r(72)), b = u(r(19));
          (0, v.default)(d, "__esModule", { value: !0 });
          var x = r(2).__importDefault(r(3));
          d.default = function(g) {
            var _ = g.config.emotions;
            function A(f) {
              var S, D, k = [];
              return f.type == "image" ? (k = (0, C.default)(S = f.content).call(S, function(L) {
                return typeof L == "string" ? "" : '<span  title="' + L.alt + `">
                    <img class="eleImg" data-emoji="` + L.alt + '" style src="' + L.src + '" alt="[' + L.alt + `]">
                </span>`;
              }), k = (0, p.default)(k).call(k, function(L) {
                return L !== "";
              })) : k = (0, C.default)(D = f.content).call(D, function(L) {
                return '<span class="eleImg" title="' + L + '">' + L + "</span>";
              }), k.join("").replace(/&nbsp;/g, "");
            }
            return { width: 300, height: 230, tabs: (0, C.default)(_).call(_, function(f) {
              return { title: g.i18next.t("menus.panelMenus.emoticon." + f.title), tpl: "<div>" + A(f) + "</div>", events: [{ selector: ".eleImg", type: "click", fn: function(S) {
                var D, k, L = x.default(S.target);
                return D = L.getNodeName() === "IMG" ? (0, b.default)(k = L.parent().html()).call(k) : "<span>" + L.html() + "</span>", g.cmd.do("insertHTML", D), !0;
              } }] };
            }) };
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 }), d.createListHandle = d.ClassType = void 0;
          var u, v = r(2), C = v.__importDefault(r(3)), p = v.__importDefault(r(369)), b = v.__importDefault(r(371)), x = v.__importDefault(r(372)), g = v.__importDefault(r(373)), _ = v.__importDefault(r(374));
          (function(S) {
            S.Wrap = "WrapListHandle", S.Join = "JoinListHandle", S.StartJoin = "StartJoinListHandle", S.EndJoin = "EndJoinListHandle", S.Other = "OtherListHandle";
          })(u = d.ClassType || (d.ClassType = {}));
          var A = { WrapListHandle: p.default, JoinListHandle: b.default, StartJoinListHandle: x.default, EndJoinListHandle: g.default, OtherListHandle: _.default };
          d.createListHandle = function(S, D, k) {
            if (S === u.Other && k === void 0) throw new Error("other 类需要传入 range");
            return S !== u.Other ? new A[S](D) : new A[S](D, k);
          };
          var f = function() {
            function S(D) {
              this.handle = D, this.handle.exec();
            }
            return S.prototype.getSelectionRangeElem = function() {
              return C.default(this.handle.selectionRangeElem.get());
            }, S;
          }();
          d.default = f;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2), b = p.__importDefault(r(3)), x = r(55), g = r(44), _ = function(A) {
            function f(S) {
              return A.call(this, S) || this;
            }
            return p.__extends(f, A), f.prototype.exec = function() {
              var S, D = this.options, k = D.listType, L = D.listTarget, h = D.$selectionElem, E = D.$startElem, w = D.$endElem, O = [], R = h == null ? void 0 : h.getNodeName(), I = E.prior, H = w.prior;
              if (!E.prior && !w.prior || !(I != null && I.prev().length) && !(H != null && H.next().length)) {
                var $;
                (0, C.default)($ = h == null ? void 0 : h.children()).call($, function(ee) {
                  O.push(b.default(ee));
                }), R === k ? S = g.createElementFragment(O, g.createDocumentFragment(), "p") : (S = g.createElement(L), (0, C.default)(O).call(O, function(ee) {
                  S.append(ee.elems[0]);
                })), this.selectionRangeElem.set(S), g.insertBefore(h, S, h.elems[0]), h.remove();
              } else {
                for (var Q = I; Q.length; ) O.push(Q), Q = H != null && H.equal(Q) ? b.default(void 0) : Q.next();
                var U = I.prev(), Y = H.next();
                if (R === k ? S = g.createElementFragment(O, g.createDocumentFragment(), "p") : (S = g.createElement(L), (0, C.default)(O).call(O, function(ee) {
                  S.append(ee.elems[0]);
                })), U.length && Y.length) {
                  for (var X = []; Y.length; ) X.push(Y), Y = Y.next();
                  var G = g.createElement(R);
                  (0, C.default)(X).call(X, function(ee) {
                    G.append(ee.elems[0]);
                  }), b.default(G).insertAfter(h), this.selectionRangeElem.set(S), (J = h.next()).length ? g.insertBefore(h, S, J.elems[0]) : h.parent().elems[0].append(S);
                } else if (U.length) {
                  var J;
                  this.selectionRangeElem.set(S), (J = h.next()).length ? g.insertBefore(h, S, J.elems[0]) : h.parent().elems[0].append(S);
                } else this.selectionRangeElem.set(S), g.insertBefore(h, S, h.elems[0]);
              }
            }, f;
          }(x.ListHandle);
          d.default = _;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = function() {
            function b() {
              this._element = null;
            }
            return b.prototype.set = function(x) {
              if (x instanceof DocumentFragment) {
                var g, _ = [];
                (0, C.default)(g = x.childNodes).call(g, function(A) {
                  _.push(A);
                }), x = _;
              }
              this._element = x;
            }, b.prototype.get = function() {
              return this._element;
            }, b.prototype.clear = function() {
              this._element = null;
            }, b;
          }();
          d.default = p;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2), b = p.__importDefault(r(3)), x = r(55), g = r(44), _ = function(A) {
            function f(S) {
              return A.call(this, S) || this;
            }
            return p.__extends(f, A), f.prototype.exec = function() {
              var S, D, k, L, h, E, w, O, R = this.options, I = R.editor, H = R.listType, $ = R.listTarget, Q = R.$startElem, U = R.$endElem, Y = I.selection.getSelectionRangeTopNodes(), X = Q == null ? void 0 : Q.getNodeName();
              if (X === (U == null ? void 0 : U.getNodeName())) if (Y.length > 2) if (Y.shift(), Y.pop(), O = g.createElementFragment(g.filterSelectionNodes(Y), g.createDocumentFragment()), X === H) (S = U.children()) === null || S === void 0 || (0, C.default)(S).call(S, function(ce) {
                O.append(ce);
              }), U.remove(), this.selectionRangeElem.set(O), Q.elems[0].append(O);
              else {
                for (var G = document.createDocumentFragment(), J = document.createDocumentFragment(), ee = g.getStartPoint(Q); ee.length; ) {
                  var re = ee.elems[0];
                  ee = ee.next(), G.append(re);
                }
                for (var oe = g.getEndPoint(U), ae = []; oe.length; ) ae.unshift(oe.elems[0]), oe = oe.prev();
                (0, C.default)(ae).call(ae, function(ce) {
                  J.append(ce);
                });
                var se = g.createElement($);
                se.append(G), se.append(O), se.append(J), O = se, this.selectionRangeElem.set(O), b.default(se).insertAfter(Q), !(!((D = Q.children()) === null || D === void 0) && D.length) && Q.remove(), !(!((k = U.children()) === null || k === void 0) && k.length) && U.remove();
              }
              else {
                for (Y.length = 0, ee = g.getStartPoint(Q); ee.length; ) Y.push(ee), ee = ee.next();
                for (oe = g.getEndPoint(U), ae = []; oe.length; ) ae.unshift(oe), oe = oe.prev();
                Y.push.apply(Y, ae), X === H ? (O = g.createElementFragment(Y, g.createDocumentFragment(), "p"), this.selectionRangeElem.set(O), g.insertBefore(Q, O, U.elems[0])) : (O = g.createElement($), (0, C.default)(Y).call(Y, function(ce) {
                  O.append(ce.elems[0]);
                }), this.selectionRangeElem.set(O), b.default(O).insertAfter(Q)), !(!((L = Q.children()) === null || L === void 0) && L.length) && U.remove(), !(!((h = U.children()) === null || h === void 0) && h.length) && U.remove();
              }
              else {
                var ve = [];
                for (oe = g.getEndPoint(U); oe.length; ) ve.unshift(oe), oe = oe.prev();
                var Ae = [];
                for (ee = g.getStartPoint(Q); ee.length; ) Ae.push(ee), ee = ee.next();
                if (O = g.createDocumentFragment(), Y.shift(), Y.pop(), (0, C.default)(Ae).call(Ae, function(ce) {
                  return O.append(ce.elems[0]);
                }), O = g.createElementFragment(g.filterSelectionNodes(Y), O), (0, C.default)(ve).call(ve, function(ce) {
                  return O.append(ce.elems[0]);
                }), this.selectionRangeElem.set(O), X === H) Q.elems[0].append(O), !(!((E = U.children()) === null || E === void 0) && E.length) && U.remove();
                else if (!((w = U.children()) === null || w === void 0) && w.length) {
                  var ye = U.children();
                  g.insertBefore(ye, O, ye.elems[0]);
                } else U.elems[0].append(O);
              }
            }, f;
          }(x.ListHandle);
          d.default = _;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2), b = p.__importDefault(r(3)), x = r(55), g = r(44), _ = function(A) {
            function f(S) {
              return A.call(this, S) || this;
            }
            return p.__extends(f, A), f.prototype.exec = function() {
              var S, D, k = this.options, L = k.editor, h = k.listType, E = k.listTarget, w = k.$startElem, O = L.selection.getSelectionRangeTopNodes(), R = w == null ? void 0 : w.getNodeName();
              O.shift();
              for (var I = [], H = g.getStartPoint(w); H.length; ) I.push(H), H = H.next();
              R === h ? (D = g.createDocumentFragment(), (0, C.default)(I).call(I, function($) {
                return D.append($.elems[0]);
              }), D = g.createElementFragment(g.filterSelectionNodes(O), D), this.selectionRangeElem.set(D), w.elems[0].append(D)) : (D = g.createElement(E), (0, C.default)(I).call(I, function($) {
                return D.append($.elems[0]);
              }), D = g.createElementFragment(g.filterSelectionNodes(O), D), this.selectionRangeElem.set(D), b.default(D).insertAfter(w), !(!((S = w.children()) === null || S === void 0) && S.length) && w.remove());
            }, f;
          }(x.ListHandle);
          d.default = _;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2), b = p.__importDefault(r(3)), x = r(55), g = r(44), _ = function(A) {
            function f(S) {
              return A.call(this, S) || this;
            }
            return p.__extends(f, A), f.prototype.exec = function() {
              var S, D, k, L = this.options, h = L.editor, E = L.listType, w = L.listTarget, O = L.$endElem, R = h.selection.getSelectionRangeTopNodes(), I = O == null ? void 0 : O.getNodeName();
              R.pop();
              for (var H = [], $ = g.getEndPoint(O); $.length; ) H.unshift($), $ = $.prev();
              if (I === E) if (k = g.createElementFragment(g.filterSelectionNodes(R), g.createDocumentFragment()), (0, C.default)(H).call(H, function(Y) {
                return k.append(Y.elems[0]);
              }), this.selectionRangeElem.set(k), (S = O.children()) === null || S === void 0 ? void 0 : S.length) {
                var Q = O.children();
                g.insertBefore(Q, k, Q.elems[0]);
              } else O.elems[0].append(k);
              else {
                var U = g.filterSelectionNodes(R);
                U.push.apply(U, H), k = g.createElementFragment(U, g.createElement(w)), this.selectionRangeElem.set(k), b.default(k).insertBefore(O), !(!((D = O.children()) === null || D === void 0) && D.length) && O.remove();
              }
            }, f;
          }(x.ListHandle);
          d.default = _;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = r(55), C = r(44), p = function(b) {
            function x(g, _) {
              var A = b.call(this, g) || this;
              return A.range = _, A;
            }
            return u.__extends(x, b), x.prototype.exec = function() {
              var g = this.options, _ = g.editor, A = g.listTarget, f = _.selection.getSelectionRangeTopNodes(), S = C.createElementFragment(C.filterSelectionNodes(f), C.createElement(A));
              this.selectionRangeElem.set(S), this.range.insertNode(S);
            }, x;
          }(v.ListHandle);
          d.default = p;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4)), p = u(r(26));
          (0, v.default)(d, "__esModule", { value: !0 });
          var b = r(2), x = b.__importDefault(r(23)), g = b.__importDefault(r(3)), _ = b.__importDefault(r(376)), A = r(6), f = function(S) {
            function D(k) {
              var L = this, h = g.default(`<div class="w-e-menu" data-title="行高">
                    <i class="w-e-icon-row-height"></i>
                </div>`), E = { width: 100, title: "设置行高", type: "list", list: new _.default(k, k.config.lineHeights).getItemList(), clickHandler: function(w) {
                k.selection.saveRange(), L.command(w);
              } };
              return L = S.call(this, h, k, E) || this;
            }
            return b.__extends(D, S), D.prototype.command = function(k) {
              var L, h = this, E = window.getSelection ? window.getSelection() : document.getSelection(), w = ["P"], O = this.editor, R = "";
              O.selection.restoreSelection();
              var I = g.default(O.selection.getSelectionContainerElem());
              if (I != null && I.length) {
                var H = g.default(O.selection.getSelectionContainerElem()), $ = g.default(O.selection.getSelectionStartElem()).elems[0], Q = "", U = [], Y = "";
                if (I && O.$textElem.equal(I)) {
                  if (A.UA.isIE()) return;
                  var X = [], G = [], J = [], ee = g.default(O.selection.getSelectionStartElem()), re = g.default(O.selection.getSelectionEndElem()), oe = (L = O.selection.getRange()) === null || L === void 0 ? void 0 : L.commonAncestorContainer.childNodes;
                  G.push(this.getDom(ee.elems[0])), oe == null || (0, C.default)(oe).call(oe, function(ye, ce) {
                    ye === h.getDom(ee.elems[0]) && X.push(ce), ye === h.getDom(re.elems[0]) && X.push(ce);
                  });
                  var ae = 0, se = void 0;
                  for (J.push(this.getDom(ee.elems[0])); G[ae] !== this.getDom(re.elems[0]); ) se = g.default(G[ae].nextElementSibling).elems[0], (0, p.default)(w).call(w, g.default(se).getNodeName()) !== -1 && J.push(se), G.push(se), ae++;
                  if (g.default(G[0]).getNodeName() !== "P") {
                    ae = 0;
                    for (var ve = 0; ve < G.length; ve++) if (g.default(G[ve]).getNodeName() === "P") {
                      ae = ve;
                      break;
                    }
                    if (ae === 0) return;
                    for (var Ae = 0; Ae !== ae; ) G.shift(), Ae++;
                  }
                  return this.setRange(G[0], G[G.length - 1]), (0, C.default)(G).call(G, function(ye) {
                    Q = ye.getAttribute("style"), U = Q ? Q.split(";") : [], Y = "", g.default(ye).getNodeName() === "P" ? (Y = k ? h.styleProcessing(U) + "line-height:" + k + ";" : h.styleProcessing(U), R = R + "<" + g.default(ye).getNodeName().toLowerCase() + ' style="' + Y + '">' + ye.innerHTML + "</" + g.default(ye).getNodeName().toLowerCase() + ">") : (Y = h.styleProcessing(U), R = R + "<" + g.default(ye).getNodeName().toLowerCase() + ' style="' + Y + '">' + ye.innerHTML + "</" + g.default(ye).getNodeName().toLowerCase() + ">");
                  }), this.action(R, O), $ = H.elems[0], void this.setRange($.children[X[0]], $.children[X[1]]);
                }
                $ = this.getDom($), (0, p.default)(w).call(w, g.default($).getNodeName()) !== -1 && (Q = $.getAttribute("style"), U = Q ? Q.split(";") : [], E == null || E.selectAllChildren($), O.selection.saveRange(), k ? (Y = Q ? this.styleProcessing(U) + "line-height:" + k + ";" : "line-height:" + k + ";", R = "<" + g.default($).getNodeName().toLowerCase() + ' style="' + Y + '">' + $.innerHTML + "</" + g.default($).getNodeName().toLowerCase() + ">", g.default($).getNodeName() === "BLOCKQUOTE" ? g.default($).css("line-height", k) : this.action(R, O)) : Q && (Y = this.styleProcessing(U), R = Y === "" ? "<" + g.default($).getNodeName().toLowerCase() + ">" + $.innerHTML + "</" + g.default($).getNodeName().toLowerCase() + ">" : "<" + g.default($).getNodeName().toLowerCase() + ' style="' + Y + '">' + $.innerHTML + "</" + g.default($).getNodeName().toLowerCase() + ">", this.action(R, O)));
              }
            }, D.prototype.getDom = function(k) {
              var L = g.default(k).elems[0];
              return L.parentNode ? L = function h(E, w) {
                var O = g.default(E.parentNode);
                return w.$textElem.equal(O) ? E : h(O.elems[0], w);
              }(L, this.editor) : L;
            }, D.prototype.action = function(k, L) {
              L.cmd.do("insertHTML", k);
            }, D.prototype.styleProcessing = function(k) {
              var L = "";
              return (0, C.default)(k).call(k, function(h) {
                h !== "" && (0, p.default)(h).call(h, "line-height") === -1 && (L = L + h + ";");
              }), L;
            }, D.prototype.setRange = function(k, L) {
              var h = this.editor, E = window.getSelection ? window.getSelection() : document.getSelection();
              E == null || E.removeAllRanges();
              var w = document.createRange(), O = k, R = L;
              w.setStart(O, 0), w.setEnd(R, 1), E == null || E.addRange(w), h.selection.saveRange(), E == null || E.removeAllRanges(), h.selection.restoreSelection();
            }, D.prototype.tryChangeActive = function() {
              var k = this.editor, L = k.selection.getSelectionContainerElem();
              if (!L || !k.$textElem.equal(L)) {
                var h = g.default(k.selection.getSelectionStartElem());
                if (h.length !== 0) {
                  var E = (h = this.getDom(h.elems[0])).getAttribute("style") ? h.getAttribute("style") : "";
                  E && (0, p.default)(E).call(E, "line-height") !== -1 ? this.active() : this.unActive();
                }
              }
            }, D;
          }(x.default);
          d.default = f;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2).__importDefault(r(3)), b = function() {
            function x(g, _) {
              var A = this;
              this.itemList = [{ $elem: p.default("<span>" + g.i18next.t("默认") + "</span>"), value: "" }], (0, C.default)(_).call(_, function(f) {
                A.itemList.push({ $elem: p.default("<span>" + f + "</span>"), value: f });
              });
            }
            return x.prototype.getItemList = function() {
              return this.itemList;
            }, x;
          }();
          d.default = b;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(3)), C = function(p) {
            function b(x) {
              var g = v.default(`<div class="w-e-menu" data-title="撤销">
                <i class="w-e-icon-undo"></i>
            </div>`);
              return p.call(this, g, x) || this;
            }
            return u.__extends(b, p), b.prototype.clickHandler = function() {
              var x = this.editor;
              x.history.revoke();
              var g = x.$textElem.children();
              if (g != null && g.length) {
                var _ = g.last();
                x.selection.createRangeByElem(_, !1, !0), x.selection.restoreSelection();
              }
            }, b.prototype.tryChangeActive = function() {
              this.editor.isCompatibleMode || (this.editor.history.size[0] ? this.active() : this.unActive());
            }, b;
          }(u.__importDefault(r(22)).default);
          d.default = C;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(3)), C = function(p) {
            function b(x) {
              var g = v.default(`<div class="w-e-menu" data-title="恢复">
                <i class="w-e-icon-redo"></i>
            </div>`);
              return p.call(this, g, x) || this;
            }
            return u.__extends(b, p), b.prototype.clickHandler = function() {
              var x = this.editor;
              x.history.restore();
              var g = x.$textElem.children();
              if (g != null && g.length) {
                var _ = g.last();
                x.selection.createRangeByElem(_, !1, !0), x.selection.restoreSelection();
              }
            }, b.prototype.tryChangeActive = function() {
              this.editor.isCompatibleMode || (this.editor.history.size[1] ? this.active() : this.unActive());
            }, b;
          }(u.__importDefault(r(22)).default);
          d.default = C;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(33)), C = u.__importDefault(r(3)), p = u.__importDefault(r(380)), b = u.__importDefault(r(31)), x = u.__importDefault(r(389)), g = function(_) {
            function A(f) {
              var S, D = C.default('<div class="w-e-menu" data-title="表格"><i class="w-e-icon-table2"></i></div>');
              return S = _.call(this, D, f) || this, x.default(f), S;
            }
            return u.__extends(A, _), A.prototype.clickHandler = function() {
              this.createPanel();
            }, A.prototype.createPanel = function() {
              var f = p.default(this.editor);
              new b.default(this, f).create();
            }, A.prototype.tryChangeActive = function() {
            }, A;
          }(v.default);
          d.default = g;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(381));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2), b = r(6), x = p.__importDefault(r(3));
          r(386);
          var g = p.__importDefault(r(388));
          function _(A) {
            return A > 0 && (0, C.default)(A);
          }
          d.default = function(A) {
            var f = new g.default(A), S = b.getRandom("w-col-id"), D = b.getRandom("w-row-id"), k = b.getRandom("btn-link"), L = "menus.panelMenus.table.", h = function(O) {
              return A.i18next.t(O);
            }, E = [{ title: h(L + "插入表格"), tpl: `<div>
                    <div class="w-e-table">
                        <span>` + h("创建") + `</span>
                        <input id="` + D + `"  type="text" class="w-e-table-input" value="5"/></td>
                        <span>` + h(L + "行") + `</span>
                        <input id="` + S + `" type="text" class="w-e-table-input" value="5"/></td>
                        <span>` + (h(L + "列") + h(L + "的") + h(L + "表格")) + `</span>
                    </div>
                    <div class="w-e-button-container">
                        <button type="button" id="` + k + '" class="right">' + h("插入") + `</button>
                    </div>
                </div>`, events: [{ selector: "#" + k, type: "click", fn: function() {
              var O = Number(x.default("#" + S).val()), R = Number(x.default("#" + D).val());
              return _(R) && _(O) ? (f.createAction(R, O), !0) : (A.config.customAlert("表格行列请输入正整数", "warning"), !1);
            } }] }], w = { width: 330, height: 0, tabs: [] };
            return w.tabs.push(E[0]), w;
          };
        }, function(m, d, r) {
          m.exports = r(382);
        }, function(m, d, r) {
          var u = r(383);
          m.exports = u;
        }, function(m, d, r) {
          r(384);
          var u = r(12);
          m.exports = u.Number.isInteger;
        }, function(m, d, r) {
          r(5)({ target: "Number", stat: !0 }, { isInteger: r(385) });
        }, function(m, d, r) {
          var u = r(13), v = Math.floor;
          m.exports = function(C) {
            return !u(C) && isFinite(C) && v(C) === C;
          };
        }, function(m, d, r) {
          var u = r(20), v = r(387);
          typeof (v = v.__esModule ? v.default : v) == "string" && (v = [[m.i, v, ""]]);
          var C = { insert: "head", singleton: !1 };
          u(v, C), m.exports = v.locals || {};
        }, function(m, d, r) {
          (d = r(21)(!1)).push([m.i, `.w-e-table {
  display: flex;
}
.w-e-table .w-e-table-input {
  width: 40px;
  text-align: center!important;
  margin: 0 5px;
}
`, ""]), m.exports = d;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = r(7), C = u.__importDefault(r(3)), p = function() {
            function b(x) {
              this.editor = x;
            }
            return b.prototype.createAction = function(x, g) {
              var _ = this.editor, A = C.default(_.selection.getSelectionContainerElem()), f = C.default(A.elems[0]).parentUntilEditor("UL", _), S = C.default(A.elems[0]).parentUntilEditor("OL", _);
              if (!f && !S) {
                var D = this.createTableHtml(x, g);
                _.cmd.do("insertHTML", D);
              }
            }, b.prototype.createTableHtml = function(x, g) {
              for (var _ = "", A = "", f = 0; f < x; f++) {
                A = "";
                for (var S = 0; S < g; S++) A += f === 0 ? "<th></th>" : "<td></td>";
                _ = _ + "<tr>" + A + "</tr>";
              }
              return '<table border="0" width="100%" cellpadding="0" cellspacing="0"><tbody>' + _ + "</tbody></table>" + v.EMPTY_P;
            }, b;
          }();
          d.default = p;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(390)), C = u.__importDefault(r(393));
          d.default = function(p) {
            v.default(p), C.default(p);
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(3)), C = u.__importDefault(r(34)), p = u.__importDefault(r(391)), b = u.__importDefault(r(392)), x = r(7);
          function g(A) {
            var f = A.selection.getSelectionStartElem(), S = A.selection.getSelectionEndElem();
            return (f == null ? void 0 : f.elems[0]) !== (S == null ? void 0 : S.elems[0]);
          }
          function _(A, f) {
            return A.elems[0].nextSibling.innerHTML === "<br>" && (f += "" + x.EMPTY_P), f;
          }
          d.default = function(A) {
            var f = /* @__PURE__ */ function(k) {
              var L;
              return { showTableTooltip: function(h) {
                var E = new b.default(k), w = function(R, I) {
                  return I === void 0 && (I = "menus.panelMenus.table."), k.i18next.t(I + R);
                }, O = [{ $elem: v.default("<span>" + w("删除表格") + "</span>"), onClick: function(R, I) {
                  return R.selection.createRangeByElem(I), R.selection.restoreSelection(), R.cmd.do("insertHTML", x.EMPTY_P), !0;
                } }, { $elem: v.default("<span>" + w("添加行") + "</span>"), onClick: function(R, I) {
                  if (g(R)) return !0;
                  var H = v.default(R.selection.getSelectionStartElem()), $ = E.getRowNode(H.elems[0]);
                  if (!$) return !0;
                  var Q = Number(E.getCurrentRowIndex(I.elems[0], $)), U = E.getTableHtml(I.elems[0]), Y = E.getTableHtml(p.default.ProcessingRow(v.default(U), Q).elems[0]);
                  return Y = _(I, Y), R.selection.createRangeByElem(I), R.selection.restoreSelection(), R.cmd.do("insertHTML", Y), !0;
                } }, { $elem: v.default("<span>" + w("删除行") + "</span>"), onClick: function(R, I) {
                  if (g(R)) return !0;
                  var H = v.default(R.selection.getSelectionStartElem()), $ = E.getRowNode(H.elems[0]);
                  if (!$) return !0;
                  var Q = Number(E.getCurrentRowIndex(I.elems[0], $)), U = E.getTableHtml(I.elems[0]), Y = p.default.DeleteRow(v.default(U), Q).elems[0].childNodes[0].childNodes.length, X = "";
                  return R.selection.createRangeByElem(I), R.selection.restoreSelection(), X = _(I, X = Y === 0 ? x.EMPTY_P : E.getTableHtml(p.default.DeleteRow(v.default(U), Q).elems[0])), R.cmd.do("insertHTML", X), !0;
                } }, { $elem: v.default("<span>" + w("添加列") + "</span>"), onClick: function(R, I) {
                  if (g(R)) return !0;
                  var H = v.default(R.selection.getSelectionStartElem()), $ = E.getCurrentColIndex(H.elems[0]), Q = E.getTableHtml(I.elems[0]), U = E.getTableHtml(p.default.ProcessingCol(v.default(Q), $).elems[0]);
                  return U = _(I, U), R.selection.createRangeByElem(I), R.selection.restoreSelection(), R.cmd.do("insertHTML", U), !0;
                } }, { $elem: v.default("<span>" + w("删除列") + "</span>"), onClick: function(R, I) {
                  if (g(R)) return !0;
                  var H = v.default(R.selection.getSelectionStartElem()), $ = E.getCurrentColIndex(H.elems[0]), Q = E.getTableHtml(I.elems[0]), U = p.default.DeleteCol(v.default(Q), $).elems[0].childNodes[0].childNodes[0].childNodes.length, Y = "";
                  return R.selection.createRangeByElem(I), R.selection.restoreSelection(), Y = _(I, Y = U === 1 ? x.EMPTY_P : E.getTableHtml(p.default.DeleteCol(v.default(Q), $).elems[0])), R.cmd.do("insertHTML", Y), !0;
                } }, { $elem: v.default("<span>" + w("设置表头") + "</span>"), onClick: function(R, I) {
                  if (g(R)) return !0;
                  var H = v.default(R.selection.getSelectionStartElem()), $ = E.getRowNode(H.elems[0]);
                  if (!$) return !0;
                  var Q = Number(E.getCurrentRowIndex(I.elems[0], $));
                  Q !== 0 && (Q = 0);
                  var U = E.getTableHtml(I.elems[0]), Y = E.getTableHtml(p.default.setTheHeader(v.default(U), Q, "th").elems[0]);
                  return Y = _(I, Y), R.selection.createRangeByElem(I), R.selection.restoreSelection(), R.cmd.do("insertHTML", Y), !0;
                } }, { $elem: v.default("<span>" + w("取消表头") + "</span>"), onClick: function(R, I) {
                  var H = v.default(R.selection.getSelectionStartElem()), $ = E.getRowNode(H.elems[0]);
                  if (!$) return !0;
                  var Q = Number(E.getCurrentRowIndex(I.elems[0], $));
                  Q !== 0 && (Q = 0);
                  var U = E.getTableHtml(I.elems[0]), Y = E.getTableHtml(p.default.setTheHeader(v.default(U), Q, "td").elems[0]);
                  return Y = _(I, Y), R.selection.createRangeByElem(I), R.selection.restoreSelection(), R.cmd.do("insertHTML", Y), !0;
                } }];
                (L = new C.default(k, h, O)).create();
              }, hideTableTooltip: function() {
                L && (L.remove(), L = null);
              } };
            }(A), S = f.showTableTooltip, D = f.hideTableTooltip;
            A.txt.eventHooks.tableClickEvents.push(S), A.txt.eventHooks.clickEvents.push(D), A.txt.eventHooks.keyupEvents.push(D), A.txt.eventHooks.toolbarClickEvents.push(D), A.txt.eventHooks.menuClickEvents.push(D), A.txt.eventHooks.textScrollEvents.push(D);
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(43)), p = u(r(92)), b = u(r(4));
          (0, v.default)(d, "__esModule", { value: !0 });
          var x = r(2).__importDefault(r(3));
          function g(A, f) {
            for (; A.childNodes.length !== 0; ) A.removeChild(A.childNodes[0]);
            for (var S = 0; S < f.length; S++) A.appendChild(f[S]);
          }
          function _(A) {
            var f = A.elems[0].childNodes[0];
            return f.nodeName === "COLGROUP" && (f = A.elems[0].childNodes[A.elems[0].childNodes.length - 1]), f;
          }
          d.default = { ProcessingRow: function(A, f) {
            for (var S = _(A), D = (0, C.default)(Array.prototype).apply(S.childNodes), k = D[0].childNodes.length, L = document.createElement("tr"), h = 0; h < k; h++) {
              var E = document.createElement("td");
              L.appendChild(E);
            }
            return (0, p.default)(D).call(D, f + 1, 0, L), g(S, D), x.default(S.parentNode);
          }, ProcessingCol: function(A, f) {
            for (var S = _(A), D = (0, C.default)(Array.prototype).apply(S.childNodes), k = function(h) {
              var E, w = [];
              for ((0, b.default)(E = D[h].childNodes).call(E, function(I) {
                w.push(I);
              }); D[h].childNodes.length !== 0; ) D[h].removeChild(D[h].childNodes[0]);
              var O = x.default(w[0]).getNodeName() !== "TH" ? document.createElement("td") : document.createElement("th");
              (0, p.default)(w).call(w, f + 1, 0, O);
              for (var R = 0; R < w.length; R++) D[h].appendChild(w[R]);
            }, L = 0; L < D.length; L++) k(L);
            return g(S, D), x.default(S.parentNode);
          }, DeleteRow: function(A, f) {
            var S = _(A), D = (0, C.default)(Array.prototype).apply(S.childNodes);
            return (0, p.default)(D).call(D, f, 1), g(S, D), x.default(S.parentNode);
          }, DeleteCol: function(A, f) {
            for (var S = _(A), D = (0, C.default)(Array.prototype).apply(S.childNodes), k = function(h) {
              var E, w = [];
              for ((0, b.default)(E = D[h].childNodes).call(E, function(R) {
                w.push(R);
              }); D[h].childNodes.length !== 0; ) D[h].removeChild(D[h].childNodes[0]);
              (0, p.default)(w).call(w, f, 1);
              for (var O = 0; O < w.length; O++) D[h].appendChild(w[O]);
            }, L = 0; L < D.length; L++) k(L);
            return g(S, D), x.default(S.parentNode);
          }, setTheHeader: function(A, f, S) {
            for (var D = _(A), k = (0, C.default)(Array.prototype).apply(D.childNodes), L = k[f].childNodes, h = document.createElement("tr"), E = function(O) {
              var R, I = document.createElement(S);
              (0, b.default)(R = L[O].childNodes).call(R, function(H) {
                I.appendChild(H);
              }), h.appendChild(I);
            }, w = 0; w < L.length; w++) E(w);
            return (0, p.default)(k).call(k, f, 1, h), g(D, k), x.default(D.parentNode);
          } };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2).__importDefault(r(3)), b = function() {
            function x(g) {
              this.editor = g;
            }
            return x.prototype.getRowNode = function(g) {
              var _, A = p.default(g).elems[0];
              return A.parentNode ? A = (_ = p.default(A).parentUntil("TR", A)) === null || _ === void 0 ? void 0 : _.elems[0] : A;
            }, x.prototype.getCurrentRowIndex = function(g, _) {
              var A, f = 0, S = g.childNodes[0];
              return S.nodeName === "COLGROUP" && (S = g.childNodes[g.childNodes.length - 1]), (0, C.default)(A = S.childNodes).call(A, function(D, k) {
                D === _ && (f = k);
              }), f;
            }, x.prototype.getCurrentColIndex = function(g) {
              var _, A, f = 0, S = p.default(g).getNodeName() === "TD" || p.default(g).getNodeName() === "TH" ? g : (A = p.default(g).parentUntil("TD", g)) === null || A === void 0 ? void 0 : A.elems[0], D = p.default(S).parent();
              return (0, C.default)(_ = D.elems[0].childNodes).call(_, function(k, L) {
                k === S && (f = L);
              }), f;
            }, x.prototype.getTableHtml = function(g) {
              return '<table border="0" width="100%" cellpadding="0" cellspacing="0">' + p.default(g).html() + "</table>";
            }, x;
          }();
          d.default = b;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 }), d.default = function(u) {
            var v = u.txt, C = u.selection;
            v.eventHooks.keydownEvents.push(function(p) {
              u.selection.saveRange();
              var b = C.getSelectionContainerElem();
              if (b) {
                var x = b.getNodeTop(u), g = x.length && x.prev().length ? x.prev() : null;
                g && g.getNodeName() === "TABLE" && C.getCursorPos() === 0 && p.keyCode === 8 && p.preventDefault();
              }
            });
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(25));
          (0, v.default)(d, "__esModule", { value: !0 }), d.formatCodeHtml = void 0;
          var p = r(2), b = p.__importDefault(r(33)), x = p.__importDefault(r(3)), g = r(6), _ = p.__importDefault(r(395)), A = p.__importDefault(r(133)), f = p.__importDefault(r(31)), S = p.__importDefault(r(396));
          d.formatCodeHtml = function(k, L) {
            return L && (L = function(h) {
              var E = h.match(/<pre[\s|\S]+?\/pre>/g);
              return E === null || (0, C.default)(E).call(E, function(w) {
                h = h.replace(w, w.replace(/<\/code><code>/g, `
`).replace(/<br>/g, ""));
              }), h;
            }(L = function h(E) {
              var w, O = E.match(/<span\sclass="hljs[\s|\S]+?\/span>/gm);
              if (!O || !O.length) return E;
              for (var R = (0, C.default)(w = g.deepClone(O)).call(w, function(H) {
                return (H = H.replace(/<span\sclass="hljs[^>]+>/, "")).replace(/<\/span>/, "");
              }), I = 0; I < O.length; I++) E = E.replace(O[I], R[I]);
              return h(E);
            }(L)), L = g.replaceSpecialSymbol(L));
          };
          var D = function(k) {
            function L(h) {
              var E, w = x.default('<div class="w-e-menu" data-title="代码"><i class="w-e-icon-terminal"></i></div>');
              return E = k.call(this, w, h) || this, S.default(h), E;
            }
            return p.__extends(L, k), L.prototype.insertLineCode = function(h) {
              var E = this.editor, w = x.default("<code>" + h + "</code>");
              E.cmd.do("insertElem", w), E.selection.createRangeByElem(w, !1), E.selection.restoreSelection();
            }, L.prototype.clickHandler = function() {
              var h = this.editor, E = h.selection.getSelectionText();
              this.isActive || (h.selection.isSelectionEmpty() ? this.createPanel("", "") : this.insertLineCode(E));
            }, L.prototype.createPanel = function(h, E) {
              var w = _.default(this.editor, h, E);
              new f.default(this, w).create();
            }, L.prototype.tryChangeActive = function() {
              var h = this.editor;
              A.default(h) ? this.active() : this.unActive();
            }, L;
          }(b.default);
          d.default = D;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(25));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2), b = r(6), x = p.__importDefault(r(3)), g = p.__importDefault(r(133)), _ = r(7);
          d.default = function(A, f, S) {
            var D, k = b.getRandom("input-iframe"), L = b.getRandom("select"), h = b.getRandom("btn-ok");
            function E(O) {
              g.default(A) && function() {
                if (g.default(A)) {
                  var H = A.selection.getSelectionStartElem(), $ = H == null ? void 0 : H.getNodeTop(A);
                  $ && (A.selection.createRangeByElem($), A.selection.restoreSelection());
                }
              }(), A.cmd.do("insertHTML", O);
              var R = A.selection.getSelectionStartElem(), I = R == null ? void 0 : R.getNodeTop(A);
              x.default(_.EMPTY_P).insertAfter(I);
            }
            var w = function(O) {
              return A.i18next.t(O);
            };
            return { width: 500, height: 0, tabs: [{ title: w("menus.panelMenus.code.插入代码"), tpl: `<div>
                        <select name="" id="` + L + `">
                            ` + (0, C.default)(D = A.config.languageType).call(D, function(O) {
              return "<option " + (S == O ? "selected" : "") + ' value ="' + O + '">' + O + "</option>";
            }) + `
                        </select>
                        <textarea id="` + k + '" type="text" class="wang-code-textarea" placeholder="" style="height: 160px">' + f.replace(/&quot;/g, '"') + `</textarea>
                        <div class="w-e-button-container">
                            <button type="button" id="` + h + '" class="right">' + (g.default(A) ? w("修改") : w("插入")) + `</button>
                        </div>
                    </div>`, events: [{ selector: "#" + h, type: "click", fn: function() {
              var O, R = document.getElementById(k), I = x.default("#" + L).val(), H = R.value;
              if (O = A.highlight ? A.highlight.highlightAuto(H).value : "<xmp>" + H + "</xmp>", H) return !g.default(A) && (E('<pre><code class="' + I + '">' + O + "</code></pre>"), !0);
            } }] }] };
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(397)), C = u.__importDefault(r(398));
          d.default = function(p) {
            v.default(p), C.default(p);
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 }), d.createShowHideFn = void 0;
          var u = r(2), v = u.__importDefault(r(3)), C = u.__importDefault(r(34));
          function p(b) {
            var x;
            return { showCodeTooltip: function(g) {
              var _, A, f = [{ $elem: v.default("<span>" + (_ = "删除代码", A === void 0 && (A = "menus.panelMenus.code."), b.i18next.t(A + _)) + "</span>"), onClick: function(S, D) {
                return D.remove(), !0;
              } }];
              (x = new C.default(b, g, f)).create();
            }, hideCodeTooltip: function() {
              x && (x.remove(), x = null);
            } };
          }
          d.createShowHideFn = p, d.default = function(b) {
            var x = p(b), g = x.showCodeTooltip, _ = x.hideCodeTooltip;
            b.txt.eventHooks.codeClickEvents.push(g), b.txt.eventHooks.clickEvents.push(_), b.txt.eventHooks.toolbarClickEvents.push(_), b.txt.eventHooks.menuClickEvents.push(_), b.txt.eventHooks.textScrollEvents.push(_);
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = r(7), C = u.__importDefault(r(3));
          d.default = function(p) {
            var b = p.$textElem, x = p.selection, g = p.txt.eventHooks.keydownEvents;
            g.push(function(_) {
              var A;
              if (_.keyCode === 40) {
                var f = x.getSelectionContainerElem(), S = (A = b.children()) === null || A === void 0 ? void 0 : A.last();
                if ((f == null ? void 0 : f.elems[0].tagName) === "XMP" && (S == null ? void 0 : S.elems[0].tagName) === "PRE") {
                  var D = C.default(v.EMPTY_P);
                  b.append(D);
                }
              }
            }), g.push(function(_) {
              p.selection.saveRange();
              var A = x.getSelectionContainerElem();
              if (A) {
                var f = A.getNodeTop(p), S = f == null ? void 0 : f.prev(), D = f == null ? void 0 : f.getNextSibling();
                S.length && (S == null ? void 0 : S.getNodeName()) === "PRE" && D.length === 0 && x.getCursorPos() === 0 && _.keyCode === 8 && _.preventDefault();
              }
            });
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(22)), C = u.__importDefault(r(3)), p = u.__importDefault(r(400)), b = r(6), x = r(7), g = function(_) {
            function A(f) {
              var S, D = C.default('<div class="w-e-menu" data-title="分割线"><i class="w-e-icon-split-line"></i></div>');
              return S = _.call(this, D, f) || this, p.default(f), S;
            }
            return u.__extends(A, _), A.prototype.clickHandler = function() {
              var f = this.editor, S = f.selection.getRange(), D = f.selection.getSelectionContainerElem();
              if (D != null && D.length) {
                var k = C.default(D.elems[0]), L = k.parentUntil("TABLE", D.elems[0]), h = k.children();
                k.getNodeName() !== "CODE" && (L && C.default(L.elems[0]).getNodeName() === "TABLE" || (!h || h.length === 0 || C.default(h.elems[0]).getNodeName() !== "IMG" || S != null && S.collapsed) && this.createSplitLine());
              }
            }, A.prototype.createSplitLine = function() {
              var f = "<hr/>" + x.EMPTY_P;
              b.UA.isFirefox && (f = "<hr/><p></p>"), this.editor.cmd.do("insertHTML", f);
            }, A.prototype.tryChangeActive = function() {
            }, A;
          }(v.default);
          d.default = g;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2).__importDefault(r(401));
          d.default = function(v) {
            u.default(v);
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(3)), C = u.__importDefault(r(34));
          d.default = function(p) {
            var b = /* @__PURE__ */ function(_) {
              var A;
              return { showSplitLineTooltip: function(f) {
                var S = [{ $elem: v.default("<span>" + _.i18next.t("menus.panelMenus.删除") + "</span>"), onClick: function(D, k) {
                  return D.selection.createRangeByElem(k), D.selection.restoreSelection(), D.cmd.do("delete"), !0;
                } }];
                (A = new C.default(_, f, S)).create();
              }, hideSplitLineTooltip: function() {
                A && (A.remove(), A = null);
              } };
            }(p), x = b.showSplitLineTooltip, g = b.hideSplitLineTooltip;
            p.txt.eventHooks.splitLineEvents.push(x), p.txt.eventHooks.clickEvents.push(g), p.txt.eventHooks.keyupEvents.push(g), p.txt.eventHooks.toolbarClickEvents.push(g), p.txt.eventHooks.menuClickEvents.push(g), p.txt.eventHooks.textScrollEvents.push(g);
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2), b = p.__importDefault(r(3)), x = p.__importDefault(r(22)), g = r(98), _ = p.__importDefault(r(408)), A = p.__importDefault(r(134)), f = function(S) {
            function D(k) {
              var L, h = b.default(`<div class="w-e-menu" data-title="待办事项">
                    <i class="w-e-icon-checkbox-checked"></i>
                </div>`);
              return L = S.call(this, h, k) || this, _.default(k), L;
            }
            return p.__extends(D, S), D.prototype.clickHandler = function() {
              var k = this.editor;
              g.isAllTodo(k) ? (this.cancelTodo(), this.tryChangeActive()) : this.setTodo();
            }, D.prototype.tryChangeActive = function() {
              g.isAllTodo(this.editor) ? this.active() : this.unActive();
            }, D.prototype.setTodo = function() {
              var k = this.editor, L = k.selection.getSelectionRangeTopNodes();
              (0, C.default)(L).call(L, function(h) {
                var E;
                if ((h == null ? void 0 : h.getNodeName()) === "P") {
                  var w = A.default(h).getTodo(), O = (E = w.children()) === null || E === void 0 ? void 0 : E.getNode();
                  w.insertAfter(h), k.selection.moveCursor(O), h.remove();
                }
              }), this.tryChangeActive();
            }, D.prototype.cancelTodo = function() {
              var k = this.editor, L = k.selection.getSelectionRangeTopNodes();
              (0, C.default)(L).call(L, function(h) {
                var E, w, O, R = (w = (E = h.childNodes()) === null || E === void 0 ? void 0 : E.childNodes()) === null || w === void 0 ? void 0 : w.clone(!0), I = b.default("<p></p>");
                I.append(R), I.insertAfter(h), (O = I.childNodes()) === null || O === void 0 || O.get(0).remove(), k.selection.moveCursor(I.getNode()), h.remove();
              });
            }, D;
          }(x.default);
          d.default = f;
        }, function(m, d, r) {
          m.exports = r(404);
        }, function(m, d, r) {
          var u = r(405);
          m.exports = u;
        }, function(m, d, r) {
          var u = r(406), v = Array.prototype;
          m.exports = function(C) {
            var p = C.every;
            return C === v || C instanceof Array && p === v.every ? u : p;
          };
        }, function(m, d, r) {
          r(407);
          var u = r(14);
          m.exports = u("Array").every;
        }, function(m, d, r) {
          var u = r(5), v = r(29).every;
          u({ target: "Array", proto: !0, forced: !r(70)("every") }, { every: function(C) {
            return v(this, C, arguments.length > 1 ? arguments[1] : void 0);
          } });
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2), b = p.__importDefault(r(3)), x = r(98), g = p.__importDefault(r(134)), _ = r(98), A = r(7);
          d.default = function(f) {
            f.txt.eventHooks.enterDownEvents.push(function(S) {
              var D, k;
              if (x.isAllTodo(f)) {
                S.preventDefault();
                var L = f.selection, h = L.getSelectionRangeTopNodes()[0], E = (D = h.childNodes()) === null || D === void 0 ? void 0 : D.get(0), w = (k = window.getSelection()) === null || k === void 0 ? void 0 : k.anchorNode, O = L.getRange();
                if (!(O != null && O.collapsed)) {
                  var R = O == null ? void 0 : O.commonAncestorContainer.childNodes, I = O == null ? void 0 : O.startContainer, H = O == null ? void 0 : O.endContainer, $ = O == null ? void 0 : O.startOffset, Q = O == null ? void 0 : O.endOffset, U = 0, Y = 0, X = [];
                  R == null || (0, C.default)(R).call(R, function(Ae, ye) {
                    Ae.contains(I) && (U = ye), Ae.contains(H) && (Y = ye);
                  }), Y - U > 1 && (R == null || (0, C.default)(R).call(R, function(Ae, ye) {
                    ye <= U || ye >= Y || X.push(Ae);
                  }), (0, C.default)(X).call(X, function(Ae) {
                    Ae.remove();
                  })), _.dealTextNode(I, $), _.dealTextNode(H, Q, !1), f.selection.moveCursor(H, 0);
                }
                if (h.text() === "") {
                  var G = b.default(A.EMPTY_P);
                  return G.insertAfter(h), L.moveCursor(G.getNode()), void h.remove();
                }
                var J = L.getCursorPos(), ee = x.getCursorNextNode(E == null ? void 0 : E.getNode(), w, J), re = g.default(b.default(ee)), oe = re.getInputContainer(), ae = oe.parent().getNode(), se = re.getTodo(), ve = oe.getNode().nextSibling;
                (E == null ? void 0 : E.text()) === "" && (E == null || E.append(b.default("<br>"))), se.insertAfter(h), ve && (ve == null ? void 0 : ve.textContent) !== "" ? L.moveCursor(ae) : ((ve == null ? void 0 : ve.nodeName) !== "BR" && b.default("<br>").insertAfter(oe), L.moveCursor(ae, 1));
              }
            }), f.txt.eventHooks.deleteUpEvents.push(function() {
              var S = f.selection.getSelectionRangeTopNodes()[0];
              S && _.isTodo(S) && S.text() === "" && (b.default(A.EMPTY_P).insertAfter(S), S.remove());
            }), f.txt.eventHooks.deleteDownEvents.push(function(S) {
              var D, k;
              if (x.isAllTodo(f)) {
                var L, h = f.selection, E = h.getSelectionRangeTopNodes()[0], w = (D = E.childNodes()) === null || D === void 0 ? void 0 : D.getNode(), O = b.default("<p></p>"), R = O.getNode(), I = (k = window.getSelection()) === null || k === void 0 ? void 0 : k.anchorNode, H = h.getCursorPos(), $ = I.previousSibling;
                if (E.text() === "") {
                  S.preventDefault();
                  var Q = b.default(A.EMPTY_P);
                  return Q.insertAfter(E), E.remove(), void h.moveCursor(Q.getNode(), 0);
                }
                ($ == null ? void 0 : $.nodeName) === "SPAN" && $.childNodes[0].nodeName === "INPUT" && H === 0 && (S.preventDefault(), w == null || (0, C.default)(L = w.childNodes).call(L, function(U, Y) {
                  Y !== 0 && R.appendChild(U.cloneNode(!0));
                }), O.insertAfter(E), E.remove());
              }
            });
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2).__importDefault(r(3)), v = r(6), C = r(7), p = { border: "1px solid #c9d8db", toolbarBgColor: "#FFF", toolbarBottomBorder: "1px solid #EEE" };
          d.default = function(b) {
            var x, g, _ = b.toolbarSelector, A = u.default(_), f = b.textSelector, S = b.config.height, D = b.i18next, k = u.default("<div></div>"), L = u.default("<div></div>"), h = null;
            f == null ? (g = A.children(), A.append(k).append(L), k.css("background-color", p.toolbarBgColor).css("border", p.border).css("border-bottom", p.toolbarBottomBorder), L.css("border", p.border).css("border-top", "none").css("height", S + "px")) : (A.append(k), h = u.default(f).children(), u.default(f).append(L), g = L.children()), (x = u.default("<div></div>")).attr("contenteditable", "true").css("width", "100%").css("height", "100%");
            var E = u.default("<div>" + D.t(b.config.placeholder) + "</div>");
            E.addClass("placeholder"), g && g.length ? (x.append(g), E.hide()) : x.append(u.default(C.EMPTY_P)), h && h.length && (x.append(h), E.hide()), L.append(x), L.append(E), k.addClass("w-e-toolbar").css("z-index", b.zIndex.get("toolbar")), L.addClass("w-e-text-container"), L.css("z-index", b.zIndex.get()), x.addClass("w-e-text");
            var w = v.getRandom("toolbar-elem");
            k.attr("id", w);
            var O = v.getRandom("text-elem");
            x.attr("id", O);
            var R = L.getBoundingClientRect().height;
            R !== x.getBoundingClientRect().height && x.css("min-height", R + "px"), b.$toolbarElem = k, b.$textContainerElem = L, b.$textElem = x, b.toolbarElemId = w, b.textElemId = O;
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2).__importDefault(r(3)), v = r(7);
          d.default = function C(p, b) {
            var x = p.$textElem, g = x.children();
            if (!g || !g.length) return x.append(u.default(v.EMPTY_P)), void C(p);
            var _ = g.last();
            if (b) {
              var A = _.html().toLowerCase(), f = _.getNodeName();
              if (A !== "<br>" && A !== "<br/>" || f !== "P") return x.append(u.default(v.EMPTY_P)), void C(p);
            }
            p.selection.createRangeByElem(_, !1, !0), p.config.focus ? p.selection.restoreSelection() : p.selection.clearWindowSelectionRange();
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2).__importDefault(r(3));
          function b(x) {
            (0, x.config.onfocus)(x.txt.html() || "");
          }
          d.default = function(x) {
            (function(g) {
              g.txt.eventHooks.changeEvents.push(function() {
                var _ = g.config.onchange;
                if (_) {
                  var A = g.txt.html() || "";
                  _(A);
                }
                g.txt.togglePlaceholder();
              });
            })(x), function(g) {
              function _(A) {
                var f = A.target, S = p.default(f), D = g.$textElem, k = g.$toolbarElem, L = D.isContain(S), h = k.isContain(S), E = k.elems[0] == A.target;
                if (L) g.isFocus || b(g), g.isFocus = !0;
                else {
                  if (h && !E || !g.isFocus) return;
                  (function(w) {
                    var O, R = w.config.onblur, I = w.txt.html() || "";
                    (0, C.default)(O = w.txt.eventHooks.onBlurEvents).call(O, function(H) {
                      return H();
                    }), R(I);
                  })(g), g.isFocus = !1;
                }
              }
              g.isFocus = !1, document.activeElement === g.$textElem.elems[0] && g.config.focus && (b(g), g.isFocus = !0), p.default(document).on("click", _), g.beforeDestroy(function() {
                p.default(document).off("click", _);
              });
            }(x), function(g) {
              g.$textElem.on("compositionstart", function() {
                g.isComposing = !0;
              }).on("compositionend", function() {
                g.isComposing = !1;
              });
            }(x);
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 }), d.default = function(u) {
            var v = u.config, C = v.lang, p = v.languages;
            if (u.i18next == null) u.i18next = { t: function(b) {
              var x = b.split(".");
              return x[x.length - 1];
            } };
            else try {
              u.i18next.init({ ns: "wangEditor", lng: C, defaultNS: "wangEditor", resources: p });
            } catch (b) {
              throw new Error("i18next:" + b);
            }
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(30));
          (0, v.default)(d, "__esModule", { value: !0 }), d.setUnFullScreen = d.setFullScreen = void 0;
          var p = r(2).__importDefault(r(3));
          r(414), d.setFullScreen = function(b) {
            var x = p.default(b.toolbarSelector), g = b.$textContainerElem, _ = b.$toolbarElem, A = (0, C.default)(_).call(_, "i.w-e-icon-fullscreen"), f = b.config;
            A.removeClass("w-e-icon-fullscreen"), A.addClass("w-e-icon-fullscreen_exit"), x.addClass("w-e-full-screen-editor"), x.css("z-index", f.zIndexFullScreen);
            var S = _.getBoundingClientRect();
            g.css("height", "calc(100% - " + S.height + "px)");
          }, d.setUnFullScreen = function(b) {
            var x = p.default(b.toolbarSelector), g = b.$textContainerElem, _ = b.$toolbarElem, A = (0, C.default)(_).call(_, "i.w-e-icon-fullscreen_exit"), f = b.config;
            A.removeClass("w-e-icon-fullscreen_exit"), A.addClass("w-e-icon-fullscreen"), x.removeClass("w-e-full-screen-editor"), x.css("z-index", "auto"), g.css("height", f.height + "px");
          }, d.default = function(b) {
            if (!b.textSelector && b.config.showFullScreen) {
              var x = b.$toolbarElem, g = p.default(`<div class="w-e-menu" data-title="全屏">
            <i class="w-e-icon-fullscreen"></i>
        </div>`);
              g.on("click", function(_) {
                var A;
                (0, C.default)(A = p.default(_.currentTarget)).call(A, "i").hasClass("w-e-icon-fullscreen") ? (g.attr("data-title", "取消全屏"), d.setFullScreen(b)) : (g.attr("data-title", "全屏"), d.setUnFullScreen(b));
              }), x.append(g);
            }
          };
        }, function(m, d, r) {
          var u = r(20), v = r(415);
          typeof (v = v.__esModule ? v.default : v) == "string" && (v = [[m.i, v, ""]]);
          var C = { insert: "head", singleton: !1 };
          u(v, C), m.exports = v.locals || {};
        }, function(m, d, r) {
          (d = r(21)(!1)).push([m.i, `.w-e-full-screen-editor {
  position: fixed;
  width: 100%!important;
  height: 100%!important;
  left: 0;
  top: 0;
}
`, ""]), m.exports = d;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(30));
          (0, v.default)(d, "__esModule", { value: !0 }), d.default = function(p, b) {
            var x = p.$textElem, g = (0, C.default)(x).call(x, "[id='" + b + "']").getOffsetData().top;
            x.scrollTop(g);
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2).__importDefault(r(123)), v = { menu: 2, panel: 2, toolbar: 1, tooltip: 1, textContainer: 1 }, C = function() {
            function p() {
              this.tier = v, this.baseZIndex = u.default.zIndex;
            }
            return p.prototype.get = function(b) {
              return b && this.tier[b] ? this.baseZIndex + this.tier[b] : this.baseZIndex;
            }, p.prototype.init = function(b) {
              this.baseZIndex == u.default.zIndex && (this.baseZIndex = b.config.zIndex);
            }, p;
          }();
          d.default = C;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(72)), p = u(r(4));
          (0, v.default)(d, "__esModule", { value: !0 });
          var b = r(2), x = b.__importDefault(r(419)), g = r(6), _ = r(7), A = function(f) {
            function S(D) {
              var k = f.call(this, function(L, h) {
                var E;
                if (L = function(w, O) {
                  return (0, C.default)(w).call(w, function(R) {
                    var I = R.type, H = R.target, $ = R.attributeName;
                    return I != "attributes" || I == "attributes" && ($ == "contenteditable" || H != O);
                  });
                }(L, h.target), (E = k.data).push.apply(E, L), D.isCompatibleMode) k.asyncSave();
                else if (!D.isComposing) return k.asyncSave();
              }) || this;
              return k.editor = D, k.data = [], k.asyncSave = _.EMPTY_FN, k;
            }
            return b.__extends(S, f), S.prototype.save = function() {
              this.data.length && (this.editor.history.save(this.data), this.data.length = 0, this.emit());
            }, S.prototype.emit = function() {
              var D;
              (0, p.default)(D = this.editor.txt.eventHooks.changeEvents).call(D, function(k) {
                return k();
              });
            }, S.prototype.observe = function() {
              var D = this;
              f.prototype.observe.call(this, this.editor.$textElem.elems[0]);
              var k = this.editor.config.onchangeTimeout;
              this.asyncSave = g.debounce(function() {
                D.save();
              }, k), this.editor.isCompatibleMode || this.editor.$textElem.on("compositionend", function() {
                D.asyncSave();
              });
            }, S;
          }(x.default);
          d.default = A;
        }, function(m, d, r) {
          var u = r(0)(r(1));
          (0, u.default)(d, "__esModule", { value: !0 });
          var v = function() {
            function C(p, b) {
              var x = this;
              this.options = { subtree: !0, childList: !0, attributes: !0, attributeOldValue: !0, characterData: !0, characterDataOldValue: !0 }, this.callback = function(g) {
                p(g, x);
              }, this.observer = new MutationObserver(this.callback), b && (this.options = b);
            }
            return (0, u.default)(C.prototype, "target", { get: function() {
              return this.node;
            }, enumerable: !1, configurable: !0 }), C.prototype.observe = function(p) {
              this.node instanceof Node || (this.node = p, this.connect());
            }, C.prototype.connect = function() {
              if (this.node) return this.observer.observe(this.node, this.options), this;
              throw new Error("还未初始化绑定，请您先绑定有效的 Node 节点");
            }, C.prototype.disconnect = function() {
              var p = this.observer.takeRecords();
              p.length && this.callback(p), this.observer.disconnect();
            }, C;
          }();
          d.default = v;
        }, function(m, d, r) {
          var u = r(0)(r(1));
          (0, u.default)(d, "__esModule", { value: !0 });
          var v = r(2), C = v.__importDefault(r(421)), p = v.__importDefault(r(428)), b = v.__importDefault(r(429)), x = function() {
            function g(_) {
              this.editor = _, this.content = new C.default(_), this.scroll = new p.default(_), this.range = new b.default(_);
            }
            return (0, u.default)(g.prototype, "size", { get: function() {
              return this.scroll.size;
            }, enumerable: !1, configurable: !0 }), g.prototype.observe = function() {
              this.content.observe(), this.scroll.observe(), !this.editor.isCompatibleMode && this.range.observe();
            }, g.prototype.save = function(_) {
              _.length && (this.content.save(_), this.scroll.save(), !this.editor.isCompatibleMode && this.range.save());
            }, g.prototype.revoke = function() {
              this.editor.change.disconnect();
              var _ = this.content.revoke();
              _ && (this.scroll.revoke(), this.editor.isCompatibleMode || (this.range.revoke(), this.editor.$textElem.focus())), this.editor.change.connect(), _ && this.editor.change.emit();
            }, g.prototype.restore = function() {
              this.editor.change.disconnect();
              var _ = this.content.restore();
              _ && (this.scroll.restore(), this.editor.isCompatibleMode || (this.range.restore(), this.editor.$textElem.focus())), this.editor.change.connect(), _ && this.editor.change.emit();
            }, g;
          }();
          d.default = x;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(422)), C = u.__importDefault(r(426)), p = function() {
            function b(x) {
              this.editor = x;
            }
            return b.prototype.observe = function() {
              this.editor.isCompatibleMode ? this.cache = new C.default(this.editor) : this.cache = new v.default(this.editor), this.cache.observe();
            }, b.prototype.save = function(x) {
              this.editor.isCompatibleMode ? this.cache.save() : this.cache.compile(x);
            }, b.prototype.revoke = function() {
              var x;
              return (x = this.cache) === null || x === void 0 ? void 0 : x.revoke();
            }, b.prototype.restore = function() {
              var x;
              return (x = this.cache) === null || x === void 0 ? void 0 : x.restore();
            }, b;
          }();
          d.default = p;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = u.__importDefault(r(99)), C = u.__importDefault(r(424)), p = r(425), b = function(x) {
            function g(_) {
              var A = x.call(this, _.config.historyMaxSize) || this;
              return A.editor = _, A;
            }
            return u.__extends(g, x), g.prototype.observe = function() {
              this.resetMaxSize(this.editor.config.historyMaxSize);
            }, g.prototype.compile = function(_) {
              return this.save(C.default(_)), this;
            }, g.prototype.revoke = function() {
              return x.prototype.revoke.call(this, function(_) {
                p.revoke(_);
              });
            }, g.prototype.restore = function() {
              return x.prototype.restore.call(this, function(_) {
                p.restore(_);
              });
            }, g;
          }(v.default);
          d.default = b;
        }, function(m, d, r) {
          var u = r(0)(r(1));
          (0, u.default)(d, "__esModule", { value: !0 }), d.CeilStack = void 0;
          var v = function() {
            function C(p) {
              p === void 0 && (p = 0), this.data = [], this.max = 0, this.reset = !1, (p = Math.abs(p)) && (this.max = p);
            }
            return C.prototype.resetMax = function(p) {
              p = Math.abs(p), this.reset || isNaN(p) || (this.max = p, this.reset = !0);
            }, (0, u.default)(C.prototype, "size", { get: function() {
              return this.data.length;
            }, enumerable: !1, configurable: !0 }), C.prototype.instack = function(p) {
              return this.data.unshift(p), this.max && this.size > this.max && (this.data.length = this.max), this;
            }, C.prototype.outstack = function() {
              return this.data.shift();
            }, C.prototype.clear = function() {
              return this.data.length = 0, this;
            }, C;
          }();
          d.CeilStack = v;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4)), p = u(r(26));
          (0, v.default)(d, "__esModule", { value: !0 }), d.compliePosition = d.complieNodes = d.compileValue = d.compileType = void 0;
          var b = r(6);
          function x(D) {
            switch (D) {
              case "childList":
                return "node";
              case "attributes":
                return "attr";
              default:
                return "text";
            }
          }
          function g(D) {
            switch (D.type) {
              case "attributes":
                return D.target.getAttribute(D.attributeName) || "";
              case "characterData":
                return D.target.textContent;
              default:
                return "";
            }
          }
          function _(D) {
            var k = {};
            return D.addedNodes.length && (k.add = b.toArray(D.addedNodes)), D.removedNodes.length && (k.remove = b.toArray(D.removedNodes)), k;
          }
          function A(D) {
            return D.previousSibling ? { type: "before", target: D.previousSibling } : D.nextSibling ? { type: "after", target: D.nextSibling } : { type: "parent", target: D.target };
          }
          d.compileType = x, d.compileValue = g, d.complieNodes = _, d.compliePosition = A;
          var f = ["UL", "OL", "H1", "H2", "H3", "H4", "H5", "H6"];
          function S(D, k) {
            for (var L = 0, h = k.length - 1; h > 0 && D.contains(k[h]); h--) L++;
            return L;
          }
          d.default = function(D) {
            var k = [], L = !1, h = [];
            return (0, C.default)(D).call(D, function(E, w) {
              var O = { type: x(E.type), target: E.target, attr: E.attributeName || "", value: g(E) || "", oldValue: E.oldValue || "", nodes: _(E), position: A(E) };
              if (k.push(O), b.UA.isFirefox) {
                if (L && E.addedNodes.length && E.addedNodes[0].nodeType == 1) {
                  var R = E.addedNodes[0], I = { type: "node", target: R, attr: "", value: "", oldValue: "", nodes: { add: [L] }, position: { type: "parent", target: R } };
                  (0, p.default)(f).call(f, R.nodeName) != -1 ? (I.nodes.add = b.toArray(R.childNodes), k.push(I)) : L.nodeType == 3 ? (S(R, h) && (I.nodes.add = b.toArray(R.childNodes)), k.push(I)) : (0, p.default)(f).call(f, E.target.nodeName) == -1 && S(R, h) && (I.nodes.add = b.toArray(R.childNodes), k.push(I));
                }
                O.type == "node" && E.removedNodes.length == 1 ? (L = E.removedNodes[0], h.push(L)) : (L = !1, h.length = 0);
              }
            }), k;
          };
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(4)), p = u(r(126));
          function b(_, A) {
            var f = _.position.target;
            switch (_.position.type) {
              case "before":
                f.nextSibling ? (f = f.nextSibling, (0, C.default)(A).call(A, function(S) {
                  _.target.insertBefore(S, f);
                })) : (0, C.default)(A).call(A, function(S) {
                  _.target.appendChild(S);
                });
                break;
              case "after":
                (0, C.default)(A).call(A, function(S) {
                  _.target.insertBefore(S, f);
                });
                break;
              default:
                (0, C.default)(A).call(A, function(S) {
                  f.appendChild(S);
                });
            }
          }
          (0, v.default)(d, "__esModule", { value: !0 }), d.restore = d.revoke = void 0;
          var x = { node: function(_) {
            for (var A = 0, f = (0, p.default)(_.nodes); A < f.length; A++) {
              var S = f[A], D = S[0], k = S[1];
              switch (D) {
                case "add":
                  (0, C.default)(k).call(k, function(L) {
                    _.target.removeChild(L);
                  });
                  break;
                default:
                  b(_, k);
              }
            }
          }, text: function(_) {
            _.target.textContent = _.oldValue;
          }, attr: function(_) {
            var A = _.target;
            _.oldValue == null ? A.removeAttribute(_.attr) : A.setAttribute(_.attr, _.oldValue);
          } };
          d.revoke = function(_) {
            for (var A = _.length - 1; A > -1; A--) {
              var f = _[A];
              x[f.type](f);
            }
          };
          var g = { node: function(_) {
            for (var A = 0, f = (0, p.default)(_.nodes); A < f.length; A++) {
              var S = f[A], D = S[0], k = S[1];
              switch (D) {
                case "add":
                  b(_, k);
                  break;
                default:
                  (0, C.default)(k).call(k, function(L) {
                    L.parentNode.removeChild(L);
                  });
              }
            }
          }, text: function(_) {
            _.target.textContent = _.value;
          }, attr: function(_) {
            _.target.setAttribute(_.attr, _.value);
          } };
          d.restore = function(_) {
            for (var A = 0, f = _; A < f.length; A++) {
              var S = f[A];
              g[S.type](S);
            }
          };
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(427), v = function() {
            function C(p) {
              this.editor = p, this.data = new u.TailChain();
            }
            return C.prototype.observe = function() {
              this.data.resetMax(this.editor.config.historyMaxSize), this.data.insertLast(this.editor.$textElem.html());
            }, C.prototype.save = function() {
              return this.data.insertLast(this.editor.$textElem.html()), this;
            }, C.prototype.revoke = function() {
              var p = this.data.prev();
              return !!p && (this.editor.$textElem.html(p), !0);
            }, C.prototype.restore = function() {
              var p = this.data.next();
              return !!p && (this.editor.$textElem.html(p), !0);
            }, C;
          }();
          d.default = v;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(92));
          (0, v.default)(d, "__esModule", { value: !0 }), d.TailChain = void 0;
          var p = function() {
            function b() {
              this.data = [], this.max = 0, this.point = 0, this.isRe = !1;
            }
            return b.prototype.resetMax = function(x) {
              (x = Math.abs(x)) && (this.max = x);
            }, (0, v.default)(b.prototype, "size", { get: function() {
              return this.data.length;
            }, enumerable: !1, configurable: !0 }), b.prototype.insertLast = function(x) {
              var g;
              for (this.isRe && ((0, C.default)(g = this.data).call(g, this.point + 1), this.isRe = !1), this.data.push(x); this.max && this.size > this.max; ) this.data.shift();
              return this.point = this.size - 1, this;
            }, b.prototype.current = function() {
              return this.data[this.point];
            }, b.prototype.prev = function() {
              if (!this.isRe && (this.isRe = !0), this.point--, !(this.point < 0)) return this.current();
              this.point = 0;
            }, b.prototype.next = function() {
              if (!this.isRe && (this.isRe = !0), this.point++, !(this.point >= this.size)) return this.current();
              this.point = this.size - 1;
            }, b;
          }();
          d.TailChain = p;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
          var u = r(2), v = function(C) {
            function p(b) {
              var x = C.call(this, b.config.historyMaxSize) || this;
              return x.editor = b, x.last = 0, x.target = b.$textElem.elems[0], x;
            }
            return u.__extends(p, C), p.prototype.observe = function() {
              var b = this;
              this.target = this.editor.$textElem.elems[0], this.editor.$textElem.on("scroll", function() {
                b.last = b.target.scrollTop;
              }), this.resetMaxSize(this.editor.config.historyMaxSize);
            }, p.prototype.save = function() {
              return C.prototype.save.call(this, [this.last, this.target.scrollTop]), this;
            }, p.prototype.revoke = function() {
              var b = this;
              return C.prototype.revoke.call(this, function(x) {
                b.target.scrollTop = x[0];
              });
            }, p.prototype.restore = function() {
              var b = this;
              return C.prototype.restore.call(this, function(x) {
                b.target.scrollTop = x[1];
              });
            }, p;
          }(u.__importDefault(r(99)).default);
          d.default = v;
        }, function(m, d, r) {
          var u = r(0)(r(1));
          (0, u.default)(d, "__esModule", { value: !0 });
          var v = r(2), C = v.__importDefault(r(99)), p = v.__importDefault(r(3)), b = r(6);
          function x(_) {
            return { start: [_.startContainer, _.startOffset], end: [_.endContainer, _.endOffset], root: _.commonAncestorContainer, collapsed: _.collapsed };
          }
          var g = function(_) {
            function A(f) {
              var S = _.call(this, f.config.historyMaxSize) || this;
              return S.editor = f, S.lastRange = x(document.createRange()), S.root = f.$textElem.elems[0], S.updateLastRange = b.debounce(function() {
                S.lastRange = x(S.rangeHandle);
              }, f.config.onchangeTimeout), S;
            }
            return v.__extends(A, _), (0, u.default)(A.prototype, "rangeHandle", { get: function() {
              var f = document.getSelection();
              return f && f.rangeCount ? f.getRangeAt(0) : document.createRange();
            }, enumerable: !1, configurable: !0 }), A.prototype.observe = function() {
              var f = this;
              function S() {
                var D = f.rangeHandle;
                (f.root === D.commonAncestorContainer || f.root.contains(D.commonAncestorContainer)) && (f.editor.isComposing || f.updateLastRange());
              }
              this.root = this.editor.$textElem.elems[0], this.resetMaxSize(this.editor.config.historyMaxSize), p.default(document).on("selectionchange", S), this.editor.beforeDestroy(function() {
                p.default(document).off("selectionchange", S);
              }), f.editor.$textElem.on("keydown", function(D) {
                D.key != "Backspace" && D.key != "Delete" || f.updateLastRange();
              });
            }, A.prototype.save = function() {
              var f = x(this.rangeHandle);
              return _.prototype.save.call(this, [this.lastRange, f]), this.lastRange = f, this;
            }, A.prototype.set = function(f) {
              try {
                if (f) {
                  var S = this.rangeHandle;
                  return S.setStart.apply(S, f.start), S.setEnd.apply(S, f.end), this.editor.menus.changeActive(), !0;
                }
              } catch (D) {
                return !1;
              }
              return !1;
            }, A.prototype.revoke = function() {
              var f = this;
              return _.prototype.revoke.call(this, function(S) {
                f.set(S[0]);
              });
            }, A.prototype.restore = function() {
              var f = this;
              return _.prototype.restore.call(this, function(S) {
                f.set(S[1]);
              });
            }, A;
          }(C.default);
          d.default = g;
        }, function(m, d, r) {
          var u = r(0), v = u(r(1)), C = u(r(30));
          (0, v.default)(d, "__esModule", { value: !0 });
          var p = r(2).__importDefault(r(3));
          r(431), d.default = function(b) {
            var x, g, _ = !1;
            return b.txt.eventHooks.changeEvents.push(function() {
              _ && (0, C.default)(x).call(x, ".w-e-content-preview").html(b.$textElem.html());
            }), { disable: function() {
              if (!_) {
                b.$textElem.hide();
                var A = b.zIndex.get("textContainer"), f = b.txt.html();
                x = p.default('<div class="w-e-content-mantle" style="z-index:' + A + `">
                <div class="w-e-content-preview w-e-text">` + f + `</div>
            </div>`), b.$textContainerElem.append(x);
                var S = b.zIndex.get("menu");
                g = p.default('<div class="w-e-menue-mantle" style="z-index:' + S + '"></div>'), b.$toolbarElem.append(g), _ = !0;
              }
            }, enable: function() {
              _ && (x.remove(), g.remove(), b.$textElem.show(), _ = !1);
            } };
          };
        }, function(m, d, r) {
          var u = r(20), v = r(432);
          typeof (v = v.__esModule ? v.default : v) == "string" && (v = [[m.i, v, ""]]);
          var C = { insert: "head", singleton: !1 };
          u(v, C), m.exports = v.locals || {};
        }, function(m, d, r) {
          (d = r(21)(!1)).push([m.i, `.w-e-content-mantle {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.w-e-content-mantle .w-e-content-preview {
  width: 100%;
  min-height: 100%;
  padding: 0 10px;
  line-height: 1.5;
}
.w-e-content-mantle .w-e-content-preview img {
  cursor: default;
}
.w-e-content-mantle .w-e-content-preview img:hover {
  box-shadow: none;
}
.w-e-menue-mantle {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}
`, ""]), m.exports = d;
        }, function(m, d, r) {
          (0, r(0)(r(1)).default)(d, "__esModule", { value: !0 });
        }]).default;
      }, W.exports = q();
    }(l = { exports: {} }, l.exports), l.exports), T = (c = M) && c.__esModule && Object.prototype.hasOwnProperty.call(c, "default") ? c.default : c, F = 1, z = Object.assign || function(W) {
      for (var K, q = 1; q < arguments.length; q++) for (var m in K = arguments[q]) Object.prototype.hasOwnProperty.call(K, m) && (W[m] = K[m]);
      return W;
    };
    return { name: "fcEditor", props: { value: String, init: Function, disabled: Boolean, config: Object }, data: function() {
      return { editor: {}, uni: F++ };
    }, watch: { disabled: function() {
      this.enable();
    }, value: function(W) {
      W !== this.editor.txt.html() && this.editor.txt.html(W);
    } }, methods: { enable: function() {
      this.disabled ? this.editor.disable() : this.editor.enable();
    }, result: function() {
      this.$emit("input", this.editor.txt.html());
    } }, mounted: function() {
      var W = this;
      this.$nextTick(function() {
        W.editor = new T("#editor".concat(W.uni)), W.editor.config.zIndex = 2, W.config && z(W.editor.config, W.config), W.init && W.init(W.editor), W.editor.create(), W.enable(), W.editor.txt.html(W.value);
      });
    }, render: function() {
      return (0, arguments[0])("div", { on: { input: this.result }, attrs: { id: "editor".concat(this.uni) }, style: "line-height: normal;" });
    }, beforeDestroy: function() {
      this.editor && this.editor.destroy(), this.editor = null;
    } };
  });
})(gd);
var rb = gd.exports;
const ib = /* @__PURE__ */ Ts(rb), Ns = (i, t, l) => {
  qe.component(i, l || t), wa.component(i, t);
};
qe.component("draggable", xs);
qe.component("DragTool", ud);
qe.component("DragBox", dd);
qe.component("Validate", Zy);
qe.component("Struct", Km);
qe.component("HtmlEditor", oy);
qe.component("FetchConfig", Ay);
qe.component("FnEditor", mo);
qe.component("FnInput", cd);
qe.component("Required", i0);
qe.component("TableOptions", pd);
qe.component("TreeOptions", h0);
qe.component("EventConfig", td);
qe.component("SizeInput", Ea);
qe.component("ColorInput", yo);
qe.component("StyleConfig", nb);
qe.component("ConfigItem", yi);
qe.component("FieldInput", Sy);
qe.component("FnConfig", Oy);
qe.component("FcRow", ey);
Ns("FcEditor", ib);
Ns("FcTable", Yy, Uy);
const ob = function(i) {
  i.component("FcDesigner", wr);
};
wr.install = ob;
wr.makeOptionsRule = Aa;
wr.formCreate = wa;
wr.designerForm = qe;
wr.component = Ns;
wr.useLocale = ed;
wr.t = bs;
Ih("2.5.36", wa.version) === 1 && console.warn("Please use FormCreate version 2.5.36 or greater, see https://github.com/xaboy/form-create.");
export {
  wr as default,
  qe as designerForm,
  wa as formCreate,
  ob as install
};
